// GLOBAL_AIRPORTS - 4,800+ airports from OurAirports
// Generated from ourairports.com data
// Format: { icao: { iata, name, city, country, continent, lat, lon, elevation, hub_tier, slots, demand, business_pct, landing_fee, competition } }

export const GLOBAL_AIRPORTS = {
  "AGGH": {
    icao: "AGGH",
    iata: "HIR",
    name: "Honiara International Airport",
    city: "Honiara",
    country: "SB",
    continent: "OC",
    lat: -9.428,
    lon: 160.055,
    elevation: 28,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "AGGM": {
    icao: "AGGM",
    iata: "MUA",
    name: "Munda Airport",
    city: "Munda",
    country: "SB",
    continent: "OC",
    lat: -8.328,
    lon: 157.263,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ANYN": {
    icao: "ANYN",
    iata: "INU",
    name: "Nauru International Airport",
    city: "Yaren District",
    country: "NR",
    continent: "OC",
    lat: -0.5475,
    lon: 166.919,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AQBC": {
    icao: "AQBC",
    iata: "",
    name: "Boulder Clay Runway",
    city: "Zucchelli Station",
    country: "AQ",
    continent: "AN",
    lat: -74.7394,
    lon: 164.0354,
    elevation: 672,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AT03": {
    icao: "AT03",
    iata: "",
    name: "Concordia Skyway",
    city: "Concordia Station",
    country: "AQ",
    continent: "AN",
    lat: -75.1033,
    lon: 123.3582,
    elevation: 10725,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AT28": {
    icao: "AT28",
    iata: "",
    name: "Vostok Skiway",
    city: "Vostok Station",
    country: "AQ",
    continent: "AN",
    lat: -78.4661,
    lon: 106.8482,
    elevation: 11447,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AT98": {
    icao: "AT98",
    iata: "WFR",
    name: "Wolf\'s Fang Runway",
    city: "",
    country: "AQ",
    continent: "AN",
    lat: -71.517,
    lon: 8.8,
    elevation: 3707,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYBA": {
    icao: "AYBA",
    iata: "VMU",
    name: "Baimuru Airport",
    city: "Baimuru",
    country: "PG",
    continent: "OC",
    lat: -7.497,
    lon: 144.8218,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYBK": {
    icao: "AYBK",
    iata: "BUA",
    name: "Buka Airport",
    city: "Buka Island",
    country: "PG",
    continent: "OC",
    lat: -5.4223,
    lon: 154.6727,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYBM": {
    icao: "AYBM",
    iata: "OPU",
    name: "Balimo Airport",
    city: "Balimo",
    country: "PG",
    continent: "OC",
    lat: -8.05,
    lon: 142.933,
    elevation: 51,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYCH": {
    icao: "AYCH",
    iata: "CMU",
    name: "Chimbu Airport",
    city: "Kundiawa",
    country: "PG",
    continent: "OC",
    lat: -6.0243,
    lon: 144.971,
    elevation: 4974,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYDU": {
    icao: "AYDU",
    iata: "DAU",
    name: "Daru Airport",
    city: "Daru",
    country: "PG",
    continent: "OC",
    lat: -9.0868,
    lon: 143.208,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYGA": {
    icao: "AYGA",
    iata: "GKA",
    name: "Goroka Airport",
    city: "Goronka",
    country: "PG",
    continent: "OC",
    lat: -6.0817,
    lon: 145.392,
    elevation: 5282,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYGN": {
    icao: "AYGN",
    iata: "GUR",
    name: "Gurney Airport",
    city: "Gurney",
    country: "PG",
    continent: "OC",
    lat: -10.3115,
    lon: 150.334,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYGR": {
    icao: "AYGR",
    iata: "PNP",
    name: "Girua Airport",
    city: "Popondetta",
    country: "PG",
    continent: "OC",
    lat: -8.8045,
    lon: 148.309,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYHK": {
    icao: "AYHK",
    iata: "HKN",
    name: "Hoskins Airport",
    city: "Kimbe",
    country: "PG",
    continent: "OC",
    lat: -5.4638,
    lon: 150.4073,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYKM": {
    icao: "AYKM",
    iata: "KMA",
    name: "Kerema Airport",
    city: "Kerema",
    country: "PG",
    continent: "OC",
    lat: -7.9636,
    lon: 145.771,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYKV": {
    icao: "AYKV",
    iata: "KVG",
    name: "Kavieng Airport",
    city: "Kavieng",
    country: "PG",
    continent: "OC",
    lat: -2.5794,
    lon: 150.808,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYMD": {
    icao: "AYMD",
    iata: "MAG",
    name: "Madang Airport",
    city: "Madang",
    country: "PG",
    continent: "OC",
    lat: -5.2071,
    lon: 145.789,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYMH": {
    icao: "AYMH",
    iata: "HGU",
    name: "Mount Hagen Kagamuga Airport",
    city: "Mount Hagen",
    country: "PG",
    continent: "OC",
    lat: -5.8282,
    lon: 144.2994,
    elevation: 5388,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYMN": {
    icao: "AYMN",
    iata: "MDU",
    name: "Mendi Airport",
    city: "Mendi",
    country: "PG",
    continent: "OC",
    lat: -6.1477,
    lon: 143.657,
    elevation: 5680,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYMO": {
    icao: "AYMO",
    iata: "MAS",
    name: "Momote Airport",
    city: "Manus Island",
    country: "PG",
    continent: "OC",
    lat: -2.0619,
    lon: 147.424,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYNZ": {
    icao: "AYNZ",
    iata: "LAE",
    name: "Nadzab Airport",
    city: "Lae",
    country: "PG",
    continent: "OC",
    lat: -6.5698,
    lon: 146.726,
    elevation: 239,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYPY": {
    icao: "AYPY",
    iata: "POM",
    name: "Port Moresby Jacksons International Airport",
    city: "Port Moresby",
    country: "PG",
    continent: "OC",
    lat: -9.4434,
    lon: 147.22,
    elevation: 146,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "AYTK": {
    icao: "AYTK",
    iata: "RAB",
    name: "Tokua Airport",
    city: "Kokopo",
    country: "PG",
    continent: "OC",
    lat: -4.3405,
    lon: 152.38,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYVN": {
    icao: "AYVN",
    iata: "VAI",
    name: "Vanimo Airport",
    city: "Vanimo",
    country: "PG",
    continent: "OC",
    lat: -2.6926,
    lon: 141.3028,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYWD": {
    icao: "AYWD",
    iata: "WBM",
    name: "Wapenamanda Airport",
    city: "Wapenamanda",
    country: "PG",
    continent: "OC",
    lat: -5.6353,
    lon: 143.8922,
    elevation: 5889,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "AYWK": {
    icao: "AYWK",
    iata: "WWK",
    name: "Wewak International Airport",
    city: "Wewak",
    country: "PG",
    continent: "OC",
    lat: -3.5838,
    lon: 143.669,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGAA": {
    icao: "BGAA",
    iata: "JEG",
    name: "Aasiaat Airport",
    city: "Aasiaat",
    country: "GL",
    continent: "NA",
    lat: 68.7218,
    lon: -52.7847,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGBW": {
    icao: "BGBW",
    iata: "UAK",
    name: "Narsarsuaq Airport",
    city: "Narsarsuaq",
    country: "GL",
    continent: "NA",
    lat: 61.1605,
    lon: -45.426,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGGH": {
    icao: "BGGH",
    iata: "GOH",
    name: "Nuuk Airport",
    city: "Nuuk",
    country: "GL",
    continent: "NA",
    lat: 64.1911,
    lon: -51.6791,
    elevation: 283,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGJN": {
    icao: "BGJN",
    iata: "JAV",
    name: "Ilulissat Airport",
    city: "Ilulissat",
    country: "GL",
    continent: "NA",
    lat: 69.2432,
    lon: -51.0571,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGKK": {
    icao: "BGKK",
    iata: "KUS",
    name: "Kulusuk Airport",
    city: "Kulusuk",
    country: "GL",
    continent: "NA",
    lat: 65.5736,
    lon: -37.1236,
    elevation: 117,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGSF": {
    icao: "BGSF",
    iata: "SFJ",
    name: "Kangerlussuaq Airport",
    city: "Kangerlussuaq",
    country: "GL",
    continent: "NA",
    lat: 67.0104,
    lon: -50.7153,
    elevation: 165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGSS": {
    icao: "BGSS",
    iata: "JHS",
    name: "Sisimiut Airport",
    city: "Sisimiut",
    country: "GL",
    continent: "NA",
    lat: 66.9513,
    lon: -53.7293,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BGTL": {
    icao: "BGTL",
    iata: "THU",
    name: "Pituffik Space Base",
    city: "Pituffik",
    country: "GL",
    continent: "NA",
    lat: 76.5312,
    lon: -68.7032,
    elevation: 251,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIAR": {
    icao: "BIAR",
    iata: "AEY",
    name: "Akureyri Airport",
    city: "Akureyri",
    country: "IS",
    continent: "EU",
    lat: 65.6566,
    lon: -18.072,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIEG": {
    icao: "BIEG",
    iata: "EGS",
    name: "Egilsstaðir Airport",
    city: "Egilsstaðir",
    country: "IS",
    continent: "EU",
    lat: 65.2833,
    lon: -14.4014,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIHN": {
    icao: "BIHN",
    iata: "HFN",
    name: "Hornafjörður Airport",
    city: "Höfn",
    country: "IS",
    continent: "EU",
    lat: 64.2956,
    lon: -15.2272,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIHU": {
    icao: "BIHU",
    iata: "HZK",
    name: "Húsavík Airport",
    city: "Húsavík",
    country: "IS",
    continent: "EU",
    lat: 65.9523,
    lon: -17.426,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIIS": {
    icao: "BIIS",
    iata: "IFJ",
    name: "Ísafjörður Airport",
    city: "Ísafjörður",
    country: "IS",
    continent: "EU",
    lat: 66.0581,
    lon: -23.1353,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIKF": {
    icao: "BIKF",
    iata: "KEF",
    name: "Keflavik International Airport",
    city: "Reykjavík",
    country: "IS",
    continent: "EU",
    lat: 63.985,
    lon: -22.6056,
    elevation: 171,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "BIRK": {
    icao: "BIRK",
    iata: "RKV",
    name: "Reykjavík Domestic Airport",
    city: "Reykjavík",
    country: "IS",
    continent: "EU",
    lat: 64.1287,
    lon: -21.9376,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BISI": {
    icao: "BISI",
    iata: "SIJ",
    name: "Siglufjörður Airport",
    city: "Siglufjörður",
    country: "IS",
    continent: "EU",
    lat: 66.1378,
    lon: -18.9082,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BIVM": {
    icao: "BIVM",
    iata: "VEY",
    name: "Vestmannaeyjar Airport",
    city: "Vestmannaeyjar",
    country: "IS",
    continent: "EU",
    lat: 63.4243,
    lon: -20.2789,
    elevation: 326,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "BKPR": {
    icao: "BKPR",
    iata: "PRN",
    name: "Priština Adem Jashari International Airport",
    city: "Prishtina",
    country: "XK",
    continent: "EU",
    lat: 42.5728,
    lon: 21.0358,
    elevation: 1789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CAJ4": {
    icao: "CAJ4",
    iata: "YAA",
    name: "Anahim Lake Airport",
    city: "Anahim Lake",
    country: "CA",
    continent: "NA",
    lat: 52.4515,
    lon: -125.3038,
    elevation: 3635,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CAT4": {
    icao: "CAT4",
    iata: "XQU",
    name: "Qualicum Beach Airport",
    city: "Qualicum Beach",
    country: "CA",
    continent: "NA",
    lat: 49.3375,
    lon: -124.3931,
    elevation: 191,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CAZ5": {
    icao: "CAZ5",
    iata: "YZA",
    name: "Cache Creek-Ashcroft Regional Airport",
    city: "Cache Creek",
    country: "CA",
    continent: "NA",
    lat: 50.7753,
    lon: -121.3213,
    elevation: 2034,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CBBC": {
    icao: "CBBC",
    iata: "ZEL",
    name: "Bella Bella (Campbell Island) Airport",
    city: "Bella Bella",
    country: "CA",
    continent: "NA",
    lat: 52.185,
    lon: -128.157,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CNC3": {
    icao: "CNC3",
    iata: "",
    name: "Brampton-Caledon Airport",
    city: "",
    country: "CA",
    continent: "NA",
    lat: 43.7603,
    lon: -79.875,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAG": {
    icao: "CYAG",
    iata: "YAG",
    name: "Fort Frances Municipal Airport",
    city: "Fort Frances",
    country: "CA",
    continent: "NA",
    lat: 48.6557,
    lon: -93.4435,
    elevation: 1125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAH": {
    icao: "CYAH",
    iata: "YAH",
    name: "La Grande-4 Airport",
    city: "La Grande-4",
    country: "CA",
    continent: "NA",
    lat: 53.7547,
    lon: -73.6753,
    elevation: 1005,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAM": {
    icao: "CYAM",
    iata: "YAM",
    name: "Sault Ste Marie Airport",
    city: "Sault Ste Marie",
    country: "CA",
    continent: "NA",
    lat: 46.4832,
    lon: -84.5085,
    elevation: 630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAQ": {
    icao: "CYAQ",
    iata: "XKS",
    name: "Kasabonika Airport",
    city: "Kasabonika",
    country: "CA",
    continent: "NA",
    lat: 53.5247,
    lon: -88.6428,
    elevation: 672,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAV": {
    icao: "CYAV",
    iata: "",
    name: "Winnipeg / St. Andrews Airport",
    city: "Winnipeg/Saint Andrews",
    country: "CA",
    continent: "NA",
    lat: 50.0564,
    lon: -97.0325,
    elevation: 760,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAX": {
    icao: "CYAX",
    iata: "",
    name: "Lac du Bonnet Airport",
    city: "Lac du Bonnet",
    country: "CA",
    continent: "NA",
    lat: 50.2944,
    lon: -96.01,
    elevation: 850,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAY": {
    icao: "CYAY",
    iata: "YAY",
    name: "St. Anthony Airport",
    city: "St. Anthony",
    country: "CA",
    continent: "NA",
    lat: 51.3919,
    lon: -56.0832,
    elevation: 108,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYAZ": {
    icao: "CYAZ",
    iata: "YAZ",
    name: "Tofino / Long Beach Airport",
    city: "Tofino",
    country: "CA",
    continent: "NA",
    lat: 49.0798,
    lon: -125.7756,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBC": {
    icao: "CYBC",
    iata: "YBC",
    name: "Baie-Comeau Airport",
    city: "Baie-Comeau",
    country: "CA",
    continent: "NA",
    lat: 49.1325,
    lon: -68.2044,
    elevation: 71,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBD": {
    icao: "CYBD",
    iata: "QBC",
    name: "Bella Coola Airport",
    city: "Bella Coola",
    country: "CA",
    continent: "NA",
    lat: 52.3875,
    lon: -126.596,
    elevation: 117,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBF": {
    icao: "CYBF",
    iata: "YBY",
    name: "Bonnyville Airport",
    city: "Bonnyville",
    country: "CA",
    continent: "NA",
    lat: 54.3042,
    lon: -110.744,
    elevation: 1836,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBG": {
    icao: "CYBG",
    iata: "YBG",
    name: "CFB Bagotville / Saguenay-Bagotville Airport",
    city: "La Baie",
    country: "CA",
    continent: "NA",
    lat: 48.3319,
    lon: -70.9929,
    elevation: 522,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBK": {
    icao: "CYBK",
    iata: "YBK",
    name: "Baker Lake Airport",
    city: "Baker Lake",
    country: "CA",
    continent: "NA",
    lat: 64.2989,
    lon: -96.0778,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBL": {
    icao: "CYBL",
    iata: "YBL",
    name: "Campbell River Airport",
    city: "Campbell River",
    country: "CA",
    continent: "NA",
    lat: 49.9508,
    lon: -125.271,
    elevation: 346,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBR": {
    icao: "CYBR",
    iata: "YBR",
    name: "Brandon Municipal Airport",
    city: "Brandon",
    country: "CA",
    continent: "NA",
    lat: 49.91,
    lon: -99.9519,
    elevation: 1343,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBU": {
    icao: "CYBU",
    iata: "",
    name: "Nipawin Airport",
    city: "Nipawin",
    country: "CA",
    continent: "NA",
    lat: 53.3325,
    lon: -104.008,
    elevation: 1220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBW": {
    icao: "CYBW",
    iata: "",
    name: "Calgary / Springbank Airport",
    city: "Calgary",
    country: "CA",
    continent: "NA",
    lat: 51.1031,
    lon: -114.374,
    elevation: 3940,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYBX": {
    icao: "CYBX",
    iata: "YBX",
    name: "Lourdes-de-Blanc-Sablon Airport",
    city: "Blanc-Sablon",
    country: "CA",
    continent: "NA",
    lat: 51.4436,
    lon: -57.1853,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCB": {
    icao: "CYCB",
    iata: "YCB",
    name: "Cambridge Bay Airport",
    city: "Cambridge Bay",
    country: "CA",
    continent: "NA",
    lat: 69.1081,
    lon: -105.138,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCC": {
    icao: "CYCC",
    iata: "YCC",
    name: "Cornwall Regional Airport",
    city: "Cornwall",
    country: "CA",
    continent: "NA",
    lat: 45.0926,
    lon: -74.5677,
    elevation: 175,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCD": {
    icao: "CYCD",
    iata: "YCD",
    name: "Nanaimo Airport",
    city: "Nanaimo",
    country: "CA",
    continent: "NA",
    lat: 49.055,
    lon: -123.8699,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCE": {
    icao: "CYCE",
    iata: "YCE",
    name: "Centralia / James T. Field Memorial Aerodrome",
    city: "Huron Park",
    country: "CA",
    continent: "NA",
    lat: 43.2856,
    lon: -81.5083,
    elevation: 824,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCG": {
    icao: "CYCG",
    iata: "YCG",
    name: "Castlegar/West Kootenay Regional Airport",
    city: "Castlegar",
    country: "CA",
    continent: "NA",
    lat: 49.2964,
    lon: -117.632,
    elevation: 1624,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCH": {
    icao: "CYCH",
    iata: "YCH",
    name: "Miramichi Airport",
    city: "Miramichi",
    country: "CA",
    continent: "NA",
    lat: 47.0078,
    lon: -65.4492,
    elevation: 108,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCL": {
    icao: "CYCL",
    iata: "YCL",
    name: "Charlo Airport",
    city: "Charlo",
    country: "CA",
    continent: "NA",
    lat: 47.9908,
    lon: -66.3303,
    elevation: 132,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCN": {
    icao: "CYCN",
    iata: "YCN",
    name: "Cochrane Airport",
    city: "Cochrane",
    country: "CA",
    continent: "NA",
    lat: 49.1056,
    lon: -81.0136,
    elevation: 861,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCP": {
    icao: "CYCP",
    iata: "",
    name: "Blue River Airport",
    city: "Blue River",
    country: "CA",
    continent: "NA",
    lat: 52.1167,
    lon: -119.283,
    elevation: 2240,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYCQ": {
    icao: "CYCQ",
    iata: "YCQ",
    name: "Chetwynd Airport",
    city: "Chetwynd",
    country: "CA",
    continent: "NA",
    lat: 55.6872,
    lon: -121.627,
    elevation: 2000,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDA": {
    icao: "CYDA",
    iata: "YDA",
    name: "Dawson City Airport",
    city: "Dawson City",
    country: "CA",
    continent: "NA",
    lat: 64.0431,
    lon: -139.128,
    elevation: 1215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDB": {
    icao: "CYDB",
    iata: "YDB",
    name: "Burwash Airport",
    city: "Burwash Landing",
    country: "CA",
    continent: "NA",
    lat: 61.3711,
    lon: -139.041,
    elevation: 2647,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDF": {
    icao: "CYDF",
    iata: "YDF",
    name: "Deer Lake Airport",
    city: "Deer Lake",
    country: "CA",
    continent: "NA",
    lat: 49.2108,
    lon: -57.3914,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDM": {
    icao: "CYDM",
    iata: "XRR",
    name: "Ross River Airport",
    city: "Ross River",
    country: "CA",
    continent: "NA",
    lat: 61.9706,
    lon: -132.423,
    elevation: 2314,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDN": {
    icao: "CYDN",
    iata: "YDN",
    name: "Dauphin Barker Airport",
    city: "Dauphin",
    country: "CA",
    continent: "NA",
    lat: 51.1008,
    lon: -100.052,
    elevation: 999,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDO": {
    icao: "CYDO",
    iata: "YDO",
    name: "Dolbeau-Saint-Felicien Airport",
    city: "Dolbeau-Saint-Felicien",
    country: "CA",
    continent: "NA",
    lat: 48.7785,
    lon: -72.375,
    elevation: 372,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYDQ": {
    icao: "CYDQ",
    iata: "YDQ",
    name: "Dawson Creek Airport",
    city: "Dawson Creek",
    country: "CA",
    continent: "NA",
    lat: 55.7412,
    lon: -120.1833,
    elevation: 2148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYEE": {
    icao: "CYEE",
    iata: "",
    name: "Huronia Airport",
    city: "Midland",
    country: "CA",
    continent: "NA",
    lat: 44.6833,
    lon: -79.9283,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYEG": {
    icao: "CYEG",
    iata: "YEG",
    name: "Edmonton International Airport",
    city: "Edmonton",
    country: "CA",
    continent: "NA",
    lat: 53.3097,
    lon: -113.58,
    elevation: 2373,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYEL": {
    icao: "CYEL",
    iata: "YEL",
    name: "Elliot Lake Municipal Airport",
    city: "Elliot Lake",
    country: "CA",
    continent: "NA",
    lat: 46.3514,
    lon: -82.5614,
    elevation: 1087,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYEM": {
    icao: "CYEM",
    iata: "YEM",
    name: "Manitoulin East Municipal Airport",
    city: "Sheguiandah",
    country: "CA",
    continent: "NA",
    lat: 45.8424,
    lon: -81.8576,
    elevation: 869,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYEN": {
    icao: "CYEN",
    iata: "YEN",
    name: "Estevan Airport",
    city: "Estevan",
    country: "CA",
    continent: "NA",
    lat: 49.2103,
    lon: -102.966,
    elevation: 1905,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYET": {
    icao: "CYET",
    iata: "YET",
    name: "Edson Airport",
    city: "Edson",
    country: "CA",
    continent: "NA",
    lat: 53.5789,
    lon: -116.465,
    elevation: 3043,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYEV": {
    icao: "CYEV",
    iata: "YEV",
    name: "Inuvik Mike Zubko Airport",
    city: "Inuvik",
    country: "CA",
    continent: "NA",
    lat: 68.3042,
    lon: -133.483,
    elevation: 224,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYEY": {
    icao: "CYEY",
    iata: "YEY",
    name: "Amos/Magny Airport",
    city: "Amos",
    country: "CA",
    continent: "NA",
    lat: 48.5639,
    lon: -78.2497,
    elevation: 1068,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYFB": {
    icao: "CYFB",
    iata: "YFB",
    name: "Iqaluit Airport",
    city: "Iqaluit",
    country: "CA",
    continent: "NA",
    lat: 63.7564,
    lon: -68.5558,
    elevation: 110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYFC": {
    icao: "CYFC",
    iata: "YFC",
    name: "Fredericton Airport",
    city: "Fredericton",
    country: "CA",
    continent: "NA",
    lat: 45.8689,
    lon: -66.5372,
    elevation: 68,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYFE": {
    icao: "CYFE",
    iata: "YFE",
    name: "Forestville Airport",
    city: "Forestville",
    country: "CA",
    continent: "NA",
    lat: 48.7461,
    lon: -69.0972,
    elevation: 293,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYFJ": {
    icao: "CYFJ",
    iata: "YTM",
    name: "Mont-Tremblant International Airport",
    city: "La Macaza",
    country: "CA",
    continent: "NA",
    lat: 46.4094,
    lon: -74.78,
    elevation: 827,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYFR": {
    icao: "CYFR",
    iata: "YFR",
    name: "Fort Resolution Airport",
    city: "Fort Resolution",
    country: "CA",
    continent: "NA",
    lat: 61.1808,
    lon: -113.69,
    elevation: 526,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYFS": {
    icao: "CYFS",
    iata: "YFS",
    name: "Fort Simpson Airport",
    city: "Fort Simpson",
    country: "CA",
    continent: "NA",
    lat: 61.7602,
    lon: -121.237,
    elevation: 555,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGD": {
    icao: "CYGD",
    iata: "",
    name: "Goderich Airport",
    city: "Goderich",
    country: "CA",
    continent: "NA",
    lat: 43.7669,
    lon: -81.7106,
    elevation: 712,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGE": {
    icao: "CYGE",
    iata: "",
    name: "Golden Airport",
    city: "Golden",
    country: "CA",
    continent: "NA",
    lat: 51.2992,
    lon: -116.982,
    elevation: 2575,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGK": {
    icao: "CYGK",
    iata: "YGK",
    name: "Kingston Norman Rogers Airport",
    city: "Kingston",
    country: "CA",
    continent: "NA",
    lat: 44.2253,
    lon: -76.5969,
    elevation: 305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGL": {
    icao: "CYGL",
    iata: "YGL",
    name: "La Grande Rivière Airport",
    city: "La Grande Rivière",
    country: "CA",
    continent: "NA",
    lat: 53.6253,
    lon: -77.7042,
    elevation: 639,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGM": {
    icao: "CYGM",
    iata: "YGM",
    name: "Gimli Industrial Park Airport",
    city: "Gimli",
    country: "CA",
    continent: "NA",
    lat: 50.6281,
    lon: -97.0433,
    elevation: 753,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGP": {
    icao: "CYGP",
    iata: "YGP",
    name: "Michel-Pouliot Gaspé Airport",
    city: "Gaspé",
    country: "CA",
    continent: "NA",
    lat: 48.7749,
    lon: -64.4819,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGQ": {
    icao: "CYGQ",
    iata: "YGQ",
    name: "Geraldton Greenstone Regional Airport",
    city: "Geraldton",
    country: "CA",
    continent: "NA",
    lat: 49.7783,
    lon: -86.9394,
    elevation: 1144,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGR": {
    icao: "CYGR",
    iata: "YGR",
    name: "Îles-de-la-Madeleine Airport",
    city: "Les Îles-de-la-Madeleine",
    country: "CA",
    continent: "NA",
    lat: 47.4252,
    lon: -61.7786,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGV": {
    icao: "CYGV",
    iata: "YGV",
    name: "Havre-Saint-Pierre Airport",
    city: "Havre-Saint-Pierre",
    country: "CA",
    continent: "NA",
    lat: 50.2819,
    lon: -63.6114,
    elevation: 124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYGW": {
    icao: "CYGW",
    iata: "YGW",
    name: "Kuujjuarapik Airport",
    city: "Kuujjuarapik",
    country: "CA",
    continent: "NA",
    lat: 55.2819,
    lon: -77.7653,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHD": {
    icao: "CYHD",
    iata: "YHD",
    name: "Dryden Regional Airport",
    city: "Dryden",
    country: "CA",
    continent: "NA",
    lat: 49.8317,
    lon: -92.7442,
    elevation: 1354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHF": {
    icao: "CYHF",
    iata: "YHF",
    name: "Hearst René Fontaine Municipal Airport",
    city: "Hearst",
    country: "CA",
    continent: "NA",
    lat: 49.7142,
    lon: -83.6861,
    elevation: 827,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHM": {
    icao: "CYHM",
    iata: "YHM",
    name: "John C. Munro Hamilton International Airport",
    city: "Hamilton",
    country: "CA",
    continent: "NA",
    lat: 43.1736,
    lon: -79.935,
    elevation: 780,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHN": {
    icao: "CYHN",
    iata: "YHN",
    name: "Hornepayne Municipal Airport",
    city: "Hornepayne",
    country: "CA",
    continent: "NA",
    lat: 49.1931,
    lon: -84.7589,
    elevation: 1099,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHT": {
    icao: "CYHT",
    iata: "YHT",
    name: "Haines Junction Airport",
    city: "Haines Junction",
    country: "CA",
    continent: "NA",
    lat: 60.7892,
    lon: -137.546,
    elevation: 2150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHU": {
    icao: "CYHU",
    iata: "YHU",
    name: "Montréal / Saint-Hubert Metropolitan Airport",
    city: "Montréal",
    country: "CA",
    continent: "NA",
    lat: 45.5175,
    lon: -73.4169,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHY": {
    icao: "CYHY",
    iata: "YHY",
    name: "Hay River / Merlyn Carter Airport",
    city: "Hay River",
    country: "CA",
    continent: "NA",
    lat: 60.8397,
    lon: -115.783,
    elevation: 541,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYHZ": {
    icao: "CYHZ",
    iata: "YHZ",
    name: "Halifax / Stanfield International Airport",
    city: "Halifax",
    country: "CA",
    continent: "NA",
    lat: 44.8808,
    lon: -63.5086,
    elevation: 477,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYIB": {
    icao: "CYIB",
    iata: "YIB",
    name: "Atikokan Municipal Airport",
    city: "Atikokan",
    country: "CA",
    continent: "NA",
    lat: 48.7739,
    lon: -91.6386,
    elevation: 1408,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYID": {
    icao: "CYID",
    iata: "YDG",
    name: "Digby / Annapolis Regional Airport",
    city: "Digby",
    country: "CA",
    continent: "NA",
    lat: 44.5458,
    lon: -65.7854,
    elevation: 499,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYIF": {
    icao: "CYIF",
    iata: "YIF",
    name: "St Augustin Airport",
    city: "St-Augustin",
    country: "CA",
    continent: "NA",
    lat: 51.2117,
    lon: -58.6583,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYIV": {
    icao: "CYIV",
    iata: "YIV",
    name: "Island Lake Airport",
    city: "Island Lake",
    country: "CA",
    continent: "NA",
    lat: 53.8572,
    lon: -94.6536,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYJF": {
    icao: "CYJF",
    iata: "YJF",
    name: "Fort Liard Airport",
    city: "Fort Liard",
    country: "CA",
    continent: "NA",
    lat: 60.2358,
    lon: -123.469,
    elevation: 708,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYJN": {
    icao: "CYJN",
    iata: "YJN",
    name: "St Jean Airport",
    city: "St Jean",
    country: "CA",
    continent: "NA",
    lat: 45.2944,
    lon: -73.2811,
    elevation: 136,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYJT": {
    icao: "CYJT",
    iata: "YJT",
    name: "Dymond Airport",
    city: "Stephenville",
    country: "CA",
    continent: "NA",
    lat: 48.5442,
    lon: -58.55,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKA": {
    icao: "CYKA",
    iata: "YKA",
    name: "Kamloops John Moose Fulton Field Regional Airport",
    city: "Kamloops",
    country: "CA",
    continent: "NA",
    lat: 50.703,
    lon: -120.4486,
    elevation: 1133,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKF": {
    icao: "CYKF",
    iata: "YKF",
    name: "Region of Waterloo International Airport",
    city: "Breslau",
    country: "CA",
    continent: "NA",
    lat: 43.4608,
    lon: -80.3786,
    elevation: 1054,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKJ": {
    icao: "CYKJ",
    iata: "YKJ",
    name: "Key Lake Airport",
    city: "Key Lake",
    country: "CA",
    continent: "NA",
    lat: 57.2561,
    lon: -105.618,
    elevation: 1679,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKL": {
    icao: "CYKL",
    iata: "YKL",
    name: "Schefferville Airport",
    city: "Schefferville",
    country: "CA",
    continent: "NA",
    lat: 54.8053,
    lon: -66.8053,
    elevation: 1709,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKM": {
    icao: "CYKM",
    iata: "YKD",
    name: "Kincardine Municipal Airport",
    city: "Kincardine",
    country: "CA",
    continent: "NA",
    lat: 44.2014,
    lon: -81.6067,
    elevation: 772,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKX": {
    icao: "CYKX",
    iata: "YKX",
    name: "Kirkland Lake Airport",
    city: "Kirkland Lake",
    country: "CA",
    continent: "NA",
    lat: 48.2103,
    lon: -79.9814,
    elevation: 1157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYKY": {
    icao: "CYKY",
    iata: "YKY",
    name: "Kindersley Airport",
    city: "Kindersley",
    country: "CA",
    continent: "NA",
    lat: 51.5175,
    lon: -109.181,
    elevation: 2277,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLD": {
    icao: "CYLD",
    iata: "YLD",
    name: "Chapleau Airport",
    city: "Chapleau",
    country: "CA",
    continent: "NA",
    lat: 47.82,
    lon: -83.3467,
    elevation: 1470,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLJ": {
    icao: "CYLJ",
    iata: "YLJ",
    name: "Meadow Lake Airport",
    city: "Meadow Lake",
    country: "CA",
    continent: "NA",
    lat: 54.1253,
    lon: -108.523,
    elevation: 1576,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLL": {
    icao: "CYLL",
    iata: "YLL",
    name: "Lloydminster Airport",
    city: "Lloydminster",
    country: "CA",
    continent: "NA",
    lat: 53.3092,
    lon: -110.073,
    elevation: 2193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLR": {
    icao: "CYLR",
    iata: "YLR",
    name: "Leaf Rapids Airport",
    city: "Leaf Rapids",
    country: "CA",
    continent: "NA",
    lat: 56.5133,
    lon: -99.9853,
    elevation: 959,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLS": {
    icao: "CYLS",
    iata: "YLK",
    name: "Barrie-Lake Simcoe Regional Airport",
    city: "Barrie",
    country: "CA",
    continent: "NA",
    lat: 44.4851,
    lon: -79.5547,
    elevation: 972,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLT": {
    icao: "CYLT",
    iata: "YLT",
    name: "Alert Airport",
    city: "Alert",
    country: "CA",
    continent: "NA",
    lat: 82.5178,
    lon: -62.2806,
    elevation: 100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYLW": {
    icao: "CYLW",
    iata: "YLW",
    name: "Kelowna International Airport",
    city: "Kelowna",
    country: "CA",
    continent: "NA",
    lat: 49.9561,
    lon: -119.378,
    elevation: 1421,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMA": {
    icao: "CYMA",
    iata: "YMA",
    name: "Mayo Airport",
    city: "Mayo",
    country: "CA",
    continent: "NA",
    lat: 63.6164,
    lon: -135.868,
    elevation: 1653,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYME": {
    icao: "CYME",
    iata: "YME",
    name: "Matane Airport",
    city: "Matane",
    country: "CA",
    continent: "NA",
    lat: 48.8569,
    lon: -67.4533,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMG": {
    icao: "CYMG",
    iata: "YMG",
    name: "Manitouwadge Airport",
    city: "Manitouwadge",
    country: "CA",
    continent: "NA",
    lat: 49.0839,
    lon: -85.8606,
    elevation: 1198,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMJ": {
    icao: "CYMJ",
    iata: "YMJ",
    name: "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
    city: "Moose Jaw",
    country: "CA",
    continent: "NA",
    lat: 50.3303,
    lon: -105.559,
    elevation: 1892,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYML": {
    icao: "CYML",
    iata: "YML",
    name: "Charlevoix Airport",
    city: "Charlevoix",
    country: "CA",
    continent: "NA",
    lat: 47.5975,
    lon: -70.2239,
    elevation: 977,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMM": {
    icao: "CYMM",
    iata: "YMM",
    name: "Fort McMurray Airport",
    city: "Fort McMurray",
    country: "CA",
    continent: "NA",
    lat: 56.6533,
    lon: -111.222,
    elevation: 1211,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMO": {
    icao: "CYMO",
    iata: "YMO",
    name: "Moosonee Airport",
    city: "Moosonee",
    country: "CA",
    continent: "NA",
    lat: 51.2911,
    lon: -80.6078,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMT": {
    icao: "CYMT",
    iata: "YMT",
    name: "Chapais Airport",
    city: "Chibougamau",
    country: "CA",
    continent: "NA",
    lat: 49.7719,
    lon: -74.5281,
    elevation: 1270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYMX": {
    icao: "CYMX",
    iata: "YMX",
    name: "Montreal International (Mirabel) Airport",
    city: "Montréal",
    country: "CA",
    continent: "NA",
    lat: 45.6795,
    lon: -74.0387,
    elevation: 270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYNA": {
    icao: "CYNA",
    iata: "YNA",
    name: "Natashquan Airport",
    city: "Natashquan",
    country: "CA",
    continent: "NA",
    lat: 50.1901,
    lon: -61.789,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYND": {
    icao: "CYND",
    iata: "YND",
    name: "Ottawa / Gatineau Airport",
    city: "Gatineau",
    country: "CA",
    continent: "NA",
    lat: 45.5217,
    lon: -75.5636,
    elevation: 211,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYNJ": {
    icao: "CYNJ",
    iata: "YLY",
    name: "Langley Airport",
    city: "Langley",
    country: "CA",
    continent: "NA",
    lat: 49.1008,
    lon: -122.631,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYNL": {
    icao: "CYNL",
    iata: "YNL",
    name: "Points North Landing Airport",
    city: "Points North Landing",
    country: "CA",
    continent: "NA",
    lat: 58.2767,
    lon: -104.082,
    elevation: 1605,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYNM": {
    icao: "CYNM",
    iata: "YNM",
    name: "Matagami Airport",
    city: "Matagami",
    country: "CA",
    continent: "NA",
    lat: 49.7617,
    lon: -77.8028,
    elevation: 918,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYNN": {
    icao: "CYNN",
    iata: "",
    name: "Nejanilini Lake Airport",
    city: "Nejanilini Lake",
    country: "CA",
    continent: "NA",
    lat: 59.4875,
    lon: -97.7803,
    elevation: 1000,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOA": {
    icao: "CYOA",
    iata: "YOA",
    name: "Ekati Airport",
    city: "Ekati",
    country: "CA",
    continent: "NA",
    lat: 64.6989,
    lon: -110.615,
    elevation: 1536,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOD": {
    icao: "CYOD",
    iata: "YOD",
    name: "CFB Cold Lake",
    city: "Cold Lake",
    country: "CA",
    continent: "NA",
    lat: 54.405,
    lon: -110.279,
    elevation: 1775,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOJ": {
    icao: "CYOJ",
    iata: "YOJ",
    name: "High Level Airport",
    city: "High Level",
    country: "CA",
    continent: "NA",
    lat: 58.6214,
    lon: -117.165,
    elevation: 1110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOO": {
    icao: "CYOO",
    iata: "YOO",
    name: "Oshawa Executive Airport",
    city: "Oshawa",
    country: "CA",
    continent: "NA",
    lat: 43.9228,
    lon: -78.895,
    elevation: 460,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOP": {
    icao: "CYOP",
    iata: "YOP",
    name: "Rainbow Lake Airport",
    city: "Rainbow Lake",
    country: "CA",
    continent: "NA",
    lat: 58.4914,
    lon: -119.408,
    elevation: 1759,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOS": {
    icao: "CYOS",
    iata: "YOS",
    name: "Owen Sound / Billy Bishop Regional Airport",
    city: "Owen Sound",
    country: "CA",
    continent: "NA",
    lat: 44.5903,
    lon: -80.8375,
    elevation: 1007,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYOW": {
    icao: "CYOW",
    iata: "YOW",
    name: "Ottawa Macdonald-Cartier International Airport",
    city: "Ottawa",
    country: "CA",
    continent: "NA",
    lat: 45.3225,
    lon: -75.6692,
    elevation: 374,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYPA": {
    icao: "CYPA",
    iata: "YPA",
    name: "Prince Albert Glass Field",
    city: "Prince Albert",
    country: "CA",
    continent: "NA",
    lat: 53.2142,
    lon: -105.673,
    elevation: 1405,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPD": {
    icao: "CYPD",
    iata: "YPS",
    name: "Port Hawkesbury Airport",
    city: "Port Hawkesbury",
    country: "CA",
    continent: "NA",
    lat: 45.6567,
    lon: -61.3681,
    elevation: 377,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPE": {
    icao: "CYPE",
    iata: "YPE",
    name: "Peace River Airport",
    city: "Peace River",
    country: "CA",
    continent: "NA",
    lat: 56.2269,
    lon: -117.447,
    elevation: 1873,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPG": {
    icao: "CYPG",
    iata: "YPG",
    name: "Portage-la-Prairie / Southport Airport",
    city: "Portage la Prairie",
    country: "CA",
    continent: "NA",
    lat: 49.9031,
    lon: -98.2738,
    elevation: 885,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPK": {
    icao: "CYPK",
    iata: "",
    name: "Pitt Meadows Airport",
    city: "Pitt Meadows",
    country: "CA",
    continent: "NA",
    lat: 49.2161,
    lon: -122.71,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPL": {
    icao: "CYPL",
    iata: "YPL",
    name: "Pickle Lake Airport",
    city: "Pickle Lake",
    country: "CA",
    continent: "NA",
    lat: 51.4464,
    lon: -90.2142,
    elevation: 1267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPN": {
    icao: "CYPN",
    iata: "YPN",
    name: "Port-Menier Airport",
    city: "Port-Menier",
    country: "CA",
    continent: "NA",
    lat: 49.8364,
    lon: -64.2886,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPQ": {
    icao: "CYPQ",
    iata: "YPQ",
    name: "Peterborough Municipal Airport",
    city: "Peterborough",
    country: "CA",
    continent: "NA",
    lat: 44.23,
    lon: -78.3633,
    elevation: 628,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPR": {
    icao: "CYPR",
    iata: "YPR",
    name: "Prince Rupert Airport",
    city: "Prince Rupert",
    country: "CA",
    continent: "NA",
    lat: 54.2861,
    lon: -130.445,
    elevation: 116,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPW": {
    icao: "CYPW",
    iata: "YPW",
    name: "Powell River Airport",
    city: "Powell River",
    country: "CA",
    continent: "NA",
    lat: 49.8342,
    lon: -124.5,
    elevation: 425,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPX": {
    icao: "CYPX",
    iata: "YPX",
    name: "Puvirnituq Airport",
    city: "Puvirnituq",
    country: "CA",
    continent: "NA",
    lat: 60.0506,
    lon: -77.2869,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPY": {
    icao: "CYPY",
    iata: "YPY",
    name: "Fort Chipewyan Airport",
    city: "Fort Chipewyan",
    country: "CA",
    continent: "NA",
    lat: 58.7672,
    lon: -111.117,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYPZ": {
    icao: "CYPZ",
    iata: "YPZ",
    name: "Burns Lake Airport",
    city: "Burns Lake",
    country: "CA",
    continent: "NA",
    lat: 54.3764,
    lon: -125.951,
    elevation: 2343,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQA": {
    icao: "CYQA",
    iata: "YQA",
    name: "Muskoka Airport",
    city: "Gravenhurst",
    country: "CA",
    continent: "NA",
    lat: 44.9754,
    lon: -79.3065,
    elevation: 925,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQB": {
    icao: "CYQB",
    iata: "YQB",
    name: "Quebec Jean Lesage International Airport",
    city: "Quebec",
    country: "CA",
    continent: "NA",
    lat: 46.7911,
    lon: -71.3933,
    elevation: 244,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYQD": {
    icao: "CYQD",
    iata: "YQD",
    name: "The Pas Airport",
    city: "The Pas",
    country: "CA",
    continent: "NA",
    lat: 53.9714,
    lon: -101.091,
    elevation: 887,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQF": {
    icao: "CYQF",
    iata: "YQF",
    name: "Red Deer Regional Airport",
    city: "Springbrook",
    country: "CA",
    continent: "NA",
    lat: 52.1822,
    lon: -113.894,
    elevation: 2968,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQG": {
    icao: "CYQG",
    iata: "YQG",
    name: "Windsor Airport",
    city: "Windsor",
    country: "CA",
    continent: "NA",
    lat: 42.2756,
    lon: -82.9556,
    elevation: 622,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQH": {
    icao: "CYQH",
    iata: "YQH",
    name: "Watson Lake Airport",
    city: "Watson Lake",
    country: "CA",
    continent: "NA",
    lat: 60.1168,
    lon: -128.822,
    elevation: 2255,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQI": {
    icao: "CYQI",
    iata: "YQI",
    name: "Yarmouth Airport",
    city: "Yarmouth",
    country: "CA",
    continent: "NA",
    lat: 43.8269,
    lon: -66.0881,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQK": {
    icao: "CYQK",
    iata: "YQK",
    name: "Kenora Airport",
    city: "Kenora",
    country: "CA",
    continent: "NA",
    lat: 49.7883,
    lon: -94.3631,
    elevation: 1332,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQL": {
    icao: "CYQL",
    iata: "YQL",
    name: "Lethbridge County Airport",
    city: "Lethbridge",
    country: "CA",
    continent: "NA",
    lat: 49.6303,
    lon: -112.8,
    elevation: 3048,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQM": {
    icao: "CYQM",
    iata: "YQM",
    name: "Greater Moncton Roméo LeBlanc International Airport",
    city: "Moncton",
    country: "CA",
    continent: "NA",
    lat: 46.1122,
    lon: -64.6786,
    elevation: 232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQN": {
    icao: "CYQN",
    iata: "YQN",
    name: "Nakina Airport",
    city: "Nakina",
    country: "CA",
    continent: "NA",
    lat: 50.1828,
    lon: -86.6964,
    elevation: 1057,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQQ": {
    icao: "CYQQ",
    iata: "YQQ",
    name: "Comox Valley Airport / CFB Comox",
    city: "Comox",
    country: "CA",
    continent: "NA",
    lat: 49.7108,
    lon: -124.887,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQR": {
    icao: "CYQR",
    iata: "YQR",
    name: "Regina International Airport",
    city: "Regina",
    country: "CA",
    continent: "NA",
    lat: 50.4319,
    lon: -104.666,
    elevation: 1894,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQS": {
    icao: "CYQS",
    iata: "YQS",
    name: "St Thomas Municipal Airport",
    city: "St Thomas",
    country: "CA",
    continent: "NA",
    lat: 42.77,
    lon: -81.1108,
    elevation: 778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQT": {
    icao: "CYQT",
    iata: "YQT",
    name: "Thunder Bay Airport",
    city: "Thunder Bay",
    country: "CA",
    continent: "NA",
    lat: 48.3719,
    lon: -89.3239,
    elevation: 653,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQU": {
    icao: "CYQU",
    iata: "YQU",
    name: "Grande Prairie Airport",
    city: "Grande Prairie",
    country: "CA",
    continent: "NA",
    lat: 55.1797,
    lon: -118.885,
    elevation: 2195,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQV": {
    icao: "CYQV",
    iata: "YQV",
    name: "Yorkton Municipal Airport",
    city: "Yorkton",
    country: "CA",
    continent: "NA",
    lat: 51.2647,
    lon: -102.462,
    elevation: 1635,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQW": {
    icao: "CYQW",
    iata: "YQW",
    name: "North Battleford Airport",
    city: "North Battleford",
    country: "CA",
    continent: "NA",
    lat: 52.7694,
    lon: -108.2437,
    elevation: 1799,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQX": {
    icao: "CYQX",
    iata: "YQX",
    name: "Gander International Airport / CFB Gander",
    city: "Gander",
    country: "CA",
    continent: "NA",
    lat: 48.9363,
    lon: -54.5677,
    elevation: 496,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQY": {
    icao: "CYQY",
    iata: "YQY",
    name: "Sydney / J.A. Douglas McCurdy Airport",
    city: "Sydney",
    country: "CA",
    continent: "NA",
    lat: 46.1614,
    lon: -60.0478,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYQZ": {
    icao: "CYQZ",
    iata: "YQZ",
    name: "Quesnel Airport",
    city: "Quesnel",
    country: "CA",
    continent: "NA",
    lat: 53.0261,
    lon: -122.51,
    elevation: 1789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRB": {
    icao: "CYRB",
    iata: "YRB",
    name: "Resolute Bay Airport",
    city: "Resolute Bay",
    country: "CA",
    continent: "NA",
    lat: 74.7169,
    lon: -94.9694,
    elevation: 215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRI": {
    icao: "CYRI",
    iata: "YRI",
    name: "Rivière-du-Loup Airport",
    city: "Rivière-du-Loup",
    country: "CA",
    continent: "NA",
    lat: 47.7644,
    lon: -69.5847,
    elevation: 427,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRJ": {
    icao: "CYRJ",
    iata: "YRJ",
    name: "Roberval Airport",
    city: "Roberval",
    country: "CA",
    continent: "NA",
    lat: 48.5197,
    lon: -72.2657,
    elevation: 586,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRL": {
    icao: "CYRL",
    iata: "YRL",
    name: "Red Lake Airport",
    city: "Red Lake",
    country: "CA",
    continent: "NA",
    lat: 51.0669,
    lon: -93.7931,
    elevation: 1265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRO": {
    icao: "CYRO",
    iata: "YRO",
    name: "Ottawa / Rockcliffe Airport",
    city: "Ottawa",
    country: "CA",
    continent: "NA",
    lat: 45.4603,
    lon: -75.6461,
    elevation: 188,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRP": {
    icao: "CYRP",
    iata: "",
    name: "Ottawa / Carp Airport",
    city: "Ottawa",
    country: "CA",
    continent: "NA",
    lat: 45.3192,
    lon: -76.0222,
    elevation: 382,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRQ": {
    icao: "CYRQ",
    iata: "YRQ",
    name: "Trois-Rivières Airport",
    city: "Trois-Rivières",
    country: "CA",
    continent: "NA",
    lat: 46.3528,
    lon: -72.6794,
    elevation: 199,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRT": {
    icao: "CYRT",
    iata: "YRT",
    name: "Rankin Inlet Airport",
    city: "Rankin Inlet",
    country: "CA",
    continent: "NA",
    lat: 62.8114,
    lon: -92.1158,
    elevation: 94,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYRV": {
    icao: "CYRV",
    iata: "YRV",
    name: "Revelstoke Airport",
    city: "Revelstoke",
    country: "CA",
    continent: "NA",
    lat: 50.9622,
    lon: -118.1843,
    elevation: 1459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSB": {
    icao: "CYSB",
    iata: "YSB",
    name: "Sudbury Airport",
    city: "Sudbury",
    country: "CA",
    continent: "NA",
    lat: 46.625,
    lon: -80.7989,
    elevation: 1141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSC": {
    icao: "CYSC",
    iata: "YSC",
    name: "Sherbrooke Airport",
    city: "Sherbrooke",
    country: "CA",
    continent: "NA",
    lat: 45.4386,
    lon: -71.6914,
    elevation: 792,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSF": {
    icao: "CYSF",
    iata: "YSF",
    name: "Stony Rapids Airport",
    city: "Stony Rapids",
    country: "CA",
    continent: "NA",
    lat: 59.2503,
    lon: -105.841,
    elevation: 805,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSG": {
    icao: "CYSG",
    iata: "",
    name: "Saint-Georges Airport",
    city: "Saint-Georges",
    country: "CA",
    continent: "NA",
    lat: 46.0964,
    lon: -70.7147,
    elevation: 893,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSH": {
    icao: "CYSH",
    iata: "YSH",
    name: "Smiths Falls-Montague (Russ Beach) Airport",
    city: "Smiths Falls",
    country: "CA",
    continent: "NA",
    lat: 44.9458,
    lon: -75.9406,
    elevation: 416,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSJ": {
    icao: "CYSJ",
    iata: "YSJ",
    name: "Saint John Airport",
    city: "Saint John",
    country: "CA",
    continent: "NA",
    lat: 45.3161,
    lon: -65.8903,
    elevation: 357,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSL": {
    icao: "CYSL",
    iata: "YSL",
    name: "Saint-Léonard Airport",
    city: "Saint-Léonard",
    country: "CA",
    continent: "NA",
    lat: 47.1571,
    lon: -67.8362,
    elevation: 793,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSM": {
    icao: "CYSM",
    iata: "YSM",
    name: "Fort Smith Airport",
    city: "Fort Smith",
    country: "CA",
    continent: "NA",
    lat: 60.0203,
    lon: -111.962,
    elevation: 671,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSN": {
    icao: "CYSN",
    iata: "YCM",
    name: "Niagara District Airport",
    city: "Niagara-on-the-Lake",
    country: "CA",
    continent: "NA",
    lat: 43.1916,
    lon: -79.1717,
    elevation: 321,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSP": {
    icao: "CYSP",
    iata: "YSP",
    name: "Marathon Airport",
    city: "Marathon",
    country: "CA",
    continent: "NA",
    lat: 48.7553,
    lon: -86.3444,
    elevation: 1035,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYSU": {
    icao: "CYSU",
    iata: "YSU",
    name: "Summerside Airport",
    city: "Slemon Park",
    country: "CA",
    continent: "NA",
    lat: 46.4406,
    lon: -63.8336,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYTA": {
    icao: "CYTA",
    iata: "YTA",
    name: "Pembroke Airport",
    city: "Pembroke",
    country: "CA",
    continent: "NA",
    lat: 45.8644,
    lon: -77.2517,
    elevation: 529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYTF": {
    icao: "CYTF",
    iata: "YTF",
    name: "Alma Airport",
    city: "Alma",
    country: "CA",
    continent: "NA",
    lat: 48.5089,
    lon: -71.6419,
    elevation: 445,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYTH": {
    icao: "CYTH",
    iata: "YTH",
    name: "Thompson Airport",
    city: "Thompson",
    country: "CA",
    continent: "NA",
    lat: 55.8011,
    lon: -97.8642,
    elevation: 729,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYTR": {
    icao: "CYTR",
    iata: "YTR",
    name: "CFB Trenton",
    city: "Trenton",
    country: "CA",
    continent: "NA",
    lat: 44.1189,
    lon: -77.5281,
    elevation: 283,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYTS": {
    icao: "CYTS",
    iata: "YTS",
    name: "Timmins/Victor M. Power",
    city: "Timmins",
    country: "CA",
    continent: "NA",
    lat: 48.5697,
    lon: -81.3767,
    elevation: 967,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYTZ": {
    icao: "CYTZ",
    iata: "YTZ",
    name: "Billy Bishop Toronto City Centre Airport",
    city: "Toronto",
    country: "CA",
    continent: "NA",
    lat: 43.6275,
    lon: -79.3962,
    elevation: 252,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYUL": {
    icao: "CYUL",
    iata: "YUL",
    name: "Montreal / Pierre Elliott Trudeau International Airport",
    city: "Montréal",
    country: "CA",
    continent: "NA",
    lat: 45.4678,
    lon: -73.7423,
    elevation: 118,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYUX": {
    icao: "CYUX",
    iata: "YUX",
    name: "Hall Beach Airport",
    city: "Sanirajak",
    country: "CA",
    continent: "NA",
    lat: 68.7761,
    lon: -81.2425,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYUY": {
    icao: "CYUY",
    iata: "YUY",
    name: "Rouyn Noranda Airport",
    city: "Rouyn-Noranda",
    country: "CA",
    continent: "NA",
    lat: 48.2061,
    lon: -78.8356,
    elevation: 988,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVB": {
    icao: "CYVB",
    iata: "YVB",
    name: "Bonaventure Airport",
    city: "Bonaventure",
    country: "CA",
    continent: "NA",
    lat: 48.0711,
    lon: -65.4603,
    elevation: 123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVC": {
    icao: "CYVC",
    iata: "YVC",
    name: "La Ronge Airport",
    city: "La Ronge",
    country: "CA",
    continent: "NA",
    lat: 55.1514,
    lon: -105.262,
    elevation: 1242,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVD": {
    icao: "CYVD",
    iata: "",
    name: "Virden / RJ (Bob) Andrew Field Regional Aerodrome",
    city: "Virden",
    country: "CA",
    continent: "NA",
    lat: 49.8783,
    lon: -100.918,
    elevation: 1454,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVK": {
    icao: "CYVK",
    iata: "YVE",
    name: "Vernon Regional Airport",
    city: "Vernon",
    country: "CA",
    continent: "NA",
    lat: 50.2462,
    lon: -119.331,
    elevation: 1140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVO": {
    icao: "CYVO",
    iata: "YVO",
    name: "Val-d\'Or Airport",
    city: "Val-d\'Or",
    country: "CA",
    continent: "NA",
    lat: 48.0533,
    lon: -77.7828,
    elevation: 1107,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVP": {
    icao: "CYVP",
    iata: "YVP",
    name: "Kuujjuaq Airport",
    city: "Kuujjuaq",
    country: "CA",
    continent: "NA",
    lat: 58.0961,
    lon: -68.4269,
    elevation: 129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVQ": {
    icao: "CYVQ",
    iata: "YVQ",
    name: "Norman Wells Airport",
    city: "Norman Wells",
    country: "CA",
    continent: "NA",
    lat: 65.2816,
    lon: -126.798,
    elevation: 238,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYVR": {
    icao: "CYVR",
    iata: "YVR",
    name: "Vancouver International Airport",
    city: "Vancouver",
    country: "CA",
    continent: "NA",
    lat: 49.1939,
    lon: -123.184,
    elevation: 14,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYVV": {
    icao: "CYVV",
    iata: "YVV",
    name: "Wiarton Airport",
    city: "Wiarton",
    country: "CA",
    continent: "NA",
    lat: 44.7458,
    lon: -81.1072,
    elevation: 729,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYWG": {
    icao: "CYWG",
    iata: "YWG",
    name: "Winnipeg / James Armstrong Richardson International Airport",
    city: "Winnipeg",
    country: "CA",
    continent: "NA",
    lat: 49.91,
    lon: -97.2399,
    elevation: 783,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYWK": {
    icao: "CYWK",
    iata: "YWK",
    name: "Wabush Airport",
    city: "Wabush",
    country: "CA",
    continent: "NA",
    lat: 52.9219,
    lon: -66.8644,
    elevation: 1808,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYWL": {
    icao: "CYWL",
    iata: "YWL",
    name: "Williams Lake Airport",
    city: "Williams Lake",
    country: "CA",
    continent: "NA",
    lat: 52.1831,
    lon: -122.054,
    elevation: 3085,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYWY": {
    icao: "CYWY",
    iata: "YWY",
    name: "Wrigley Airport",
    city: "Wrigley",
    country: "CA",
    continent: "NA",
    lat: 63.2094,
    lon: -123.437,
    elevation: 489,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXC": {
    icao: "CYXC",
    iata: "YXC",
    name: "Cranbrook/Canadian Rockies International Airport",
    city: "Cranbrook",
    country: "CA",
    continent: "NA",
    lat: 49.6108,
    lon: -115.782,
    elevation: 3082,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXE": {
    icao: "CYXE",
    iata: "YXE",
    name: "Saskatoon John G. Diefenbaker International Airport",
    city: "Saskatoon",
    country: "CA",
    continent: "NA",
    lat: 52.1708,
    lon: -106.7,
    elevation: 1653,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXH": {
    icao: "CYXH",
    iata: "YXH",
    name: "Medicine Hat Regional Airport",
    city: "Medicine Hat",
    country: "CA",
    continent: "NA",
    lat: 50.0189,
    lon: -110.721,
    elevation: 2352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXJ": {
    icao: "CYXJ",
    iata: "YXJ",
    name: "Fort St John / North Peace Regional Airport",
    city: "Fort Saint John",
    country: "CA",
    continent: "NA",
    lat: 56.2381,
    lon: -120.74,
    elevation: 2280,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXK": {
    icao: "CYXK",
    iata: "YXK",
    name: "Rimouski Airport",
    city: "Rimouski",
    country: "CA",
    continent: "NA",
    lat: 48.4776,
    lon: -68.4963,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXL": {
    icao: "CYXL",
    iata: "YXL",
    name: "Sioux Lookout Airport",
    city: "Sioux Lookout",
    country: "CA",
    continent: "NA",
    lat: 50.1139,
    lon: -91.9053,
    elevation: 1258,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXQ": {
    icao: "CYXQ",
    iata: "YXQ",
    name: "Beaver Creek Airport",
    city: "Beaver Creek",
    country: "CA",
    continent: "NA",
    lat: 62.4103,
    lon: -140.867,
    elevation: 2131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXR": {
    icao: "CYXR",
    iata: "YXR",
    name: "Earlton (Timiskaming Regional) Airport",
    city: "Earlton",
    country: "CA",
    continent: "NA",
    lat: 47.6974,
    lon: -79.8473,
    elevation: 800,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXS": {
    icao: "CYXS",
    iata: "YXS",
    name: "Prince George Airport",
    city: "Prince George",
    country: "CA",
    continent: "NA",
    lat: 53.8843,
    lon: -122.6666,
    elevation: 2267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXT": {
    icao: "CYXT",
    iata: "YXT",
    name: "Northwest Regional Airport Terrace-Kitimat",
    city: "Terrace",
    country: "CA",
    continent: "NA",
    lat: 54.4685,
    lon: -128.576,
    elevation: 713,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXU": {
    icao: "CYXU",
    iata: "YXU",
    name: "London Airport",
    city: "London",
    country: "CA",
    continent: "NA",
    lat: 43.0356,
    lon: -81.1539,
    elevation: 912,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXX": {
    icao: "CYXX",
    iata: "YXX",
    name: "Abbotsford International Airport",
    city: "Abbotsford",
    country: "CA",
    continent: "NA",
    lat: 49.0253,
    lon: -122.361,
    elevation: 195,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXY": {
    icao: "CYXY",
    iata: "YXY",
    name: "Whitehorse / Erik Nielsen International Airport",
    city: "Whitehorse",
    country: "CA",
    continent: "NA",
    lat: 60.7096,
    lon: -135.067,
    elevation: 2317,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYXZ": {
    icao: "CYXZ",
    iata: "YXZ",
    name: "Wawa Airport",
    city: "Wawa",
    country: "CA",
    continent: "NA",
    lat: 47.9667,
    lon: -84.7867,
    elevation: 942,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYB": {
    icao: "CYYB",
    iata: "YYB",
    name: "North Bay Jack Garland Airport",
    city: "North Bay",
    country: "CA",
    continent: "NA",
    lat: 46.3636,
    lon: -79.4228,
    elevation: 1215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYC": {
    icao: "CYYC",
    iata: "YYC",
    name: "Calgary International Airport",
    city: "Calgary",
    country: "CA",
    continent: "NA",
    lat: 51.1188,
    lon: -114.0099,
    elevation: 3557,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYYD": {
    icao: "CYYD",
    iata: "YYD",
    name: "Smithers Airport",
    city: "Smithers",
    country: "CA",
    continent: "NA",
    lat: 54.8247,
    lon: -127.183,
    elevation: 1712,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYE": {
    icao: "CYYE",
    iata: "YYE",
    name: "Fort Nelson Airport",
    city: "Fort Nelson",
    country: "CA",
    continent: "NA",
    lat: 58.8364,
    lon: -122.597,
    elevation: 1253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYF": {
    icao: "CYYF",
    iata: "YYF",
    name: "Penticton Airport",
    city: "Penticton",
    country: "CA",
    continent: "NA",
    lat: 49.4631,
    lon: -119.602,
    elevation: 1129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYG": {
    icao: "CYYG",
    iata: "YYG",
    name: "Charlottetown Airport",
    city: "Charlottetown",
    country: "CA",
    continent: "NA",
    lat: 46.29,
    lon: -63.1211,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYJ": {
    icao: "CYYJ",
    iata: "YYJ",
    name: "Victoria International Airport",
    city: "Victoria",
    country: "CA",
    continent: "NA",
    lat: 48.6472,
    lon: -123.4278,
    elevation: 63,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYL": {
    icao: "CYYL",
    iata: "YYL",
    name: "Lynn Lake Airport",
    city: "Lynn Lake",
    country: "CA",
    continent: "NA",
    lat: 56.8639,
    lon: -101.076,
    elevation: 1170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYN": {
    icao: "CYYN",
    iata: "YYN",
    name: "Swift Current Airport",
    city: "Swift Current",
    country: "CA",
    continent: "NA",
    lat: 50.2919,
    lon: -107.691,
    elevation: 2680,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYQ": {
    icao: "CYYQ",
    iata: "YYQ",
    name: "Churchill Airport",
    city: "Churchill",
    country: "CA",
    continent: "NA",
    lat: 58.7392,
    lon: -94.065,
    elevation: 94,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYR": {
    icao: "CYYR",
    iata: "YYR",
    name: "Goose Bay Airport",
    city: "Goose Bay",
    country: "CA",
    continent: "NA",
    lat: 53.3192,
    lon: -60.4258,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYT": {
    icao: "CYYT",
    iata: "YYT",
    name: "St. John\'s International Airport",
    city: "St. John\'s",
    country: "CA",
    continent: "NA",
    lat: 47.6186,
    lon: -52.7519,
    elevation: 461,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYYU": {
    icao: "CYYU",
    iata: "YYU",
    name: "Kapuskasing Airport",
    city: "Kapuskasing",
    country: "CA",
    continent: "NA",
    lat: 49.4116,
    lon: -82.4696,
    elevation: 743,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYW": {
    icao: "CYYW",
    iata: "YYW",
    name: "Armstrong Airport",
    city: "Armstrong",
    country: "CA",
    continent: "NA",
    lat: 50.2903,
    lon: -88.9097,
    elevation: 1058,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYY": {
    icao: "CYYY",
    iata: "YYY",
    name: "Mont Joli Airport",
    city: "Mont-Joli",
    country: "CA",
    continent: "NA",
    lat: 48.6086,
    lon: -68.2081,
    elevation: 172,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYYZ": {
    icao: "CYYZ",
    iata: "YYZ",
    name: "Toronto Lester B. Pearson International Airport",
    city: "Toronto",
    country: "CA",
    continent: "NA",
    lat: 43.6772,
    lon: -79.6306,
    elevation: 569,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "CYZE": {
    icao: "CYZE",
    iata: "YZE",
    name: "Gore Bay Manitoulin Airport",
    city: "Gore Bay",
    country: "CA",
    continent: "NA",
    lat: 45.8853,
    lon: -82.5678,
    elevation: 623,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZF": {
    icao: "CYZF",
    iata: "YZF",
    name: "Yellowknife International Airport",
    city: "Yellowknife",
    country: "CA",
    continent: "NA",
    lat: 62.4628,
    lon: -114.44,
    elevation: 675,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZH": {
    icao: "CYZH",
    iata: "YZH",
    name: "Slave Lake Airport",
    city: "Slave Lake",
    country: "CA",
    continent: "NA",
    lat: 55.2929,
    lon: -114.7773,
    elevation: 1912,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZP": {
    icao: "CYZP",
    iata: "YZP",
    name: "Sandspit Airport",
    city: "Sandspit",
    country: "CA",
    continent: "NA",
    lat: 53.2543,
    lon: -131.814,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZR": {
    icao: "CYZR",
    iata: "YZR",
    name: "Chris Hadfield Airport",
    city: "Sarnia",
    country: "CA",
    continent: "NA",
    lat: 42.9994,
    lon: -82.3089,
    elevation: 594,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZS": {
    icao: "CYZS",
    iata: "YZS",
    name: "Coral Harbour Airport",
    city: "Coral Harbour",
    country: "CA",
    continent: "NA",
    lat: 64.1933,
    lon: -83.3594,
    elevation: 210,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZT": {
    icao: "CYZT",
    iata: "YZT",
    name: "Port Hardy Airport",
    city: "Port Hardy",
    country: "CA",
    continent: "NA",
    lat: 50.6806,
    lon: -127.367,
    elevation: 71,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZU": {
    icao: "CYZU",
    iata: "YZU",
    name: "Whitecourt Airport",
    city: "Whitecourt",
    country: "CA",
    continent: "NA",
    lat: 54.1439,
    lon: -115.787,
    elevation: 2567,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZV": {
    icao: "CYZV",
    iata: "YZV",
    name: "Sept-Îles Airport",
    city: "Sept-Îles",
    country: "CA",
    continent: "NA",
    lat: 50.2233,
    lon: -66.2656,
    elevation: 180,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZW": {
    icao: "CYZW",
    iata: "YZW",
    name: "Teslin Airport",
    city: "Teslin",
    country: "CA",
    continent: "NA",
    lat: 60.1728,
    lon: -132.743,
    elevation: 2313,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZX": {
    icao: "CYZX",
    iata: "YZX",
    name: "CFB Greenwood",
    city: "Greenwood",
    country: "CA",
    continent: "NA",
    lat: 44.9844,
    lon: -64.9169,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CYZY": {
    icao: "CYZY",
    iata: "",
    name: "Mackenzie Airport",
    city: "Mackenzie",
    country: "CA",
    continent: "NA",
    lat: 55.2978,
    lon: -123.1339,
    elevation: 2264,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZAM": {
    icao: "CZAM",
    iata: "YSN",
    name: "Shuswap Regional Airport",
    city: "Salmon Arm",
    country: "CA",
    continent: "NA",
    lat: 50.6828,
    lon: -119.229,
    elevation: 1751,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZBB": {
    icao: "CZBB",
    iata: "YDT",
    name: "Boundary Bay Airport",
    city: "Delta",
    country: "CA",
    continent: "NA",
    lat: 49.0742,
    lon: -123.012,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZBF": {
    icao: "CZBF",
    iata: "ZBF",
    name: "Bathurst Airport",
    city: "South Tetagouche",
    country: "CA",
    continent: "NA",
    lat: 47.6297,
    lon: -65.7389,
    elevation: 193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZBM": {
    icao: "CZBM",
    iata: "ZBM",
    name: "Bromont (Roland Désourdy) Airport",
    city: "Bromont",
    country: "CA",
    continent: "NA",
    lat: 45.2908,
    lon: -72.7414,
    elevation: 375,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZEE": {
    icao: "CZEE",
    iata: "KES",
    name: "Kelsey Airport",
    city: "Kelsey",
    country: "CA",
    continent: "NA",
    lat: 56.0375,
    lon: -96.5097,
    elevation: 600,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZFA": {
    icao: "CZFA",
    iata: "ZFA",
    name: "Faro Airport",
    city: "Faro",
    country: "CA",
    continent: "NA",
    lat: 62.2075,
    lon: -133.376,
    elevation: 2351,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZGF": {
    icao: "CZGF",
    iata: "ZGF",
    name: "Grand Forks Airport",
    city: "Grand Forks",
    country: "CA",
    continent: "NA",
    lat: 49.0156,
    lon: -118.431,
    elevation: 1720,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZJG": {
    icao: "CZJG",
    iata: "ZJG",
    name: "Jenpeg Airport",
    city: "Jenpeg",
    country: "CA",
    continent: "NA",
    lat: 54.5189,
    lon: -98.0461,
    elevation: 729,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZJN": {
    icao: "CZJN",
    iata: "ZJN",
    name: "Swan River Airport",
    city: "Swan River",
    country: "CA",
    continent: "NA",
    lat: 52.1206,
    lon: -101.236,
    elevation: 1100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZLQ": {
    icao: "CZLQ",
    iata: "YTD",
    name: "Thicket Portage Airport",
    city: "Thicket Portage",
    country: "CA",
    continent: "NA",
    lat: 55.3189,
    lon: -97.7078,
    elevation: 678,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZMN": {
    icao: "CZMN",
    iata: "PIW",
    name: "Pikwitonei Airport",
    city: "Pikwitonei",
    country: "CA",
    continent: "NA",
    lat: 55.5889,
    lon: -97.1642,
    elevation: 630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZMT": {
    icao: "CZMT",
    iata: "ZMT",
    name: "Masset Airport",
    city: "Masset",
    country: "CA",
    continent: "NA",
    lat: 54.0275,
    lon: -132.125,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZPC": {
    icao: "CZPC",
    iata: "WPC",
    name: "Pincher Creek Airport",
    city: "Pincher Creek",
    country: "CA",
    continent: "NA",
    lat: 49.5204,
    lon: -113.997,
    elevation: 3903,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZSJ": {
    icao: "CZSJ",
    iata: "ZSJ",
    name: "Sandy Lake Airport",
    city: "Sandy Lake",
    country: "CA",
    continent: "NA",
    lat: 53.0642,
    lon: -93.3444,
    elevation: 951,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZST": {
    icao: "CZST",
    iata: "ZST",
    name: "Stewart Airport",
    city: "Stewart",
    country: "CA",
    continent: "NA",
    lat: 55.9354,
    lon: -129.9824,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "CZUC": {
    icao: "CZUC",
    iata: "ZUC",
    name: "Ignace Municipal Airport",
    city: "Ignace",
    country: "CA",
    continent: "NA",
    lat: 49.4282,
    lon: -91.7204,
    elevation: 1435,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAB": {
    icao: "DAAB",
    iata: "",
    name: "Blida Airport",
    city: "Blida",
    country: "DZ",
    continent: "AF",
    lat: 36.5036,
    lon: 2.8142,
    elevation: 535,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAD": {
    icao: "DAAD",
    iata: "BUJ",
    name: "Bou Saada Airport",
    city: "Ouled Sidi Brahim",
    country: "DZ",
    continent: "AF",
    lat: 35.3325,
    lon: 4.2064,
    elevation: 1506,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAE": {
    icao: "DAAE",
    iata: "BJA",
    name: "Soummam–Abane Ramdane Airport",
    city: "Béjaïa",
    country: "DZ",
    continent: "AF",
    lat: 36.712,
    lon: 5.0698,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAG": {
    icao: "DAAG",
    iata: "ALG",
    name: "Houari Boumediene Airport",
    city: "Algiers",
    country: "DZ",
    continent: "AF",
    lat: 36.6939,
    lon: 3.2145,
    elevation: 82,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "DAAJ": {
    icao: "DAAJ",
    iata: "DJG",
    name: "Djanet Inedbirene Airport",
    city: "Djanet",
    country: "DZ",
    continent: "AF",
    lat: 24.2928,
    lon: 9.4524,
    elevation: 3176,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAK": {
    icao: "DAAK",
    iata: "",
    name: "Boufarik Air Base",
    city: "Boufarik",
    country: "DZ",
    continent: "AF",
    lat: 36.5458,
    lon: 2.8761,
    elevation: 335,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAP": {
    icao: "DAAP",
    iata: "VVZ",
    name: "Illizi Takhamalt Airport",
    city: "Illizi",
    country: "DZ",
    continent: "AF",
    lat: 26.7235,
    lon: 8.6227,
    elevation: 1778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAS": {
    icao: "DAAS",
    iata: "QSF",
    name: "Ain Arnat Airport",
    city: "Sétif",
    country: "DZ",
    continent: "AF",
    lat: 36.1781,
    lon: 5.3245,
    elevation: 3360,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAT": {
    icao: "DAAT",
    iata: "TMR",
    name: "Aguenar – Hadj Bey Akhamok Airport",
    city: "Tamanrasset",
    country: "DZ",
    continent: "AF",
    lat: 22.8115,
    lon: 5.4511,
    elevation: 4518,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAV": {
    icao: "DAAV",
    iata: "GJL",
    name: "Jijel Ferhat Abbas Airport",
    city: "Tahir",
    country: "DZ",
    continent: "AF",
    lat: 36.7951,
    lon: 5.8736,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAY": {
    icao: "DAAY",
    iata: "MZW",
    name: "Mecheria Airport",
    city: "Mecheria",
    country: "DZ",
    continent: "AF",
    lat: 33.5359,
    lon: -0.2424,
    elevation: 3855,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAAZ": {
    icao: "DAAZ",
    iata: "",
    name: "Relizane Airport",
    city: "Relizane",
    country: "DZ",
    continent: "AF",
    lat: 35.753,
    lon: 0.6259,
    elevation: 282,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DABB": {
    icao: "DABB",
    iata: "AAE",
    name: "Annaba Rabah Bitat Airport",
    city: "Annaba",
    country: "DZ",
    continent: "AF",
    lat: 36.8268,
    lon: 7.8133,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DABC": {
    icao: "DABC",
    iata: "CZL",
    name: "Mohamed Boudiaf International Airport",
    city: "Constantine",
    country: "DZ",
    continent: "AF",
    lat: 36.276,
    lon: 6.6204,
    elevation: 2265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DABS": {
    icao: "DABS",
    iata: "TEE",
    name: "Cheikh Larbi Tébessi Airport",
    city: "Tébessi",
    country: "DZ",
    continent: "AF",
    lat: 35.4316,
    lon: 8.1207,
    elevation: 2661,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DABT": {
    icao: "DABT",
    iata: "BLJ",
    name: "Batna Mostefa Ben Boulaid Airport",
    city: "Batna",
    country: "DZ",
    continent: "AF",
    lat: 35.7521,
    lon: 6.3086,
    elevation: 2697,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAFH": {
    icao: "DAFH",
    iata: "HRM",
    name: "Hassi R\'Mel Airport",
    city: "Hassi R\'Mel",
    country: "DZ",
    continent: "AF",
    lat: 32.9304,
    lon: 3.3115,
    elevation: 2540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOB": {
    icao: "DAOB",
    iata: "TID",
    name: "Abdelhafid Boussouf Bou Chekif Airport",
    city: "Tiaret",
    country: "DZ",
    continent: "AF",
    lat: 35.3411,
    lon: 1.4631,
    elevation: 3245,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOF": {
    icao: "DAOF",
    iata: "TIN",
    name: "Tindouf Airport",
    city: "Tindouf",
    country: "DZ",
    continent: "AF",
    lat: 27.7004,
    lon: -8.1671,
    elevation: 1453,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOI": {
    icao: "DAOI",
    iata: "CFK",
    name: "Chlef Aboubakr Belkaid International Airport",
    city: "Chlef",
    country: "DZ",
    continent: "AF",
    lat: 36.2172,
    lon: 1.3422,
    elevation: 463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOL": {
    icao: "DAOL",
    iata: "TAF",
    name: "Oran Tafraoui Airport",
    city: "Tafraoui",
    country: "DZ",
    continent: "AF",
    lat: 35.5424,
    lon: -0.5323,
    elevation: 367,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAON": {
    icao: "DAON",
    iata: "TLM",
    name: "Zenata – Messali El Hadj Airport",
    city: "Zenata",
    country: "DZ",
    continent: "AF",
    lat: 35.0134,
    lon: -1.4572,
    elevation: 814,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOO": {
    icao: "DAOO",
    iata: "ORN",
    name: "Oran Es-Sénia (Ahmed Ben Bella) International Airport",
    city: "Es-Sénia",
    country: "DZ",
    continent: "AF",
    lat: 35.6239,
    lon: -0.6212,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOR": {
    icao: "DAOR",
    iata: "CBH",
    name: "Béchar Boudghene Ben Ali Lotfi Airport",
    city: "Béchar",
    country: "DZ",
    continent: "AF",
    lat: 31.6457,
    lon: -2.2699,
    elevation: 2661,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAOV": {
    icao: "DAOV",
    iata: "MUW",
    name: "Ghriss Airport",
    city: "Ghriss",
    country: "DZ",
    continent: "AF",
    lat: 35.2077,
    lon: 0.1471,
    elevation: 1686,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUA": {
    icao: "DAUA",
    iata: "AZR",
    name: "Touat Cheikh Sidi Mohamed Belkebir Airport",
    city: "Adrar",
    country: "DZ",
    continent: "AF",
    lat: 27.8376,
    lon: -0.1864,
    elevation: 919,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUB": {
    icao: "DAUB",
    iata: "BSK",
    name: "Biskra - Mohamed Khider Airport",
    city: "Biskra",
    country: "DZ",
    continent: "AF",
    lat: 34.7933,
    lon: 5.7382,
    elevation: 289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUE": {
    icao: "DAUE",
    iata: "ELG",
    name: "El Golea Airport",
    city: "El Menia",
    country: "DZ",
    continent: "AF",
    lat: 30.5807,
    lon: 2.8616,
    elevation: 1306,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUG": {
    icao: "DAUG",
    iata: "GHA",
    name: "Noumérat - Moufdi Zakaria Airport",
    city: "El Atteuf",
    country: "DZ",
    continent: "AF",
    lat: 32.3841,
    lon: 3.7941,
    elevation: 1512,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUH": {
    icao: "DAUH",
    iata: "HME",
    name: "Hassi Messaoud-Oued Irara Krim Belkacem Airport",
    city: "Hassi Messaoud",
    country: "DZ",
    continent: "AF",
    lat: 31.673,
    lon: 6.1404,
    elevation: 463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUI": {
    icao: "DAUI",
    iata: "INZ",
    name: "In Salah Airport",
    city: "In Salah",
    country: "DZ",
    continent: "AF",
    lat: 27.251,
    lon: 2.512,
    elevation: 896,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUK": {
    icao: "DAUK",
    iata: "TGR",
    name: "Touggourt Sidi Madhi Airport",
    city: "Touggourt",
    country: "DZ",
    continent: "AF",
    lat: 33.0678,
    lon: 6.0887,
    elevation: 279,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUL": {
    icao: "DAUL",
    iata: "LOO",
    name: "Laghouat - Molay Ahmed Medeghri Airport",
    city: "Laghouat",
    country: "DZ",
    continent: "AF",
    lat: 33.7644,
    lon: 2.9283,
    elevation: 2510,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUO": {
    icao: "DAUO",
    iata: "ELU",
    name: "Guemar Airport - مطار قمار بالوادي",
    city: "Guemar",
    country: "DZ",
    continent: "AF",
    lat: 33.5114,
    lon: 6.7768,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUT": {
    icao: "DAUT",
    iata: "TMX",
    name: "Timimoun Airport",
    city: "Timimoun",
    country: "DZ",
    continent: "AF",
    lat: 29.2371,
    lon: 0.276,
    elevation: 1027,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUU": {
    icao: "DAUU",
    iata: "OGX",
    name: "Ain Beida Airport",
    city: "Ouargla",
    country: "DZ",
    continent: "AF",
    lat: 31.9172,
    lon: 5.4128,
    elevation: 492,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DAUZ": {
    icao: "DAUZ",
    iata: "IAM",
    name: "Zarzaitine - In Aménas Airport",
    city: "In Aménas",
    country: "DZ",
    continent: "AF",
    lat: 28.0515,
    lon: 9.6429,
    elevation: 1847,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DBBB": {
    icao: "DBBB",
    iata: "COO",
    name: "Cadjehoun Airport",
    city: "Cotonou",
    country: "BJ",
    continent: "AF",
    lat: 6.3572,
    lon: 2.3844,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DFFD": {
    icao: "DFFD",
    iata: "OUA",
    name: "Ouagadougou Airport",
    city: "Ouagadougou",
    country: "BF",
    continent: "AF",
    lat: 12.3532,
    lon: -1.5124,
    elevation: 1037,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DFOO": {
    icao: "DFOO",
    iata: "BOY",
    name: "Bobo Dioulasso Airport",
    city: "Bobo Dioulasso",
    country: "BF",
    continent: "AF",
    lat: 11.1601,
    lon: -4.331,
    elevation: 1511,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DGAA": {
    icao: "DGAA",
    iata: "ACC",
    name: "Kotoka International Airport",
    city: "Accra",
    country: "GH",
    continent: "AF",
    lat: 5.6052,
    lon: -0.1668,
    elevation: 205,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "DGAH": {
    icao: "DGAH",
    iata: "",
    name: "Ho Airport",
    city: "Ho",
    country: "GH",
    continent: "AF",
    lat: 6.5797,
    lon: 0.5325,
    elevation: 356,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DGLE": {
    icao: "DGLE",
    iata: "TML",
    name: "Tamale Airport",
    city: "Tamale",
    country: "GH",
    continent: "AF",
    lat: 9.5572,
    lon: -0.8632,
    elevation: 553,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DGSI": {
    icao: "DGSI",
    iata: "KMS",
    name: "Kumasi Airport",
    city: "Kumasi",
    country: "GH",
    continent: "AF",
    lat: 6.7146,
    lon: -1.5908,
    elevation: 942,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DGSN": {
    icao: "DGSN",
    iata: "NYI",
    name: "Sunyani Airport",
    city: "Sunyani",
    country: "GH",
    continent: "AF",
    lat: 7.3618,
    lon: -2.3288,
    elevation: 1014,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DGTK": {
    icao: "DGTK",
    iata: "TKD",
    name: "Takoradi Airport",
    city: "Sekondi-Takoradi",
    country: "GH",
    continent: "AF",
    lat: 4.8961,
    lon: -1.7748,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DIAP": {
    icao: "DIAP",
    iata: "ABJ",
    name: "Félix-Houphouët-Boigny International Airport",
    city: "Abidjan",
    country: "CI",
    continent: "AF",
    lat: 5.2614,
    lon: -3.9263,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DIBK": {
    icao: "DIBK",
    iata: "BYK",
    name: "Bouaké Airport",
    city: "Bouaké",
    country: "CI",
    continent: "AF",
    lat: 7.7388,
    lon: -5.0737,
    elevation: 1230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DIDL": {
    icao: "DIDL",
    iata: "DJO",
    name: "Daloa Airport",
    city: "",
    country: "CI",
    continent: "AF",
    lat: 6.7928,
    lon: -6.4732,
    elevation: 823,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DIKO": {
    icao: "DIKO",
    iata: "HGO",
    name: "Korhogo Airport",
    city: "Korhogo",
    country: "CI",
    continent: "AF",
    lat: 9.3872,
    lon: -5.5567,
    elevation: 1214,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DIMN": {
    icao: "DIMN",
    iata: "MJC",
    name: "Man Airport",
    city: "",
    country: "CI",
    continent: "AF",
    lat: 7.2721,
    lon: -7.5874,
    elevation: 1089,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DISP": {
    icao: "DISP",
    iata: "SPY",
    name: "San Pedro Airport",
    city: "",
    country: "CI",
    continent: "AF",
    lat: 4.7467,
    lon: -6.6608,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DIYO": {
    icao: "DIYO",
    iata: "ASK",
    name: "Yamoussoukro Airport",
    city: "Yamoussoukro",
    country: "CI",
    continent: "AF",
    lat: 6.9032,
    lon: -5.3656,
    elevation: 699,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNAA": {
    icao: "DNAA",
    iata: "ABV",
    name: "Nnamdi Azikiwe International Airport",
    city: "Abuja",
    country: "NG",
    continent: "AF",
    lat: 9.0068,
    lon: 7.2632,
    elevation: 1123,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "DNAI": {
    icao: "DNAI",
    iata: "QUO",
    name: "Akwa Ibom International Airport",
    city: "Uyo",
    country: "NG",
    continent: "AF",
    lat: 4.8725,
    lon: 8.093,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNAK": {
    icao: "DNAK",
    iata: "AKR",
    name: "Akure Airport",
    city: "Akure",
    country: "NG",
    continent: "AF",
    lat: 7.2467,
    lon: 5.301,
    elevation: 1100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNAS": {
    icao: "DNAS",
    iata: "ABB",
    name: "Asaba International Airport",
    city: "Asaba",
    country: "NG",
    continent: "AF",
    lat: 6.2042,
    lon: 6.6653,
    elevation: 305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNBC": {
    icao: "DNBC",
    iata: "BCU",
    name: "Sir Abubakar Tafawa Balewa International Airport",
    city: "Bauchi",
    country: "NG",
    continent: "AF",
    lat: 10.4828,
    lon: 9.744,
    elevation: 1965,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNBE": {
    icao: "DNBE",
    iata: "BNI",
    name: "Benin Airport",
    city: "Benin",
    country: "NG",
    continent: "AF",
    lat: 6.317,
    lon: 5.5995,
    elevation: 258,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNBY": {
    icao: "DNBY",
    iata: "",
    name: "Bayelsa International Airport",
    city: "Yenagoa",
    country: "NG",
    continent: "AF",
    lat: 4.9576,
    lon: 6.2033,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNCA": {
    icao: "DNCA",
    iata: "CBQ",
    name: "Margaret Ekpo International Airport",
    city: "Calabar",
    country: "NG",
    continent: "AF",
    lat: 4.976,
    lon: 8.3472,
    elevation: 210,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNEN": {
    icao: "DNEN",
    iata: "ENU",
    name: "Akanu Ibiam International Airport",
    city: "Enegu",
    country: "NG",
    continent: "AF",
    lat: 6.4743,
    lon: 7.562,
    elevation: 466,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNGO": {
    icao: "DNGO",
    iata: "GMO",
    name: "Gombe Lawanti International Airport",
    city: "Gombe",
    country: "NG",
    continent: "AF",
    lat: 10.2989,
    lon: 10.9,
    elevation: 1590,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNGU": {
    icao: "DNGU",
    iata: "",
    name: "Gusau Airport",
    city: "Gusau",
    country: "NG",
    continent: "AF",
    lat: 12.1729,
    lon: 6.6961,
    elevation: 1520,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNIB": {
    icao: "DNIB",
    iata: "IBA",
    name: "Ibadan Airport",
    city: "Ibadan",
    country: "NG",
    continent: "AF",
    lat: 7.3625,
    lon: 3.9783,
    elevation: 725,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNIL": {
    icao: "DNIL",
    iata: "ILR",
    name: "Ilorin International Airport",
    city: "Ilorin",
    country: "NG",
    continent: "AF",
    lat: 8.4402,
    lon: 4.4939,
    elevation: 1126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNIM": {
    icao: "DNIM",
    iata: "QOW",
    name: "Sam Mbakwe International Airport",
    city: "Owerri",
    country: "NG",
    continent: "AF",
    lat: 5.4271,
    lon: 7.206,
    elevation: 373,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNJO": {
    icao: "DNJO",
    iata: "JOS",
    name: "Yakubu Gowon Airport",
    city: "Jos",
    country: "NG",
    continent: "AF",
    lat: 9.6398,
    lon: 8.8691,
    elevation: 4232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNKA": {
    icao: "DNKA",
    iata: "KAD",
    name: "Kaduna Airport",
    city: "Kaduna",
    country: "NG",
    continent: "AF",
    lat: 10.696,
    lon: 7.3201,
    elevation: 2073,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNKN": {
    icao: "DNKN",
    iata: "KAN",
    name: "Mallam Aminu International Airport",
    city: "Kano",
    country: "NG",
    continent: "AF",
    lat: 12.0476,
    lon: 8.5246,
    elevation: 1562,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNMA": {
    icao: "DNMA",
    iata: "MIU",
    name: "Maiduguri International Airport",
    city: "Maiduguri",
    country: "NG",
    continent: "AF",
    lat: 11.8553,
    lon: 13.0809,
    elevation: 1099,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNMK": {
    icao: "DNMK",
    iata: "MDI",
    name: "Makurdi Airport",
    city: "Makurdi",
    country: "NG",
    continent: "AF",
    lat: 7.7039,
    lon: 8.6139,
    elevation: 371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNMM": {
    icao: "DNMM",
    iata: "LOS",
    name: "Murtala Muhammed International Airport",
    city: "Lagos",
    country: "NG",
    continent: "AF",
    lat: 6.5774,
    lon: 3.3212,
    elevation: 135,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "DNMN": {
    icao: "DNMN",
    iata: "MXJ",
    name: "Minna Airport",
    city: "Minna",
    country: "NG",
    continent: "AF",
    lat: 9.6522,
    lon: 6.4623,
    elevation: 834,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNPO": {
    icao: "DNPO",
    iata: "PHC",
    name: "Port Harcourt International Airport",
    city: "Port Harcourt",
    country: "NG",
    continent: "AF",
    lat: 5.0155,
    lon: 6.9496,
    elevation: 87,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNSO": {
    icao: "DNSO",
    iata: "SKO",
    name: "Sadiq Abubakar III International Airport",
    city: "Sokoto",
    country: "NG",
    continent: "AF",
    lat: 12.9163,
    lon: 5.2072,
    elevation: 1010,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNSU": {
    icao: "DNSU",
    iata: "QRW",
    name: "Warri Airport",
    city: "Okpe",
    country: "NG",
    continent: "AF",
    lat: 5.5982,
    lon: 5.8187,
    elevation: 242,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNYO": {
    icao: "DNYO",
    iata: "YOL",
    name: "Yola Airport",
    city: "Yola",
    country: "NG",
    continent: "AF",
    lat: 9.2576,
    lon: 12.4304,
    elevation: 599,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DNZA": {
    icao: "DNZA",
    iata: "ZAR",
    name: "Zaria Airport",
    city: "Zaria",
    country: "NG",
    continent: "AF",
    lat: 11.1302,
    lon: 7.6858,
    elevation: 2170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DRRM": {
    icao: "DRRM",
    iata: "MFQ",
    name: "Maradi Airport",
    city: "Maradi",
    country: "NE",
    continent: "AF",
    lat: 13.5025,
    lon: 7.1268,
    elevation: 1240,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DRRN": {
    icao: "DRRN",
    iata: "NIM",
    name: "Diori Hamani International Airport",
    city: "Niamey",
    country: "NE",
    continent: "AF",
    lat: 13.4815,
    lon: 2.1836,
    elevation: 732,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "DRRT": {
    icao: "DRRT",
    iata: "THZ",
    name: "Tahoua Airport",
    city: "Tahoua",
    country: "NE",
    continent: "AF",
    lat: 14.8757,
    lon: 5.2654,
    elevation: 1266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DRZA": {
    icao: "DRZA",
    iata: "AJY",
    name: "Mano Dayak International Airport",
    city: "Agadez",
    country: "NE",
    continent: "AF",
    lat: 16.966,
    lon: 8.0001,
    elevation: 1657,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DRZR": {
    icao: "DRZR",
    iata: "ZND",
    name: "Zinder Airport",
    city: "Zinder",
    country: "NE",
    continent: "AF",
    lat: 13.779,
    lon: 8.9838,
    elevation: 1516,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTKA": {
    icao: "DTKA",
    iata: "TBJ",
    name: "Tabarka-Aïn Draham International Airport",
    city: "Tabarka",
    country: "TN",
    continent: "AF",
    lat: 36.98,
    lon: 8.8769,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTMB": {
    icao: "DTMB",
    iata: "MIR",
    name: "Monastir Habib Bourguiba International Airport",
    city: "Monastir",
    country: "TN",
    continent: "AF",
    lat: 35.7581,
    lon: 10.7547,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTNH": {
    icao: "DTNH",
    iata: "NBE",
    name: "Enfidha - Hammamet International Airport",
    city: "Enfidha",
    country: "TN",
    continent: "AF",
    lat: 36.0758,
    lon: 10.4386,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTA": {
    icao: "DTTA",
    iata: "TUN",
    name: "Tunis Carthage International Airport",
    city: "Tunis",
    country: "TN",
    continent: "AF",
    lat: 36.851,
    lon: 10.2272,
    elevation: 22,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "DTTB": {
    icao: "DTTB",
    iata: "",
    name: "Bizerte Sidi Ahmed Air Base",
    city: "Borj Challouf",
    country: "TN",
    continent: "AF",
    lat: 37.2424,
    lon: 9.787,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTD": {
    icao: "DTTD",
    iata: "",
    name: "Remada Air Base",
    city: "Remada",
    country: "TN",
    continent: "AF",
    lat: 32.3062,
    lon: 10.3821,
    elevation: 1004,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTF": {
    icao: "DTTF",
    iata: "GAF",
    name: "Gafsa Ksar International Airport",
    city: "Gafsa",
    country: "TN",
    continent: "AF",
    lat: 34.422,
    lon: 8.8225,
    elevation: 1060,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTG": {
    icao: "DTTG",
    iata: "GAE",
    name: "Gabès Matmata International Airport",
    city: "Gabès",
    country: "TN",
    continent: "AF",
    lat: 33.7337,
    lon: 9.9194,
    elevation: 407,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTJ": {
    icao: "DTTJ",
    iata: "DJE",
    name: "Djerba Zarzis International Airport",
    city: "Mellita",
    country: "TN",
    continent: "AF",
    lat: 33.875,
    lon: 10.7755,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTR": {
    icao: "DTTR",
    iata: "EBM",
    name: "El Borma Airport",
    city: "El Borma",
    country: "TN",
    continent: "AF",
    lat: 31.7043,
    lon: 9.2546,
    elevation: 827,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTX": {
    icao: "DTTX",
    iata: "SFA",
    name: "Sfax Thyna International Airport",
    city: "Sfax",
    country: "TN",
    continent: "AF",
    lat: 34.718,
    lon: 10.691,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DTTZ": {
    icao: "DTTZ",
    iata: "TOE",
    name: "Tozeur Nefta International Airport",
    city: "Tozeur",
    country: "TN",
    continent: "AF",
    lat: 33.9397,
    lon: 8.1106,
    elevation: 287,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DXNG": {
    icao: "DXNG",
    iata: "LRL",
    name: "Niamtougou International Airport",
    city: "Niamtougou",
    country: "TG",
    continent: "AF",
    lat: 9.7673,
    lon: 1.0912,
    elevation: 1515,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "DXXX": {
    icao: "DXXX",
    iata: "LFW",
    name: "Lomé–Tokoin International Airport",
    city: "Lomé",
    country: "TG",
    continent: "AF",
    lat: 6.1656,
    lon: 1.2545,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBAW": {
    icao: "EBAW",
    iata: "ANR",
    name: "Antwerp International Airport (Deurne)",
    city: "Antwerp",
    country: "BE",
    continent: "EU",
    lat: 51.1907,
    lon: 4.4632,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBBE": {
    icao: "EBBE",
    iata: "",
    name: "Beauvechain Air Base",
    city: "Beauvechain",
    country: "BE",
    continent: "EU",
    lat: 50.7586,
    lon: 4.7683,
    elevation: 370,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBBL": {
    icao: "EBBL",
    iata: "",
    name: "Kleine Brogel Air Base",
    city: "Kleine Brogel",
    country: "BE",
    continent: "EU",
    lat: 51.1683,
    lon: 5.47,
    elevation: 200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBBR": {
    icao: "EBBR",
    iata: "BRU",
    name: "Brussels Airport",
    city: "Zaventem",
    country: "BE",
    continent: "EU",
    lat: 50.9014,
    lon: 4.4844,
    elevation: 175,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EBCI": {
    icao: "EBCI",
    iata: "CRL",
    name: "Brussels South Charleroi Airport",
    city: "Charleroi",
    country: "BE",
    continent: "EU",
    lat: 50.461,
    lon: 4.4572,
    elevation: 614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBCV": {
    icao: "EBCV",
    iata: "",
    name: "Chièvres Air Base",
    city: "Chièvres",
    country: "BE",
    continent: "EU",
    lat: 50.5758,
    lon: 3.831,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBFN": {
    icao: "EBFN",
    iata: "",
    name: "Koksijde Air Base",
    city: "Koksijde",
    country: "BE",
    continent: "EU",
    lat: 51.0903,
    lon: 2.6528,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBFS": {
    icao: "EBFS",
    iata: "",
    name: "Florennes Air Base",
    city: "Florennes",
    country: "BE",
    continent: "EU",
    lat: 50.2433,
    lon: 4.6458,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBKT": {
    icao: "EBKT",
    iata: "KJK",
    name: "Flanders International Airport Kortrijk-Wevelgem",
    city: "Wevelgem",
    country: "BE",
    continent: "EU",
    lat: 50.8189,
    lon: 3.2096,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBLG": {
    icao: "EBLG",
    iata: "LGG",
    name: "Liège Airport",
    city: "Grâce-Hollogne",
    country: "BE",
    continent: "EU",
    lat: 50.6386,
    lon: 5.4439,
    elevation: 659,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EBOS": {
    icao: "EBOS",
    iata: "OST",
    name: "Oostende-Brugge International Airport",
    city: "Oostende",
    country: "BE",
    continent: "EU",
    lat: 51.1998,
    lon: 2.8747,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDAC": {
    icao: "EDAC",
    iata: "AOC",
    name: "Leipzig–Altenburg Airport",
    city: "Nobitz",
    country: "DE",
    continent: "EU",
    lat: 50.9819,
    lon: 12.5064,
    elevation: 640,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDAH": {
    icao: "EDAH",
    iata: "HDF",
    name: "Heringsdorf Airport",
    city: "Zirchow",
    country: "DE",
    continent: "EU",
    lat: 53.8787,
    lon: 14.1523,
    elevation: 94,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDBN": {
    icao: "EDBN",
    iata: "FNB",
    name: "Neubrandenburg Trollenhagen Airport",
    city: "Trollenhagen",
    country: "DE",
    continent: "EU",
    lat: 53.6022,
    lon: 13.306,
    elevation: 228,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDBR": {
    icao: "EDBR",
    iata: "",
    name: "Rothenburg/Görlitz Airfield",
    city: "Rothenburg/Oberlausitz",
    country: "DE",
    continent: "EU",
    lat: 51.3633,
    lon: 14.95,
    elevation: 515,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDDB": {
    icao: "EDDB",
    iata: "BER",
    name: "Berlin Brandenburg Airport",
    city: "Berlin",
    country: "DE",
    continent: "EU",
    lat: 52.3622,
    lon: 13.5007,
    elevation: 157,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDC": {
    icao: "EDDC",
    iata: "DRS",
    name: "Dresden Airport",
    city: "Dresden",
    country: "DE",
    continent: "EU",
    lat: 51.1341,
    lon: 13.7678,
    elevation: 755,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDDE": {
    icao: "EDDE",
    iata: "ERF",
    name: "Erfurt-Weimar Airport",
    city: "Erfurt",
    country: "DE",
    continent: "EU",
    lat: 50.9798,
    lon: 10.9581,
    elevation: 1036,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDDF": {
    icao: "EDDF",
    iata: "FRA",
    name: "Frankfurt Airport",
    city: "Frankfurt am Main",
    country: "DE",
    continent: "EU",
    lat: 50.0302,
    lon: 8.5611,
    elevation: 364,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "EDDG": {
    icao: "EDDG",
    iata: "FMO",
    name: "Münster Osnabrück Airport",
    city: "Greven",
    country: "DE",
    continent: "EU",
    lat: 52.1346,
    lon: 7.6848,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDDH": {
    icao: "EDDH",
    iata: "HAM",
    name: "Hamburg Helmut Schmidt Airport",
    city: "Hamburg",
    country: "DE",
    continent: "EU",
    lat: 53.6304,
    lon: 9.9882,
    elevation: 53,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDK": {
    icao: "EDDK",
    iata: "CGN",
    name: "Cologne Bonn Airport",
    city: "Köln (Cologne)",
    country: "DE",
    continent: "EU",
    lat: 50.8659,
    lon: 7.1427,
    elevation: 302,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDL": {
    icao: "EDDL",
    iata: "DUS",
    name: "Düsseldorf Airport",
    city: "Düsseldorf",
    country: "DE",
    continent: "EU",
    lat: 51.2895,
    lon: 6.7668,
    elevation: 147,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDM": {
    icao: "EDDM",
    iata: "MUC",
    name: "Munich Airport",
    city: "Munich",
    country: "DE",
    continent: "EU",
    lat: 48.3538,
    lon: 11.7861,
    elevation: 1487,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDN": {
    icao: "EDDN",
    iata: "NUE",
    name: "Nuremberg Airport",
    city: "Nuremberg",
    country: "DE",
    continent: "EU",
    lat: 49.4987,
    lon: 11.0781,
    elevation: 1046,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDP": {
    icao: "EDDP",
    iata: "LEJ",
    name: "Leipzig/Halle Airport",
    city: "Schkeuditz",
    country: "DE",
    continent: "EU",
    lat: 51.4207,
    lon: 12.2327,
    elevation: 465,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDR": {
    icao: "EDDR",
    iata: "SCN",
    name: "Saarbrücken Airport",
    city: "Saarbrücken",
    country: "DE",
    continent: "EU",
    lat: 49.2146,
    lon: 7.1095,
    elevation: 1058,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDDS": {
    icao: "EDDS",
    iata: "STR",
    name: "Stuttgart Airport",
    city: "Stuttgart",
    country: "DE",
    continent: "EU",
    lat: 48.6899,
    lon: 9.222,
    elevation: 1276,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDV": {
    icao: "EDDV",
    iata: "HAJ",
    name: "Hannover Airport",
    city: "Hannover",
    country: "DE",
    continent: "EU",
    lat: 52.4611,
    lon: 9.6851,
    elevation: 183,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EDDW": {
    icao: "EDDW",
    iata: "BRE",
    name: "Bremen Airport",
    city: "Bremen",
    country: "DE",
    continent: "EU",
    lat: 53.0468,
    lon: 8.7893,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDFE": {
    icao: "EDFE",
    iata: "",
    name: "Frankfurt-Egelsbach Airport",
    city: "Egelsbach",
    country: "DE",
    continent: "EU",
    lat: 49.96,
    lon: 8.643,
    elevation: 384,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDFH": {
    icao: "EDFH",
    iata: "HHN",
    name: "Frankfurt-Hahn Airport",
    city: "Frankfurt am Main (Lautzenhausen)",
    country: "DE",
    continent: "EU",
    lat: 49.9487,
    lon: 7.2639,
    elevation: 1649,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDFM": {
    icao: "EDFM",
    iata: "MHG",
    name: "Mannheim-City Airport",
    city: "Mannheim",
    country: "DE",
    continent: "EU",
    lat: 49.4731,
    lon: 8.5142,
    elevation: 308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDFZ": {
    icao: "EDFZ",
    iata: "",
    name: "Mainz-Finthen Airfield",
    city: "Mainz",
    country: "DE",
    continent: "EU",
    lat: 49.9675,
    lon: 8.1472,
    elevation: 760,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDGE": {
    icao: "EDGE",
    iata: "EIB",
    name: "Eisenach-Kindel Airport",
    city: "Hörselberg-Hainich",
    country: "DE",
    continent: "EU",
    lat: 50.9916,
    lon: 10.4797,
    elevation: 1112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDGS": {
    icao: "EDGS",
    iata: "SGE",
    name: "Siegerland Airport",
    city: "Burbach",
    country: "DE",
    continent: "EU",
    lat: 50.7077,
    lon: 8.083,
    elevation: 1966,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDHI": {
    icao: "EDHI",
    iata: "XFW",
    name: "Hamburg-Finkenwerder Airport",
    city: "Hamburg",
    country: "DE",
    continent: "EU",
    lat: 53.5353,
    lon: 9.8356,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDHK": {
    icao: "EDHK",
    iata: "KEL",
    name: "Kiel-Holtenau Airport",
    city: "Kiel",
    country: "DE",
    continent: "EU",
    lat: 54.3796,
    lon: 10.1453,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDHL": {
    icao: "EDHL",
    iata: "LBC",
    name: "Lübeck Blankensee Airport",
    city: "Lübeck",
    country: "DE",
    continent: "EU",
    lat: 53.8054,
    lon: 10.7192,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDJA": {
    icao: "EDJA",
    iata: "FMM",
    name: "Memmingen Allgau Airport",
    city: "Memmingen",
    country: "DE",
    continent: "EU",
    lat: 47.9888,
    lon: 10.2395,
    elevation: 2077,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDLN": {
    icao: "EDLN",
    iata: "MGL",
    name: "Mönchengladbach Airport",
    city: "Mönchengladbach",
    country: "DE",
    continent: "EU",
    lat: 51.2303,
    lon: 6.5044,
    elevation: 125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDLP": {
    icao: "EDLP",
    iata: "PAD",
    name: "Paderborn Lippstadt Airport",
    city: "Büren",
    country: "DE",
    continent: "EU",
    lat: 51.6141,
    lon: 8.6163,
    elevation: 699,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDLV": {
    icao: "EDLV",
    iata: "NRN",
    name: "Weeze Airport",
    city: "Weeze",
    country: "DE",
    continent: "EU",
    lat: 51.6024,
    lon: 6.1422,
    elevation: 106,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDLW": {
    icao: "EDLW",
    iata: "DTM",
    name: "Dortmund Airport",
    city: "Dortmund",
    country: "DE",
    continent: "EU",
    lat: 51.5183,
    lon: 7.6122,
    elevation: 425,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDMA": {
    icao: "EDMA",
    iata: "AGB",
    name: "Augsburg Airport",
    city: "Augsburg",
    country: "DE",
    continent: "EU",
    lat: 48.4253,
    lon: 10.9317,
    elevation: 1516,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDMO": {
    icao: "EDMO",
    iata: "OBF",
    name: "Oberpfaffenhofen Airport",
    city: "Weßling",
    country: "DE",
    continent: "EU",
    lat: 48.0814,
    lon: 11.2831,
    elevation: 1947,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDNY": {
    icao: "EDNY",
    iata: "FDH",
    name: "Friedrichshafen Airport",
    city: "Friedrichshafen",
    country: "DE",
    continent: "EU",
    lat: 47.6713,
    lon: 9.5115,
    elevation: 1367,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDQA": {
    icao: "EDQA",
    iata: "",
    name: "Bamberg-Breitenau Airfield",
    city: "Bamberg",
    country: "DE",
    continent: "EU",
    lat: 49.9204,
    lon: 10.9142,
    elevation: 811,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDQD": {
    icao: "EDQD",
    iata: "BYU",
    name: "Bayreuth Airport",
    city: "Bindlach",
    country: "DE",
    continent: "EU",
    lat: 49.985,
    lon: 11.64,
    elevation: 1601,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDQM": {
    icao: "EDQM",
    iata: "HOQ",
    name: "Hof-Plauen Airport",
    city: "Hof",
    country: "DE",
    continent: "EU",
    lat: 50.2885,
    lon: 11.8529,
    elevation: 1959,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDSB": {
    icao: "EDSB",
    iata: "FKB",
    name: "Karlsruhe Baden-Baden Airport",
    city: "Rheinmünster",
    country: "DE",
    continent: "EU",
    lat: 48.7794,
    lon: 8.0805,
    elevation: 408,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDTD": {
    icao: "EDTD",
    iata: "",
    name: "Donaueschingen-Villingen Airfield",
    city: "Donaueschingen",
    country: "DE",
    continent: "EU",
    lat: 47.9733,
    lon: 8.5222,
    elevation: 2231,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDTL": {
    icao: "EDTL",
    iata: "LHA",
    name: "Lahr Airport",
    city: "Lahr/Schwarzwald",
    country: "DE",
    continent: "EU",
    lat: 48.3693,
    lon: 7.8277,
    elevation: 511,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDTM": {
    icao: "EDTM",
    iata: "",
    name: "Mengen-Hohentengen Airfield",
    city: "Mengen",
    country: "DE",
    continent: "EU",
    lat: 48.0539,
    lon: 9.3728,
    elevation: 1818,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDTY": {
    icao: "EDTY",
    iata: "",
    name: "Adolf Würth Airport",
    city: "Schwäbisch Hall",
    country: "DE",
    continent: "EU",
    lat: 49.1183,
    lon: 9.7839,
    elevation: 1299,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDUZ": {
    icao: "EDUZ",
    iata: "",
    name: "Zerbst Airfield",
    city: "Straguth",
    country: "DE",
    continent: "EU",
    lat: 52.0008,
    lon: 12.1486,
    elevation: 289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDVE": {
    icao: "EDVE",
    iata: "BWE",
    name: "Braunschweig-Wolfsburg Airport",
    city: "Braunschweig",
    country: "DE",
    continent: "EU",
    lat: 52.3192,
    lon: 10.5561,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDVK": {
    icao: "EDVK",
    iata: "KSF",
    name: "Kassel Airport",
    city: "Calden",
    country: "DE",
    continent: "EU",
    lat: 51.4207,
    lon: 9.3922,
    elevation: 820,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EDXW": {
    icao: "EDXW",
    iata: "GWT",
    name: "Westerland Sylt Airport",
    city: "Sylt",
    country: "DE",
    continent: "EU",
    lat: 54.9132,
    lon: 8.3405,
    elevation: 51,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EEEI": {
    icao: "EEEI",
    iata: "",
    name: "Ämari Air Base",
    city: "Keila",
    country: "EE",
    continent: "EU",
    lat: 59.2596,
    lon: 24.2048,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EEKA": {
    icao: "EEKA",
    iata: "KDL",
    name: "Kärdla Airport",
    city: "Kärdla",
    country: "EE",
    continent: "EU",
    lat: 58.9908,
    lon: 22.8307,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EEKE": {
    icao: "EEKE",
    iata: "URE",
    name: "Kuressaare Airport",
    city: "Kuressaare",
    country: "EE",
    continent: "EU",
    lat: 58.2299,
    lon: 22.5095,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EEPU": {
    icao: "EEPU",
    iata: "EPU",
    name: "Pärnu Airport",
    city: "Pärnu",
    country: "EE",
    continent: "EU",
    lat: 58.419,
    lon: 24.4728,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EETN": {
    icao: "EETN",
    iata: "TLL",
    name: "Lennart Meri Tallinn Airport",
    city: "Tallinn",
    country: "EE",
    continent: "EU",
    lat: 59.4132,
    lon: 24.8326,
    elevation: 131,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EETU": {
    icao: "EETU",
    iata: "TAY",
    name: "Tartu Airport",
    city: "Reola",
    country: "EE",
    continent: "EU",
    lat: 58.3074,
    lon: 26.6865,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFET": {
    icao: "EFET",
    iata: "ENF",
    name: "Enontekio Airport",
    city: "Enontekio",
    country: "FI",
    continent: "EU",
    lat: 68.3626,
    lon: 23.4243,
    elevation: 1005,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFHA": {
    icao: "EFHA",
    iata: "KEV",
    name: "Halli Airport",
    city: "Jämsä",
    country: "FI",
    continent: "EU",
    lat: 61.856,
    lon: 24.7867,
    elevation: 479,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFHK": {
    icao: "EFHK",
    iata: "HEL",
    name: "Helsinki Vantaa Airport",
    city: "Helsinki (Vantaa)",
    country: "FI",
    continent: "EU",
    lat: 60.3184,
    lon: 24.9633,
    elevation: 179,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EFIT": {
    icao: "EFIT",
    iata: "KTQ",
    name: "Kitee Airport",
    city: "Kitee",
    country: "FI",
    continent: "EU",
    lat: 62.1661,
    lon: 30.0736,
    elevation: 364,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFIV": {
    icao: "EFIV",
    iata: "IVL",
    name: "Ivalo Airport",
    city: "Ivalo",
    country: "FI",
    continent: "EU",
    lat: 68.6073,
    lon: 27.4053,
    elevation: 481,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFJO": {
    icao: "EFJO",
    iata: "JOE",
    name: "Joensuu Airport",
    city: "Joensuu",
    country: "FI",
    continent: "EU",
    lat: 62.6588,
    lon: 29.6194,
    elevation: 398,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFJY": {
    icao: "EFJY",
    iata: "JYV",
    name: "Jyväskylä Airport",
    city: "Jyväskylän Maalaiskunta",
    country: "FI",
    continent: "EU",
    lat: 62.3995,
    lon: 25.6783,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKA": {
    icao: "EFKA",
    iata: "KAU",
    name: "Kauhava Airfield",
    city: "Kauhava",
    country: "FI",
    continent: "EU",
    lat: 63.1271,
    lon: 23.0514,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKE": {
    icao: "EFKE",
    iata: "KEM",
    name: "Kemi-Tornio Airport",
    city: "Kemi / Tornio",
    country: "FI",
    continent: "EU",
    lat: 65.7787,
    lon: 24.5821,
    elevation: 61,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKI": {
    icao: "EFKI",
    iata: "KAJ",
    name: "Kajaani Airport",
    city: "Kajaani",
    country: "FI",
    continent: "EU",
    lat: 64.2855,
    lon: 27.6924,
    elevation: 483,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKJ": {
    icao: "EFKJ",
    iata: "KHJ",
    name: "Kauhajoki Airfield",
    city: "Kauhajoki",
    country: "FI",
    continent: "EU",
    lat: 62.4632,
    lon: 22.3908,
    elevation: 407,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKK": {
    icao: "EFKK",
    iata: "KOK",
    name: "Kokkola-Pietarsaari Airport",
    city: "Kokkola / Kruunupyy",
    country: "FI",
    continent: "EU",
    lat: 63.7212,
    lon: 23.1431,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKS": {
    icao: "EFKS",
    iata: "KAO",
    name: "Kuusamo Airport",
    city: "Kuusamo",
    country: "FI",
    continent: "EU",
    lat: 65.9876,
    lon: 29.2394,
    elevation: 866,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKT": {
    icao: "EFKT",
    iata: "KTT",
    name: "Kittilä Airport",
    city: "Kittilä",
    country: "FI",
    continent: "EU",
    lat: 67.701,
    lon: 24.8468,
    elevation: 644,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFKU": {
    icao: "EFKU",
    iata: "KUO",
    name: "Kuopio Airport",
    city: "Kuopio / Siilinjärvi",
    country: "FI",
    continent: "EU",
    lat: 63.0071,
    lon: 27.7978,
    elevation: 323,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFLP": {
    icao: "EFLP",
    iata: "LPP",
    name: "Lappeenranta Airport",
    city: "Lappeenranta",
    country: "FI",
    continent: "EU",
    lat: 61.0446,
    lon: 28.1447,
    elevation: 349,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFMA": {
    icao: "EFMA",
    iata: "MHQ",
    name: "Mariehamn Airport",
    city: "Mariehamn",
    country: "FI",
    continent: "EU",
    lat: 60.1222,
    lon: 19.8982,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFMI": {
    icao: "EFMI",
    iata: "MIK",
    name: "Mikkeli Airport",
    city: "Mikkeli",
    country: "FI",
    continent: "EU",
    lat: 61.6866,
    lon: 27.2018,
    elevation: 329,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFOU": {
    icao: "EFOU",
    iata: "OUL",
    name: "Oulu Airport",
    city: "Oulu / Oulunsalo",
    country: "FI",
    continent: "EU",
    lat: 64.9301,
    lon: 25.3546,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFPO": {
    icao: "EFPO",
    iata: "POR",
    name: "Pori Airport",
    city: "Pori",
    country: "FI",
    continent: "EU",
    lat: 61.4617,
    lon: 21.8,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFPR": {
    icao: "EFPR",
    iata: "",
    name: "Helsinki East-Redstone Aerodrome",
    city: "Helsinki (Pyhtää)",
    country: "FI",
    continent: "EU",
    lat: 60.4792,
    lon: 26.5939,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFRO": {
    icao: "EFRO",
    iata: "RVN",
    name: "Rovaniemi Airport",
    city: "Rovaniemi",
    country: "FI",
    continent: "EU",
    lat: 66.5648,
    lon: 25.8304,
    elevation: 642,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFSA": {
    icao: "EFSA",
    iata: "SVL",
    name: "Savonlinna Airport",
    city: "Savonlinna",
    country: "FI",
    continent: "EU",
    lat: 61.9431,
    lon: 28.9451,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFSI": {
    icao: "EFSI",
    iata: "SJY",
    name: "Seinäjoki Airport",
    city: "Seinäjoki / Ilmajoki",
    country: "FI",
    continent: "EU",
    lat: 62.6921,
    lon: 22.8323,
    elevation: 302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFSO": {
    icao: "EFSO",
    iata: "SOT",
    name: "Sodankyla Airport",
    city: "Sodankyla",
    country: "FI",
    continent: "EU",
    lat: 67.395,
    lon: 26.6191,
    elevation: 602,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFTP": {
    icao: "EFTP",
    iata: "TMP",
    name: "Tampere-Pirkkala Airport",
    city: "Tampere / Pirkkala",
    country: "FI",
    continent: "EU",
    lat: 61.4141,
    lon: 23.6044,
    elevation: 390,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFTU": {
    icao: "EFTU",
    iata: "TKU",
    name: "Turku Airport",
    city: "Turku",
    country: "FI",
    continent: "EU",
    lat: 60.5141,
    lon: 22.2628,
    elevation: 161,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFUT": {
    icao: "EFUT",
    iata: "UTI",
    name: "Utti Air Base",
    city: "Utti / Valkeala",
    country: "FI",
    continent: "EU",
    lat: 60.8964,
    lon: 26.9384,
    elevation: 339,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFVA": {
    icao: "EFVA",
    iata: "VAA",
    name: "Vaasa Airport",
    city: "Vaasa",
    country: "FI",
    continent: "EU",
    lat: 63.0507,
    lon: 21.7622,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFVR": {
    icao: "EFVR",
    iata: "VRK",
    name: "Varkaus Airport",
    city: "Varkaus / Joroinen",
    country: "FI",
    continent: "EU",
    lat: 62.1711,
    lon: 27.8686,
    elevation: 286,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EFYL": {
    icao: "EFYL",
    iata: "YLI",
    name: "Ylivieska Airfield",
    city: "Ylivieska",
    country: "FI",
    continent: "EU",
    lat: 64.0547,
    lon: 24.7253,
    elevation: 252,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGAA": {
    icao: "EGAA",
    iata: "BFS",
    name: "Belfast International Airport",
    city: "Belfast",
    country: "GB",
    continent: "EU",
    lat: 54.6575,
    lon: -6.2158,
    elevation: 268,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGAB": {
    icao: "EGAB",
    iata: "ENK",
    name: "Enniskillen/St Angelo Airport",
    city: "Enniskillen, Fermanagh and Omagh",
    country: "GB",
    continent: "EU",
    lat: 54.3983,
    lon: -7.6512,
    elevation: 155,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGAC": {
    icao: "EGAC",
    iata: "BHD",
    name: "George Best Belfast City Airport",
    city: "Belfast",
    country: "GB",
    continent: "EU",
    lat: 54.6181,
    lon: -5.8725,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGAE": {
    icao: "EGAE",
    iata: "LDY",
    name: "City of Derry Airport",
    city: "Derry",
    country: "GB",
    continent: "EU",
    lat: 55.0428,
    lon: -7.1611,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGBB": {
    icao: "EGBB",
    iata: "BHX",
    name: "Birmingham Airport",
    city: "Birmingham, West Midlands",
    country: "GB",
    continent: "EU",
    lat: 52.4539,
    lon: -1.748,
    elevation: 327,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGBE": {
    icao: "EGBE",
    iata: "CVT",
    name: "Coventry Airport",
    city: "Coventry, West Midlands",
    country: "GB",
    continent: "EU",
    lat: 52.3697,
    lon: -1.4797,
    elevation: 267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGBJ": {
    icao: "EGBJ",
    iata: "GLO",
    name: "Gloucestershire Airport",
    city: "Staverton",
    country: "GB",
    continent: "EU",
    lat: 51.8942,
    lon: -2.1672,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGCC": {
    icao: "EGCC",
    iata: "MAN",
    name: "Manchester Airport",
    city: "Manchester, Greater Manchester",
    country: "GB",
    continent: "EU",
    lat: 53.3494,
    lon: -2.2795,
    elevation: 257,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGDC": {
    icao: "EGDC",
    iata: "",
    name: "Royal Marines Base Chivenor",
    city: "Chivenor",
    country: "GB",
    continent: "EU",
    lat: 51.0872,
    lon: -4.1503,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGDM": {
    icao: "EGDM",
    iata: "",
    name: "MoD Boscombe Down",
    city: "Salisbury, Wiltshire",
    country: "GB",
    continent: "EU",
    lat: 51.1522,
    lon: -1.7474,
    elevation: 407,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGDR": {
    icao: "EGDR",
    iata: "",
    name: "RNAS Culdrose",
    city: "Helston",
    country: "GB",
    continent: "EU",
    lat: 50.0861,
    lon: -5.2557,
    elevation: 267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGDX": {
    icao: "EGDX",
    iata: "",
    name: "MOD St Athan",
    city: "St Athan, Vale of Glamorgan",
    country: "GB",
    continent: "EU",
    lat: 51.4052,
    lon: -3.4333,
    elevation: 163,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGDY": {
    icao: "EGDY",
    iata: "YEO",
    name: "RNAS Yeovilton",
    city: "Yeovil, Somerset",
    country: "GB",
    continent: "EU",
    lat: 51.0094,
    lon: -2.6388,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGEC": {
    icao: "EGEC",
    iata: "CAL",
    name: "Campbeltown Airport",
    city: "Campbeltown",
    country: "GB",
    continent: "EU",
    lat: 55.4372,
    lon: -5.6864,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGED": {
    icao: "EGED",
    iata: "EOI",
    name: "Eday Airport",
    city: "Eday",
    country: "GB",
    continent: "EU",
    lat: 59.1906,
    lon: -2.7722,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGFE": {
    icao: "EGFE",
    iata: "HAW",
    name: "Haverfordwest Airport",
    city: "Haverfordwest",
    country: "GB",
    continent: "EU",
    lat: 51.8331,
    lon: -4.9611,
    elevation: 159,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGFF": {
    icao: "EGFF",
    iata: "CWL",
    name: "Cardiff International Airport",
    city: "Cardiff",
    country: "GB",
    continent: "EU",
    lat: 51.3967,
    lon: -3.3433,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGFH": {
    icao: "EGFH",
    iata: "SWS",
    name: "Swansea Airport",
    city: "Swansea",
    country: "GB",
    continent: "EU",
    lat: 51.6014,
    lon: -4.071,
    elevation: 299,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGGD": {
    icao: "EGGD",
    iata: "BRS",
    name: "Bristol Airport",
    city: "Bristol",
    country: "GB",
    continent: "EU",
    lat: 51.3827,
    lon: -2.7191,
    elevation: 622,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGGP": {
    icao: "EGGP",
    iata: "LPL",
    name: "Liverpool John Lennon Airport",
    city: "Liverpool",
    country: "GB",
    continent: "EU",
    lat: 53.3336,
    lon: -2.8497,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGGW": {
    icao: "EGGW",
    iata: "LTN",
    name: "London Luton Airport",
    city: "Luton, Bedfordshire",
    country: "GB",
    continent: "EU",
    lat: 51.8747,
    lon: -0.3683,
    elevation: 526,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGHH": {
    icao: "EGHH",
    iata: "BOH",
    name: "Bournemouth Airport",
    city: "Bournemouth",
    country: "GB",
    continent: "EU",
    lat: 50.7805,
    lon: -1.8396,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGHI": {
    icao: "EGHI",
    iata: "SOU",
    name: "Southampton Airport",
    city: "Southampton",
    country: "GB",
    continent: "EU",
    lat: 50.9503,
    lon: -1.3568,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGHL": {
    icao: "EGHL",
    iata: "",
    name: "Lasham Airfield",
    city: "Alton, Hampshire",
    country: "GB",
    continent: "EU",
    lat: 51.1874,
    lon: -1.0317,
    elevation: 618,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGHQ": {
    icao: "EGHQ",
    iata: "NQY",
    name: "Cornwall Airport Newquay",
    city: "Newquay",
    country: "GB",
    continent: "EU",
    lat: 50.4406,
    lon: -4.9954,
    elevation: 390,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGJA": {
    icao: "EGJA",
    iata: "ACI",
    name: "Alderney Airport",
    city: "Saint Anne",
    country: "GG",
    continent: "EU",
    lat: 49.7061,
    lon: -2.2147,
    elevation: 290,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGJB": {
    icao: "EGJB",
    iata: "GCI",
    name: "Guernsey Airport",
    city: "Saint Peter Port",
    country: "GG",
    continent: "EU",
    lat: 49.435,
    lon: -2.602,
    elevation: 336,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGJJ": {
    icao: "EGJJ",
    iata: "JER",
    name: "Jersey Airport",
    city: "St. Peter",
    country: "JE",
    continent: "EU",
    lat: 49.2079,
    lon: -2.1955,
    elevation: 277,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGKA": {
    icao: "EGKA",
    iata: "ESH",
    name: "Brighton City Airport",
    city: "Brighton, East Sussex",
    country: "GB",
    continent: "EU",
    lat: 50.8356,
    lon: -0.2972,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGKB": {
    icao: "EGKB",
    iata: "BQH",
    name: "London Biggin Hill Airport",
    city: "London",
    country: "GB",
    continent: "EU",
    lat: 51.3308,
    lon: 0.0325,
    elevation: 598,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGKK": {
    icao: "EGKK",
    iata: "LGW",
    name: "London Gatwick Airport",
    city: "London",
    country: "GB",
    continent: "EU",
    lat: 51.1488,
    lon: -0.1921,
    elevation: 202,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGLC": {
    icao: "EGLC",
    iata: "LCY",
    name: "London City Airport",
    city: "London",
    country: "GB",
    continent: "EU",
    lat: 51.5053,
    lon: 0.0553,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGLF": {
    icao: "EGLF",
    iata: "FAB",
    name: "Farnborough Airport",
    city: "Farnborough, Hampshire",
    country: "GB",
    continent: "EU",
    lat: 51.2758,
    lon: -0.7763,
    elevation: 238,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGLK": {
    icao: "EGLK",
    iata: "BBS",
    name: "Blackbushe Airport",
    city: "Camberley, Surrey",
    country: "GB",
    continent: "EU",
    lat: 51.3239,
    lon: -0.8475,
    elevation: 325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGLL": {
    icao: "EGLL",
    iata: "LHR",
    name: "London Heathrow Airport",
    city: "London",
    country: "GB",
    continent: "EU",
    lat: 51.4706,
    lon: -0.4619,
    elevation: 83,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "EGMC": {
    icao: "EGMC",
    iata: "SEN",
    name: "London Southend Airport",
    city: "Southend-on-Sea, Essex",
    country: "GB",
    continent: "EU",
    lat: 51.5706,
    lon: 0.6936,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGMD": {
    icao: "EGMD",
    iata: "LYX",
    name: "Lydd London Ashford Airport",
    city: "Romney Marsh, Kent",
    country: "GB",
    continent: "EU",
    lat: 50.9562,
    lon: 0.9391,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNC": {
    icao: "EGNC",
    iata: "CAX",
    name: "Carlisle Lake District Airport",
    city: "Carlisle, Cumbria",
    country: "GB",
    continent: "EU",
    lat: 54.9375,
    lon: -2.8092,
    elevation: 190,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNH": {
    icao: "EGNH",
    iata: "BLK",
    name: "Blackpool Airport",
    city: "Blackpool",
    country: "GB",
    continent: "EU",
    lat: 53.7717,
    lon: -3.0286,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNJ": {
    icao: "EGNJ",
    iata: "HUY",
    name: "Humberside Airport",
    city: "Grimsby, Lincolnshire",
    country: "GB",
    continent: "EU",
    lat: 53.5762,
    lon: -0.3495,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNL": {
    icao: "EGNL",
    iata: "BWF",
    name: "Barrow Walney Island Airport",
    city: "Barrow-in-Furness",
    country: "GB",
    continent: "EU",
    lat: 54.1286,
    lon: -3.2675,
    elevation: 173,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNM": {
    icao: "EGNM",
    iata: "LBA",
    name: "Leeds Bradford Airport",
    city: "Leeds, West Yorkshire",
    country: "GB",
    continent: "EU",
    lat: 53.8659,
    lon: -1.6606,
    elevation: 681,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNO": {
    icao: "EGNO",
    iata: "WRT",
    name: "Warton Aerodrome",
    city: "Warton",
    country: "GB",
    continent: "EU",
    lat: 53.7451,
    lon: -2.8831,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNR": {
    icao: "EGNR",
    iata: "CEG",
    name: "Hawarden Airport",
    city: "Broughton",
    country: "GB",
    continent: "EU",
    lat: 53.1781,
    lon: -2.9778,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNS": {
    icao: "EGNS",
    iata: "IOM",
    name: "Isle of Man Airport",
    city: "Castletown",
    country: "IM",
    continent: "EU",
    lat: 54.0833,
    lon: -4.6239,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNT": {
    icao: "EGNT",
    iata: "NCL",
    name: "Newcastle International Airport",
    city: "Newcastle upon Tyne, Tyne and Wear",
    country: "GB",
    continent: "EU",
    lat: 55.038,
    lon: -1.6896,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNV": {
    icao: "EGNV",
    iata: "MME",
    name: "Teesside International Airport",
    city: "Darlington, Durham",
    country: "GB",
    continent: "EU",
    lat: 54.5092,
    lon: -1.4294,
    elevation: 120,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGNX": {
    icao: "EGNX",
    iata: "EMA",
    name: "East Midlands Airport",
    city: "Nottingham",
    country: "GB",
    continent: "EU",
    lat: 52.8311,
    lon: -1.3281,
    elevation: 306,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGOM": {
    icao: "EGOM",
    iata: "",
    name: "RAF Spadeadam",
    city: "Spadeadam",
    country: "GB",
    continent: "EU",
    lat: 55.05,
    lon: -2.55,
    elevation: 1066,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGOS": {
    icao: "EGOS",
    iata: "",
    name: "RAF Shawbury",
    city: "Shrewsbury, Shropshire",
    country: "GB",
    continent: "EU",
    lat: 52.7982,
    lon: -2.668,
    elevation: 249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGOV": {
    icao: "EGOV",
    iata: "VLY",
    name: "Anglesey Airport",
    city: "Angelsey",
    country: "GB",
    continent: "EU",
    lat: 53.2481,
    lon: -4.5353,
    elevation: 37,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPA": {
    icao: "EGPA",
    iata: "KOI",
    name: "Kirkwall Airport",
    city: "Orkney Islands",
    country: "GB",
    continent: "EU",
    lat: 58.9578,
    lon: -2.905,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPB": {
    icao: "EGPB",
    iata: "LSI",
    name: "Sumburgh Airport",
    city: "Lerwick, Shetland",
    country: "GB",
    continent: "EU",
    lat: 59.8789,
    lon: -1.2956,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPC": {
    icao: "EGPC",
    iata: "WIC",
    name: "Wick John O\'Groats Airport",
    city: "Wick",
    country: "GB",
    continent: "EU",
    lat: 58.4589,
    lon: -3.0931,
    elevation: 126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPD": {
    icao: "EGPD",
    iata: "ABZ",
    name: "Aberdeen International Airport",
    city: "Aberdeen",
    country: "GB",
    continent: "EU",
    lat: 57.2019,
    lon: -2.1978,
    elevation: 215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPE": {
    icao: "EGPE",
    iata: "INV",
    name: "Inverness Airport",
    city: "Inverness",
    country: "GB",
    continent: "EU",
    lat: 57.5425,
    lon: -4.0475,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPF": {
    icao: "EGPF",
    iata: "GLA",
    name: "Glasgow Airport",
    city: "Glasgow",
    country: "GB",
    continent: "EU",
    lat: 55.8719,
    lon: -4.4331,
    elevation: 26,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGPH": {
    icao: "EGPH",
    iata: "EDI",
    name: "Edinburgh Airport",
    city: "Edinburgh",
    country: "GB",
    continent: "EU",
    lat: 55.9501,
    lon: -3.3723,
    elevation: 135,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGPI": {
    icao: "EGPI",
    iata: "ILY",
    name: "Islay Airport",
    city: "Isle of Islay, Argyll and Bute",
    country: "GB",
    continent: "EU",
    lat: 55.6827,
    lon: -6.2575,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPK": {
    icao: "EGPK",
    iata: "PIK",
    name: "Glasgow Prestwick Airport",
    city: "Prestwick, South Ayrshire",
    country: "GB",
    continent: "EU",
    lat: 55.502,
    lon: -4.587,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPL": {
    icao: "EGPL",
    iata: "BEB",
    name: "Benbecula Airport",
    city: "Balivanich",
    country: "GB",
    continent: "EU",
    lat: 57.4811,
    lon: -7.3628,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPN": {
    icao: "EGPN",
    iata: "DND",
    name: "Dundee Airport",
    city: "Dundee",
    country: "GB",
    continent: "EU",
    lat: 56.4525,
    lon: -3.0258,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPO": {
    icao: "EGPO",
    iata: "SYY",
    name: "Stornoway Airport",
    city: "Stornoway, Western Isles",
    country: "GB",
    continent: "EU",
    lat: 58.2156,
    lon: -6.3311,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPR": {
    icao: "EGPR",
    iata: "BRR",
    name: "Barra Airport",
    city: "Eoligarry",
    country: "GB",
    continent: "EU",
    lat: 57.0228,
    lon: -7.4431,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGPU": {
    icao: "EGPU",
    iata: "TRE",
    name: "Tiree Airport",
    city: "Balemartine",
    country: "GB",
    continent: "EU",
    lat: 56.4992,
    lon: -6.8692,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGQL": {
    icao: "EGQL",
    iata: "ADX",
    name: "Leuchars Station Airfield",
    city: "Leuchars, Fife",
    country: "GB",
    continent: "EU",
    lat: 56.374,
    lon: -2.8689,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGQS": {
    icao: "EGQS",
    iata: "LMO",
    name: "RAF Lossiemouth",
    city: "Lossiemouth",
    country: "GB",
    continent: "EU",
    lat: 57.7052,
    lon: -3.3392,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGSC": {
    icao: "EGSC",
    iata: "CBG",
    name: "Cambridge City Airport",
    city: "Cambridge, Cambridgeshire",
    country: "GB",
    continent: "EU",
    lat: 52.205,
    lon: 0.175,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGSH": {
    icao: "EGSH",
    iata: "NWI",
    name: "Norwich Airport",
    city: "Norwich, Norfolk",
    country: "GB",
    continent: "EU",
    lat: 52.6758,
    lon: 1.2828,
    elevation: 117,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGSS": {
    icao: "EGSS",
    iata: "STN",
    name: "London Stansted Airport",
    city: "London",
    country: "GB",
    continent: "EU",
    lat: 51.885,
    lon: 0.235,
    elevation: 348,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EGTC": {
    icao: "EGTC",
    iata: "",
    name: "Cranfield Airport",
    city: "Bedford, Bedfordshire",
    country: "GB",
    continent: "EU",
    lat: 52.0722,
    lon: -0.6167,
    elevation: 360,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGTE": {
    icao: "EGTE",
    iata: "EXT",
    name: "Exeter International Airport",
    city: "Exeter, Devon",
    country: "GB",
    continent: "EU",
    lat: 50.7343,
    lon: -3.414,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGTK": {
    icao: "EGTK",
    iata: "OXF",
    name: "London Oxford Airport",
    city: "Kidlington, Oxfordshire",
    country: "GB",
    continent: "EU",
    lat: 51.8369,
    lon: -1.32,
    elevation: 270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGUB": {
    icao: "EGUB",
    iata: "BEX",
    name: "RAF Benson",
    city: "Wallingford, Oxfordshire",
    country: "GB",
    continent: "EU",
    lat: 51.6144,
    lon: -1.096,
    elevation: 226,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGUL": {
    icao: "EGUL",
    iata: "LKZ",
    name: "RAF Lakenheath",
    city: "Brandon, Suffolk",
    country: "GB",
    continent: "EU",
    lat: 52.4095,
    lon: 0.5612,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGUN": {
    icao: "EGUN",
    iata: "MHZ",
    name: "RAF Mildenhall",
    city: "Bury Saint Edmunds, Suffolk",
    country: "GB",
    continent: "EU",
    lat: 52.3619,
    lon: 0.4864,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGUW": {
    icao: "EGUW",
    iata: "",
    name: "Wattisham Airfield",
    city: "Ipswich, Suffolk",
    country: "GB",
    continent: "EU",
    lat: 52.1275,
    lon: 0.9562,
    elevation: 284,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGVA": {
    icao: "EGVA",
    iata: "FFD",
    name: "RAF Fairford",
    city: "Fairford, Gloucestershire",
    country: "GB",
    continent: "EU",
    lat: 51.6836,
    lon: -1.7892,
    elevation: 286,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGVN": {
    icao: "EGVN",
    iata: "BZZ",
    name: "RAF Brize Norton",
    city: "Carterton, Oxfordshire",
    country: "GB",
    continent: "EU",
    lat: 51.75,
    lon: -1.5836,
    elevation: 288,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGVO": {
    icao: "EGVO",
    iata: "ODH",
    name: "RAF Odiham",
    city: "Hook, Hampshire",
    country: "GB",
    continent: "EU",
    lat: 51.2341,
    lon: -0.9428,
    elevation: 405,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGWC": {
    icao: "EGWC",
    iata: "",
    name: "RAF Cosford",
    city: "Cosford",
    country: "GB",
    continent: "EU",
    lat: 52.64,
    lon: -2.3056,
    elevation: 272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGWU": {
    icao: "EGWU",
    iata: "NHT",
    name: "RAF Northolt",
    city: "London",
    country: "GB",
    continent: "EU",
    lat: 51.553,
    lon: -0.4182,
    elevation: 124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXC": {
    icao: "EGXC",
    iata: "QCY",
    name: "RAF Coningsby",
    city: "Lincoln, Lincolnshire",
    country: "GB",
    continent: "EU",
    lat: 53.093,
    lon: -0.166,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXE": {
    icao: "EGXE",
    iata: "",
    name: "RAF Leeming",
    city: "Northallerton, North Yorkshire",
    country: "GB",
    continent: "EU",
    lat: 54.2972,
    lon: -1.5389,
    elevation: 132,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXG": {
    icao: "EGXG",
    iata: "",
    name: "Leeds East Airport",
    city: "Tadcaster, North Yorkshire",
    country: "GB",
    continent: "EU",
    lat: 53.8347,
    lon: -1.1947,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXH": {
    icao: "EGXH",
    iata: "BEQ",
    name: "RAF Honington",
    city: "Bury Saint Edmunds, Suffolk",
    country: "GB",
    continent: "EU",
    lat: 52.3426,
    lon: 0.7729,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXT": {
    icao: "EGXT",
    iata: "",
    name: "RAF Wittering",
    city: "Peterborough, Cambridgeshire",
    country: "GB",
    continent: "EU",
    lat: 52.6126,
    lon: -0.4765,
    elevation: 273,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXW": {
    icao: "EGXW",
    iata: "WTN",
    name: "RAF Waddington",
    city: "Lincoln, Lincolnshire",
    country: "GB",
    continent: "EU",
    lat: 53.1662,
    lon: -0.5238,
    elevation: 231,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGXZ": {
    icao: "EGXZ",
    iata: "",
    name: "RAF Topcliffe",
    city: "Thirsk, North Yorkshire",
    country: "GB",
    continent: "EU",
    lat: 54.2041,
    lon: -1.3803,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGYD": {
    icao: "EGYD",
    iata: "",
    name: "RAF Cranwell",
    city: "Sleaford, Lincolnshire",
    country: "GB",
    continent: "EU",
    lat: 53.0303,
    lon: -0.4832,
    elevation: 218,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGYE": {
    icao: "EGYE",
    iata: "",
    name: "RAF Barkston Heath",
    city: "Grantham, Lincolnshire",
    country: "GB",
    continent: "EU",
    lat: 52.9606,
    lon: -0.5594,
    elevation: 367,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGYM": {
    icao: "EGYM",
    iata: "KNF",
    name: "RAF Marham",
    city: "King\'s Lynn, Norfolk",
    country: "GB",
    continent: "EU",
    lat: 52.6484,
    lon: 0.5507,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EGYP": {
    icao: "EGYP",
    iata: "MPN",
    name: "Mount Pleasant Airport",
    city: "Mount Pleasant",
    country: "FK",
    continent: "SA",
    lat: -51.8228,
    lon: -58.4472,
    elevation: 244,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHAM": {
    icao: "EHAM",
    iata: "AMS",
    name: "Amsterdam Airport Schiphol",
    city: "Amsterdam",
    country: "NL",
    continent: "EU",
    lat: 52.3086,
    lon: 4.7639,
    elevation: -11,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "EHBD": {
    icao: "EHBD",
    iata: "",
    name: "Kempen Airport Budel",
    city: "Weert",
    country: "NL",
    continent: "EU",
    lat: 51.2553,
    lon: 5.6014,
    elevation: 114,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHBK": {
    icao: "EHBK",
    iata: "MST",
    name: "Maastricht Aachen Airport",
    city: "Maastricht",
    country: "NL",
    continent: "EU",
    lat: 50.9117,
    lon: 5.7701,
    elevation: 375,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHDL": {
    icao: "EHDL",
    iata: "",
    name: "Deelen Air Base",
    city: "Arnhem",
    country: "NL",
    continent: "EU",
    lat: 52.0606,
    lon: 5.8731,
    elevation: 158,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHEH": {
    icao: "EHEH",
    iata: "EIN",
    name: "Eindhoven Airport",
    city: "Eindhoven",
    country: "NL",
    continent: "EU",
    lat: 51.4501,
    lon: 5.3745,
    elevation: 74,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EHGG": {
    icao: "EHGG",
    iata: "GRQ",
    name: "Groningen Airport Eelde",
    city: "Groningen",
    country: "NL",
    continent: "EU",
    lat: 53.1197,
    lon: 6.5794,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHGR": {
    icao: "EHGR",
    iata: "GLZ",
    name: "Gilze Rijen Air Base",
    city: "Rijen",
    country: "NL",
    continent: "EU",
    lat: 51.5674,
    lon: 4.9318,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHKD": {
    icao: "EHKD",
    iata: "DHR",
    name: "De Kooy Airfield / Den Helder Naval Air Station",
    city: "Den Helder",
    country: "NL",
    continent: "EU",
    lat: 52.9234,
    lon: 4.7806,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHLE": {
    icao: "EHLE",
    iata: "LEY",
    name: "Lelystad Airport",
    city: "Lelystad",
    country: "NL",
    continent: "EU",
    lat: 52.4532,
    lon: 5.5146,
    elevation: -13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHLW": {
    icao: "EHLW",
    iata: "LWR",
    name: "Leeuwarden Air Base",
    city: "Leeuwarden",
    country: "NL",
    continent: "EU",
    lat: 53.2286,
    lon: 5.7606,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHRD": {
    icao: "EHRD",
    iata: "RTM",
    name: "Rotterdam The Hague Airport",
    city: "Rotterdam",
    country: "NL",
    continent: "EU",
    lat: 51.9569,
    lon: 4.4372,
    elevation: -15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHTW": {
    icao: "EHTW",
    iata: "ENS",
    name: "Twente Airport",
    city: "Enschede",
    country: "NL",
    continent: "EU",
    lat: 52.2758,
    lon: 6.8892,
    elevation: 114,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHVK": {
    icao: "EHVK",
    iata: "UDE",
    name: "Volkel Air Base",
    city: "Uden",
    country: "NL",
    continent: "EU",
    lat: 51.6572,
    lon: 5.7078,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EHWO": {
    icao: "EHWO",
    iata: "WOE",
    name: "Woensdrecht Air Base",
    city: "Hoogerheide",
    country: "NL",
    continent: "EU",
    lat: 51.4491,
    lon: 4.342,
    elevation: 63,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EICK": {
    icao: "EICK",
    iata: "ORK",
    name: "Cork Airport",
    city: "Cork",
    country: "IE",
    continent: "EU",
    lat: 51.8413,
    lon: -8.4911,
    elevation: 502,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EICM": {
    icao: "EICM",
    iata: "",
    name: "Galway Airport",
    city: "Galway",
    country: "IE",
    continent: "EU",
    lat: 53.3002,
    lon: -8.9416,
    elevation: 81,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EIDL": {
    icao: "EIDL",
    iata: "CFN",
    name: "Donegal Airport",
    city: "Donegal",
    country: "IE",
    continent: "EU",
    lat: 55.0442,
    lon: -8.341,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EIDW": {
    icao: "EIDW",
    iata: "DUB",
    name: "Dublin Airport",
    city: "Dublin",
    country: "IE",
    continent: "EU",
    lat: 53.4287,
    lon: -6.2621,
    elevation: 242,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EIKN": {
    icao: "EIKN",
    iata: "NOC",
    name: "Ireland West Knock Airport",
    city: "Charlestown",
    country: "IE",
    continent: "EU",
    lat: 53.9103,
    lon: -8.8185,
    elevation: 665,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EIKY": {
    icao: "EIKY",
    iata: "KIR",
    name: "Kerry Airport",
    city: "Farranfore",
    country: "IE",
    continent: "EU",
    lat: 52.1809,
    lon: -9.5238,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EIME": {
    icao: "EIME",
    iata: "",
    name: "Casement Air Base",
    city: "Baldonnel",
    country: "IE",
    continent: "EU",
    lat: 53.3017,
    lon: -6.4513,
    elevation: 319,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EINN": {
    icao: "EINN",
    iata: "SNN",
    name: "Shannon Airport",
    city: "Shannon",
    country: "IE",
    continent: "EU",
    lat: 52.702,
    lon: -8.9248,
    elevation: 46,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EISG": {
    icao: "EISG",
    iata: "SXL",
    name: "Sligo Airport",
    city: "Sligo",
    country: "IE",
    continent: "EU",
    lat: 54.2802,
    lon: -8.5992,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EIWF": {
    icao: "EIWF",
    iata: "WAT",
    name: "Waterford Airport",
    city: "Waterford",
    country: "IE",
    continent: "EU",
    lat: 52.1872,
    lon: -7.087,
    elevation: 119,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EIWT": {
    icao: "EIWT",
    iata: "",
    name: "Weston Airport",
    city: "Leixlip",
    country: "IE",
    continent: "EU",
    lat: 53.3516,
    lon: -6.4904,
    elevation: 150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKAH": {
    icao: "EKAH",
    iata: "AAR",
    name: "Aarhus Airport",
    city: "Aarhus",
    country: "DK",
    continent: "EU",
    lat: 56.3033,
    lon: 10.6183,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKBI": {
    icao: "EKBI",
    iata: "BLL",
    name: "Billund Airport",
    city: "Billund",
    country: "DK",
    continent: "EU",
    lat: 55.7403,
    lon: 9.157,
    elevation: 247,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EKCH": {
    icao: "EKCH",
    iata: "CPH",
    name: "Copenhagen Kastrup Airport",
    city: "Copenhagen",
    country: "DK",
    continent: "EU",
    lat: 55.6179,
    lon: 12.656,
    elevation: 17,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EKEB": {
    icao: "EKEB",
    iata: "EBJ",
    name: "Esbjerg Airport",
    city: "Esbjerg",
    country: "DK",
    continent: "EU",
    lat: 55.5259,
    lon: 8.5534,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKKA": {
    icao: "EKKA",
    iata: "KRP",
    name: "Midtjyllands Airport / Air Base Karup",
    city: "Karup",
    country: "DK",
    continent: "EU",
    lat: 56.2971,
    lon: 9.1043,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKMB": {
    icao: "EKMB",
    iata: "MRW",
    name: "Lolland Falster Maribo Airport",
    city: "Rødby",
    country: "DK",
    continent: "EU",
    lat: 54.6994,
    lon: 11.4382,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKOD": {
    icao: "EKOD",
    iata: "ODE",
    name: "Odense Hans Christian Andersen Airport",
    city: "Odense",
    country: "DK",
    continent: "EU",
    lat: 55.4753,
    lon: 10.3272,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKRK": {
    icao: "EKRK",
    iata: "RKE",
    name: "Copenhagen Roskilde Airport",
    city: "Roskilde",
    country: "DK",
    continent: "EU",
    lat: 55.5856,
    lon: 12.1314,
    elevation: 146,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKRN": {
    icao: "EKRN",
    iata: "RNN",
    name: "Bornholm Airport",
    city: "Rønne",
    country: "DK",
    continent: "EU",
    lat: 55.0633,
    lon: 14.7596,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKSB": {
    icao: "EKSB",
    iata: "SGD",
    name: "Sønderborg Airport",
    city: "Sønderborg",
    country: "DK",
    continent: "EU",
    lat: 54.9644,
    lon: 9.7917,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKSN": {
    icao: "EKSN",
    iata: "CNL",
    name: "Sindal Airport",
    city: "Sindal",
    country: "DK",
    continent: "EU",
    lat: 57.5035,
    lon: 10.2294,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKSP": {
    icao: "EKSP",
    iata: "SKS",
    name: "Skrydstrup Air Base",
    city: "Vojens",
    country: "DK",
    continent: "EU",
    lat: 55.221,
    lon: 9.267,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKSV": {
    icao: "EKSV",
    iata: "SQW",
    name: "Skive Airport",
    city: "Skive",
    country: "DK",
    continent: "EU",
    lat: 56.5502,
    lon: 9.173,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKTS": {
    icao: "EKTS",
    iata: "TED",
    name: "Thisted Airport",
    city: "Thisted",
    country: "DK",
    continent: "EU",
    lat: 57.0688,
    lon: 8.7052,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKVD": {
    icao: "EKVD",
    iata: "",
    name: "Kolding Vamdrup Airfield",
    city: "Kolding / Vamdrup",
    country: "DK",
    continent: "EU",
    lat: 55.4363,
    lon: 9.3309,
    elevation: 143,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKVG": {
    icao: "EKVG",
    iata: "FAE",
    name: "Vágar Airport",
    city: "Vágar",
    country: "FO",
    continent: "EU",
    lat: 62.0633,
    lon: -7.2758,
    elevation: 280,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKVJ": {
    icao: "EKVJ",
    iata: "STA",
    name: "Stauning Vestjylland  Airport",
    city: "Skjern",
    country: "DK",
    continent: "EU",
    lat: 55.9901,
    lon: 8.3539,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EKYT": {
    icao: "EKYT",
    iata: "AAL",
    name: "Aalborg Airport",
    city: "Aalborg",
    country: "DK",
    continent: "EU",
    lat: 57.0948,
    lon: 9.8499,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ELLX": {
    icao: "ELLX",
    iata: "LUX",
    name: "Luxembourg-Findel International Airport",
    city: "Luxembourg",
    country: "LU",
    continent: "EU",
    lat: 49.6233,
    lon: 6.2044,
    elevation: 1234,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ENAL": {
    icao: "ENAL",
    iata: "AES",
    name: "Ålesund Airport, Vigra",
    city: "Ålesund",
    country: "NO",
    continent: "EU",
    lat: 62.5625,
    lon: 6.1197,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENAN": {
    icao: "ENAN",
    iata: "ANX",
    name: "Andøya Airport, Andenes",
    city: "Andenes",
    country: "NO",
    continent: "EU",
    lat: 69.2925,
    lon: 16.1442,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENAT": {
    icao: "ENAT",
    iata: "ALF",
    name: "Alta Airport",
    city: "Alta",
    country: "NO",
    continent: "EU",
    lat: 69.9761,
    lon: 23.3717,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENBN": {
    icao: "ENBN",
    iata: "BNN",
    name: "Brønnøysund Airport, Brønnøy",
    city: "Brønnøy",
    country: "NO",
    continent: "EU",
    lat: 65.4611,
    lon: 12.2175,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENBO": {
    icao: "ENBO",
    iata: "BOO",
    name: "Bodø Airport",
    city: "Bodø",
    country: "NO",
    continent: "EU",
    lat: 67.2692,
    lon: 14.3653,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENBR": {
    icao: "ENBR",
    iata: "BGO",
    name: "Bergen Airport, Flesland",
    city: "Bergen",
    country: "NO",
    continent: "EU",
    lat: 60.2934,
    lon: 5.2181,
    elevation: 170,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ENBS": {
    icao: "ENBS",
    iata: "BJF",
    name: "Båtsfjord Airport",
    city: "Båtsfjord",
    country: "NO",
    continent: "EU",
    lat: 70.6003,
    lon: 29.6926,
    elevation: 490,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENBV": {
    icao: "ENBV",
    iata: "BVG",
    name: "Berlevåg Airport",
    city: "Berlevåg",
    country: "NO",
    continent: "EU",
    lat: 70.8715,
    lon: 29.0341,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENCN": {
    icao: "ENCN",
    iata: "KRS",
    name: "Kristiansand Airport, Kjevik",
    city: "Kjevik",
    country: "NO",
    continent: "EU",
    lat: 58.2042,
    lon: 8.0854,
    elevation: 57,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENDU": {
    icao: "ENDU",
    iata: "BDU",
    name: "Bardufoss Airport",
    city: "Målselv",
    country: "NO",
    continent: "EU",
    lat: 69.0558,
    lon: 18.5404,
    elevation: 252,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENEV": {
    icao: "ENEV",
    iata: "EVE",
    name: "Harstad/Narvik Airport, Evenes",
    city: "Evenes",
    country: "NO",
    continent: "EU",
    lat: 68.4913,
    lon: 16.6781,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENFL": {
    icao: "ENFL",
    iata: "FRO",
    name: "Florø Airport",
    city: "Florø",
    country: "NO",
    continent: "EU",
    lat: 61.5836,
    lon: 5.0247,
    elevation: 37,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENGM": {
    icao: "ENGM",
    iata: "OSL",
    name: "Oslo Airport, Gardermoen",
    city: "Oslo (Gardermoen)",
    country: "NO",
    continent: "EU",
    lat: 60.1939,
    lon: 11.1004,
    elevation: 681,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ENHD": {
    icao: "ENHD",
    iata: "HAU",
    name: "Haugesund Airport, Karmøy",
    city: "Karmøy",
    country: "NO",
    continent: "EU",
    lat: 59.3453,
    lon: 5.2084,
    elevation: 86,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENHF": {
    icao: "ENHF",
    iata: "HFT",
    name: "Hammerfest Airport",
    city: "Hammerfest",
    country: "NO",
    continent: "EU",
    lat: 70.6797,
    lon: 23.6686,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENHV": {
    icao: "ENHV",
    iata: "HVG",
    name: "Honningsvåg Airport, Valan",
    city: "Honningsvåg",
    country: "NO",
    continent: "EU",
    lat: 71.0097,
    lon: 25.9836,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENKB": {
    icao: "ENKB",
    iata: "KSU",
    name: "Kristiansund Airport, Kvernberget",
    city: "Kvernberget",
    country: "NO",
    continent: "EU",
    lat: 63.1118,
    lon: 7.8245,
    elevation: 204,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENKR": {
    icao: "ENKR",
    iata: "KKN",
    name: "Kirkenes Airport, Høybuktmoen",
    city: "Kirkenes",
    country: "NO",
    continent: "EU",
    lat: 69.7258,
    lon: 29.8913,
    elevation: 283,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENLK": {
    icao: "ENLK",
    iata: "LKN",
    name: "Leknes Airport",
    city: "Leknes",
    country: "NO",
    continent: "EU",
    lat: 68.1525,
    lon: 13.6094,
    elevation: 78,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENMH": {
    icao: "ENMH",
    iata: "MEH",
    name: "Mehamn Airport",
    city: "Mehamn",
    country: "NO",
    continent: "EU",
    lat: 71.0297,
    lon: 27.8267,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENML": {
    icao: "ENML",
    iata: "MOL",
    name: "Molde Airport, Årø",
    city: "Årø",
    country: "NO",
    continent: "EU",
    lat: 62.7447,
    lon: 7.2625,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENMS": {
    icao: "ENMS",
    iata: "MJF",
    name: "Mosjøen Airport, Kjærstad",
    city: "Mosjøen",
    country: "NO",
    continent: "EU",
    lat: 65.784,
    lon: 13.2149,
    elevation: 237,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENNA": {
    icao: "ENNA",
    iata: "LKL",
    name: "Lakselv Airport, Banak",
    city: "Lakselv",
    country: "NO",
    continent: "EU",
    lat: 70.0688,
    lon: 24.9735,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENNO": {
    icao: "ENNO",
    iata: "NTB",
    name: "Notodden Airport",
    city: "Notodden",
    country: "NO",
    continent: "EU",
    lat: 59.5651,
    lon: 9.2132,
    elevation: 63,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENOL": {
    icao: "ENOL",
    iata: "OLA",
    name: "Ørland Airport",
    city: "Ørland",
    country: "NO",
    continent: "EU",
    lat: 63.6989,
    lon: 9.604,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENOV": {
    icao: "ENOV",
    iata: "HOV",
    name: "Ørsta-Volda Airport, Hovden",
    city: "Ørsta",
    country: "NO",
    continent: "EU",
    lat: 62.18,
    lon: 6.0741,
    elevation: 243,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENRA": {
    icao: "ENRA",
    iata: "MQN",
    name: "Mo i Rana Airport, Røssvoll",
    city: "Mo i Rana",
    country: "NO",
    continent: "EU",
    lat: 66.3639,
    lon: 14.3014,
    elevation: 229,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENRM": {
    icao: "ENRM",
    iata: "RVK",
    name: "Rørvik Airport, Ryum",
    city: "Rørvik",
    country: "NO",
    continent: "EU",
    lat: 64.8383,
    lon: 11.1461,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENRO": {
    icao: "ENRO",
    iata: "RRS",
    name: "Røros Airport",
    city: "Røros",
    country: "NO",
    continent: "EU",
    lat: 62.5784,
    lon: 11.3423,
    elevation: 2054,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENRY": {
    icao: "ENRY",
    iata: "",
    name: "Moss Airport, Rygge",
    city: "Oslo",
    country: "NO",
    continent: "EU",
    lat: 59.3788,
    lon: 10.7854,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSB": {
    icao: "ENSB",
    iata: "LYR",
    name: "Svalbard Airport, Longyear",
    city: "Longyearbyen",
    country: "NO",
    continent: "EU",
    lat: 78.2461,
    lon: 15.4656,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSH": {
    icao: "ENSH",
    iata: "SVJ",
    name: "Svolvær Airport, Helle",
    city: "Svolvær",
    country: "NO",
    continent: "EU",
    lat: 68.2433,
    lon: 14.6692,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSK": {
    icao: "ENSK",
    iata: "SKN",
    name: "Stokmarknes Airport, Skagen",
    city: "Hadsel",
    country: "NO",
    continent: "EU",
    lat: 68.5788,
    lon: 15.0334,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSN": {
    icao: "ENSN",
    iata: "",
    name: "Skien Airport",
    city: "Geiteryggen",
    country: "NO",
    continent: "EU",
    lat: 59.185,
    lon: 9.5669,
    elevation: 463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSO": {
    icao: "ENSO",
    iata: "SRP",
    name: "Stord Airport, Sørstokken",
    city: "Leirvik",
    country: "NO",
    continent: "EU",
    lat: 59.7919,
    lon: 5.3408,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSR": {
    icao: "ENSR",
    iata: "SOJ",
    name: "Sørkjosen Airport",
    city: "Sørkjosen",
    country: "NO",
    continent: "EU",
    lat: 69.7868,
    lon: 20.9594,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENSS": {
    icao: "ENSS",
    iata: "VAW",
    name: "Vardø Airport, Svartnes",
    city: "Vardø",
    country: "NO",
    continent: "EU",
    lat: 70.3554,
    lon: 31.0449,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENST": {
    icao: "ENST",
    iata: "SSJ",
    name: "Sandnessjøen Airport, Stokka",
    city: "Alstahaug",
    country: "NO",
    continent: "EU",
    lat: 65.9568,
    lon: 12.4689,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENTC": {
    icao: "ENTC",
    iata: "TOS",
    name: "Tromsø Airport, Langnes",
    city: "Tromsø",
    country: "NO",
    continent: "EU",
    lat: 69.6833,
    lon: 18.9189,
    elevation: 31,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ENTO": {
    icao: "ENTO",
    iata: "TRF",
    name: "Sandefjord Airport, Torp",
    city: "Torp",
    country: "NO",
    continent: "EU",
    lat: 59.1867,
    lon: 10.2586,
    elevation: 286,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENVA": {
    icao: "ENVA",
    iata: "TRD",
    name: "Trondheim Airport, Værnes",
    city: "Trondheim",
    country: "NO",
    continent: "EU",
    lat: 63.4578,
    lon: 10.924,
    elevation: 56,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ENVD": {
    icao: "ENVD",
    iata: "VDS",
    name: "Vadsø Airport",
    city: "Vadsø",
    country: "NO",
    continent: "EU",
    lat: 70.0653,
    lon: 29.8447,
    elevation: 127,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ENZV": {
    icao: "ENZV",
    iata: "SVG",
    name: "Stavanger Airport, Sola",
    city: "Stavanger",
    country: "NO",
    continent: "EU",
    lat: 58.8767,
    lon: 5.6378,
    elevation: 29,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EPBY": {
    icao: "EPBY",
    iata: "BZG",
    name: "Bydgoszcz Ignacy Jan Paderewski Airport",
    city: "Bydgoszcz",
    country: "PL",
    continent: "EU",
    lat: 53.0968,
    lon: 17.9777,
    elevation: 235,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPCE": {
    icao: "EPCE",
    iata: "",
    name: "Cewice Naval Air Base",
    city: "Siemirowice",
    country: "PL",
    continent: "EU",
    lat: 54.4165,
    lon: 17.7657,
    elevation: 495,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPDE": {
    icao: "EPDE",
    iata: "",
    name: "Deblin Military Air Base",
    city: "Dęblin",
    country: "PL",
    continent: "EU",
    lat: 51.551,
    lon: 21.8923,
    elevation: 392,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPGD": {
    icao: "EPGD",
    iata: "GDN",
    name: "Gdańsk Lech Wałęsa Airport",
    city: "Gdańsk",
    country: "PL",
    continent: "EU",
    lat: 54.3776,
    lon: 18.4662,
    elevation: 489,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EPIR": {
    icao: "EPIR",
    iata: "",
    name: "Inowroclaw Military Air Base",
    city: "",
    country: "PL",
    continent: "EU",
    lat: 52.8294,
    lon: 18.3306,
    elevation: 259,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPKK": {
    icao: "EPKK",
    iata: "KRK",
    name: "Kraków John Paul II International Airport",
    city: "Balice",
    country: "PL",
    continent: "EU",
    lat: 50.0777,
    lon: 19.7848,
    elevation: 791,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EPKS": {
    icao: "EPKS",
    iata: "",
    name: "Krzesiny Military Air Base",
    city: "Poznań",
    country: "PL",
    continent: "EU",
    lat: 52.3317,
    lon: 16.9664,
    elevation: 265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPKT": {
    icao: "EPKT",
    iata: "KTW",
    name: "Katowice Wojciech Korfanty International Airport",
    city: "Katowice",
    country: "PL",
    continent: "EU",
    lat: 50.476,
    lon: 19.0807,
    elevation: 995,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPLB": {
    icao: "EPLB",
    iata: "LUZ",
    name: "Lublin Airport",
    city: "Lublin",
    country: "PL",
    continent: "EU",
    lat: 51.2402,
    lon: 22.7135,
    elevation: 633,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPLK": {
    icao: "EPLK",
    iata: "",
    name: "Łask Air Base",
    city: "Łask",
    country: "PL",
    continent: "EU",
    lat: 51.5517,
    lon: 19.1791,
    elevation: 633,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPLL": {
    icao: "EPLL",
    iata: "LCJ",
    name: "Łódź Władysław Reymont Airport",
    city: "Łódź",
    country: "PL",
    continent: "EU",
    lat: 51.7219,
    lon: 19.3981,
    elevation: 604,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPLY": {
    icao: "EPLY",
    iata: "",
    name: "Leźnica Wielka Air Base",
    city: "Leźnica Wielka",
    country: "PL",
    continent: "EU",
    lat: 52.0049,
    lon: 19.1438,
    elevation: 404,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPMB": {
    icao: "EPMB",
    iata: "",
    name: "Malbork Królewo Air Base",
    city: "Królewo",
    country: "PL",
    continent: "EU",
    lat: 54.0266,
    lon: 19.1357,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPMI": {
    icao: "EPMI",
    iata: "",
    name: "Miroslawiec Military Air Base",
    city: "Mirosławiec",
    country: "PL",
    continent: "EU",
    lat: 53.3951,
    lon: 16.0828,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPMM": {
    icao: "EPMM",
    iata: "",
    name: "Minsk Mazowiecki Military Air Base",
    city: "",
    country: "PL",
    continent: "EU",
    lat: 52.1955,
    lon: 21.6559,
    elevation: 604,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPMO": {
    icao: "EPMO",
    iata: "WMI",
    name: "Modlin Airport",
    city: "Nowy Dwór Mazowiecki",
    country: "PL",
    continent: "EU",
    lat: 52.4511,
    lon: 20.6518,
    elevation: 341,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPPO": {
    icao: "EPPO",
    iata: "POZ",
    name: "Poznań-Ławica Airport",
    city: "Poznań",
    country: "PL",
    continent: "EU",
    lat: 52.4216,
    lon: 16.8234,
    elevation: 308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPPW": {
    icao: "EPPW",
    iata: "",
    name: "Powidz Military Air Base",
    city: "Powidz",
    country: "PL",
    continent: "EU",
    lat: 52.3801,
    lon: 17.8532,
    elevation: 371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPRA": {
    icao: "EPRA",
    iata: "RDO",
    name: "Warsaw Radom Airport",
    city: "Radom",
    country: "PL",
    continent: "EU",
    lat: 51.3894,
    lon: 21.2147,
    elevation: 610,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPRZ": {
    icao: "EPRZ",
    iata: "RZE",
    name: "Rzeszów-Jasionka Airport",
    city: "Jasionka",
    country: "PL",
    continent: "EU",
    lat: 50.1098,
    lon: 22.0242,
    elevation: 693,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPSC": {
    icao: "EPSC",
    iata: "SZZ",
    name: "Solidarity Szczecin–Goleniów Airport",
    city: "Glewice",
    country: "PL",
    continent: "EU",
    lat: 53.5847,
    lon: 14.9022,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPSN": {
    icao: "EPSN",
    iata: "",
    name: "Swidwin Military Air Base",
    city: "",
    country: "PL",
    continent: "EU",
    lat: 53.7906,
    lon: 15.8263,
    elevation: 394,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPSY": {
    icao: "EPSY",
    iata: "SZY",
    name: "Olsztyn-Mazury Airport",
    city: "Szymany",
    country: "PL",
    continent: "EU",
    lat: 53.4819,
    lon: 20.9377,
    elevation: 463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPTM": {
    icao: "EPTM",
    iata: "",
    name: "Tomaszów Mazowiecki Military Air Base",
    city: "Nowy Glinnik",
    country: "PL",
    continent: "EU",
    lat: 51.5844,
    lon: 20.0978,
    elevation: 571,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPWA": {
    icao: "EPWA",
    iata: "WAW",
    name: "Warsaw Chopin Airport",
    city: "Warsaw",
    country: "PL",
    continent: "EU",
    lat: 52.1657,
    lon: 20.9671,
    elevation: 362,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EPWR": {
    icao: "EPWR",
    iata: "WRO",
    name: "Copernicus Wrocław Airport",
    city: "Wrocław",
    country: "PL",
    continent: "EU",
    lat: 51.1037,
    lon: 16.8821,
    elevation: 404,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EPZG": {
    icao: "EPZG",
    iata: "IEG",
    name: "Zielona Góra-Babimost Airport",
    city: "Nowe Kramsko",
    country: "PL",
    continent: "EU",
    lat: 52.1385,
    lon: 15.7986,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESCF": {
    icao: "ESCF",
    iata: "",
    name: "Malmen Air Base",
    city: "Linköping",
    country: "SE",
    continent: "EU",
    lat: 58.3977,
    lon: 15.5224,
    elevation: 308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESDF": {
    icao: "ESDF",
    iata: "RNB",
    name: "Ronneby Airport",
    city: "Ronneby",
    country: "SE",
    continent: "EU",
    lat: 56.2667,
    lon: 15.265,
    elevation: 191,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESFR": {
    icao: "ESFR",
    iata: "",
    name: "Råda Air Base",
    city: "Råda",
    country: "SE",
    continent: "EU",
    lat: 58.4981,
    lon: 13.0532,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESGG": {
    icao: "ESGG",
    iata: "GOT",
    name: "Göteborg Landvetter Airport",
    city: "Göteborg",
    country: "SE",
    continent: "EU",
    lat: 57.6628,
    lon: 12.2798,
    elevation: 506,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ESGJ": {
    icao: "ESGJ",
    iata: "JKG",
    name: "Jönköping Airport",
    city: "Jönköping",
    country: "SE",
    continent: "EU",
    lat: 57.7576,
    lon: 14.0687,
    elevation: 741,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESGP": {
    icao: "ESGP",
    iata: "GSE",
    name: "Säve Airport",
    city: "Göteborg",
    country: "SE",
    continent: "EU",
    lat: 57.7747,
    lon: 11.8704,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESGR": {
    icao: "ESGR",
    iata: "KVB",
    name: "Skövde Airport",
    city: "Skövde",
    country: "SE",
    continent: "EU",
    lat: 58.4564,
    lon: 13.9727,
    elevation: 324,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESGT": {
    icao: "ESGT",
    iata: "THN",
    name: "Trollhättan-Vänersborg Airport",
    city: "Trollhättan",
    country: "SE",
    continent: "EU",
    lat: 58.3181,
    lon: 12.345,
    elevation: 137,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESIB": {
    icao: "ESIB",
    iata: "",
    name: "Såtenäs Air Base",
    city: "Såtenäs",
    country: "SE",
    continent: "EU",
    lat: 58.4264,
    lon: 12.7144,
    elevation: 181,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESKK": {
    icao: "ESKK",
    iata: "KSK",
    name: "Karlskoga Airport",
    city: "Karlskoga",
    country: "SE",
    continent: "EU",
    lat: 59.3459,
    lon: 14.4959,
    elevation: 407,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESKM": {
    icao: "ESKM",
    iata: "MXX",
    name: "Mora Airport",
    city: "Mora",
    country: "SE",
    continent: "EU",
    lat: 60.9579,
    lon: 14.5114,
    elevation: 634,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESKN": {
    icao: "ESKN",
    iata: "NYO",
    name: "Stockholm Skavsta Airport",
    city: "Nyköping",
    country: "SE",
    continent: "EU",
    lat: 58.7886,
    lon: 16.9122,
    elevation: 140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESKS": {
    icao: "ESKS",
    iata: "SCR",
    name: "Scandinavian Mountains Airport",
    city: "Malung-Sälen",
    country: "SE",
    continent: "EU",
    lat: 61.1584,
    lon: 12.8425,
    elevation: 1608,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESMK": {
    icao: "ESMK",
    iata: "KID",
    name: "Kristianstad Airport",
    city: "Kristianstad",
    country: "SE",
    continent: "EU",
    lat: 55.9217,
    lon: 14.0855,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESMQ": {
    icao: "ESMQ",
    iata: "KLR",
    name: "Kalmar Airport",
    city: "Kalmar",
    country: "SE",
    continent: "EU",
    lat: 56.6855,
    lon: 16.2876,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESMS": {
    icao: "ESMS",
    iata: "MMX",
    name: "Malmö Sturup Airport",
    city: "Malmö",
    country: "SE",
    continent: "EU",
    lat: 55.5356,
    lon: 13.3763,
    elevation: 236,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESMT": {
    icao: "ESMT",
    iata: "HAD",
    name: "Halmstad Airport",
    city: "Halmstad",
    country: "SE",
    continent: "EU",
    lat: 56.6911,
    lon: 12.8202,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESMX": {
    icao: "ESMX",
    iata: "VXO",
    name: "Växjö Kronoberg Airport",
    city: "Växjö",
    country: "SE",
    continent: "EU",
    lat: 56.9291,
    lon: 14.728,
    elevation: 610,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNG": {
    icao: "ESNG",
    iata: "GEV",
    name: "Gällivare Airport",
    city: "Gällivare",
    country: "SE",
    continent: "EU",
    lat: 67.1324,
    lon: 20.8146,
    elevation: 1027,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNK": {
    icao: "ESNK",
    iata: "KRF",
    name: "Kramfors-Sollefteå Höga Kusten Airport",
    city: "Nyland",
    country: "SE",
    continent: "EU",
    lat: 63.0486,
    lon: 17.7689,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNL": {
    icao: "ESNL",
    iata: "LYC",
    name: "Lycksele Airport",
    city: "Lycksele",
    country: "SE",
    continent: "EU",
    lat: 64.5483,
    lon: 18.7162,
    elevation: 705,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNN": {
    icao: "ESNN",
    iata: "SDL",
    name: "Sundsvall-Härnösand Airport",
    city: "Sundsvall/ Härnösand",
    country: "SE",
    continent: "EU",
    lat: 62.5281,
    lon: 17.4439,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNO": {
    icao: "ESNO",
    iata: "OER",
    name: "Örnsköldsvik Airport",
    city: "Örnsköldsvik",
    country: "SE",
    continent: "EU",
    lat: 63.4083,
    lon: 18.99,
    elevation: 354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNQ": {
    icao: "ESNQ",
    iata: "KRN",
    name: "Kiruna Airport",
    city: "Kiruna",
    country: "SE",
    continent: "EU",
    lat: 67.822,
    lon: 20.3368,
    elevation: 1508,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNS": {
    icao: "ESNS",
    iata: "SFT",
    name: "Skellefteå Airport",
    city: "Skellefteå",
    country: "SE",
    continent: "EU",
    lat: 64.6248,
    lon: 21.0769,
    elevation: 157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNU": {
    icao: "ESNU",
    iata: "UME",
    name: "Umeå Airport",
    city: "Umeå",
    country: "SE",
    continent: "EU",
    lat: 63.7918,
    lon: 20.2828,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNV": {
    icao: "ESNV",
    iata: "VHM",
    name: "Vilhelmina South Lapland Airport",
    city: "Vilhelmina",
    country: "SE",
    continent: "EU",
    lat: 64.5791,
    lon: 16.8336,
    elevation: 1140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNX": {
    icao: "ESNX",
    iata: "AJR",
    name: "Arvidsjaur Airport",
    city: "Arvidsjaur",
    country: "SE",
    continent: "EU",
    lat: 65.5903,
    lon: 19.2819,
    elevation: 1245,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNY": {
    icao: "ESNY",
    iata: "SOO",
    name: "Söderhamn Airport",
    city: "Söderhamn",
    country: "SE",
    continent: "EU",
    lat: 61.2615,
    lon: 17.0991,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESNZ": {
    icao: "ESNZ",
    iata: "OSD",
    name: "Åre Östersund Airport",
    city: "Östersund",
    country: "SE",
    continent: "EU",
    lat: 63.1941,
    lon: 14.5003,
    elevation: 1233,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESOE": {
    icao: "ESOE",
    iata: "ORB",
    name: "Örebro Airport",
    city: "Örebro",
    country: "SE",
    continent: "EU",
    lat: 59.2237,
    lon: 15.038,
    elevation: 188,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESOK": {
    icao: "ESOK",
    iata: "KSD",
    name: "Karlstad Airport",
    city: "Karlstad",
    country: "SE",
    continent: "EU",
    lat: 59.4447,
    lon: 13.3374,
    elevation: 352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESOW": {
    icao: "ESOW",
    iata: "VST",
    name: "Stockholm Västerås Airport",
    city: "Stockholm / Västerås",
    country: "SE",
    continent: "EU",
    lat: 59.5894,
    lon: 16.6336,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESPA": {
    icao: "ESPA",
    iata: "LLA",
    name: "Luleå Airport",
    city: "Luleå",
    country: "SE",
    continent: "EU",
    lat: 65.5438,
    lon: 22.122,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSA": {
    icao: "ESSA",
    iata: "ARN",
    name: "Stockholm-Arlanda Airport",
    city: "Stockholm",
    country: "SE",
    continent: "EU",
    lat: 59.6485,
    lon: 17.9288,
    elevation: 137,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ESSB": {
    icao: "ESSB",
    iata: "BMA",
    name: "Stockholm-Bromma Airport",
    city: "Stockholm",
    country: "SE",
    continent: "EU",
    lat: 59.3544,
    lon: 17.9417,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSD": {
    icao: "ESSD",
    iata: "BLE",
    name: "Dala Airport",
    city: "Borlange",
    country: "SE",
    continent: "EU",
    lat: 60.422,
    lon: 15.5152,
    elevation: 503,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSK": {
    icao: "ESSK",
    iata: "GVX",
    name: "Gävle Sandviken Airport",
    city: "Gävle / Sandviken",
    country: "SE",
    continent: "EU",
    lat: 60.5933,
    lon: 16.9514,
    elevation: 224,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSL": {
    icao: "ESSL",
    iata: "LPI",
    name: "Linköping City Airport",
    city: "Linköping",
    country: "SE",
    continent: "EU",
    lat: 58.4062,
    lon: 15.6805,
    elevation: 172,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSP": {
    icao: "ESSP",
    iata: "NRK",
    name: "Norrköping Airport",
    city: "Norrköping",
    country: "SE",
    continent: "EU",
    lat: 58.5863,
    lon: 16.2506,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESST": {
    icao: "ESST",
    iata: "TYF",
    name: "Torsby Airport",
    city: "Torsby",
    country: "SE",
    continent: "EU",
    lat: 60.1576,
    lon: 12.9913,
    elevation: 393,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSU": {
    icao: "ESSU",
    iata: "EKT",
    name: "Eskilstuna Airport",
    city: "Eskilstuna",
    country: "SE",
    continent: "EU",
    lat: 59.3511,
    lon: 16.7084,
    elevation: 139,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESSV": {
    icao: "ESSV",
    iata: "VBY",
    name: "Visby Airport",
    city: "Visby",
    country: "SE",
    continent: "EU",
    lat: 57.6628,
    lon: 18.3462,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESTA": {
    icao: "ESTA",
    iata: "AGH",
    name: "Ängelholm-Helsingborg Airport",
    city: "Ängelholm",
    country: "SE",
    continent: "EU",
    lat: 56.2961,
    lon: 12.8471,
    elevation: 68,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESTL": {
    icao: "ESTL",
    iata: "",
    name: "Ljungbyhed Airfield",
    city: "Ljungbyhed",
    country: "SE",
    continent: "EU",
    lat: 56.0828,
    lon: 13.2125,
    elevation: 140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ESUD": {
    icao: "ESUD",
    iata: "SQO",
    name: "Storuman Airport",
    city: "Storuman",
    country: "SE",
    continent: "EU",
    lat: 64.9609,
    lon: 17.6966,
    elevation: 915,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETAD": {
    icao: "ETAD",
    iata: "SPM",
    name: "Spangdahlem Air Base",
    city: "Trier",
    country: "DE",
    continent: "EU",
    lat: 49.9765,
    lon: 6.6984,
    elevation: 1197,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETAR": {
    icao: "ETAR",
    iata: "RMS",
    name: "Ramstein Air Base",
    city: "Ramstein-Miesenbach",
    country: "DE",
    continent: "EU",
    lat: 49.4369,
    lon: 7.6003,
    elevation: 776,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETHB": {
    icao: "ETHB",
    iata: "",
    name: "Bückeburg Air Base",
    city: "Bückeburg",
    country: "DE",
    continent: "EU",
    lat: 52.2785,
    lon: 9.0822,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETHC": {
    icao: "ETHC",
    iata: "",
    name: "Celle Army Airfield",
    city: "Celle",
    country: "DE",
    continent: "EU",
    lat: 52.5912,
    lon: 10.0221,
    elevation: 129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETHF": {
    icao: "ETHF",
    iata: "FRZ",
    name: "Fritzlar Army Airfield",
    city: "Fritzlar",
    country: "DE",
    continent: "EU",
    lat: 51.1146,
    lon: 9.286,
    elevation: 565,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETHL": {
    icao: "ETHL",
    iata: "",
    name: "Laupheim Air Base",
    city: "Laupheim",
    country: "DE",
    continent: "EU",
    lat: 48.2203,
    lon: 9.91,
    elevation: 1766,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETHN": {
    icao: "ETHN",
    iata: "",
    name: "Niederstetten Army Air Base",
    city: "Niederstetten",
    country: "DE",
    continent: "EU",
    lat: 49.3916,
    lon: 9.9567,
    elevation: 1536,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETHS": {
    icao: "ETHS",
    iata: "",
    name: "Faßberg Air Base",
    city: "Faßberg",
    country: "DE",
    continent: "EU",
    lat: 52.9194,
    lon: 10.1858,
    elevation: 245,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETIC": {
    icao: "ETIC",
    iata: "",
    name: "Grafenwöhr Army Air Field",
    city: "Grafenwöhr",
    country: "DE",
    continent: "EU",
    lat: 49.6987,
    lon: 11.9402,
    elevation: 1363,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETIH": {
    icao: "ETIH",
    iata: "",
    name: "Hohenfels Army Airfield",
    city: "Hohenfels",
    country: "DE",
    continent: "EU",
    lat: 49.2165,
    lon: 11.8361,
    elevation: 1455,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETMN": {
    icao: "ETMN",
    iata: "FCN",
    name: "Sea-Airport Cuxhaven/Nordholz / Nordholz Naval Airbase",
    city: "Wurster Nordseeküste",
    country: "DE",
    continent: "EU",
    lat: 53.7677,
    lon: 8.6592,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETND": {
    icao: "ETND",
    iata: "",
    name: "Diepholz Air Base",
    city: "Diepholz",
    country: "DE",
    continent: "EU",
    lat: 52.5856,
    lon: 8.3422,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNG": {
    icao: "ETNG",
    iata: "GKE",
    name: "Geilenkirchen Air Base",
    city: "Geilenkirchen",
    country: "DE",
    continent: "EU",
    lat: 50.9608,
    lon: 6.0424,
    elevation: 296,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNH": {
    icao: "ETNH",
    iata: "",
    name: "Hohn Air Base",
    city: "Hohn",
    country: "DE",
    continent: "EU",
    lat: 54.3122,
    lon: 9.5382,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNL": {
    icao: "ETNL",
    iata: "RLG",
    name: "Rostock-Laage Airport",
    city: "Laage",
    country: "DE",
    continent: "EU",
    lat: 53.9182,
    lon: 12.2783,
    elevation: 138,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNN": {
    icao: "ETNN",
    iata: "",
    name: "Nörvenich Air Base",
    city: "Nörvenich",
    country: "DE",
    continent: "EU",
    lat: 50.8312,
    lon: 6.6582,
    elevation: 386,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNS": {
    icao: "ETNS",
    iata: "WBG",
    name: "Schleswig Air Base",
    city: "Jagel",
    country: "DE",
    continent: "EU",
    lat: 54.4593,
    lon: 9.5163,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNT": {
    icao: "ETNT",
    iata: "",
    name: "Wittmundhafen Air Base",
    city: "Wittmund",
    country: "DE",
    continent: "EU",
    lat: 53.5478,
    lon: 7.6673,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETNW": {
    icao: "ETNW",
    iata: "",
    name: "Wunstorf Air Base",
    city: "",
    country: "DE",
    continent: "EU",
    lat: 52.4573,
    lon: 9.4272,
    elevation: 187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETOU": {
    icao: "ETOU",
    iata: "WIE",
    name: "Wiesbaden Army Airfield",
    city: "Wiesbaden",
    country: "DE",
    continent: "EU",
    lat: 50.0498,
    lon: 8.3254,
    elevation: 461,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETSB": {
    icao: "ETSB",
    iata: "",
    name: "Büchel Air Base",
    city: "Alflen",
    country: "DE",
    continent: "EU",
    lat: 50.1738,
    lon: 7.0633,
    elevation: 1568,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETSH": {
    icao: "ETSH",
    iata: "",
    name: "Holzdorf Air Base",
    city: "Holzdorf",
    country: "DE",
    continent: "EU",
    lat: 51.7678,
    lon: 13.1677,
    elevation: 265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETSI": {
    icao: "ETSI",
    iata: "IGS",
    name: "Ingolstadt Manching Airport",
    city: "Manching",
    country: "DE",
    continent: "EU",
    lat: 48.7157,
    lon: 11.534,
    elevation: 1202,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETSL": {
    icao: "ETSL",
    iata: "",
    name: "Lechfeld Air Base",
    city: "Graben",
    country: "DE",
    continent: "EU",
    lat: 48.1855,
    lon: 10.8612,
    elevation: 1822,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ETSN": {
    icao: "ETSN",
    iata: "",
    name: "Neuburg Air Base",
    city: "Neuburg an der Donau",
    country: "DE",
    continent: "EU",
    lat: 48.711,
    lon: 11.2115,
    elevation: 1249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EVKA": {
    icao: "EVKA",
    iata: "",
    name: "Jēkabpils Air Base",
    city: "Jēkabpils",
    country: "LV",
    continent: "EU",
    lat: 56.5347,
    lon: 25.8925,
    elevation: 289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EVLA": {
    icao: "EVLA",
    iata: "LPX",
    name: "Liepāja International Airport",
    city: "Liepāja",
    country: "LV",
    continent: "EU",
    lat: 56.5175,
    lon: 21.0969,
    elevation: 16,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EVRA": {
    icao: "EVRA",
    iata: "RIX",
    name: "Riga International Airport",
    city: "Riga",
    country: "LV",
    continent: "EU",
    lat: 56.9208,
    lon: 23.9707,
    elevation: 36,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "EVTA": {
    icao: "EVTA",
    iata: "",
    name: "Jūrmala Airport",
    city: "Tukums",
    country: "LV",
    continent: "EU",
    lat: 56.9422,
    lon: 23.2239,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYKA": {
    icao: "EYKA",
    iata: "KUN",
    name: "Kaunas International Airport",
    city: "Kaunas",
    country: "LT",
    continent: "EU",
    lat: 54.9639,
    lon: 24.0848,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYKD": {
    icao: "EYKD",
    iata: "",
    name: "Kėdainiai Air Base",
    city: "Kėdainiai",
    country: "LT",
    continent: "EU",
    lat: 55.3117,
    lon: 23.9564,
    elevation: 171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYPA": {
    icao: "EYPA",
    iata: "PLQ",
    name: "Palanga International Airport",
    city: "Palanga",
    country: "LT",
    continent: "EU",
    lat: 55.9732,
    lon: 21.0939,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYPP": {
    icao: "EYPP",
    iata: "PNV",
    name: "Panevėžys Air Base",
    city: "Panevėžys",
    country: "LT",
    continent: "EU",
    lat: 55.7294,
    lon: 24.4608,
    elevation: 197,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYSA": {
    icao: "EYSA",
    iata: "SQQ",
    name: "Šiauliai International Airport",
    city: "Šiauliai",
    country: "LT",
    continent: "EU",
    lat: 55.8939,
    lon: 23.395,
    elevation: 443,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYSB": {
    icao: "EYSB",
    iata: "",
    name: "Barysiai Airfield",
    city: "Šiauliai",
    country: "LT",
    continent: "EU",
    lat: 56.0706,
    lon: 23.5581,
    elevation: 270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "EYVI": {
    icao: "EYVI",
    iata: "VNO",
    name: "Vilnius International Airport",
    city: "Vilnius",
    country: "LT",
    continent: "EU",
    lat: 54.6341,
    lon: 25.2858,
    elevation: 648,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FAAB": {
    icao: "FAAB",
    iata: "ALJ",
    name: "Alexander Bay Airport",
    city: "Alexander Bay",
    country: "ZA",
    continent: "AF",
    lat: -28.575,
    lon: 16.5333,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAAG": {
    icao: "FAAG",
    iata: "AGZ",
    name: "Aggeneys Airport",
    city: "Aggeneys",
    country: "ZA",
    continent: "AF",
    lat: -29.2818,
    lon: 18.8139,
    elevation: 2648,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FABE": {
    icao: "FABE",
    iata: "BIY",
    name: "Bisho Airport",
    city: "Bisho",
    country: "ZA",
    continent: "AF",
    lat: -32.8971,
    lon: 27.2791,
    elevation: 1950,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FABL": {
    icao: "FABL",
    iata: "BFN",
    name: "Bram Fischer International Airport",
    city: "Bloemfontain",
    country: "ZA",
    continent: "AF",
    lat: -29.0927,
    lon: 26.3024,
    elevation: 4457,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FABR": {
    icao: "FABR",
    iata: "",
    name: "Barberton Airport",
    city: "Umjindi (Barberton)",
    country: "ZA",
    continent: "AF",
    lat: -25.7171,
    lon: 30.975,
    elevation: 2250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FACT": {
    icao: "FACT",
    iata: "CPT",
    name: "Cape Town International Airport",
    city: "Cape Town",
    country: "ZA",
    continent: "AF",
    lat: -33.9648,
    lon: 18.6017,
    elevation: 151,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FAEL": {
    icao: "FAEL",
    iata: "ELS",
    name: "King Phalo Airport",
    city: "East London",
    country: "ZA",
    continent: "AF",
    lat: -33.0356,
    lon: 27.8259,
    elevation: 435,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAEO": {
    icao: "FAEO",
    iata: "",
    name: "Ermelo Airport",
    city: "Ermelo",
    country: "ZA",
    continent: "AF",
    lat: -26.4956,
    lon: 29.9798,
    elevation: 5700,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAFB": {
    icao: "FAFB",
    iata: "FCB",
    name: "Ficksburg Sentraoes Airport",
    city: "Ficksburg",
    country: "ZA",
    continent: "AF",
    lat: -28.8231,
    lon: 27.9089,
    elevation: 5315,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAGC": {
    icao: "FAGC",
    iata: "GCJ",
    name: "Grand Central Airport",
    city: "Midrand",
    country: "ZA",
    continent: "AF",
    lat: -25.9863,
    lon: 28.1401,
    elevation: 5325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAGG": {
    icao: "FAGG",
    iata: "GRJ",
    name: "George Airport",
    city: "George",
    country: "ZA",
    continent: "AF",
    lat: -34.0056,
    lon: 22.3789,
    elevation: 648,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAGM": {
    icao: "FAGM",
    iata: "QRA",
    name: "Rand Airport",
    city: "Johannesburg",
    country: "ZA",
    continent: "AF",
    lat: -26.2425,
    lon: 28.1512,
    elevation: 5483,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAHR": {
    icao: "FAHR",
    iata: "HRS",
    name: "Harrismith Airport",
    city: "Harrismith",
    country: "ZA",
    continent: "AF",
    lat: -28.2351,
    lon: 29.1062,
    elevation: 5585,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAKD": {
    icao: "FAKD",
    iata: "KXE",
    name: "P C Pelser Airport",
    city: "Klerksdorp",
    country: "ZA",
    continent: "AF",
    lat: -26.8711,
    lon: 26.718,
    elevation: 4444,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAKM": {
    icao: "FAKM",
    iata: "KIM",
    name: "Kimberley Airport",
    city: "Kimberley",
    country: "ZA",
    continent: "AF",
    lat: -28.8028,
    lon: 24.7652,
    elevation: 3950,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAKN": {
    icao: "FAKN",
    iata: "MQP",
    name: "Kruger Mpumalanga International Airport",
    city: "Mpumalanga",
    country: "ZA",
    continent: "AF",
    lat: -25.3832,
    lon: 31.1056,
    elevation: 2829,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAKU": {
    icao: "FAKU",
    iata: "KMH",
    name: "Johan Pienaar Airport",
    city: "Kuruman",
    country: "ZA",
    continent: "AF",
    lat: -27.4567,
    lon: 23.4114,
    elevation: 4382,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAKZ": {
    icao: "FAKZ",
    iata: "KLZ",
    name: "Kleinsee Airport",
    city: "Kleinsee",
    country: "ZA",
    continent: "AF",
    lat: -29.6884,
    lon: 17.094,
    elevation: 270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FALA": {
    icao: "FALA",
    iata: "HLA",
    name: "Lanseria International Airport",
    city: "Johannesburg",
    country: "ZA",
    continent: "AF",
    lat: -25.9385,
    lon: 27.9261,
    elevation: 4517,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FALC": {
    icao: "FALC",
    iata: "LMR",
    name: "Lime Acres Finsch Mine Airport",
    city: "Lime Acres",
    country: "ZA",
    continent: "AF",
    lat: -28.3601,
    lon: 23.4391,
    elevation: 4900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FALE": {
    icao: "FALE",
    iata: "DUR",
    name: "King Shaka International Airport",
    city: "Durban",
    country: "ZA",
    continent: "AF",
    lat: -29.6144,
    lon: 31.1197,
    elevation: 295,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FALW": {
    icao: "FALW",
    iata: "SDB",
    name: "Langebaanweg Airport",
    city: "Langebaanweg",
    country: "ZA",
    continent: "AF",
    lat: -32.9689,
    lon: 18.1603,
    elevation: 108,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FALY": {
    icao: "FALY",
    iata: "LAY",
    name: "Ladysmith Airport",
    city: "Ladysmith",
    country: "ZA",
    continent: "AF",
    lat: -28.5817,
    lon: 29.7497,
    elevation: 3548,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAMD": {
    icao: "FAMD",
    iata: "AAM",
    name: "Malamala Airport",
    city: "Malamala",
    country: "ZA",
    continent: "AF",
    lat: -24.8169,
    lon: 31.5441,
    elevation: 1124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAMG": {
    icao: "FAMG",
    iata: "MGH",
    name: "Margate Airport",
    city: "Margate",
    country: "ZA",
    continent: "AF",
    lat: -30.8574,
    lon: 30.343,
    elevation: 495,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAMM": {
    icao: "FAMM",
    iata: "MBD",
    name: "Mmabatho International Airport",
    city: "Mafeking",
    country: "ZA",
    continent: "AF",
    lat: -25.7984,
    lon: 25.548,
    elevation: 4181,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAMS": {
    icao: "FAMS",
    iata: "",
    name: "Morningside Farm Airport",
    city: "Silveroaks",
    country: "ZA",
    continent: "AF",
    lat: -25.7045,
    lon: 26.909,
    elevation: 4251,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAMU": {
    icao: "FAMU",
    iata: "MZQ",
    name: "Mkuze Airport",
    city: "Mkuze",
    country: "ZA",
    continent: "AF",
    lat: -27.6261,
    lon: 32.0443,
    elevation: 400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FANC": {
    icao: "FANC",
    iata: "NCS",
    name: "Newcastle Airport",
    city: "Newcastle",
    country: "ZA",
    continent: "AF",
    lat: -27.7706,
    lon: 29.9769,
    elevation: 4074,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAOH": {
    icao: "FAOH",
    iata: "OUH",
    name: "Oudtshoorn Airport",
    city: "Oudtshoorn",
    country: "ZA",
    continent: "AF",
    lat: -33.607,
    lon: 22.189,
    elevation: 1063,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAOR": {
    icao: "FAOR",
    iata: "JNB",
    name: "O.R. Tambo International Airport",
    city: "Johannesburg",
    country: "ZA",
    continent: "AF",
    lat: -26.1392,
    lon: 28.246,
    elevation: 5558,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FAPE": {
    icao: "FAPE",
    iata: "PLZ",
    name: "Chief Dawid Stuurman International Airport",
    city: "Gqeberha (Port Elizabeth)",
    country: "ZA",
    continent: "AF",
    lat: -33.9849,
    lon: 25.6173,
    elevation: 226,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPG": {
    icao: "FAPG",
    iata: "PBZ",
    name: "Plettenberg Bay Airport",
    city: "Plettenberg Bay",
    country: "ZA",
    continent: "AF",
    lat: -34.0882,
    lon: 23.3287,
    elevation: 465,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPH": {
    icao: "FAPH",
    iata: "PHW",
    name: "Hendrik Van Eck Airport",
    city: "Phalaborwa",
    country: "ZA",
    continent: "AF",
    lat: -23.9372,
    lon: 31.1554,
    elevation: 1432,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPI": {
    icao: "FAPI",
    iata: "",
    name: "Pietersburg Municipal Airport",
    city: "Polokwane",
    country: "ZA",
    continent: "AF",
    lat: -23.9261,
    lon: 29.4844,
    elevation: 4354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPJ": {
    icao: "FAPJ",
    iata: "JOH",
    name: "Port St Johns Airport",
    city: "Port St Johns",
    country: "ZA",
    continent: "AF",
    lat: -31.6061,
    lon: 29.5218,
    elevation: 1227,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPM": {
    icao: "FAPM",
    iata: "PZB",
    name: "Pietermaritzburg Airport",
    city: "Pietermaritzburg",
    country: "ZA",
    continent: "AF",
    lat: -29.649,
    lon: 30.3987,
    elevation: 2423,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPP": {
    icao: "FAPP",
    iata: "PTG",
    name: "Polokwane International Airport",
    city: "Polokwane",
    country: "ZA",
    continent: "AF",
    lat: -23.8453,
    lon: 29.4586,
    elevation: 4076,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAPS": {
    icao: "FAPS",
    iata: "PCF",
    name: "Potchefstroom Airport",
    city: "Potchefstroom",
    country: "ZA",
    continent: "AF",
    lat: -26.671,
    lon: 27.0819,
    elevation: 4520,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAQT": {
    icao: "FAQT",
    iata: "UTW",
    name: "Queenstown Airport",
    city: "Queenstown",
    country: "ZA",
    continent: "AF",
    lat: -31.9202,
    lon: 26.8822,
    elevation: 3637,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FARB": {
    icao: "FARB",
    iata: "RCB",
    name: "Richards Bay Airport",
    city: "Richards Bay",
    country: "ZA",
    continent: "AF",
    lat: -28.741,
    lon: 32.0921,
    elevation: 109,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FARG": {
    icao: "FARG",
    iata: "",
    name: "Rustenburg Airport",
    city: "Rustenburg",
    country: "ZA",
    continent: "AF",
    lat: -25.6443,
    lon: 27.2711,
    elevation: 3700,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FARS": {
    icao: "FARS",
    iata: "ROD",
    name: "Robertson Airport",
    city: "Robertson",
    country: "ZA",
    continent: "AF",
    lat: -33.8122,
    lon: 19.9028,
    elevation: 640,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FASB": {
    icao: "FASB",
    iata: "SBU",
    name: "Springbok Airport",
    city: "Springbok",
    country: "ZA",
    continent: "AF",
    lat: -29.6893,
    lon: 17.9396,
    elevation: 2690,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FASC": {
    icao: "FASC",
    iata: "ZEC",
    name: "Secunda Airport",
    city: "Secunda",
    country: "ZA",
    continent: "AF",
    lat: -26.5241,
    lon: 29.1701,
    elevation: 5250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FASD": {
    icao: "FASD",
    iata: "",
    name: "Saldanha/Vredenburg Airport",
    city: "Saldanha-Vredenburg",
    country: "ZA",
    continent: "AF",
    lat: -32.9641,
    lon: 17.9693,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FASK": {
    icao: "FASK",
    iata: "",
    name: "Swartkop Air Force Base",
    city: "Pretoria",
    country: "ZA",
    continent: "AF",
    lat: -25.8097,
    lon: 28.1646,
    elevation: 4780,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FASS": {
    icao: "FASS",
    iata: "SIS",
    name: "Sishen Airport",
    city: "Sishen",
    country: "ZA",
    continent: "AF",
    lat: -27.6486,
    lon: 22.9993,
    elevation: 3848,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FASZ": {
    icao: "FASZ",
    iata: "SZK",
    name: "Skukuza Airport",
    city: "Skukuza",
    country: "ZA",
    continent: "AF",
    lat: -24.9609,
    lon: 31.5887,
    elevation: 1020,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FATZ": {
    icao: "FATZ",
    iata: "LTA",
    name: "Tzaneen Airport",
    city: "Tzaneen",
    country: "ZA",
    continent: "AF",
    lat: -23.8244,
    lon: 30.3293,
    elevation: 1914,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAUL": {
    icao: "FAUL",
    iata: "ULD",
    name: "Prince Mangosuthu Buthelezi Airport",
    city: "Ulundi",
    country: "ZA",
    continent: "AF",
    lat: -28.3206,
    lon: 31.4165,
    elevation: 1720,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAUP": {
    icao: "FAUP",
    iata: "UTN",
    name: "Pierre Van Ryneveld Airport",
    city: "Upington",
    country: "ZA",
    continent: "AF",
    lat: -28.3991,
    lon: 21.2602,
    elevation: 2782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAUT": {
    icao: "FAUT",
    iata: "UTT",
    name: "K. D. Matanzima Airport",
    city: "Mthatha",
    country: "ZA",
    continent: "AF",
    lat: -31.5464,
    lon: 28.6734,
    elevation: 2400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAVB": {
    icao: "FAVB",
    iata: "VRU",
    name: "Vryburg Airport",
    city: "Vyrburg",
    country: "ZA",
    continent: "AF",
    lat: -26.9824,
    lon: 24.7288,
    elevation: 3920,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAVG": {
    icao: "FAVG",
    iata: "VIR",
    name: "Virginia Airport",
    city: "Durban",
    country: "ZA",
    continent: "AF",
    lat: -29.7706,
    lon: 31.0584,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAVR": {
    icao: "FAVR",
    iata: "VRE",
    name: "Vredendal Airport",
    city: "Vredendal",
    country: "ZA",
    continent: "AF",
    lat: -31.641,
    lon: 18.5448,
    elevation: 330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAVV": {
    icao: "FAVV",
    iata: "",
    name: "Vereeniging Airport",
    city: "Vereeniging",
    country: "ZA",
    continent: "AF",
    lat: -26.5664,
    lon: 27.9608,
    elevation: 4846,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAWB": {
    icao: "FAWB",
    iata: "PRY",
    name: "Wonderboom Airport",
    city: "Pretoria",
    country: "ZA",
    continent: "AF",
    lat: -25.6539,
    lon: 28.2242,
    elevation: 4095,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAWK": {
    icao: "FAWK",
    iata: "WKF",
    name: "Waterkloof Air Force Base",
    city: "Pretoria",
    country: "ZA",
    continent: "AF",
    lat: -25.83,
    lon: 28.2225,
    elevation: 4940,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FAYP": {
    icao: "FAYP",
    iata: "",
    name: "Ysterplaat Air Force Base",
    city: "Cape Town",
    country: "ZA",
    continent: "AF",
    lat: -33.9002,
    lon: 18.4983,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FBFT": {
    icao: "FBFT",
    iata: "FRW",
    name: "P G Matante Intl",
    city: "Francistown",
    country: "BW",
    continent: "AF",
    lat: -21.1591,
    lon: 27.4685,
    elevation: 3283,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FBJW": {
    icao: "FBJW",
    iata: "JWA",
    name: "Jwaneng Airport",
    city: "Jwaneng",
    country: "BW",
    continent: "AF",
    lat: -24.6023,
    lon: 24.691,
    elevation: 3900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FBKE": {
    icao: "FBKE",
    iata: "BBK",
    name: "Kasane Airport",
    city: "Kasane",
    country: "BW",
    continent: "AF",
    lat: -17.8329,
    lon: 25.1624,
    elevation: 3289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FBMN": {
    icao: "FBMN",
    iata: "MUB",
    name: "Maun Airport",
    city: "Maun",
    country: "BW",
    continent: "AF",
    lat: -19.9705,
    lon: 23.4314,
    elevation: 3093,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FBSK": {
    icao: "FBSK",
    iata: "GBE",
    name: "Sir Seretse Khama International Airport",
    city: "Gaborone",
    country: "BW",
    continent: "AF",
    lat: -24.5552,
    lon: 25.9182,
    elevation: 3299,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FBSN": {
    icao: "FBSN",
    iata: "SXN",
    name: "Sua Pan Airport",
    city: "Sowa",
    country: "BW",
    continent: "AF",
    lat: -20.5534,
    lon: 26.1158,
    elevation: 2985,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FBSP": {
    icao: "FBSP",
    iata: "PKW",
    name: "Selebi Phikwe Airport",
    city: "Selebi Phikwe",
    country: "BW",
    continent: "AF",
    lat: -22.0583,
    lon: 27.8288,
    elevation: 2925,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FCBB": {
    icao: "FCBB",
    iata: "BZV",
    name: "Maya-Maya Airport",
    city: "Brazzaville",
    country: "CG",
    continent: "AF",
    lat: -4.2517,
    lon: 15.253,
    elevation: 1048,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FCOD": {
    icao: "FCOD",
    iata: "OLL",
    name: "Oyo Ollombo Airport",
    city: "Oyo",
    country: "CG",
    continent: "AF",
    lat: -1.2267,
    lon: 15.91,
    elevation: 1073,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FCOO": {
    icao: "FCOO",
    iata: "FTX",
    name: "Owando Airport",
    city: "Owando",
    country: "CG",
    continent: "AF",
    lat: -0.5246,
    lon: 15.9378,
    elevation: 1214,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FCOU": {
    icao: "FCOU",
    iata: "OUE",
    name: "Ouesso Airport",
    city: "",
    country: "CG",
    continent: "AF",
    lat: 1.616,
    lon: 16.0379,
    elevation: 1158,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FCPL": {
    icao: "FCPL",
    iata: "DIS",
    name: "Ngot Nzoungou Airport",
    city: "Dolisie",
    country: "CG",
    continent: "AF",
    lat: -4.2063,
    lon: 12.6599,
    elevation: 1079,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FCPP": {
    icao: "FCPP",
    iata: "PNR",
    name: "Antonio Agostinho-Neto International Airport",
    city: "Pointe Noire",
    country: "CG",
    continent: "AF",
    lat: -4.816,
    lon: 11.8866,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FDMS": {
    icao: "FDMS",
    iata: "MTS",
    name: "Matsapha Airport",
    city: "Manzini",
    country: "SZ",
    continent: "AF",
    lat: -26.529,
    lon: 31.3075,
    elevation: 2075,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FDSK": {
    icao: "FDSK",
    iata: "SHO",
    name: "King Mswati III International Airport",
    city: "Mpaka",
    country: "SZ",
    continent: "AF",
    lat: -26.3586,
    lon: 31.7169,
    elevation: 1092,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FEFF": {
    icao: "FEFF",
    iata: "BGF",
    name: "Bangui M\'Poko International Airport",
    city: "Bangui",
    country: "CF",
    continent: "AF",
    lat: 4.3985,
    lon: 18.5188,
    elevation: 1208,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FEFT": {
    icao: "FEFT",
    iata: "BBT",
    name: "Berbérati Airport",
    city: "Berbérati",
    country: "CF",
    continent: "AF",
    lat: 4.2216,
    lon: 15.7864,
    elevation: 1929,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FGBT": {
    icao: "FGBT",
    iata: "BSG",
    name: "Bata Airport",
    city: "Bata",
    country: "GQ",
    continent: "AF",
    lat: 1.9055,
    lon: 9.8057,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FGSL": {
    icao: "FGSL",
    iata: "SSG",
    name: "Malabo Airport",
    city: "Malabo",
    country: "GQ",
    continent: "AF",
    lat: 3.7553,
    lon: 8.7087,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FHAW": {
    icao: "FHAW",
    iata: "ASI",
    name: "RAF Ascension Island",
    city: "Cat Hill",
    country: "SH",
    continent: "AF",
    lat: -7.9696,
    lon: -14.3937,
    elevation: 278,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FIMP": {
    icao: "FIMP",
    iata: "MRU",
    name: "Sir Seewoosagur Ramgoolam International Airport",
    city: "Plaine Magnien",
    country: "MU",
    continent: "AF",
    lat: -20.4302,
    lon: 57.6836,
    elevation: 186,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FIMR": {
    icao: "FIMR",
    iata: "RRG",
    name: "Sir Charles Gaetan Duval Airport",
    city: "Port Mathurin",
    country: "MU",
    continent: "AF",
    lat: -19.7577,
    lon: 63.361,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FJDG": {
    icao: "FJDG",
    iata: "NKW",
    name: "Diego Garcia Naval Support Facility",
    city: "Diego Garcia",
    country: "IO",
    continent: "AS",
    lat: -7.3133,
    lon: 72.4111,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKC": {
    icao: "FKKC",
    iata: "TKC",
    name: "Tiko Airport",
    city: "Tiko",
    country: "CM",
    continent: "AF",
    lat: 4.0892,
    lon: 9.3605,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKD": {
    icao: "FKKD",
    iata: "DLA",
    name: "Douala International Airport",
    city: "Douala",
    country: "CM",
    continent: "AF",
    lat: 4.0061,
    lon: 9.7195,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKL": {
    icao: "FKKL",
    iata: "MVR",
    name: "Salak Airport",
    city: "Maroua",
    country: "CM",
    continent: "AF",
    lat: 10.4514,
    lon: 14.2574,
    elevation: 1390,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKM": {
    icao: "FKKM",
    iata: "FOM",
    name: "Foumban Nkounja Airport",
    city: "Foumban",
    country: "CM",
    continent: "AF",
    lat: 5.6369,
    lon: 10.7508,
    elevation: 3963,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKN": {
    icao: "FKKN",
    iata: "NGE",
    name: "N\'Gaoundéré Airport",
    city: "N\'Gaoundéré",
    country: "CM",
    continent: "AF",
    lat: 7.357,
    lon: 13.5592,
    elevation: 3655,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKR": {
    icao: "FKKR",
    iata: "GOU",
    name: "Garoua International Airport",
    city: "Garoua",
    country: "CM",
    continent: "AF",
    lat: 9.3359,
    lon: 13.3701,
    elevation: 794,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKU": {
    icao: "FKKU",
    iata: "BFX",
    name: "Bafoussam Airport",
    city: "Bafoussam",
    country: "CM",
    continent: "AF",
    lat: 5.5369,
    lon: 10.3546,
    elevation: 4347,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKV": {
    icao: "FKKV",
    iata: "BPC",
    name: "Bamenda Airport",
    city: "Bamenda",
    country: "CM",
    continent: "AF",
    lat: 6.0392,
    lon: 10.1226,
    elevation: 4065,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKKY": {
    icao: "FKKY",
    iata: "YAO",
    name: "Yaoundé Airport",
    city: "Yaoundé",
    country: "CM",
    continent: "AF",
    lat: 3.836,
    lon: 11.5235,
    elevation: 2464,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FKYS": {
    icao: "FKYS",
    iata: "NSI",
    name: "Yaoundé Nsimalen International Airport",
    city: "Yaoundé",
    country: "CM",
    continent: "AF",
    lat: 3.7226,
    lon: 11.5533,
    elevation: 2278,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLKE": {
    icao: "FLKE",
    iata: "CGJ",
    name: "Kasompe Airport",
    city: "Chingola",
    country: "ZM",
    continent: "AF",
    lat: -12.5728,
    lon: 27.8939,
    elevation: 4636,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLLC": {
    icao: "FLLC",
    iata: "",
    name: "Lusaka City Airport",
    city: "Lusaka",
    country: "ZM",
    continent: "AF",
    lat: -15.4138,
    lon: 28.3307,
    elevation: 4200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLLI": {
    icao: "FLLI",
    iata: "LVI",
    name: "Harry Mwanga Nkumbula International Airport",
    city: "Livingstone",
    country: "ZM",
    continent: "AF",
    lat: -17.8218,
    lon: 25.8227,
    elevation: 3302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLLS": {
    icao: "FLLS",
    iata: "LUN",
    name: "Kenneth Kaunda International Airport",
    city: "Lusaka",
    country: "ZM",
    continent: "AF",
    lat: -15.3308,
    lon: 28.4527,
    elevation: 3779,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FLMF": {
    icao: "FLMF",
    iata: "MFU",
    name: "Mfuwe Airport",
    city: "Mfuwe",
    country: "ZM",
    continent: "AF",
    lat: -13.2589,
    lon: 31.9366,
    elevation: 1853,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLMG": {
    icao: "FLMG",
    iata: "MNR",
    name: "Mongu Airport",
    city: "Mongu",
    country: "ZM",
    continent: "AF",
    lat: -15.2545,
    lon: 23.1623,
    elevation: 3488,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLND": {
    icao: "FLND",
    iata: "",
    name: "Peter Zuze Air Force Base",
    city: "Ndola",
    country: "ZM",
    continent: "AF",
    lat: -12.9972,
    lon: 28.6639,
    elevation: 4170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLSK": {
    icao: "FLSK",
    iata: "NLA",
    name: "Simon Mwansa Kapwepwe International Airport",
    city: "Ndola",
    country: "ZM",
    continent: "AF",
    lat: -12.9617,
    lon: 28.5167,
    elevation: 4308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FLSO": {
    icao: "FLSO",
    iata: "KIW",
    name: "Southdowns Airport",
    city: "Kitwe",
    country: "ZM",
    continent: "AF",
    lat: -12.9005,
    lon: 28.1499,
    elevation: 4145,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMCH": {
    icao: "FMCH",
    iata: "HAH",
    name: "Prince Said Ibrahim International Airport",
    city: "Moroni",
    country: "KM",
    continent: "AF",
    lat: -11.5337,
    lon: 43.2719,
    elevation: 93,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMCI": {
    icao: "FMCI",
    iata: "NWA",
    name: "Mohéli Bandar Es Eslam Airport",
    city: "Fomboni",
    country: "KM",
    continent: "AF",
    lat: -12.2981,
    lon: 43.7664,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMCV": {
    icao: "FMCV",
    iata: "AJN",
    name: "Ouani Airport",
    city: "Ouani",
    country: "KM",
    continent: "AF",
    lat: -12.131,
    lon: 44.43,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMCZ": {
    icao: "FMCZ",
    iata: "DZA",
    name: "Dzaoudzi Pamandzi International Airport",
    city: "Dzaoudzi",
    country: "YT",
    continent: "AF",
    lat: -12.8093,
    lon: 45.2818,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMEE": {
    icao: "FMEE",
    iata: "RUN",
    name: "Roland Garros Airport",
    city: "Sainte-Marie",
    country: "RE",
    continent: "AF",
    lat: -20.8901,
    lon: 55.5189,
    elevation: 66,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FMEP": {
    icao: "FMEP",
    iata: "ZSE",
    name: "Pierrefonds Airport",
    city: "Saint-Pierre",
    country: "RE",
    continent: "AF",
    lat: -21.3194,
    lon: 55.4225,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMMI": {
    icao: "FMMI",
    iata: "TNR",
    name: "Ivato Airport",
    city: "Antananarivo",
    country: "MG",
    continent: "AF",
    lat: -18.7969,
    lon: 47.4788,
    elevation: 4198,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FMMN": {
    icao: "FMMN",
    iata: "ZVA",
    name: "Miandrivazo Airport",
    city: "Miandrivazo",
    country: "MG",
    continent: "AF",
    lat: -19.5628,
    lon: 45.4508,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMMS": {
    icao: "FMMS",
    iata: "SMS",
    name: "Sainte Marie Airport",
    city: "Vohilava",
    country: "MG",
    continent: "AF",
    lat: -17.0939,
    lon: 49.8158,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMMT": {
    icao: "FMMT",
    iata: "TMM",
    name: "Toamasina Ambalamanasy Airport",
    city: "Toamasina",
    country: "MG",
    continent: "AF",
    lat: -18.1095,
    lon: 49.3925,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMMV": {
    icao: "FMMV",
    iata: "MOQ",
    name: "Morondava Airport",
    city: "Morondava",
    country: "MG",
    continent: "AF",
    lat: -20.2847,
    lon: 44.3176,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNA": {
    icao: "FMNA",
    iata: "DIE",
    name: "Arrachart Airport",
    city: "Antisiranana",
    country: "MG",
    continent: "AF",
    lat: -12.3494,
    lon: 49.2917,
    elevation: 374,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNC": {
    icao: "FMNC",
    iata: "WMR",
    name: "Mananara Nord Airport",
    city: "Mananara Nord",
    country: "MG",
    continent: "AF",
    lat: -16.1639,
    lon: 49.7738,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMND": {
    icao: "FMND",
    iata: "ZWA",
    name: "Andapa Airport",
    city: "",
    country: "MG",
    continent: "AF",
    lat: -14.6517,
    lon: 49.6206,
    elevation: 1552,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNH": {
    icao: "FMNH",
    iata: "ANM",
    name: "Antsirabe Airport",
    city: "Antsirabe",
    country: "MG",
    continent: "AF",
    lat: -14.9994,
    lon: 50.3202,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNL": {
    icao: "FMNL",
    iata: "HVA",
    name: "Analalava Airport",
    city: "Analalava",
    country: "MG",
    continent: "AF",
    lat: -14.6295,
    lon: 47.7636,
    elevation: 345,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNM": {
    icao: "FMNM",
    iata: "MJN",
    name: "Amborovy Airport",
    city: "Mahajanga",
    country: "MG",
    continent: "AF",
    lat: -15.6668,
    lon: 46.3512,
    elevation: 87,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNN": {
    icao: "FMNN",
    iata: "NOS",
    name: "Fascene Airport",
    city: "Nosy Be",
    country: "MG",
    continent: "AF",
    lat: -13.3121,
    lon: 48.3148,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNQ": {
    icao: "FMNQ",
    iata: "BPY",
    name: "Besalampy Airport",
    city: "Besalampy",
    country: "MG",
    continent: "AF",
    lat: -16.7445,
    lon: 44.4825,
    elevation: 125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNR": {
    icao: "FMNR",
    iata: "WMN",
    name: "Maroantsetra Airport",
    city: "Maroantsetra",
    country: "MG",
    continent: "AF",
    lat: -15.4377,
    lon: 49.6891,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNS": {
    icao: "FMNS",
    iata: "SVB",
    name: "Sambava Airport",
    city: "Sambava",
    country: "MG",
    continent: "AF",
    lat: -14.2786,
    lon: 50.1747,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNV": {
    icao: "FMNV",
    iata: "VOH",
    name: "Vohemar Airport",
    city: "Vohemar",
    country: "MG",
    continent: "AF",
    lat: -13.3758,
    lon: 50.0028,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMNW": {
    icao: "FMNW",
    iata: "WAI",
    name: "Ambalabe Airport",
    city: "Antsohihy",
    country: "MG",
    continent: "AF",
    lat: -14.8988,
    lon: 47.9939,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMSD": {
    icao: "FMSD",
    iata: "FTU",
    name: "Tôlanaro Airport",
    city: "Tôlanaro",
    country: "MG",
    continent: "AF",
    lat: -25.0381,
    lon: 46.9561,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMSF": {
    icao: "FMSF",
    iata: "WFI",
    name: "Fianarantsoa Airport",
    city: "Fianarantsoa",
    country: "MG",
    continent: "AF",
    lat: -21.4416,
    lon: 47.1117,
    elevation: 3658,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMSK": {
    icao: "FMSK",
    iata: "WVK",
    name: "Manakara Airport",
    city: "Manakara",
    country: "MG",
    continent: "AF",
    lat: -22.1197,
    lon: 48.0217,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMSM": {
    icao: "FMSM",
    iata: "MNJ",
    name: "Mananjary Airport",
    city: "Mananjary",
    country: "MG",
    continent: "AF",
    lat: -21.2018,
    lon: 48.3583,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMSR": {
    icao: "FMSR",
    iata: "MXM",
    name: "Morombe Airport",
    city: "Morombe",
    country: "MG",
    continent: "AF",
    lat: -21.7538,
    lon: 43.3748,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FMST": {
    icao: "FMST",
    iata: "TLE",
    name: "Toliara Airport",
    city: "Toliara",
    country: "MG",
    continent: "AF",
    lat: -23.3834,
    lon: 43.7285,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNBC": {
    icao: "FNBC",
    iata: "SSY",
    name: "Mbanza Congo Airport",
    city: "Mbanza Congo",
    country: "AO",
    continent: "AF",
    lat: -6.2699,
    lon: 14.247,
    elevation: 1860,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNBG": {
    icao: "FNBG",
    iata: "BUG",
    name: "Benguela Airport",
    city: "Benguela",
    country: "AO",
    continent: "AF",
    lat: -12.609,
    lon: 13.4037,
    elevation: 118,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNBJ": {
    icao: "FNBJ",
    iata: "NBJ",
    name: "Dr. Antonio Agostinho Neto International Airport",
    city: "Luanda (Ícolo e Bengo)",
    country: "AO",
    continent: "AF",
    lat: -9.0507,
    lon: 13.4991,
    elevation: 550,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNCA": {
    icao: "FNCA",
    iata: "CAB",
    name: "Cabinda Airport",
    city: "Cabinda",
    country: "AO",
    continent: "AF",
    lat: -5.597,
    lon: 12.1884,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNCT": {
    icao: "FNCT",
    iata: "CBT",
    name: "Catumbela Airport",
    city: "Catumbela",
    country: "AO",
    continent: "AF",
    lat: -12.4792,
    lon: 13.4869,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNDU": {
    icao: "FNDU",
    iata: "DUE",
    name: "Dundo Airport",
    city: "Chitato",
    country: "AO",
    continent: "AF",
    lat: -7.4009,
    lon: 20.8185,
    elevation: 2451,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNGI": {
    icao: "FNGI",
    iata: "VPE",
    name: "Ngjiva Pereira Airport",
    city: "Ngiva",
    country: "AO",
    continent: "AF",
    lat: -17.0435,
    lon: 15.6838,
    elevation: 3566,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNHU": {
    icao: "FNHU",
    iata: "NOV",
    name: "Albano Machado Airport",
    city: "Huambo",
    country: "AO",
    continent: "AF",
    lat: -12.8089,
    lon: 15.7605,
    elevation: 5587,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNKU": {
    icao: "FNKU",
    iata: "SVP",
    name: "Kuito Airport",
    city: "Kuito",
    country: "AO",
    continent: "AF",
    lat: -12.4046,
    lon: 16.9474,
    elevation: 5618,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNLU": {
    icao: "FNLU",
    iata: "LAD",
    name: "Quatro de Fevereiro International Airport",
    city: "Luanda",
    country: "AO",
    continent: "AF",
    lat: -8.8584,
    lon: 13.2312,
    elevation: 243,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FNMA": {
    icao: "FNMA",
    iata: "MEG",
    name: "Malanje Airport",
    city: "Malanje",
    country: "AO",
    continent: "AF",
    lat: -9.5251,
    lon: 16.3124,
    elevation: 3868,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNME": {
    icao: "FNME",
    iata: "SPP",
    name: "Menongue Airport",
    city: "Menongue",
    country: "AO",
    continent: "AF",
    lat: -14.6576,
    lon: 17.7198,
    elevation: 4469,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNMO": {
    icao: "FNMO",
    iata: "MSZ",
    name: "Welwitschia Mirabilis International Airport",
    city: "Moçâmedes",
    country: "AO",
    continent: "AF",
    lat: -15.2612,
    lon: 12.1468,
    elevation: 210,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNNG": {
    icao: "FNNG",
    iata: "GXG",
    name: "Negage Airport",
    city: "Negage",
    country: "AO",
    continent: "AF",
    lat: -7.7545,
    lon: 15.2877,
    elevation: 4105,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNPA": {
    icao: "FNPA",
    iata: "PBN",
    name: "Porto Amboim Airport",
    city: "Port Amboim",
    country: "AO",
    continent: "AF",
    lat: -10.722,
    lon: 13.7655,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNSA": {
    icao: "FNSA",
    iata: "VHC",
    name: "Saurimo Airport",
    city: "Saurimo",
    country: "AO",
    continent: "AF",
    lat: -9.6891,
    lon: 20.4319,
    elevation: 3584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNSO": {
    icao: "FNSO",
    iata: "SZA",
    name: "Soyo Airport",
    city: "Soyo",
    country: "AO",
    continent: "AF",
    lat: -6.1411,
    lon: 12.3718,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNSU": {
    icao: "FNSU",
    iata: "NDD",
    name: "Sumbe Airport",
    city: "Sumbe",
    country: "AO",
    continent: "AF",
    lat: -11.1679,
    lon: 13.8475,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNUB": {
    icao: "FNUB",
    iata: "SDD",
    name: "Lubango Airport",
    city: "Lubango",
    country: "AO",
    continent: "AF",
    lat: -14.9247,
    lon: 13.575,
    elevation: 5778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNUE": {
    icao: "FNUE",
    iata: "LUO",
    name: "Luena Airport",
    city: "Luena",
    country: "AO",
    continent: "AF",
    lat: -11.7681,
    lon: 19.8977,
    elevation: 4360,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNUG": {
    icao: "FNUG",
    iata: "UGO",
    name: "Uige Airport",
    city: "Uige",
    country: "AO",
    continent: "AF",
    lat: -7.6031,
    lon: 15.0278,
    elevation: 2720,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FNXA": {
    icao: "FNXA",
    iata: "XGN",
    name: "Xangongo Airport",
    city: "Xangongo",
    country: "AO",
    continent: "AF",
    lat: -16.7554,
    lon: 14.9653,
    elevation: 3635,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOGK": {
    icao: "FOGK",
    iata: "KOU",
    name: "Koulamoutou Mabimbi Airport",
    city: "Koulamoutou",
    country: "GA",
    continent: "AF",
    lat: -1.1846,
    lon: 12.4413,
    elevation: 1070,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOGM": {
    icao: "FOGM",
    iata: "MJL",
    name: "Mouilla Ville Airport",
    city: "Mouila",
    country: "GA",
    continent: "AF",
    lat: -1.8451,
    lon: 11.0567,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOGO": {
    icao: "FOGO",
    iata: "OYE",
    name: "Oyem Airport",
    city: "Oyem",
    country: "GA",
    continent: "AF",
    lat: 1.5431,
    lon: 11.5814,
    elevation: 2158,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOGQ": {
    icao: "FOGQ",
    iata: "OKN",
    name: "Okondja Airport",
    city: "Okondja",
    country: "GA",
    continent: "AF",
    lat: -0.6652,
    lon: 13.6731,
    elevation: 1325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOGR": {
    icao: "FOGR",
    iata: "LBQ",
    name: "Lambarene Airport",
    city: "Lambarene",
    country: "GA",
    continent: "AF",
    lat: -0.7044,
    lon: 10.2457,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOOB": {
    icao: "FOOB",
    iata: "BMM",
    name: "Bitam Airport",
    city: "Bitam",
    country: "GA",
    continent: "AF",
    lat: 2.0756,
    lon: 11.4932,
    elevation: 1969,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOOG": {
    icao: "FOOG",
    iata: "POG",
    name: "Port Gentil Airport",
    city: "Port Gentil",
    country: "GA",
    continent: "AF",
    lat: -0.7117,
    lon: 8.7544,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOOH": {
    icao: "FOOH",
    iata: "OMB",
    name: "Omboue Hospital Airport",
    city: "Omboue",
    country: "GA",
    continent: "AF",
    lat: -1.5747,
    lon: 9.2627,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOOK": {
    icao: "FOOK",
    iata: "MKU",
    name: "Makokou Airport",
    city: "Makokou",
    country: "GA",
    continent: "AF",
    lat: 0.5792,
    lon: 12.8909,
    elevation: 1726,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOOL": {
    icao: "FOOL",
    iata: "LBV",
    name: "Libreville Leon M\'ba International Airport",
    city: "Libreville",
    country: "GA",
    continent: "AF",
    lat: 0.4586,
    lon: 9.4123,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FOON": {
    icao: "FOON",
    iata: "MVB",
    name: "M\'Vengue El Hadj Omar Bongo Ondimba International Airport",
    city: "Franceville",
    country: "GA",
    continent: "AF",
    lat: -1.6562,
    lon: 13.438,
    elevation: 1450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FPPR": {
    icao: "FPPR",
    iata: "PCP",
    name: "Principe Airport",
    city: "São Tomé & Príncipe",
    country: "ST",
    continent: "AF",
    lat: 1.6629,
    lon: 7.4117,
    elevation: 591,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FPST": {
    icao: "FPST",
    iata: "TMS",
    name: "São Tomé International Airport",
    city: "São Tomé",
    country: "ST",
    continent: "AF",
    lat: 0.3782,
    lon: 6.7122,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQBR": {
    icao: "FQBR",
    iata: "BEW",
    name: "Beira Airport",
    city: "Beira",
    country: "MZ",
    continent: "AF",
    lat: -19.7964,
    lon: 34.9076,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQCH": {
    icao: "FQCH",
    iata: "VPY",
    name: "Chimoio Airport",
    city: "Chimoio",
    country: "MZ",
    continent: "AF",
    lat: -19.1513,
    lon: 33.429,
    elevation: 2287,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQIN": {
    icao: "FQIN",
    iata: "INH",
    name: "Inhambane Airport",
    city: "Inhambane",
    country: "MZ",
    continent: "AF",
    lat: -23.8764,
    lon: 35.4085,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQLC": {
    icao: "FQLC",
    iata: "VXC",
    name: "Lichinga Airport",
    city: "Lichinga",
    country: "MZ",
    continent: "AF",
    lat: -13.274,
    lon: 35.2663,
    elevation: 4505,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQMA": {
    icao: "FQMA",
    iata: "MPM",
    name: "Maputo Airport",
    city: "Maputo",
    country: "MZ",
    continent: "AF",
    lat: -25.9208,
    lon: 32.5726,
    elevation: 145,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FQMD": {
    icao: "FQMD",
    iata: "MUD",
    name: "Mueda Airport",
    city: "Mueda",
    country: "MZ",
    continent: "AF",
    lat: -11.6729,
    lon: 39.5631,
    elevation: 2789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQMP": {
    icao: "FQMP",
    iata: "MZB",
    name: "Mocímboa da Praia Airport",
    city: "Mocímboa da Praia",
    country: "MZ",
    continent: "AF",
    lat: -11.3618,
    lon: 40.3549,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQNP": {
    icao: "FQNP",
    iata: "APL",
    name: "Nampula Airport",
    city: "Nampula",
    country: "MZ",
    continent: "AF",
    lat: -15.1056,
    lon: 39.2818,
    elevation: 1444,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQPB": {
    icao: "FQPB",
    iata: "POL",
    name: "Pemba Airport",
    city: "Pemba",
    country: "MZ",
    continent: "AF",
    lat: -12.9933,
    lon: 40.5249,
    elevation: 331,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQQL": {
    icao: "FQQL",
    iata: "UEL",
    name: "Quelimane Airport",
    city: "Quelimane",
    country: "MZ",
    continent: "AF",
    lat: -17.8555,
    lon: 36.8691,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQTT": {
    icao: "FQTT",
    iata: "TET",
    name: "Chingozi Airport",
    city: "Tete",
    country: "MZ",
    continent: "AF",
    lat: -16.1048,
    lon: 33.6402,
    elevation: 525,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FQVL": {
    icao: "FQVL",
    iata: "VNX",
    name: "Vilankulo Airport",
    city: "Vilanculo",
    country: "MZ",
    continent: "AF",
    lat: -22.0184,
    lon: 35.3133,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FSIA": {
    icao: "FSIA",
    iata: "SEZ",
    name: "Seychelles International Airport",
    city: "Mahe Island",
    country: "SC",
    continent: "AF",
    lat: -4.6743,
    lon: 55.5218,
    elevation: 10,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FSPP": {
    icao: "FSPP",
    iata: "PRI",
    name: "Praslin Island Airport",
    city: "Praslin Island",
    country: "SC",
    continent: "AF",
    lat: -4.3193,
    lon: 55.6916,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FTFY": {
    icao: "FTFY",
    iata: "",
    name: "Ouadi Doum Air Base",
    city: "Wadi Doum",
    country: "TD",
    continent: "AF",
    lat: 18.5279,
    lon: 20.1886,
    elevation: 1308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FTTC": {
    icao: "FTTC",
    iata: "AEH",
    name: "Abeche Airport",
    city: "Abeche",
    country: "TD",
    continent: "AF",
    lat: 13.847,
    lon: 20.8443,
    elevation: 1788,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FTTD": {
    icao: "FTTD",
    iata: "MQQ",
    name: "Moundou Airport",
    city: "Moundou",
    country: "TD",
    continent: "AF",
    lat: 8.6285,
    lon: 16.0742,
    elevation: 1407,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FTTJ": {
    icao: "FTTJ",
    iata: "NDJ",
    name: "N\'Djamena International Airport",
    city: "N\'Djamena",
    country: "TD",
    continent: "AF",
    lat: 12.1337,
    lon: 15.034,
    elevation: 968,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FTTY": {
    icao: "FTTY",
    iata: "FYT",
    name: "Faya-Largeau Airport",
    city: "Faya-Largeau",
    country: "TD",
    continent: "AF",
    lat: 17.9171,
    lon: 19.1111,
    elevation: 771,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVBU": {
    icao: "FVBU",
    iata: "BUQ",
    name: "Joshua Mqabuko Nkomo International Airport",
    city: "Bulawayo",
    country: "ZW",
    continent: "AF",
    lat: -20.0213,
    lon: 28.6263,
    elevation: 4359,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVCZ": {
    icao: "FVCZ",
    iata: "BFO",
    name: "Buffalo Range Airport",
    city: "Chiredzi",
    country: "ZW",
    continent: "AF",
    lat: -21.0081,
    lon: 31.5786,
    elevation: 1421,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVFA": {
    icao: "FVFA",
    iata: "VFA",
    name: "Victoria Falls International Airport",
    city: "Victoria Falls",
    country: "ZW",
    continent: "AF",
    lat: -18.0959,
    lon: 25.839,
    elevation: 3490,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVHA": {
    icao: "FVHA",
    iata: "HRE",
    name: "Robert Gabriel Mugabe International Airport",
    city: "Harare",
    country: "ZW",
    continent: "AF",
    lat: -17.9318,
    lon: 31.0928,
    elevation: 4887,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FVKB": {
    icao: "FVKB",
    iata: "KAB",
    name: "Kariba International Airport",
    city: "Kariba",
    country: "ZW",
    continent: "AF",
    lat: -16.5198,
    lon: 28.885,
    elevation: 1706,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVMT": {
    icao: "FVMT",
    iata: "",
    name: "Mutoko Airport",
    city: "Mutoko",
    country: "ZW",
    continent: "AF",
    lat: -17.4319,
    lon: 32.1845,
    elevation: 3950,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVMV": {
    icao: "FVMV",
    iata: "MVZ",
    name: "Masvingo International Airport",
    city: "Masvingo",
    country: "ZW",
    continent: "AF",
    lat: -20.0553,
    lon: 30.8591,
    elevation: 3595,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVTL": {
    icao: "FVTL",
    iata: "GWE",
    name: "Gweru - Thornhill Air Base",
    city: "Gweru",
    country: "ZW",
    continent: "AF",
    lat: -19.4367,
    lon: 29.8619,
    elevation: 4680,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FVWN": {
    icao: "FVWN",
    iata: "HWN",
    name: "Hwange National Park Airport",
    city: "Gwayi River Farms",
    country: "ZW",
    continent: "AF",
    lat: -18.6299,
    lon: 27.021,
    elevation: 3543,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FWCL": {
    icao: "FWCL",
    iata: "BLZ",
    name: "Chileka International Airport",
    city: "Blantyre",
    country: "MW",
    continent: "AF",
    lat: -15.6791,
    lon: 34.974,
    elevation: 2555,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FWDW": {
    icao: "FWDW",
    iata: "DWA",
    name: "Dwangwa Airport",
    city: "Dwangwa",
    country: "MW",
    continent: "AF",
    lat: -12.5175,
    lon: 34.1319,
    elevation: 1605,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FWKA": {
    icao: "FWKA",
    iata: "KGJ",
    name: "Karonga Airport",
    city: "Karonga",
    country: "MW",
    continent: "AF",
    lat: -9.9536,
    lon: 33.8933,
    elevation: 1765,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FWKI": {
    icao: "FWKI",
    iata: "LLW",
    name: "Kamuzu International Airport",
    city: "Lumbadzi",
    country: "MW",
    continent: "AF",
    lat: -13.7894,
    lon: 33.781,
    elevation: 4035,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FWUU": {
    icao: "FWUU",
    iata: "ZZU",
    name: "Mzuzu Airport",
    city: "Mzuzu",
    country: "MW",
    continent: "AF",
    lat: -11.4447,
    lon: 34.0118,
    elevation: 4115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FXMM": {
    icao: "FXMM",
    iata: "MSU",
    name: "Moshoeshoe I International Airport",
    city: "Mazenod",
    country: "LS",
    continent: "AF",
    lat: -29.4623,
    lon: 27.5525,
    elevation: 5348,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYAR": {
    icao: "FYAR",
    iata: "ADI",
    name: "Arandis Airport",
    city: "Arandis",
    country: "NA",
    continent: "AF",
    lat: -22.4619,
    lon: 14.9793,
    elevation: 1905,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYGF": {
    icao: "FYGF",
    iata: "GFY",
    name: "Grootfontein Airport",
    city: "Grootfontein",
    country: "NA",
    continent: "AF",
    lat: -19.6022,
    lon: 18.1227,
    elevation: 4636,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYKM": {
    icao: "FYKM",
    iata: "MPA",
    name: "Katima Mulilo Airport",
    city: "Mpacha",
    country: "NA",
    continent: "AF",
    lat: -17.6343,
    lon: 24.1767,
    elevation: 3144,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYKT": {
    icao: "FYKT",
    iata: "KMP",
    name: "Keetmanshoop Airport",
    city: "Keetmanshoop",
    country: "NA",
    continent: "AF",
    lat: -26.5398,
    lon: 18.1114,
    elevation: 3506,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYLZ": {
    icao: "FYLZ",
    iata: "LUD",
    name: "Luderitz Airport",
    city: "Luderitz",
    country: "NA",
    continent: "AF",
    lat: -26.6874,
    lon: 15.2429,
    elevation: 457,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYML": {
    icao: "FYML",
    iata: "",
    name: "Mariental Airport",
    city: "Mariental",
    country: "NA",
    continent: "AF",
    lat: -24.6054,
    lon: 17.9254,
    elevation: 3650,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYOA": {
    icao: "FYOA",
    iata: "OND",
    name: "Ondangwa Airport",
    city: "Ondangwa",
    country: "NA",
    continent: "AF",
    lat: -17.8782,
    lon: 15.9526,
    elevation: 3599,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYOG": {
    icao: "FYOG",
    iata: "OMD",
    name: "Oranjemund Airport",
    city: "Oranjemund",
    country: "NA",
    continent: "AF",
    lat: -28.5847,
    lon: 16.4467,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYRU": {
    icao: "FYRU",
    iata: "NDU",
    name: "Rundu Airport",
    city: "Rundu",
    country: "NA",
    continent: "AF",
    lat: -17.9565,
    lon: 19.7194,
    elevation: 3627,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYTM": {
    icao: "FYTM",
    iata: "TSB",
    name: "Tsumeb Airport",
    city: "Tsumeb",
    country: "NA",
    continent: "AF",
    lat: -19.2621,
    lon: 17.7325,
    elevation: 4353,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYWB": {
    icao: "FYWB",
    iata: "WVB",
    name: "Walvis Bay Airport",
    city: "Rooikop",
    country: "NA",
    continent: "AF",
    lat: -22.9793,
    lon: 14.6471,
    elevation: 299,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYWE": {
    icao: "FYWE",
    iata: "ERS",
    name: "Eros Airport",
    city: "Windhoek",
    country: "NA",
    continent: "AF",
    lat: -22.6049,
    lon: 17.079,
    elevation: 5575,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FYWH": {
    icao: "FYWH",
    iata: "WDH",
    name: "Hosea Kutako International Airport",
    city: "Windhoek",
    country: "NA",
    continent: "AF",
    lat: -22.4799,
    lon: 17.4709,
    elevation: 5640,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FZAA": {
    icao: "FZAA",
    iata: "FIH",
    name: "Ndjili International Airport",
    city: "Kinshasa",
    country: "CD",
    continent: "AF",
    lat: -4.3857,
    lon: 15.4446,
    elevation: 1027,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "FZAB": {
    icao: "FZAB",
    iata: "NLO",
    name: "Ndolo Airport",
    city: "N\'dolo",
    country: "CD",
    continent: "AF",
    lat: -4.3267,
    lon: 15.3275,
    elevation: 915,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZBO": {
    icao: "FZBO",
    iata: "FDU",
    name: "Bandundu Airport",
    city: "Bandundu",
    country: "CD",
    continent: "AF",
    lat: -3.3113,
    lon: 17.3817,
    elevation: 1063,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZCA": {
    icao: "FZCA",
    iata: "KKW",
    name: "Kikwit Airport",
    city: "Kikwit",
    country: "CD",
    continent: "AF",
    lat: -5.0358,
    lon: 18.7856,
    elevation: 1572,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZEA": {
    icao: "FZEA",
    iata: "MDK",
    name: "Mbandaka Airport",
    city: "Mbandaka",
    country: "CD",
    continent: "AF",
    lat: 0.0226,
    lon: 18.2887,
    elevation: 1040,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZFD": {
    icao: "FZFD",
    iata: "BDT",
    name: "Gbadolite Airport",
    city: "Gbadolite",
    country: "CD",
    continent: "AF",
    lat: 4.2527,
    lon: 20.9753,
    elevation: 1509,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZFK": {
    icao: "FZFK",
    iata: "GMA",
    name: "Gemena Airport",
    city: "Gemena",
    country: "CD",
    continent: "AF",
    lat: 3.2354,
    lon: 19.7713,
    elevation: 1378,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZGA": {
    icao: "FZGA",
    iata: "LIQ",
    name: "Lisala Airport",
    city: "Lisala",
    country: "CD",
    continent: "AF",
    lat: 2.1707,
    lon: 21.4969,
    elevation: 1509,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZIC": {
    icao: "FZIC",
    iata: "FKI",
    name: "Bangoka International Airport",
    city: "Kisangani",
    country: "CD",
    continent: "AF",
    lat: 0.4816,
    lon: 25.338,
    elevation: 1417,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZJH": {
    icao: "FZJH",
    iata: "IRP",
    name: "Matari Airport",
    city: "Isiro",
    country: "CD",
    continent: "AF",
    lat: 2.8276,
    lon: 27.5883,
    elevation: 2438,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZKA": {
    icao: "FZKA",
    iata: "BUX",
    name: "Bunia Airport",
    city: "Bunia",
    country: "CD",
    continent: "AF",
    lat: 1.5657,
    lon: 30.2207,
    elevation: 4045,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZKJ": {
    icao: "FZKJ",
    iata: "BZU",
    name: "Buta Zega Airport",
    city: "Buta",
    country: "CD",
    continent: "AF",
    lat: 2.8181,
    lon: 24.794,
    elevation: 1378,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZMA": {
    icao: "FZMA",
    iata: "BKY",
    name: "Bukavu Kavumu Airport",
    city: "Kamakombe",
    country: "CD",
    continent: "AF",
    lat: -2.309,
    lon: 28.8088,
    elevation: 5643,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZNA": {
    icao: "FZNA",
    iata: "GOM",
    name: "Goma International Airport",
    city: "Goma",
    country: "CD",
    continent: "AF",
    lat: -1.6662,
    lon: 29.2379,
    elevation: 5089,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZOA": {
    icao: "FZOA",
    iata: "KND",
    name: "Kindu Airport",
    city: "Kindu",
    country: "CD",
    continent: "AF",
    lat: -2.9192,
    lon: 25.9154,
    elevation: 1630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZQA": {
    icao: "FZQA",
    iata: "FBM",
    name: "Lubumbashi International Airport",
    city: "Lubumbashi",
    country: "CD",
    continent: "AF",
    lat: -11.5913,
    lon: 27.5309,
    elevation: 4295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZQM": {
    icao: "FZQM",
    iata: "KWZ",
    name: "Kolwezi Airport",
    city: "Kolwezi",
    country: "CD",
    continent: "AF",
    lat: -10.7659,
    lon: 25.5057,
    elevation: 5007,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZRF": {
    icao: "FZRF",
    iata: "FMI",
    name: "Kalemie Airport",
    city: "Kalemie",
    country: "CD",
    continent: "AF",
    lat: -5.8756,
    lon: 29.25,
    elevation: 2569,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZSA": {
    icao: "FZSA",
    iata: "",
    name: "Kamina Air Base",
    city: "Lumwe",
    country: "CD",
    continent: "AF",
    lat: -8.642,
    lon: 25.2529,
    elevation: 3543,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZUA": {
    icao: "FZUA",
    iata: "KGA",
    name: "Kananga Airport",
    city: "Kananga",
    country: "CD",
    continent: "AF",
    lat: -5.9001,
    lon: 22.4692,
    elevation: 2139,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "FZWA": {
    icao: "FZWA",
    iata: "MJM",
    name: "Mbuji Mayi Airport",
    city: "Mbuji Mayi",
    country: "CD",
    continent: "AF",
    lat: -6.1212,
    lon: 23.569,
    elevation: 2221,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GABS": {
    icao: "GABS",
    iata: "BKO",
    name: "Modibo Keita International Airport",
    city: "Bamako",
    country: "ML",
    continent: "AF",
    lat: 12.5335,
    lon: -7.9499,
    elevation: 1247,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GAGO": {
    icao: "GAGO",
    iata: "GAQ",
    name: "Gao Airport",
    city: "",
    country: "ML",
    continent: "AF",
    lat: 16.2484,
    lon: -0.0055,
    elevation: 870,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GAKY": {
    icao: "GAKY",
    iata: "KYS",
    name: "Kayes Dag Dag Airport",
    city: "",
    country: "ML",
    continent: "AF",
    lat: 14.4825,
    lon: -11.3997,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GAMB": {
    icao: "GAMB",
    iata: "MZI",
    name: "Mopti Ambodédjo International Airport",
    city: "Sévaré",
    country: "ML",
    continent: "AF",
    lat: 14.5128,
    lon: -4.0796,
    elevation: 906,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GATB": {
    icao: "GATB",
    iata: "TOM",
    name: "Timbuktu Airport",
    city: "Timbuktu",
    country: "ML",
    continent: "AF",
    lat: 16.7305,
    lon: -3.0076,
    elevation: 863,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GBYD": {
    icao: "GBYD",
    iata: "BJL",
    name: "Banjul International Airport",
    city: "Yundum",
    country: "GM",
    continent: "AF",
    lat: 13.338,
    lon: -16.6522,
    elevation: 95,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GCFV": {
    icao: "GCFV",
    iata: "FUE",
    name: "Fuerteventura Airport",
    city: "El Matorral",
    country: "ES",
    continent: "AF",
    lat: 28.4527,
    lon: -13.8638,
    elevation: 85,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GCHI": {
    icao: "GCHI",
    iata: "VDE",
    name: "El Hierro Airport",
    city: "El Hierro Island",
    country: "ES",
    continent: "AF",
    lat: 27.8148,
    lon: -17.8871,
    elevation: 103,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GCLA": {
    icao: "GCLA",
    iata: "SPC",
    name: "La Palma Airport",
    city: "Sta Cruz de la Palma, La Palma Island",
    country: "ES",
    continent: "AF",
    lat: 28.6265,
    lon: -17.7556,
    elevation: 107,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GCLP": {
    icao: "GCLP",
    iata: "LPA",
    name: "Gran Canaria Airport",
    city: "Gran Canaria Island",
    country: "ES",
    continent: "AF",
    lat: 27.9319,
    lon: -15.3866,
    elevation: 78,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GCRR": {
    icao: "GCRR",
    iata: "ACE",
    name: "César Manrique-Lanzarote Airport",
    city: "San Bartolomé",
    country: "ES",
    continent: "AF",
    lat: 28.9455,
    lon: -13.6052,
    elevation: 46,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GCTS": {
    icao: "GCTS",
    iata: "TFS",
    name: "Tenerife Sur Airport",
    city: "Tenerife",
    country: "ES",
    continent: "AF",
    lat: 28.0445,
    lon: -16.5725,
    elevation: 209,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GCXO": {
    icao: "GCXO",
    iata: "TFN",
    name: "Tenerife Norte-Ciudad de La Laguna Airport",
    city: "Tenerife",
    country: "ES",
    continent: "AF",
    lat: 28.4827,
    lon: -16.3415,
    elevation: 2076,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GEML": {
    icao: "GEML",
    iata: "MLN",
    name: "Melilla Airport",
    city: "Melilla",
    country: "ES",
    continent: "AF",
    lat: 35.2798,
    lon: -2.9563,
    elevation: 156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GFBO": {
    icao: "GFBO",
    iata: "KBS",
    name: "Bo Airport",
    city: "Bo",
    country: "SL",
    continent: "AF",
    lat: 7.9444,
    lon: -11.761,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GFKE": {
    icao: "GFKE",
    iata: "KEN",
    name: "Kenema Airport",
    city: "Kenema",
    country: "SL",
    continent: "AF",
    lat: 7.8964,
    lon: -11.1741,
    elevation: 485,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GFLL": {
    icao: "GFLL",
    iata: "FNA",
    name: "Lungi International Airport",
    city: "Freetown (Lungi-Town)",
    country: "SL",
    continent: "AF",
    lat: 8.6164,
    lon: -13.1955,
    elevation: 84,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GFYE": {
    icao: "GFYE",
    iata: "WYE",
    name: "Yengema Airport",
    city: "Yengema",
    country: "SL",
    continent: "AF",
    lat: 8.6105,
    lon: -11.0454,
    elevation: 1300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GGOV": {
    icao: "GGOV",
    iata: "OXB",
    name: "Osvaldo Vieira International Airport",
    city: "Bissau",
    country: "GW",
    continent: "AF",
    lat: 11.8948,
    lon: -15.6537,
    elevation: 129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GLMR": {
    icao: "GLMR",
    iata: "MLW",
    name: "Spriggs Payne Airport",
    city: "Monrovia",
    country: "LR",
    continent: "AF",
    lat: 6.2891,
    lon: -10.7587,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GLRB": {
    icao: "GLRB",
    iata: "ROB",
    name: "Roberts International Airport",
    city: "Monrovia",
    country: "LR",
    continent: "AF",
    lat: 6.2338,
    lon: -10.3623,
    elevation: 31,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GMAD": {
    icao: "GMAD",
    iata: "AGA",
    name: "Al Massira Airport",
    city: "Agadir (Temsia)",
    country: "MA",
    continent: "AF",
    lat: 30.3225,
    lon: -9.412,
    elevation: 250,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GMAT": {
    icao: "GMAT",
    iata: "TTA",
    name: "Tan Tan Airport",
    city: "Tan Tan",
    country: "MA",
    continent: "AF",
    lat: 28.4482,
    lon: -11.1613,
    elevation: 653,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMAZ": {
    icao: "GMAZ",
    iata: "OZG",
    name: "Zagora Airport",
    city: "Zagora",
    country: "MA",
    continent: "AF",
    lat: 30.2639,
    lon: -5.8533,
    elevation: 2414,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMFB": {
    icao: "GMFB",
    iata: "UAR",
    name: "Bouarfa Airport",
    city: "Bouarfa",
    country: "MA",
    continent: "AF",
    lat: 32.5143,
    lon: -1.9831,
    elevation: 3630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMFF": {
    icao: "GMFF",
    iata: "FEZ",
    name: "Fes Saïss International Airport",
    city: "Saïss",
    country: "MA",
    continent: "AF",
    lat: 33.9273,
    lon: -4.978,
    elevation: 1900,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GMFK": {
    icao: "GMFK",
    iata: "ERH",
    name: "Moulay Ali Cherif Airport",
    city: "Errachidia",
    country: "MA",
    continent: "AF",
    lat: 31.9475,
    lon: -4.3983,
    elevation: 3428,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMFM": {
    icao: "GMFM",
    iata: "MEK",
    name: "Bassatine Airport",
    city: "Meknes",
    country: "MA",
    continent: "AF",
    lat: 33.8791,
    lon: -5.5151,
    elevation: 1890,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMFO": {
    icao: "GMFO",
    iata: "OUD",
    name: "Oujda Angads Airport",
    city: "Ahl Angad",
    country: "MA",
    continent: "AF",
    lat: 34.7896,
    lon: -1.926,
    elevation: 1535,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMMA": {
    icao: "GMMA",
    iata: "SMW",
    name: "Smara Airport",
    city: "Smara",
    country: "EH",
    continent: "AF",
    lat: 26.732,
    lon: -11.6837,
    elevation: 350,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMME": {
    icao: "GMME",
    iata: "RBA",
    name: "Rabat-Salé Airport",
    city: "Rabat",
    country: "MA",
    continent: "AF",
    lat: 34.0515,
    lon: -6.7515,
    elevation: 276,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GMMH": {
    icao: "GMMH",
    iata: "VIL",
    name: "Dakhla Airport",
    city: "Dakhla",
    country: "EH",
    continent: "AF",
    lat: 23.7183,
    lon: -15.932,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMMI": {
    icao: "GMMI",
    iata: "ESU",
    name: "Essaouira-Mogador Airport",
    city: "Essaouira",
    country: "MA",
    continent: "AF",
    lat: 31.3975,
    lon: -9.6817,
    elevation: 384,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMML": {
    icao: "GMML",
    iata: "EUN",
    name: "Hassan I Airport",
    city: "El Aaiún",
    country: "EH",
    continent: "AF",
    lat: 27.1425,
    lon: -13.2249,
    elevation: 207,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMMN": {
    icao: "GMMN",
    iata: "CMN",
    name: "Mohammed V International Airport",
    city: "Casablanca",
    country: "MA",
    continent: "AF",
    lat: 33.3675,
    lon: -7.59,
    elevation: 656,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GMMW": {
    icao: "GMMW",
    iata: "NDR",
    name: "Nador Al Aaroui International Airport",
    city: "Al Aaroui",
    country: "MA",
    continent: "AF",
    lat: 34.9888,
    lon: -3.0282,
    elevation: 574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMMX": {
    icao: "GMMX",
    iata: "RAK",
    name: "Menara Airport",
    city: "Marrakech",
    country: "MA",
    continent: "AF",
    lat: 31.6069,
    lon: -8.0363,
    elevation: 1545,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GMMY": {
    icao: "GMMY",
    iata: "NNA",
    name: "Kenitra Air Base",
    city: "Kenitra",
    country: "MA",
    continent: "AF",
    lat: 34.2989,
    lon: -6.5959,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMMZ": {
    icao: "GMMZ",
    iata: "OZZ",
    name: "Ouarzazate Airport",
    city: "Ouarzazate",
    country: "MA",
    continent: "AF",
    lat: 30.9391,
    lon: -6.9094,
    elevation: 3782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMTA": {
    icao: "GMTA",
    iata: "AHU",
    name: "Cherif Al Idrissi Airport",
    city: "Al Hoceima",
    country: "MA",
    continent: "AF",
    lat: 35.1771,
    lon: -3.8395,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMTN": {
    icao: "GMTN",
    iata: "TTU",
    name: "Sania Ramel Airport",
    city: "Tétouan",
    country: "MA",
    continent: "AF",
    lat: 35.5943,
    lon: -5.32,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GMTT": {
    icao: "GMTT",
    iata: "TNG",
    name: "Tangier Ibn Battuta Airport",
    city: "Tangier",
    country: "MA",
    continent: "AF",
    lat: 35.7317,
    lon: -5.9215,
    elevation: 62,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GOBD": {
    icao: "GOBD",
    iata: "DSS",
    name: "Blaise Diagne International Airport",
    city: "Dakar",
    country: "SN",
    continent: "AF",
    lat: 14.6709,
    lon: -17.0728,
    elevation: 290,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GOGG": {
    icao: "GOGG",
    iata: "ZIG",
    name: "Ziguinchor Airport",
    city: "Ziguinchor",
    country: "SN",
    continent: "AF",
    lat: 12.5556,
    lon: -16.2818,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOGS": {
    icao: "GOGS",
    iata: "CSK",
    name: "Cap Skirring Airport",
    city: "Cap Skirring",
    country: "SN",
    continent: "AF",
    lat: 12.3953,
    lon: -16.748,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOOK": {
    icao: "GOOK",
    iata: "KLC",
    name: "Kaolack Airport",
    city: "Kaolack",
    country: "SN",
    continent: "AF",
    lat: 14.1469,
    lon: -16.0513,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOOY": {
    icao: "GOOY",
    iata: "DKR",
    name: "Léopold Sédar Senghor International Airport",
    city: "Dakar",
    country: "SN",
    continent: "AF",
    lat: 14.7397,
    lon: -17.4902,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOSM": {
    icao: "GOSM",
    iata: "MAX",
    name: "Ouro Sogui Airport",
    city: "Ouro Sogui",
    country: "SN",
    continent: "AF",
    lat: 15.5936,
    lon: -13.3228,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOSS": {
    icao: "GOSS",
    iata: "XLS",
    name: "Saint Louis Airport",
    city: "Saint Louis",
    country: "SN",
    continent: "AF",
    lat: 16.0498,
    lon: -16.461,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOTB": {
    icao: "GOTB",
    iata: "BXE",
    name: "Bakel Airport",
    city: "Bakel",
    country: "SN",
    continent: "AF",
    lat: 14.8473,
    lon: -12.4683,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOTK": {
    icao: "GOTK",
    iata: "KGG",
    name: "Kédougou Airport",
    city: "Kédougou",
    country: "SN",
    continent: "AF",
    lat: 12.5723,
    lon: -12.2203,
    elevation: 584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GOTT": {
    icao: "GOTT",
    iata: "TUD",
    name: "Tambacounda Airport",
    city: "Tambacounda",
    country: "SN",
    continent: "AF",
    lat: 13.7368,
    lon: -13.6531,
    elevation: 161,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GQNO": {
    icao: "GQNO",
    iata: "NKC",
    name: "Nouakchott–Oumtounsy International Airport",
    city: "Nouakchott",
    country: "MR",
    continent: "AF",
    lat: 18.31,
    lon: -15.9697,
    elevation: 9,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GQPA": {
    icao: "GQPA",
    iata: "ATR",
    name: "Atar International Airport",
    city: "Atar",
    country: "MR",
    continent: "AF",
    lat: 20.5068,
    lon: -13.0432,
    elevation: 734,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GQPP": {
    icao: "GQPP",
    iata: "NDB",
    name: "Nouadhibou International Airport",
    city: "Nouadhibou",
    country: "MR",
    continent: "AF",
    lat: 20.9331,
    lon: -17.03,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GUCY": {
    icao: "GUCY",
    iata: "CKY",
    name: "Conakry International Airport",
    city: "Conakry",
    country: "GN",
    continent: "AF",
    lat: 9.5769,
    lon: -13.612,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GVAC": {
    icao: "GVAC",
    iata: "SID",
    name: "Amílcar Cabral International Airport",
    city: "Espargos",
    country: "CV",
    continent: "AF",
    lat: 16.7414,
    lon: -22.9494,
    elevation: 177,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GVBA": {
    icao: "GVBA",
    iata: "BVC",
    name: "Rabil Airport",
    city: "Rabil",
    country: "CV",
    continent: "AF",
    lat: 16.1365,
    lon: -22.8889,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GVMA": {
    icao: "GVMA",
    iata: "MMO",
    name: "Maio Airport",
    city: "Vila do Maio",
    country: "CV",
    continent: "AF",
    lat: 15.1559,
    lon: -23.2137,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GVNP": {
    icao: "GVNP",
    iata: "RAI",
    name: "Nelson Mandela International Airport",
    city: "Praia",
    country: "CV",
    continent: "AF",
    lat: 14.9411,
    lon: -23.4847,
    elevation: 230,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "GVSN": {
    icao: "GVSN",
    iata: "SNE",
    name: "Preguiça Airport",
    city: "Preguiça",
    country: "CV",
    continent: "AF",
    lat: 16.5889,
    lon: -24.2841,
    elevation: 669,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "GVSV": {
    icao: "GVSV",
    iata: "VXE",
    name: "São Pedro Airport",
    city: "São Pedro",
    country: "CV",
    continent: "AF",
    lat: 16.8332,
    lon: -25.0553,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAAB": {
    icao: "HAAB",
    iata: "ADD",
    name: "Addis Ababa Bole International Airport",
    city: "Addis Ababa",
    country: "ET",
    continent: "AF",
    lat: 8.9779,
    lon: 38.7993,
    elevation: 7630,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HAAM": {
    icao: "HAAM",
    iata: "AMH",
    name: "Arba Minch Airport",
    city: "Arba Minch",
    country: "ET",
    continent: "AF",
    lat: 6.0394,
    lon: 37.5905,
    elevation: 3901,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAAX": {
    icao: "HAAX",
    iata: "AXU",
    name: "Axum Airport",
    city: "Axum",
    country: "ET",
    continent: "AF",
    lat: 14.1468,
    lon: 38.7728,
    elevation: 6959,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HABD": {
    icao: "HABD",
    iata: "BJR",
    name: "Bahir Dar Airport",
    city: "Bahir Dar",
    country: "ET",
    continent: "AF",
    lat: 11.6081,
    lon: 37.3216,
    elevation: 5978,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HADR": {
    icao: "HADR",
    iata: "DIR",
    name: "Aba Tenna Dejazmach Yilma International Airport",
    city: "Dire Dawa",
    country: "ET",
    continent: "AF",
    lat: 9.6247,
    lon: 41.8542,
    elevation: 3827,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAGM": {
    icao: "HAGM",
    iata: "GMB",
    name: "Gambela Airport",
    city: "Gambela",
    country: "ET",
    continent: "AF",
    lat: 8.1288,
    lon: 34.5631,
    elevation: 1614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAGN": {
    icao: "HAGN",
    iata: "GDQ",
    name: "Gondar Airport",
    city: "Azezo",
    country: "ET",
    continent: "AF",
    lat: 12.5199,
    lon: 37.434,
    elevation: 6449,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAGO": {
    icao: "HAGO",
    iata: "GDE",
    name: "Gode Airport",
    city: "Gode",
    country: "ET",
    continent: "AF",
    lat: 5.9351,
    lon: 43.5786,
    elevation: 834,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAHM": {
    icao: "HAHM",
    iata: "QHR",
    name: "Harar Meda Airport",
    city: "Debre Zeyit",
    country: "ET",
    continent: "AF",
    lat: 8.7163,
    lon: 39.0059,
    elevation: 6201,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAJJ": {
    icao: "HAJJ",
    iata: "JIJ",
    name: "Wilwal International Airport",
    city: "Jijiga",
    country: "ET",
    continent: "AF",
    lat: 9.3325,
    lon: 42.9121,
    elevation: 5954,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAJM": {
    icao: "HAJM",
    iata: "JIM",
    name: "Jimma Airport",
    city: "Jimma",
    country: "ET",
    continent: "AF",
    lat: 7.6661,
    lon: 36.8166,
    elevation: 5500,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAKD": {
    icao: "HAKD",
    iata: "ABK",
    name: "Kebri Dahar Airport",
    city: "Kebri Dahar",
    country: "ET",
    continent: "AF",
    lat: 6.7326,
    lon: 44.2413,
    elevation: 1800,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HALA": {
    icao: "HALA",
    iata: "AWA",
    name: "Hawassa International Airport",
    city: "Hawassa",
    country: "ET",
    continent: "AF",
    lat: 7.0999,
    lon: 38.3962,
    elevation: 5450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HAMK": {
    icao: "HAMK",
    iata: "MQX",
    name: "Alula Aba Nega Airport",
    city: "Mekele",
    country: "ET",
    continent: "AF",
    lat: 13.4674,
    lon: 39.5335,
    elevation: 7396,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HASO": {
    icao: "HASO",
    iata: "ASO",
    name: "Asosa Airport",
    city: "Asosa",
    country: "ET",
    continent: "AF",
    lat: 10.0185,
    lon: 34.5863,
    elevation: 5100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HBBA": {
    icao: "HBBA",
    iata: "BJM",
    name: "Bujumbura Melchior Ndadaye International Airport",
    city: "Bujumbura",
    country: "BI",
    continent: "AF",
    lat: -3.324,
    lon: 29.3185,
    elevation: 2582,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HCMH": {
    icao: "HCMH",
    iata: "HGA",
    name: "Egal International Airport",
    city: "Hargeisa",
    country: "SO",
    continent: "AF",
    lat: 9.5132,
    lon: 44.0824,
    elevation: 4471,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HCMI": {
    icao: "HCMI",
    iata: "BBO",
    name: "Berbera Airport",
    city: "Berbera",
    country: "SO",
    continent: "AF",
    lat: 10.385,
    lon: 44.9367,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HCMK": {
    icao: "HCMK",
    iata: "KMU",
    name: "Kismayo Airport",
    city: "Kismayo",
    country: "SO",
    continent: "AF",
    lat: -0.3774,
    lon: 42.4592,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HCMM": {
    icao: "HCMM",
    iata: "MGQ",
    name: "Aden Adde International Airport",
    city: "Mogadishu",
    country: "SO",
    continent: "AF",
    lat: 2.0144,
    lon: 45.3047,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HDAM": {
    icao: "HDAM",
    iata: "JIB",
    name: "Djibouti-Ambouli Airport",
    city: "Djibouti City",
    country: "DJ",
    continent: "AF",
    lat: 11.5473,
    lon: 43.1595,
    elevation: 49,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HE16": {
    icao: "HE16",
    iata: "",
    name: "Birma Air Base",
    city: "Tanta",
    country: "EG",
    continent: "AF",
    lat: 30.8366,
    lon: 30.936,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HE28": {
    icao: "HE28",
    iata: "",
    name: "Gebel El Basur Air Base",
    city: "Markaz Ad Delingat",
    country: "EG",
    continent: "AF",
    lat: 30.5405,
    lon: 30.5602,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HE32": {
    icao: "HE32",
    iata: "",
    name: "Al Mansurah Airbase",
    city: "Mansoura",
    country: "EG",
    continent: "AF",
    lat: 30.9676,
    lon: 31.4342,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HE35": {
    icao: "HE35",
    iata: "",
    name: "Abu Suwayr Air Base",
    city: "Abu Suwayr",
    country: "EG",
    continent: "AF",
    lat: 30.5727,
    lon: 32.0953,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HE36": {
    icao: "HE36",
    iata: "RDL",
    name: "Bardawil International Airport",
    city: "El Hassana",
    country: "EG",
    continent: "AS",
    lat: 30.4107,
    lon: 33.1553,
    elevation: 1060,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HE37": {
    icao: "HE37",
    iata: "",
    name: "Bilbeis Air Base",
    city: "Bilbeis",
    country: "EG",
    continent: "AF",
    lat: 30.3949,
    lon: 31.6014,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HE42": {
    icao: "HE42",
    iata: "",
    name: "Quesna Airport",
    city: "Quesna",
    country: "EG",
    continent: "AF",
    lat: 30.579,
    lon: 31.1292,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEAL": {
    icao: "HEAL",
    iata: "DBB",
    name: "El Alamein International Airport",
    city: "El Alamein",
    country: "EG",
    continent: "AF",
    lat: 30.9243,
    lon: 28.4616,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEAR": {
    icao: "HEAR",
    iata: "AAC",
    name: "El Arish International Airport",
    city: "El Arish",
    country: "EG",
    continent: "AS",
    lat: 31.0786,
    lon: 33.8368,
    elevation: 118,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEAT": {
    icao: "HEAT",
    iata: "ATZ",
    name: "Asyut International Airport",
    city: "Asyut",
    country: "EG",
    continent: "AF",
    lat: 27.0508,
    lon: 31.0163,
    elevation: 748,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEAZ": {
    icao: "HEAZ",
    iata: "",
    name: "Almaza Air Force Base",
    city: "El Nozha",
    country: "EG",
    continent: "AF",
    lat: 30.0917,
    lon: 31.3597,
    elevation: 246,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEBA": {
    icao: "HEBA",
    iata: "HBE",
    name: "Alexandria International Airport",
    city: "Alexandria",
    country: "EG",
    continent: "AF",
    lat: 30.9325,
    lon: 29.6964,
    elevation: 171,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HEBL": {
    icao: "HEBL",
    iata: "ABS",
    name: "Abu Simbel Airport",
    city: "Abu Simbel",
    country: "EG",
    continent: "AF",
    lat: 22.3677,
    lon: 31.61,
    elevation: 614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEBS": {
    icao: "HEBS",
    iata: "",
    name: "Bani Sweif Air Base",
    city: "Bani Sweif",
    country: "EG",
    continent: "AF",
    lat: 29.2022,
    lon: 31.0135,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HECA": {
    icao: "HECA",
    iata: "CAI",
    name: "Cairo International Airport",
    city: "Cairo",
    country: "EG",
    continent: "AF",
    lat: 30.1115,
    lon: 31.3967,
    elevation: 322,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HECP": {
    icao: "HECP",
    iata: "CCE",
    name: "Capital International Airport",
    city: "New Cairo",
    country: "EG",
    continent: "AF",
    lat: 30.0743,
    lon: 31.843,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HECW": {
    icao: "HECW",
    iata: "",
    name: "Cairo West Air Base",
    city: "Cairo",
    country: "EG",
    continent: "AF",
    lat: 30.1164,
    lon: 30.9155,
    elevation: 557,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEGN": {
    icao: "HEGN",
    iata: "HRG",
    name: "Hurghada International Airport",
    city: "Hurghada",
    country: "EG",
    continent: "AF",
    lat: 27.1768,
    lon: 33.7967,
    elevation: 32,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HEGR": {
    icao: "HEGR",
    iata: "EGH",
    name: "El Jora Airport",
    city: "El Jora",
    country: "EG",
    continent: "AS",
    lat: 31.0781,
    lon: 34.1531,
    elevation: 331,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEGS": {
    icao: "HEGS",
    iata: "",
    name: "Jiyanklis Air Base",
    city: "Abu El Matamir",
    country: "EG",
    continent: "AF",
    lat: 30.8198,
    lon: 30.1912,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEIS": {
    icao: "HEIS",
    iata: "",
    name: "Ismailia Air Base",
    city: "Ismailia",
    country: "EG",
    continent: "AF",
    lat: 30.598,
    lon: 32.2357,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HELX": {
    icao: "HELX",
    iata: "LXR",
    name: "Luxor International Airport",
    city: "Luxor",
    country: "EG",
    continent: "AF",
    lat: 25.671,
    lon: 32.7065,
    elevation: 276,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEMA": {
    icao: "HEMA",
    iata: "RMF",
    name: "Marsa Alam International Airport",
    city: "Marsa Alam",
    country: "EG",
    continent: "AF",
    lat: 25.5555,
    lon: 34.5924,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEMM": {
    icao: "HEMM",
    iata: "MUH",
    name: "Marsa Matruh International Airport",
    city: "Marsa Matruh",
    country: "EG",
    continent: "AF",
    lat: 31.3255,
    lon: 27.2217,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HEPS": {
    icao: "HEPS",
    iata: "PSD",
    name: "Port Said International Airport",
    city: "Port Said",
    country: "EG",
    continent: "AF",
    lat: 31.2793,
    lon: 32.2406,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HESC": {
    icao: "HESC",
    iata: "SKV",
    name: "Saint Catherine International Airport",
    city: "Saint Catherine",
    country: "EG",
    continent: "AS",
    lat: 28.6846,
    lon: 34.0627,
    elevation: 4402,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HESG": {
    icao: "HESG",
    iata: "HMB",
    name: "Sohag International Airport",
    city: "Suhaj",
    country: "EG",
    continent: "AF",
    lat: 26.3425,
    lon: 31.743,
    elevation: 322,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HESH": {
    icao: "HESH",
    iata: "SSH",
    name: "Sharm El Sheikh International Airport",
    city: "Sharm El Sheikh",
    country: "EG",
    continent: "AS",
    lat: 27.9773,
    lon: 34.3947,
    elevation: 191,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HESN": {
    icao: "HESN",
    iata: "ASW",
    name: "Aswan International Airport",
    city: "Aswan",
    country: "EG",
    continent: "AF",
    lat: 23.9681,
    lon: 32.8244,
    elevation: 650,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HESX": {
    icao: "HESX",
    iata: "SPX",
    name: "Sphinx International Airport",
    city: "Al Jiza",
    country: "EG",
    continent: "AF",
    lat: 30.1082,
    lon: 30.8957,
    elevation: 510,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HETB": {
    icao: "HETB",
    iata: "TCP",
    name: "Taba International Airport",
    city: "Taba",
    country: "EG",
    continent: "AS",
    lat: 29.5945,
    lon: 34.7758,
    elevation: 2425,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HHAS": {
    icao: "HHAS",
    iata: "ASM",
    name: "Asmara International Airport",
    city: "Asmara",
    country: "ER",
    continent: "AF",
    lat: 15.2919,
    lon: 38.9107,
    elevation: 7661,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HHMS": {
    icao: "HHMS",
    iata: "MSW",
    name: "Massawa International Airport",
    city: "Massawa",
    country: "ER",
    continent: "AF",
    lat: 15.67,
    lon: 39.3701,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HHSB": {
    icao: "HHSB",
    iata: "ASA",
    name: "Assab International Airport",
    city: "Assab",
    country: "ER",
    continent: "AF",
    lat: 13.0718,
    lon: 42.645,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HJJJ": {
    icao: "HJJJ",
    iata: "JUB",
    name: "Juba International Airport",
    city: "Juba",
    country: "SS",
    continent: "AF",
    lat: 4.872,
    lon: 31.6011,
    elevation: 1513,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HKAM": {
    icao: "HKAM",
    iata: "ASV",
    name: "Amboseli Airport",
    city: "Amboseli National Park",
    country: "KE",
    continent: "AF",
    lat: -2.6451,
    lon: 37.2531,
    elevation: 3755,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKEL": {
    icao: "HKEL",
    iata: "EDL",
    name: "Eldoret International Airport",
    city: "Eldoret",
    country: "KE",
    continent: "AF",
    lat: 0.4045,
    lon: 35.2389,
    elevation: 6941,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKJK": {
    icao: "HKJK",
    iata: "NBO",
    name: "Jomo Kenyatta International Airport",
    city: "Nairobi",
    country: "KE",
    continent: "AF",
    lat: -1.3192,
    lon: 36.9278,
    elevation: 5330,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HKKI": {
    icao: "HKKI",
    iata: "KIS",
    name: "Kisumu Airport",
    city: "Kisumu",
    country: "KE",
    continent: "AF",
    lat: -0.0861,
    lon: 34.7289,
    elevation: 3734,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKKT": {
    icao: "HKKT",
    iata: "KTL",
    name: "Kitale Airport",
    city: "Kitale",
    country: "KE",
    continent: "AF",
    lat: 0.972,
    lon: 34.9586,
    elevation: 6070,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKLK": {
    icao: "HKLK",
    iata: "LKG",
    name: "Lokichogio Airport",
    city: "Lokichogio",
    country: "KE",
    continent: "AF",
    lat: 4.2041,
    lon: 34.3482,
    elevation: 2074,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKLO": {
    icao: "HKLO",
    iata: "LOK",
    name: "Lodwar Airport",
    city: "Lodwar",
    country: "KE",
    continent: "AF",
    lat: 3.122,
    lon: 35.6087,
    elevation: 1715,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKLU": {
    icao: "HKLU",
    iata: "LAU",
    name: "Manda Airport",
    city: "Lamu",
    country: "KE",
    continent: "AF",
    lat: -2.2524,
    lon: 40.9129,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKML": {
    icao: "HKML",
    iata: "MYD",
    name: "Malindi Airport",
    city: "Malindi",
    country: "KE",
    continent: "AF",
    lat: -3.2293,
    lon: 40.1017,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKMO": {
    icao: "HKMO",
    iata: "MBA",
    name: "Moi International Airport",
    city: "Mombasa",
    country: "KE",
    continent: "AF",
    lat: -4.0348,
    lon: 39.5942,
    elevation: 200,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HKMS": {
    icao: "HKMS",
    iata: "MRE",
    name: "Mara Serena Lodge Airstrip",
    city: "Masai Mara",
    country: "KE",
    continent: "AF",
    lat: -1.4061,
    lon: 35.0081,
    elevation: 5200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKNL": {
    icao: "HKNL",
    iata: "NYK",
    name: "Nanyuki Airport",
    city: "Nanyuki",
    country: "KE",
    continent: "AF",
    lat: -0.0624,
    lon: 37.041,
    elevation: 6250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKNW": {
    icao: "HKNW",
    iata: "WIL",
    name: "Nairobi Wilson Airport",
    city: "Nairobi",
    country: "KE",
    continent: "AF",
    lat: -1.3217,
    lon: 36.8148,
    elevation: 5536,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKNY": {
    icao: "HKNY",
    iata: "",
    name: "Laikipia Air Base",
    city: "Nanyuki",
    country: "KE",
    continent: "AF",
    lat: 0.0329,
    lon: 37.0269,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKRE": {
    icao: "HKRE",
    iata: "",
    name: "Moi Air Base",
    city: "Nairobi",
    country: "KE",
    continent: "AF",
    lat: -1.2773,
    lon: 36.8623,
    elevation: 5336,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HKWJ": {
    icao: "HKWJ",
    iata: "WJR",
    name: "Wajir Airport",
    city: "Wajir",
    country: "KE",
    continent: "AF",
    lat: 1.7332,
    lon: 40.0916,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HL56": {
    icao: "HL56",
    iata: "",
    name: "Matan al-Sarra Air Base",
    city: "",
    country: "LY",
    continent: "AF",
    lat: 21.6877,
    lon: 21.8309,
    elevation: 1769,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HL68": {
    icao: "HL68",
    iata: "",
    name: "Bombah Airport",
    city: "Bombah",
    country: "LY",
    continent: "AF",
    lat: 32.4529,
    lon: 23.1186,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HL77": {
    icao: "HL77",
    iata: "",
    name: "Okba Ibn Nafa Air Base",
    city: "",
    country: "LY",
    continent: "AF",
    lat: 32.4734,
    lon: 11.8979,
    elevation: 253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLGD": {
    icao: "HLGD",
    iata: "SRX",
    name: "Sirt International Airport / Ghardabiya Airbase",
    city: "Sirt",
    country: "LY",
    continent: "AF",
    lat: 31.0635,
    lon: 16.595,
    elevation: 267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLGT": {
    icao: "HLGT",
    iata: "GHT",
    name: "Ghat Airport",
    city: "Ghat",
    country: "LY",
    continent: "AF",
    lat: 25.1456,
    lon: 10.1426,
    elevation: 2296,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLKF": {
    icao: "HLKF",
    iata: "AKF",
    name: "Kufra Airport",
    city: "Kufra",
    country: "LY",
    continent: "AF",
    lat: 24.1787,
    lon: 23.314,
    elevation: 1367,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLLB": {
    icao: "HLLB",
    iata: "BEN",
    name: "Benina International Airport",
    city: "Benina",
    country: "LY",
    continent: "AF",
    lat: 32.0968,
    lon: 20.2695,
    elevation: 433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLLM": {
    icao: "HLLM",
    iata: "MJI",
    name: "Mitiga International Airport",
    city: "Tripoli",
    country: "LY",
    continent: "AF",
    lat: 32.8918,
    lon: 13.2879,
    elevation: 36,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HLLQ": {
    icao: "HLLQ",
    iata: "LAQ",
    name: "Al Abraq International Airport",
    city: "Al Albraq",
    country: "LY",
    continent: "AF",
    lat: 32.7887,
    lon: 21.9643,
    elevation: 2157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLLS": {
    icao: "HLLS",
    iata: "SEB",
    name: "Sabha Airport",
    city: "Sabha",
    country: "LY",
    continent: "AF",
    lat: 26.9925,
    lon: 14.4662,
    elevation: 1427,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLMB": {
    icao: "HLMB",
    iata: "LMQ",
    name: "Marsa al Brega Airport",
    city: "Marsa al Brega",
    country: "LY",
    continent: "AF",
    lat: 30.3781,
    lon: 19.5764,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HLTD": {
    icao: "HLTD",
    iata: "LTD",
    name: "Ghadames East Airport",
    city: "Ghadames",
    country: "LY",
    continent: "AF",
    lat: 30.1517,
    lon: 9.7153,
    elevation: 1122,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HRYG": {
    icao: "HRYG",
    iata: "GYI",
    name: "Gisenyi Airport",
    city: "Gisenyi",
    country: "RW",
    continent: "AF",
    lat: -1.6772,
    lon: 29.2589,
    elevation: 5082,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HRYR": {
    icao: "HRYR",
    iata: "KGL",
    name: "Kigali International Airport",
    city: "Kigali",
    country: "RW",
    continent: "AF",
    lat: -1.9686,
    lon: 30.1395,
    elevation: 4859,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HRZA": {
    icao: "HRZA",
    iata: "KME",
    name: "Kamembe Airport",
    city: "Kamembe",
    country: "RW",
    continent: "AF",
    lat: -2.4622,
    lon: 28.9079,
    elevation: 5192,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSDN": {
    icao: "HSDN",
    iata: "DOG",
    name: "Dongola Airport",
    city: "Dongola",
    country: "SD",
    continent: "AF",
    lat: 19.1539,
    lon: 30.4301,
    elevation: 772,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSFA": {
    icao: "HSFA",
    iata: "",
    name: "Paloich Airport",
    city: "Higleig",
    country: "SS",
    continent: "AF",
    lat: 10.5292,
    lon: 32.5006,
    elevation: 1290,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSFS": {
    icao: "HSFS",
    iata: "ELF",
    name: "El Fasher Airport",
    city: "El Fasher",
    country: "SD",
    continent: "AF",
    lat: 13.6149,
    lon: 25.3246,
    elevation: 2393,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSKA": {
    icao: "HSKA",
    iata: "KSL",
    name: "Kassala Airport",
    city: "Kassala",
    country: "SD",
    continent: "AF",
    lat: 15.3875,
    lon: 36.3288,
    elevation: 1671,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSMN": {
    icao: "HSMN",
    iata: "MWE",
    name: "Merowe Airport",
    city: "Merowe",
    country: "SD",
    continent: "AF",
    lat: 18.4433,
    lon: 31.8433,
    elevation: 897,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSNN": {
    icao: "HSNN",
    iata: "UYL",
    name: "Nyala Airport",
    city: "Nyala",
    country: "SD",
    continent: "AF",
    lat: 12.0535,
    lon: 24.9562,
    elevation: 2106,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSOB": {
    icao: "HSOB",
    iata: "EBD",
    name: "El-Obeid Airport",
    city: "El-Obeid",
    country: "SD",
    continent: "AF",
    lat: 13.1532,
    lon: 30.2327,
    elevation: 1927,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSPN": {
    icao: "HSPN",
    iata: "PZU",
    name: "Port Sudan New International Airport",
    city: "Port Sudan",
    country: "SD",
    continent: "AF",
    lat: 19.4336,
    lon: 37.2341,
    elevation: 135,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSSG": {
    icao: "HSSG",
    iata: "",
    name: "Sabera Geneina Airport",
    city: "Geneina",
    country: "SD",
    continent: "AF",
    lat: 13.4774,
    lon: 22.5372,
    elevation: 2633,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSSK": {
    icao: "HSSK",
    iata: "KRT",
    name: "Khartoum International Airport",
    city: "Khartoum",
    country: "SD",
    continent: "AF",
    lat: 15.5895,
    lon: 32.5532,
    elevation: 1265,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HSSM": {
    icao: "HSSM",
    iata: "MAK",
    name: "Malakal Airport",
    city: "Malakal",
    country: "SS",
    continent: "AF",
    lat: 9.559,
    lon: 31.6522,
    elevation: 1291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HSWW": {
    icao: "HSWW",
    iata: "WUU",
    name: "Wau Airport",
    city: "Wau",
    country: "SS",
    continent: "AF",
    lat: 7.7258,
    lon: 27.975,
    elevation: 1529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTAR": {
    icao: "HTAR",
    iata: "ARK",
    name: "Arusha Airport",
    city: "Arusha",
    country: "TZ",
    continent: "AF",
    lat: -3.3678,
    lon: 36.6333,
    elevation: 4550,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTDA": {
    icao: "HTDA",
    iata: "DAR",
    name: "Julius Nyerere International Airport",
    city: "Dar es Salaam",
    country: "TZ",
    continent: "AF",
    lat: -6.8781,
    lon: 39.2026,
    elevation: 182,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HTDO": {
    icao: "HTDO",
    iata: "DOD",
    name: "Dodoma Airport",
    city: "Dodoma",
    country: "TZ",
    continent: "AF",
    lat: -6.1704,
    lon: 35.7526,
    elevation: 3673,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTGW": {
    icao: "HTGW",
    iata: "MBI",
    name: "Songwe Airport",
    city: "Mbeya",
    country: "TZ",
    continent: "AF",
    lat: -8.9199,
    lon: 33.274,
    elevation: 4412,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTIR": {
    icao: "HTIR",
    iata: "IRI",
    name: "Iringa Airport",
    city: "Nduli",
    country: "TZ",
    continent: "AF",
    lat: -7.6686,
    lon: 35.7521,
    elevation: 4678,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTKJ": {
    icao: "HTKJ",
    iata: "JRO",
    name: "Kilimanjaro International Airport",
    city: "Arusha",
    country: "TZ",
    continent: "AF",
    lat: -3.4294,
    lon: 37.0745,
    elevation: 2932,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTLM": {
    icao: "HTLM",
    iata: "LKY",
    name: "Lake Manyara Airport",
    city: "Lake Manyara National Park",
    country: "TZ",
    continent: "AF",
    lat: -3.3763,
    lon: 35.8183,
    elevation: 4150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTMT": {
    icao: "HTMT",
    iata: "MYW",
    name: "Mtwara Airport",
    city: "Mtwara",
    country: "TZ",
    continent: "AF",
    lat: -10.3362,
    lon: 40.182,
    elevation: 371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTMW": {
    icao: "HTMW",
    iata: "MWZ",
    name: "Mwanza Airport",
    city: "Mwanza",
    country: "TZ",
    continent: "AF",
    lat: -2.4445,
    lon: 32.9327,
    elevation: 3763,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTPE": {
    icao: "HTPE",
    iata: "PMA",
    name: "Pemba Airport",
    city: "Chake Chake",
    country: "TZ",
    continent: "AF",
    lat: -5.2573,
    lon: 39.8114,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTTG": {
    icao: "HTTG",
    iata: "TGT",
    name: "Tanga Airport",
    city: "Tanga",
    country: "TZ",
    continent: "AF",
    lat: -5.0924,
    lon: 39.0712,
    elevation: 129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HTZA": {
    icao: "HTZA",
    iata: "ZNZ",
    name: "Abeid Amani Karume International Airport",
    city: "Zanzibar",
    country: "TZ",
    continent: "AF",
    lat: -6.222,
    lon: 39.2249,
    elevation: 54,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HUAR": {
    icao: "HUAR",
    iata: "RUA",
    name: "Arua Airport",
    city: "Arua",
    country: "UG",
    continent: "AF",
    lat: 3.0492,
    lon: 30.9117,
    elevation: 3951,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HUEN": {
    icao: "HUEN",
    iata: "EBB",
    name: "Entebbe International Airport",
    city: "Kampala",
    country: "UG",
    continent: "AF",
    lat: 0.0424,
    lon: 32.4435,
    elevation: 3782,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "HUGU": {
    icao: "HUGU",
    iata: "ULU",
    name: "Gulu Airport",
    city: "Gulu",
    country: "UG",
    continent: "AF",
    lat: 2.8056,
    lon: 32.2718,
    elevation: 3510,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "HUSO": {
    icao: "HUSO",
    iata: "SRT",
    name: "Soroti Airport",
    city: "Soroti",
    country: "UG",
    continent: "AF",
    lat: 1.7277,
    lon: 33.6228,
    elevation: 3697,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "K61B": {
    icao: "K61B",
    iata: "BLD",
    name: "Boulder City Municipal Airport",
    city: "Boulder City",
    country: "US",
    continent: "NA",
    lat: 35.9472,
    lon: -114.8588,
    elevation: 2201,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "K67L": {
    icao: "K67L",
    iata: "MFH",
    name: "Mesquite Airport",
    city: "Mesquite",
    country: "US",
    continent: "NA",
    lat: 36.8331,
    lon: -114.0559,
    elevation: 1978,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "K76F": {
    icao: "K76F",
    iata: "",
    name: "Van Zandt County Regional Airport",
    city: "Wills Point",
    country: "US",
    continent: "NA",
    lat: 32.6815,
    lon: -95.9841,
    elevation: 518,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "K79J": {
    icao: "K79J",
    iata: "",
    name: "South Alabama Regional At Bill Benton Field Airport",
    city: "Andalusia/Opp",
    country: "US",
    continent: "NA",
    lat: 31.3088,
    lon: -86.3938,
    elevation: 310,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KABE": {
    icao: "KABE",
    iata: "ABE",
    name: "Lehigh Valley International Airport",
    city: "Allentown",
    country: "US",
    continent: "NA",
    lat: 40.6518,
    lon: -75.4428,
    elevation: 393,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KABI": {
    icao: "KABI",
    iata: "ABI",
    name: "Abilene Regional Airport",
    city: "Abilene",
    country: "US",
    continent: "NA",
    lat: 32.4113,
    lon: -99.6819,
    elevation: 1791,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KABQ": {
    icao: "KABQ",
    iata: "ABQ",
    name: "Albuquerque International Sunport",
    city: "Albuquerque",
    country: "US",
    continent: "NA",
    lat: 35.04,
    lon: -106.6089,
    elevation: 5355,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KABR": {
    icao: "KABR",
    iata: "ABR",
    name: "Aberdeen Regional Airport",
    city: "Aberdeen",
    country: "US",
    continent: "NA",
    lat: 45.4491,
    lon: -98.4218,
    elevation: 1302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KABY": {
    icao: "KABY",
    iata: "ABY",
    name: "Southwest Georgia Regional Airport",
    city: "Albany",
    country: "US",
    continent: "NA",
    lat: 31.5329,
    lon: -84.1962,
    elevation: 197,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KACK": {
    icao: "KACK",
    iata: "ACK",
    name: "Nantucket Memorial Airport",
    city: "Nantucket",
    country: "US",
    continent: "NA",
    lat: 41.2531,
    lon: -70.0602,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KACT": {
    icao: "KACT",
    iata: "ACT",
    name: "Waco Regional Airport",
    city: "Waco",
    country: "US",
    continent: "NA",
    lat: 31.6113,
    lon: -97.2305,
    elevation: 516,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KACV": {
    icao: "KACV",
    iata: "ACV",
    name: "California Redwood Coast-Humboldt County Airport",
    city: "Arcata/Eureka",
    country: "US",
    continent: "NA",
    lat: 40.9781,
    lon: -124.109,
    elevation: 221,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KACY": {
    icao: "KACY",
    iata: "ACY",
    name: "Atlantic City International Airport",
    city: "Atlantic City",
    country: "US",
    continent: "NA",
    lat: 39.4576,
    lon: -74.5772,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KADH": {
    icao: "KADH",
    iata: "ADT",
    name: "Ada Regional Airport",
    city: "Ada",
    country: "US",
    continent: "NA",
    lat: 34.8052,
    lon: -96.672,
    elevation: 1016,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KADW": {
    icao: "KADW",
    iata: "ADW",
    name: "Joint Base Andrews",
    city: "Camp Springs",
    country: "US",
    continent: "NA",
    lat: 38.8108,
    lon: -76.867,
    elevation: 280,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KAEX": {
    icao: "KAEX",
    iata: "AEX",
    name: "Alexandria International Airport",
    city: "Alexandria",
    country: "US",
    continent: "NA",
    lat: 31.3274,
    lon: -92.5498,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAFW": {
    icao: "KAFW",
    iata: "AFW",
    name: "Perot Field/Fort Worth Alliance Airport",
    city: "Fort Worth",
    country: "US",
    continent: "NA",
    lat: 32.9904,
    lon: -97.3195,
    elevation: 722,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAGC": {
    icao: "KAGC",
    iata: "AGC",
    name: "Allegheny County Airport",
    city: "Pittsburgh",
    country: "US",
    continent: "NA",
    lat: 40.3544,
    lon: -79.9302,
    elevation: 1252,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAGS": {
    icao: "KAGS",
    iata: "AGS",
    name: "Augusta Regional At Bush Field",
    city: "Augusta",
    country: "US",
    continent: "NA",
    lat: 33.3699,
    lon: -81.9645,
    elevation: 144,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAHN": {
    icao: "KAHN",
    iata: "AHN",
    name: "Athens Ben Epps Airport",
    city: "Athens",
    country: "US",
    continent: "NA",
    lat: 33.9488,
    lon: -83.3256,
    elevation: 808,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAIA": {
    icao: "KAIA",
    iata: "AIA",
    name: "Alliance Municipal Airport",
    city: "Alliance",
    country: "US",
    continent: "NA",
    lat: 42.0525,
    lon: -102.804,
    elevation: 3931,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAKR": {
    icao: "KAKR",
    iata: "AKC",
    name: "Akron Fulton International Airport",
    city: "Akron",
    country: "US",
    continent: "NA",
    lat: 41.0374,
    lon: -81.4678,
    elevation: 1067,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALB": {
    icao: "KALB",
    iata: "ALB",
    name: "Albany International Airport",
    city: "Albany",
    country: "US",
    continent: "NA",
    lat: 42.7483,
    lon: -73.8017,
    elevation: 285,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALI": {
    icao: "KALI",
    iata: "ALI",
    name: "Alice International Airport",
    city: "Alice",
    country: "US",
    continent: "NA",
    lat: 27.7409,
    lon: -98.0269,
    elevation: 178,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALM": {
    icao: "KALM",
    iata: "ALM",
    name: "Alamogordo White Sands Regional Airport",
    city: "Alamogordo",
    country: "US",
    continent: "NA",
    lat: 32.8378,
    lon: -105.9931,
    elevation: 4200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALN": {
    icao: "KALN",
    iata: "ALN",
    name: "St Louis Regional Airport",
    city: "Alton/St Louis",
    country: "US",
    continent: "NA",
    lat: 38.8903,
    lon: -90.046,
    elevation: 544,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALO": {
    icao: "KALO",
    iata: "ALO",
    name: "Waterloo Regional Airport",
    city: "Waterloo",
    country: "US",
    continent: "NA",
    lat: 42.5571,
    lon: -92.4003,
    elevation: 873,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALS": {
    icao: "KALS",
    iata: "ALS",
    name: "San Luis Valley Regional Airport/Bergman Field",
    city: "Alamosa",
    country: "US",
    continent: "NA",
    lat: 37.4349,
    lon: -105.867,
    elevation: 7539,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KALW": {
    icao: "KALW",
    iata: "ALW",
    name: "Walla Walla Regional Airport",
    city: "Walla Walla",
    country: "US",
    continent: "NA",
    lat: 46.0949,
    lon: -118.288,
    elevation: 1194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAMA": {
    icao: "KAMA",
    iata: "AMA",
    name: "Rick Husband Amarillo International Airport",
    city: "Amarillo",
    country: "US",
    continent: "NA",
    lat: 35.2194,
    lon: -101.706,
    elevation: 3607,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KANB": {
    icao: "KANB",
    iata: "ANB",
    name: "Anniston Regional Airport",
    city: "Anniston",
    country: "US",
    continent: "NA",
    lat: 33.5882,
    lon: -85.8581,
    elevation: 612,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAND": {
    icao: "KAND",
    iata: "AND",
    name: "Anderson Regional Airport",
    city: "Anderson",
    country: "US",
    continent: "NA",
    lat: 34.4946,
    lon: -82.7094,
    elevation: 782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAOO": {
    icao: "KAOO",
    iata: "AOO",
    name: "Altoona Blair County Airport",
    city: "Altoona",
    country: "US",
    continent: "NA",
    lat: 40.2964,
    lon: -78.32,
    elevation: 1503,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAPA": {
    icao: "KAPA",
    iata: "APA",
    name: "Centennial Airport",
    city: "Denver",
    country: "US",
    continent: "NA",
    lat: 39.5701,
    lon: -104.849,
    elevation: 5885,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAPF": {
    icao: "KAPF",
    iata: "APF",
    name: "Naples Municipal Airport",
    city: "Naples",
    country: "US",
    continent: "NA",
    lat: 26.1526,
    lon: -81.7753,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAPG": {
    icao: "KAPG",
    iata: "APG",
    name: "Phillips Army Air Field",
    city: "Aberdeen",
    country: "US",
    continent: "NA",
    lat: 39.4662,
    lon: -76.1688,
    elevation: 57,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAPN": {
    icao: "KAPN",
    iata: "APN",
    name: "Alpena County Regional Airport",
    city: "Alpena",
    country: "US",
    continent: "NA",
    lat: 45.0781,
    lon: -83.5603,
    elevation: 690,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KARA": {
    icao: "KARA",
    iata: "ARA",
    name: "Acadiana Regional Airport",
    city: "New Iberia",
    country: "US",
    continent: "NA",
    lat: 30.0378,
    lon: -91.8839,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KART": {
    icao: "KART",
    iata: "ART",
    name: "Watertown International Airport",
    city: "Watertown",
    country: "US",
    continent: "NA",
    lat: 43.9919,
    lon: -76.0217,
    elevation: 325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KASE": {
    icao: "KASE",
    iata: "ASE",
    name: "Aspen-Pitkin County Airport (Sardy Field)",
    city: "Aspen",
    country: "US",
    continent: "NA",
    lat: 39.2232,
    lon: -106.869,
    elevation: 7820,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAST": {
    icao: "KAST",
    iata: "AST",
    name: "Astoria Regional Airport",
    city: "Astoria",
    country: "US",
    continent: "NA",
    lat: 46.158,
    lon: -123.879,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KATL": {
    icao: "KATL",
    iata: "ATL",
    name: "Hartsfield Jackson Atlanta International Airport",
    city: "Atlanta",
    country: "US",
    continent: "NA",
    lat: 33.6367,
    lon: -84.4281,
    elevation: 1026,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KATW": {
    icao: "KATW",
    iata: "ATW",
    name: "Appleton International Airport",
    city: "Appleton",
    country: "US",
    continent: "NA",
    lat: 44.2581,
    lon: -88.5191,
    elevation: 918,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KATY": {
    icao: "KATY",
    iata: "ATY",
    name: "Watertown Regional Airport",
    city: "Watertown",
    country: "US",
    continent: "NA",
    lat: 44.914,
    lon: -97.1547,
    elevation: 1749,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAUG": {
    icao: "KAUG",
    iata: "AUG",
    name: "Augusta State Airport",
    city: "Augusta",
    country: "US",
    continent: "NA",
    lat: 44.3206,
    lon: -69.7973,
    elevation: 352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAUS": {
    icao: "KAUS",
    iata: "AUS",
    name: "Austin Bergstrom International Airport",
    city: "Austin",
    country: "US",
    continent: "NA",
    lat: 30.1975,
    lon: -97.662,
    elevation: 542,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KAUW": {
    icao: "KAUW",
    iata: "AUW",
    name: "Wausau Downtown Airport",
    city: "Wausau",
    country: "US",
    continent: "NA",
    lat: 44.9262,
    lon: -89.6266,
    elevation: 1201,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAVL": {
    icao: "KAVL",
    iata: "AVL",
    name: "Asheville Regional Airport",
    city: "Asheville",
    country: "US",
    continent: "NA",
    lat: 35.4362,
    lon: -82.5418,
    elevation: 2165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAVP": {
    icao: "KAVP",
    iata: "AVP",
    name: "Wilkes Barre Scranton International Airport",
    city: "Wilkes-Barre/Scranton",
    country: "US",
    continent: "NA",
    lat: 41.3385,
    lon: -75.7234,
    elevation: 962,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAWO": {
    icao: "KAWO",
    iata: "",
    name: "Arlington Municipal Airport",
    city: "Arlington",
    country: "US",
    continent: "NA",
    lat: 48.1614,
    lon: -122.1584,
    elevation: 142,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAXN": {
    icao: "KAXN",
    iata: "AXN",
    name: "Chandler Field",
    city: "Alexandria",
    country: "US",
    continent: "NA",
    lat: 45.8663,
    lon: -95.3947,
    elevation: 1425,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KAZO": {
    icao: "KAZO",
    iata: "AZO",
    name: "Kalamazoo Battle Creek International Airport",
    city: "Kalamazoo",
    country: "US",
    continent: "NA",
    lat: 42.2349,
    lon: -85.5521,
    elevation: 874,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBAB": {
    icao: "KBAB",
    iata: "BAB",
    name: "Beale Air Force Base",
    city: "Beale Air Force Base",
    country: "US",
    continent: "NA",
    lat: 39.1361,
    lon: -121.437,
    elevation: 113,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBAD": {
    icao: "KBAD",
    iata: "BAD",
    name: "Barksdale Air Force Base",
    city: "Bossier City",
    country: "US",
    continent: "NA",
    lat: 32.5018,
    lon: -93.6627,
    elevation: 166,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBAF": {
    icao: "KBAF",
    iata: "BAF",
    name: "Westfield-Barnes Regional Airport",
    city: "Westfield",
    country: "US",
    continent: "NA",
    lat: 42.1578,
    lon: -72.7156,
    elevation: 271,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBAK": {
    icao: "KBAK",
    iata: "CLU",
    name: "Columbus Municipal Airport",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 39.2624,
    lon: -85.8956,
    elevation: 656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBAZ": {
    icao: "KBAZ",
    iata: "",
    name: "New Braunfels Municipal Airport",
    city: "New Braunfels",
    country: "US",
    continent: "NA",
    lat: 29.7045,
    lon: -98.0422,
    elevation: 651,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBBD": {
    icao: "KBBD",
    iata: "BBD",
    name: "Curtis Field",
    city: "Brady",
    country: "US",
    continent: "NA",
    lat: 31.1789,
    lon: -99.3247,
    elevation: 1827,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBBG": {
    icao: "KBBG",
    iata: "BKG",
    name: "Branson Airport",
    city: "Branson",
    country: "US",
    continent: "NA",
    lat: 36.5321,
    lon: -93.2005,
    elevation: 1302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBCE": {
    icao: "KBCE",
    iata: "BCE",
    name: "Bryce Canyon Airport",
    city: "Bryce Canyon",
    country: "US",
    continent: "NA",
    lat: 37.7064,
    lon: -112.145,
    elevation: 7590,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBCT": {
    icao: "KBCT",
    iata: "BCT",
    name: "Boca Raton Airport",
    city: "Boca Raton",
    country: "US",
    continent: "NA",
    lat: 26.3785,
    lon: -80.1077,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBDE": {
    icao: "KBDE",
    iata: "BDE",
    name: "Baudette International Airport",
    city: "Baudette",
    country: "US",
    continent: "NA",
    lat: 48.7284,
    lon: -94.6122,
    elevation: 1086,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBDL": {
    icao: "KBDL",
    iata: "BDL",
    name: "Bradley International Airport",
    city: "Hartford",
    country: "US",
    continent: "NA",
    lat: 41.9385,
    lon: -72.6881,
    elevation: 173,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KBDR": {
    icao: "KBDR",
    iata: "BDR",
    name: "Igor I Sikorsky Memorial Airport",
    city: "Bridgeport",
    country: "US",
    continent: "NA",
    lat: 41.1635,
    lon: -73.1262,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBED": {
    icao: "KBED",
    iata: "BED",
    name: "Laurence G Hanscom Field",
    city: "Bedford",
    country: "US",
    continent: "NA",
    lat: 42.47,
    lon: -71.289,
    elevation: 133,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBFD": {
    icao: "KBFD",
    iata: "BFD",
    name: "Bradford Regional Airport",
    city: "Bradford",
    country: "US",
    continent: "NA",
    lat: 41.8031,
    lon: -78.6401,
    elevation: 2143,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBFF": {
    icao: "KBFF",
    iata: "BFF",
    name: "Western Neb. Rgnl/William B. Heilig Airport",
    city: "Scottsbluff",
    country: "US",
    continent: "NA",
    lat: 41.874,
    lon: -103.596,
    elevation: 3967,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBFI": {
    icao: "KBFI",
    iata: "BFI",
    name: "Boeing Field King County International Airport",
    city: "Seattle",
    country: "US",
    continent: "NA",
    lat: 47.53,
    lon: -122.302,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBFL": {
    icao: "KBFL",
    iata: "BFL",
    name: "Meadows Field",
    city: "Bakersfield",
    country: "US",
    continent: "NA",
    lat: 35.4336,
    lon: -119.057,
    elevation: 510,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBFM": {
    icao: "KBFM",
    iata: "BFM",
    name: "Mobile Downtown Airport",
    city: "Mobile",
    country: "US",
    continent: "NA",
    lat: 30.6268,
    lon: -88.0681,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBGM": {
    icao: "KBGM",
    iata: "BGM",
    name: "Greater Binghamton/Edwin A Link field",
    city: "Binghamton",
    country: "US",
    continent: "NA",
    lat: 42.2087,
    lon: -75.9798,
    elevation: 1636,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBGR": {
    icao: "KBGR",
    iata: "BGR",
    name: "Bangor International Airport",
    city: "Bangor",
    country: "US",
    continent: "NA",
    lat: 44.8074,
    lon: -68.8281,
    elevation: 192,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBHB": {
    icao: "KBHB",
    iata: "BHB",
    name: "Hancock County-Bar Harbor Airport",
    city: "Bar Harbor",
    country: "US",
    continent: "NA",
    lat: 44.45,
    lon: -68.3615,
    elevation: 83,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBHM": {
    icao: "KBHM",
    iata: "BHM",
    name: "Birmingham-Shuttlesworth International Airport",
    city: "Birmingham",
    country: "US",
    continent: "NA",
    lat: 33.5629,
    lon: -86.7535,
    elevation: 650,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBIF": {
    icao: "KBIF",
    iata: "BIF",
    name: "Biggs Army Air Field (Fort Bliss)",
    city: "Fort Bliss/El Paso",
    country: "US",
    continent: "NA",
    lat: 31.8495,
    lon: -106.38,
    elevation: 3946,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBIH": {
    icao: "KBIH",
    iata: "BIH",
    name: "Eastern Sierra Regional Airport",
    city: "Bishop",
    country: "US",
    continent: "NA",
    lat: 37.3731,
    lon: -118.364,
    elevation: 4124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBIL": {
    icao: "KBIL",
    iata: "BIL",
    name: "Billings Logan International Airport",
    city: "Billings",
    country: "US",
    continent: "NA",
    lat: 45.8077,
    lon: -108.543,
    elevation: 3652,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBIS": {
    icao: "KBIS",
    iata: "BIS",
    name: "Bismarck Municipal Airport",
    city: "Bismarck",
    country: "US",
    continent: "NA",
    lat: 46.7727,
    lon: -100.746,
    elevation: 1661,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBIX": {
    icao: "KBIX",
    iata: "BIX",
    name: "Keesler Air Force Base",
    city: "Biloxi",
    country: "US",
    continent: "NA",
    lat: 30.4104,
    lon: -88.9244,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBJC": {
    icao: "KBJC",
    iata: "BJC",
    name: "Rocky Mountain Metropolitan Airport",
    city: "Denver",
    country: "US",
    continent: "NA",
    lat: 39.9088,
    lon: -105.117,
    elevation: 5673,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBJI": {
    icao: "KBJI",
    iata: "BJI",
    name: "Bemidji Regional Airport",
    city: "Bemidji",
    country: "US",
    continent: "NA",
    lat: 47.5094,
    lon: -94.9337,
    elevation: 1391,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBKE": {
    icao: "KBKE",
    iata: "BKE",
    name: "Baker City Municipal Airport",
    city: "Baker City",
    country: "US",
    continent: "NA",
    lat: 44.8373,
    lon: -117.809,
    elevation: 3373,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBKF": {
    icao: "KBKF",
    iata: "BFK",
    name: "Buckley Space Force Base",
    city: "Aurora",
    country: "US",
    continent: "NA",
    lat: 39.7017,
    lon: -104.752,
    elevation: 5662,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBKL": {
    icao: "KBKL",
    iata: "BKL",
    name: "Burke Lakefront Airport",
    city: "Cleveland",
    country: "US",
    continent: "NA",
    lat: 41.5175,
    lon: -81.6833,
    elevation: 583,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBKW": {
    icao: "KBKW",
    iata: "BKW",
    name: "Raleigh County Memorial Airport",
    city: "Beaver",
    country: "US",
    continent: "NA",
    lat: 37.7873,
    lon: -81.1242,
    elevation: 2504,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBLF": {
    icao: "KBLF",
    iata: "BLF",
    name: "Mercer County Airport",
    city: "Bluefield",
    country: "US",
    continent: "NA",
    lat: 37.2958,
    lon: -81.2077,
    elevation: 2857,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBLH": {
    icao: "KBLH",
    iata: "BLH",
    name: "Blythe Airport",
    city: "Blythe",
    country: "US",
    continent: "NA",
    lat: 33.6192,
    lon: -114.717,
    elevation: 399,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBLI": {
    icao: "KBLI",
    iata: "BLI",
    name: "Bellingham International Airport",
    city: "Bellingham",
    country: "US",
    continent: "NA",
    lat: 48.7928,
    lon: -122.538,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBLV": {
    icao: "KBLV",
    iata: "BLV",
    name: "Scott AFB/Midamerica Airport",
    city: "Belleville",
    country: "US",
    continent: "NA",
    lat: 38.5452,
    lon: -89.8352,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBMG": {
    icao: "KBMG",
    iata: "BMG",
    name: "Monroe County Airport",
    city: "Bloomington",
    country: "US",
    continent: "NA",
    lat: 39.146,
    lon: -86.6167,
    elevation: 846,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBMI": {
    icao: "KBMI",
    iata: "BMI",
    name: "Central Illinois Regional Airport at Bloomington-Normal",
    city: "Bloomington/Normal",
    country: "US",
    continent: "NA",
    lat: 40.4771,
    lon: -88.9159,
    elevation: 871,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBNA": {
    icao: "KBNA",
    iata: "BNA",
    name: "Nashville International Airport",
    city: "Nashville",
    country: "US",
    continent: "NA",
    lat: 36.1245,
    lon: -86.6782,
    elevation: 599,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KBNO": {
    icao: "KBNO",
    iata: "BNO",
    name: "Burns Municipal Airport",
    city: "Burns",
    country: "US",
    continent: "NA",
    lat: 43.5905,
    lon: -118.9552,
    elevation: 4148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBOI": {
    icao: "KBOI",
    iata: "BOI",
    name: "Boise Air Terminal/Gowen Field",
    city: "Boise",
    country: "US",
    continent: "NA",
    lat: 43.5644,
    lon: -116.223,
    elevation: 2871,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBOS": {
    icao: "KBOS",
    iata: "BOS",
    name: "Logan International Airport",
    city: "Boston",
    country: "US",
    continent: "NA",
    lat: 42.362,
    lon: -71.0079,
    elevation: 20,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KBPI": {
    icao: "KBPI",
    iata: "BPI",
    name: "Miley Memorial Field",
    city: "Big Piney",
    country: "US",
    continent: "NA",
    lat: 42.5851,
    lon: -110.111,
    elevation: 6990,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBPK": {
    icao: "KBPK",
    iata: "WMH",
    name: "Ozark Regional Airport",
    city: "Mountain Home",
    country: "US",
    continent: "NA",
    lat: 36.3689,
    lon: -92.4705,
    elevation: 928,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBPT": {
    icao: "KBPT",
    iata: "BPT",
    name: "Jack Brooks Regional Airport",
    city: "Beaumont/Port Arthur",
    country: "US",
    continent: "NA",
    lat: 29.9508,
    lon: -94.0207,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBQK": {
    icao: "KBQK",
    iata: "BQK",
    name: "Brunswick Golden Isles Airport",
    city: "Brunswick",
    country: "US",
    continent: "NA",
    lat: 31.2588,
    lon: -81.4665,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBRD": {
    icao: "KBRD",
    iata: "BRD",
    name: "Brainerd Lakes Regional Airport",
    city: "Brainerd",
    country: "US",
    continent: "NA",
    lat: 46.4029,
    lon: -94.1297,
    elevation: 1232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBRL": {
    icao: "KBRL",
    iata: "BRL",
    name: "Southeast Iowa Regional Airport",
    city: "Burlington",
    country: "US",
    continent: "NA",
    lat: 40.7832,
    lon: -91.1255,
    elevation: 698,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBRO": {
    icao: "KBRO",
    iata: "BRO",
    name: "Brownsville South Padre Island International Airport",
    city: "Brownsville",
    country: "US",
    continent: "NA",
    lat: 25.9068,
    lon: -97.4259,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBTL": {
    icao: "KBTL",
    iata: "BTL",
    name: "Battle Creek Executive Airport at Kellogg Field",
    city: "Battle Creek",
    country: "US",
    continent: "NA",
    lat: 42.3073,
    lon: -85.2515,
    elevation: 952,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBTM": {
    icao: "KBTM",
    iata: "BTM",
    name: "Bert Mooney Airport",
    city: "Butte",
    country: "US",
    continent: "NA",
    lat: 45.9548,
    lon: -112.497,
    elevation: 5550,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBTR": {
    icao: "KBTR",
    iata: "BTR",
    name: "Baton Rouge Metropolitan Airport",
    city: "Baton Rouge",
    country: "US",
    continent: "NA",
    lat: 30.5332,
    lon: -91.1496,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBTV": {
    icao: "KBTV",
    iata: "BTV",
    name: "Burlington International Airport",
    city: "South Burlington",
    country: "US",
    continent: "NA",
    lat: 44.4719,
    lon: -73.1533,
    elevation: 335,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBUF": {
    icao: "KBUF",
    iata: "BUF",
    name: "Buffalo Niagara International Airport",
    city: "Buffalo",
    country: "US",
    continent: "NA",
    lat: 42.9405,
    lon: -78.7322,
    elevation: 728,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KBUR": {
    icao: "KBUR",
    iata: "BUR",
    name: "Hollywood Burbank Airport",
    city: "Burbank",
    country: "US",
    continent: "NA",
    lat: 34.1977,
    lon: -118.3564,
    elevation: 778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBVI": {
    icao: "KBVI",
    iata: "BFP",
    name: "Beaver County Airport",
    city: "Beaver Falls",
    country: "US",
    continent: "NA",
    lat: 40.7725,
    lon: -80.3914,
    elevation: 1253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBVY": {
    icao: "KBVY",
    iata: "BVY",
    name: "Beverly Regional Airport",
    city: "Beverly / Danvers",
    country: "US",
    continent: "NA",
    lat: 42.5842,
    lon: -70.9165,
    elevation: 107,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBWG": {
    icao: "KBWG",
    iata: "BWG",
    name: "Bowling Green Warren County Regional Airport",
    city: "Bowling Green",
    country: "US",
    continent: "NA",
    lat: 36.9645,
    lon: -86.4197,
    elevation: 547,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBWI": {
    icao: "KBWI",
    iata: "BWI",
    name: "Baltimore/Washington International Thurgood Marshall Airport",
    city: "Baltimore",
    country: "US",
    continent: "NA",
    lat: 39.1754,
    lon: -76.6683,
    elevation: 146,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KBXM": {
    icao: "KBXM",
    iata: "NHZ",
    name: "Brunswick Executive Airport",
    city: "Brunswick",
    country: "US",
    continent: "NA",
    lat: 43.8922,
    lon: -69.9386,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBYH": {
    icao: "KBYH",
    iata: "BYH",
    name: "Arkansas International Airport",
    city: "Blytheville",
    country: "US",
    continent: "NA",
    lat: 35.9643,
    lon: -89.944,
    elevation: 254,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBYI": {
    icao: "KBYI",
    iata: "BYI",
    name: "Burley Municipal Airport",
    city: "Burley",
    country: "US",
    continent: "NA",
    lat: 42.5426,
    lon: -113.772,
    elevation: 4150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBYS": {
    icao: "KBYS",
    iata: "BYS",
    name: "Bicycle Lake Army Air Field",
    city: "Fort Irwin/Barstow",
    country: "US",
    continent: "NA",
    lat: 35.2805,
    lon: -116.63,
    elevation: 2350,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KBZN": {
    icao: "KBZN",
    iata: "BZN",
    name: "Bozeman Yellowstone International Airport",
    city: "Bozeman",
    country: "US",
    continent: "NA",
    lat: 45.7775,
    lon: -111.153,
    elevation: 4473,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCAE": {
    icao: "KCAE",
    iata: "CAE",
    name: "Columbia Metropolitan Airport",
    city: "Columbia",
    country: "US",
    continent: "NA",
    lat: 33.9388,
    lon: -81.1195,
    elevation: 236,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCAK": {
    icao: "KCAK",
    iata: "CAK",
    name: "Akron Canton Regional Airport",
    city: "Akron",
    country: "US",
    continent: "NA",
    lat: 40.9161,
    lon: -81.4422,
    elevation: 1228,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCAR": {
    icao: "KCAR",
    iata: "CAR",
    name: "Caribou Municipal Airport",
    city: "Caribou",
    country: "US",
    continent: "NA",
    lat: 46.8715,
    lon: -68.0179,
    elevation: 626,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCBM": {
    icao: "KCBM",
    iata: "CBM",
    name: "Columbus Air Force Base",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 33.6438,
    lon: -88.4438,
    elevation: 219,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCCR": {
    icao: "KCCR",
    iata: "CCR",
    name: "Buchanan Field",
    city: "Concord",
    country: "US",
    continent: "NA",
    lat: 37.9897,
    lon: -122.057,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCCY": {
    icao: "KCCY",
    iata: "CCY",
    name: "Northeast Iowa Regional Airport",
    city: "Charles City",
    country: "US",
    continent: "NA",
    lat: 43.0726,
    lon: -92.6108,
    elevation: 1125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCDC": {
    icao: "KCDC",
    iata: "CDC",
    name: "Cedar City Regional Airport",
    city: "Cedar City",
    country: "US",
    continent: "NA",
    lat: 37.701,
    lon: -113.099,
    elevation: 5622,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCDR": {
    icao: "KCDR",
    iata: "CDR",
    name: "Chadron Municipal Airport",
    city: "Chadron",
    country: "US",
    continent: "NA",
    lat: 42.8376,
    lon: -103.095,
    elevation: 3297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCDS": {
    icao: "KCDS",
    iata: "CDS",
    name: "Childress Municipal Airport",
    city: "Childress",
    country: "US",
    continent: "NA",
    lat: 34.4338,
    lon: -100.288,
    elevation: 1954,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCEC": {
    icao: "KCEC",
    iata: "CEC",
    name: "Jack Mc Namara Field Airport",
    city: "Crescent City",
    country: "US",
    continent: "NA",
    lat: 41.7789,
    lon: -124.2364,
    elevation: 61,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCEF": {
    icao: "KCEF",
    iata: "CEF",
    name: "Westover Metropolitan Airport / Westover Air Reserve Base",
    city: "Chicopee",
    country: "US",
    continent: "NA",
    lat: 42.194,
    lon: -72.5348,
    elevation: 241,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCEW": {
    icao: "KCEW",
    iata: "CEW",
    name: "Bob Sikes Airport",
    city: "Crestview",
    country: "US",
    continent: "NA",
    lat: 30.7788,
    lon: -86.5221,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCEZ": {
    icao: "KCEZ",
    iata: "CEZ",
    name: "Cortez Municipal Airport",
    city: "Cortez",
    country: "US",
    continent: "NA",
    lat: 37.303,
    lon: -108.628,
    elevation: 5918,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCGF": {
    icao: "KCGF",
    iata: "CGF",
    name: "Cuyahoga County Airport",
    city: "Cleveland",
    country: "US",
    continent: "NA",
    lat: 41.5651,
    lon: -81.4864,
    elevation: 879,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCGI": {
    icao: "KCGI",
    iata: "CGI",
    name: "Cape Girardeau Regional Airport",
    city: "Cape Girardeau",
    country: "US",
    continent: "NA",
    lat: 37.2253,
    lon: -89.5708,
    elevation: 342,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCHA": {
    icao: "KCHA",
    iata: "CHA",
    name: "Chattanooga Metropolitan Airport (Lovell Field)",
    city: "Chattanooga",
    country: "US",
    continent: "NA",
    lat: 35.0353,
    lon: -85.2038,
    elevation: 683,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCHO": {
    icao: "KCHO",
    iata: "CHO",
    name: "Charlottesville Albemarle Airport",
    city: "Charlottesville",
    country: "US",
    continent: "NA",
    lat: 38.1386,
    lon: -78.4529,
    elevation: 639,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCHS": {
    icao: "KCHS",
    iata: "CHS",
    name: "Charleston International Airport",
    city: "Charleston",
    country: "US",
    continent: "NA",
    lat: 32.8986,
    lon: -80.0405,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCID": {
    icao: "KCID",
    iata: "CID",
    name: "The Eastern Iowa Airport",
    city: "Cedar Rapids",
    country: "US",
    continent: "NA",
    lat: 41.8847,
    lon: -91.7108,
    elevation: 869,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCIU": {
    icao: "KCIU",
    iata: "CIU",
    name: "Chippewa County International Airport",
    city: "Kincheloe",
    country: "US",
    continent: "NA",
    lat: 46.2477,
    lon: -84.4714,
    elevation: 800,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCKB": {
    icao: "KCKB",
    iata: "CKB",
    name: "North Central West Virginia Airport",
    city: "Bridgeport",
    country: "US",
    continent: "NA",
    lat: 39.2966,
    lon: -80.2281,
    elevation: 1217,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCLE": {
    icao: "KCLE",
    iata: "CLE",
    name: "Cleveland Hopkins International Airport",
    city: "Cleveland",
    country: "US",
    continent: "NA",
    lat: 41.4117,
    lon: -81.8498,
    elevation: 791,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KCLL": {
    icao: "KCLL",
    iata: "CLL",
    name: "Easterwood Field",
    city: "College Station",
    country: "US",
    continent: "NA",
    lat: 30.5886,
    lon: -96.3638,
    elevation: 320,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCLM": {
    icao: "KCLM",
    iata: "CLM",
    name: "William R Fairchild International Airport",
    city: "Port Angeles",
    country: "US",
    continent: "NA",
    lat: 48.1202,
    lon: -123.5,
    elevation: 291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCLT": {
    icao: "KCLT",
    iata: "CLT",
    name: "Charlotte Douglas International Airport",
    city: "Charlotte",
    country: "US",
    continent: "NA",
    lat: 35.214,
    lon: -80.9431,
    elevation: 748,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KCMA": {
    icao: "KCMA",
    iata: "",
    name: "Camarillo International Airport",
    city: "Camarillo",
    country: "US",
    continent: "NA",
    lat: 34.2137,
    lon: -119.094,
    elevation: 77,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCMH": {
    icao: "KCMH",
    iata: "CMH",
    name: "John Glenn Columbus International Airport",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 39.998,
    lon: -82.8919,
    elevation: 815,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KCMI": {
    icao: "KCMI",
    iata: "CMI",
    name: "University of Illinois Willard Airport",
    city: "Savoy",
    country: "US",
    continent: "NA",
    lat: 40.0398,
    lon: -88.2762,
    elevation: 755,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCMX": {
    icao: "KCMX",
    iata: "CMX",
    name: "Houghton County Memorial Airport",
    city: "Hancock",
    country: "US",
    continent: "NA",
    lat: 47.1684,
    lon: -88.4891,
    elevation: 1095,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCNM": {
    icao: "KCNM",
    iata: "CNM",
    name: "Cavern City Air Terminal",
    city: "Carlsbad",
    country: "US",
    continent: "NA",
    lat: 32.3375,
    lon: -104.263,
    elevation: 3295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCNU": {
    icao: "KCNU",
    iata: "CNU",
    name: "Chanute Martin Johnson Airport",
    city: "Chanute",
    country: "US",
    continent: "NA",
    lat: 37.6682,
    lon: -95.4867,
    elevation: 1002,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCNY": {
    icao: "KCNY",
    iata: "CNY",
    name: "Canyonlands Regional Airport",
    city: "Moab",
    country: "US",
    continent: "NA",
    lat: 38.755,
    lon: -109.755,
    elevation: 4557,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCOD": {
    icao: "KCOD",
    iata: "COD",
    name: "Yellowstone Regional Airport",
    city: "Cody",
    country: "US",
    continent: "NA",
    lat: 44.5202,
    lon: -109.024,
    elevation: 5102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCOE": {
    icao: "KCOE",
    iata: "COE",
    name: "Coeur D\'Alene Airport - Pappy Boyington Field",
    city: "Coeur d\'Alene",
    country: "US",
    continent: "NA",
    lat: 47.7743,
    lon: -116.82,
    elevation: 2320,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCOF": {
    icao: "KCOF",
    iata: "COF",
    name: "Patrick Space Force Base",
    city: "Cocoa Beach",
    country: "US",
    continent: "NA",
    lat: 28.2349,
    lon: -80.6101,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCON": {
    icao: "KCON",
    iata: "CON",
    name: "Concord Municipal Airport",
    city: "Concord",
    country: "US",
    continent: "NA",
    lat: 43.2027,
    lon: -71.5023,
    elevation: 342,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCOS": {
    icao: "KCOS",
    iata: "COS",
    name: "City of Colorado Springs Municipal Airport",
    city: "Colorado Springs",
    country: "US",
    continent: "NA",
    lat: 38.8058,
    lon: -104.701,
    elevation: 6187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCOU": {
    icao: "KCOU",
    iata: "COU",
    name: "Columbia Regional Airport",
    city: "Columbia",
    country: "US",
    continent: "NA",
    lat: 38.8181,
    lon: -92.2196,
    elevation: 889,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCPR": {
    icao: "KCPR",
    iata: "CPR",
    name: "Casper-Natrona County International Airport",
    city: "Casper",
    country: "US",
    continent: "NA",
    lat: 42.908,
    lon: -106.464,
    elevation: 5350,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCRE": {
    icao: "KCRE",
    iata: "CRE",
    name: "Grand Strand Airport",
    city: "North Myrtle Beach",
    country: "US",
    continent: "NA",
    lat: 33.8117,
    lon: -78.7239,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCRG": {
    icao: "KCRG",
    iata: "CRG",
    name: "Jacksonville Executive at Craig Airport",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 30.3363,
    lon: -81.5144,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCRP": {
    icao: "KCRP",
    iata: "CRP",
    name: "Corpus Christi International Airport",
    city: "Corpus Christi",
    country: "US",
    continent: "NA",
    lat: 27.7704,
    lon: -97.5012,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCRQ": {
    icao: "KCRQ",
    iata: "CLD",
    name: "McClellan-Palomar Airport",
    city: "Carlsbad",
    country: "US",
    continent: "NA",
    lat: 33.1283,
    lon: -117.28,
    elevation: 331,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCRW": {
    icao: "KCRW",
    iata: "CRW",
    name: "Yeager Airport",
    city: "Charleston",
    country: "US",
    continent: "NA",
    lat: 38.3731,
    lon: -81.5932,
    elevation: 981,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCSG": {
    icao: "KCSG",
    iata: "CSG",
    name: "Columbus Metropolitan Airport",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 32.5163,
    lon: -84.9389,
    elevation: 397,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCSV": {
    icao: "KCSV",
    iata: "CSV",
    name: "Crossville Memorial Airport Whitson Field",
    city: "Crossville",
    country: "US",
    continent: "NA",
    lat: 35.9513,
    lon: -85.085,
    elevation: 1881,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCTB": {
    icao: "KCTB",
    iata: "CTB",
    name: "Cut Bank International Airport",
    city: "Cut Bank",
    country: "US",
    continent: "NA",
    lat: 48.6087,
    lon: -112.3782,
    elevation: 3854,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCUB": {
    icao: "KCUB",
    iata: "CUB",
    name: "Jim Hamilton L.B. Owens Airport",
    city: "Columbia",
    country: "US",
    continent: "NA",
    lat: 33.9705,
    lon: -80.9952,
    elevation: 193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCVG": {
    icao: "KCVG",
    iata: "CVG",
    name: "Cincinnati Northern Kentucky International Airport",
    city: "Cincinnati / Covington",
    country: "US",
    continent: "NA",
    lat: 39.0488,
    lon: -84.6678,
    elevation: 896,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KCVN": {
    icao: "KCVN",
    iata: "CVN",
    name: "Clovis Municipal Airport",
    city: "Clovis",
    country: "US",
    continent: "NA",
    lat: 34.4266,
    lon: -103.0788,
    elevation: 4216,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCVO": {
    icao: "KCVO",
    iata: "CVO",
    name: "Corvallis Municipal Airport",
    city: "Corvallis",
    country: "US",
    continent: "NA",
    lat: 44.4972,
    lon: -123.29,
    elevation: 250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCVS": {
    icao: "KCVS",
    iata: "CVS",
    name: "Cannon Air Force Base",
    city: "Clovis",
    country: "US",
    continent: "NA",
    lat: 34.3828,
    lon: -103.322,
    elevation: 4295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCWA": {
    icao: "KCWA",
    iata: "CWA",
    name: "Central Wisconsin Airport",
    city: "Mosinee",
    country: "US",
    continent: "NA",
    lat: 44.7774,
    lon: -89.6702,
    elevation: 1277,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCXO": {
    icao: "KCXO",
    iata: "CXO",
    name: "Conroe-North Houston Regional Airport",
    city: "Houston",
    country: "US",
    continent: "NA",
    lat: 30.3518,
    lon: -95.4145,
    elevation: 245,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KCYS": {
    icao: "KCYS",
    iata: "CYS",
    name: "Cheyenne Regional Jerry Olson Field",
    city: "Cheyenne",
    country: "US",
    continent: "NA",
    lat: 41.1557,
    lon: -104.812,
    elevation: 6159,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDAA": {
    icao: "KDAA",
    iata: "DAA",
    name: "Davison Army Air Field",
    city: "Fort Belvoir",
    country: "US",
    continent: "NA",
    lat: 38.715,
    lon: -77.181,
    elevation: 73,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDAB": {
    icao: "KDAB",
    iata: "DAB",
    name: "Daytona Beach International Airport",
    city: "Daytona Beach",
    country: "US",
    continent: "NA",
    lat: 29.1799,
    lon: -81.0581,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDAG": {
    icao: "KDAG",
    iata: "DAG",
    name: "Barstow Daggett Airport",
    city: "Daggett",
    country: "US",
    continent: "NA",
    lat: 34.8537,
    lon: -116.787,
    elevation: 1930,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDAL": {
    icao: "KDAL",
    iata: "DAL",
    name: "Dallas Love Field",
    city: "Dallas",
    country: "US",
    continent: "NA",
    lat: 32.8471,
    lon: -96.8518,
    elevation: 487,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDAN": {
    icao: "KDAN",
    iata: "DAN",
    name: "Danville Regional Airport",
    city: "Danville",
    country: "US",
    continent: "NA",
    lat: 36.5729,
    lon: -79.3361,
    elevation: 571,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDAY": {
    icao: "KDAY",
    iata: "DAY",
    name: "James M Cox Dayton International Airport",
    city: "Dayton",
    country: "US",
    continent: "NA",
    lat: 39.9024,
    lon: -84.2194,
    elevation: 1009,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDBQ": {
    icao: "KDBQ",
    iata: "DBQ",
    name: "Dubuque Regional Airport",
    city: "Dubuque",
    country: "US",
    continent: "NA",
    lat: 42.402,
    lon: -90.7095,
    elevation: 1077,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDCA": {
    icao: "KDCA",
    iata: "DCA",
    name: "Ronald Reagan Washington National Airport",
    city: "Washington",
    country: "US",
    continent: "NA",
    lat: 38.8521,
    lon: -77.0377,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KDDC": {
    icao: "KDDC",
    iata: "DDC",
    name: "Dodge City Regional Airport",
    city: "Dodge City",
    country: "US",
    continent: "NA",
    lat: 37.7634,
    lon: -99.9656,
    elevation: 2594,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDEC": {
    icao: "KDEC",
    iata: "DEC",
    name: "Decatur Airport",
    city: "Decatur",
    country: "US",
    continent: "NA",
    lat: 39.8346,
    lon: -88.8657,
    elevation: 682,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDEN": {
    icao: "KDEN",
    iata: "DEN",
    name: "Denver International Airport",
    city: "Denver",
    country: "US",
    continent: "NA",
    lat: 39.8617,
    lon: -104.673,
    elevation: 5431,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KDET": {
    icao: "KDET",
    iata: "DET",
    name: "Coleman A. Young Municipal Airport",
    city: "Detroit",
    country: "US",
    continent: "NA",
    lat: 42.4092,
    lon: -83.0099,
    elevation: 626,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDFW": {
    icao: "KDFW",
    iata: "DFW",
    name: "Dallas Fort Worth International Airport",
    city: "Dallas-Fort Worth",
    country: "US",
    continent: "NA",
    lat: 32.8968,
    lon: -97.038,
    elevation: 607,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KDHN": {
    icao: "KDHN",
    iata: "DHN",
    name: "Dothan Regional Airport",
    city: "Dothan",
    country: "US",
    continent: "NA",
    lat: 31.3213,
    lon: -85.4496,
    elevation: 401,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDHT": {
    icao: "KDHT",
    iata: "DHT",
    name: "Dalhart Municipal Airport",
    city: "Dalhart",
    country: "US",
    continent: "NA",
    lat: 36.0226,
    lon: -102.547,
    elevation: 3991,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDIK": {
    icao: "KDIK",
    iata: "DIK",
    name: "Dickinson Theodore Roosevelt Regional Airport",
    city: "Dickinson",
    country: "US",
    continent: "NA",
    lat: 46.7975,
    lon: -102.8019,
    elevation: 2592,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDLF": {
    icao: "KDLF",
    iata: "DLF",
    name: "Laughlin Air Force Base",
    city: "Del Rio",
    country: "US",
    continent: "NA",
    lat: 29.3595,
    lon: -100.778,
    elevation: 1082,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDLH": {
    icao: "KDLH",
    iata: "DLH",
    name: "Duluth International Airport",
    city: "Duluth",
    country: "US",
    continent: "NA",
    lat: 46.8421,
    lon: -92.1936,
    elevation: 1428,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDLS": {
    icao: "KDLS",
    iata: "DLS",
    name: "Columbia Gorge Regional Airport",
    city: "Dallesport / The Dalles",
    country: "US",
    continent: "NA",
    lat: 45.621,
    lon: -121.1708,
    elevation: 247,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDMA": {
    icao: "KDMA",
    iata: "DMA",
    name: "Davis Monthan Air Force Base",
    city: "Tucson",
    country: "US",
    continent: "NA",
    lat: 32.1665,
    lon: -110.883,
    elevation: 2704,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDMN": {
    icao: "KDMN",
    iata: "DMN",
    name: "Deming Municipal Airport",
    city: "Deming",
    country: "US",
    continent: "NA",
    lat: 32.2623,
    lon: -107.721,
    elevation: 4314,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDNL": {
    icao: "KDNL",
    iata: "DNL",
    name: "Daniel Field",
    city: "Augusta",
    country: "US",
    continent: "NA",
    lat: 33.4665,
    lon: -82.0394,
    elevation: 423,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDOV": {
    icao: "KDOV",
    iata: "DOV",
    name: "Dover Air Force Base",
    city: "Dover",
    country: "US",
    continent: "NA",
    lat: 39.1295,
    lon: -75.466,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDPA": {
    icao: "KDPA",
    iata: "DPA",
    name: "Dupage Airport",
    city: "Chicago/West Chicago",
    country: "US",
    continent: "NA",
    lat: 41.9078,
    lon: -88.2486,
    elevation: 759,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDRA": {
    icao: "KDRA",
    iata: "DRA",
    name: "Desert Rock Airport",
    city: "Mercury",
    country: "US",
    continent: "NA",
    lat: 36.6194,
    lon: -116.033,
    elevation: 3314,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDRI": {
    icao: "KDRI",
    iata: "DRI",
    name: "Beauregard Regional Airport",
    city: "DeRidder",
    country: "US",
    continent: "NA",
    lat: 30.8317,
    lon: -93.3399,
    elevation: 202,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDRO": {
    icao: "KDRO",
    iata: "DRO",
    name: "Durango La Plata County Airport",
    city: "Durango",
    country: "US",
    continent: "NA",
    lat: 37.1515,
    lon: -107.754,
    elevation: 6685,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDRT": {
    icao: "KDRT",
    iata: "DRT",
    name: "Del Rio International Airport",
    city: "Del Rio",
    country: "US",
    continent: "NA",
    lat: 29.3742,
    lon: -100.927,
    elevation: 1002,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDSM": {
    icao: "KDSM",
    iata: "DSM",
    name: "Des Moines International Airport",
    city: "Des Moines",
    country: "US",
    continent: "NA",
    lat: 41.534,
    lon: -93.6631,
    elevation: 958,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDTS": {
    icao: "KDTS",
    iata: "DSI",
    name: "Destin Executive Airport",
    city: "Destin",
    country: "US",
    continent: "NA",
    lat: 30.4001,
    lon: -86.4715,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDTW": {
    icao: "KDTW",
    iata: "DTW",
    name: "Detroit Metropolitan Wayne County Airport",
    city: "Detroit",
    country: "US",
    continent: "NA",
    lat: 42.2138,
    lon: -83.3538,
    elevation: 645,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KDUA": {
    icao: "KDUA",
    iata: "DUA",
    name: "Durant Regional Airport - Eaker Field",
    city: "Durant",
    country: "US",
    continent: "NA",
    lat: 33.9397,
    lon: -96.3951,
    elevation: 699,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDUG": {
    icao: "KDUG",
    iata: "DUG",
    name: "Bisbee Douglas International Airport",
    city: "Douglas Bisbee",
    country: "US",
    continent: "NA",
    lat: 31.469,
    lon: -109.604,
    elevation: 4154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDUJ": {
    icao: "KDUJ",
    iata: "DUJ",
    name: "DuBois Regional Airport",
    city: "Dubois",
    country: "US",
    continent: "NA",
    lat: 41.1783,
    lon: -78.8987,
    elevation: 1817,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDVL": {
    icao: "KDVL",
    iata: "DVL",
    name: "Devils Lake Regional Airport",
    city: "Devils Lake",
    country: "US",
    continent: "NA",
    lat: 48.1155,
    lon: -98.9088,
    elevation: 1456,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDXR": {
    icao: "KDXR",
    iata: "DXR",
    name: "Danbury Municipal Airport",
    city: "Danbury",
    country: "US",
    continent: "NA",
    lat: 41.3717,
    lon: -73.4822,
    elevation: 458,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KDYS": {
    icao: "KDYS",
    iata: "DYS",
    name: "Dyess Air Force Base",
    city: "Abilene",
    country: "US",
    continent: "NA",
    lat: 32.4208,
    lon: -99.8546,
    elevation: 1789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEAR": {
    icao: "KEAR",
    iata: "EAR",
    name: "Kearney Regional Airport",
    city: "Kearney",
    country: "US",
    continent: "NA",
    lat: 40.727,
    lon: -99.0068,
    elevation: 2131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEAT": {
    icao: "KEAT",
    iata: "EAT",
    name: "Pangborn Memorial Airport",
    city: "Wenatchee",
    country: "US",
    continent: "NA",
    lat: 47.3989,
    lon: -120.207,
    elevation: 1249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEAU": {
    icao: "KEAU",
    iata: "EAU",
    name: "Chippewa Valley Regional Airport",
    city: "Eau Claire",
    country: "US",
    continent: "NA",
    lat: 44.8658,
    lon: -91.4843,
    elevation: 913,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KECG": {
    icao: "KECG",
    iata: "ECG",
    name: "Elizabeth City Regional Airport & Coast Guard Air Station",
    city: "Elizabeth City",
    country: "US",
    continent: "NA",
    lat: 36.2606,
    lon: -76.1746,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KECP": {
    icao: "KECP",
    iata: "ECP",
    name: "Northwest Florida Beaches International Airport",
    city: "Panama City Beach",
    country: "US",
    continent: "NA",
    lat: 30.3571,
    lon: -85.7954,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEDW": {
    icao: "KEDW",
    iata: "EDW",
    name: "Edwards Air Force Base",
    city: "Edwards",
    country: "US",
    continent: "NA",
    lat: 34.9108,
    lon: -117.8864,
    elevation: 2312,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEED": {
    icao: "KEED",
    iata: "EED",
    name: "Needles Airport",
    city: "Needles",
    country: "US",
    continent: "NA",
    lat: 34.7663,
    lon: -114.623,
    elevation: 983,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEEN": {
    icao: "KEEN",
    iata: "EEN",
    name: "Dillant Hopkins Airport",
    city: "Keene",
    country: "US",
    continent: "NA",
    lat: 42.8984,
    lon: -72.2708,
    elevation: 488,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEET": {
    icao: "KEET",
    iata: "",
    name: "Shelby County Airport",
    city: "Alabaster",
    country: "US",
    continent: "NA",
    lat: 33.177,
    lon: -86.7828,
    elevation: 586,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEFD": {
    icao: "KEFD",
    iata: "EFD",
    name: "Ellington Airport",
    city: "Houston",
    country: "US",
    continent: "NA",
    lat: 29.6073,
    lon: -95.1588,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEGE": {
    icao: "KEGE",
    iata: "EGE",
    name: "Eagle County Regional Airport",
    city: "Eagle",
    country: "US",
    continent: "NA",
    lat: 39.6426,
    lon: -106.918,
    elevation: 6548,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEGI": {
    icao: "KEGI",
    iata: "EGI",
    name: "Duke Field",
    city: "Crestview",
    country: "US",
    continent: "NA",
    lat: 30.6504,
    lon: -86.5229,
    elevation: 191,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEKA": {
    icao: "KEKA",
    iata: "EKA",
    name: "Murray Field",
    city: "Eureka",
    country: "US",
    continent: "NA",
    lat: 40.8034,
    lon: -124.113,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEKN": {
    icao: "KEKN",
    iata: "EKN",
    name: "Elkins-Randolph County Regional Airport",
    city: "Elkins",
    country: "US",
    continent: "NA",
    lat: 38.8898,
    lon: -79.8577,
    elevation: 1987,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEKO": {
    icao: "KEKO",
    iata: "EKO",
    name: "Elko Regional Airport",
    city: "Elko",
    country: "US",
    continent: "NA",
    lat: 40.8249,
    lon: -115.792,
    elevation: 5140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KELD": {
    icao: "KELD",
    iata: "ELD",
    name: "South Arkansas Regional Airport at Goodwin Field",
    city: "El Dorado",
    country: "US",
    continent: "NA",
    lat: 33.221,
    lon: -92.8133,
    elevation: 277,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KELM": {
    icao: "KELM",
    iata: "ELM",
    name: "Elmira Corning Regional Airport",
    city: "Elmira/Corning",
    country: "US",
    continent: "NA",
    lat: 42.1599,
    lon: -76.8916,
    elevation: 954,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KELO": {
    icao: "KELO",
    iata: "LYU",
    name: "Ely Municipal Airport",
    city: "Ely",
    country: "US",
    continent: "NA",
    lat: 47.8245,
    lon: -91.8307,
    elevation: 1456,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KELP": {
    icao: "KELP",
    iata: "ELP",
    name: "El Paso International Airport",
    city: "El Paso",
    country: "US",
    continent: "NA",
    lat: 31.8072,
    lon: -106.378,
    elevation: 3959,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KELY": {
    icao: "KELY",
    iata: "ELY",
    name: "Ely Airport Yelland Field",
    city: "Ely",
    country: "US",
    continent: "NA",
    lat: 39.2997,
    lon: -114.842,
    elevation: 6259,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEND": {
    icao: "KEND",
    iata: "END",
    name: "Vance Air Force Base",
    city: "Enid",
    country: "US",
    continent: "NA",
    lat: 36.3392,
    lon: -97.9165,
    elevation: 1307,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KENV": {
    icao: "KENV",
    iata: "ENV",
    name: "Wendover Airport",
    city: "Wendover",
    country: "US",
    continent: "NA",
    lat: 40.7187,
    lon: -114.031,
    elevation: 4237,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KENW": {
    icao: "KENW",
    iata: "ENW",
    name: "Kenosha Regional Airport",
    city: "Kenosha",
    country: "US",
    continent: "NA",
    lat: 42.5957,
    lon: -87.9278,
    elevation: 742,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KERI": {
    icao: "KERI",
    iata: "ERI",
    name: "Erie International Tom Ridge Field",
    city: "Erie",
    country: "US",
    continent: "NA",
    lat: 42.0831,
    lon: -80.1739,
    elevation: 732,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KESC": {
    icao: "KESC",
    iata: "ESC",
    name: "Delta County Airport",
    city: "Escanaba",
    country: "US",
    continent: "NA",
    lat: 45.7232,
    lon: -87.0886,
    elevation: 609,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KESF": {
    icao: "KESF",
    iata: "ESF",
    name: "Esler Army Airfield / Esler Regional Airport",
    city: "Alexandria",
    country: "US",
    continent: "NA",
    lat: 31.3943,
    lon: -92.2941,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEUG": {
    icao: "KEUG",
    iata: "EUG",
    name: "Mahlon Sweet Field",
    city: "Eugene",
    country: "US",
    continent: "NA",
    lat: 44.1246,
    lon: -123.212,
    elevation: 374,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEVV": {
    icao: "KEVV",
    iata: "EVV",
    name: "Evansville Regional Airport",
    city: "Evansville",
    country: "US",
    continent: "NA",
    lat: 38.037,
    lon: -87.5324,
    elevation: 418,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEVW": {
    icao: "KEVW",
    iata: "EVW",
    name: "Evanston-Uinta County Airport-Burns Field",
    city: "Evanston",
    country: "US",
    continent: "NA",
    lat: 41.2748,
    lon: -111.035,
    elevation: 7143,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEWB": {
    icao: "KEWB",
    iata: "EWB",
    name: "New Bedford Regional Airport",
    city: "New Bedford",
    country: "US",
    continent: "NA",
    lat: 41.6761,
    lon: -70.9569,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEWN": {
    icao: "KEWN",
    iata: "EWN",
    name: "Coastal Carolina Regional Airport",
    city: "New Bern",
    country: "US",
    continent: "NA",
    lat: 35.073,
    lon: -77.0429,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KEWR": {
    icao: "KEWR",
    iata: "EWR",
    name: "Newark Liberty International Airport",
    city: "Newark",
    country: "US",
    continent: "NA",
    lat: 40.6925,
    lon: -74.1687,
    elevation: 18,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KEYW": {
    icao: "KEYW",
    iata: "EYW",
    name: "Key West International Airport",
    city: "Key West",
    country: "US",
    continent: "NA",
    lat: 24.5561,
    lon: -81.7596,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFAF": {
    icao: "KFAF",
    iata: "FAF",
    name: "Felker Army Air Field",
    city: "Newport News (Fort Eustis)",
    country: "US",
    continent: "NA",
    lat: 37.1325,
    lon: -76.6088,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFAR": {
    icao: "KFAR",
    iata: "FAR",
    name: "Hector International Airport",
    city: "Fargo",
    country: "US",
    continent: "NA",
    lat: 46.9207,
    lon: -96.8158,
    elevation: 902,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFAT": {
    icao: "KFAT",
    iata: "FAT",
    name: "Fresno Yosemite International Airport",
    city: "Fresno",
    country: "US",
    continent: "NA",
    lat: 36.7762,
    lon: -119.718,
    elevation: 336,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFAY": {
    icao: "KFAY",
    iata: "FAY",
    name: "Fayetteville Regional Airport - Grannis Field",
    city: "Fayetteville",
    country: "US",
    continent: "NA",
    lat: 34.9912,
    lon: -78.8803,
    elevation: 189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFBG": {
    icao: "KFBG",
    iata: "FBG",
    name: "Simmons Army Air Field",
    city: "Fort Bragg",
    country: "US",
    continent: "NA",
    lat: 35.1318,
    lon: -78.9367,
    elevation: 244,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFCS": {
    icao: "KFCS",
    iata: "FCS",
    name: "Butts AAF (Fort Carson) Air Field",
    city: "Fort Carson",
    country: "US",
    continent: "NA",
    lat: 38.6784,
    lon: -104.757,
    elevation: 5838,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFDY": {
    icao: "KFDY",
    iata: "FDY",
    name: "Findlay Airport",
    city: "Findlay",
    country: "US",
    continent: "NA",
    lat: 41.0135,
    lon: -83.6687,
    elevation: 813,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFFO": {
    icao: "KFFO",
    iata: "FFO",
    name: "Wright-Patterson Air Force Base",
    city: "Dayton",
    country: "US",
    continent: "NA",
    lat: 39.8261,
    lon: -84.0483,
    elevation: 823,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFHR": {
    icao: "KFHR",
    iata: "FRD",
    name: "Friday Harbor Airport",
    city: "Friday Harbor",
    country: "US",
    continent: "NA",
    lat: 48.5237,
    lon: -123.0246,
    elevation: 113,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFHU": {
    icao: "KFHU",
    iata: "FHU",
    name: "Sierra Vista Municipal Airport / Libby Army Air Field",
    city: "Fort Huachuca / Sierra Vista",
    country: "US",
    continent: "NA",
    lat: 31.5874,
    lon: -110.3482,
    elevation: 4719,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFKL": {
    icao: "KFKL",
    iata: "FKL",
    name: "Venango Regional Airport",
    city: "Franklin",
    country: "US",
    continent: "NA",
    lat: 41.3779,
    lon: -79.8604,
    elevation: 1540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFLG": {
    icao: "KFLG",
    iata: "FLG",
    name: "Flagstaff Pulliam International Airport",
    city: "Flagstaff",
    country: "US",
    continent: "NA",
    lat: 35.1385,
    lon: -111.671,
    elevation: 7014,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFLL": {
    icao: "KFLL",
    iata: "FLL",
    name: "Fort Lauderdale Hollywood International Airport",
    city: "Fort Lauderdale",
    country: "US",
    continent: "NA",
    lat: 26.0726,
    lon: -80.1527,
    elevation: 9,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KFLO": {
    icao: "KFLO",
    iata: "FLO",
    name: "Florence Regional Airport",
    city: "Florence",
    country: "US",
    continent: "NA",
    lat: 34.1854,
    lon: -79.7239,
    elevation: 146,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFME": {
    icao: "KFME",
    iata: "FME",
    name: "Fort Meade Executive Airport",
    city: "Fort Meade(Odenton)",
    country: "US",
    continent: "NA",
    lat: 39.0854,
    lon: -76.7594,
    elevation: 150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFMN": {
    icao: "KFMN",
    iata: "FMN",
    name: "Four Corners Regional Airport",
    city: "Farmington",
    country: "US",
    continent: "NA",
    lat: 36.7412,
    lon: -108.23,
    elevation: 5506,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFMY": {
    icao: "KFMY",
    iata: "FMY",
    name: "Page Field",
    city: "Fort Myers",
    country: "US",
    continent: "NA",
    lat: 26.5866,
    lon: -81.8633,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFNL": {
    icao: "KFNL",
    iata: "FNL",
    name: "Northern Colorado Regional Airport",
    city: "Loveland",
    country: "US",
    continent: "NA",
    lat: 40.4497,
    lon: -105.0113,
    elevation: 5016,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFNT": {
    icao: "KFNT",
    iata: "FNT",
    name: "Bishop International Airport",
    city: "Flint",
    country: "US",
    continent: "NA",
    lat: 42.9654,
    lon: -83.7436,
    elevation: 782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFOD": {
    icao: "KFOD",
    iata: "FOD",
    name: "Fort Dodge Regional Airport",
    city: "Fort Dodge",
    country: "US",
    continent: "NA",
    lat: 42.5526,
    lon: -94.1912,
    elevation: 1156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFOE": {
    icao: "KFOE",
    iata: "FOE",
    name: "Topeka Regional Airport",
    city: "Topeka",
    country: "US",
    continent: "NA",
    lat: 38.9509,
    lon: -95.6636,
    elevation: 1078,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFPR": {
    icao: "KFPR",
    iata: "FPR",
    name: "Treasure Coast International Airport",
    city: "Fort Pierce",
    country: "US",
    continent: "NA",
    lat: 27.4951,
    lon: -80.3683,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFRG": {
    icao: "KFRG",
    iata: "FRG",
    name: "Republic Airport",
    city: "Farmingdale",
    country: "US",
    continent: "NA",
    lat: 40.7288,
    lon: -73.4134,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFRI": {
    icao: "KFRI",
    iata: "FRI",
    name: "Marshall Army Air Field",
    city: "Fort Riley (Junction City)",
    country: "US",
    continent: "NA",
    lat: 39.053,
    lon: -96.7642,
    elevation: 1065,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFSD": {
    icao: "KFSD",
    iata: "FSD",
    name: "Sioux Falls Regional Airport / Joe Foss Field",
    city: "Sioux Falls",
    country: "US",
    continent: "NA",
    lat: 43.5855,
    lon: -96.7412,
    elevation: 1429,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFSI": {
    icao: "KFSI",
    iata: "FSI",
    name: "Henry Post Army Air Field",
    city: "Fort Sill",
    country: "US",
    continent: "NA",
    lat: 34.6498,
    lon: -98.4022,
    elevation: 1189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFSM": {
    icao: "KFSM",
    iata: "FSM",
    name: "Fort Smith Regional Airport",
    city: "Fort Smith",
    country: "US",
    continent: "NA",
    lat: 35.3366,
    lon: -94.3674,
    elevation: 469,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFST": {
    icao: "KFST",
    iata: "FST",
    name: "Fort Stockton Pecos County Airport",
    city: "Fort Stockton",
    country: "US",
    continent: "NA",
    lat: 30.9157,
    lon: -102.916,
    elevation: 3011,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFTK": {
    icao: "KFTK",
    iata: "FTK",
    name: "Godman Army Air Field",
    city: "Fort Knox",
    country: "US",
    continent: "NA",
    lat: 37.9071,
    lon: -85.9721,
    elevation: 756,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFTW": {
    icao: "KFTW",
    iata: "FTW",
    name: "Fort Worth Meacham International Airport",
    city: "Fort Worth",
    country: "US",
    continent: "NA",
    lat: 32.8198,
    lon: -97.3624,
    elevation: 710,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFTY": {
    icao: "KFTY",
    iata: "FTY",
    name: "Fulton County Airport Brown Field",
    city: "Atlanta",
    country: "US",
    continent: "NA",
    lat: 33.7791,
    lon: -84.5214,
    elevation: 841,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFWA": {
    icao: "KFWA",
    iata: "FWA",
    name: "Fort Wayne International Airport",
    city: "Fort Wayne",
    country: "US",
    continent: "NA",
    lat: 40.9785,
    lon: -85.1951,
    elevation: 814,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFXE": {
    icao: "KFXE",
    iata: "FXE",
    name: "Fort Lauderdale Executive Airport",
    city: "Fort Lauderdale",
    country: "US",
    continent: "NA",
    lat: 26.1973,
    lon: -80.1707,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KFYV": {
    icao: "KFYV",
    iata: "FYV",
    name: "Drake Field",
    city: "Fayetteville",
    country: "US",
    continent: "NA",
    lat: 36.0051,
    lon: -94.1701,
    elevation: 1251,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGCC": {
    icao: "KGCC",
    iata: "GCC",
    name: "Northeast Wyoming Regional Airport",
    city: "Gillette",
    country: "US",
    continent: "NA",
    lat: 44.3489,
    lon: -105.539,
    elevation: 4365,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGCK": {
    icao: "KGCK",
    iata: "GCK",
    name: "Garden City Regional Airport",
    city: "Garden City",
    country: "US",
    continent: "NA",
    lat: 37.9275,
    lon: -100.724,
    elevation: 2891,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGCN": {
    icao: "KGCN",
    iata: "GCN",
    name: "Grand Canyon National Park Airport",
    city: "Grand Canyon - Tusayan",
    country: "US",
    continent: "NA",
    lat: 35.9524,
    lon: -112.147,
    elevation: 6609,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGDV": {
    icao: "KGDV",
    iata: "GDV",
    name: "Dawson Community Airport",
    city: "Glendive",
    country: "US",
    continent: "NA",
    lat: 47.1377,
    lon: -104.8069,
    elevation: 2458,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGEG": {
    icao: "KGEG",
    iata: "GEG",
    name: "Spokane International Airport",
    city: "Spokane",
    country: "US",
    continent: "NA",
    lat: 47.6199,
    lon: -117.534,
    elevation: 2376,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGFK": {
    icao: "KGFK",
    iata: "GFK",
    name: "Grand Forks International Airport",
    city: "Grand Forks",
    country: "US",
    continent: "NA",
    lat: 47.9493,
    lon: -97.1761,
    elevation: 845,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGFL": {
    icao: "KGFL",
    iata: "GFL",
    name: "Floyd Bennett Memorial Airport",
    city: "Glens Falls",
    country: "US",
    continent: "NA",
    lat: 43.3412,
    lon: -73.6103,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGGG": {
    icao: "KGGG",
    iata: "GGG",
    name: "East Texas Regional Airport",
    city: "Longview",
    country: "US",
    continent: "NA",
    lat: 32.384,
    lon: -94.7115,
    elevation: 365,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGGW": {
    icao: "KGGW",
    iata: "GGW",
    name: "Glasgow Valley County Airport Wokal Field",
    city: "Glasgow",
    country: "US",
    continent: "NA",
    lat: 48.2125,
    lon: -106.615,
    elevation: 2296,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGJT": {
    icao: "KGJT",
    iata: "GJT",
    name: "Grand Junction Regional Airport",
    city: "Grand Junction",
    country: "US",
    continent: "NA",
    lat: 39.1267,
    lon: -108.5294,
    elevation: 4858,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGLD": {
    icao: "KGLD",
    iata: "GLD",
    name: "Goodland Municipal Airport",
    city: "Goodland",
    country: "US",
    continent: "NA",
    lat: 39.3707,
    lon: -101.6998,
    elevation: 3656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGLH": {
    icao: "KGLH",
    iata: "GLH",
    name: "Mid Delta Regional Airport",
    city: "Greenville",
    country: "US",
    continent: "NA",
    lat: 33.4829,
    lon: -90.9856,
    elevation: 131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGLS": {
    icao: "KGLS",
    iata: "GLS",
    name: "Scholes International At Galveston Airport",
    city: "Galveston",
    country: "US",
    continent: "NA",
    lat: 29.2653,
    lon: -94.8604,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGMU": {
    icao: "KGMU",
    iata: "GMU",
    name: "Greenville Downtown Airport",
    city: "Greenville",
    country: "US",
    continent: "NA",
    lat: 34.8479,
    lon: -82.3502,
    elevation: 1048,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGNV": {
    icao: "KGNV",
    iata: "GNV",
    name: "Gainesville Regional Airport",
    city: "Gainesville",
    country: "US",
    continent: "NA",
    lat: 29.6901,
    lon: -82.2718,
    elevation: 152,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGON": {
    icao: "KGON",
    iata: "GON",
    name: "Groton New London Airport",
    city: "Groton",
    country: "US",
    continent: "NA",
    lat: 41.3301,
    lon: -72.0451,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGPI": {
    icao: "KGPI",
    iata: "FCA",
    name: "Glacier Park International Airport",
    city: "Kalispell",
    country: "US",
    continent: "NA",
    lat: 48.3105,
    lon: -114.256,
    elevation: 2977,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGPT": {
    icao: "KGPT",
    iata: "GPT",
    name: "Gulfport Biloxi International Airport",
    city: "Gulfport",
    country: "US",
    continent: "NA",
    lat: 30.4073,
    lon: -89.0701,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGRB": {
    icao: "KGRB",
    iata: "GRB",
    name: "Austin Straubel International Airport",
    city: "Green Bay",
    country: "US",
    continent: "NA",
    lat: 44.4835,
    lon: -88.1308,
    elevation: 695,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGRF": {
    icao: "KGRF",
    iata: "GRF",
    name: "Gray Army Air Field",
    city: "Fort Lewis/Tacoma",
    country: "US",
    continent: "NA",
    lat: 47.0792,
    lon: -122.581,
    elevation: 300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGRI": {
    icao: "KGRI",
    iata: "GRI",
    name: "Central Nebraska Regional Airport",
    city: "Grand Island",
    country: "US",
    continent: "NA",
    lat: 40.9675,
    lon: -98.3096,
    elevation: 1847,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGRK": {
    icao: "KGRK",
    iata: "GRK",
    name: "Killeen Regional Airport / Robert Gray Army Airfield",
    city: "Fort Cavazos",
    country: "US",
    continent: "NA",
    lat: 31.0672,
    lon: -97.8289,
    elevation: 1015,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGRR": {
    icao: "KGRR",
    iata: "GRR",
    name: "Gerald R. Ford International Airport",
    city: "Grand Rapids",
    country: "US",
    continent: "NA",
    lat: 42.8808,
    lon: -85.5228,
    elevation: 794,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGSB": {
    icao: "KGSB",
    iata: "GSB",
    name: "Seymour Johnson Air Force Base",
    city: "Goldsboro",
    country: "US",
    continent: "NA",
    lat: 35.3394,
    lon: -77.9606,
    elevation: 109,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGSO": {
    icao: "KGSO",
    iata: "GSO",
    name: "Piedmont Triad International Airport",
    city: "Greensboro",
    country: "US",
    continent: "NA",
    lat: 36.0978,
    lon: -79.9373,
    elevation: 925,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGSP": {
    icao: "KGSP",
    iata: "GSP",
    name: "Greenville Spartanburg International Airport",
    city: "Greer",
    country: "US",
    continent: "NA",
    lat: 34.8957,
    lon: -82.2189,
    elevation: 964,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGTB": {
    icao: "KGTB",
    iata: "",
    name: "Wheeler Sack Army Air Field",
    city: "Fort Drum",
    country: "US",
    continent: "NA",
    lat: 44.0556,
    lon: -75.7195,
    elevation: 688,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGTF": {
    icao: "KGTF",
    iata: "GTF",
    name: "Great Falls International Airport",
    city: "Great Falls",
    country: "US",
    continent: "NA",
    lat: 47.482,
    lon: -111.371,
    elevation: 3680,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGTR": {
    icao: "KGTR",
    iata: "GTR",
    name: "Golden Triangle Regional Airport",
    city: "Columbus/W Point/Starkville",
    country: "US",
    continent: "NA",
    lat: 33.4503,
    lon: -88.5914,
    elevation: 264,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGUC": {
    icao: "KGUC",
    iata: "GUC",
    name: "Gunnison Crested Butte Regional Airport",
    city: "Gunnison",
    country: "US",
    continent: "NA",
    lat: 38.5347,
    lon: -106.9346,
    elevation: 7680,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGUP": {
    icao: "KGUP",
    iata: "GUP",
    name: "Gallup Municipal Airport",
    city: "Gallup",
    country: "US",
    continent: "NA",
    lat: 35.5117,
    lon: -108.7882,
    elevation: 6472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGUS": {
    icao: "KGUS",
    iata: "GUS",
    name: "Grissom Air Reserve Base",
    city: "Peru",
    country: "US",
    continent: "NA",
    lat: 40.6481,
    lon: -86.1521,
    elevation: 812,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGUY": {
    icao: "KGUY",
    iata: "GUY",
    name: "Guymon Municipal Airport",
    city: "Guymon",
    country: "US",
    continent: "NA",
    lat: 36.6851,
    lon: -101.508,
    elevation: 3123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGWO": {
    icao: "KGWO",
    iata: "GWO",
    name: "Greenwood–Leflore Airport",
    city: "Greenwood",
    country: "US",
    continent: "NA",
    lat: 33.495,
    lon: -90.0882,
    elevation: 162,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGYI": {
    icao: "KGYI",
    iata: "PNX",
    name: "North Texas Regional Airport Perrin Field",
    city: "Denison",
    country: "US",
    continent: "NA",
    lat: 33.7141,
    lon: -96.6737,
    elevation: 749,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KGYY": {
    icao: "KGYY",
    iata: "GYY",
    name: "Gary Chicago International Airport",
    city: "Gary",
    country: "US",
    continent: "NA",
    lat: 41.6163,
    lon: -87.4128,
    elevation: 591,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHBG": {
    icao: "KHBG",
    iata: "HBG",
    name: "Hattiesburg Bobby L Chain Municipal Airport",
    city: "Hattiesburg",
    country: "US",
    continent: "NA",
    lat: 31.2648,
    lon: -89.2528,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHBR": {
    icao: "KHBR",
    iata: "HBR",
    name: "Hobart Regional Airport",
    city: "Hobart",
    country: "US",
    continent: "NA",
    lat: 34.9913,
    lon: -99.0513,
    elevation: 1563,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHDN": {
    icao: "KHDN",
    iata: "HDN",
    name: "Yampa Valley Airport",
    city: "Hayden",
    country: "US",
    continent: "NA",
    lat: 40.4812,
    lon: -107.218,
    elevation: 6606,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHEF": {
    icao: "KHEF",
    iata: "MNZ",
    name: "Manassas Regional Airport/Harry P. Davis Field",
    city: "Manassas",
    country: "US",
    continent: "NA",
    lat: 38.7214,
    lon: -77.5154,
    elevation: 192,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHFD": {
    icao: "KHFD",
    iata: "HFD",
    name: "Hartford Brainard Airport",
    city: "Hartford",
    country: "US",
    continent: "NA",
    lat: 41.7367,
    lon: -72.6494,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHGR": {
    icao: "KHGR",
    iata: "HGR",
    name: "Hagerstown Regional Richard A Henson Field",
    city: "Hagerstown",
    country: "US",
    continent: "NA",
    lat: 39.7088,
    lon: -77.728,
    elevation: 703,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHHR": {
    icao: "KHHR",
    iata: "HHR",
    name: "Jack Northrop Field Hawthorne Municipal Airport",
    city: "Hawthorne",
    country: "US",
    continent: "NA",
    lat: 33.9228,
    lon: -118.335,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHIB": {
    icao: "KHIB",
    iata: "HIB",
    name: "Range Regional Airport",
    city: "Hibbing",
    country: "US",
    continent: "NA",
    lat: 47.3848,
    lon: -92.8369,
    elevation: 1354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHIF": {
    icao: "KHIF",
    iata: "HIF",
    name: "Hill Air Force Base",
    city: "Ogden",
    country: "US",
    continent: "NA",
    lat: 41.124,
    lon: -111.9731,
    elevation: 4789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHII": {
    icao: "KHII",
    iata: "HII",
    name: "Lake Havasu City International Airport",
    city: "Lake Havasu City",
    country: "US",
    continent: "NA",
    lat: 34.5711,
    lon: -114.358,
    elevation: 783,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHIO": {
    icao: "KHIO",
    iata: "HIO",
    name: "Portland Hillsboro Airport",
    city: "Portland",
    country: "US",
    continent: "NA",
    lat: 45.5404,
    lon: -122.95,
    elevation: 208,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHKY": {
    icao: "KHKY",
    iata: "HKY",
    name: "Hickory Regional Airport",
    city: "Hickory",
    country: "US",
    continent: "NA",
    lat: 35.7411,
    lon: -81.3895,
    elevation: 1190,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHLG": {
    icao: "KHLG",
    iata: "HLG",
    name: "Wheeling Ohio County Airport",
    city: "Wheeling",
    country: "US",
    continent: "NA",
    lat: 40.175,
    lon: -80.6463,
    elevation: 1195,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHLN": {
    icao: "KHLN",
    iata: "HLN",
    name: "Helena Regional Airport",
    city: "Helena",
    country: "US",
    continent: "NA",
    lat: 46.6068,
    lon: -111.983,
    elevation: 3877,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHMN": {
    icao: "KHMN",
    iata: "HMN",
    name: "Holloman Air Force Base",
    city: "Alamogordo",
    country: "US",
    continent: "NA",
    lat: 32.8525,
    lon: -106.107,
    elevation: 4093,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHOB": {
    icao: "KHOB",
    iata: "HOB",
    name: "Lea County Regional Airport",
    city: "Hobbs",
    country: "US",
    continent: "NA",
    lat: 32.6875,
    lon: -103.217,
    elevation: 3661,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHON": {
    icao: "KHON",
    iata: "HON",
    name: "Huron Regional Airport",
    city: "Huron",
    country: "US",
    continent: "NA",
    lat: 44.3852,
    lon: -98.2285,
    elevation: 1289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHOP": {
    icao: "KHOP",
    iata: "HOP",
    name: "Campbell Army Airfield (Fort Campbell)",
    city: "Fort Campbell",
    country: "US",
    continent: "NA",
    lat: 36.6742,
    lon: -87.4897,
    elevation: 573,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHOT": {
    icao: "KHOT",
    iata: "HOT",
    name: "Memorial Field Airport",
    city: "Hot Springs",
    country: "US",
    continent: "NA",
    lat: 34.4788,
    lon: -93.0963,
    elevation: 540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHOU": {
    icao: "KHOU",
    iata: "HOU",
    name: "William P Hobby Airport",
    city: "Houston",
    country: "US",
    continent: "NA",
    lat: 29.6454,
    lon: -95.2789,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHPN": {
    icao: "KHPN",
    iata: "HPN",
    name: "Westchester County Airport",
    city: "White Plains",
    country: "US",
    continent: "NA",
    lat: 41.067,
    lon: -73.7076,
    elevation: 439,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHQM": {
    icao: "KHQM",
    iata: "HQM",
    name: "Bowerman Airport",
    city: "Hoquiam",
    country: "US",
    continent: "NA",
    lat: 46.9712,
    lon: -123.937,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHRL": {
    icao: "KHRL",
    iata: "HRL",
    name: "Valley International Airport",
    city: "Harlingen",
    country: "US",
    continent: "NA",
    lat: 26.2285,
    lon: -97.6544,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHRO": {
    icao: "KHRO",
    iata: "HRO",
    name: "Boone County Airport",
    city: "Harrison",
    country: "US",
    continent: "NA",
    lat: 36.2615,
    lon: -93.1547,
    elevation: 1365,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHRT": {
    icao: "KHRT",
    iata: "",
    name: "Hurlburt Field",
    city: "Mary Esther",
    country: "US",
    continent: "NA",
    lat: 30.4278,
    lon: -86.6893,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHST": {
    icao: "KHST",
    iata: "HST",
    name: "Homestead ARB Airport",
    city: "Homestead",
    country: "US",
    continent: "NA",
    lat: 25.4886,
    lon: -80.3836,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHSV": {
    icao: "KHSV",
    iata: "HSV",
    name: "Huntsville International Carl T Jones Field",
    city: "Huntsville",
    country: "US",
    continent: "NA",
    lat: 34.6372,
    lon: -86.7751,
    elevation: 629,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHTS": {
    icao: "KHTS",
    iata: "HTS",
    name: "Tri-State Airport / Milton J. Ferguson Field",
    city: "Huntington",
    country: "US",
    continent: "NA",
    lat: 38.3667,
    lon: -82.558,
    elevation: 828,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHUA": {
    icao: "KHUA",
    iata: "HUA",
    name: "Redstone Army Air Field",
    city: "Redstone Arsnl Huntsville",
    country: "US",
    continent: "NA",
    lat: 34.6787,
    lon: -86.6848,
    elevation: 684,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHUF": {
    icao: "KHUF",
    iata: "HUF",
    name: "Terre Haute Regional Airport, Hulman Field",
    city: "Terre Haute",
    country: "US",
    continent: "NA",
    lat: 39.4515,
    lon: -87.3076,
    elevation: 589,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHUL": {
    icao: "KHUL",
    iata: "HUL",
    name: "Houlton International Airport",
    city: "Houlton",
    country: "US",
    continent: "NA",
    lat: 46.1231,
    lon: -67.7921,
    elevation: 489,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHUT": {
    icao: "KHUT",
    iata: "HUT",
    name: "Hutchinson Municipal Airport",
    city: "Hutchinson",
    country: "US",
    continent: "NA",
    lat: 38.0655,
    lon: -97.8606,
    elevation: 1543,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHVN": {
    icao: "KHVN",
    iata: "HVN",
    name: "Tweed New Haven Airport",
    city: "New Haven",
    country: "US",
    continent: "NA",
    lat: 41.2637,
    lon: -72.8868,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHVR": {
    icao: "KHVR",
    iata: "HVR",
    name: "Havre City County Airport",
    city: "Havre",
    country: "US",
    continent: "NA",
    lat: 48.5414,
    lon: -109.7629,
    elevation: 2591,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHXD": {
    icao: "KHXD",
    iata: "HHH",
    name: "Hilton Head Airport",
    city: "Hilton Head Island",
    country: "US",
    continent: "NA",
    lat: 32.2244,
    lon: -80.6975,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHYA": {
    icao: "KHYA",
    iata: "HYA",
    name: "Cape Cod Gateway Airport",
    city: "Hyannis",
    country: "US",
    continent: "NA",
    lat: 41.6693,
    lon: -70.2804,
    elevation: 54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHYI": {
    icao: "KHYI",
    iata: "",
    name: "San Marcos Regional Airport",
    city: "San Marcos",
    country: "US",
    continent: "NA",
    lat: 29.8927,
    lon: -97.863,
    elevation: 597,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHYR": {
    icao: "KHYR",
    iata: "HYR",
    name: "Sawyer County Airport",
    city: "Hayward",
    country: "US",
    continent: "NA",
    lat: 46.0252,
    lon: -91.4443,
    elevation: 1216,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHYS": {
    icao: "KHYS",
    iata: "HYS",
    name: "Hays Regional Airport",
    city: "Hays",
    country: "US",
    continent: "NA",
    lat: 38.8445,
    lon: -99.2731,
    elevation: 1999,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KHZY": {
    icao: "KHZY",
    iata: "JFN",
    name: "Northeast Ohio Regional Airport",
    city: "Ashtabula",
    country: "US",
    continent: "NA",
    lat: 41.778,
    lon: -80.6955,
    elevation: 924,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KI39": {
    icao: "KI39",
    iata: "",
    name: "Central Kentucky Regional Airport",
    city: "Richmond",
    country: "US",
    continent: "NA",
    lat: 37.6308,
    lon: -84.3323,
    elevation: 1002,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIAB": {
    icao: "KIAB",
    iata: "IAB",
    name: "McConnell Air Force Base",
    city: "Wichita",
    country: "US",
    continent: "NA",
    lat: 37.6219,
    lon: -97.2682,
    elevation: 1371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIAD": {
    icao: "KIAD",
    iata: "IAD",
    name: "Washington Dulles International Airport",
    city: "Dulles",
    country: "US",
    continent: "NA",
    lat: 38.9445,
    lon: -77.4558,
    elevation: 312,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KIAG": {
    icao: "KIAG",
    iata: "IAG",
    name: "Niagara Falls International Airport",
    city: "Niagara Falls",
    country: "US",
    continent: "NA",
    lat: 43.1073,
    lon: -78.9462,
    elevation: 589,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIAH": {
    icao: "KIAH",
    iata: "IAH",
    name: "George Bush Intercontinental Houston Airport",
    city: "Houston",
    country: "US",
    continent: "NA",
    lat: 29.9844,
    lon: -95.3414,
    elevation: 97,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KICT": {
    icao: "KICT",
    iata: "ICT",
    name: "Wichita Eisenhower National Airport",
    city: "Wichita",
    country: "US",
    continent: "NA",
    lat: 37.6499,
    lon: -97.4331,
    elevation: 1333,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIDA": {
    icao: "KIDA",
    iata: "IDA",
    name: "Idaho Falls Regional Airport",
    city: "Idaho Falls",
    country: "US",
    continent: "NA",
    lat: 43.5146,
    lon: -112.071,
    elevation: 4744,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIFP": {
    icao: "KIFP",
    iata: "IFP",
    name: "Laughlin Bullhead International Airport",
    city: "Bullhead City",
    country: "US",
    continent: "NA",
    lat: 35.1574,
    lon: -114.56,
    elevation: 701,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIGM": {
    icao: "KIGM",
    iata: "IGM",
    name: "Kingman Airport",
    city: "Kingman",
    country: "US",
    continent: "NA",
    lat: 35.2595,
    lon: -113.938,
    elevation: 3449,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIKK": {
    icao: "KIKK",
    iata: "IKK",
    name: "Greater Kankakee Airport",
    city: "Kankakee",
    country: "US",
    continent: "NA",
    lat: 41.0714,
    lon: -87.8463,
    elevation: 630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KILG": {
    icao: "KILG",
    iata: "ILG",
    name: "Wilmington Airport",
    city: "Wilmington",
    country: "US",
    continent: "NA",
    lat: 39.6787,
    lon: -75.6065,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KILM": {
    icao: "KILM",
    iata: "ILM",
    name: "Wilmington International Airport",
    city: "Wilmington",
    country: "US",
    continent: "NA",
    lat: 34.2706,
    lon: -77.9026,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KILN": {
    icao: "KILN",
    iata: "ILN",
    name: "Wilmington Airpark",
    city: "Wilmington",
    country: "US",
    continent: "NA",
    lat: 39.4279,
    lon: -83.7921,
    elevation: 1077,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIMT": {
    icao: "KIMT",
    iata: "IMT",
    name: "Ford Airport",
    city: "Kingsford",
    country: "US",
    continent: "NA",
    lat: 45.8191,
    lon: -88.1146,
    elevation: 1182,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIND": {
    icao: "KIND",
    iata: "IND",
    name: "Indianapolis International Airport",
    city: "Indianapolis",
    country: "US",
    continent: "NA",
    lat: 39.7173,
    lon: -86.2944,
    elevation: 797,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KINK": {
    icao: "KINK",
    iata: "INK",
    name: "Winkler County Airport",
    city: "Wink",
    country: "US",
    continent: "NA",
    lat: 31.7796,
    lon: -103.201,
    elevation: 2822,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KINL": {
    icao: "KINL",
    iata: "INL",
    name: "Falls International Airport",
    city: "International Falls",
    country: "US",
    continent: "NA",
    lat: 48.5662,
    lon: -93.4031,
    elevation: 1185,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KINT": {
    icao: "KINT",
    iata: "INT",
    name: "Smith Reynolds Airport",
    city: "Winston Salem",
    country: "US",
    continent: "NA",
    lat: 36.1337,
    lon: -80.222,
    elevation: 969,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KINW": {
    icao: "KINW",
    iata: "INW",
    name: "Winslow Lindbergh Regional Airport",
    city: "Winslow",
    country: "US",
    continent: "NA",
    lat: 35.0219,
    lon: -110.723,
    elevation: 4941,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIPL": {
    icao: "KIPL",
    iata: "IPL",
    name: "Imperial County Airport",
    city: "Imperial",
    country: "US",
    continent: "NA",
    lat: 32.8354,
    lon: -115.574,
    elevation: -54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIPT": {
    icao: "KIPT",
    iata: "IPT",
    name: "Williamsport Regional Airport",
    city: "Williamsport",
    country: "US",
    continent: "NA",
    lat: 41.2421,
    lon: -76.9224,
    elevation: 529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIRK": {
    icao: "KIRK",
    iata: "IRK",
    name: "Kirksville Regional Airport",
    city: "Kirksville",
    country: "US",
    continent: "NA",
    lat: 40.0935,
    lon: -92.5449,
    elevation: 966,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KISM": {
    icao: "KISM",
    iata: "ISM",
    name: "Kissimmee Gateway Airport",
    city: "Orlando",
    country: "US",
    continent: "NA",
    lat: 28.2898,
    lon: -81.4371,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KISO": {
    icao: "KISO",
    iata: "ISO",
    name: "Kinston Regional Jetport At Stallings Field",
    city: "Kinston",
    country: "US",
    continent: "NA",
    lat: 35.3314,
    lon: -77.6088,
    elevation: 93,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KISP": {
    icao: "KISP",
    iata: "ISP",
    name: "Long Island Mac Arthur Airport",
    city: "Islip",
    country: "US",
    continent: "NA",
    lat: 40.7952,
    lon: -73.1002,
    elevation: 99,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KITH": {
    icao: "KITH",
    iata: "ITH",
    name: "Ithaca Tompkins Regional Airport",
    city: "Ithaca",
    country: "US",
    continent: "NA",
    lat: 42.491,
    lon: -76.4584,
    elevation: 1099,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KIWA": {
    icao: "KIWA",
    iata: "AZA",
    name: "Mesa Gateway Airport",
    city: "Mesa",
    country: "US",
    continent: "NA",
    lat: 33.3078,
    lon: -111.655,
    elevation: 1382,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJAC": {
    icao: "KJAC",
    iata: "JAC",
    name: "Jackson Hole Airport",
    city: "Jackson",
    country: "US",
    continent: "NA",
    lat: 43.6073,
    lon: -110.738,
    elevation: 6451,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJAN": {
    icao: "KJAN",
    iata: "JAN",
    name: "Jackson-Medgar Wiley Evers International Airport",
    city: "Jackson",
    country: "US",
    continent: "NA",
    lat: 32.3112,
    lon: -90.0759,
    elevation: 346,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJAX": {
    icao: "KJAX",
    iata: "JAX",
    name: "Jacksonville International Airport",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 30.4925,
    lon: -81.6878,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KJBR": {
    icao: "KJBR",
    iata: "JBR",
    name: "Jonesboro Municipal Airport",
    city: "Jonesboro",
    country: "US",
    continent: "NA",
    lat: 35.8317,
    lon: -90.6464,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJCT": {
    icao: "KJCT",
    iata: "JCT",
    name: "Kimble County Airport",
    city: "Junction",
    country: "US",
    continent: "NA",
    lat: 30.5113,
    lon: -99.7635,
    elevation: 1749,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJFK": {
    icao: "KJFK",
    iata: "JFK",
    name: "John F Kennedy International Airport",
    city: "New York",
    country: "US",
    continent: "NA",
    lat: 40.6394,
    lon: -73.7793,
    elevation: 13,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KJHW": {
    icao: "KJHW",
    iata: "JHW",
    name: "Chautauqua County-Jamestown Airport",
    city: "Jamestown",
    country: "US",
    continent: "NA",
    lat: 42.1542,
    lon: -79.254,
    elevation: 1723,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJKL": {
    icao: "KJKL",
    iata: "",
    name: "Julian Carroll Airport",
    city: "Jackson",
    country: "US",
    continent: "NA",
    lat: 37.5939,
    lon: -83.3173,
    elevation: 1381,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJLN": {
    icao: "KJLN",
    iata: "JLN",
    name: "Joplin Regional Airport",
    city: "Joplin",
    country: "US",
    continent: "NA",
    lat: 37.1518,
    lon: -94.4983,
    elevation: 981,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJMS": {
    icao: "KJMS",
    iata: "JMS",
    name: "Jamestown Regional Airport",
    city: "Jamestown",
    country: "US",
    continent: "NA",
    lat: 46.9297,
    lon: -98.6782,
    elevation: 1500,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJNX": {
    icao: "KJNX",
    iata: "",
    name: "Johnston Regional Airport",
    city: "Smithfield",
    country: "US",
    continent: "NA",
    lat: 35.5409,
    lon: -78.3903,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJQF": {
    icao: "KJQF",
    iata: "USA",
    name: "Concord-Padgett Regional Airport",
    city: "Concord",
    country: "US",
    continent: "NA",
    lat: 35.3878,
    lon: -80.7091,
    elevation: 705,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJST": {
    icao: "KJST",
    iata: "JST",
    name: "John Murtha Johnstown Cambria County Airport",
    city: "Johnstown",
    country: "US",
    continent: "NA",
    lat: 40.3161,
    lon: -78.8339,
    elevation: 2284,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJWY": {
    icao: "KJWY",
    iata: "",
    name: "Mid-Way Regional Airport",
    city: "Midlothian/Waxahachie",
    country: "US",
    continent: "NA",
    lat: 32.4587,
    lon: -96.9124,
    elevation: 713,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KJXN": {
    icao: "KJXN",
    iata: "JXN",
    name: "Jackson County Airport/Reynolds Field",
    city: "Jackson",
    country: "US",
    continent: "NA",
    lat: 42.2605,
    lon: -84.463,
    elevation: 1001,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KKLS": {
    icao: "KKLS",
    iata: "KLS",
    name: "Southwest Washington Regional Airport",
    city: "Kelso",
    country: "US",
    continent: "NA",
    lat: 46.118,
    lon: -122.898,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KL45": {
    icao: "KL45",
    iata: "",
    name: "Bakersfield International Airport",
    city: "Bakersfield",
    country: "US",
    continent: "NA",
    lat: 35.3248,
    lon: -118.996,
    elevation: 378,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAA": {
    icao: "KLAA",
    iata: "LAA",
    name: "Southeast Colorado Regional Airport",
    city: "Lamar",
    country: "US",
    continent: "NA",
    lat: 38.0664,
    lon: -102.6914,
    elevation: 3706,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAF": {
    icao: "KLAF",
    iata: "LAF",
    name: "Purdue University Airport",
    city: "West Lafayette",
    country: "US",
    continent: "NA",
    lat: 40.4129,
    lon: -86.9394,
    elevation: 606,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAL": {
    icao: "KLAL",
    iata: "LAL",
    name: "Lakeland Linder International Airport",
    city: "Lakeland",
    country: "US",
    continent: "NA",
    lat: 27.9877,
    lon: -82.0188,
    elevation: 142,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAN": {
    icao: "KLAN",
    iata: "LAN",
    name: "Capital City Airport",
    city: "Lansing",
    country: "US",
    continent: "NA",
    lat: 42.7787,
    lon: -84.5874,
    elevation: 861,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAR": {
    icao: "KLAR",
    iata: "LAR",
    name: "Laramie Regional Airport",
    city: "Laramie",
    country: "US",
    continent: "NA",
    lat: 41.3121,
    lon: -105.675,
    elevation: 7284,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAS": {
    icao: "KLAS",
    iata: "LAS",
    name: "Harry Reid International Airport",
    city: "Las Vegas",
    country: "US",
    continent: "NA",
    lat: 36.0834,
    lon: -115.1518,
    elevation: 2181,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KLAW": {
    icao: "KLAW",
    iata: "LAW",
    name: "Lawton Fort Sill Regional Airport",
    city: "Lawton",
    country: "US",
    continent: "NA",
    lat: 34.5677,
    lon: -98.4166,
    elevation: 1110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLAX": {
    icao: "KLAX",
    iata: "LAX",
    name: "Los Angeles International Airport",
    city: "Los Angeles",
    country: "US",
    continent: "NA",
    lat: 33.9425,
    lon: -118.408,
    elevation: 125,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KLBB": {
    icao: "KLBB",
    iata: "LBB",
    name: "Lubbock Preston Smith International Airport",
    city: "Lubbock",
    country: "US",
    continent: "NA",
    lat: 33.6636,
    lon: -101.823,
    elevation: 3282,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLBE": {
    icao: "KLBE",
    iata: "LBE",
    name: "Arnold Palmer Regional Airport",
    city: "Latrobe",
    country: "US",
    continent: "NA",
    lat: 40.2759,
    lon: -79.4048,
    elevation: 1199,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLBF": {
    icao: "KLBF",
    iata: "LBF",
    name: "North Platte Regional Airport Lee Bird Field",
    city: "North Platte",
    country: "US",
    continent: "NA",
    lat: 41.1262,
    lon: -100.684,
    elevation: 2777,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLBL": {
    icao: "KLBL",
    iata: "LBL",
    name: "Liberal Mid-America Regional Airport",
    city: "Liberal",
    country: "US",
    continent: "NA",
    lat: 37.0442,
    lon: -100.96,
    elevation: 2885,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLBT": {
    icao: "KLBT",
    iata: "LBT",
    name: "Lumberton Regional Airport",
    city: "Lumberton",
    country: "US",
    continent: "NA",
    lat: 34.6108,
    lon: -79.0594,
    elevation: 126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLBX": {
    icao: "KLBX",
    iata: "LJN",
    name: "Texas Gulf Coast Regional Airport",
    city: "Angleton",
    country: "US",
    continent: "NA",
    lat: 29.1086,
    lon: -95.4621,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLCH": {
    icao: "KLCH",
    iata: "LCH",
    name: "Lake Charles Regional Airport",
    city: "Lake Charles",
    country: "US",
    continent: "NA",
    lat: 30.1261,
    lon: -93.2233,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLCK": {
    icao: "KLCK",
    iata: "LCK",
    name: "Rickenbacker International Airport",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 39.8138,
    lon: -82.9278,
    elevation: 744,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLEB": {
    icao: "KLEB",
    iata: "LEB",
    name: "Lebanon Municipal Airport",
    city: "Lebanon",
    country: "US",
    continent: "NA",
    lat: 43.6261,
    lon: -72.3042,
    elevation: 603,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLEE": {
    icao: "KLEE",
    iata: "LEE",
    name: "Leesburg International Airport",
    city: "Leesburg",
    country: "US",
    continent: "NA",
    lat: 28.8231,
    lon: -81.8087,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLEX": {
    icao: "KLEX",
    iata: "LEX",
    name: "Blue Grass Airport",
    city: "Lexington",
    country: "US",
    continent: "NA",
    lat: 38.0365,
    lon: -84.6059,
    elevation: 979,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLFI": {
    icao: "KLFI",
    iata: "LFI",
    name: "Langley Air Force Base",
    city: "Hampton",
    country: "US",
    continent: "NA",
    lat: 37.0829,
    lon: -76.3605,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLFK": {
    icao: "KLFK",
    iata: "LFK",
    name: "Angelina County Airport",
    city: "Lufkin",
    country: "US",
    continent: "NA",
    lat: 31.234,
    lon: -94.75,
    elevation: 296,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLFT": {
    icao: "KLFT",
    iata: "LFT",
    name: "Lafayette Regional Airport",
    city: "Lafayette",
    country: "US",
    continent: "NA",
    lat: 30.2053,
    lon: -91.9876,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLGA": {
    icao: "KLGA",
    iata: "LGA",
    name: "LaGuardia Airport",
    city: "New York",
    country: "US",
    continent: "NA",
    lat: 40.7772,
    lon: -73.8726,
    elevation: 21,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KLGB": {
    icao: "KLGB",
    iata: "LGB",
    name: "Long Beach Airport (Daugherty Field)",
    city: "Long Beach",
    country: "US",
    continent: "NA",
    lat: 33.8165,
    lon: -118.1499,
    elevation: 60,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLGU": {
    icao: "KLGU",
    iata: "LGU",
    name: "Logan-Cache Airport",
    city: "Logan",
    country: "US",
    continent: "NA",
    lat: 41.7912,
    lon: -111.852,
    elevation: 4457,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLIT": {
    icao: "KLIT",
    iata: "LIT",
    name: "Bill & Hillary Clinton National Airport/Adams Field",
    city: "Little Rock",
    country: "US",
    continent: "NA",
    lat: 34.7296,
    lon: -92.2237,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLLQ": {
    icao: "KLLQ",
    iata: "",
    name: "Monticello Municipal Ellis Field",
    city: "Monticello",
    country: "US",
    continent: "NA",
    lat: 33.6386,
    lon: -91.751,
    elevation: 270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLMT": {
    icao: "KLMT",
    iata: "LMT",
    name: "Crater Lake-Klamath Regional Airport",
    city: "Klamath Falls",
    country: "US",
    continent: "NA",
    lat: 42.1561,
    lon: -121.733,
    elevation: 4095,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLND": {
    icao: "KLND",
    iata: "LND",
    name: "Hunt Field",
    city: "Lander",
    country: "US",
    continent: "NA",
    lat: 42.8152,
    lon: -108.73,
    elevation: 5586,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLNK": {
    icao: "KLNK",
    iata: "LNK",
    name: "Lincoln Airport",
    city: "Lincoln",
    country: "US",
    continent: "NA",
    lat: 40.851,
    lon: -96.7592,
    elevation: 1219,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLNS": {
    icao: "KLNS",
    iata: "LNS",
    name: "Lancaster Airport",
    city: "Lancaster",
    country: "US",
    continent: "NA",
    lat: 40.1217,
    lon: -76.2961,
    elevation: 403,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLOL": {
    icao: "KLOL",
    iata: "LOL",
    name: "Derby Field",
    city: "Lovelock",
    country: "US",
    continent: "NA",
    lat: 40.0664,
    lon: -118.565,
    elevation: 3904,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLOU": {
    icao: "KLOU",
    iata: "LOU",
    name: "Bowman Field",
    city: "Louisville",
    country: "US",
    continent: "NA",
    lat: 38.228,
    lon: -85.6637,
    elevation: 546,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLOZ": {
    icao: "KLOZ",
    iata: "LOZ",
    name: "London-Corbin Airport/Magee Field",
    city: "London",
    country: "US",
    continent: "NA",
    lat: 37.0822,
    lon: -84.0849,
    elevation: 1212,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLRD": {
    icao: "KLRD",
    iata: "LRD",
    name: "Laredo International Airport",
    city: "Laredo",
    country: "US",
    continent: "NA",
    lat: 27.5438,
    lon: -99.4616,
    elevation: 508,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLRF": {
    icao: "KLRF",
    iata: "LRF",
    name: "Little Rock Air Force Base",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 34.9169,
    lon: -92.1497,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLRU": {
    icao: "KLRU",
    iata: "LRU",
    name: "Las Cruces International Airport",
    city: "Las Cruces",
    country: "US",
    continent: "NA",
    lat: 32.2894,
    lon: -106.922,
    elevation: 4456,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLSE": {
    icao: "KLSE",
    iata: "LSE",
    name: "La Crosse Regional Airport",
    city: "La Crosse",
    country: "US",
    continent: "NA",
    lat: 43.879,
    lon: -91.2567,
    elevation: 655,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLSF": {
    icao: "KLSF",
    iata: "LSF",
    name: "Lawson Army Air Field",
    city: "Fort Benning",
    country: "US",
    continent: "NA",
    lat: 32.3325,
    lon: -84.988,
    elevation: 232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLSV": {
    icao: "KLSV",
    iata: "LSV",
    name: "Nellis Air Force Base",
    city: "Las Vegas",
    country: "US",
    continent: "NA",
    lat: 36.2362,
    lon: -115.034,
    elevation: 1870,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLTS": {
    icao: "KLTS",
    iata: "LTS",
    name: "Altus Air Force Base",
    city: "Altus",
    country: "US",
    continent: "NA",
    lat: 34.6671,
    lon: -99.2667,
    elevation: 1382,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLUF": {
    icao: "KLUF",
    iata: "LUF",
    name: "Luke Air Force Base",
    city: "Glendale",
    country: "US",
    continent: "NA",
    lat: 33.535,
    lon: -112.383,
    elevation: 1085,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLUK": {
    icao: "KLUK",
    iata: "LUK",
    name: "Cincinnati Municipal Airport Lunken Field",
    city: "Cincinnati",
    country: "US",
    continent: "NA",
    lat: 39.1024,
    lon: -84.4189,
    elevation: 483,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLVM": {
    icao: "KLVM",
    iata: "LVM",
    name: "Mission Field",
    city: "Livingston",
    country: "US",
    continent: "NA",
    lat: 45.6994,
    lon: -110.448,
    elevation: 4660,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLVS": {
    icao: "KLVS",
    iata: "LVS",
    name: "Las Vegas Municipal Airport",
    city: "Las Vegas",
    country: "US",
    continent: "NA",
    lat: 35.6542,
    lon: -105.142,
    elevation: 6877,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLWB": {
    icao: "KLWB",
    iata: "LWB",
    name: "Greenbrier Valley Airport",
    city: "Lewisburg",
    country: "US",
    continent: "NA",
    lat: 37.8579,
    lon: -80.4004,
    elevation: 2302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLWM": {
    icao: "KLWM",
    iata: "LWM",
    name: "Lawrence Municipal Airport",
    city: "Lawrence",
    country: "US",
    continent: "NA",
    lat: 42.7172,
    lon: -71.1234,
    elevation: 148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLWS": {
    icao: "KLWS",
    iata: "LWS",
    name: "Lewiston Nez Perce County Airport",
    city: "Lewiston",
    country: "US",
    continent: "NA",
    lat: 46.3745,
    lon: -117.015,
    elevation: 1442,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLWT": {
    icao: "KLWT",
    iata: "LWT",
    name: "Lewistown Municipal Airport",
    city: "Lewistown",
    country: "US",
    continent: "NA",
    lat: 47.0484,
    lon: -109.4661,
    elevation: 4170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KLYH": {
    icao: "KLYH",
    iata: "LYH",
    name: "Lynchburg Regional Airport - Preston Glenn Field",
    city: "Lynchburg",
    country: "US",
    continent: "NA",
    lat: 37.3267,
    lon: -79.2004,
    elevation: 938,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMAF": {
    icao: "KMAF",
    iata: "MAF",
    name: "Midland International Air and Space Port",
    city: "Midland",
    country: "US",
    continent: "NA",
    lat: 31.9425,
    lon: -102.202,
    elevation: 2871,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMBG": {
    icao: "KMBG",
    iata: "MBG",
    name: "Mobridge Municipal Airport",
    city: "Mobridge",
    country: "US",
    continent: "NA",
    lat: 45.5465,
    lon: -100.408,
    elevation: 1716,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMBS": {
    icao: "KMBS",
    iata: "MBS",
    name: "MBS International Airport",
    city: "Freeland",
    country: "US",
    continent: "NA",
    lat: 43.5319,
    lon: -84.0823,
    elevation: 668,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCB": {
    icao: "KMCB",
    iata: "MCB",
    name: "McComb-Pike County Airport / John E Lewis Field",
    city: "McComb",
    country: "US",
    continent: "NA",
    lat: 31.1785,
    lon: -90.4719,
    elevation: 413,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCC": {
    icao: "KMCC",
    iata: "MCC",
    name: "McClellan Airfield",
    city: "Sacramento",
    country: "US",
    continent: "NA",
    lat: 38.6676,
    lon: -121.401,
    elevation: 77,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCE": {
    icao: "KMCE",
    iata: "MCE",
    name: "Merced Regional Macready Field",
    city: "Merced",
    country: "US",
    continent: "NA",
    lat: 37.2847,
    lon: -120.514,
    elevation: 155,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCF": {
    icao: "KMCF",
    iata: "MCF",
    name: "MacDill Air Force Base",
    city: "Tampa",
    country: "US",
    continent: "NA",
    lat: 27.8493,
    lon: -82.5212,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCI": {
    icao: "KMCI",
    iata: "MCI",
    name: "Kansas City International Airport",
    city: "Kansas City",
    country: "US",
    continent: "NA",
    lat: 39.2976,
    lon: -94.7139,
    elevation: 1026,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KMCK": {
    icao: "KMCK",
    iata: "MCK",
    name: "McCook Ben Nelson Regional Airport",
    city: "McCook",
    country: "US",
    continent: "NA",
    lat: 40.2078,
    lon: -100.5928,
    elevation: 2583,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCN": {
    icao: "KMCN",
    iata: "MCN",
    name: "Middle Georgia Regional Airport",
    city: "Macon",
    country: "US",
    continent: "NA",
    lat: 32.6928,
    lon: -83.6492,
    elevation: 354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMCO": {
    icao: "KMCO",
    iata: "MCO",
    name: "Orlando International Airport",
    city: "Orlando",
    country: "US",
    continent: "NA",
    lat: 28.4294,
    lon: -81.309,
    elevation: 96,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KMCW": {
    icao: "KMCW",
    iata: "MCW",
    name: "Mason City Municipal Airport",
    city: "Mason City",
    country: "US",
    continent: "NA",
    lat: 43.1598,
    lon: -93.3297,
    elevation: 1213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMDH": {
    icao: "KMDH",
    iata: "MDH",
    name: "Southern Illinois Airport",
    city: "Murphysboro",
    country: "US",
    continent: "NA",
    lat: 37.7781,
    lon: -89.252,
    elevation: 411,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMDT": {
    icao: "KMDT",
    iata: "MDT",
    name: "Harrisburg International Airport",
    city: "Harrisburg",
    country: "US",
    continent: "NA",
    lat: 40.1935,
    lon: -76.7634,
    elevation: 310,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMDW": {
    icao: "KMDW",
    iata: "MDW",
    name: "Chicago Midway International Airport",
    city: "Chicago",
    country: "US",
    continent: "NA",
    lat: 41.786,
    lon: -87.7524,
    elevation: 620,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KMEI": {
    icao: "KMEI",
    iata: "MEI",
    name: "Key Field / Meridian Regional Airport",
    city: "Meridian",
    country: "US",
    continent: "NA",
    lat: 32.3326,
    lon: -88.7519,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMEM": {
    icao: "KMEM",
    iata: "MEM",
    name: "Memphis International Airport",
    city: "Memphis",
    country: "US",
    continent: "NA",
    lat: 35.0424,
    lon: -89.9767,
    elevation: 341,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KMER": {
    icao: "KMER",
    iata: "MER",
    name: "Castle Airport",
    city: "Merced",
    country: "US",
    continent: "NA",
    lat: 37.3805,
    lon: -120.568,
    elevation: 191,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMFD": {
    icao: "KMFD",
    iata: "MFD",
    name: "Mansfield Lahm Regional Airport",
    city: "Mansfield",
    country: "US",
    continent: "NA",
    lat: 40.8214,
    lon: -82.5166,
    elevation: 1297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMFE": {
    icao: "KMFE",
    iata: "MFE",
    name: "McAllen Miller International Airport",
    city: "McAllen",
    country: "US",
    continent: "NA",
    lat: 26.1761,
    lon: -98.238,
    elevation: 107,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMFR": {
    icao: "KMFR",
    iata: "MFR",
    name: "Rogue Valley International Medford Airport",
    city: "Medford",
    country: "US",
    continent: "NA",
    lat: 42.3742,
    lon: -122.873,
    elevation: 1335,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMGE": {
    icao: "KMGE",
    iata: "MGE",
    name: "Dobbins Air Reserve Base",
    city: "Marietta",
    country: "US",
    continent: "NA",
    lat: 33.9154,
    lon: -84.5163,
    elevation: 1068,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMGM": {
    icao: "KMGM",
    iata: "MGM",
    name: "Montgomery Regional (Dannelly Field) Airport",
    city: "Montgomery",
    country: "US",
    continent: "NA",
    lat: 32.3006,
    lon: -86.394,
    elevation: 221,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMGW": {
    icao: "KMGW",
    iata: "MGW",
    name: "Morgantown Municipal Airport Walter L. (Bill) Hart Field",
    city: "Morgantown",
    country: "US",
    continent: "NA",
    lat: 39.6433,
    lon: -79.9176,
    elevation: 1248,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMHK": {
    icao: "KMHK",
    iata: "MHK",
    name: "Manhattan Regional Airport",
    city: "Manhattan",
    country: "US",
    continent: "NA",
    lat: 39.141,
    lon: -96.6708,
    elevation: 1057,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMHR": {
    icao: "KMHR",
    iata: "MHR",
    name: "Sacramento Mather Airport",
    city: "Sacramento",
    country: "US",
    continent: "NA",
    lat: 38.5547,
    lon: -121.298,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMHT": {
    icao: "KMHT",
    iata: "MHT",
    name: "Manchester-Boston Regional Airport",
    city: "Manchester",
    country: "US",
    continent: "NA",
    lat: 42.9326,
    lon: -71.4357,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMIA": {
    icao: "KMIA",
    iata: "MIA",
    name: "Miami International Airport",
    city: "Miami",
    country: "US",
    continent: "NA",
    lat: 25.7932,
    lon: -80.2906,
    elevation: 8,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KMIB": {
    icao: "KMIB",
    iata: "MIB",
    name: "Minot Air Force Base",
    city: "Minot",
    country: "US",
    continent: "NA",
    lat: 48.4156,
    lon: -101.358,
    elevation: 1667,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMIE": {
    icao: "KMIE",
    iata: "MIE",
    name: "Delaware County Johnson Field",
    city: "Muncie",
    country: "US",
    continent: "NA",
    lat: 40.2423,
    lon: -85.3959,
    elevation: 937,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMIV": {
    icao: "KMIV",
    iata: "MIV",
    name: "Millville Municipal Airport",
    city: "Millville",
    country: "US",
    continent: "NA",
    lat: 39.3678,
    lon: -75.0722,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMKC": {
    icao: "KMKC",
    iata: "MKC",
    name: "Charles B. Wheeler Downtown Airport",
    city: "Kansas City",
    country: "US",
    continent: "NA",
    lat: 39.1232,
    lon: -94.5928,
    elevation: 759,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMKE": {
    icao: "KMKE",
    iata: "MKE",
    name: "General Mitchell International Airport",
    city: "Milwaukee",
    country: "US",
    continent: "NA",
    lat: 42.9472,
    lon: -87.8966,
    elevation: 723,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KMKG": {
    icao: "KMKG",
    iata: "MKG",
    name: "Muskegon County Airport",
    city: "Muskegon",
    country: "US",
    continent: "NA",
    lat: 43.1695,
    lon: -86.2382,
    elevation: 629,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMKL": {
    icao: "KMKL",
    iata: "MKL",
    name: "McKellar-Sipes Regional Airport",
    city: "Jackson",
    country: "US",
    continent: "NA",
    lat: 35.5999,
    lon: -88.9156,
    elevation: 434,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMLB": {
    icao: "KMLB",
    iata: "MLB",
    name: "Melbourne Orlando International Airport",
    city: "Melbourne",
    country: "US",
    continent: "NA",
    lat: 28.1028,
    lon: -80.6453,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMLC": {
    icao: "KMLC",
    iata: "MLC",
    name: "Mc Alester Regional Airport",
    city: "Mc Alester",
    country: "US",
    continent: "NA",
    lat: 34.8824,
    lon: -95.7835,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMLI": {
    icao: "KMLI",
    iata: "MLI",
    name: "Quad City International Airport",
    city: "Moline",
    country: "US",
    continent: "NA",
    lat: 41.4485,
    lon: -90.5075,
    elevation: 590,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMLS": {
    icao: "KMLS",
    iata: "MLS",
    name: "Miles City Airport - Frank Wiley Field",
    city: "Miles City",
    country: "US",
    continent: "NA",
    lat: 46.4273,
    lon: -105.8854,
    elevation: 2630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMLU": {
    icao: "KMLU",
    iata: "MLU",
    name: "Monroe Regional Airport",
    city: "Monroe",
    country: "US",
    continent: "NA",
    lat: 32.5109,
    lon: -92.0377,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMMT": {
    icao: "KMMT",
    iata: "MMT",
    name: "Mc Entire Joint National Guard Base",
    city: "Eastover",
    country: "US",
    continent: "NA",
    lat: 33.9208,
    lon: -80.8013,
    elevation: 254,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMMU": {
    icao: "KMMU",
    iata: "MMU",
    name: "Morristown Municipal Airport",
    city: "Morristown",
    country: "US",
    continent: "NA",
    lat: 40.7991,
    lon: -74.4149,
    elevation: 187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMMV": {
    icao: "KMMV",
    iata: "",
    name: "Mc Minnville Municipal Airport",
    city: "Mc Minnville",
    country: "US",
    continent: "NA",
    lat: 45.1944,
    lon: -123.136,
    elevation: 163,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMOB": {
    icao: "KMOB",
    iata: "MOB",
    name: "Mobile Regional Airport",
    city: "Mobile",
    country: "US",
    continent: "NA",
    lat: 30.6912,
    lon: -88.2428,
    elevation: 219,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMOD": {
    icao: "KMOD",
    iata: "MOD",
    name: "Modesto City Co-Harry Sham Field",
    city: "Modesto",
    country: "US",
    continent: "NA",
    lat: 37.6258,
    lon: -120.954,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMOT": {
    icao: "KMOT",
    iata: "MOT",
    name: "Minot International Airport",
    city: "Minot",
    country: "US",
    continent: "NA",
    lat: 48.2594,
    lon: -101.28,
    elevation: 1716,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMPV": {
    icao: "KMPV",
    iata: "MPV",
    name: "Edward F Knapp State Airport",
    city: "Barre/Montpelier",
    country: "US",
    continent: "NA",
    lat: 44.2035,
    lon: -72.5623,
    elevation: 1166,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMQY": {
    icao: "KMQY",
    iata: "MQY",
    name: "Smyrna Airport",
    city: "Smyrna",
    country: "US",
    continent: "NA",
    lat: 36.009,
    lon: -86.5201,
    elevation: 543,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMRB": {
    icao: "KMRB",
    iata: "MRB",
    name: "Eastern WV Regional Airport/Shepherd Field",
    city: "Martinsburg",
    country: "US",
    continent: "NA",
    lat: 39.4019,
    lon: -77.9846,
    elevation: 565,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMRY": {
    icao: "KMRY",
    iata: "MRY",
    name: "Monterey Peninsula Airport",
    city: "Monterey",
    country: "US",
    continent: "NA",
    lat: 36.587,
    lon: -121.843,
    elevation: 257,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMSL": {
    icao: "KMSL",
    iata: "MSL",
    name: "Northwest Alabama Regional Airport",
    city: "Muscle Shoals",
    country: "US",
    continent: "NA",
    lat: 34.7451,
    lon: -87.613,
    elevation: 551,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMSN": {
    icao: "KMSN",
    iata: "MSN",
    name: "Dane County Regional Truax Field",
    city: "Madison",
    country: "US",
    continent: "NA",
    lat: 43.1399,
    lon: -89.3375,
    elevation: 887,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMSO": {
    icao: "KMSO",
    iata: "MSO",
    name: "Missoula International Airport",
    city: "Missoula",
    country: "US",
    continent: "NA",
    lat: 46.9163,
    lon: -114.091,
    elevation: 3206,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMSP": {
    icao: "KMSP",
    iata: "MSP",
    name: "Minneapolis–Saint Paul International Airport / Wold–Chamberlain Field",
    city: "Minneapolis",
    country: "US",
    continent: "NA",
    lat: 44.8801,
    lon: -93.2217,
    elevation: 841,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KMSS": {
    icao: "KMSS",
    iata: "MSS",
    name: "Massena International Airport Richards Field",
    city: "Massena",
    country: "US",
    continent: "NA",
    lat: 44.9362,
    lon: -74.8443,
    elevation: 215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMSY": {
    icao: "KMSY",
    iata: "MSY",
    name: "Louis Armstrong New Orleans International Airport",
    city: "New Orleans",
    country: "US",
    continent: "NA",
    lat: 29.9934,
    lon: -90.258,
    elevation: 4,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KMTC": {
    icao: "KMTC",
    iata: "MTC",
    name: "Selfridge Air National Guard Base Airport",
    city: "Mount Clemens",
    country: "US",
    continent: "NA",
    lat: 42.6135,
    lon: -82.8369,
    elevation: 580,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMTH": {
    icao: "KMTH",
    iata: "MTH",
    name: "The Florida Keys Marathon Airport",
    city: "Marathon",
    country: "US",
    continent: "NA",
    lat: 24.7261,
    lon: -81.0514,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMTJ": {
    icao: "KMTJ",
    iata: "MTJ",
    name: "Montrose Regional Airport",
    city: "Montrose",
    country: "US",
    continent: "NA",
    lat: 38.5098,
    lon: -107.894,
    elevation: 5759,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMTN": {
    icao: "KMTN",
    iata: "MTN",
    name: "Martin State Airport",
    city: "Baltimore",
    country: "US",
    continent: "NA",
    lat: 39.3257,
    lon: -76.4138,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMUI": {
    icao: "KMUI",
    iata: "MUI",
    name: "Muir Army Air Field (Fort Indiantown Gap) Airport",
    city: "Fort Indiantown Gap(Annville)",
    country: "US",
    continent: "NA",
    lat: 40.4352,
    lon: -76.5687,
    elevation: 488,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMUO": {
    icao: "KMUO",
    iata: "MUO",
    name: "Mountain Home Air Force Base",
    city: "Mountain Home",
    country: "US",
    continent: "NA",
    lat: 43.0436,
    lon: -115.872,
    elevation: 2996,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMWA": {
    icao: "KMWA",
    iata: "MWA",
    name: "Veterans Airport of Southern Illinois",
    city: "Marion",
    country: "US",
    continent: "NA",
    lat: 37.7512,
    lon: -89.0166,
    elevation: 472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMWH": {
    icao: "KMWH",
    iata: "MWH",
    name: "Grant County International Airport",
    city: "Moses Lake",
    country: "US",
    continent: "NA",
    lat: 47.2077,
    lon: -119.32,
    elevation: 1189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMXF": {
    icao: "KMXF",
    iata: "MXF",
    name: "Maxwell Air Force Base",
    city: "Montgomery",
    country: "US",
    continent: "NA",
    lat: 32.3829,
    lon: -86.3658,
    elevation: 171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMYL": {
    icao: "KMYL",
    iata: "MYL",
    name: "McCall Municipal Airport",
    city: "McCall",
    country: "US",
    continent: "NA",
    lat: 44.8888,
    lon: -116.1011,
    elevation: 5024,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMYR": {
    icao: "KMYR",
    iata: "MYR",
    name: "Myrtle Beach International Airport",
    city: "Myrtle Beach",
    country: "US",
    continent: "NA",
    lat: 33.6797,
    lon: -78.9283,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KMYV": {
    icao: "KMYV",
    iata: "MYV",
    name: "Yuba County Airport",
    city: "Marysville",
    country: "US",
    continent: "NA",
    lat: 39.0978,
    lon: -121.57,
    elevation: 64,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNBC": {
    icao: "KNBC",
    iata: "",
    name: "Beaufort MCAS - Merritt Field",
    city: "Beaufort",
    country: "US",
    continent: "NA",
    lat: 32.4774,
    lon: -80.7232,
    elevation: 37,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNBG": {
    icao: "KNBG",
    iata: "NBG",
    name: "New Orleans NAS JRB/Alvin Callender Field",
    city: "New Orleans",
    country: "US",
    continent: "NA",
    lat: 29.8253,
    lon: -90.035,
    elevation: 2,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNCA": {
    icao: "KNCA",
    iata: "",
    name: "MCAS New River / McCutcheon Field",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 34.7084,
    lon: -77.4397,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNDZ": {
    icao: "KNDZ",
    iata: "",
    name: "Whiting Field Naval Air Station South Airport",
    city: "Milton",
    country: "US",
    continent: "NA",
    lat: 30.7044,
    lon: -87.023,
    elevation: 177,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNEL": {
    icao: "KNEL",
    iata: "NEL",
    name: "Lakehurst Maxfield Field Airport",
    city: "Lakehurst",
    country: "US",
    continent: "NA",
    lat: 40.0333,
    lon: -74.3533,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNEW": {
    icao: "KNEW",
    iata: "NEW",
    name: "Lakefront Airport",
    city: "New Orleans",
    country: "US",
    continent: "NA",
    lat: 30.0424,
    lon: -90.0283,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNFG": {
    icao: "KNFG",
    iata: "",
    name: "Camp Pendleton MCAS (Munn Field) Airport",
    city: "Oceanside",
    country: "US",
    continent: "NA",
    lat: 33.3013,
    lon: -117.355,
    elevation: 78,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNFL": {
    icao: "KNFL",
    iata: "NFL",
    name: "Fallon Naval Air Station",
    city: "Fallon",
    country: "US",
    continent: "NA",
    lat: 39.4166,
    lon: -118.701,
    elevation: 3934,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNFW": {
    icao: "KNFW",
    iata: "FWH",
    name: "NAS Fort Worth JRB / Carswell Field",
    city: "Fort Worth",
    country: "US",
    continent: "NA",
    lat: 32.7692,
    lon: -97.4415,
    elevation: 650,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNGP": {
    icao: "KNGP",
    iata: "NGP",
    name: "Naval Air Station Corpus Christi Truax Field",
    city: "Corpus Christi",
    country: "US",
    continent: "NA",
    lat: 27.6926,
    lon: -97.2911,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNGU": {
    icao: "KNGU",
    iata: "NGU",
    name: "Norfolk Naval Station (Chambers Field)",
    city: "Norfolk",
    country: "US",
    continent: "NA",
    lat: 36.9376,
    lon: -76.2893,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNHK": {
    icao: "KNHK",
    iata: "NHK",
    name: "Patuxent River Naval Air Station (Trapnell Field)",
    city: "Patuxent River",
    country: "US",
    continent: "NA",
    lat: 38.286,
    lon: -76.4118,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNID": {
    icao: "KNID",
    iata: "",
    name: "China Lake Naws (Armitage Field) Airport",
    city: "China Lake",
    country: "US",
    continent: "NA",
    lat: 35.6854,
    lon: -117.692,
    elevation: 2283,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNIP": {
    icao: "KNIP",
    iata: "NIP",
    name: "Jacksonville Naval Air Station (Towers Field)",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 30.2358,
    lon: -81.6806,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNJK": {
    icao: "KNJK",
    iata: "NJK",
    name: "El Centro NAF Airport (Vraciu Field)",
    city: "El Centro",
    country: "US",
    continent: "NA",
    lat: 32.8292,
    lon: -115.672,
    elevation: -42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNKT": {
    icao: "KNKT",
    iata: "",
    name: "Cherry Point MCAS / Cunningham Field/",
    city: "Cherry Point",
    country: "US",
    continent: "NA",
    lat: 34.9009,
    lon: -76.8807,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNKX": {
    icao: "KNKX",
    iata: "NKX",
    name: "Miramar Marine Corps Air Station - Mitscher Field",
    city: "San Diego",
    country: "US",
    continent: "NA",
    lat: 32.8684,
    lon: -117.143,
    elevation: 477,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNLC": {
    icao: "KNLC",
    iata: "NLC",
    name: "Lemoore Naval Air Station (Reeves Field) Airport",
    city: "Lemoore",
    country: "US",
    continent: "NA",
    lat: 36.333,
    lon: -119.952,
    elevation: 232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNMM": {
    icao: "KNMM",
    iata: "",
    name: "Naval Air Station Meridian / McCain Field",
    city: "Lauderdale",
    country: "US",
    continent: "NA",
    lat: 32.5531,
    lon: -88.5541,
    elevation: 316,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNPA": {
    icao: "KNPA",
    iata: "NPA",
    name: "Naval Air Station Pensacola Forrest Sherman Field",
    city: "Pensacola",
    country: "US",
    continent: "NA",
    lat: 30.3527,
    lon: -87.3186,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNQA": {
    icao: "KNQA",
    iata: "NQA",
    name: "Millington-Memphis Airport",
    city: "Millington",
    country: "US",
    continent: "NA",
    lat: 35.3567,
    lon: -89.8703,
    elevation: 320,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNQI": {
    icao: "KNQI",
    iata: "NQI",
    name: "Kingsville Naval Air Station",
    city: "Kingsville",
    country: "US",
    continent: "NA",
    lat: 27.5072,
    lon: -97.8097,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNQX": {
    icao: "KNQX",
    iata: "NQX",
    name: "Naval Air Station Key West/Boca Chica Field",
    city: "Key West",
    country: "US",
    continent: "NA",
    lat: 24.5758,
    lon: -81.6889,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNRB": {
    icao: "KNRB",
    iata: "NRB",
    name: "Naval Station Mayport / Admiral David L McDonald Field",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 30.3911,
    lon: -81.4247,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNSE": {
    icao: "KNSE",
    iata: "NSE",
    name: "Whiting Field Naval Air Station - North",
    city: "Milton",
    country: "US",
    continent: "NA",
    lat: 30.7242,
    lon: -87.0219,
    elevation: 199,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNTD": {
    icao: "KNTD",
    iata: "NTD",
    name: "Point Mugu Naval Air Station (Naval Base Ventura Co)",
    city: "Point Mugu",
    country: "US",
    continent: "NA",
    lat: 34.1203,
    lon: -119.121,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNTU": {
    icao: "KNTU",
    iata: "NTU",
    name: "Oceana Naval Air Station",
    city: "Virginia Beach",
    country: "US",
    continent: "NA",
    lat: 36.8207,
    lon: -76.0335,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNUQ": {
    icao: "KNUQ",
    iata: "NUQ",
    name: "Moffett Federal Airfield",
    city: "Mountain View",
    country: "US",
    continent: "NA",
    lat: 37.4161,
    lon: -122.049,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNUW": {
    icao: "KNUW",
    iata: "NUW",
    name: "Whidbey Island Naval Air Station (Ault Field)",
    city: "Oak Harbor",
    country: "US",
    continent: "NA",
    lat: 48.3518,
    lon: -122.656,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNXP": {
    icao: "KNXP",
    iata: "",
    name: "Twentynine Palms Strategic Expeditionary Landing Field",
    city: "Twentynine Palms",
    country: "US",
    continent: "NA",
    lat: 34.2962,
    lon: -116.162,
    elevation: 2051,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNYG": {
    icao: "KNYG",
    iata: "NYG",
    name: "Quantico Marine Corps Airfield / Turner Field",
    city: "Quantico",
    country: "US",
    continent: "NA",
    lat: 38.5017,
    lon: -77.3053,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNYL": {
    icao: "KNYL",
    iata: "YUM",
    name: "Yuma International Airport / Marine Corps Air Station Yuma",
    city: "Yuma",
    country: "US",
    continent: "NA",
    lat: 32.6509,
    lon: -114.6094,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KNZY": {
    icao: "KNZY",
    iata: "NZY",
    name: "North Island Naval Air Station-Halsey Field",
    city: "San Diego",
    country: "US",
    continent: "NA",
    lat: 32.6992,
    lon: -117.215,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOAJ": {
    icao: "KOAJ",
    iata: "OAJ",
    name: "Albert J Ellis Airport",
    city: "Richlands",
    country: "US",
    continent: "NA",
    lat: 34.8292,
    lon: -77.6121,
    elevation: 94,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOAK": {
    icao: "KOAK",
    iata: "OAK",
    name: "San Francisco Bay Oakland International Airport",
    city: "Oakland",
    country: "US",
    continent: "NA",
    lat: 37.7201,
    lon: -122.2212,
    elevation: 9,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KOFF": {
    icao: "KOFF",
    iata: "OFF",
    name: "Offutt Air Force Base",
    city: "Omaha",
    country: "US",
    continent: "NA",
    lat: 41.1193,
    lon: -95.9085,
    elevation: 1052,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOFK": {
    icao: "KOFK",
    iata: "OFK",
    name: "Karl Stefan Memorial Airport",
    city: "Norfolk",
    country: "US",
    continent: "NA",
    lat: 41.9855,
    lon: -97.4351,
    elevation: 1573,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOGB": {
    icao: "KOGB",
    iata: "OGB",
    name: "Orangeburg Municipal Airport",
    city: "Orangeburg",
    country: "US",
    continent: "NA",
    lat: 33.4568,
    lon: -80.8595,
    elevation: 195,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOGD": {
    icao: "KOGD",
    iata: "OGD",
    name: "Ogden Hinckley Airport",
    city: "Ogden",
    country: "US",
    continent: "NA",
    lat: 41.1959,
    lon: -112.012,
    elevation: 4473,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOGS": {
    icao: "KOGS",
    iata: "OGS",
    name: "Ogdensburg International Airport",
    city: "Ogdensburg",
    country: "US",
    continent: "NA",
    lat: 44.6819,
    lon: -75.4655,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOKC": {
    icao: "KOKC",
    iata: "OKC",
    name: "Will Rogers World Airport",
    city: "Oklahoma City",
    country: "US",
    continent: "NA",
    lat: 35.3934,
    lon: -97.5982,
    elevation: 1295,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KOLF": {
    icao: "KOLF",
    iata: "OLF",
    name: "L M Clayton Airport",
    city: "Wolf Point",
    country: "US",
    continent: "NA",
    lat: 48.0945,
    lon: -105.575,
    elevation: 1986,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOLM": {
    icao: "KOLM",
    iata: "OLM",
    name: "Olympia Regional Airport",
    city: "Olympia",
    country: "US",
    continent: "NA",
    lat: 46.9694,
    lon: -122.903,
    elevation: 209,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOLS": {
    icao: "KOLS",
    iata: "OLS",
    name: "Nogales International Airport",
    city: "Nogales",
    country: "US",
    continent: "NA",
    lat: 31.4177,
    lon: -110.848,
    elevation: 3955,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOLU": {
    icao: "KOLU",
    iata: "OLU",
    name: "Columbus Municipal Airport",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 41.4481,
    lon: -97.3402,
    elevation: 1447,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOMA": {
    icao: "KOMA",
    iata: "OMA",
    name: "Eppley Airfield",
    city: "Omaha",
    country: "US",
    continent: "NA",
    lat: 41.3032,
    lon: -95.8941,
    elevation: 984,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KONO": {
    icao: "KONO",
    iata: "ONO",
    name: "Ontario Municipal Airport",
    city: "Oregon",
    country: "US",
    continent: "NA",
    lat: 44.0198,
    lon: -117.0133,
    elevation: 2193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KONP": {
    icao: "KONP",
    iata: "ONP",
    name: "Newport Municipal Airport",
    city: "Newport",
    country: "US",
    continent: "NA",
    lat: 44.5804,
    lon: -124.058,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KONT": {
    icao: "KONT",
    iata: "ONT",
    name: "Ontario International Airport",
    city: "Ontario",
    country: "US",
    continent: "NA",
    lat: 34.056,
    lon: -117.601,
    elevation: 944,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KOPF": {
    icao: "KOPF",
    iata: "OPF",
    name: "Miami-Opa Locka Executive Airport",
    city: "Miami",
    country: "US",
    continent: "NA",
    lat: 25.907,
    lon: -80.2784,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOQU": {
    icao: "KOQU",
    iata: "NCO",
    name: "Quonset State Airport",
    city: "North Kingstown",
    country: "US",
    continent: "NA",
    lat: 41.5971,
    lon: -71.4121,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KORD": {
    icao: "KORD",
    iata: "ORD",
    name: "Chicago O\'Hare International Airport",
    city: "Chicago",
    country: "US",
    continent: "NA",
    lat: 41.9786,
    lon: -87.9048,
    elevation: 680,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KORF": {
    icao: "KORF",
    iata: "ORF",
    name: "Norfolk International Airport",
    city: "Norfolk",
    country: "US",
    continent: "NA",
    lat: 36.8953,
    lon: -76.201,
    elevation: 26,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KORH": {
    icao: "KORH",
    iata: "ORH",
    name: "Worcester Regional Airport",
    city: "Worcester",
    country: "US",
    continent: "NA",
    lat: 42.2673,
    lon: -71.8757,
    elevation: 1009,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KORS": {
    icao: "KORS",
    iata: "ESD",
    name: "Orcas Island Airport",
    city: "Eastsound",
    country: "US",
    continent: "NA",
    lat: 48.7082,
    lon: -122.91,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOSH": {
    icao: "KOSH",
    iata: "OSH",
    name: "Wittman Regional Airport",
    city: "Oshkosh",
    country: "US",
    continent: "NA",
    lat: 43.9844,
    lon: -88.557,
    elevation: 808,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOSU": {
    icao: "KOSU",
    iata: "OSU",
    name: "The Ohio State University Airport - Don Scott Field",
    city: "Columbus",
    country: "US",
    continent: "NA",
    lat: 40.0798,
    lon: -83.073,
    elevation: 905,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOTH": {
    icao: "KOTH",
    iata: "OTH",
    name: "Southwest Oregon Regional Airport",
    city: "North Bend",
    country: "US",
    continent: "NA",
    lat: 43.4171,
    lon: -124.246,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOTM": {
    icao: "KOTM",
    iata: "OTM",
    name: "Ottumwa Regional Airport",
    city: "Ottumwa",
    country: "US",
    continent: "NA",
    lat: 41.1064,
    lon: -92.4498,
    elevation: 845,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOWB": {
    icao: "KOWB",
    iata: "OWB",
    name: "Owensboro Daviess County Airport",
    city: "Owensboro",
    country: "US",
    continent: "NA",
    lat: 37.7401,
    lon: -87.1668,
    elevation: 407,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOWD": {
    icao: "KOWD",
    iata: "OWD",
    name: "Norwood Memorial Airport",
    city: "Norwood",
    country: "US",
    continent: "NA",
    lat: 42.1905,
    lon: -71.1729,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOXR": {
    icao: "KOXR",
    iata: "OXR",
    name: "Oxnard Airport",
    city: "Oxnard",
    country: "US",
    continent: "NA",
    lat: 34.2008,
    lon: -119.207,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KOZR": {
    icao: "KOZR",
    iata: "OZR",
    name: "Cairns AAF (Fort Rucker) Air Field",
    city: "Fort Rucker/Ozark",
    country: "US",
    continent: "NA",
    lat: 31.2757,
    lon: -85.7134,
    elevation: 301,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPAE": {
    icao: "KPAE",
    iata: "PAE",
    name: "Seattle Paine Field International Airport",
    city: "Everett",
    country: "US",
    continent: "NA",
    lat: 47.9063,
    lon: -122.282,
    elevation: 606,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPAH": {
    icao: "KPAH",
    iata: "PAH",
    name: "Barkley Regional Airport",
    city: "Paducah",
    country: "US",
    continent: "NA",
    lat: 37.0608,
    lon: -88.7738,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPAM": {
    icao: "KPAM",
    iata: "PAM",
    name: "Tyndall Air Force Base",
    city: "Panama City",
    country: "US",
    continent: "NA",
    lat: 30.0696,
    lon: -85.5754,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPAO": {
    icao: "KPAO",
    iata: "PAO",
    name: "Palo Alto Airport",
    city: "Palo Alto",
    country: "US",
    continent: "NA",
    lat: 37.4611,
    lon: -122.115,
    elevation: 4,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPBF": {
    icao: "KPBF",
    iata: "PBF",
    name: "Pine Bluff Regional Airport, Grider Field",
    city: "Pine Bluff",
    country: "US",
    continent: "NA",
    lat: 34.1741,
    lon: -91.9356,
    elevation: 206,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPBG": {
    icao: "KPBG",
    iata: "PBG",
    name: "Plattsburgh International Airport",
    city: "Plattsburgh",
    country: "US",
    continent: "NA",
    lat: 44.6509,
    lon: -73.4681,
    elevation: 234,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPBI": {
    icao: "KPBI",
    iata: "PBI",
    name: "Palm Beach International Airport",
    city: "West Palm Beach",
    country: "US",
    continent: "NA",
    lat: 26.6832,
    lon: -80.0956,
    elevation: 19,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KPCW": {
    icao: "KPCW",
    iata: "",
    name: "Carl R Keller Field",
    city: "Port Clinton",
    country: "US",
    continent: "NA",
    lat: 41.5156,
    lon: -82.8683,
    elevation: 590,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPDK": {
    icao: "KPDK",
    iata: "PDK",
    name: "DeKalb Peachtree Airport",
    city: "Atlanta",
    country: "US",
    continent: "NA",
    lat: 33.8763,
    lon: -84.3021,
    elevation: 1003,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPDT": {
    icao: "KPDT",
    iata: "PDT",
    name: "Eastern Oregon Regional Airport at Pendleton",
    city: "Pendleton",
    country: "US",
    continent: "NA",
    lat: 45.6951,
    lon: -118.841,
    elevation: 1497,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPDX": {
    icao: "KPDX",
    iata: "PDX",
    name: "Portland International Airport",
    city: "Portland",
    country: "US",
    continent: "NA",
    lat: 45.5887,
    lon: -122.598,
    elevation: 31,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KPGA": {
    icao: "KPGA",
    iata: "PGA",
    name: "Page Municipal Airport",
    city: "Page",
    country: "US",
    continent: "NA",
    lat: 36.9242,
    lon: -111.4477,
    elevation: 4316,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPGD": {
    icao: "KPGD",
    iata: "PGD",
    name: "Punta Gorda Airport",
    city: "Punta Gorda",
    country: "US",
    continent: "NA",
    lat: 26.9202,
    lon: -81.9905,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPGV": {
    icao: "KPGV",
    iata: "PGV",
    name: "Pitt-Greenville Airport",
    city: "Greenville",
    country: "US",
    continent: "NA",
    lat: 35.6355,
    lon: -77.3843,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPHF": {
    icao: "KPHF",
    iata: "PHF",
    name: "Newport News Williamsburg International Airport",
    city: "Newport News",
    country: "US",
    continent: "NA",
    lat: 37.1319,
    lon: -76.493,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPHL": {
    icao: "KPHL",
    iata: "PHL",
    name: "Philadelphia International Airport",
    city: "Philadelphia",
    country: "US",
    continent: "NA",
    lat: 39.8719,
    lon: -75.2411,
    elevation: 36,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KPHX": {
    icao: "KPHX",
    iata: "PHX",
    name: "Phoenix Sky Harbor International Airport",
    city: "Phoenix",
    country: "US",
    continent: "NA",
    lat: 33.4353,
    lon: -112.0059,
    elevation: 1135,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KPIA": {
    icao: "KPIA",
    iata: "PIA",
    name: "General Wayne A. Downing Peoria International Airport",
    city: "Peoria",
    country: "US",
    continent: "NA",
    lat: 40.6642,
    lon: -89.6933,
    elevation: 660,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPIB": {
    icao: "KPIB",
    iata: "PIB",
    name: "Hattiesburg Laurel Regional Airport",
    city: "Moselle",
    country: "US",
    continent: "NA",
    lat: 31.4671,
    lon: -89.3371,
    elevation: 298,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPIE": {
    icao: "KPIE",
    iata: "PIE",
    name: "St. Petersburg Clearwater International Airport",
    city: "Pinellas Park",
    country: "US",
    continent: "NA",
    lat: 27.9102,
    lon: -82.6874,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPIH": {
    icao: "KPIH",
    iata: "PIH",
    name: "Pocatello Regional Airport",
    city: "Pocatello",
    country: "US",
    continent: "NA",
    lat: 42.9098,
    lon: -112.596,
    elevation: 4452,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPIR": {
    icao: "KPIR",
    iata: "PIR",
    name: "Pierre Regional Airport",
    city: "Pierre",
    country: "US",
    continent: "NA",
    lat: 44.3827,
    lon: -100.286,
    elevation: 1744,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPIT": {
    icao: "KPIT",
    iata: "PIT",
    name: "Pittsburgh International Airport",
    city: "Pittsburgh",
    country: "US",
    continent: "NA",
    lat: 40.4915,
    lon: -80.2329,
    elevation: 1203,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KPKB": {
    icao: "KPKB",
    iata: "PKB",
    name: "Mid Ohio Valley Regional Airport",
    city: "Parkersburg (Williamstown)",
    country: "US",
    continent: "NA",
    lat: 39.3451,
    lon: -81.4392,
    elevation: 858,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPLN": {
    icao: "KPLN",
    iata: "PLN",
    name: "Pellston Regional Airport of Emmet County Airport",
    city: "Pellston",
    country: "US",
    continent: "NA",
    lat: 45.5709,
    lon: -84.7967,
    elevation: 721,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPMD": {
    icao: "KPMD",
    iata: "PMD",
    name: "Palmdale Regional Airport / USAF Plant 42 Airport",
    city: "Palmdale",
    country: "US",
    continent: "NA",
    lat: 34.6294,
    lon: -118.085,
    elevation: 2543,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPNA": {
    icao: "KPNA",
    iata: "PWY",
    name: "Ralph Wenz Field",
    city: "Pinedale",
    country: "US",
    continent: "NA",
    lat: 42.7955,
    lon: -109.807,
    elevation: 7102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPNC": {
    icao: "KPNC",
    iata: "PNC",
    name: "Ponca City Regional Airport",
    city: "Ponca City",
    country: "US",
    continent: "NA",
    lat: 36.732,
    lon: -97.0998,
    elevation: 1008,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPNE": {
    icao: "KPNE",
    iata: "PNE",
    name: "Northeast Philadelphia Airport",
    city: "Philadelphia",
    country: "US",
    continent: "NA",
    lat: 40.0824,
    lon: -75.0106,
    elevation: 120,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPNS": {
    icao: "KPNS",
    iata: "PNS",
    name: "Pensacola International Airport",
    city: "Pensacola",
    country: "US",
    continent: "NA",
    lat: 30.4734,
    lon: -87.1866,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPOB": {
    icao: "KPOB",
    iata: "POB",
    name: "Pope Field",
    city: "Fort Bragg",
    country: "US",
    continent: "NA",
    lat: 35.1709,
    lon: -79.0145,
    elevation: 217,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPOE": {
    icao: "KPOE",
    iata: "POE",
    name: "Polk Army Air Field",
    city: "Fort Polk",
    country: "US",
    continent: "NA",
    lat: 31.0448,
    lon: -93.1917,
    elevation: 330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPOU": {
    icao: "KPOU",
    iata: "POU",
    name: "Dutchess County Airport",
    city: "Poughkeepsie",
    country: "US",
    continent: "NA",
    lat: 41.6266,
    lon: -73.8842,
    elevation: 165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPQI": {
    icao: "KPQI",
    iata: "PQI",
    name: "Presque Isle International Airport",
    city: "Presque Isle",
    country: "US",
    continent: "NA",
    lat: 46.689,
    lon: -68.0448,
    elevation: 534,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPRB": {
    icao: "KPRB",
    iata: "PRB",
    name: "Paso Robles Municipal Airport",
    city: "Paso Robles",
    country: "US",
    continent: "NA",
    lat: 35.6729,
    lon: -120.627,
    elevation: 840,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPRC": {
    icao: "KPRC",
    iata: "PRC",
    name: "Prescott International Airport - Ernest A. Love Field",
    city: "Prescott",
    country: "US",
    continent: "NA",
    lat: 34.6545,
    lon: -112.42,
    elevation: 5045,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPRX": {
    icao: "KPRX",
    iata: "PRX",
    name: "Cox Field",
    city: "Paris",
    country: "US",
    continent: "NA",
    lat: 33.6366,
    lon: -95.4508,
    elevation: 547,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPSC": {
    icao: "KPSC",
    iata: "PSC",
    name: "Tri Cities Airport",
    city: "Pasco",
    country: "US",
    continent: "NA",
    lat: 46.2647,
    lon: -119.119,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPSM": {
    icao: "KPSM",
    iata: "PSM",
    name: "Portsmouth International at Pease Airport",
    city: "Portsmouth",
    country: "US",
    continent: "NA",
    lat: 43.0779,
    lon: -70.8233,
    elevation: 100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPSP": {
    icao: "KPSP",
    iata: "PSP",
    name: "Palm Springs International Airport",
    city: "Palm Springs",
    country: "US",
    continent: "NA",
    lat: 33.8297,
    lon: -116.507,
    elevation: 477,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPTK": {
    icao: "KPTK",
    iata: "PTK",
    name: "Oakland County International Airport",
    city: "Pontiac",
    country: "US",
    continent: "NA",
    lat: 42.6655,
    lon: -83.4201,
    elevation: 980,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPUB": {
    icao: "KPUB",
    iata: "PUB",
    name: "Pueblo Memorial Airport",
    city: "Pueblo",
    country: "US",
    continent: "NA",
    lat: 38.2891,
    lon: -104.497,
    elevation: 4726,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPUW": {
    icao: "KPUW",
    iata: "PUW",
    name: "Pullman-Moscow Regional Airport",
    city: "Pullman",
    country: "US",
    continent: "NA",
    lat: 46.7416,
    lon: -117.1116,
    elevation: 2556,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPVD": {
    icao: "KPVD",
    iata: "PVD",
    name: "Theodore Francis Green State Airport",
    city: "Warwick",
    country: "US",
    continent: "NA",
    lat: 41.725,
    lon: -71.4257,
    elevation: 55,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KPVU": {
    icao: "KPVU",
    iata: "PVU",
    name: "Provo-Utah Lake International Airport",
    city: "Provo",
    country: "US",
    continent: "NA",
    lat: 40.2192,
    lon: -111.723,
    elevation: 4497,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPWK": {
    icao: "KPWK",
    iata: "PWK",
    name: "Chicago Executive Airport",
    city: "Chicago/Prospect Heights/Wheeling",
    country: "US",
    continent: "NA",
    lat: 42.1142,
    lon: -87.9015,
    elevation: 647,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KPWM": {
    icao: "KPWM",
    iata: "PWM",
    name: "Portland International Jetport",
    city: "Portland",
    country: "US",
    continent: "NA",
    lat: 43.6462,
    lon: -70.3093,
    elevation: 76,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KPWT": {
    icao: "KPWT",
    iata: "PWT",
    name: "Bremerton National Airport",
    city: "Bremerton",
    country: "US",
    continent: "NA",
    lat: 47.4902,
    lon: -122.765,
    elevation: 444,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRAL": {
    icao: "KRAL",
    iata: "RAL",
    name: "Riverside Municipal Airport",
    city: "Riverside",
    country: "US",
    continent: "NA",
    lat: 33.9519,
    lon: -117.445,
    elevation: 819,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRAP": {
    icao: "KRAP",
    iata: "RAP",
    name: "Rapid City Regional Airport",
    city: "Rapid City",
    country: "US",
    continent: "NA",
    lat: 44.0453,
    lon: -103.057,
    elevation: 3204,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRBL": {
    icao: "KRBL",
    iata: "RBL",
    name: "Red Bluff Municipal Airport",
    city: "Red Bluff",
    country: "US",
    continent: "NA",
    lat: 40.1507,
    lon: -122.252,
    elevation: 352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRCA": {
    icao: "KRCA",
    iata: "RCA",
    name: "Ellsworth Air Force Base",
    city: "Rapid City",
    country: "US",
    continent: "NA",
    lat: 44.145,
    lon: -103.104,
    elevation: 3276,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRDD": {
    icao: "KRDD",
    iata: "RDD",
    name: "Redding Municipal Airport",
    city: "Redding",
    country: "US",
    continent: "NA",
    lat: 40.509,
    lon: -122.293,
    elevation: 505,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRDG": {
    icao: "KRDG",
    iata: "RDG",
    name: "Reading Regional Airport (Carl A Spaatz Field)",
    city: "Reading",
    country: "US",
    continent: "NA",
    lat: 40.3785,
    lon: -75.9652,
    elevation: 344,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRDM": {
    icao: "KRDM",
    iata: "RDM",
    name: "Roberts Field",
    city: "Redmond",
    country: "US",
    continent: "NA",
    lat: 44.2541,
    lon: -121.15,
    elevation: 3080,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRDR": {
    icao: "KRDR",
    iata: "RDR",
    name: "Grand Forks Air Force Base",
    city: "Grand Forks",
    country: "US",
    continent: "NA",
    lat: 47.9611,
    lon: -97.4012,
    elevation: 913,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRDU": {
    icao: "KRDU",
    iata: "RDU",
    name: "Raleigh Durham International Airport",
    city: "Raleigh/Durham",
    country: "US",
    continent: "NA",
    lat: 35.8776,
    lon: -78.7875,
    elevation: 435,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KRFD": {
    icao: "KRFD",
    iata: "RFD",
    name: "Chicago Rockford International Airport",
    city: "Chicago/Rockford",
    country: "US",
    continent: "NA",
    lat: 42.1954,
    lon: -89.0972,
    elevation: 742,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRHI": {
    icao: "KRHI",
    iata: "RHI",
    name: "Rhinelander Oneida County Airport",
    city: "Rhinelander",
    country: "US",
    continent: "NA",
    lat: 45.6312,
    lon: -89.4675,
    elevation: 1624,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRHP": {
    icao: "KRHP",
    iata: "",
    name: "Western Carolina Regional Airport",
    city: "Andrews",
    country: "US",
    continent: "NA",
    lat: 35.1952,
    lon: -83.863,
    elevation: 1697,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRIC": {
    icao: "KRIC",
    iata: "RIC",
    name: "Richmond International Airport",
    city: "Richmond",
    country: "US",
    continent: "NA",
    lat: 37.5052,
    lon: -77.3197,
    elevation: 167,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KRIL": {
    icao: "KRIL",
    iata: "RIL",
    name: "Garfield County Regional Airport",
    city: "Rifle",
    country: "US",
    continent: "NA",
    lat: 39.5263,
    lon: -107.727,
    elevation: 5548,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRIV": {
    icao: "KRIV",
    iata: "RIV",
    name: "March Air Reserve Base",
    city: "Riverside",
    country: "US",
    continent: "NA",
    lat: 33.8807,
    lon: -117.259,
    elevation: 1536,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRIW": {
    icao: "KRIW",
    iata: "RIW",
    name: "Central Wyoming Regional Airport",
    city: "Riverton",
    country: "US",
    continent: "NA",
    lat: 43.0642,
    lon: -108.46,
    elevation: 5525,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRKD": {
    icao: "KRKD",
    iata: "RKD",
    name: "Knox County Regional Airport",
    city: "Rockland",
    country: "US",
    continent: "NA",
    lat: 44.0601,
    lon: -69.0992,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRKS": {
    icao: "KRKS",
    iata: "RKS",
    name: "Southwest Wyoming Regional Airport",
    city: "Rock Springs",
    country: "US",
    continent: "NA",
    lat: 41.5942,
    lon: -109.065,
    elevation: 6764,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRME": {
    icao: "KRME",
    iata: "RME",
    name: "Griffiss International Airport",
    city: "Rome",
    country: "US",
    continent: "NA",
    lat: 43.2338,
    lon: -75.407,
    elevation: 504,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRMG": {
    icao: "KRMG",
    iata: "RMG",
    name: "Richard B Russell Airport",
    city: "Rome",
    country: "US",
    continent: "NA",
    lat: 34.3506,
    lon: -85.158,
    elevation: 644,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRND": {
    icao: "KRND",
    iata: "RND",
    name: "Randolph Air Force Base",
    city: "Universal City",
    country: "US",
    continent: "NA",
    lat: 29.5297,
    lon: -98.2789,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRNH": {
    icao: "KRNH",
    iata: "RNH",
    name: "New Richmond Regional Airport",
    city: "New Richmond",
    country: "US",
    continent: "NA",
    lat: 45.1483,
    lon: -92.5381,
    elevation: 998,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRNO": {
    icao: "KRNO",
    iata: "RNO",
    name: "Reno Tahoe International Airport",
    city: "Reno",
    country: "US",
    continent: "NA",
    lat: 39.4991,
    lon: -119.768,
    elevation: 4415,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KROA": {
    icao: "KROA",
    iata: "ROA",
    name: "Roanoke–Blacksburg Regional Airport",
    city: "Roanoke",
    country: "US",
    continent: "NA",
    lat: 37.3255,
    lon: -79.9754,
    elevation: 1175,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KROC": {
    icao: "KROC",
    iata: "ROC",
    name: "Frederick Douglass Greater Rochester International Airport",
    city: "Rochester",
    country: "US",
    continent: "NA",
    lat: 43.1189,
    lon: -77.6724,
    elevation: 559,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KROW": {
    icao: "KROW",
    iata: "ROW",
    name: "Roswell Air Center Airport",
    city: "Roswell",
    country: "US",
    continent: "NA",
    lat: 33.3016,
    lon: -104.531,
    elevation: 3671,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRSL": {
    icao: "KRSL",
    iata: "RSL",
    name: "Russell Municipal Airport",
    city: "Russell",
    country: "US",
    continent: "NA",
    lat: 38.8721,
    lon: -98.8118,
    elevation: 1862,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRST": {
    icao: "KRST",
    iata: "RST",
    name: "Rochester International Airport",
    city: "Rochester",
    country: "US",
    continent: "NA",
    lat: 43.9083,
    lon: -92.5,
    elevation: 1317,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRSW": {
    icao: "KRSW",
    iata: "RSW",
    name: "Southwest Florida International Airport",
    city: "Fort Myers",
    country: "US",
    continent: "NA",
    lat: 26.5362,
    lon: -81.7552,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KRUT": {
    icao: "KRUT",
    iata: "RUT",
    name: "Rutland - Southern Vermont Regional Airport",
    city: "Rutland",
    country: "US",
    continent: "NA",
    lat: 43.5294,
    lon: -72.9496,
    elevation: 787,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRVS": {
    icao: "KRVS",
    iata: "RVS",
    name: "Tulsa Riverside Airport",
    city: "Tulsa",
    country: "US",
    continent: "NA",
    lat: 36.0396,
    lon: -95.9846,
    elevation: 638,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRWF": {
    icao: "KRWF",
    iata: "RWF",
    name: "Redwood Falls Municipal Airport",
    city: "Redwood Falls",
    country: "US",
    continent: "NA",
    lat: 44.5472,
    lon: -95.0823,
    elevation: 1024,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRWI": {
    icao: "KRWI",
    iata: "RWI",
    name: "Rocky Mount Wilson Regional Airport",
    city: "Rocky Mount",
    country: "US",
    continent: "NA",
    lat: 35.8563,
    lon: -77.8919,
    elevation: 159,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRWL": {
    icao: "KRWL",
    iata: "RWL",
    name: "Rawlins Municipal Airport/Harvey Field",
    city: "Rawlins",
    country: "US",
    continent: "NA",
    lat: 41.8056,
    lon: -107.2,
    elevation: 6813,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KRYY": {
    icao: "KRYY",
    iata: "",
    name: "Cobb County International Airport-McCollum Field",
    city: "Atlanta",
    country: "US",
    continent: "NA",
    lat: 34.0132,
    lon: -84.5972,
    elevation: 1040,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSAC": {
    icao: "KSAC",
    iata: "SAC",
    name: "Sacramento Executive Airport",
    city: "Sacramento",
    country: "US",
    continent: "NA",
    lat: 38.5125,
    lon: -121.493,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSAF": {
    icao: "KSAF",
    iata: "SAF",
    name: "Santa Fe Municipal Airport",
    city: "Santa Fe",
    country: "US",
    continent: "NA",
    lat: 35.6171,
    lon: -106.089,
    elevation: 6348,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSAN": {
    icao: "KSAN",
    iata: "SAN",
    name: "San Diego International Airport",
    city: "San Diego",
    country: "US",
    continent: "NA",
    lat: 32.7336,
    lon: -117.19,
    elevation: 17,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSAT": {
    icao: "KSAT",
    iata: "SAT",
    name: "San Antonio International Airport",
    city: "San Antonio",
    country: "US",
    continent: "NA",
    lat: 29.5337,
    lon: -98.4698,
    elevation: 809,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSAV": {
    icao: "KSAV",
    iata: "SAV",
    name: "Savannah Hilton Head International Airport",
    city: "Savannah",
    country: "US",
    continent: "NA",
    lat: 32.1276,
    lon: -81.2021,
    elevation: 50,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSAW": {
    icao: "KSAW",
    iata: "MQT",
    name: "Marquette/Sawyer International Airport",
    city: "Gwinn",
    country: "US",
    continent: "NA",
    lat: 46.3536,
    lon: -87.3954,
    elevation: 1221,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSBA": {
    icao: "KSBA",
    iata: "SBA",
    name: "Santa Barbara Municipal Airport",
    city: "Santa Barbara",
    country: "US",
    continent: "NA",
    lat: 34.4262,
    lon: -119.84,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSBD": {
    icao: "KSBD",
    iata: "SBD",
    name: "San Bernardino International Airport",
    city: "San Bernardino",
    country: "US",
    continent: "NA",
    lat: 34.0954,
    lon: -117.235,
    elevation: 1159,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSBN": {
    icao: "KSBN",
    iata: "SBN",
    name: "South Bend Regional Airport",
    city: "South Bend",
    country: "US",
    continent: "NA",
    lat: 41.7087,
    lon: -86.3173,
    elevation: 799,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSBP": {
    icao: "KSBP",
    iata: "SBP",
    name: "San Luis County Regional Airport",
    city: "San Luis Obispo",
    country: "US",
    continent: "NA",
    lat: 35.2368,
    lon: -120.642,
    elevation: 212,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSBY": {
    icao: "KSBY",
    iata: "SBY",
    name: "Salisbury Ocean City Wicomico Regional Airport",
    city: "Salisbury",
    country: "US",
    continent: "NA",
    lat: 38.3405,
    lon: -75.5103,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSCH": {
    icao: "KSCH",
    iata: "SCH",
    name: "Schenectady County Airport",
    city: "Schenectady",
    country: "US",
    continent: "NA",
    lat: 42.8525,
    lon: -73.9289,
    elevation: 378,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSCK": {
    icao: "KSCK",
    iata: "SCK",
    name: "Stockton Metropolitan Airport",
    city: "Stockton",
    country: "US",
    continent: "NA",
    lat: 37.8933,
    lon: -121.2381,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSDF": {
    icao: "KSDF",
    iata: "SDF",
    name: "Louisville Muhammad Ali International Airport",
    city: "Louisville",
    country: "US",
    continent: "NA",
    lat: 38.1744,
    lon: -85.736,
    elevation: 501,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSDM": {
    icao: "KSDM",
    iata: "SDM",
    name: "Brown Field Municipal Airport",
    city: "San Diego",
    country: "US",
    continent: "NA",
    lat: 32.5726,
    lon: -116.98,
    elevation: 526,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSDY": {
    icao: "KSDY",
    iata: "SDY",
    name: "Sidney - Richland Regional Airport",
    city: "Sidney",
    country: "US",
    continent: "NA",
    lat: 47.7051,
    lon: -104.1944,
    elevation: 1985,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSEA": {
    icao: "KSEA",
    iata: "SEA",
    name: "Seattle–Tacoma International Airport",
    city: "Seattle",
    country: "US",
    continent: "NA",
    lat: 47.4479,
    lon: -122.3103,
    elevation: 433,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KSFB": {
    icao: "KSFB",
    iata: "SFB",
    name: "Orlando Sanford International Airport",
    city: "Orlando",
    country: "US",
    continent: "NA",
    lat: 28.7776,
    lon: -81.2375,
    elevation: 55,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSFF": {
    icao: "KSFF",
    iata: "SFF",
    name: "Felts Field",
    city: "Spokane",
    country: "US",
    continent: "NA",
    lat: 47.6829,
    lon: -117.3219,
    elevation: 1953,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSFO": {
    icao: "KSFO",
    iata: "SFO",
    name: "San Francisco International Airport",
    city: "San Francisco",
    country: "US",
    continent: "NA",
    lat: 37.6198,
    lon: -122.3748,
    elevation: 13,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "KSGF": {
    icao: "KSGF",
    iata: "SGF",
    name: "Springfield Branson National Airport",
    city: "Springfield",
    country: "US",
    continent: "NA",
    lat: 37.2457,
    lon: -93.3886,
    elevation: 1268,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSGH": {
    icao: "KSGH",
    iata: "SGH",
    name: "Springfield-Beckley Municipal Airport",
    city: "Springfield",
    country: "US",
    continent: "NA",
    lat: 39.8403,
    lon: -83.8402,
    elevation: 1051,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSGJ": {
    icao: "KSGJ",
    iata: "UST",
    name: "Northeast Florida Regional Airport",
    city: "St Augustine",
    country: "US",
    continent: "NA",
    lat: 29.9592,
    lon: -81.3398,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSGR": {
    icao: "KSGR",
    iata: "SGR",
    name: "Sugar Land Regional Airport",
    city: "Houston",
    country: "US",
    continent: "NA",
    lat: 29.6223,
    lon: -95.6565,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSGU": {
    icao: "KSGU",
    iata: "SGU",
    name: "St George Regional Airport",
    city: "St George",
    country: "US",
    continent: "NA",
    lat: 37.0364,
    lon: -113.5103,
    elevation: 2941,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSHD": {
    icao: "KSHD",
    iata: "SHD",
    name: "Shenandoah Valley Regional Airport",
    city: "Weyers Cave",
    country: "US",
    continent: "NA",
    lat: 38.2638,
    lon: -78.8964,
    elevation: 1201,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSHR": {
    icao: "KSHR",
    iata: "SHR",
    name: "Sheridan County Airport",
    city: "Sheridan",
    country: "US",
    continent: "NA",
    lat: 44.7692,
    lon: -106.98,
    elevation: 4021,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSHV": {
    icao: "KSHV",
    iata: "SHV",
    name: "Shreveport Regional Airport",
    city: "Shreveport",
    country: "US",
    continent: "NA",
    lat: 32.4466,
    lon: -93.8256,
    elevation: 258,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSJC": {
    icao: "KSJC",
    iata: "SJC",
    name: "Norman Y. Mineta San Jose International Airport",
    city: "San Jose",
    country: "US",
    continent: "NA",
    lat: 37.3625,
    lon: -121.9292,
    elevation: 62,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSJT": {
    icao: "KSJT",
    iata: "SJT",
    name: "San Angelo Regional Mathis Field",
    city: "San Angelo",
    country: "US",
    continent: "NA",
    lat: 31.3577,
    lon: -100.496,
    elevation: 1919,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSKA": {
    icao: "KSKA",
    iata: "SKA",
    name: "Fairchild Air Force Base",
    city: "Spokane",
    country: "US",
    continent: "NA",
    lat: 47.6151,
    lon: -117.656,
    elevation: 2461,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSKF": {
    icao: "KSKF",
    iata: "SKF",
    name: "Lackland Air Force Base",
    city: "San Antonio",
    country: "US",
    continent: "NA",
    lat: 29.3842,
    lon: -98.5811,
    elevation: 691,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSKX": {
    icao: "KSKX",
    iata: "TSM",
    name: "Taos Regional Airport",
    city: "Taos",
    country: "US",
    continent: "NA",
    lat: 36.4525,
    lon: -105.6775,
    elevation: 7095,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSLC": {
    icao: "KSLC",
    iata: "SLC",
    name: "Salt Lake City International Airport",
    city: "Salt Lake City",
    country: "US",
    continent: "NA",
    lat: 40.7889,
    lon: -111.9799,
    elevation: 4227,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSLE": {
    icao: "KSLE",
    iata: "SLE",
    name: "Salem-Willamette Valley Airport/McNary Field",
    city: "Salem",
    country: "US",
    continent: "NA",
    lat: 44.9095,
    lon: -123.003,
    elevation: 214,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSLI": {
    icao: "KSLI",
    iata: "",
    name: "Los Alamitos Army Air Field",
    city: "Los Alamitos",
    country: "US",
    continent: "NA",
    lat: 33.79,
    lon: -118.052,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSLK": {
    icao: "KSLK",
    iata: "SLK",
    name: "Adirondack Regional Airport",
    city: "Saranac Lake",
    country: "US",
    continent: "NA",
    lat: 44.3869,
    lon: -74.2046,
    elevation: 1663,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSLN": {
    icao: "KSLN",
    iata: "SLN",
    name: "Salina Municipal Airport",
    city: "Salina",
    country: "US",
    continent: "NA",
    lat: 38.791,
    lon: -97.6522,
    elevation: 1288,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSME": {
    icao: "KSME",
    iata: "SME",
    name: "Lake Cumberland Regional Airport",
    city: "Somerset",
    country: "US",
    continent: "NA",
    lat: 37.0534,
    lon: -84.6159,
    elevation: 927,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSMF": {
    icao: "KSMF",
    iata: "SMF",
    name: "Sacramento International Airport",
    city: "Sacramento",
    country: "US",
    continent: "NA",
    lat: 38.6954,
    lon: -121.591,
    elevation: 27,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSMN": {
    icao: "KSMN",
    iata: "SMN",
    name: "Lemhi County Airport",
    city: "Salmon",
    country: "US",
    continent: "NA",
    lat: 45.1222,
    lon: -113.882,
    elevation: 4043,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSMO": {
    icao: "KSMO",
    iata: "SMO",
    name: "Santa Monica Municipal Airport",
    city: "Santa Monica",
    country: "US",
    continent: "NA",
    lat: 34.0158,
    lon: -118.451,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSMX": {
    icao: "KSMX",
    iata: "SMX",
    name: "Santa Maria Public Airport Captain G Allan Hancock Field",
    city: "Santa Maria",
    country: "US",
    continent: "NA",
    lat: 34.8989,
    lon: -120.457,
    elevation: 261,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSNA": {
    icao: "KSNA",
    iata: "SNA",
    name: "John Wayne Orange County International Airport",
    city: "Santa Ana",
    country: "US",
    continent: "NA",
    lat: 33.6757,
    lon: -117.868,
    elevation: 56,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSNS": {
    icao: "KSNS",
    iata: "SNS",
    name: "Salinas Municipal Airport",
    city: "Salinas",
    country: "US",
    continent: "NA",
    lat: 36.6628,
    lon: -121.606,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSNY": {
    icao: "KSNY",
    iata: "SNY",
    name: "Sidney Municipal Airport Lloyd W Carr Field",
    city: "Sidney",
    country: "US",
    continent: "NA",
    lat: 41.1013,
    lon: -102.985,
    elevation: 4313,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSOA": {
    icao: "KSOA",
    iata: "",
    name: "Sonora Municipal Airport",
    city: "Sonora",
    country: "US",
    continent: "NA",
    lat: 30.5857,
    lon: -100.649,
    elevation: 2140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSOW": {
    icao: "KSOW",
    iata: "SOW",
    name: "Show Low Regional Airport",
    city: "Show Low",
    country: "US",
    continent: "NA",
    lat: 34.2641,
    lon: -110.0071,
    elevation: 6415,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSPI": {
    icao: "KSPI",
    iata: "SPI",
    name: "Abraham Lincoln Capital Airport",
    city: "Springfield",
    country: "US",
    continent: "NA",
    lat: 39.8441,
    lon: -89.6779,
    elevation: 598,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSPS": {
    icao: "KSPS",
    iata: "SPS",
    name: "Wichita Falls Municipal Airport / Sheppard Air Force Base",
    city: "Wichita Falls",
    country: "US",
    continent: "NA",
    lat: 33.9888,
    lon: -98.4919,
    elevation: 1019,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSQL": {
    icao: "KSQL",
    iata: "SQL",
    name: "San Carlos Airport",
    city: "San Carlos",
    country: "US",
    continent: "NA",
    lat: 37.5131,
    lon: -122.2508,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSRQ": {
    icao: "KSRQ",
    iata: "SRQ",
    name: "Sarasota Bradenton International Airport",
    city: "Sarasota/Bradenton",
    country: "US",
    continent: "NA",
    lat: 27.3946,
    lon: -82.5544,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSRR": {
    icao: "KSRR",
    iata: "RUI",
    name: "Sierra Blanca Regional Airport",
    city: "Alto",
    country: "US",
    continent: "NA",
    lat: 33.4628,
    lon: -105.535,
    elevation: 6814,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSSC": {
    icao: "KSSC",
    iata: "SSC",
    name: "Shaw Air Force Base",
    city: "Sumter",
    country: "US",
    continent: "NA",
    lat: 33.9727,
    lon: -80.4706,
    elevation: 241,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSSF": {
    icao: "KSSF",
    iata: "SSF",
    name: "Stinson Municipal Airport",
    city: "San Antonio",
    country: "US",
    continent: "NA",
    lat: 29.337,
    lon: -98.4711,
    elevation: 577,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSSI": {
    icao: "KSSI",
    iata: "SSI",
    name: "St Simons Island Airport",
    city: "St Simons Island",
    country: "US",
    continent: "NA",
    lat: 31.1518,
    lon: -81.3913,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSTC": {
    icao: "KSTC",
    iata: "STC",
    name: "Saint Cloud Regional Airport",
    city: "Saint Cloud",
    country: "US",
    continent: "NA",
    lat: 45.5466,
    lon: -94.0599,
    elevation: 1031,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSTJ": {
    icao: "KSTJ",
    iata: "STJ",
    name: "Rosecrans Memorial Airport",
    city: "St Joseph",
    country: "US",
    continent: "NA",
    lat: 39.7719,
    lon: -94.9097,
    elevation: 826,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSTL": {
    icao: "KSTL",
    iata: "STL",
    name: "St. Louis Lambert International Airport",
    city: "St Louis",
    country: "US",
    continent: "NA",
    lat: 38.7487,
    lon: -90.37,
    elevation: 618,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSTP": {
    icao: "KSTP",
    iata: "STP",
    name: "Saint Paul Downtown Holman Field",
    city: "Saint Paul",
    country: "US",
    continent: "NA",
    lat: 44.9348,
    lon: -93.06,
    elevation: 705,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSTS": {
    icao: "KSTS",
    iata: "STS",
    name: "Charles M. Schulz Sonoma County Airport",
    city: "Santa Rosa",
    country: "US",
    continent: "NA",
    lat: 38.509,
    lon: -122.813,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSUN": {
    icao: "KSUN",
    iata: "SUN",
    name: "Friedman Memorial Airport",
    city: "Hailey",
    country: "US",
    continent: "NA",
    lat: 43.5044,
    lon: -114.296,
    elevation: 5318,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSUS": {
    icao: "KSUS",
    iata: "SUS",
    name: "Spirit of St Louis Airport",
    city: "St Louis",
    country: "US",
    continent: "NA",
    lat: 38.6621,
    lon: -90.652,
    elevation: 463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSUU": {
    icao: "KSUU",
    iata: "SUU",
    name: "Travis Air Force Base",
    city: "Fairfield",
    country: "US",
    continent: "NA",
    lat: 38.2627,
    lon: -121.927,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSUX": {
    icao: "KSUX",
    iata: "SUX",
    name: "Sioux Gateway Airport / Brigadier General Bud Day Field",
    city: "Sioux City",
    country: "US",
    continent: "NA",
    lat: 42.3976,
    lon: -96.3822,
    elevation: 1098,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSUZ": {
    icao: "KSUZ",
    iata: "",
    name: "Saline County Regional Airport",
    city: "Bryant",
    country: "US",
    continent: "NA",
    lat: 34.5906,
    lon: -92.4794,
    elevation: 390,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSVC": {
    icao: "KSVC",
    iata: "SVC",
    name: "Grant County Airport",
    city: "Silver City",
    country: "US",
    continent: "NA",
    lat: 32.6367,
    lon: -108.1547,
    elevation: 5446,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSVN": {
    icao: "KSVN",
    iata: "SVN",
    name: "Hunter Army Air Field",
    city: "Savannah",
    country: "US",
    continent: "NA",
    lat: 32.01,
    lon: -81.1457,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSWF": {
    icao: "KSWF",
    iata: "SWF",
    name: "New York Stewart International Airport",
    city: "Newburgh",
    country: "US",
    continent: "NA",
    lat: 41.5041,
    lon: -74.1048,
    elevation: 491,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSWO": {
    icao: "KSWO",
    iata: "SWO",
    name: "Stillwater Regional Airport",
    city: "Stillwater",
    country: "US",
    continent: "NA",
    lat: 36.1621,
    lon: -97.0856,
    elevation: 1000,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KSYR": {
    icao: "KSYR",
    iata: "SYR",
    name: "Syracuse Hancock International Airport",
    city: "Syracuse",
    country: "US",
    continent: "NA",
    lat: 43.1112,
    lon: -76.1063,
    elevation: 421,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KSZL": {
    icao: "KSZL",
    iata: "SZL",
    name: "Whiteman Air Force Base",
    city: "Knob Noster",
    country: "US",
    continent: "NA",
    lat: 38.7303,
    lon: -93.5479,
    elevation: 870,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTBN": {
    icao: "KTBN",
    iata: "TBN",
    name: "Waynesville-St. Robert Regional Airport-Forney Field",
    city: "Fort Leonard Wood",
    country: "US",
    continent: "NA",
    lat: 37.7416,
    lon: -92.1407,
    elevation: 1159,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTCC": {
    icao: "KTCC",
    iata: "TCC",
    name: "Tucumcari Municipal Airport",
    city: "Tucumcari",
    country: "US",
    continent: "NA",
    lat: 35.1828,
    lon: -103.603,
    elevation: 4065,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTCL": {
    icao: "KTCL",
    iata: "TCL",
    name: "Tuscaloosa National Airport",
    city: "Tuscaloosa",
    country: "US",
    continent: "NA",
    lat: 33.2206,
    lon: -87.6114,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTCM": {
    icao: "KTCM",
    iata: "TCM",
    name: "McChord Air Force Base",
    city: "Tacoma",
    country: "US",
    continent: "NA",
    lat: 47.1377,
    lon: -122.476,
    elevation: 322,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTCS": {
    icao: "KTCS",
    iata: "TCS",
    name: "Truth or Consequences Municipal Airport",
    city: "Truth or Consequences",
    country: "US",
    continent: "NA",
    lat: 33.2369,
    lon: -107.272,
    elevation: 4853,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTEB": {
    icao: "KTEB",
    iata: "TEB",
    name: "Teterboro Airport",
    city: "Teterboro",
    country: "US",
    continent: "NA",
    lat: 40.8501,
    lon: -74.0608,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTEX": {
    icao: "KTEX",
    iata: "TEX",
    name: "Telluride Regional Airport",
    city: "Telluride",
    country: "US",
    continent: "NA",
    lat: 37.9538,
    lon: -107.908,
    elevation: 9070,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTIK": {
    icao: "KTIK",
    iata: "TIK",
    name: "Tinker Air Force Base",
    city: "Oklahoma City",
    country: "US",
    continent: "NA",
    lat: 35.4147,
    lon: -97.3866,
    elevation: 1291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTIW": {
    icao: "KTIW",
    iata: "TIW",
    name: "Tacoma Narrows Airport",
    city: "Tacoma",
    country: "US",
    continent: "NA",
    lat: 47.2674,
    lon: -122.5773,
    elevation: 294,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTIX": {
    icao: "KTIX",
    iata: "TIX",
    name: "Space Coast Regional Airport",
    city: "Titusville",
    country: "US",
    continent: "NA",
    lat: 28.5148,
    lon: -80.7992,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTLH": {
    icao: "KTLH",
    iata: "TLH",
    name: "Tallahassee Regional Airport",
    city: "Tallahassee",
    country: "US",
    continent: "NA",
    lat: 30.3965,
    lon: -84.3503,
    elevation: 81,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTMB": {
    icao: "KTMB",
    iata: "TMB",
    name: "Miami Executive Airport",
    city: "Miami",
    country: "US",
    continent: "NA",
    lat: 25.6479,
    lon: -80.4328,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTOI": {
    icao: "KTOI",
    iata: "TOI",
    name: "Troy Municipal Airport at N Kenneth Campbell Field",
    city: "Troy",
    country: "US",
    continent: "NA",
    lat: 31.8604,
    lon: -86.0121,
    elevation: 398,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTOL": {
    icao: "KTOL",
    iata: "TOL",
    name: "Eugene F. Kranz Toledo Express Airport",
    city: "Toledo",
    country: "US",
    continent: "NA",
    lat: 41.5868,
    lon: -83.8078,
    elevation: 683,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTOP": {
    icao: "KTOP",
    iata: "TOP",
    name: "Philip Billard Municipal Airport",
    city: "Topeka",
    country: "US",
    continent: "NA",
    lat: 39.0699,
    lon: -95.6226,
    elevation: 881,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTPA": {
    icao: "KTPA",
    iata: "TPA",
    name: "Tampa International Airport",
    city: "Tampa",
    country: "US",
    continent: "NA",
    lat: 27.9755,
    lon: -82.5332,
    elevation: 26,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KTPH": {
    icao: "KTPH",
    iata: "TPH",
    name: "Tonopah Airport",
    city: "Tonopah",
    country: "US",
    continent: "NA",
    lat: 38.0602,
    lon: -117.087,
    elevation: 5430,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTPL": {
    icao: "KTPL",
    iata: "TPL",
    name: "Draughon Miller Central Texas Regional Airport",
    city: "Temple",
    country: "US",
    continent: "NA",
    lat: 31.1525,
    lon: -97.4078,
    elevation: 682,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTRI": {
    icao: "KTRI",
    iata: "TRI",
    name: "Tri-Cities Regional TN/VA Airport",
    city: "Blountville",
    country: "US",
    continent: "NA",
    lat: 36.4752,
    lon: -82.4074,
    elevation: 1519,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTRK": {
    icao: "KTRK",
    iata: "TKF",
    name: "Truckee Tahoe Airport",
    city: "Truckee",
    country: "US",
    continent: "NA",
    lat: 39.3186,
    lon: -120.1406,
    elevation: 5900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTRM": {
    icao: "KTRM",
    iata: "TRM",
    name: "Jacqueline Cochran Regional Airport",
    city: "Palm Springs",
    country: "US",
    continent: "NA",
    lat: 33.6267,
    lon: -116.16,
    elevation: -115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTTD": {
    icao: "KTTD",
    iata: "TTD",
    name: "Portland Troutdale Airport",
    city: "Portland",
    country: "US",
    continent: "NA",
    lat: 45.5494,
    lon: -122.401,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTTN": {
    icao: "KTTN",
    iata: "TTN",
    name: "Trenton Mercer Airport",
    city: "Ewing Township",
    country: "US",
    continent: "NA",
    lat: 40.2767,
    lon: -74.8135,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTTS": {
    icao: "KTTS",
    iata: "",
    name: "Space Florida Launch and Landing Facility",
    city: "Titusville",
    country: "US",
    continent: "NA",
    lat: 28.615,
    lon: -80.6945,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTUL": {
    icao: "KTUL",
    iata: "TUL",
    name: "Tulsa International Airport",
    city: "Tulsa",
    country: "US",
    continent: "NA",
    lat: 36.1984,
    lon: -95.8881,
    elevation: 677,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "KTUP": {
    icao: "KTUP",
    iata: "TUP",
    name: "Tupelo Regional Airport",
    city: "Tupelo",
    country: "US",
    continent: "NA",
    lat: 34.2681,
    lon: -88.7699,
    elevation: 346,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTUS": {
    icao: "KTUS",
    iata: "TUS",
    name: "Tucson International Airport / Morris Air National Guard Base",
    city: "Tucson",
    country: "US",
    continent: "NA",
    lat: 32.115,
    lon: -110.9381,
    elevation: 2643,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTVC": {
    icao: "KTVC",
    iata: "TVC",
    name: "Cherry Capital Airport",
    city: "Traverse City",
    country: "US",
    continent: "NA",
    lat: 44.7414,
    lon: -85.5822,
    elevation: 624,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTVF": {
    icao: "KTVF",
    iata: "TVF",
    name: "Thief River Falls Regional Airport",
    city: "Thief River Falls",
    country: "US",
    continent: "NA",
    lat: 48.0657,
    lon: -96.185,
    elevation: 1119,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTVL": {
    icao: "KTVL",
    iata: "TVL",
    name: "Lake Tahoe Airport",
    city: "South Lake Tahoe",
    country: "US",
    continent: "NA",
    lat: 38.8939,
    lon: -119.995,
    elevation: 6264,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTWF": {
    icao: "KTWF",
    iata: "TWF",
    name: "Joslin Field Magic Valley Regional Airport",
    city: "Twin Falls",
    country: "US",
    continent: "NA",
    lat: 42.4818,
    lon: -114.488,
    elevation: 4154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTXK": {
    icao: "KTXK",
    iata: "TXK",
    name: "Texarkana Regional Airport (Webb Field)",
    city: "Texarkana",
    country: "US",
    continent: "NA",
    lat: 33.4537,
    lon: -93.991,
    elevation: 390,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTYR": {
    icao: "KTYR",
    iata: "TYR",
    name: "Tyler Pounds Regional Airport",
    city: "Tyler",
    country: "US",
    continent: "NA",
    lat: 32.3541,
    lon: -95.4024,
    elevation: 544,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KTYS": {
    icao: "KTYS",
    iata: "TYS",
    name: "McGhee Tyson Airport",
    city: "Alcoa",
    country: "US",
    continent: "NA",
    lat: 35.811,
    lon: -83.994,
    elevation: 981,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KU42": {
    icao: "KU42",
    iata: "",
    name: "South Valley Regional Airport",
    city: "Salt Lake City",
    country: "US",
    continent: "NA",
    lat: 40.6195,
    lon: -111.993,
    elevation: 4607,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KUAO": {
    icao: "KUAO",
    iata: "",
    name: "Aurora State Airport",
    city: "Aurora",
    country: "US",
    continent: "NA",
    lat: 45.2471,
    lon: -122.77,
    elevation: 200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KUIN": {
    icao: "KUIN",
    iata: "UIN",
    name: "Quincy Regional Airport Baldwin Field",
    city: "Quincy",
    country: "US",
    continent: "NA",
    lat: 39.9427,
    lon: -91.1946,
    elevation: 768,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KUKI": {
    icao: "KUKI",
    iata: "UKI",
    name: "Ukiah Municipal Airport",
    city: "Ukiah",
    country: "US",
    continent: "NA",
    lat: 39.126,
    lon: -123.201,
    elevation: 614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KUNV": {
    icao: "KUNV",
    iata: "SCE",
    name: "State College Regional Airport",
    city: "State College",
    country: "US",
    continent: "NA",
    lat: 40.8494,
    lon: -77.8485,
    elevation: 1239,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KUOX": {
    icao: "KUOX",
    iata: "UOX",
    name: "University Oxford Airport",
    city: "Oxford",
    country: "US",
    continent: "NA",
    lat: 34.3843,
    lon: -89.5368,
    elevation: 452,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KUTS": {
    icao: "KUTS",
    iata: "HTV",
    name: "Huntsville Regional Airport",
    city: "Huntsville",
    country: "US",
    continent: "NA",
    lat: 30.7469,
    lon: -95.5872,
    elevation: 363,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVAD": {
    icao: "KVAD",
    iata: "VAD",
    name: "Moody Air Force Base",
    city: "Valdosta",
    country: "US",
    continent: "NA",
    lat: 30.9678,
    lon: -83.193,
    elevation: 233,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVBG": {
    icao: "KVBG",
    iata: "VBG",
    name: "Vandenberg Space Force Base",
    city: "Lompoc",
    country: "US",
    continent: "NA",
    lat: 34.7373,
    lon: -120.584,
    elevation: 369,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVCT": {
    icao: "KVCT",
    iata: "VCT",
    name: "Victoria Regional Airport",
    city: "Victoria",
    country: "US",
    continent: "NA",
    lat: 28.8526,
    lon: -96.9185,
    elevation: 115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVEL": {
    icao: "KVEL",
    iata: "VEL",
    name: "Vernal Regional Airport",
    city: "Vernal",
    country: "US",
    continent: "NA",
    lat: 40.4362,
    lon: -109.5117,
    elevation: 5278,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVGT": {
    icao: "KVGT",
    iata: "VGT",
    name: "North Las Vegas Metropolitan International Airport",
    city: "Las Vegas",
    country: "US",
    continent: "NA",
    lat: 36.2107,
    lon: -115.194,
    elevation: 2205,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVIS": {
    icao: "KVIS",
    iata: "VIS",
    name: "Visalia Municipal Airport",
    city: "Visalia",
    country: "US",
    continent: "NA",
    lat: 36.3187,
    lon: -119.393,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVLD": {
    icao: "KVLD",
    iata: "VLD",
    name: "Valdosta Regional Airport",
    city: "Valdosta",
    country: "US",
    continent: "NA",
    lat: 30.7825,
    lon: -83.2767,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVNY": {
    icao: "KVNY",
    iata: "VNY",
    name: "Van Nuys Airport",
    city: "Van Nuys",
    country: "US",
    continent: "NA",
    lat: 34.2098,
    lon: -118.49,
    elevation: 802,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVOK": {
    icao: "KVOK",
    iata: "VOK",
    name: "Volk Field",
    city: "Camp Douglas",
    country: "US",
    continent: "NA",
    lat: 43.939,
    lon: -90.2534,
    elevation: 912,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVPS": {
    icao: "KVPS",
    iata: "VPS",
    name: "Destin-Fort Walton Beach Airport",
    city: "Valparaiso",
    country: "US",
    continent: "NA",
    lat: 30.4832,
    lon: -86.5254,
    elevation: 87,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVPZ": {
    icao: "KVPZ",
    iata: "VPZ",
    name: "Porter County Municipal Airport",
    city: "Valparaiso",
    country: "US",
    continent: "NA",
    lat: 41.454,
    lon: -87.0071,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVQQ": {
    icao: "KVQQ",
    iata: "VQQ",
    name: "Cecil Airport",
    city: "Jacksonville",
    country: "US",
    continent: "NA",
    lat: 30.2187,
    lon: -81.8767,
    elevation: 81,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVRB": {
    icao: "KVRB",
    iata: "VRB",
    name: "Vero Beach Regional Airport",
    city: "Vero Beach",
    country: "US",
    continent: "NA",
    lat: 27.6556,
    lon: -80.4179,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KVTN": {
    icao: "KVTN",
    iata: "VTN",
    name: "Miller Field",
    city: "Valentine",
    country: "US",
    continent: "NA",
    lat: 42.8562,
    lon: -100.5492,
    elevation: 2596,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KW63": {
    icao: "KW63",
    iata: "",
    name: "Lake Country Regional Airport",
    city: "Clarksville",
    country: "US",
    continent: "NA",
    lat: 36.5958,
    lon: -78.5601,
    elevation: 421,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWJF": {
    icao: "KWJF",
    iata: "WJF",
    name: "General William J Fox Airfield",
    city: "Lancaster",
    country: "US",
    continent: "NA",
    lat: 34.7411,
    lon: -118.219,
    elevation: 2351,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWMC": {
    icao: "KWMC",
    iata: "WMC",
    name: "Winnemucca Municipal Airport",
    city: "Winnemucca",
    country: "US",
    continent: "NA",
    lat: 40.8966,
    lon: -117.806,
    elevation: 4308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWRB": {
    icao: "KWRB",
    iata: "WRB",
    name: "Robins Air Force Base",
    city: "Warner Robins",
    country: "US",
    continent: "NA",
    lat: 32.6401,
    lon: -83.5919,
    elevation: 294,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWRI": {
    icao: "KWRI",
    iata: "WRI",
    name: "Mc Guire Air Force Base",
    city: "Wrightstown",
    country: "US",
    continent: "NA",
    lat: 40.0156,
    lon: -74.5917,
    elevation: 131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWRL": {
    icao: "KWRL",
    iata: "WRL",
    name: "Worland Municipal Airport",
    city: "Worland",
    country: "US",
    continent: "NA",
    lat: 43.9657,
    lon: -107.951,
    elevation: 4227,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWST": {
    icao: "KWST",
    iata: "WST",
    name: "Westerly State Airport",
    city: "Westerly",
    country: "US",
    continent: "NA",
    lat: 41.3496,
    lon: -71.8034,
    elevation: 81,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWWD": {
    icao: "KWWD",
    iata: "WWD",
    name: "Cape May County Airport",
    city: "Wildwood",
    country: "US",
    continent: "NA",
    lat: 39.0085,
    lon: -74.9083,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWWR": {
    icao: "KWWR",
    iata: "WWR",
    name: "West Woodward Airport",
    city: "Woodward",
    country: "US",
    continent: "NA",
    lat: 36.438,
    lon: -99.5227,
    elevation: 2189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KWYS": {
    icao: "KWYS",
    iata: "WYS",
    name: "Yellowstone Airport",
    city: "West Yellowstone",
    country: "US",
    continent: "NA",
    lat: 44.6884,
    lon: -111.118,
    elevation: 6649,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KX51": {
    icao: "KX51",
    iata: "",
    name: "Miami Homestead General Aviation Airport",
    city: "Homestead",
    country: "US",
    continent: "NA",
    lat: 25.4992,
    lon: -80.5543,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KXMR": {
    icao: "KXMR",
    iata: "",
    name: "Cape Canaveral SFS Skid Strip",
    city: "Cocoa Beach",
    country: "US",
    continent: "NA",
    lat: 28.4676,
    lon: -80.5666,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KXNA": {
    icao: "KXNA",
    iata: "XNA",
    name: "Northwest Arkansas National Airport",
    city: "Fayetteville/Springdale/Rogers",
    country: "US",
    continent: "NA",
    lat: 36.2819,
    lon: -94.3068,
    elevation: 1287,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KXTA": {
    icao: "KXTA",
    iata: "",
    name: "Homey (Area 51) Airport",
    city: "Groom Lake",
    country: "US",
    continent: "NA",
    lat: 37.235,
    lon: -115.811,
    elevation: 4462,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KXWA": {
    icao: "KXWA",
    iata: "XWA",
    name: "Williston Basin International Airport",
    city: "Williston",
    country: "US",
    continent: "NA",
    lat: 48.2584,
    lon: -103.7488,
    elevation: 2344,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KYIP": {
    icao: "KYIP",
    iata: "YIP",
    name: "Willow Run Airport",
    city: "Detroit",
    country: "US",
    continent: "NA",
    lat: 42.2379,
    lon: -83.5304,
    elevation: 716,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KYKM": {
    icao: "KYKM",
    iata: "YKM",
    name: "Yakima Air Terminal McAllister Field",
    city: "Yakima",
    country: "US",
    continent: "NA",
    lat: 46.5682,
    lon: -120.544,
    elevation: 1099,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KYKN": {
    icao: "KYKN",
    iata: "YKN",
    name: "Chan Gurney Municipal Airport",
    city: "Yankton",
    country: "US",
    continent: "NA",
    lat: 42.9167,
    lon: -97.3859,
    elevation: 1306,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KYNG": {
    icao: "KYNG",
    iata: "YNG",
    name: "Youngstown Warren Regional Airport",
    city: "Youngstown/Warren",
    country: "US",
    continent: "NA",
    lat: 41.2607,
    lon: -80.6791,
    elevation: 1192,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "KZZV": {
    icao: "KZZV",
    iata: "ZZV",
    name: "Zanesville Municipal Airport",
    city: "Zanesville",
    country: "US",
    continent: "NA",
    lat: 39.9444,
    lon: -81.8921,
    elevation: 900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LAKU": {
    icao: "LAKU",
    iata: "KFZ",
    name: "Kukës International Airport",
    city: "Kukës",
    country: "AL",
    continent: "EU",
    lat: 42.0358,
    lon: 20.416,
    elevation: 1120,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LAKV": {
    icao: "LAKV",
    iata: "",
    name: "Kuçovë Air Base",
    city: "Kuçovë",
    country: "AL",
    continent: "EU",
    lat: 40.7719,
    lon: 19.9019,
    elevation: 135,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LATI": {
    icao: "LATI",
    iata: "TIA",
    name: "Tirana International Airport Mother Teresa",
    city: "Rinas",
    country: "AL",
    continent: "EU",
    lat: 41.4147,
    lon: 19.7206,
    elevation: 126,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LBBG": {
    icao: "LBBG",
    iata: "BOJ",
    name: "Burgas Airport",
    city: "Burgas",
    country: "BG",
    continent: "EU",
    lat: 42.5699,
    lon: 27.5152,
    elevation: 135,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LBGO": {
    icao: "LBGO",
    iata: "GOZ",
    name: "Gorna Oryahovitsa Airport",
    city: "Gorna Oryahovitsa",
    country: "BG",
    continent: "EU",
    lat: 43.1514,
    lon: 25.7129,
    elevation: 285,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LBPD": {
    icao: "LBPD",
    iata: "PDV",
    name: "Plovdiv International Airport",
    city: "Plovdiv",
    country: "BG",
    continent: "EU",
    lat: 42.0678,
    lon: 24.8508,
    elevation: 597,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LBPG": {
    icao: "LBPG",
    iata: "",
    name: "Graf Ignatievo Air Base",
    city: "Graf Ignatievo",
    country: "BG",
    continent: "EU",
    lat: 42.2904,
    lon: 24.714,
    elevation: 190,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LBPL": {
    icao: "LBPL",
    iata: "",
    name: "Dolna Mitropoliya Air Base",
    city: "Dolna Mitropoliya",
    country: "BG",
    continent: "EU",
    lat: 43.4518,
    lon: 24.5024,
    elevation: 330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LBSF": {
    icao: "LBSF",
    iata: "SOF",
    name: "Sofia Airport",
    city: "Sofia",
    country: "BG",
    continent: "EU",
    lat: 42.6964,
    lon: 23.4177,
    elevation: 1742,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LBWB": {
    icao: "LBWB",
    iata: "",
    name: "Balchik Airfield",
    city: "Balchik",
    country: "BG",
    continent: "EU",
    lat: 43.4238,
    lon: 28.1813,
    elevation: 660,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LBWN": {
    icao: "LBWN",
    iata: "VAR",
    name: "Varna Airport",
    city: "Varna",
    country: "BG",
    continent: "EU",
    lat: 43.2321,
    lon: 27.8251,
    elevation: 230,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LCEN": {
    icao: "LCEN",
    iata: "ECN",
    name: "Nicosia (Lefkoşa) Ercan International Airport",
    city: "Tymbou (Kirklar)",
    country: "CY",
    continent: "AS",
    lat: 35.1523,
    lon: 33.5066,
    elevation: 404,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LCGK": {
    icao: "LCGK",
    iata: "GEC",
    name: "Lefkoniko Airport / Geçitkale Air Base",
    city: "Lefkoniko (Geçitkale)",
    country: "CY",
    continent: "AS",
    lat: 35.2359,
    lon: 33.7201,
    elevation: 146,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LCLK": {
    icao: "LCLK",
    iata: "LCA",
    name: "Larnaca International Airport",
    city: "Larnaca",
    country: "CY",
    continent: "AS",
    lat: 34.8751,
    lon: 33.6249,
    elevation: 8,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LCPH": {
    icao: "LCPH",
    iata: "PFO",
    name: "Paphos International Airport",
    city: "Paphos",
    country: "CY",
    continent: "AS",
    lat: 34.718,
    lon: 32.4857,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LCRA": {
    icao: "LCRA",
    iata: "AKT",
    name: "RAF Akrotiri",
    city: "Akrotiri",
    country: "CY",
    continent: "AS",
    lat: 34.5904,
    lon: 32.9879,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDDU": {
    icao: "LDDU",
    iata: "DBV",
    name: "Dubrovnik Ruđer Bošković Airport",
    city: "Čilipi",
    country: "HR",
    continent: "EU",
    lat: 42.5622,
    lon: 18.2655,
    elevation: 527,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDOS": {
    icao: "LDOS",
    iata: "OSI",
    name: "Osijek Airport",
    city: "Klisa",
    country: "HR",
    continent: "EU",
    lat: 45.4624,
    lon: 18.8113,
    elevation: 290,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDPL": {
    icao: "LDPL",
    iata: "PUY",
    name: "Pula Airport",
    city: "Pula",
    country: "HR",
    continent: "EU",
    lat: 44.8935,
    lon: 13.9222,
    elevation: 274,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDRI": {
    icao: "LDRI",
    iata: "RJK",
    name: "Rijeka Airport",
    city: "Omišalj",
    country: "HR",
    continent: "EU",
    lat: 45.2169,
    lon: 14.5703,
    elevation: 278,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDSB": {
    icao: "LDSB",
    iata: "BWK",
    name: "Brač Airport",
    city: "Gornji Humac",
    country: "HR",
    continent: "EU",
    lat: 43.2845,
    lon: 16.6784,
    elevation: 1776,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDSP": {
    icao: "LDSP",
    iata: "SPU",
    name: "Split Airport",
    city: "Kaštel Štafilić",
    country: "HR",
    continent: "EU",
    lat: 43.5389,
    lon: 16.298,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LDZA": {
    icao: "LDZA",
    iata: "ZAG",
    name: "Zagreb Franjo Tuđman International Airport",
    city: "Velika Gorica",
    country: "HR",
    continent: "EU",
    lat: 45.7429,
    lon: 16.0688,
    elevation: 353,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LDZD": {
    icao: "LDZD",
    iata: "ZAD",
    name: "Zadar Airport",
    city: "Zemunik Donji (Zadar)",
    country: "HR",
    continent: "EU",
    lat: 44.095,
    lon: 15.3549,
    elevation: 289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEAB": {
    icao: "LEAB",
    iata: "ABC",
    name: "Albacete Airport / Los Llanos Air Base",
    city: "Albacete",
    country: "ES",
    continent: "EU",
    lat: 38.9485,
    lon: -1.8635,
    elevation: 2302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEAL": {
    icao: "LEAL",
    iata: "ALC",
    name: "Alicante-Elche Miguel Hernández Airport",
    city: "Alicante",
    country: "ES",
    continent: "EU",
    lat: 38.2822,
    lon: -0.5582,
    elevation: 142,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LEAM": {
    icao: "LEAM",
    iata: "LEI",
    name: "Almería Airport",
    city: "Almería",
    country: "ES",
    continent: "EU",
    lat: 36.8439,
    lon: -2.3701,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEAS": {
    icao: "LEAS",
    iata: "OVD",
    name: "Asturias Airport",
    city: "Ranón",
    country: "ES",
    continent: "EU",
    lat: 43.5636,
    lon: -6.0346,
    elevation: 416,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEBA": {
    icao: "LEBA",
    iata: "ODB",
    name: "Córdoba Airport",
    city: "Córdoba",
    country: "ES",
    continent: "EU",
    lat: 37.842,
    lon: -4.8489,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEBB": {
    icao: "LEBB",
    iata: "BIO",
    name: "Bilbao Airport",
    city: "Bilbao",
    country: "ES",
    continent: "EU",
    lat: 43.3011,
    lon: -2.9106,
    elevation: 138,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEBG": {
    icao: "LEBG",
    iata: "RGS",
    name: "Burgos Airport",
    city: "Burgos",
    country: "ES",
    continent: "EU",
    lat: 42.3576,
    lon: -3.6208,
    elevation: 2962,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEBL": {
    icao: "LEBL",
    iata: "BCN",
    name: "Josep Tarradellas Barcelona-El Prat Airport",
    city: "Barcelona",
    country: "ES",
    continent: "EU",
    lat: 41.2971,
    lon: 2.0785,
    elevation: 12,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LEBZ": {
    icao: "LEBZ",
    iata: "BJZ",
    name: "Badajoz Airport",
    city: "Badajoz",
    country: "ES",
    continent: "EU",
    lat: 38.8913,
    lon: -6.8213,
    elevation: 609,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LECH": {
    icao: "LECH",
    iata: "CDT",
    name: "Castellón-Costa Azahar Airport",
    city: "Castellón de la Plana",
    country: "ES",
    continent: "EU",
    lat: 40.2139,
    lon: 0.0733,
    elevation: 1182,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LECO": {
    icao: "LECO",
    iata: "LCG",
    name: "A Coruña Airport",
    city: "Culleredo",
    country: "ES",
    continent: "EU",
    lat: 43.3021,
    lon: -8.3773,
    elevation: 326,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LECU": {
    icao: "LECU",
    iata: "",
    name: "Madrid-Cuatro Vientos Airport",
    city: "Madrid",
    country: "ES",
    continent: "EU",
    lat: 40.3707,
    lon: -3.7851,
    elevation: 2269,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEDA": {
    icao: "LEDA",
    iata: "ILD",
    name: "Lleida-Alguaire Airport",
    city: "Lleida",
    country: "ES",
    continent: "EU",
    lat: 41.7282,
    lon: 0.535,
    elevation: 1152,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEGA": {
    icao: "LEGA",
    iata: "",
    name: "Armilla Air Base",
    city: "Armilla",
    country: "ES",
    continent: "EU",
    lat: 37.1332,
    lon: -3.6357,
    elevation: 2297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEGE": {
    icao: "LEGE",
    iata: "GRO",
    name: "Girona-Costa Brava Airport",
    city: "Girona",
    country: "ES",
    continent: "EU",
    lat: 41.9046,
    lon: 2.7618,
    elevation: 468,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEGR": {
    icao: "LEGR",
    iata: "GRX",
    name: "F.G.L. Airport Granada-Jaén Airport",
    city: "Granada",
    country: "ES",
    continent: "EU",
    lat: 37.1887,
    lon: -3.7774,
    elevation: 1860,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEGT": {
    icao: "LEGT",
    iata: "",
    name: "Getafe Air Base",
    city: "Getafe",
    country: "ES",
    continent: "EU",
    lat: 40.2941,
    lon: -3.7238,
    elevation: 2034,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEIB": {
    icao: "LEIB",
    iata: "IBZ",
    name: "Ibiza Airport",
    city: "Ibiza (Eivissa)",
    country: "ES",
    continent: "EU",
    lat: 38.8729,
    lon: 1.3731,
    elevation: 24,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LEJR": {
    icao: "LEJR",
    iata: "XRY",
    name: "Jerez Airport",
    city: "Jerez de la Frontera",
    country: "ES",
    continent: "EU",
    lat: 36.7446,
    lon: -6.0601,
    elevation: 93,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LELC": {
    icao: "LELC",
    iata: "",
    name: "San Javier Airport",
    city: "San Javier",
    country: "ES",
    continent: "EU",
    lat: 37.775,
    lon: -0.8124,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LELN": {
    icao: "LELN",
    iata: "LEN",
    name: "León Int\'l Airport",
    city: "La Virgen Del Camino",
    country: "ES",
    continent: "EU",
    lat: 42.589,
    lon: -5.6556,
    elevation: 3006,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LELO": {
    icao: "LELO",
    iata: "RJL",
    name: "Logroño-Agoncillo Airport",
    city: "Logroño",
    country: "ES",
    continent: "EU",
    lat: 42.461,
    lon: -2.3222,
    elevation: 1161,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEMD": {
    icao: "LEMD",
    iata: "MAD",
    name: "Adolfo Suárez Madrid–Barajas Airport",
    city: "Madrid",
    country: "ES",
    continent: "EU",
    lat: 40.4719,
    lon: -3.5626,
    elevation: 1998,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "LEMG": {
    icao: "LEMG",
    iata: "AGP",
    name: "Málaga-Costa del Sol Airport",
    city: "Málaga",
    country: "ES",
    continent: "EU",
    lat: 36.6749,
    lon: -4.4991,
    elevation: 53,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LEMH": {
    icao: "LEMH",
    iata: "MAH",
    name: "Menorca Airport",
    city: "Mahón (Maó)",
    country: "ES",
    continent: "EU",
    lat: 39.8626,
    lon: 4.2187,
    elevation: 302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEMI": {
    icao: "LEMI",
    iata: "RMU",
    name: "Región de Murcia International Airport",
    city: "Corvera",
    country: "ES",
    continent: "EU",
    lat: 37.803,
    lon: -1.125,
    elevation: 644,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEMO": {
    icao: "LEMO",
    iata: "OZP",
    name: "Moron Air Base",
    city: "Morón",
    country: "ES",
    continent: "EU",
    lat: 37.1749,
    lon: -5.6159,
    elevation: 285,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEPA": {
    icao: "LEPA",
    iata: "PMI",
    name: "Palma de Mallorca Airport",
    city: "Palma de Mallorca",
    country: "ES",
    continent: "EU",
    lat: 39.5517,
    lon: 2.7388,
    elevation: 27,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LEPP": {
    icao: "LEPP",
    iata: "PNA",
    name: "Pamplona Airport",
    city: "Pamplona",
    country: "ES",
    continent: "EU",
    lat: 42.77,
    lon: -1.6463,
    elevation: 1504,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LERI": {
    icao: "LERI",
    iata: "",
    name: "Alcantarilla Air Base",
    city: "Alcantarilla",
    country: "ES",
    continent: "EU",
    lat: 37.9511,
    lon: -1.2303,
    elevation: 250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LERL": {
    icao: "LERL",
    iata: "CQM",
    name: "Ciudad Real International Airport",
    city: "Ciudad Real",
    country: "ES",
    continent: "EU",
    lat: 38.8565,
    lon: -3.9699,
    elevation: 2120,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LERS": {
    icao: "LERS",
    iata: "REU",
    name: "Reus Airport",
    city: "Reus",
    country: "ES",
    continent: "EU",
    lat: 41.1474,
    lon: 1.1672,
    elevation: 233,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LERT": {
    icao: "LERT",
    iata: "ROZ",
    name: "Rota Naval Station Airport",
    city: "Rota",
    country: "ES",
    continent: "EU",
    lat: 36.6452,
    lon: -6.3495,
    elevation: 86,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LESA": {
    icao: "LESA",
    iata: "SLM",
    name: "Salamanca Airport",
    city: "Salamanca",
    country: "ES",
    continent: "EU",
    lat: 40.9521,
    lon: -5.502,
    elevation: 2595,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LESO": {
    icao: "LESO",
    iata: "EAS",
    name: "San Sebastián Airport",
    city: "Hondarribia",
    country: "ES",
    continent: "EU",
    lat: 43.3565,
    lon: -1.7906,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEST": {
    icao: "LEST",
    iata: "SCQ",
    name: "Santiago-Rosalía de Castro Airport",
    city: "Santiago de Compostela",
    country: "ES",
    continent: "EU",
    lat: 42.8963,
    lon: -8.4151,
    elevation: 1213,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LETL": {
    icao: "LETL",
    iata: "TEV",
    name: "Teruel Airport",
    city: "Teruel",
    country: "ES",
    continent: "EU",
    lat: 40.4103,
    lon: -1.2174,
    elevation: 3380,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LETO": {
    icao: "LETO",
    iata: "TOJ",
    name: "Madrid–Torrejón Airport / Torrejón Air Base",
    city: "Madrid",
    country: "ES",
    continent: "EU",
    lat: 40.4879,
    lon: -3.4568,
    elevation: 2026,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEVC": {
    icao: "LEVC",
    iata: "VLC",
    name: "Valencia Airport",
    city: "Valencia",
    country: "ES",
    continent: "EU",
    lat: 39.4893,
    lon: -0.4816,
    elevation: 240,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LEVD": {
    icao: "LEVD",
    iata: "VLL",
    name: "Valladolid Airport",
    city: "Valladolid",
    country: "ES",
    continent: "EU",
    lat: 41.7061,
    lon: -4.8519,
    elevation: 2776,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEVT": {
    icao: "LEVT",
    iata: "VIT",
    name: "Vitoria Airport",
    city: "Alava",
    country: "ES",
    continent: "EU",
    lat: 42.8828,
    lon: -2.7245,
    elevation: 1682,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEVX": {
    icao: "LEVX",
    iata: "VGO",
    name: "Vigo Airport",
    city: "Vigo",
    country: "ES",
    continent: "EU",
    lat: 42.2318,
    lon: -8.6268,
    elevation: 856,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEXJ": {
    icao: "LEXJ",
    iata: "SDR",
    name: "Seve Ballesteros-Santander Airport",
    city: "Santander",
    country: "ES",
    continent: "EU",
    lat: 43.4271,
    lon: -3.82,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEZG": {
    icao: "LEZG",
    iata: "ZAZ",
    name: "Zaragoza Airport",
    city: "Zaragoza",
    country: "ES",
    continent: "EU",
    lat: 41.6662,
    lon: -1.0415,
    elevation: 863,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LEZL": {
    icao: "LEZL",
    iata: "SVQ",
    name: "Sevilla Airport",
    city: "Sevilla",
    country: "ES",
    continent: "EU",
    lat: 37.418,
    lon: -5.8931,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFAC": {
    icao: "LFAC",
    iata: "CQF",
    name: "Calais Marck Airport",
    city: "Calais",
    country: "FR",
    continent: "EU",
    lat: 50.9621,
    lon: 1.9548,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFAG": {
    icao: "LFAG",
    iata: "",
    name: "Péronne Saint-Quentin Airfield",
    city: "Monchy-Lagache, Somme",
    country: "FR",
    continent: "EU",
    lat: 49.8689,
    lon: 3.0296,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFAT": {
    icao: "LFAT",
    iata: "LTQ",
    name: "Le Touquet-Côte d\'Opale Airport",
    city: "Le Touquet-Paris-Plage",
    country: "FR",
    continent: "EU",
    lat: 50.5183,
    lon: 1.6217,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFAV": {
    icao: "LFAV",
    iata: "",
    name: "Valenciennes-Denain Airfield",
    city: "Prouvy",
    country: "FR",
    continent: "EU",
    lat: 50.3278,
    lon: 3.4611,
    elevation: 165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFAY": {
    icao: "LFAY",
    iata: "",
    name: "Amiens Glisy Airfield",
    city: "Amiens",
    country: "FR",
    continent: "EU",
    lat: 49.873,
    lon: 2.3871,
    elevation: 208,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBA": {
    icao: "LFBA",
    iata: "AGF",
    name: "Agen La Garenne airport",
    city: "Agen",
    country: "FR",
    continent: "EU",
    lat: 44.1742,
    lon: 0.5931,
    elevation: 204,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBC": {
    icao: "LFBC",
    iata: "",
    name: "Cazaux (BA 120) Air Base",
    city: "Cazaux (La Teste-de-Buch)",
    country: "FR",
    continent: "EU",
    lat: 44.5333,
    lon: -1.125,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBD": {
    icao: "LFBD",
    iata: "BOD",
    name: "Bordeaux–Mérignac Airport",
    city: "Bordeaux",
    country: "FR",
    continent: "EU",
    lat: 44.8287,
    lon: -0.7154,
    elevation: 162,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFBE": {
    icao: "LFBE",
    iata: "EGC",
    name: "Bergerac Dordogne-Périgord airport",
    city: "Bergerac",
    country: "FR",
    continent: "EU",
    lat: 44.8253,
    lon: 0.5186,
    elevation: 171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBF": {
    icao: "LFBF",
    iata: "",
    name: "Toulouse-Francazal (BA 101) Air Base",
    city: "Toulouse/Francazal",
    country: "FR",
    continent: "EU",
    lat: 43.5456,
    lon: 1.3675,
    elevation: 535,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBG": {
    icao: "LFBG",
    iata: "CNG",
    name: "Cognac-Châteaubernard (BA 709) Air Base",
    city: "Cognac/Châteaubernard",
    country: "FR",
    continent: "EU",
    lat: 45.6583,
    lon: -0.3175,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBH": {
    icao: "LFBH",
    iata: "LRH",
    name: "La Rochelle Île de Ré Airport",
    city: "La Rochelle",
    country: "FR",
    continent: "EU",
    lat: 46.1792,
    lon: -1.1953,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBI": {
    icao: "LFBI",
    iata: "PIS",
    name: "Poitiers-Biard Airport",
    city: "Poitiers/Biard",
    country: "FR",
    continent: "EU",
    lat: 46.5877,
    lon: 0.3067,
    elevation: 423,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBK": {
    icao: "LFBK",
    iata: "MCU",
    name: "Montluçon-Guéret Airport",
    city: "Lépaud, Creuse",
    country: "FR",
    continent: "EU",
    lat: 46.2226,
    lon: 2.364,
    elevation: 1497,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBL": {
    icao: "LFBL",
    iata: "LIG",
    name: "Limoges Airport",
    city: "Limoges/Bellegarde",
    country: "FR",
    continent: "EU",
    lat: 45.8628,
    lon: 1.1794,
    elevation: 1300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBM": {
    icao: "LFBM",
    iata: "",
    name: "Mont-de-Marsan (BA 118) Air Base",
    city: "Mont-de-Marsan",
    country: "FR",
    continent: "EU",
    lat: 43.9117,
    lon: -0.5075,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBN": {
    icao: "LFBN",
    iata: "NIT",
    name: "Niort - Marais Poitevin Airport",
    city: "Niort/Souché",
    country: "FR",
    continent: "EU",
    lat: 46.3135,
    lon: -0.3945,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBO": {
    icao: "LFBO",
    iata: "TLS",
    name: "Toulouse-Blagnac Airport",
    city: "Toulouse/Blagnac",
    country: "FR",
    continent: "EU",
    lat: 43.6291,
    lon: 1.3638,
    elevation: 499,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFBP": {
    icao: "LFBP",
    iata: "PUF",
    name: "Pau Pyrénées Airport",
    city: "Pau/Pyrénées (Uzein)",
    country: "FR",
    continent: "EU",
    lat: 43.38,
    lon: -0.4186,
    elevation: 616,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBT": {
    icao: "LFBT",
    iata: "LDE",
    name: "Tarbes-Lourdes-Pyrénées Airport",
    city: "Tarbes/Lourdes/Pyrénées",
    country: "FR",
    continent: "EU",
    lat: 43.1787,
    lon: -0.0064,
    elevation: 1260,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBU": {
    icao: "LFBU",
    iata: "ANG",
    name: "Angoulême Brie-Champniers airport",
    city: "Angoulême",
    country: "FR",
    continent: "EU",
    lat: 45.7292,
    lon: 0.2215,
    elevation: 436,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBX": {
    icao: "LFBX",
    iata: "PGX",
    name: "Périgueux-Bassillac Airport",
    city: "Périgueux/Bassillac",
    country: "FR",
    continent: "EU",
    lat: 45.1981,
    lon: 0.8156,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFBZ": {
    icao: "LFBZ",
    iata: "BIQ",
    name: "Biarritz Pays Basque airport",
    city: "Biarritz",
    country: "FR",
    continent: "EU",
    lat: 43.4684,
    lon: -1.5232,
    elevation: 245,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCC": {
    icao: "LFCC",
    iata: "ZAO",
    name: "Cahors Lalbenque airport",
    city: "Cahors",
    country: "FR",
    continent: "EU",
    lat: 44.3514,
    lon: 1.4753,
    elevation: 912,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCG": {
    icao: "LFCG",
    iata: "",
    name: "Aérodrome de Saint-Girons - Antichan",
    city: "Saint-Girons/Antichan",
    country: "FR",
    continent: "EU",
    lat: 43.0078,
    lon: 1.1032,
    elevation: 1368,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCH": {
    icao: "LFCH",
    iata: "",
    name: "Aérodrome d\'Arcachon-La Teste-de-Buch",
    city: "Arcachon/La Teste-de-Buch",
    country: "FR",
    continent: "EU",
    lat: 44.5964,
    lon: -1.1108,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCI": {
    icao: "LFCI",
    iata: "LBI",
    name: "Albi Le Sequestre airport",
    city: "Albi",
    country: "FR",
    continent: "EU",
    lat: 43.9139,
    lon: 2.1131,
    elevation: 564,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCK": {
    icao: "LFCK",
    iata: "DCM",
    name: "Castres Mazamet Airport",
    city: "Castres",
    country: "FR",
    continent: "EU",
    lat: 43.5563,
    lon: 2.2892,
    elevation: 788,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCR": {
    icao: "LFCR",
    iata: "RDZ",
    name: "Rodez–Aveyron Airport",
    city: "Rodez/Marcillac",
    country: "FR",
    continent: "EU",
    lat: 44.4079,
    lon: 2.4827,
    elevation: 1910,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFCY": {
    icao: "LFCY",
    iata: "RYN",
    name: "Royan-Médis Airport",
    city: "Royan/Médis",
    country: "FR",
    continent: "EU",
    lat: 45.6281,
    lon: -0.9725,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFDH": {
    icao: "LFDH",
    iata: "",
    name: "Auch Gers Airfield",
    city: "Auch",
    country: "FR",
    continent: "EU",
    lat: 43.6836,
    lon: 0.5997,
    elevation: 411,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFDN": {
    icao: "LFDN",
    iata: "RCO",
    name: "Rochefort-Saint-Agnant (BA 721) Airport",
    city: "Rochefort/Saint-Agnant",
    country: "FR",
    continent: "EU",
    lat: 45.8878,
    lon: -0.9831,
    elevation: 60,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFGA": {
    icao: "LFGA",
    iata: "CMR",
    name: "Colmar Houssen airport",
    city: "Colmar",
    country: "FR",
    continent: "EU",
    lat: 48.1099,
    lon: 7.359,
    elevation: 628,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFGJ": {
    icao: "LFGJ",
    iata: "DLE",
    name: "Dole Tavaux Airport",
    city: "Dole",
    country: "FR",
    continent: "EU",
    lat: 47.039,
    lon: 5.4276,
    elevation: 645,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFGW": {
    icao: "LFGW",
    iata: "",
    name: "Verdun-Le Rozelier Airfield",
    city: "Sommedieue",
    country: "FR",
    continent: "EU",
    lat: 49.1224,
    lon: 5.4691,
    elevation: 1230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFHO": {
    icao: "LFHO",
    iata: "OBS",
    name: "Aubenas-South Ardèche Airport",
    city: "Lanas, Ardèche",
    country: "FR",
    continent: "EU",
    lat: 44.5444,
    lon: 4.3722,
    elevation: 923,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFJL": {
    icao: "LFJL",
    iata: "ETZ",
    name: "Metz-Nancy-Lorraine Airport",
    city: "Goin",
    country: "FR",
    continent: "EU",
    lat: 48.9821,
    lon: 6.2513,
    elevation: 870,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFJR": {
    icao: "LFJR",
    iata: "ANE",
    name: "Angers Marcé airport",
    city: "Angers",
    country: "FR",
    continent: "EU",
    lat: 47.5603,
    lon: -0.3122,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFKB": {
    icao: "LFKB",
    iata: "BIA",
    name: "Bastia Poretta airport",
    city: "Bastia",
    country: "FR",
    continent: "EU",
    lat: 42.5527,
    lon: 9.4837,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFKC": {
    icao: "LFKC",
    iata: "CLY",
    name: "Calvi Sainte Catherine Airport",
    city: "Calvi",
    country: "FR",
    continent: "EU",
    lat: 42.5304,
    lon: 8.793,
    elevation: 209,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFKF": {
    icao: "LFKF",
    iata: "FSC",
    name: "Figari Sud-Corse Airport",
    city: "Figari",
    country: "FR",
    continent: "EU",
    lat: 41.5006,
    lon: 9.0978,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFKJ": {
    icao: "LFKJ",
    iata: "AJA",
    name: "Ajaccio Napoléon Bonaparte airport",
    city: "Ajaccio",
    country: "FR",
    continent: "EU",
    lat: 41.9236,
    lon: 8.8029,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFKS": {
    icao: "LFKS",
    iata: "SOZ",
    name: "Solenzara (BA 126) Air Base",
    city: "Solenzara",
    country: "FR",
    continent: "EU",
    lat: 41.9244,
    lon: 9.406,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLA": {
    icao: "LFLA",
    iata: "AUF",
    name: "Auxerre Branches airport",
    city: "Auxerre",
    country: "FR",
    continent: "EU",
    lat: 47.8502,
    lon: 3.4971,
    elevation: 523,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLB": {
    icao: "LFLB",
    iata: "CMF",
    name: "Chambéry Aix les Bains airport",
    city: "Chambéry",
    country: "FR",
    continent: "EU",
    lat: 45.6381,
    lon: 5.8802,
    elevation: 779,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLC": {
    icao: "LFLC",
    iata: "CFE",
    name: "Clermont-Ferrand Auvergne airport",
    city: "Clermont-Ferrand",
    country: "FR",
    continent: "EU",
    lat: 45.7867,
    lon: 3.1692,
    elevation: 1090,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLD": {
    icao: "LFLD",
    iata: "BOU",
    name: "Bourges airport",
    city: "Bourges",
    country: "FR",
    continent: "EU",
    lat: 47.0602,
    lon: 2.3696,
    elevation: 529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLI": {
    icao: "LFLI",
    iata: "",
    name: "Annemasse Airfield",
    city: "Annemasse",
    country: "FR",
    continent: "EU",
    lat: 46.192,
    lon: 6.2684,
    elevation: 1620,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLL": {
    icao: "LFLL",
    iata: "LYS",
    name: "Lyon Saint-Exupéry Airport",
    city: "Colombier-Saugnieu, Rhône",
    country: "FR",
    continent: "EU",
    lat: 45.726,
    lon: 5.0901,
    elevation: 821,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFLM": {
    icao: "LFLM",
    iata: "",
    name: "Mâcon-Charnay Airfield",
    city: "Charnay-lès-Mâcon, Saône-et-Loire",
    country: "FR",
    continent: "EU",
    lat: 46.2951,
    lon: 4.796,
    elevation: 728,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLN": {
    icao: "LFLN",
    iata: "SYT",
    name: "Saint-Yan Airport",
    city: "L\'Hôpital-le-Mercier, Saône-et-Loire",
    country: "FR",
    continent: "EU",
    lat: 46.414,
    lon: 4.0142,
    elevation: 796,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLO": {
    icao: "LFLO",
    iata: "RNE",
    name: "Roanne-Renaison Airport",
    city: "Saint-Léger-sur-Roanne",
    country: "FR",
    continent: "EU",
    lat: 46.0538,
    lon: 3.999,
    elevation: 1106,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLP": {
    icao: "LFLP",
    iata: "NCY",
    name: "Annecy Meythet airport",
    city: "Annecy",
    country: "FR",
    continent: "EU",
    lat: 45.9289,
    lon: 6.0987,
    elevation: 1521,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLS": {
    icao: "LFLS",
    iata: "GNB",
    name: "Grenoble Alpes Isère Airport",
    city: "Grenoble",
    country: "FR",
    continent: "EU",
    lat: 45.3629,
    lon: 5.3294,
    elevation: 1302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLU": {
    icao: "LFLU",
    iata: "VAF",
    name: "Valence-Chabeuil Airport",
    city: "Chabeuil, Drôme",
    country: "FR",
    continent: "EU",
    lat: 44.9216,
    lon: 4.9699,
    elevation: 525,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLV": {
    icao: "LFLV",
    iata: "VHY",
    name: "Vichy-Charmeil Airport",
    city: "Charmeil, Allier",
    country: "FR",
    continent: "EU",
    lat: 46.1697,
    lon: 3.4036,
    elevation: 817,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLW": {
    icao: "LFLW",
    iata: "AUR",
    name: "Aurillac airport",
    city: "Aurillac",
    country: "FR",
    continent: "EU",
    lat: 44.8914,
    lon: 2.4219,
    elevation: 2096,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLX": {
    icao: "LFLX",
    iata: "CHR",
    name: "Châteauroux Déols airport",
    city: "Châteauroux",
    country: "FR",
    continent: "EU",
    lat: 46.8602,
    lon: 1.7283,
    elevation: 529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFLY": {
    icao: "LFLY",
    iata: "LYN",
    name: "Lyon Bron Airport",
    city: "Chassieu, Lyon",
    country: "FR",
    continent: "EU",
    lat: 45.7279,
    lon: 4.944,
    elevation: 659,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMC": {
    icao: "LFMC",
    iata: "",
    name: "Le Luc-Le Cannet Airfield",
    city: "Le Cannet-des-Maures, Var",
    country: "FR",
    continent: "EU",
    lat: 43.3847,
    lon: 6.3871,
    elevation: 265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMD": {
    icao: "LFMD",
    iata: "CEQ",
    name: "Cannes Mandelieu Airport",
    city: "Cannes",
    country: "FR",
    continent: "EU",
    lat: 43.548,
    lon: 6.9552,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMH": {
    icao: "LFMH",
    iata: "EBU",
    name: "Saint-Étienne-Bouthéon Airport",
    city: "Andrézieux-Bouthéon, Loire",
    country: "FR",
    continent: "EU",
    lat: 45.5406,
    lon: 4.2964,
    elevation: 1325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMI": {
    icao: "LFMI",
    iata: "",
    name: "Istres-Le Tubé Air Base",
    city: "Istres, Bouches-du-Rhône",
    country: "FR",
    continent: "EU",
    lat: 43.5227,
    lon: 4.9238,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMK": {
    icao: "LFMK",
    iata: "CCF",
    name: "Carcassonne Salvaza Airport",
    city: "Carcassonne",
    country: "FR",
    continent: "EU",
    lat: 43.216,
    lon: 2.3063,
    elevation: 433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFML": {
    icao: "LFML",
    iata: "MRS",
    name: "Marseille Provence Airport",
    city: "Marignane, Bouches-du-Rhône",
    country: "FR",
    continent: "EU",
    lat: 43.4381,
    lon: 5.2125,
    elevation: 74,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFMN": {
    icao: "LFMN",
    iata: "NCE",
    name: "Nice-Côte d\'Azur Airport",
    city: "Nice, Alpes-Maritimes",
    country: "FR",
    continent: "EU",
    lat: 43.6584,
    lon: 7.2159,
    elevation: 12,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFMO": {
    icao: "LFMO",
    iata: "",
    name: "Orange-Caritat (BA 115) Air Base",
    city: "Orange, Vaucluse",
    country: "FR",
    continent: "EU",
    lat: 44.1405,
    lon: 4.8667,
    elevation: 197,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMP": {
    icao: "LFMP",
    iata: "PGF",
    name: "Perpignan-Rivesaltes (Llabanère) Airport",
    city: "Perpignan/Rivesaltes",
    country: "FR",
    continent: "EU",
    lat: 42.7404,
    lon: 2.8707,
    elevation: 144,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMQ": {
    icao: "LFMQ",
    iata: "CTT",
    name: "Le Castellet Airport",
    city: "Le Castellet, Var",
    country: "FR",
    continent: "EU",
    lat: 43.2525,
    lon: 5.7852,
    elevation: 1391,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMS": {
    icao: "LFMS",
    iata: "",
    name: "Aérodrome d\'Alès Cévennes",
    city: "Alès/Deaux",
    country: "FR",
    continent: "EU",
    lat: 44.0697,
    lon: 4.1421,
    elevation: 668,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMT": {
    icao: "LFMT",
    iata: "MPL",
    name: "Montpellier-Méditerranée Airport",
    city: "Montpellier/Méditerranée",
    country: "FR",
    continent: "EU",
    lat: 43.5762,
    lon: 3.963,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMU": {
    icao: "LFMU",
    iata: "BZR",
    name: "Béziers Vias airport",
    city: "Béziers",
    country: "FR",
    continent: "EU",
    lat: 43.3235,
    lon: 3.3539,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMV": {
    icao: "LFMV",
    iata: "AVN",
    name: "Avignon Caumont airport",
    city: "Avignon",
    country: "FR",
    continent: "EU",
    lat: 43.9073,
    lon: 4.9018,
    elevation: 124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFMY": {
    icao: "LFMY",
    iata: "",
    name: "Salon-de-Provence (BA 701) Air Base",
    city: "Salon",
    country: "FR",
    continent: "EU",
    lat: 43.6064,
    lon: 5.1093,
    elevation: 195,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFNB": {
    icao: "LFNB",
    iata: "MEN",
    name: "Mende-Brenoux Airfield",
    city: "Mende/Brénoux",
    country: "FR",
    continent: "EU",
    lat: 44.5021,
    lon: 3.5328,
    elevation: 3362,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOA": {
    icao: "LFOA",
    iata: "",
    name: "Avord (BA 702) Air Base",
    city: "Avord",
    country: "FR",
    continent: "EU",
    lat: 47.0533,
    lon: 2.6325,
    elevation: 580,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOB": {
    icao: "LFOB",
    iata: "BVA",
    name: "Beauvais Tillé airport",
    city: "Beauvais",
    country: "FR",
    continent: "EU",
    lat: 49.4544,
    lon: 2.1128,
    elevation: 359,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOC": {
    icao: "LFOC",
    iata: "",
    name: "Châteaudun Airfield",
    city: "Châteaudun, Eure-et-Loir",
    country: "FR",
    continent: "EU",
    lat: 48.0579,
    lon: 1.3793,
    elevation: 433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOE": {
    icao: "LFOE",
    iata: "EVX",
    name: "Évreux-Fauville (BA 105) Air Base",
    city: "Fauville, Eure",
    country: "FR",
    continent: "EU",
    lat: 49.0287,
    lon: 1.2199,
    elevation: 464,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOH": {
    icao: "LFOH",
    iata: "LEH",
    name: "Le Havre-Octeville Airport",
    city: "Le Havre",
    country: "FR",
    continent: "EU",
    lat: 49.534,
    lon: 0.0884,
    elevation: 313,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOI": {
    icao: "LFOI",
    iata: "",
    name: "Abbeville-Buigny Baie de Somme Airfield",
    city: "Buigny-Saint-Maclou",
    country: "FR",
    continent: "EU",
    lat: 50.1435,
    lon: 1.8319,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOJ": {
    icao: "LFOJ",
    iata: "",
    name: "Orléans-Bricy (BA 123) Air Base",
    city: "Boulay-les-Barres, Loiret",
    country: "FR",
    continent: "EU",
    lat: 47.9878,
    lon: 1.7606,
    elevation: 412,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOK": {
    icao: "LFOK",
    iata: "XCR",
    name: "Chalons Vatry airport",
    city: "Chalons en Champagne",
    country: "FR",
    continent: "EU",
    lat: 48.7733,
    lon: 4.2061,
    elevation: 587,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOP": {
    icao: "LFOP",
    iata: "URO",
    name: "Rouen Vallée de Seine Airport",
    city: "Boos",
    country: "FR",
    continent: "EU",
    lat: 49.3849,
    lon: 1.1791,
    elevation: 512,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOT": {
    icao: "LFOT",
    iata: "TUF",
    name: "Tours Val de Loire Airport",
    city: "Tours, Indre-et-Loire",
    country: "FR",
    continent: "EU",
    lat: 47.4322,
    lon: 0.7276,
    elevation: 357,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFOV": {
    icao: "LFOV",
    iata: "LVA",
    name: "Laval-Entrammes Airport",
    city: "Laval, Mayenne",
    country: "FR",
    continent: "EU",
    lat: 48.0322,
    lon: -0.744,
    elevation: 330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFPB": {
    icao: "LFPB",
    iata: "LBG",
    name: "Paris-Le Bourget Airport",
    city: "Paris",
    country: "FR",
    continent: "EU",
    lat: 48.9694,
    lon: 2.4414,
    elevation: 218,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFPC": {
    icao: "LFPC",
    iata: "CSF",
    name: "Creil Air Base",
    city: "Creil",
    country: "FR",
    continent: "EU",
    lat: 49.2535,
    lon: 2.5191,
    elevation: 291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFPG": {
    icao: "LFPG",
    iata: "CDG",
    name: "Charles de Gaulle International Airport",
    city: "Paris (Roissy-en-France, Val-d\'Oise)",
    country: "FR",
    continent: "EU",
    lat: 49.0128,
    lon: 2.55,
    elevation: 392,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "LFPM": {
    icao: "LFPM",
    iata: "",
    name: "Melun-Villaroche Airfield",
    city: "Moissy-Cramayel, Seine-et-Marne",
    country: "FR",
    continent: "EU",
    lat: 48.6047,
    lon: 2.6711,
    elevation: 302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFPN": {
    icao: "LFPN",
    iata: "TNF",
    name: "Toussus-le-Noble Airport",
    city: "Toussus-le-Noble, Yvelines",
    country: "FR",
    continent: "EU",
    lat: 48.7519,
    lon: 2.1062,
    elevation: 538,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFPO": {
    icao: "LFPO",
    iata: "ORY",
    name: "Paris-Orly Airport",
    city: "Paris (Orly, Val-de-Marne)",
    country: "FR",
    continent: "EU",
    lat: 48.7233,
    lon: 2.3794,
    elevation: 291,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFPT": {
    icao: "LFPT",
    iata: "POX",
    name: "Pontoise-Cormeilles Aerodrome",
    city: "Cormeilles-en-Vexin, Val-d\'Oise",
    country: "FR",
    continent: "EU",
    lat: 49.0961,
    lon: 2.0355,
    elevation: 325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFPV": {
    icao: "LFPV",
    iata: "VIY",
    name: "Vélizy-Villacoublay Air Base",
    city: "Vélizy-Villacoublay, Yvelines",
    country: "FR",
    continent: "EU",
    lat: 48.7744,
    lon: 2.2031,
    elevation: 584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQB": {
    icao: "LFQB",
    iata: "",
    name: "Troyes-Barberey Airport",
    city: "Barberey-Saint-Sulpice, Aube",
    country: "FR",
    continent: "EU",
    lat: 48.3221,
    lon: 4.0167,
    elevation: 388,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQE": {
    icao: "LFQE",
    iata: "",
    name: "Lieutenant Étienne Mantoux Air Base",
    city: "Rouvres-en-Woëvre",
    country: "FR",
    continent: "EU",
    lat: 49.2269,
    lon: 5.6722,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQG": {
    icao: "LFQG",
    iata: "NVS",
    name: "Nevers-Fourchambault Airport",
    city: "Marzy, Nièvre",
    country: "FR",
    continent: "EU",
    lat: 47.0029,
    lon: 3.1131,
    elevation: 602,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQP": {
    icao: "LFQP",
    iata: "",
    name: "Phalsbourg-Bourscheid Air Base",
    city: "Bourscheid",
    country: "FR",
    continent: "EU",
    lat: 48.7662,
    lon: 7.2006,
    elevation: 1017,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQQ": {
    icao: "LFQQ",
    iata: "LIL",
    name: "Lille Airport",
    city: "Lesquin",
    country: "FR",
    continent: "EU",
    lat: 50.5633,
    lon: 3.0869,
    elevation: 157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQT": {
    icao: "LFQT",
    iata: "HZB",
    name: "Merville-Calonne Airport",
    city: "Merville, Nord",
    country: "FR",
    continent: "EU",
    lat: 50.6184,
    lon: 2.6422,
    elevation: 61,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQV": {
    icao: "LFQV",
    iata: "",
    name: "Charleville-Mézières Ardennes-Etienne Riché Airfield",
    city: "Charleville-Mézières",
    country: "FR",
    continent: "EU",
    lat: 49.7839,
    lon: 4.6471,
    elevation: 492,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFQW": {
    icao: "LFQW",
    iata: "",
    name: "Vesoul-Frotey Airfield",
    city: "Frotey-lès-Vesoul, Haute-Saône",
    country: "FR",
    continent: "EU",
    lat: 47.6386,
    lon: 6.2044,
    elevation: 1249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRB": {
    icao: "LFRB",
    iata: "BES",
    name: "Brest Bretagne airport",
    city: "Brest",
    country: "FR",
    continent: "EU",
    lat: 48.4479,
    lon: -4.4185,
    elevation: 325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRC": {
    icao: "LFRC",
    iata: "CER",
    name: "Cherbourg Manche airport",
    city: "Cherbourg",
    country: "FR",
    continent: "EU",
    lat: 49.6501,
    lon: -1.4703,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRD": {
    icao: "LFRD",
    iata: "DNR",
    name: "Dinard Pleurtuit Saint-Malo airport",
    city: "Dinard",
    country: "FR",
    continent: "EU",
    lat: 48.5877,
    lon: -2.08,
    elevation: 219,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRE": {
    icao: "LFRE",
    iata: "LBY",
    name: "La Baule-Escoublac Airport",
    city: "La Baule-Escoublac",
    country: "FR",
    continent: "EU",
    lat: 47.2894,
    lon: -2.3464,
    elevation: 105,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRF": {
    icao: "LFRF",
    iata: "GFR",
    name: "Granville Airport",
    city: "Bréville-sur-Mer, Manche",
    country: "FR",
    continent: "EU",
    lat: 48.8831,
    lon: -1.5642,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRG": {
    icao: "LFRG",
    iata: "DOL",
    name: "Deauville Normandie airport",
    city: "Deauville",
    country: "FR",
    continent: "EU",
    lat: 49.3652,
    lon: 0.1545,
    elevation: 479,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRH": {
    icao: "LFRH",
    iata: "LRT",
    name: "Lorient South Brittany (Bretagne Sud) Airport",
    city: "Lorient/Lann/Bihoué",
    country: "FR",
    continent: "EU",
    lat: 47.7606,
    lon: -3.44,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRI": {
    icao: "LFRI",
    iata: "EDM",
    name: "La Roche-sur-Yon Les Ajoncs Airport",
    city: "La Roche-sur-Yon",
    country: "FR",
    continent: "EU",
    lat: 46.7019,
    lon: -1.3786,
    elevation: 299,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRJ": {
    icao: "LFRJ",
    iata: "LDV",
    name: "Landivisiau Air Base",
    city: "Landivisiau",
    country: "FR",
    continent: "EU",
    lat: 48.5303,
    lon: -4.1516,
    elevation: 348,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRK": {
    icao: "LFRK",
    iata: "CFR",
    name: "Caen Carpiquet airport",
    city: "Caen",
    country: "FR",
    continent: "EU",
    lat: 49.1768,
    lon: -0.4549,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRL": {
    icao: "LFRL",
    iata: "",
    name: "Lanvéoc-Poulmic Air Base",
    city: "Lanvéoc/Poulmic",
    country: "FR",
    continent: "EU",
    lat: 48.2817,
    lon: -4.445,
    elevation: 287,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRM": {
    icao: "LFRM",
    iata: "LME",
    name: "Le Mans-Arnage Airport",
    city: "Le Mans, Sarthe",
    country: "FR",
    continent: "EU",
    lat: 47.9486,
    lon: 0.2017,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRN": {
    icao: "LFRN",
    iata: "RNS",
    name: "Rennes-Saint-Jacques Airport",
    city: "Saint-Jacques-de-la-Lande, Ille-et-Vilaine",
    country: "FR",
    continent: "EU",
    lat: 48.0695,
    lon: -1.7348,
    elevation: 124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRO": {
    icao: "LFRO",
    iata: "LAI",
    name: "Lannion Airport",
    city: "Lannion",
    country: "FR",
    continent: "EU",
    lat: 48.7544,
    lon: -3.4717,
    elevation: 290,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRQ": {
    icao: "LFRQ",
    iata: "UIP",
    name: "Quimper-Cornouaille Airport",
    city: "Quimper/Pluguffan",
    country: "FR",
    continent: "EU",
    lat: 47.973,
    lon: -4.1697,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRS": {
    icao: "LFRS",
    iata: "NTE",
    name: "Nantes Atlantique Airport",
    city: "Nantes",
    country: "FR",
    continent: "EU",
    lat: 47.1532,
    lon: -1.6107,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRT": {
    icao: "LFRT",
    iata: "SBK",
    name: "Saint-Brieuc-Armor Airport",
    city: "Trémuson, Côtes-d\'Armor",
    country: "FR",
    continent: "EU",
    lat: 48.5386,
    lon: -2.8535,
    elevation: 453,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRU": {
    icao: "LFRU",
    iata: "MXN",
    name: "Morlaix-Ploujean Airport",
    city: "Morlaix/Ploujean",
    country: "FR",
    continent: "EU",
    lat: 48.6032,
    lon: -3.8158,
    elevation: 272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRV": {
    icao: "LFRV",
    iata: "VNE",
    name: "Vannes-Meucon Airport",
    city: "Vannes/Meucon",
    country: "FR",
    continent: "EU",
    lat: 47.7233,
    lon: -2.7186,
    elevation: 446,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFRZ": {
    icao: "LFRZ",
    iata: "SNR",
    name: "Saint-Nazaire-Montoir Airport",
    city: "Saint-Nazaire/Montoir",
    country: "FR",
    continent: "EU",
    lat: 47.3114,
    lon: -2.1526,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSB": {
    icao: "LFSB",
    iata: "BSL",
    name: "EuroAirport Basel–Mulhouse–Freiburg",
    city: "Bâle / Mulhouse",
    country: "FR",
    continent: "EU",
    lat: 47.6007,
    lon: 7.5211,
    elevation: 885,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LFSD": {
    icao: "LFSD",
    iata: "DIJ",
    name: "Dijon Longvic airport",
    city: "Dijon",
    country: "FR",
    continent: "EU",
    lat: 47.2689,
    lon: 5.09,
    elevation: 726,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSG": {
    icao: "LFSG",
    iata: "EPL",
    name: "Épinal Mirecourt Airport",
    city: "Épinal",
    country: "FR",
    continent: "EU",
    lat: 48.325,
    lon: 6.07,
    elevation: 1084,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSI": {
    icao: "LFSI",
    iata: "",
    name: "Saint-Dizier – Robinson Air Base",
    city: "Saint-Dizier",
    country: "FR",
    continent: "EU",
    lat: 48.636,
    lon: 4.8994,
    elevation: 458,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSL": {
    icao: "LFSL",
    iata: "BVE",
    name: "Brive Souillac airport",
    city: "Brive",
    country: "FR",
    continent: "EU",
    lat: 45.0397,
    lon: 1.4856,
    elevation: 1016,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSM": {
    icao: "LFSM",
    iata: "",
    name: "Montbéliard-Courcelles Airfield",
    city: "Courcelles-lès-Montbéliard",
    country: "FR",
    continent: "EU",
    lat: 47.487,
    lon: 6.7905,
    elevation: 1041,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSN": {
    icao: "LFSN",
    iata: "ENC",
    name: "Nancy-Essey Airport",
    city: "Tomblaine, Meurthe-et-Moselle",
    country: "FR",
    continent: "EU",
    lat: 48.6921,
    lon: 6.2305,
    elevation: 751,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSO": {
    icao: "LFSO",
    iata: "",
    name: "Nancy-Ochey (BA 133) Air Base",
    city: "Thuilley-aux-Groseilles",
    country: "FR",
    continent: "EU",
    lat: 48.5831,
    lon: 5.955,
    elevation: 1106,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFST": {
    icao: "LFST",
    iata: "SXB",
    name: "Strasbourg Airport",
    city: "Strasbourg",
    country: "FR",
    continent: "EU",
    lat: 48.5383,
    lon: 7.6282,
    elevation: 505,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFSX": {
    icao: "LFSX",
    iata: "",
    name: "Luxeuil-Saint-Sauveur (BA 116) Air Base",
    city: "Saint-Sauveur",
    country: "FR",
    continent: "EU",
    lat: 47.7877,
    lon: 6.3534,
    elevation: 913,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFTH": {
    icao: "LFTH",
    iata: "TLN",
    name: "Toulon-Hyères Airport",
    city: "Hyères, Var",
    country: "FR",
    continent: "EU",
    lat: 43.0973,
    lon: 6.146,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFTW": {
    icao: "LFTW",
    iata: "FNI",
    name: "Nîmes-Arles-Camargue Airport",
    city: "Nîmes/Garons",
    country: "FR",
    continent: "EU",
    lat: 43.7574,
    lon: 4.4164,
    elevation: 309,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFVP": {
    icao: "LFVP",
    iata: "FSP",
    name: "St Pierre Airport",
    city: "Saint-Pierre",
    country: "PM",
    continent: "NA",
    lat: 46.7629,
    lon: -56.1731,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LFXA": {
    icao: "LFXA",
    iata: "",
    name: "Ambérieu Air Base (BA 278)",
    city: "Ambérieu",
    country: "FR",
    continent: "EU",
    lat: 45.9873,
    lon: 5.3284,
    elevation: 823,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGAD": {
    icao: "LGAD",
    iata: "PYR",
    name: "Andravida Air Base",
    city: "Andravida",
    country: "GR",
    continent: "EU",
    lat: 37.9207,
    lon: 21.2926,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGAL": {
    icao: "LGAL",
    iata: "AXD",
    name: "Alexandroupoli Democritus Airport",
    city: "Alexandroupolis",
    country: "GR",
    continent: "EU",
    lat: 40.8559,
    lon: 25.9563,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGAV": {
    icao: "LGAV",
    iata: "ATH",
    name: "Athens Eleftherios Venizelos International Airport",
    city: "Spata-Artemida",
    country: "GR",
    continent: "EU",
    lat: 37.9364,
    lon: 23.9445,
    elevation: 308,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LGBL": {
    icao: "LGBL",
    iata: "VOL",
    name: "Nea Anchialos National Airport",
    city: "Nea Anchialos",
    country: "GR",
    continent: "EU",
    lat: 39.2196,
    lon: 22.7943,
    elevation: 83,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGEL": {
    icao: "LGEL",
    iata: "",
    name: "Elefsis Air Base",
    city: "Elefsina",
    country: "GR",
    continent: "EU",
    lat: 38.0638,
    lon: 23.556,
    elevation: 143,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGHI": {
    icao: "LGHI",
    iata: "JKH",
    name: "Chios Island National Airport",
    city: "Chios Island",
    country: "GR",
    continent: "EU",
    lat: 38.3432,
    lon: 26.1406,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGIO": {
    icao: "LGIO",
    iata: "IOA",
    name: "Ioannina King Pyrrhus National Airport",
    city: "Ioannina",
    country: "GR",
    continent: "EU",
    lat: 39.6964,
    lon: 20.8225,
    elevation: 1558,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGIR": {
    icao: "LGIR",
    iata: "HER",
    name: "Heraklion International Nikos Kazantzakis Airport",
    city: "Heraklion",
    country: "GR",
    continent: "EU",
    lat: 35.3397,
    lon: 25.1803,
    elevation: 115,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LGKF": {
    icao: "LGKF",
    iata: "EFL",
    name: "Kefallinia Airport",
    city: "Kefallinia Island",
    country: "GR",
    continent: "EU",
    lat: 38.1201,
    lon: 20.5005,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGKL": {
    icao: "LGKL",
    iata: "KLX",
    name: "Kalamata Airport",
    city: "Kalamata",
    country: "GR",
    continent: "EU",
    lat: 37.0683,
    lon: 22.0255,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGKO": {
    icao: "LGKO",
    iata: "KGS",
    name: "Kos Airport",
    city: "Kos Island",
    country: "GR",
    continent: "AS",
    lat: 36.7945,
    lon: 27.0911,
    elevation: 412,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGKP": {
    icao: "LGKP",
    iata: "AOK",
    name: "Karpathos Airport",
    city: "Karpathos Island",
    country: "GR",
    continent: "EU",
    lat: 35.4214,
    lon: 27.146,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGKR": {
    icao: "LGKR",
    iata: "CFU",
    name: "Corfu Ioannis Kapodistrias International Airport",
    city: "Kerkyra (Corfu)",
    country: "GR",
    continent: "EU",
    lat: 39.602,
    lon: 19.912,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGKV": {
    icao: "LGKV",
    iata: "KVA",
    name: "Kavala Alexander the Great International Airport",
    city: "Kavala",
    country: "GR",
    continent: "EU",
    lat: 40.9133,
    lon: 24.6192,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGKZ": {
    icao: "LGKZ",
    iata: "KZI",
    name: "Kozani National Airport Filippos",
    city: "Kozani",
    country: "GR",
    continent: "EU",
    lat: 40.2861,
    lon: 21.8408,
    elevation: 2059,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGMK": {
    icao: "LGMK",
    iata: "JMK",
    name: "Mykonos Island National Airport",
    city: "Mykonos",
    country: "GR",
    continent: "EU",
    lat: 37.4351,
    lon: 25.3481,
    elevation: 405,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGMT": {
    icao: "LGMT",
    iata: "MJT",
    name: "Mytilene International Airport",
    city: "Mytilene",
    country: "GR",
    continent: "EU",
    lat: 39.0573,
    lon: 26.5989,
    elevation: 60,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGPZ": {
    icao: "LGPZ",
    iata: "PVK",
    name: "Aktion National Airport",
    city: "Preveza",
    country: "GR",
    continent: "EU",
    lat: 38.9255,
    lon: 20.7653,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGRP": {
    icao: "LGRP",
    iata: "RHO",
    name: "Diagoras Airport",
    city: "Rhodes",
    country: "GR",
    continent: "AS",
    lat: 36.4054,
    lon: 28.0862,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGRX": {
    icao: "LGRX",
    iata: "GPA",
    name: "Patras Araxos Agamemnon Airport",
    city: "Patras",
    country: "GR",
    continent: "EU",
    lat: 38.1511,
    lon: 21.4256,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGSA": {
    icao: "LGSA",
    iata: "CHQ",
    name: "Chania International Airport",
    city: "Souda",
    country: "GR",
    continent: "EU",
    lat: 35.5317,
    lon: 24.1497,
    elevation: 490,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGSK": {
    icao: "LGSK",
    iata: "JSI",
    name: "Skiathos Island National Airport",
    city: "Skiathos",
    country: "GR",
    continent: "EU",
    lat: 39.1771,
    lon: 23.5037,
    elevation: 54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGSM": {
    icao: "LGSM",
    iata: "SMI",
    name: "Samos Airport",
    city: "Samos Island",
    country: "GR",
    continent: "EU",
    lat: 37.69,
    lon: 26.9117,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGSR": {
    icao: "LGSR",
    iata: "JTR",
    name: "Santorini Airport",
    city: "Santorini Island",
    country: "GR",
    continent: "EU",
    lat: 36.3992,
    lon: 25.4793,
    elevation: 127,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGST": {
    icao: "LGST",
    iata: "JSH",
    name: "Sitia Airport",
    city: "Crete Island",
    country: "GR",
    continent: "EU",
    lat: 35.2161,
    lon: 26.1013,
    elevation: 376,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGTG": {
    icao: "LGTG",
    iata: "",
    name: "Tanagra Air Base",
    city: "Tanagra",
    country: "GR",
    continent: "EU",
    lat: 38.3398,
    lon: 23.565,
    elevation: 495,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LGTS": {
    icao: "LGTS",
    iata: "SKG",
    name: "Thessaloniki Macedonia International Airport",
    city: "Thessaloniki",
    country: "GR",
    continent: "EU",
    lat: 40.5193,
    lon: 22.97,
    elevation: 22,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LGZA": {
    icao: "LGZA",
    iata: "ZTH",
    name: "Zakynthos International Airport Dionysios Solomos",
    city: "Zakynthos",
    country: "GR",
    continent: "EU",
    lat: 37.7509,
    lon: 20.8843,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHBP": {
    icao: "LHBP",
    iata: "BUD",
    name: "Budapest Liszt Ferenc International Airport",
    city: "Budapest",
    country: "HU",
    continent: "EU",
    lat: 47.4302,
    lon: 19.2624,
    elevation: 495,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LHDC": {
    icao: "LHDC",
    iata: "DEB",
    name: "Debrecen International Airport",
    city: "Debrecen",
    country: "HU",
    continent: "EU",
    lat: 47.4889,
    lon: 21.6153,
    elevation: 359,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHKE": {
    icao: "LHKE",
    iata: "",
    name: "Kecskemét Air Base",
    city: "Kecskemét",
    country: "HU",
    continent: "EU",
    lat: 46.9175,
    lon: 19.7492,
    elevation: 376,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHPP": {
    icao: "LHPP",
    iata: "PEV",
    name: "Pécs-Pogány Airport",
    city: "Pécs",
    country: "HU",
    continent: "EU",
    lat: 45.9889,
    lon: 18.242,
    elevation: 651,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHPR": {
    icao: "LHPR",
    iata: "",
    name: "Győr-Pér International Airport",
    city: "Pér",
    country: "HU",
    continent: "EU",
    lat: 47.6284,
    lon: 17.8047,
    elevation: 424,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHSM": {
    icao: "LHSM",
    iata: "SOB",
    name: "Hévíz–Balaton Airport",
    city: "Sármellék",
    country: "HU",
    continent: "EU",
    lat: 46.6864,
    lon: 17.1591,
    elevation: 408,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHSN": {
    icao: "LHSN",
    iata: "",
    name: "Szolnok Air Base",
    city: "Szolnok",
    country: "HU",
    continent: "EU",
    lat: 47.1229,
    lon: 20.2355,
    elevation: 322,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHTA": {
    icao: "LHTA",
    iata: "",
    name: "Taszár Air Base",
    city: "Taszár",
    country: "HU",
    continent: "EU",
    lat: 46.3931,
    lon: 17.9175,
    elevation: 531,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LHTL": {
    icao: "LHTL",
    iata: "",
    name: "Tököl Airport",
    city: "Tököl",
    country: "HU",
    continent: "EU",
    lat: 47.3453,
    lon: 18.9808,
    elevation: 318,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBA": {
    icao: "LIBA",
    iata: "",
    name: "Amendola Air Base",
    city: "San Giovanni Rotondo (FG)",
    country: "IT",
    continent: "EU",
    lat: 41.5384,
    lon: 15.7172,
    elevation: 183,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBC": {
    icao: "LIBC",
    iata: "CRV",
    name: "Crotone Sant\'Anna Pythagoras Airport",
    city: "Isola di Capo Rizzuto (KR)",
    country: "IT",
    continent: "EU",
    lat: 38.9972,
    lon: 17.0802,
    elevation: 522,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBD": {
    icao: "LIBD",
    iata: "BRI",
    name: "Bari Karol Wojtyła International Airport",
    city: "Bari",
    country: "IT",
    continent: "EU",
    lat: 41.1389,
    lon: 16.7606,
    elevation: 193,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIBF": {
    icao: "LIBF",
    iata: "FOG",
    name: "Foggia Gino Lisa Airport",
    city: "Foggia (FG)",
    country: "IT",
    continent: "EU",
    lat: 41.4336,
    lon: 15.5346,
    elevation: 265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBG": {
    icao: "LIBG",
    iata: "TAR",
    name: "Taranto-Grottaglie Marcello Arlotta Airport",
    city: "Grottaglie",
    country: "IT",
    continent: "EU",
    lat: 40.5175,
    lon: 17.4032,
    elevation: 215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBN": {
    icao: "LIBN",
    iata: "LCC",
    name: "Lecce Galatina Air Base / Galatina Fortunato Cesari Airport",
    city: "Galatina (LE)",
    country: "IT",
    continent: "EU",
    lat: 40.2392,
    lon: 18.1333,
    elevation: 156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBP": {
    icao: "LIBP",
    iata: "PSR",
    name: "Abruzzo Airport",
    city: "Pescara",
    country: "IT",
    continent: "EU",
    lat: 42.4317,
    lon: 14.1811,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIBR": {
    icao: "LIBR",
    iata: "BDS",
    name: "Brindisi Airport",
    city: "Brindisi",
    country: "IT",
    continent: "EU",
    lat: 40.6576,
    lon: 17.947,
    elevation: 47,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIBV": {
    icao: "LIBV",
    iata: "",
    name: "Gioia del Colle Antonio Ramirez Air Base",
    city: "Gioia del Colle (BA)",
    country: "IT",
    continent: "EU",
    lat: 40.7678,
    lon: 16.9333,
    elevation: 1187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICA": {
    icao: "LICA",
    iata: "SUF",
    name: "Lamezia Terme Sant\'Eufemia International Airport",
    city: "Lamezia Terme (CZ)",
    country: "IT",
    continent: "EU",
    lat: 38.9052,
    lon: 16.2438,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICB": {
    icao: "LICB",
    iata: "CIY",
    name: "Comiso Airport",
    city: "Comiso",
    country: "IT",
    continent: "EU",
    lat: 36.9958,
    lon: 14.6089,
    elevation: 756,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICC": {
    icao: "LICC",
    iata: "CTA",
    name: "Catania-Fontanarossa Airport",
    city: "Catania",
    country: "IT",
    continent: "EU",
    lat: 37.4668,
    lon: 15.0664,
    elevation: 39,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LICD": {
    icao: "LICD",
    iata: "LMP",
    name: "Lampedusa Airport",
    city: "Lampedusa",
    country: "IT",
    continent: "EU",
    lat: 35.4979,
    lon: 12.6181,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICG": {
    icao: "LICG",
    iata: "PNL",
    name: "Pantelleria Airport",
    city: "Pantelleria (TP)",
    country: "IT",
    continent: "EU",
    lat: 36.8165,
    lon: 11.9689,
    elevation: 628,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICJ": {
    icao: "LICJ",
    iata: "PMO",
    name: "Falcone–Borsellino Airport",
    city: "Palermo",
    country: "IT",
    continent: "EU",
    lat: 38.176,
    lon: 13.091,
    elevation: 65,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LICP": {
    icao: "LICP",
    iata: "",
    name: "Palermo-Boccadifalco Airport",
    city: "Palermo",
    country: "IT",
    continent: "EU",
    lat: 38.1159,
    lon: 13.3134,
    elevation: 345,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICR": {
    icao: "LICR",
    iata: "REG",
    name: "Reggio Calabria Airport",
    city: "Reggio Calabria",
    country: "IT",
    continent: "EU",
    lat: 38.0712,
    lon: 15.6516,
    elevation: 96,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICT": {
    icao: "LICT",
    iata: "TPS",
    name: "Vincenzo Florio Airport Trapani-Birgi",
    city: "Trapani (TP)",
    country: "IT",
    continent: "EU",
    lat: 37.9114,
    lon: 12.488,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LICZ": {
    icao: "LICZ",
    iata: "",
    name: "Sigonella Navy Air Base",
    city: "Sigonella (CT)",
    country: "IT",
    continent: "EU",
    lat: 37.4017,
    lon: 14.9224,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIDT": {
    icao: "LIDT",
    iata: "",
    name: "Trento-Mattarello Airport",
    city: "Trento (TN)",
    country: "IT",
    continent: "EU",
    lat: 46.0233,
    lon: 11.125,
    elevation: 610,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIEA": {
    icao: "LIEA",
    iata: "AHO",
    name: "Alghero-Fertilia Airport",
    city: "Alghero",
    country: "IT",
    continent: "EU",
    lat: 40.6321,
    lon: 8.2908,
    elevation: 87,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIED": {
    icao: "LIED",
    iata: "DCI",
    name: "Decimomannu Air Base",
    city: "Decimomannu",
    country: "IT",
    continent: "EU",
    lat: 39.3542,
    lon: 8.9725,
    elevation: 100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIEE": {
    icao: "LIEE",
    iata: "CAG",
    name: "Cagliari Elmas Airport",
    city: "Cagliari",
    country: "IT",
    continent: "EU",
    lat: 39.2515,
    lon: 9.0543,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIEO": {
    icao: "LIEO",
    iata: "OLB",
    name: "Olbia Costa Smeralda Airport",
    city: "Olbia (SS)",
    country: "IT",
    continent: "EU",
    lat: 40.8987,
    lon: 9.5176,
    elevation: 37,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIET": {
    icao: "LIET",
    iata: "",
    name: "Tortolì Airport",
    city: "Arbatax",
    country: "IT",
    continent: "EU",
    lat: 39.9188,
    lon: 9.683,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LILE": {
    icao: "LILE",
    iata: "",
    name: "Biella-Cerrione Airfield",
    city: "Cerrione (BI)",
    country: "IT",
    continent: "EU",
    lat: 45.4953,
    lon: 8.1028,
    elevation: 920,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LILN": {
    icao: "LILN",
    iata: "",
    name: "Varese-Venegono Airport",
    city: "Venegono Superiore (VA)",
    country: "IT",
    continent: "EU",
    lat: 45.7422,
    lon: 8.8882,
    elevation: 1100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMA": {
    icao: "LIMA",
    iata: "",
    name: "Torino-Aeritalia Airport",
    city: "Torino (TO)",
    country: "IT",
    continent: "EU",
    lat: 45.0844,
    lon: 7.6031,
    elevation: 943,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMC": {
    icao: "LIMC",
    iata: "MXP",
    name: "Milan Malpensa International Airport",
    city: "Ferno (VA)",
    country: "IT",
    continent: "EU",
    lat: 45.6306,
    lon: 8.7281,
    elevation: 768,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIME": {
    icao: "LIME",
    iata: "BGY",
    name: "Milan Bergamo Airport / Antonio Locatelli Air Base",
    city: "Orio al Serio (BG)",
    country: "IT",
    continent: "EU",
    lat: 45.6707,
    lon: 9.7092,
    elevation: 782,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIMF": {
    icao: "LIMF",
    iata: "TRN",
    name: "Turin Airport",
    city: "Caselle Torinese (TO)",
    country: "IT",
    continent: "EU",
    lat: 45.2008,
    lon: 7.6496,
    elevation: 989,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIMG": {
    icao: "LIMG",
    iata: "",
    name: "Riviera Villanova d\'Albenga International Airport",
    city: "Villanova d\'Albenga (SV)",
    country: "IT",
    continent: "EU",
    lat: 44.0506,
    lon: 8.1274,
    elevation: 148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMJ": {
    icao: "LIMJ",
    iata: "GOA",
    name: "Genoa Cristoforo Colombo Airport",
    city: "Genova (GE)",
    country: "IT",
    continent: "EU",
    lat: 44.412,
    lon: 8.8407,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIML": {
    icao: "LIML",
    iata: "LIN",
    name: "Milano Linate Airport",
    city: "Segrate (MI)",
    country: "IT",
    continent: "EU",
    lat: 45.4451,
    lon: 9.2767,
    elevation: 353,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMN": {
    icao: "LIMN",
    iata: "",
    name: "Cameri Air Base [MIL]",
    city: "Cameri (NO)",
    country: "IT",
    continent: "EU",
    lat: 45.5296,
    lon: 8.6692,
    elevation: 586,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMP": {
    icao: "LIMP",
    iata: "PMF",
    name: "Parma Airport",
    city: "Parma (PR)",
    country: "IT",
    continent: "EU",
    lat: 44.8264,
    lon: 10.2971,
    elevation: 161,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMR": {
    icao: "LIMR",
    iata: "",
    name: "Novi Ligure Eugenio Mossi Airfield",
    city: "Novi Ligure (AL)",
    country: "IT",
    continent: "EU",
    lat: 44.78,
    lon: 8.7864,
    elevation: 607,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMS": {
    icao: "LIMS",
    iata: "",
    name: "Piacenza San Damiano Air Base",
    city: "San Damiano (PC)",
    country: "IT",
    continent: "EU",
    lat: 44.9131,
    lon: 9.7233,
    elevation: 456,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMW": {
    icao: "LIMW",
    iata: "AOT",
    name: "Aosta Corrado Gex Airport",
    city: "Saint-Christophe (AO)",
    country: "IT",
    continent: "EU",
    lat: 45.7386,
    lon: 7.3683,
    elevation: 1791,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIMZ": {
    icao: "LIMZ",
    iata: "CUF",
    name: "Cuneo International Airport",
    city: "Levaldigi (CN)",
    country: "IT",
    continent: "EU",
    lat: 44.547,
    lon: 7.6232,
    elevation: 1267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPA": {
    icao: "LIPA",
    iata: "AVB",
    name: "Aviano Air Base",
    city: "Aviano (PN)",
    country: "IT",
    continent: "EU",
    lat: 46.0319,
    lon: 12.5965,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPB": {
    icao: "LIPB",
    iata: "BZO",
    name: "Bolzano Airport",
    city: "Bolzano (BZ)",
    country: "IT",
    continent: "EU",
    lat: 46.4602,
    lon: 11.3264,
    elevation: 789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPC": {
    icao: "LIPC",
    iata: "",
    name: "Cervia Air Base",
    city: "Cervia (RA)",
    country: "IT",
    continent: "EU",
    lat: 44.2242,
    lon: 12.3072,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPE": {
    icao: "LIPE",
    iata: "BLQ",
    name: "Bologna Guglielmo Marconi Airport",
    city: "Bologna",
    country: "IT",
    continent: "EU",
    lat: 44.5354,
    lon: 11.2887,
    elevation: 123,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIPH": {
    icao: "LIPH",
    iata: "TSF",
    name: "Treviso Antonio Canova Airport",
    city: "Treviso (TV)",
    country: "IT",
    continent: "EU",
    lat: 45.6484,
    lon: 12.1944,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPI": {
    icao: "LIPI",
    iata: "",
    name: "Udine-Rivolto Air Base",
    city: "Codroipo (UD)",
    country: "IT",
    continent: "EU",
    lat: 45.9787,
    lon: 13.0493,
    elevation: 179,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPK": {
    icao: "LIPK",
    iata: "FRL",
    name: "Forlì Luigi Ridolfi Airport",
    city: "Forlì (FC)",
    country: "IT",
    continent: "EU",
    lat: 44.1948,
    lon: 12.0701,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPL": {
    icao: "LIPL",
    iata: "",
    name: "Ghedi Air Base",
    city: "Ghedi (BS)",
    country: "IT",
    continent: "EU",
    lat: 45.4326,
    lon: 10.2686,
    elevation: 333,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPO": {
    icao: "LIPO",
    iata: "VBS",
    name: "Brescia Gabriele d\'Annunzio Airport",
    city: "Montichiari (BS)",
    country: "IT",
    continent: "EU",
    lat: 45.4289,
    lon: 10.3306,
    elevation: 355,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPQ": {
    icao: "LIPQ",
    iata: "TRS",
    name: "Trieste–Friuli Venezia Giulia Airport",
    city: "Ronchi dei Legionari (GO)",
    country: "IT",
    continent: "EU",
    lat: 45.8275,
    lon: 13.4722,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPR": {
    icao: "LIPR",
    iata: "RMI",
    name: "Federico Fellini International Airport",
    city: "Rimini (RN)",
    country: "IT",
    continent: "EU",
    lat: 44.0203,
    lon: 12.6117,
    elevation: 40,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPS": {
    icao: "LIPS",
    iata: "",
    name: "Istrana Air Base",
    city: "Istrana (TV)",
    country: "IT",
    continent: "EU",
    lat: 45.6844,
    lon: 12.0871,
    elevation: 137,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPU": {
    icao: "LIPU",
    iata: "",
    name: "Padova Gino Allegri Airfield",
    city: "Padova (PD)",
    country: "IT",
    continent: "EU",
    lat: 45.3953,
    lon: 11.8471,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPX": {
    icao: "LIPX",
    iata: "VRN",
    name: "Verona Villafranca Valerio Catullo Airport",
    city: "Caselle (VR)",
    country: "IT",
    continent: "EU",
    lat: 45.395,
    lon: 10.8873,
    elevation: 239,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIPY": {
    icao: "LIPY",
    iata: "AOI",
    name: "Marche Airport",
    city: "Falconara Marittima (AN)",
    country: "IT",
    continent: "EU",
    lat: 43.6163,
    lon: 13.3623,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIPZ": {
    icao: "LIPZ",
    iata: "VCE",
    name: "Venice Marco Polo Airport",
    city: "Venezia (VE)",
    country: "IT",
    continent: "EU",
    lat: 45.5053,
    lon: 12.3519,
    elevation: 7,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIQS": {
    icao: "LIQS",
    iata: "",
    name: "Siena-Ampugnano Airport",
    city: "Ampugnano (SI)",
    country: "IT",
    continent: "EU",
    lat: 43.2563,
    lon: 11.255,
    elevation: 634,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIQW": {
    icao: "LIQW",
    iata: "",
    name: "Sarzana-Luni Air Base",
    city: "Sarzana (SP)",
    country: "IT",
    continent: "EU",
    lat: 44.088,
    lon: 9.9879,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRA": {
    icao: "LIRA",
    iata: "CIA",
    name: "Ciampino–G. B. Pastine International Airport",
    city: "Rome",
    country: "IT",
    continent: "EU",
    lat: 41.7994,
    lon: 12.5949,
    elevation: 427,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRE": {
    icao: "LIRE",
    iata: "",
    name: "Pratica Di Mare Air Base",
    city: "Pomezia",
    country: "IT",
    continent: "EU",
    lat: 41.6545,
    lon: 12.4452,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRF": {
    icao: "LIRF",
    iata: "FCO",
    name: "Rome–Fiumicino Leonardo da Vinci International Airport",
    city: "Rome",
    country: "IT",
    continent: "EU",
    lat: 41.8045,
    lon: 12.252,
    elevation: 13,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "LIRG": {
    icao: "LIRG",
    iata: "",
    name: "Guidonia Air Base",
    city: "Guidonia",
    country: "IT",
    continent: "EU",
    lat: 41.9903,
    lon: 12.7408,
    elevation: 289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRI": {
    icao: "LIRI",
    iata: "QSR",
    name: "Salerno Costa d\'Amalfi Airport",
    city: "Salerno",
    country: "IT",
    continent: "EU",
    lat: 40.6204,
    lon: 14.9113,
    elevation: 123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRJ": {
    icao: "LIRJ",
    iata: "EBA",
    name: "Marina di Campo Airport",
    city: "Campo nell\'Elba (LI)",
    country: "IT",
    continent: "EU",
    lat: 42.7609,
    lon: 10.2398,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRL": {
    icao: "LIRL",
    iata: "",
    name: "Latina Air Base",
    city: "Latina",
    country: "IT",
    continent: "EU",
    lat: 41.5424,
    lon: 12.909,
    elevation: 94,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRM": {
    icao: "LIRM",
    iata: "",
    name: "Grazzanise Air Base",
    city: "Caserta",
    country: "IT",
    continent: "EU",
    lat: 41.0608,
    lon: 14.0819,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRN": {
    icao: "LIRN",
    iata: "NAP",
    name: "Naples International Airport",
    city: "Napoli",
    country: "IT",
    continent: "EU",
    lat: 40.886,
    lon: 14.2908,
    elevation: 294,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIRP": {
    icao: "LIRP",
    iata: "PSA",
    name: "Pisa International Airport",
    city: "Pisa (PI)",
    country: "IT",
    continent: "EU",
    lat: 43.6839,
    lon: 10.3927,
    elevation: 6,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIRQ": {
    icao: "LIRQ",
    iata: "FLR",
    name: "Florence Airport, Peretola",
    city: "Firenze (FI)",
    country: "IT",
    continent: "EU",
    lat: 43.8086,
    lon: 11.2028,
    elevation: 142,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LIRS": {
    icao: "LIRS",
    iata: "GRS",
    name: "Grosseto Corrado Baccarini Air Base / Grosseto Airport",
    city: "Grosseto (GR)",
    country: "IT",
    continent: "EU",
    lat: 42.7597,
    lon: 11.0719,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRU": {
    icao: "LIRU",
    iata: "",
    name: "Rome Urbe Airport",
    city: "Rome",
    country: "IT",
    continent: "EU",
    lat: 41.9521,
    lon: 12.5022,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRV": {
    icao: "LIRV",
    iata: "",
    name: "Viterbo Airport",
    city: "Viterbo",
    country: "IT",
    continent: "EU",
    lat: 42.4302,
    lon: 12.0642,
    elevation: 992,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LIRZ": {
    icao: "LIRZ",
    iata: "PEG",
    name: "Perugia San Francesco d\'Assisi – Umbria International Airport",
    city: "Perugia (PG)",
    country: "IT",
    continent: "EU",
    lat: 43.0959,
    lon: 12.5132,
    elevation: 697,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LJCE": {
    icao: "LJCE",
    iata: "",
    name: "Cerklje ob Krki Air Base",
    city: "Cerklje ob Krki",
    country: "SI",
    continent: "EU",
    lat: 45.9,
    lon: 15.5302,
    elevation: 510,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LJLJ": {
    icao: "LJLJ",
    iata: "LJU",
    name: "Ljubljana Jože Pučnik Airport",
    city: "Zgornji Brnik",
    country: "SI",
    continent: "EU",
    lat: 46.2237,
    lon: 14.4576,
    elevation: 1273,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LJMB": {
    icao: "LJMB",
    iata: "MBX",
    name: "Maribor Edvard Rusjan Airport",
    city: "Orehova Vas",
    country: "SI",
    continent: "EU",
    lat: 46.4799,
    lon: 15.6861,
    elevation: 876,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LJPZ": {
    icao: "LJPZ",
    iata: "POW",
    name: "Portorož Airport",
    city: "Sečovlje",
    country: "SI",
    continent: "EU",
    lat: 45.472,
    lon: 13.616,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKCV": {
    icao: "LKCV",
    iata: "",
    name: "Čáslav Air Base",
    city: "Chotusice",
    country: "CZ",
    continent: "EU",
    lat: 49.9397,
    lon: 15.3818,
    elevation: 794,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKKB": {
    icao: "LKKB",
    iata: "",
    name: "Prague–Kbely Air Base",
    city: "Prague",
    country: "CZ",
    continent: "EU",
    lat: 50.1214,
    lon: 14.5436,
    elevation: 939,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKKU": {
    icao: "LKKU",
    iata: "UHE",
    name: "Kunovice Airport",
    city: "Uherské Hradiště",
    country: "CZ",
    continent: "EU",
    lat: 49.0294,
    lon: 17.4397,
    elevation: 581,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKKV": {
    icao: "LKKV",
    iata: "KLV",
    name: "Karlovy Vary Airport",
    city: "Karlovy Vary",
    country: "CZ",
    continent: "EU",
    lat: 50.203,
    lon: 12.915,
    elevation: 1989,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKLN": {
    icao: "LKLN",
    iata: "",
    name: "Plzeň-Líně Airport",
    city: "Plzen",
    country: "CZ",
    continent: "EU",
    lat: 49.6752,
    lon: 13.2746,
    elevation: 1188,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKMT": {
    icao: "LKMT",
    iata: "OSR",
    name: "Ostrava Leos Janáček Airport",
    city: "Mošnov",
    country: "CZ",
    continent: "EU",
    lat: 49.6963,
    lon: 18.1111,
    elevation: 844,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKNA": {
    icao: "LKNA",
    iata: "",
    name: "Náměšť Air Base",
    city: "Sedlec",
    country: "CZ",
    continent: "EU",
    lat: 49.1663,
    lon: 16.124,
    elevation: 1548,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKPD": {
    icao: "LKPD",
    iata: "PED",
    name: "Pardubice Airport",
    city: "Pardubice",
    country: "CZ",
    continent: "EU",
    lat: 50.0134,
    lon: 15.7386,
    elevation: 741,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKPO": {
    icao: "LKPO",
    iata: "PRV",
    name: "Přerov Air Base",
    city: "Přerov",
    country: "CZ",
    continent: "EU",
    lat: 49.4258,
    lon: 17.4047,
    elevation: 676,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKPR": {
    icao: "LKPR",
    iata: "PRG",
    name: "Václav Havel Airport Prague",
    city: "Prague",
    country: "CZ",
    continent: "EU",
    lat: 50.1009,
    lon: 14.2599,
    elevation: 1247,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LKTB": {
    icao: "LKTB",
    iata: "BRQ",
    name: "Brno-Tuřany Airport",
    city: "Brno",
    country: "CZ",
    continent: "EU",
    lat: 49.1513,
    lon: 16.6944,
    elevation: 778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LKVO": {
    icao: "LKVO",
    iata: "VOD",
    name: "Vodochody Airport",
    city: "Vodochody",
    country: "CZ",
    continent: "EU",
    lat: 50.2166,
    lon: 14.3958,
    elevation: 919,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLBG": {
    icao: "LLBG",
    iata: "TLV",
    name: "Ben Gurion International Airport",
    city: "Tel Aviv",
    country: "IL",
    continent: "AS",
    lat: 32.0114,
    lon: 34.8867,
    elevation: 135,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LLEK": {
    icao: "LLEK",
    iata: "",
    name: "Tel Nof Air Base",
    city: "Rehovot",
    country: "IL",
    continent: "AS",
    lat: 31.8395,
    lon: 34.8218,
    elevation: 193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLER": {
    icao: "LLER",
    iata: "ETM",
    name: "Ramon International Airport",
    city: "Eilat",
    country: "IL",
    continent: "AS",
    lat: 29.727,
    lon: 35.0141,
    elevation: 288,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LLHA": {
    icao: "LLHA",
    iata: "HFA",
    name: "Haifa International Airport",
    city: "Haifa",
    country: "IL",
    continent: "AS",
    lat: 32.8094,
    lon: 35.0431,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLIB": {
    icao: "LLIB",
    iata: "RPN",
    name: "Rosh Pina Airport",
    city: "Rosh Pina",
    country: "IL",
    continent: "AS",
    lat: 32.981,
    lon: 35.5719,
    elevation: 884,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLMZ": {
    icao: "LLMZ",
    iata: "MTZ",
    name: "Bar Yehuda Airfield",
    city: "Masada",
    country: "IL",
    continent: "AS",
    lat: 31.3282,
    lon: 35.3886,
    elevation: -1266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLNV": {
    icao: "LLNV",
    iata: "VTM",
    name: "Nevatim Air Base",
    city: "Beersheba",
    country: "IL",
    continent: "AS",
    lat: 31.2083,
    lon: 35.0123,
    elevation: 1330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLRD": {
    icao: "LLRD",
    iata: "",
    name: "Ramat David Air Base",
    city: "Haifa",
    country: "IL",
    continent: "AS",
    lat: 32.6651,
    lon: 35.1795,
    elevation: 185,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LLRM": {
    icao: "LLRM",
    iata: "MIP",
    name: "Ramon Air Base",
    city: "Beersheba",
    country: "IL",
    continent: "AS",
    lat: 30.7761,
    lon: 34.6667,
    elevation: 2126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LMML": {
    icao: "LMML",
    iata: "MLA",
    name: "Malta International Airport",
    city: "Valletta",
    country: "MT",
    continent: "EU",
    lat: 35.8575,
    lon: 14.4775,
    elevation: 300,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LOAN": {
    icao: "LOAN",
    iata: "",
    name: "Wiener Neustadt East Airport",
    city: "Wiener Neustadt",
    country: "AT",
    continent: "EU",
    lat: 47.8433,
    lon: 16.2601,
    elevation: 896,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOWG": {
    icao: "LOWG",
    iata: "GRZ",
    name: "Graz Airport",
    city: "Feldkirchen bei Graz",
    country: "AT",
    continent: "EU",
    lat: 46.9911,
    lon: 15.4396,
    elevation: 1115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOWI": {
    icao: "LOWI",
    iata: "INN",
    name: "Innsbruck Airport",
    city: "Innsbruck",
    country: "AT",
    continent: "EU",
    lat: 47.2602,
    lon: 11.344,
    elevation: 1907,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOWK": {
    icao: "LOWK",
    iata: "KLU",
    name: "Klagenfurt Airport",
    city: "Klagenfurt am Wörthersee",
    country: "AT",
    continent: "EU",
    lat: 46.6425,
    lon: 14.3377,
    elevation: 1472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOWL": {
    icao: "LOWL",
    iata: "LNZ",
    name: "Linz-Hörsching Airport / Vogler Air Base",
    city: "Linz",
    country: "AT",
    continent: "EU",
    lat: 48.2332,
    lon: 14.1875,
    elevation: 980,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOWS": {
    icao: "LOWS",
    iata: "SZG",
    name: "Salzburg Airport",
    city: "Salzburg",
    country: "AT",
    continent: "EU",
    lat: 47.7933,
    lon: 13.0043,
    elevation: 1411,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOWW": {
    icao: "LOWW",
    iata: "VIE",
    name: "Vienna International Airport",
    city: "Vienna",
    country: "AT",
    continent: "EU",
    lat: 48.1103,
    lon: 16.5697,
    elevation: 600,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LOXN": {
    icao: "LOXN",
    iata: "",
    name: "Wiener Neustadt West Airport",
    city: "Wiener Neustadt",
    country: "AT",
    continent: "EU",
    lat: 47.8369,
    lon: 16.2218,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LOXZ": {
    icao: "LOXZ",
    iata: "",
    name: "Hinterstoisser Air Base",
    city: "Zeltweg",
    country: "AT",
    continent: "EU",
    lat: 47.2028,
    lon: 14.7442,
    elevation: 2264,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPAR": {
    icao: "LPAR",
    iata: "",
    name: "Alverca Air Base",
    city: "Vila Franca de Xira",
    country: "PT",
    continent: "EU",
    lat: 38.8833,
    lon: -9.0301,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPAZ": {
    icao: "LPAZ",
    iata: "SMA",
    name: "Santa Maria Airport",
    city: "Vila do Porto",
    country: "PT",
    continent: "EU",
    lat: 36.9714,
    lon: -25.1706,
    elevation: 308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPBG": {
    icao: "LPBG",
    iata: "BGC",
    name: "Bragança Airport",
    city: "Bragança",
    country: "PT",
    continent: "EU",
    lat: 41.8578,
    lon: -6.7071,
    elevation: 2241,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPBJ": {
    icao: "LPBJ",
    iata: "BYJ",
    name: "Beja Airport / Airbase",
    city: "Beja",
    country: "PT",
    continent: "EU",
    lat: 38.0789,
    lon: -7.9324,
    elevation: 636,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPBR": {
    icao: "LPBR",
    iata: "",
    name: "Braga Municipal Aerodrome",
    city: "Braga",
    country: "PT",
    continent: "EU",
    lat: 41.587,
    lon: -8.4452,
    elevation: 247,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPCB": {
    icao: "LPCB",
    iata: "",
    name: "Aerodromo de Castelo Branco",
    city: "Castelo Branco",
    country: "PT",
    continent: "EU",
    lat: 39.8445,
    lon: -7.4399,
    elevation: 1300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPCO": {
    icao: "LPCO",
    iata: "",
    name: "Aerodromo Municipal de Coimbra",
    city: "Coimbra",
    country: "PT",
    continent: "EU",
    lat: 40.1588,
    lon: -8.4708,
    elevation: 587,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPCS": {
    icao: "LPCS",
    iata: "CAT",
    name: "Cascais Airport",
    city: "Cascais",
    country: "PT",
    continent: "EU",
    lat: 38.725,
    lon: -9.3552,
    elevation: 325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPEV": {
    icao: "LPEV",
    iata: "",
    name: "Évora Airfield",
    city: "Évora",
    country: "PT",
    continent: "EU",
    lat: 38.5335,
    lon: -7.8896,
    elevation: 807,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPFL": {
    icao: "LPFL",
    iata: "FLW",
    name: "Flores Airport",
    city: "Santa Cruz das Flores",
    country: "PT",
    continent: "EU",
    lat: 39.4553,
    lon: -31.1314,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPFR": {
    icao: "LPFR",
    iata: "FAO",
    name: "Faro Airport",
    city: "Faro",
    country: "PT",
    continent: "EU",
    lat: 37.0144,
    lon: -7.9659,
    elevation: 24,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LPGR": {
    icao: "LPGR",
    iata: "GRW",
    name: "Graciosa Airport",
    city: "Santa Cruz da Graciosa",
    country: "PT",
    continent: "EU",
    lat: 39.0922,
    lon: -28.0298,
    elevation: 86,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPHR": {
    icao: "LPHR",
    iata: "HOR",
    name: "Horta Airport",
    city: "Horta",
    country: "PT",
    continent: "EU",
    lat: 38.5199,
    lon: -28.7159,
    elevation: 118,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPLA": {
    icao: "LPLA",
    iata: "TER",
    name: "Lajes Airport",
    city: "Praia da Vitória",
    country: "PT",
    continent: "EU",
    lat: 38.7618,
    lon: -27.0908,
    elevation: 180,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPMA": {
    icao: "LPMA",
    iata: "FNC",
    name: "Madeira International Airport Cristiano Ronaldo",
    city: "Funchal",
    country: "PT",
    continent: "EU",
    lat: 32.6979,
    lon: -16.7745,
    elevation: 192,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LPMR": {
    icao: "LPMR",
    iata: "",
    name: "Monte Real Air Base",
    city: "",
    country: "PT",
    continent: "EU",
    lat: 39.8283,
    lon: -8.8875,
    elevation: 187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPMT": {
    icao: "LPMT",
    iata: "",
    name: "Montijo Air Base",
    city: "Montijo",
    country: "PT",
    continent: "EU",
    lat: 38.7093,
    lon: -9.0337,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPOV": {
    icao: "LPOV",
    iata: "",
    name: "Ovar Air Base",
    city: "Ovar",
    country: "PT",
    continent: "EU",
    lat: 40.9159,
    lon: -8.6459,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPPD": {
    icao: "LPPD",
    iata: "PDL",
    name: "João Paulo II Airport",
    city: "Ponta Delgada",
    country: "PT",
    continent: "EU",
    lat: 37.7412,
    lon: -25.6979,
    elevation: 259,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LPPI": {
    icao: "LPPI",
    iata: "PIX",
    name: "Pico Airport",
    city: "Pico Island",
    country: "PT",
    continent: "EU",
    lat: 38.5543,
    lon: -28.4413,
    elevation: 109,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPPM": {
    icao: "LPPM",
    iata: "PRM",
    name: "Portimão Airport",
    city: "Portimão",
    country: "PT",
    continent: "EU",
    lat: 37.1493,
    lon: -8.584,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPPR": {
    icao: "LPPR",
    iata: "OPO",
    name: "Francisco de Sá Carneiro Airport",
    city: "Porto",
    country: "PT",
    continent: "EU",
    lat: 41.2481,
    lon: -8.6814,
    elevation: 228,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LPPS": {
    icao: "LPPS",
    iata: "PXO",
    name: "Porto Santo Airport",
    city: "Vila Baleira",
    country: "PT",
    continent: "EU",
    lat: 33.0734,
    lon: -16.35,
    elevation: 341,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPPT": {
    icao: "LPPT",
    iata: "LIS",
    name: "Lisbon Humberto Delgado Airport",
    city: "Lisbon",
    country: "PT",
    continent: "EU",
    lat: 38.7813,
    lon: -9.1359,
    elevation: 374,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LPSJ": {
    icao: "LPSJ",
    iata: "SJZ",
    name: "São Jorge Airport",
    city: "Velas",
    country: "PT",
    continent: "EU",
    lat: 38.6655,
    lon: -28.1758,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPSO": {
    icao: "LPSO",
    iata: "",
    name: "Aeródromo Municipal de Ponte de Sor",
    city: "Ponte de Sor",
    country: "PT",
    continent: "EU",
    lat: 39.2115,
    lon: -8.0578,
    elevation: 390,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPST": {
    icao: "LPST",
    iata: "",
    name: "Sintra Air Base",
    city: "Sintra",
    country: "PT",
    continent: "EU",
    lat: 38.8311,
    lon: -9.3395,
    elevation: 440,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPTN": {
    icao: "LPTN",
    iata: "",
    name: "Tancos Airbase",
    city: "Tancos",
    country: "PT",
    continent: "EU",
    lat: 39.4751,
    lon: -8.3646,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPVL": {
    icao: "LPVL",
    iata: "",
    name: "Vilar de Luz Airfield",
    city: "Maia",
    country: "PT",
    continent: "EU",
    lat: 41.2773,
    lon: -8.5162,
    elevation: 762,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPVR": {
    icao: "LPVR",
    iata: "VRL",
    name: "Vila Real Airport",
    city: "Vila Real",
    country: "PT",
    continent: "EU",
    lat: 41.2743,
    lon: -7.7205,
    elevation: 1805,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LPVZ": {
    icao: "LPVZ",
    iata: "VSE",
    name: "Aerodromo Goncalves Lobato (Viseu Airport)",
    city: "Viseu",
    country: "PT",
    continent: "EU",
    lat: 40.7255,
    lon: -7.889,
    elevation: 2060,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LQBK": {
    icao: "LQBK",
    iata: "BNX",
    name: "Banja Luka International Airport",
    city: "Mahovljani",
    country: "BA",
    continent: "EU",
    lat: 44.9414,
    lon: 17.2975,
    elevation: 400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LQMO": {
    icao: "LQMO",
    iata: "OMO",
    name: "Mostar International Airport",
    city: "Mostar",
    country: "BA",
    continent: "EU",
    lat: 43.2829,
    lon: 17.8459,
    elevation: 156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LQSA": {
    icao: "LQSA",
    iata: "SJJ",
    name: "Sarajevo International Airport",
    city: "Sarajevo",
    country: "BA",
    continent: "EU",
    lat: 43.8246,
    lon: 18.3315,
    elevation: 1708,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LQTZ": {
    icao: "LQTZ",
    iata: "TZL",
    name: "Tuzla International Airport",
    city: "Dubrave Gornje",
    country: "BA",
    continent: "EU",
    lat: 44.4587,
    lon: 18.7248,
    elevation: 784,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LR80": {
    icao: "LR80",
    iata: "",
    name: "Feteşti Borcea Air Base",
    city: "Borcea",
    country: "RO",
    continent: "EU",
    lat: 44.3923,
    lon: 27.7267,
    elevation: 180,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LR82": {
    icao: "LR82",
    iata: "",
    name: "Boboc Air Base",
    city: "Boboc",
    country: "RO",
    continent: "EU",
    lat: 45.2164,
    lon: 26.9786,
    elevation: 344,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRAR": {
    icao: "LRAR",
    iata: "ARW",
    name: "Arad International Airport",
    city: "Arad",
    country: "RO",
    continent: "EU",
    lat: 46.1766,
    lon: 21.262,
    elevation: 352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRBC": {
    icao: "LRBC",
    iata: "BCM",
    name: "Bacău George Enescu International  Airport",
    city: "Bacău",
    country: "RO",
    continent: "EU",
    lat: 46.5219,
    lon: 26.9103,
    elevation: 607,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRBM": {
    icao: "LRBM",
    iata: "BAY",
    name: "Maramureș International Airport",
    city: "Tăuții-Măgherăuș",
    country: "RO",
    continent: "EU",
    lat: 47.6584,
    lon: 23.4644,
    elevation: 605,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRBS": {
    icao: "LRBS",
    iata: "BBU",
    name: "Bucharest Băneasa Aurel Vlaicu International Airport",
    city: "Bucharest",
    country: "RO",
    continent: "EU",
    lat: 44.5032,
    lon: 26.1021,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRBV": {
    icao: "LRBV",
    iata: "GHV",
    name: "Brașov-Ghimbav International Airport",
    city: "Brașov (Ghimbav)",
    country: "RO",
    continent: "EU",
    lat: 45.7056,
    lon: 25.5229,
    elevation: 1740,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRCK": {
    icao: "LRCK",
    iata: "CND",
    name: "Mihail Kogălniceanu International Airport",
    city: "Mihail Kogălniceanu",
    country: "RO",
    continent: "EU",
    lat: 44.3622,
    lon: 28.4883,
    elevation: 353,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRCL": {
    icao: "LRCL",
    iata: "CLJ",
    name: "Cluj Avram Iancu International Airport",
    city: "Cluj-Napoca",
    country: "RO",
    continent: "EU",
    lat: 46.7874,
    lon: 23.6843,
    elevation: 1039,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRCS": {
    icao: "LRCS",
    iata: "CSB",
    name: "Caransebeş Airport",
    city: "Caransebeş",
    country: "RO",
    continent: "EU",
    lat: 45.4201,
    lon: 22.2525,
    elevation: 866,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRCT": {
    icao: "LRCT",
    iata: "",
    name: "Câmpia Turzii Air Base",
    city: "Câmpia Turzii",
    country: "RO",
    continent: "EU",
    lat: 46.5023,
    lon: 23.8859,
    elevation: 1083,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRCV": {
    icao: "LRCV",
    iata: "CRA",
    name: "Craiova International Airport",
    city: "Craiova",
    country: "RO",
    continent: "EU",
    lat: 44.3181,
    lon: 23.8886,
    elevation: 626,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRIA": {
    icao: "LRIA",
    iata: "IAS",
    name: "Iaşi Airport",
    city: "Iaşi",
    country: "RO",
    continent: "EU",
    lat: 47.1803,
    lon: 27.6208,
    elevation: 411,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LROD": {
    icao: "LROD",
    iata: "OMR",
    name: "Oradea International Airport",
    city: "Oradea",
    country: "RO",
    continent: "EU",
    lat: 47.0253,
    lon: 21.9025,
    elevation: 465,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LROP": {
    icao: "LROP",
    iata: "OTP",
    name: "Bucharest Henri Coandă International Airport",
    city: "Otopeni",
    country: "RO",
    continent: "EU",
    lat: 44.5721,
    lon: 26.1034,
    elevation: 314,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LRSB": {
    icao: "LRSB",
    iata: "SBZ",
    name: "Sibiu International Airport",
    city: "Sibiu",
    country: "RO",
    continent: "EU",
    lat: 45.7858,
    lon: 24.0867,
    elevation: 1496,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRSM": {
    icao: "LRSM",
    iata: "SUJ",
    name: "Satu Mare International Airport",
    city: "Satu Mare",
    country: "RO",
    continent: "EU",
    lat: 47.7033,
    lon: 22.8857,
    elevation: 405,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRSV": {
    icao: "LRSV",
    iata: "SCV",
    name: "Suceava Stefan cel Mare Airport",
    city: "Suceava",
    country: "RO",
    continent: "EU",
    lat: 47.6875,
    lon: 26.3541,
    elevation: 1375,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRTC": {
    icao: "LRTC",
    iata: "TCE",
    name: "Tulcea Danube Delta Airport",
    city: "Mihail Kogălniceanu",
    country: "RO",
    continent: "EU",
    lat: 45.0625,
    lon: 28.7143,
    elevation: 200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRTM": {
    icao: "LRTM",
    iata: "TGM",
    name: "Târgu Mureş Transilvania International Airport",
    city: "Recea",
    country: "RO",
    continent: "EU",
    lat: 46.4677,
    lon: 24.4125,
    elevation: 963,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LRTR": {
    icao: "LRTR",
    iata: "TSR",
    name: "Timişoara Traian Vuia Airport",
    city: "Timişoara",
    country: "RO",
    continent: "EU",
    lat: 45.8099,
    lon: 21.3379,
    elevation: 348,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSGC": {
    icao: "LSGC",
    iata: "",
    name: "Les Eplatures Airport",
    city: "La Chaux-de-Fonds",
    country: "CH",
    continent: "EU",
    lat: 47.0839,
    lon: 6.7928,
    elevation: 3368,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSGG": {
    icao: "LSGG",
    iata: "GVA",
    name: "Geneva Cointrin International Airport",
    city: "Geneva",
    country: "CH",
    continent: "EU",
    lat: 46.2381,
    lon: 6.109,
    elevation: 1411,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LSGS": {
    icao: "LSGS",
    iata: "SIR",
    name: "Sion Airport",
    city: "Sion",
    country: "CH",
    continent: "EU",
    lat: 46.2192,
    lon: 7.3269,
    elevation: 1582,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSMA": {
    icao: "LSMA",
    iata: "",
    name: "Alpnach Air Base",
    city: "Alpnach",
    country: "CH",
    continent: "EU",
    lat: 46.9439,
    lon: 8.2842,
    elevation: 1460,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSMD": {
    icao: "LSMD",
    iata: "",
    name: "Dübendorf Air Base",
    city: "Zurich",
    country: "CH",
    continent: "EU",
    lat: 47.3986,
    lon: 8.6482,
    elevation: 1470,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSME": {
    icao: "LSME",
    iata: "EML",
    name: "Emmen Air Base",
    city: "Emmen",
    country: "CH",
    continent: "EU",
    lat: 47.0924,
    lon: 8.3052,
    elevation: 1400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSMP": {
    icao: "LSMP",
    iata: "VIP",
    name: "Payerne Air Base",
    city: "Payerne",
    country: "CH",
    continent: "EU",
    lat: 46.8432,
    lon: 6.9151,
    elevation: 1465,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSZA": {
    icao: "LSZA",
    iata: "LUG",
    name: "Lugano Airport",
    city: "Agno",
    country: "CH",
    continent: "EU",
    lat: 46.0043,
    lon: 8.9106,
    elevation: 915,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSZB": {
    icao: "LSZB",
    iata: "BRN",
    name: "Bern Airport",
    city: "Bern",
    country: "CH",
    continent: "EU",
    lat: 46.9129,
    lon: 7.4985,
    elevation: 1671,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSZG": {
    icao: "LSZG",
    iata: "",
    name: "Grenchen Airfield",
    city: "Grenchen",
    country: "CH",
    continent: "EU",
    lat: 47.1816,
    lon: 7.4172,
    elevation: 1411,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSZH": {
    icao: "LSZH",
    iata: "ZRH",
    name: "Zürich Airport",
    city: "Zurich",
    country: "CH",
    continent: "EU",
    lat: 47.4581,
    lon: 8.5481,
    elevation: 1417,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LSZR": {
    icao: "LSZR",
    iata: "ACH",
    name: "Sankt Gallen Altenrhein Airport",
    city: "St. Gallen",
    country: "CH",
    continent: "EU",
    lat: 47.485,
    lon: 9.5608,
    elevation: 1306,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LSZS": {
    icao: "LSZS",
    iata: "SMV",
    name: "Samedan Airport",
    city: "Samedan",
    country: "CH",
    continent: "EU",
    lat: 46.5341,
    lon: 9.8841,
    elevation: 5600,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAC": {
    icao: "LTAC",
    iata: "ESB",
    name: "Esenboğa International Airport",
    city: "Ankara",
    country: "TR",
    continent: "AS",
    lat: 40.1281,
    lon: 32.9951,
    elevation: 3125,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTAD": {
    icao: "LTAD",
    iata: "ANK",
    name: "Etimesgut Air Base",
    city: "Ankara",
    country: "TR",
    continent: "AS",
    lat: 39.9498,
    lon: 32.6886,
    elevation: 2653,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAE": {
    icao: "LTAE",
    iata: "",
    name: "Akıncı Air Base",
    city: "Ankara",
    country: "TR",
    continent: "AS",
    lat: 40.0789,
    lon: 32.5656,
    elevation: 2767,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAF": {
    icao: "LTAF",
    iata: "ADA",
    name: "Adana Şakirpaşa Airport",
    city: "Seyhan",
    country: "TR",
    continent: "AS",
    lat: 36.9822,
    lon: 35.2804,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAG": {
    icao: "LTAG",
    iata: "UAB",
    name: "İncirlik Air Base",
    city: "Sarıçam",
    country: "TR",
    continent: "AS",
    lat: 37.0021,
    lon: 35.4259,
    elevation: 238,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAH": {
    icao: "LTAH",
    iata: "AFY",
    name: "Afyon Air Base",
    city: "Afyonkarahisar",
    country: "TR",
    continent: "AS",
    lat: 38.7264,
    lon: 30.6011,
    elevation: 3310,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAI": {
    icao: "LTAI",
    iata: "AYT",
    name: "Antalya International Airport",
    city: "Antalya",
    country: "TR",
    continent: "AS",
    lat: 36.8987,
    lon: 30.8005,
    elevation: 177,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTAJ": {
    icao: "LTAJ",
    iata: "GZT",
    name: "Gaziantep International Airport",
    city: "Gaziantep",
    country: "TR",
    continent: "AS",
    lat: 36.9472,
    lon: 37.4787,
    elevation: 2315,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAL": {
    icao: "LTAL",
    iata: "KFS",
    name: "Kastamonu Airport",
    city: "Kastamonu",
    country: "TR",
    continent: "AS",
    lat: 41.3142,
    lon: 33.7958,
    elevation: 3520,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAN": {
    icao: "LTAN",
    iata: "KYA",
    name: "Konya Airport",
    city: "Konya",
    country: "TR",
    continent: "AS",
    lat: 37.979,
    lon: 32.5619,
    elevation: 3392,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAS": {
    icao: "LTAS",
    iata: "ONQ",
    name: "Zonguldak Çaycuma Airport",
    city: "Zonguldak",
    country: "TR",
    continent: "AS",
    lat: 41.5064,
    lon: 32.0886,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAT": {
    icao: "LTAT",
    iata: "MLX",
    name: "Malatya Erhaç Airport",
    city: "Malatya",
    country: "TR",
    continent: "AS",
    lat: 38.4353,
    lon: 38.091,
    elevation: 2828,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAU": {
    icao: "LTAU",
    iata: "ASR",
    name: "Kayseri Erkilet Airport",
    city: "Kayseri",
    country: "TR",
    continent: "AS",
    lat: 38.7704,
    lon: 35.4954,
    elevation: 3463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAV": {
    icao: "LTAV",
    iata: "",
    name: "Sivrihisar Airport",
    city: "Sivrihisar",
    country: "TR",
    continent: "AS",
    lat: 39.4515,
    lon: 31.3653,
    elevation: 3185,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAW": {
    icao: "LTAW",
    iata: "TJK",
    name: "Tokat Airport",
    city: "Tokat",
    country: "TR",
    continent: "AS",
    lat: 40.3247,
    lon: 36.3906,
    elevation: 1859,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTAY": {
    icao: "LTAY",
    iata: "DNZ",
    name: "Çardak Airport",
    city: "Denizli",
    country: "TR",
    continent: "AS",
    lat: 37.7856,
    lon: 29.7013,
    elevation: 2795,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBA": {
    icao: "LTBA",
    iata: "ISL",
    name: "İstanbul Atatürk Airport",
    city: "Bakırköy, Istanbul",
    country: "TR",
    continent: "EU",
    lat: 40.9719,
    lon: 28.8237,
    elevation: 163,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBF": {
    icao: "LTBF",
    iata: "BZI",
    name: "Balıkesir Airport",
    city: "Balıkesir",
    country: "TR",
    continent: "AS",
    lat: 39.6193,
    lon: 27.926,
    elevation: 340,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBG": {
    icao: "LTBG",
    iata: "BDM",
    name: "Bandırma Airport",
    city: "Bandırma",
    country: "TR",
    continent: "AS",
    lat: 40.318,
    lon: 27.9777,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBH": {
    icao: "LTBH",
    iata: "CKZ",
    name: "Çanakkale Airport",
    city: "Çanakkale",
    country: "TR",
    continent: "AS",
    lat: 40.1377,
    lon: 26.4268,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBI": {
    icao: "LTBI",
    iata: "ESK",
    name: "Eskişehir Air Base",
    city: "Eskişehir",
    country: "TR",
    continent: "AS",
    lat: 39.7841,
    lon: 30.5821,
    elevation: 2581,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBJ": {
    icao: "LTBJ",
    iata: "ADB",
    name: "Adnan Menderes International Airport",
    city: "Gaziemir",
    country: "TR",
    continent: "AS",
    lat: 38.2924,
    lon: 27.157,
    elevation: 412,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTBL": {
    icao: "LTBL",
    iata: "IGL",
    name: "Çiğli Airbase",
    city: "Çiğli",
    country: "TR",
    continent: "AS",
    lat: 38.513,
    lon: 27.0101,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBO": {
    icao: "LTBO",
    iata: "USQ",
    name: "Uşak Airport",
    city: "Uşak",
    country: "TR",
    continent: "AS",
    lat: 38.6815,
    lon: 29.4717,
    elevation: 2897,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBQ": {
    icao: "LTBQ",
    iata: "KCO",
    name: "Cengiz Topel Airport",
    city: "Kartepe",
    country: "TR",
    continent: "AS",
    lat: 40.735,
    lon: 30.0833,
    elevation: 182,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBR": {
    icao: "LTBR",
    iata: "YEI",
    name: "Bursa Yenişehir Airport",
    city: "Yenişehir",
    country: "TR",
    continent: "AS",
    lat: 40.2552,
    lon: 29.5626,
    elevation: 764,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBS": {
    icao: "LTBS",
    iata: "DLM",
    name: "Dalaman International Airport",
    city: "Dalaman",
    country: "TR",
    continent: "AS",
    lat: 36.7131,
    lon: 28.7925,
    elevation: 20,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTBT": {
    icao: "LTBT",
    iata: "",
    name: "Akhisar Airport / Akhisar Air Base",
    city: "Akhisar",
    country: "TR",
    continent: "AS",
    lat: 38.8089,
    lon: 27.8339,
    elevation: 263,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBU": {
    icao: "LTBU",
    iata: "TEQ",
    name: "Tekirdağ Çorlu Airport",
    city: "Çorlu",
    country: "TR",
    continent: "EU",
    lat: 41.1382,
    lon: 27.9191,
    elevation: 574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBX": {
    icao: "LTBX",
    iata: "",
    name: "İstanbul Samandıra Army Air Base",
    city: "Ümraniye, Istanbul",
    country: "TR",
    continent: "AS",
    lat: 40.993,
    lon: 29.2165,
    elevation: 400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTBY": {
    icao: "LTBY",
    iata: "AOE",
    name: "Anadolu Airport",
    city: "Eskişehir",
    country: "TR",
    continent: "AS",
    lat: 39.8099,
    lon: 30.5194,
    elevation: 2588,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCA": {
    icao: "LTCA",
    iata: "EZS",
    name: "Elazığ Airport",
    city: "Elazığ",
    country: "TR",
    continent: "AS",
    lat: 38.598,
    lon: 39.2835,
    elevation: 2927,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCB": {
    icao: "LTCB",
    iata: "OGU",
    name: "Ordu–Giresun Airport",
    city: "Ordu",
    country: "TR",
    continent: "AS",
    lat: 40.9669,
    lon: 38.086,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCC": {
    icao: "LTCC",
    iata: "DIY",
    name: "Diyarbakır Airport",
    city: "Diyarbakır",
    country: "TR",
    continent: "AS",
    lat: 37.8939,
    lon: 40.201,
    elevation: 2251,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCD": {
    icao: "LTCD",
    iata: "ERC",
    name: "Erzincan Airport",
    city: "Erzincan",
    country: "TR",
    continent: "AS",
    lat: 39.7102,
    lon: 39.527,
    elevation: 3783,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCE": {
    icao: "LTCE",
    iata: "ERZ",
    name: "Erzurum International Airport",
    city: "Erzurum",
    country: "TR",
    continent: "AS",
    lat: 39.9565,
    lon: 41.1702,
    elevation: 5763,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCF": {
    icao: "LTCF",
    iata: "KSY",
    name: "Kars Airport",
    city: "Kars",
    country: "TR",
    continent: "AS",
    lat: 40.5622,
    lon: 43.115,
    elevation: 5889,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCG": {
    icao: "LTCG",
    iata: "TZX",
    name: "Trabzon International Airport",
    city: "Trabzon",
    country: "TR",
    continent: "AS",
    lat: 40.9951,
    lon: 39.7897,
    elevation: 104,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCI": {
    icao: "LTCI",
    iata: "VAN",
    name: "Van Ferit Melen Airport",
    city: "Van",
    country: "TR",
    continent: "AS",
    lat: 38.4682,
    lon: 43.3323,
    elevation: 5480,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCJ": {
    icao: "LTCJ",
    iata: "BAL",
    name: "Batman Airport",
    city: "Batman",
    country: "TR",
    continent: "AS",
    lat: 37.929,
    lon: 41.1166,
    elevation: 1822,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCK": {
    icao: "LTCK",
    iata: "MSR",
    name: "Muş Airport",
    city: "Muş",
    country: "TR",
    continent: "AS",
    lat: 38.7478,
    lon: 41.6612,
    elevation: 4157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCL": {
    icao: "LTCL",
    iata: "SXZ",
    name: "Siirt Airport",
    city: "Siirt",
    country: "TR",
    continent: "AS",
    lat: 37.9789,
    lon: 41.8404,
    elevation: 2001,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCM": {
    icao: "LTCM",
    iata: "NOP",
    name: "Sinop Airport",
    city: "Sinop",
    country: "TR",
    continent: "AS",
    lat: 42.0183,
    lon: 35.0718,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCN": {
    icao: "LTCN",
    iata: "KCM",
    name: "Kahramanmaraş Airport",
    city: "Kahramanmaraş",
    country: "TR",
    continent: "AS",
    lat: 37.5388,
    lon: 36.9535,
    elevation: 1723,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCO": {
    icao: "LTCO",
    iata: "AJI",
    name: "Ağrı Airport",
    city: "Ağrı",
    country: "TR",
    continent: "AS",
    lat: 39.6556,
    lon: 43.0257,
    elevation: 5462,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCP": {
    icao: "LTCP",
    iata: "ADF",
    name: "Adıyaman Airport",
    city: "Adıyaman",
    country: "TR",
    continent: "AS",
    lat: 37.7314,
    lon: 38.4689,
    elevation: 2216,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCR": {
    icao: "LTCR",
    iata: "MQM",
    name: "Mardin Airport",
    city: "Mardin",
    country: "TR",
    continent: "AS",
    lat: 37.2233,
    lon: 40.6317,
    elevation: 1729,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCS": {
    icao: "LTCS",
    iata: "GNY",
    name: "Şanlıurfa GAP Airport",
    city: "Şanlıurfa",
    country: "TR",
    continent: "AS",
    lat: 37.4457,
    lon: 38.8956,
    elevation: 2708,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCT": {
    icao: "LTCT",
    iata: "IGD",
    name: "Iğdır Airport",
    city: "Iğdır",
    country: "TR",
    continent: "AS",
    lat: 39.9766,
    lon: 43.8766,
    elevation: 3101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCV": {
    icao: "LTCV",
    iata: "NKT",
    name: "Şırnak Şerafettin Elçi Airport",
    city: "Şırnak",
    country: "TR",
    continent: "AS",
    lat: 37.3647,
    lon: 42.0582,
    elevation: 2038,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTCW": {
    icao: "LTCW",
    iata: "YKO",
    name: "Hakkari Yüksekova Airport",
    city: "Hakkari",
    country: "TR",
    continent: "AS",
    lat: 37.5497,
    lon: 44.2381,
    elevation: 6400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTDA": {
    icao: "LTDA",
    iata: "HTY",
    name: "Hatay Airport",
    city: "Antakya",
    country: "TR",
    continent: "AS",
    lat: 36.3628,
    lon: 36.2822,
    elevation: 269,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTDB": {
    icao: "LTDB",
    iata: "COV",
    name: "Çukurova International Airport",
    city: "Tarsus",
    country: "TR",
    continent: "AS",
    lat: 36.8909,
    lon: 35.0705,
    elevation: 35,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTFC": {
    icao: "LTFC",
    iata: "ISE",
    name: "Süleyman Demirel International Airport",
    city: "Isparta",
    country: "TR",
    continent: "AS",
    lat: 37.8554,
    lon: 30.3684,
    elevation: 2835,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTFD": {
    icao: "LTFD",
    iata: "EDO",
    name: "Balıkesir Koca Seyit Airport",
    city: "Edremit",
    country: "TR",
    continent: "AS",
    lat: 39.5546,
    lon: 27.0138,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTFE": {
    icao: "LTFE",
    iata: "BJV",
    name: "Milas Bodrum International Airport",
    city: "Bodrum",
    country: "TR",
    continent: "AS",
    lat: 37.2506,
    lon: 27.6643,
    elevation: 21,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTFG": {
    icao: "LTFG",
    iata: "GZP",
    name: "Gazipaşa-Alanya Airport",
    city: "Gazipaşa",
    country: "TR",
    continent: "AS",
    lat: 36.2992,
    lon: 32.3006,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTFH": {
    icao: "LTFH",
    iata: "SZF",
    name: "Samsun-Çarşamba Airport",
    city: "Samsun",
    country: "TR",
    continent: "AS",
    lat: 41.254,
    lon: 36.5675,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LTFJ": {
    icao: "LTFJ",
    iata: "SAW",
    name: "Istanbul Sabiha Gökçen International Airport",
    city: "Pendik, Istanbul",
    country: "TR",
    continent: "AS",
    lat: 40.8986,
    lon: 29.3092,
    elevation: 312,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTFM": {
    icao: "LTFM",
    iata: "IST",
    name: "İstanbul Airport",
    city: "Arnavutköy, Istanbul",
    country: "TR",
    continent: "EU",
    lat: 41.2613,
    lon: 28.742,
    elevation: 325,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LTFO": {
    icao: "LTFO",
    iata: "RZV",
    name: "Rize–Artvin Airport",
    city: "Rize",
    country: "TR",
    continent: "AS",
    lat: 41.1798,
    lon: 40.8488,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LUBL": {
    icao: "LUBL",
    iata: "BZY",
    name: "Bălți International Airport",
    city: "Bălți",
    country: "MD",
    continent: "EU",
    lat: 47.8377,
    lon: 27.7811,
    elevation: 758,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LUBM": {
    icao: "LUBM",
    iata: "",
    name: "Mărculești Air Base",
    city: "Mărculeşti",
    country: "MD",
    continent: "EU",
    lat: 47.8627,
    lon: 28.2128,
    elevation: 312,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LUCH": {
    icao: "LUCH",
    iata: "",
    name: "Cahul International Airport",
    city: "Cahul",
    country: "MD",
    continent: "EU",
    lat: 45.8438,
    lon: 28.2637,
    elevation: 652,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LUKK": {
    icao: "LUKK",
    iata: "RMO",
    name: "Chişinău International Airport",
    city: "Chişinău",
    country: "MD",
    continent: "EU",
    lat: 46.9277,
    lon: 28.931,
    elevation: 399,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LUTR": {
    icao: "LUTR",
    iata: "",
    name: "Tiraspol Airport",
    city: "Tiraspol",
    country: "MD",
    continent: "EU",
    lat: 46.8681,
    lon: 29.5906,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LWOH": {
    icao: "LWOH",
    iata: "OHD",
    name: "Ohrid St. Paul the Apostle Airport",
    city: "Ohrid",
    country: "MK",
    continent: "EU",
    lat: 41.18,
    lon: 20.7423,
    elevation: 2313,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LWSK": {
    icao: "LWSK",
    iata: "SKP",
    name: "Skopje International Airport",
    city: "Ilinden",
    country: "MK",
    continent: "EU",
    lat: 41.9581,
    lon: 21.6226,
    elevation: 781,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LXGB": {
    icao: "LXGB",
    iata: "GIB",
    name: "Gibraltar Airport",
    city: "Gibraltar",
    country: "GI",
    continent: "EU",
    lat: 36.1512,
    lon: -5.3497,
    elevation: 12,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LYBE": {
    icao: "LYBE",
    iata: "BEG",
    name: "Belgrade Nikola Tesla Airport",
    city: "Belgrade",
    country: "RS",
    continent: "EU",
    lat: 44.8184,
    lon: 20.3091,
    elevation: 335,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LYBT": {
    icao: "LYBT",
    iata: "BJY",
    name: "Batajnica Air Base",
    city: "Zemun",
    country: "RS",
    continent: "EU",
    lat: 44.9353,
    lon: 20.2575,
    elevation: 265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LYKV": {
    icao: "LYKV",
    iata: "KVO",
    name: "Morava Airport",
    city: "Kraljevo",
    country: "RS",
    continent: "EU",
    lat: 43.8175,
    lon: 20.5867,
    elevation: 686,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LYNI": {
    icao: "LYNI",
    iata: "INI",
    name: "Niš Constantine the Great Airport",
    city: "Niš",
    country: "RS",
    continent: "EU",
    lat: 43.337,
    lon: 21.8545,
    elevation: 648,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LYPG": {
    icao: "LYPG",
    iata: "TGD",
    name: "Podgorica Airport / Podgorica Golubovci Airbase",
    city: "Podgorica",
    country: "ME",
    continent: "EU",
    lat: 42.3594,
    lon: 19.2519,
    elevation: 141,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LYTV": {
    icao: "LYTV",
    iata: "TIV",
    name: "Tivat Airport",
    city: "Tivat",
    country: "ME",
    continent: "EU",
    lat: 42.4047,
    lon: 18.7233,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LYUZ": {
    icao: "LYUZ",
    iata: "UZC",
    name: "Ponikve Airport",
    city: "Stapari",
    country: "RS",
    continent: "EU",
    lat: 43.8989,
    lon: 19.6977,
    elevation: 2966,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LZIB": {
    icao: "LZIB",
    iata: "BTS",
    name: "M. R. Štefánik Airport",
    city: "Bratislava",
    country: "SK",
    continent: "EU",
    lat: 48.1702,
    lon: 17.2127,
    elevation: 436,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "LZKZ": {
    icao: "LZKZ",
    iata: "KSC",
    name: "Košice International Airport",
    city: "Košice",
    country: "SK",
    continent: "EU",
    lat: 48.6631,
    lon: 21.2411,
    elevation: 755,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LZMC": {
    icao: "LZMC",
    iata: "",
    name: "Malacky/Kuchyňa Air Base",
    city: "Kuchyňa",
    country: "SK",
    continent: "EU",
    lat: 48.402,
    lon: 17.1184,
    elevation: 679,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LZPP": {
    icao: "LZPP",
    iata: "PZY",
    name: "Piešťany Airport",
    city: "Piešťany",
    country: "SK",
    continent: "EU",
    lat: 48.6252,
    lon: 17.8284,
    elevation: 545,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LZSL": {
    icao: "LZSL",
    iata: "SLD",
    name: "Sliač Airport",
    city: "Sliač",
    country: "SK",
    continent: "EU",
    lat: 48.6378,
    lon: 19.1341,
    elevation: 1043,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LZTT": {
    icao: "LZTT",
    iata: "TAT",
    name: "Poprad-Tatry Airport",
    city: "Poprad",
    country: "SK",
    continent: "EU",
    lat: 49.0736,
    lon: 20.2411,
    elevation: 2356,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "LZZI": {
    icao: "LZZI",
    iata: "ILZ",
    name: "Žilina-Dolný Hričov Airport",
    city: "Dolný Hričov",
    country: "SK",
    continent: "EU",
    lat: 49.2333,
    lon: 18.6134,
    elevation: 1020,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MBGT": {
    icao: "MBGT",
    iata: "GDT",
    name: "JAGS McCartney International Airport",
    city: "Cockburn Town",
    country: "TC",
    continent: "NA",
    lat: 21.4445,
    lon: -71.1423,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MBNC": {
    icao: "MBNC",
    iata: "NCA",
    name: "North Caicos Airport",
    city: "North Caicos",
    country: "TC",
    continent: "NA",
    lat: 21.9161,
    lon: -71.943,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MBPV": {
    icao: "MBPV",
    iata: "PLS",
    name: "Providenciales International Airport",
    city: "Providenciales",
    country: "TC",
    continent: "NA",
    lat: 21.7737,
    lon: -72.2683,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MBSC": {
    icao: "MBSC",
    iata: "XSC",
    name: "South Caicos Airport",
    city: "South Caicos",
    country: "TC",
    continent: "NA",
    lat: 21.5157,
    lon: -71.5285,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDBH": {
    icao: "MDBH",
    iata: "BRX",
    name: "Maria Montez International Airport",
    city: "Barahona",
    country: "DO",
    continent: "NA",
    lat: 18.2515,
    lon: -71.1204,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDCR": {
    icao: "MDCR",
    iata: "CBJ",
    name: "Cabo Rojo Airport",
    city: "Cabo Rojo",
    country: "DO",
    continent: "NA",
    lat: 17.929,
    lon: -71.6448,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDCY": {
    icao: "MDCY",
    iata: "AZS",
    name: "Samaná El Catey International Airport",
    city: "Samana",
    country: "DO",
    continent: "NA",
    lat: 19.2693,
    lon: -69.7374,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDJB": {
    icao: "MDJB",
    iata: "JBQ",
    name: "La Isabela International Airport",
    city: "La Isabela",
    country: "DO",
    continent: "NA",
    lat: 18.5725,
    lon: -69.9856,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDLR": {
    icao: "MDLR",
    iata: "LRM",
    name: "Casa De Campo International Airport",
    city: "La Romana",
    country: "DO",
    continent: "NA",
    lat: 18.4522,
    lon: -68.9111,
    elevation: 213,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MDPC": {
    icao: "MDPC",
    iata: "PUJ",
    name: "Punta Cana International Airport",
    city: "Punta Cana",
    country: "DO",
    continent: "NA",
    lat: 18.5674,
    lon: -68.3634,
    elevation: 47,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MDPP": {
    icao: "MDPP",
    iata: "POP",
    name: "Gregorio Luperon International Airport",
    city: "Puerto Plata",
    country: "DO",
    continent: "NA",
    lat: 19.7579,
    lon: -70.57,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDSD": {
    icao: "MDSD",
    iata: "SDQ",
    name: "Las Américas International Airport",
    city: "Santo Domingo",
    country: "DO",
    continent: "NA",
    lat: 18.4297,
    lon: -69.6689,
    elevation: 59,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MDSI": {
    icao: "MDSI",
    iata: "",
    name: "San Isidro Air Base",
    city: "San Isidro",
    country: "DO",
    continent: "NA",
    lat: 18.5037,
    lon: -69.7617,
    elevation: 111,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MDST": {
    icao: "MDST",
    iata: "STI",
    name: "Cibao International Airport",
    city: "Santiago",
    country: "DO",
    continent: "NA",
    lat: 19.4061,
    lon: -70.6047,
    elevation: 565,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MGCB": {
    icao: "MGCB",
    iata: "CBV",
    name: "Coban Airport",
    city: "Coban",
    country: "GT",
    continent: "NA",
    lat: 15.469,
    lon: -90.4067,
    elevation: 4339,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MGGT": {
    icao: "MGGT",
    iata: "GUA",
    name: "La Aurora Airport",
    city: "Guatemala City",
    country: "GT",
    continent: "NA",
    lat: 14.5833,
    lon: -90.5275,
    elevation: 4952,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MGPB": {
    icao: "MGPB",
    iata: "PBR",
    name: "Puerto Barrios Airport",
    city: "Puerto Barrios",
    country: "GT",
    continent: "NA",
    lat: 15.7309,
    lon: -88.5838,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MGRB": {
    icao: "MGRB",
    iata: "RUV",
    name: "Rubelsanto Airport",
    city: "Rubelsanto",
    country: "GT",
    continent: "NA",
    lat: 15.992,
    lon: -90.4453,
    elevation: 426,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MGRT": {
    icao: "MGRT",
    iata: "RER",
    name: "Retalhuleu Airport",
    city: "Retalhuleu",
    country: "GT",
    continent: "NA",
    lat: 14.5214,
    lon: -91.697,
    elevation: 656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MGSJ": {
    icao: "MGSJ",
    iata: "GSJ",
    name: "San José Airport",
    city: "Puerto San José",
    country: "GT",
    continent: "NA",
    lat: 13.9362,
    lon: -90.8358,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MGTK": {
    icao: "MGTK",
    iata: "FRS",
    name: "Mundo Maya International Airport",
    city: "San Benito",
    country: "GT",
    continent: "NA",
    lat: 16.9138,
    lon: -89.8664,
    elevation: 427,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHLC": {
    icao: "MHLC",
    iata: "LCE",
    name: "Goloson International Airport",
    city: "La Ceiba",
    country: "HN",
    continent: "NA",
    lat: 15.7425,
    lon: -86.853,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHLM": {
    icao: "MHLM",
    iata: "SAP",
    name: "Ramón Villeda Morales International Airport",
    city: "San Pedro Sula",
    country: "HN",
    continent: "NA",
    lat: 15.4526,
    lon: -87.9236,
    elevation: 91,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHNJ": {
    icao: "MHNJ",
    iata: "GJA",
    name: "La Laguna Airport",
    city: "Guanaja",
    country: "HN",
    continent: "NA",
    lat: 16.4454,
    lon: -85.9066,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHRO": {
    icao: "MHRO",
    iata: "RTB",
    name: "Juan Manuel Gálvez International Airport",
    city: "Coxen Hole",
    country: "HN",
    continent: "NA",
    lat: 16.3168,
    lon: -86.523,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHSC": {
    icao: "MHSC",
    iata: "XPL",
    name: "Palmerola International Airport / José Enrique Soto Cano Air Base",
    city: "Palmerola",
    country: "HN",
    continent: "NA",
    lat: 14.3824,
    lon: -87.6212,
    elevation: 2061,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHTE": {
    icao: "MHTE",
    iata: "TEA",
    name: "Tela Airport",
    city: "Tela",
    country: "HN",
    continent: "NA",
    lat: 15.7759,
    lon: -87.4758,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHTG": {
    icao: "MHTG",
    iata: "TGU",
    name: "Toncontín International Airport",
    city: "Tegucigalpa",
    country: "HN",
    continent: "NA",
    lat: 14.0609,
    lon: -87.2172,
    elevation: 3294,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MHTJ": {
    icao: "MHTJ",
    iata: "TJI",
    name: "Trujillo Airport",
    city: "Trujillo",
    country: "HN",
    continent: "NA",
    lat: 15.9266,
    lon: -85.9386,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MKBS": {
    icao: "MKBS",
    iata: "OCJ",
    name: "Ian Fleming International Airport",
    city: "Boscobel",
    country: "JM",
    continent: "NA",
    lat: 18.4041,
    lon: -76.9698,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MKJP": {
    icao: "MKJP",
    iata: "KIN",
    name: "Norman Manley International Airport",
    city: "Kingston",
    country: "JM",
    continent: "NA",
    lat: 17.9357,
    lon: -76.7875,
    elevation: 10,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MKJS": {
    icao: "MKJS",
    iata: "MBJ",
    name: "Sangster International Airport",
    city: "Montego Bay",
    country: "JM",
    continent: "NA",
    lat: 18.5037,
    lon: -77.9134,
    elevation: 4,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MKKJ": {
    icao: "MKKJ",
    iata: "POT",
    name: "Ken Jones Airport",
    city: "Ken Jones",
    country: "JM",
    continent: "NA",
    lat: 18.1988,
    lon: -76.5345,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MKTP": {
    icao: "MKTP",
    iata: "KTP",
    name: "Tinson Pen Airport",
    city: "Tinson Pen",
    country: "JM",
    continent: "NA",
    lat: 17.9886,
    lon: -76.8238,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMAA": {
    icao: "MMAA",
    iata: "ACA",
    name: "General Juan N. Álvarez International Airport",
    city: "Acapulco",
    country: "MX",
    continent: "NA",
    lat: 16.7571,
    lon: -99.7531,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMAN": {
    icao: "MMAN",
    iata: "NTR",
    name: "Del Norte International Airport",
    city: "Monterrey",
    country: "MX",
    continent: "NA",
    lat: 25.8656,
    lon: -100.237,
    elevation: 1476,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMAS": {
    icao: "MMAS",
    iata: "AGU",
    name: "Jesús Terán Peredo International Airport",
    city: "Aguascalientes",
    country: "MX",
    continent: "NA",
    lat: 21.6996,
    lon: -102.3184,
    elevation: 6112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMBT": {
    icao: "MMBT",
    iata: "HUX",
    name: "Bahías de Huatulco International Airport",
    city: "Huatulco",
    country: "MX",
    continent: "NA",
    lat: 15.7749,
    lon: -96.2603,
    elevation: 464,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCB": {
    icao: "MMCB",
    iata: "CVJ",
    name: "General Mariano Matamoros International Airport",
    city: "Temixco",
    country: "MX",
    continent: "NA",
    lat: 18.8339,
    lon: -99.2618,
    elevation: 4277,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCE": {
    icao: "MMCE",
    iata: "CME",
    name: "Ciudad del Carmen International Airport",
    city: "Ciudad del Carmen",
    country: "MX",
    continent: "NA",
    lat: 18.6537,
    lon: -91.799,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCL": {
    icao: "MMCL",
    iata: "CUL",
    name: "Bachigualato Federal International Airport",
    city: "Culiacán",
    country: "MX",
    continent: "NA",
    lat: 24.765,
    lon: -107.4752,
    elevation: 108,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCM": {
    icao: "MMCM",
    iata: "CTM",
    name: "Chetumal International Airport",
    city: "Chetumal",
    country: "MX",
    continent: "NA",
    lat: 18.505,
    lon: -88.328,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCN": {
    icao: "MMCN",
    iata: "CEN",
    name: "Ciudad Obregón International Airport",
    city: "Ciudad Obregón",
    country: "MX",
    continent: "NA",
    lat: 27.3926,
    lon: -109.833,
    elevation: 243,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCP": {
    icao: "MMCP",
    iata: "CPE",
    name: "Ingeniero Alberto Acuña Ongay International Airport",
    city: "Campeche",
    country: "MX",
    continent: "NA",
    lat: 19.8168,
    lon: -90.5003,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCS": {
    icao: "MMCS",
    iata: "CJS",
    name: "Abraham González International Airport",
    city: "Ciudad Juárez",
    country: "MX",
    continent: "NA",
    lat: 31.6361,
    lon: -106.429,
    elevation: 3904,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCU": {
    icao: "MMCU",
    iata: "CUU",
    name: "General Roberto Fierro Villalobos International Airport",
    city: "Chihuahua",
    country: "MX",
    continent: "NA",
    lat: 28.7029,
    lon: -105.965,
    elevation: 4462,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCV": {
    icao: "MMCV",
    iata: "CVM",
    name: "General Pedro Jose Mendez International Airport",
    city: "Ciudad Victoria",
    country: "MX",
    continent: "NA",
    lat: 23.7033,
    lon: -98.9565,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCY": {
    icao: "MMCY",
    iata: "CYW",
    name: "Captain Rogelio Castillo National Airport",
    city: "Celaya",
    country: "MX",
    continent: "NA",
    lat: 20.546,
    lon: -100.8865,
    elevation: 5709,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMCZ": {
    icao: "MMCZ",
    iata: "CZM",
    name: "Cozumel International Airport",
    city: "Cozumel",
    country: "MX",
    continent: "NA",
    lat: 20.5149,
    lon: -86.9285,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMDO": {
    icao: "MMDO",
    iata: "DGO",
    name: "General Guadalupe Victoria International Airport",
    city: "Durango",
    country: "MX",
    continent: "NA",
    lat: 24.1255,
    lon: -104.5279,
    elevation: 6104,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMEP": {
    icao: "MMEP",
    iata: "TPQ",
    name: "Amado Nervo National Airport",
    city: "Tepic",
    country: "MX",
    continent: "NA",
    lat: 21.4198,
    lon: -104.8425,
    elevation: 3020,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMGL": {
    icao: "MMGL",
    iata: "GDL",
    name: "Guadalajara International Airport",
    city: "Guadalajara",
    country: "MX",
    continent: "NA",
    lat: 20.5233,
    lon: -103.3101,
    elevation: 5016,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMGM": {
    icao: "MMGM",
    iata: "GYM",
    name: "General José María Yáñez International Airport",
    city: "Guaymas",
    country: "MX",
    continent: "NA",
    lat: 27.969,
    lon: -110.925,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMHO": {
    icao: "MMHO",
    iata: "HMO",
    name: "General Ignacio P. Garcia International Airport",
    city: "Hermosillo",
    country: "MX",
    continent: "NA",
    lat: 29.0935,
    lon: -111.0499,
    elevation: 627,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMIA": {
    icao: "MMIA",
    iata: "CLQ",
    name: "Licenciado Miguel de la Madrid International Airport",
    city: "Colima",
    country: "MX",
    continent: "NA",
    lat: 19.277,
    lon: -103.577,
    elevation: 2467,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMIO": {
    icao: "MMIO",
    iata: "SLW",
    name: "Plan De Guadalupe International Airport",
    city: "Saltillo",
    country: "MX",
    continent: "NA",
    lat: 25.5441,
    lon: -100.9302,
    elevation: 4778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMIT": {
    icao: "MMIT",
    iata: "IZT",
    name: "General Antonio Cárdenas Rodríguez National Airport / Ixtepec Air Base",
    city: "Ixtepec",
    country: "MX",
    continent: "NA",
    lat: 16.446,
    lon: -95.0937,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMJA": {
    icao: "MMJA",
    iata: "JAL",
    name: "El Lencero Airport",
    city: "Emiliano Zapata",
    country: "MX",
    continent: "NA",
    lat: 19.4751,
    lon: -96.797,
    elevation: 3127,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMLC": {
    icao: "MMLC",
    iata: "LZC",
    name: "Lázaro Cárdenas Airport",
    city: "Lázaro Cárdenas",
    country: "MX",
    continent: "NA",
    lat: 18.0017,
    lon: -102.2203,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMLM": {
    icao: "MMLM",
    iata: "LMM",
    name: "Valle del Fuerte International Airport",
    city: "Los Mochis",
    country: "MX",
    continent: "NA",
    lat: 25.6854,
    lon: -109.0811,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMLO": {
    icao: "MMLO",
    iata: "BJX",
    name: "Del Bajío International Airport",
    city: "Silao",
    country: "MX",
    continent: "NA",
    lat: 20.9927,
    lon: -101.4803,
    elevation: 5956,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMLP": {
    icao: "MMLP",
    iata: "LAP",
    name: "Manuel Márquez de León International Airport",
    city: "La Paz",
    country: "MX",
    continent: "NA",
    lat: 24.0727,
    lon: -110.362,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMLT": {
    icao: "MMLT",
    iata: "LTO",
    name: "Loreto International Airport",
    city: "Loreto",
    country: "MX",
    continent: "NA",
    lat: 25.9892,
    lon: -111.348,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMMA": {
    icao: "MMMA",
    iata: "MAM",
    name: "General Servando Canales International Airport",
    city: "Matamoros",
    country: "MX",
    continent: "NA",
    lat: 25.7699,
    lon: -97.5253,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMMD": {
    icao: "MMMD",
    iata: "MID",
    name: "Manuel Crescencio Rejón International Airport",
    city: "Mérida",
    country: "MX",
    continent: "NA",
    lat: 20.9305,
    lon: -89.6455,
    elevation: 38,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMML": {
    icao: "MMML",
    iata: "MXL",
    name: "General Rodolfo Sánchez Taboada International Airport",
    city: "Mexicali",
    country: "MX",
    continent: "NA",
    lat: 32.6306,
    lon: -115.2428,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMMM": {
    icao: "MMMM",
    iata: "MLM",
    name: "General Francisco J. Mujica International Airport",
    city: "Morelia",
    country: "MX",
    continent: "NA",
    lat: 19.8499,
    lon: -101.025,
    elevation: 6033,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMMT": {
    icao: "MMMT",
    iata: "MTT",
    name: "Minatitlán/Coatzacoalcos International Airport",
    city: "Cosoleacaque",
    country: "MX",
    continent: "NA",
    lat: 18.1034,
    lon: -94.5807,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMMV": {
    icao: "MMMV",
    iata: "LOV",
    name: "Monclova International Airport",
    city: "Monclova",
    country: "MX",
    continent: "NA",
    lat: 26.9557,
    lon: -101.47,
    elevation: 1864,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMMX": {
    icao: "MMMX",
    iata: "MEX",
    name: "Benito Juárez International Airport",
    city: "Ciudad de México",
    country: "MX",
    continent: "NA",
    lat: 19.4351,
    lon: -99.0713,
    elevation: 7316,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "MMMY": {
    icao: "MMMY",
    iata: "MTY",
    name: "Monterrey International Airport",
    city: "Monterrey",
    country: "MX",
    continent: "NA",
    lat: 25.7785,
    lon: -100.107,
    elevation: 1278,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMMZ": {
    icao: "MMMZ",
    iata: "MZT",
    name: "General Rafael Buelna International Airport",
    city: "Mazatlàn",
    country: "MX",
    continent: "NA",
    lat: 23.1615,
    lon: -106.2646,
    elevation: 38,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMNL": {
    icao: "MMNL",
    iata: "NLD",
    name: "Quetzalcóatl International Airport",
    city: "Nuevo Laredo",
    country: "MX",
    continent: "NA",
    lat: 27.4439,
    lon: -99.5705,
    elevation: 484,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMOX": {
    icao: "MMOX",
    iata: "OAX",
    name: "Xoxocotlán International Airport",
    city: "Oaxaca",
    country: "MX",
    continent: "NA",
    lat: 17.0008,
    lon: -96.722,
    elevation: 4989,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMPA": {
    icao: "MMPA",
    iata: "PAZ",
    name: "El Tajín National Airport",
    city: "Poza Rica",
    country: "MX",
    continent: "NA",
    lat: 20.6027,
    lon: -97.4608,
    elevation: 497,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMPB": {
    icao: "MMPB",
    iata: "PBC",
    name: "Hermanos Serdán International Airport",
    city: "Puebla",
    country: "MX",
    continent: "NA",
    lat: 19.1585,
    lon: -98.3716,
    elevation: 7361,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMPG": {
    icao: "MMPG",
    iata: "PDS",
    name: "Piedras Negras International Airport",
    city: "Piedras Negras",
    country: "MX",
    continent: "NA",
    lat: 28.6279,
    lon: -100.5352,
    elevation: 901,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMPN": {
    icao: "MMPN",
    iata: "UPN",
    name: "Uruapan - Licenciado y General Ignacio Lopez Rayon International Airport",
    city: "Uruapan",
    country: "MX",
    continent: "NA",
    lat: 19.3967,
    lon: -102.039,
    elevation: 5258,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMPR": {
    icao: "MMPR",
    iata: "PVR",
    name: "Puerto Vallarta International Airport",
    city: "Puerto Vallarta",
    country: "MX",
    continent: "NA",
    lat: 20.6799,
    lon: -105.2544,
    elevation: 23,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMPS": {
    icao: "MMPS",
    iata: "PXM",
    name: "Puerto Escondido International Airport",
    city: "Puerto Escondido",
    country: "MX",
    continent: "NA",
    lat: 15.8768,
    lon: -97.0891,
    elevation: 294,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMQT": {
    icao: "MMQT",
    iata: "QRO",
    name: "Querétaro Intercontinental Airport",
    city: "Querétaro",
    country: "MX",
    continent: "NA",
    lat: 20.6173,
    lon: -100.186,
    elevation: 6296,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMRX": {
    icao: "MMRX",
    iata: "REX",
    name: "General Lucio Blanco International Airport",
    city: "Reynosa",
    country: "MX",
    continent: "NA",
    lat: 26.0089,
    lon: -98.2285,
    elevation: 139,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMSD": {
    icao: "MMSD",
    iata: "SJD",
    name: "Los Cabos International Airport",
    city: "San José del Cabo",
    country: "MX",
    continent: "NA",
    lat: 23.1519,
    lon: -109.7207,
    elevation: 374,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMSL": {
    icao: "MMSL",
    iata: "",
    name: "Cabo San Lucas International Airport",
    city: "Cabo San Lucas",
    country: "MX",
    continent: "NA",
    lat: 22.9482,
    lon: -109.9382,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMSM": {
    icao: "MMSM",
    iata: "NLU",
    name: "General Felipe Ángeles International Airport",
    city: "Mexico City",
    country: "MX",
    continent: "NA",
    lat: 19.7357,
    lon: -99.0257,
    elevation: 7369,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMSP": {
    icao: "MMSP",
    iata: "SLP",
    name: "Ponciano Arriaga International Airport",
    city: "San Luis Potosí",
    country: "MX",
    continent: "NA",
    lat: 22.2543,
    lon: -100.931,
    elevation: 6035,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTB": {
    icao: "MMTB",
    iata: "",
    name: "Terán Air Base",
    city: "Tuxtla Gutiérrez",
    country: "MX",
    continent: "NA",
    lat: 16.7399,
    lon: -93.1733,
    elevation: 1909,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTC": {
    icao: "MMTC",
    iata: "TRC",
    name: "Francisco Sarabia Tinoco International Airport",
    city: "Torreón",
    country: "MX",
    continent: "NA",
    lat: 25.5683,
    lon: -103.411,
    elevation: 3688,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTG": {
    icao: "MMTG",
    iata: "TGZ",
    name: "Angel Albino Corzo International Airport",
    city: "Tuxtla Gutiérrez",
    country: "MX",
    continent: "NA",
    lat: 16.5636,
    lon: -93.0225,
    elevation: 1499,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTJ": {
    icao: "MMTJ",
    iata: "TIJ",
    name: "General Abelardo L. Rodriguez International Airport",
    city: "Tijuana",
    country: "MX",
    continent: "NA",
    lat: 32.541,
    lon: -116.97,
    elevation: 489,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMTL": {
    icao: "MMTL",
    iata: "TQO",
    name: "Felipe Carrillo Puerto International Airport",
    city: "Tulum",
    country: "MX",
    continent: "NA",
    lat: 20.1721,
    lon: -87.6603,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTM": {
    icao: "MMTM",
    iata: "TAM",
    name: "General Francisco Javier Mina International Airport",
    city: "Tampico",
    country: "MX",
    continent: "NA",
    lat: 22.2964,
    lon: -97.8659,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTO": {
    icao: "MMTO",
    iata: "TLC",
    name: "Adolfo López Mateos International Airport",
    city: "Toluca",
    country: "MX",
    continent: "NA",
    lat: 19.3369,
    lon: -99.5658,
    elevation: 8466,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMTP": {
    icao: "MMTP",
    iata: "TAP",
    name: "Tapachula International Airport",
    city: "Tapachula",
    country: "MX",
    continent: "NA",
    lat: 14.7945,
    lon: -92.3699,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMUN": {
    icao: "MMUN",
    iata: "CUN",
    name: "Cancún International Airport",
    city: "Cancún",
    country: "MX",
    continent: "NA",
    lat: 21.0394,
    lon: -86.8743,
    elevation: 22,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MMVA": {
    icao: "MMVA",
    iata: "VSA",
    name: "Carlos Rovirosa Pérez International Airport",
    city: "Villahermosa",
    country: "MX",
    continent: "NA",
    lat: 17.997,
    lon: -92.8174,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMVR": {
    icao: "MMVR",
    iata: "VER",
    name: "General Heriberto Jara International Airport",
    city: "Veracruz",
    country: "MX",
    continent: "NA",
    lat: 19.1459,
    lon: -96.1873,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMZC": {
    icao: "MMZC",
    iata: "ZCL",
    name: "General Leobardo C. Ruiz International Airport",
    city: "Zacatecas",
    country: "MX",
    continent: "NA",
    lat: 22.8971,
    lon: -102.687,
    elevation: 7141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMZH": {
    icao: "MMZH",
    iata: "ZIH",
    name: "Ixtapa-Zihuatanejo International Airport",
    city: "Ixtapa",
    country: "MX",
    continent: "NA",
    lat: 17.6018,
    lon: -101.4606,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MMZO": {
    icao: "MMZO",
    iata: "ZLO",
    name: "Playa de Oro International Airport",
    city: "Manzanillo",
    country: "MX",
    continent: "NA",
    lat: 19.1448,
    lon: -104.559,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MNBL": {
    icao: "MNBL",
    iata: "BEF",
    name: "Bluefields Airport",
    city: "Bluefields",
    country: "NI",
    continent: "NA",
    lat: 11.991,
    lon: -83.7741,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MNMG": {
    icao: "MNMG",
    iata: "MGA",
    name: "Augusto C. Sandino (Managua) International Airport",
    city: "Managua",
    country: "NI",
    continent: "NA",
    lat: 12.1415,
    lon: -86.1682,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MNPC": {
    icao: "MNPC",
    iata: "PUZ",
    name: "Puerto Cabezas Airport",
    city: "Puerto Cabezas",
    country: "NI",
    continent: "NA",
    lat: 14.0472,
    lon: -83.3867,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPBO": {
    icao: "MPBO",
    iata: "BOC",
    name: "Bocas del Toro International Airport",
    city: "Isla Colón",
    country: "PA",
    continent: "NA",
    lat: 9.3408,
    lon: -82.2508,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPCE": {
    icao: "MPCE",
    iata: "CTD",
    name: "Alonso Valderrama Airport",
    city: "Chitré",
    country: "PA",
    continent: "NA",
    lat: 7.9878,
    lon: -80.4098,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPCH": {
    icao: "MPCH",
    iata: "CHX",
    name: "Changuinola Captain Manuel Niño International Airport",
    city: "Changuinola",
    country: "PA",
    continent: "NA",
    lat: 9.459,
    lon: -82.5151,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPDA": {
    icao: "MPDA",
    iata: "DAV",
    name: "Enrique Malek International Airport",
    city: "David",
    country: "PA",
    continent: "NA",
    lat: 8.391,
    lon: -82.435,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPEJ": {
    icao: "MPEJ",
    iata: "ONX",
    name: "Enrique Adolfo Jimenez Airport",
    city: "Colón",
    country: "PA",
    continent: "NA",
    lat: 9.3566,
    lon: -79.8674,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPMG": {
    icao: "MPMG",
    iata: "PAC",
    name: "Marcos A. Gelabert International Airport",
    city: "Albrook",
    country: "PA",
    continent: "NA",
    lat: 8.9733,
    lon: -79.5556,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPSA": {
    icao: "MPSA",
    iata: "SYP",
    name: "Ruben Cantu Airport",
    city: "Santiago",
    country: "PA",
    continent: "NA",
    lat: 8.0856,
    lon: -80.9453,
    elevation: 272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MPTO": {
    icao: "MPTO",
    iata: "PTY",
    name: "Tocumen International Airport",
    city: "Tocumen",
    country: "PA",
    continent: "NA",
    lat: 9.0714,
    lon: -79.3835,
    elevation: 135,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MRAO": {
    icao: "MRAO",
    iata: "",
    name: "Aerotortuguero Airport",
    city: "Roxana",
    country: "CR",
    continent: "NA",
    lat: 10.42,
    lon: -83.6095,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRBA": {
    icao: "MRBA",
    iata: "BAI",
    name: "Buenos Aires Airport",
    city: "Punta Arenas",
    country: "CR",
    continent: "NA",
    lat: 9.1639,
    lon: -83.3302,
    elevation: 1214,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRBC": {
    icao: "MRBC",
    iata: "BCL",
    name: "Barra del Colorado Airport",
    city: "Pococi",
    country: "CR",
    continent: "NA",
    lat: 10.7687,
    lon: -83.5856,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRCC": {
    icao: "MRCC",
    iata: "OTR",
    name: "Coto 47 Airport",
    city: "Corredores",
    country: "CR",
    continent: "NA",
    lat: 8.6016,
    lon: -82.9688,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRGF": {
    icao: "MRGF",
    iata: "GLF",
    name: "Golfito Airport",
    city: "Golfito",
    country: "CR",
    continent: "NA",
    lat: 8.654,
    lon: -83.1822,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRGP": {
    icao: "MRGP",
    iata: "GPL",
    name: "Guapiles Airport",
    city: "Pococi",
    country: "CR",
    continent: "NA",
    lat: 10.2172,
    lon: -83.797,
    elevation: 883,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRLB": {
    icao: "MRLB",
    iata: "LIR",
    name: "Guanacaste Airport",
    city: "Liberia",
    country: "CR",
    continent: "NA",
    lat: 10.5933,
    lon: -85.5444,
    elevation: 270,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MRLC": {
    icao: "MRLC",
    iata: "LSL",
    name: "Los Chiles Airport",
    city: "Los Chiles",
    country: "CR",
    continent: "NA",
    lat: 11.0353,
    lon: -84.7061,
    elevation: 131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRLM": {
    icao: "MRLM",
    iata: "LIO",
    name: "Limon International Airport",
    city: "Puerto Limon",
    country: "CR",
    continent: "NA",
    lat: 9.958,
    lon: -83.022,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRNS": {
    icao: "MRNS",
    iata: "NOB",
    name: "Nosara Airport",
    city: "Nicoya",
    country: "CR",
    continent: "NA",
    lat: 9.9765,
    lon: -85.653,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MROC": {
    icao: "MROC",
    iata: "SJO",
    name: "Juan Santamaría International Airport",
    city: "San José (Alajuela)",
    country: "CR",
    continent: "NA",
    lat: 9.9939,
    lon: -84.2088,
    elevation: 3021,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MRPJ": {
    icao: "MRPJ",
    iata: "PJM",
    name: "Puerto Jimenez Airport",
    city: "Puerto Jimenez",
    country: "CR",
    continent: "NA",
    lat: 8.5333,
    lon: -83.3,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRPM": {
    icao: "MRPM",
    iata: "PMZ",
    name: "Palmar Sur Airport",
    city: "Palmar Sur",
    country: "CR",
    continent: "NA",
    lat: 8.951,
    lon: -83.4686,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRPV": {
    icao: "MRPV",
    iata: "SYQ",
    name: "Tobías Bolaños International Airport",
    city: "San Jose",
    country: "CR",
    continent: "NA",
    lat: 9.9571,
    lon: -84.1398,
    elevation: 3287,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRQP": {
    icao: "MRQP",
    iata: "XQP",
    name: "Quepos Managua Airport",
    city: "Quepos",
    country: "CR",
    continent: "NA",
    lat: 9.4432,
    lon: -84.1298,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MRUP": {
    icao: "MRUP",
    iata: "UPL",
    name: "Upala Airport",
    city: "Upala",
    country: "CR",
    continent: "NA",
    lat: 10.8922,
    lon: -85.0162,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MSLP": {
    icao: "MSLP",
    iata: "SAL",
    name: "Monseñor Óscar Arnulfo Romero International Airport",
    city: "San Salvador (San Luis Talpa)",
    country: "SV",
    continent: "NA",
    lat: 13.4409,
    lon: -89.0557,
    elevation: 101,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MSSS": {
    icao: "MSSS",
    iata: "ILS",
    name: "Ilopango International Airport",
    city: "San Salvador",
    country: "SV",
    continent: "NA",
    lat: 13.6995,
    lon: -89.1199,
    elevation: 2027,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MTCA": {
    icao: "MTCA",
    iata: "CYA",
    name: "Antoine-Simon International Airport",
    city: "Les Cayes",
    country: "HT",
    continent: "NA",
    lat: 18.2711,
    lon: -73.7883,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MTCH": {
    icao: "MTCH",
    iata: "CAP",
    name: "Cap Haitien International Airport",
    city: "Cap Haitien",
    country: "HT",
    continent: "NA",
    lat: 19.7267,
    lon: -72.1996,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MTJA": {
    icao: "MTJA",
    iata: "JAK",
    name: "Jacmel Airport",
    city: "Jacmel",
    country: "HT",
    continent: "NA",
    lat: 18.2411,
    lon: -72.5185,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MTJE": {
    icao: "MTJE",
    iata: "JEE",
    name: "Jérémie Airport",
    city: "Carrefour Sanon",
    country: "HT",
    continent: "NA",
    lat: 18.6631,
    lon: -74.1703,
    elevation: 147,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MTPP": {
    icao: "MTPP",
    iata: "PAP",
    name: "Toussaint Louverture International Airport",
    city: "Port-au-Prince",
    country: "HT",
    continent: "NA",
    lat: 18.58,
    lon: -72.2926,
    elevation: 122,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MTPX": {
    icao: "MTPX",
    iata: "PAX",
    name: "Port-de-Paix Airport",
    city: "Port-de-Paix",
    country: "HT",
    continent: "NA",
    lat: 19.934,
    lon: -72.848,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUBA": {
    icao: "MUBA",
    iata: "BCA",
    name: "Gustavo Rizo Airport",
    city: "Baracoa",
    country: "CU",
    continent: "NA",
    lat: 20.3653,
    lon: -74.5062,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUBY": {
    icao: "MUBY",
    iata: "BYM",
    name: "Carlos Manuel de Cespedes Airport",
    city: "Bayamo",
    country: "CU",
    continent: "NA",
    lat: 20.3964,
    lon: -76.6214,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUCA": {
    icao: "MUCA",
    iata: "AVI",
    name: "Máximo Gómez Airport",
    city: "Ciro Redondo",
    country: "CU",
    continent: "NA",
    lat: 22.0271,
    lon: -78.7896,
    elevation: 335,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUCC": {
    icao: "MUCC",
    iata: "CCC",
    name: "Jardines Del Rey Airport",
    city: "Cayo Coco",
    country: "CU",
    continent: "NA",
    lat: 22.461,
    lon: -78.3284,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUCF": {
    icao: "MUCF",
    iata: "CFG",
    name: "Jaime Gonzalez Airport",
    city: "Cienfuegos",
    country: "CU",
    continent: "NA",
    lat: 22.15,
    lon: -80.4142,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUCL": {
    icao: "MUCL",
    iata: "CYO",
    name: "Vilo Acuña International Airport",
    city: "Cayo Largo del Sur",
    country: "CU",
    continent: "NA",
    lat: 21.6165,
    lon: -81.546,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUCM": {
    icao: "MUCM",
    iata: "CMW",
    name: "Ignacio Agramonte International Airport",
    city: "Camaguey",
    country: "CU",
    continent: "NA",
    lat: 21.4203,
    lon: -77.8475,
    elevation: 413,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUCU": {
    icao: "MUCU",
    iata: "SCU",
    name: "Antonio Maceo International Airport",
    city: "Santiago",
    country: "CU",
    continent: "NA",
    lat: 19.9698,
    lon: -75.8354,
    elevation: 249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUGM": {
    icao: "MUGM",
    iata: "NBW",
    name: "Leeward Point Field",
    city: "Guantanamo Bay Naval Station",
    country: "CU",
    continent: "NA",
    lat: 19.9065,
    lon: -75.2071,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUGT": {
    icao: "MUGT",
    iata: "GAO",
    name: "Mariana Grajales Airport",
    city: "Guantánamo",
    country: "CU",
    continent: "NA",
    lat: 20.0853,
    lon: -75.1583,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUHA": {
    icao: "MUHA",
    iata: "HAV",
    name: "José Martí International Airport",
    city: "Havana",
    country: "CU",
    continent: "NA",
    lat: 22.9892,
    lon: -82.4091,
    elevation: 210,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MUHG": {
    icao: "MUHG",
    iata: "HOG",
    name: "Frank Pais International Airport",
    city: "Holguin",
    country: "CU",
    continent: "NA",
    lat: 20.7856,
    lon: -76.3151,
    elevation: 361,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUKW": {
    icao: "MUKW",
    iata: "VRO",
    name: "Kawama Airport",
    city: "Santa Marta",
    country: "CU",
    continent: "NA",
    lat: 23.124,
    lon: -81.3016,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MULM": {
    icao: "MULM",
    iata: "LCL",
    name: "La Coloma Airport",
    city: "Pinar del Rio",
    country: "CU",
    continent: "NA",
    lat: 22.3361,
    lon: -83.6419,
    elevation: 131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUMO": {
    icao: "MUMO",
    iata: "MOA",
    name: "Orestes Acosta Airport",
    city: "Moa",
    country: "CU",
    continent: "NA",
    lat: 20.6539,
    lon: -74.9222,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUMZ": {
    icao: "MUMZ",
    iata: "MZO",
    name: "Sierra Maestra International Airport",
    city: "Manzanillo",
    country: "CU",
    continent: "NA",
    lat: 20.2886,
    lon: -77.0875,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUNB": {
    icao: "MUNB",
    iata: "",
    name: "San Nicolás de Bari Airport",
    city: "San Nicolás de Bari",
    country: "CU",
    continent: "NA",
    lat: 22.7565,
    lon: -81.9207,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUNG": {
    icao: "MUNG",
    iata: "GER",
    name: "Rafael Cabrera Airport",
    city: "Nueva Gerona",
    country: "CU",
    continent: "NA",
    lat: 21.8347,
    lon: -82.7838,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUPB": {
    icao: "MUPB",
    iata: "UPB",
    name: "Playa Baracoa Airport",
    city: "Havana",
    country: "CU",
    continent: "NA",
    lat: 23.0328,
    lon: -82.5794,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUSC": {
    icao: "MUSC",
    iata: "SNU",
    name: "Abel Santamaria Airport",
    city: "Santa Clara",
    country: "CU",
    continent: "NA",
    lat: 22.4922,
    lon: -79.9436,
    elevation: 338,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUSJ": {
    icao: "MUSJ",
    iata: "SNJ",
    name: "San Julián Air Base",
    city: "Sandino",
    country: "CU",
    continent: "NA",
    lat: 22.1005,
    lon: -84.1574,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUSN": {
    icao: "MUSN",
    iata: "SZJ",
    name: "Siguanea Airport",
    city: "Isla de la Juventud",
    country: "CU",
    continent: "NA",
    lat: 21.6425,
    lon: -82.9551,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUTD": {
    icao: "MUTD",
    iata: "TND",
    name: "Alberto Delgado Airport",
    city: "Trinidad",
    country: "CU",
    continent: "NA",
    lat: 21.7883,
    lon: -79.9972,
    elevation: 125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MUVR": {
    icao: "MUVR",
    iata: "VRA",
    name: "Juan Gualberto Gomez International Airport",
    city: "Matanzas",
    country: "CU",
    continent: "NA",
    lat: 23.0344,
    lon: -81.4353,
    elevation: 210,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MUVT": {
    icao: "MUVT",
    iata: "VTU",
    name: "Hermanos Ameijeiras Airport",
    city: "Las Tunas",
    country: "CU",
    continent: "NA",
    lat: 20.9876,
    lon: -76.9358,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MWCB": {
    icao: "MWCB",
    iata: "CYB",
    name: "Charles Kirkconnell International Airport",
    city: "West End",
    country: "KY",
    continent: "NA",
    lat: 19.687,
    lon: -79.8828,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MWCL": {
    icao: "MWCL",
    iata: "LYB",
    name: "Edward Bodden Little Cayman Airfield",
    city: "Blossom Village",
    country: "KY",
    continent: "NA",
    lat: 19.6602,
    lon: -80.0888,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MWCR": {
    icao: "MWCR",
    iata: "GCM",
    name: "Owen Roberts International Airport",
    city: "George Town",
    country: "KY",
    continent: "NA",
    lat: 19.2928,
    lon: -81.3577,
    elevation: 8,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MYAB": {
    icao: "MYAB",
    iata: "MAY",
    name: "Clarence A. Bain Airport",
    city: "Mangrove Cay",
    country: "BS",
    continent: "NA",
    lat: 24.2877,
    lon: -77.6846,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYAF": {
    icao: "MYAF",
    iata: "ASD",
    name: "Andros Town Airport",
    city: "Andros Town",
    country: "BS",
    continent: "NA",
    lat: 24.6979,
    lon: -77.7956,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYAK": {
    icao: "MYAK",
    iata: "TZN",
    name: "Congo Town Airport",
    city: "Andros",
    country: "BS",
    continent: "NA",
    lat: 24.1587,
    lon: -77.5898,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYAM": {
    icao: "MYAM",
    iata: "MHH",
    name: "Leonard M Thompson International Airport",
    city: "Marsh Harbour",
    country: "BS",
    continent: "NA",
    lat: 26.5107,
    lon: -77.0843,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYAN": {
    icao: "MYAN",
    iata: "SAQ",
    name: "San Andros Airport",
    city: "Andros Island",
    country: "BS",
    continent: "NA",
    lat: 25.0538,
    lon: -78.049,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYAP": {
    icao: "MYAP",
    iata: "AXP",
    name: "Spring Point Airport",
    city: "Spring Point",
    country: "BS",
    continent: "NA",
    lat: 22.4418,
    lon: -73.9709,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYAT": {
    icao: "MYAT",
    iata: "TCB",
    name: "Treasure Cay Airport",
    city: "Treasure Cay",
    country: "BS",
    continent: "NA",
    lat: 26.7453,
    lon: -77.3913,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYBC": {
    icao: "MYBC",
    iata: "CCZ",
    name: "Chub Cay Airport",
    city: "Chub Cay",
    country: "BS",
    continent: "NA",
    lat: 25.4171,
    lon: -77.8809,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYBG": {
    icao: "MYBG",
    iata: "GHC",
    name: "Great Harbour Cay Airport",
    city: "Bullocks Harbour",
    country: "BS",
    continent: "NA",
    lat: 25.7383,
    lon: -77.8401,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYBS": {
    icao: "MYBS",
    iata: "BIM",
    name: "South Bimini Airport",
    city: "South Bimini",
    country: "BS",
    continent: "NA",
    lat: 25.6999,
    lon: -79.2647,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYCA": {
    icao: "MYCA",
    iata: "ATC",
    name: "Arthur\'s Town Airport",
    city: "Arthur\'s Town",
    country: "BS",
    continent: "NA",
    lat: 24.6294,
    lon: -75.6738,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYCB": {
    icao: "MYCB",
    iata: "TBI",
    name: "New Bight Airport",
    city: "Cat Island",
    country: "BS",
    continent: "NA",
    lat: 24.3153,
    lon: -75.4523,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYCI": {
    icao: "MYCI",
    iata: "CRI",
    name: "Colonel Hill Airport",
    city: "Colonel Hill",
    country: "BS",
    continent: "NA",
    lat: 22.7456,
    lon: -74.1824,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYEF": {
    icao: "MYEF",
    iata: "GGT",
    name: "Exuma International Airport",
    city: "Moss Town",
    country: "BS",
    continent: "NA",
    lat: 23.5626,
    lon: -75.878,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYEH": {
    icao: "MYEH",
    iata: "ELH",
    name: "North Eleuthera Airport",
    city: "North Eleuthera",
    country: "BS",
    continent: "NA",
    lat: 25.4749,
    lon: -76.6835,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYEM": {
    icao: "MYEM",
    iata: "GHB",
    name: "Governor\'s Harbour Airport",
    city: "Governor\'s Harbour",
    country: "BS",
    continent: "NA",
    lat: 25.2847,
    lon: -76.331,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYEN": {
    icao: "MYEN",
    iata: "NMC",
    name: "Normans Cay Airport",
    city: "Normans Cay",
    country: "BS",
    continent: "NA",
    lat: 24.5943,
    lon: -76.8202,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYER": {
    icao: "MYER",
    iata: "RSD",
    name: "Rock Sound Airport",
    city: "Rock Sound",
    country: "BS",
    continent: "NA",
    lat: 24.8951,
    lon: -76.1769,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYES": {
    icao: "MYES",
    iata: "TYM",
    name: "Staniel Cay Airport",
    city: "Staniel Cay",
    country: "BS",
    continent: "NA",
    lat: 24.1691,
    lon: -76.4391,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYGF": {
    icao: "MYGF",
    iata: "FPO",
    name: "Grand Bahama International Airport",
    city: "Freeport",
    country: "BS",
    continent: "NA",
    lat: 26.5587,
    lon: -78.6956,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYIG": {
    icao: "MYIG",
    iata: "IGA",
    name: "Inagua Airport",
    city: "Matthew Town",
    country: "BS",
    continent: "NA",
    lat: 20.975,
    lon: -73.6669,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYLD": {
    icao: "MYLD",
    iata: "LGI",
    name: "Deadman\'s Cay Airport",
    city: "Deadman\'s Cay",
    country: "BS",
    continent: "NA",
    lat: 23.179,
    lon: -75.0936,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYLR": {
    icao: "MYLR",
    iata: "",
    name: "Hard Bargain Airport",
    city: "",
    country: "BS",
    continent: "NA",
    lat: 23.0099,
    lon: -74.9049,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYLS": {
    icao: "MYLS",
    iata: "SML",
    name: "Stella Maris Airport",
    city: "Stella Maris",
    country: "BS",
    continent: "NA",
    lat: 23.5823,
    lon: -75.2686,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYMM": {
    icao: "MYMM",
    iata: "MYG",
    name: "Mayaguana Airport",
    city: "Abraham Bay Settlement",
    country: "BS",
    continent: "NA",
    lat: 22.3795,
    lon: -73.0135,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYNN": {
    icao: "MYNN",
    iata: "NAS",
    name: "Lynden Pindling International Airport",
    city: "Nassau",
    country: "BS",
    continent: "NA",
    lat: 25.039,
    lon: -77.4662,
    elevation: 16,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MYRD": {
    icao: "MYRD",
    iata: "DCT",
    name: "Duncan Town Airport",
    city: "Duncan Town",
    country: "BS",
    continent: "NA",
    lat: 22.1818,
    lon: -75.7295,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MYSM": {
    icao: "MYSM",
    iata: "ZSA",
    name: "San Salvador Airport",
    city: "San Salvador",
    country: "BS",
    continent: "NA",
    lat: 24.0633,
    lon: -74.524,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "MZBZ": {
    icao: "MZBZ",
    iata: "BZE",
    name: "Philip S. W. Goldson International Airport",
    city: "Belize City",
    country: "BZ",
    continent: "NA",
    lat: 17.54,
    lon: -88.3036,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "MZPL": {
    icao: "MZPL",
    iata: "PLJ",
    name: "Placencia Airport",
    city: "Placencia",
    country: "BZ",
    continent: "NA",
    lat: 16.537,
    lon: -88.3615,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NCRG": {
    icao: "NCRG",
    iata: "RAR",
    name: "Rarotonga International Airport",
    city: "Avarua",
    country: "CK",
    continent: "OC",
    lat: -21.2027,
    lon: -159.806,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NFFN": {
    icao: "NFFN",
    iata: "NAN",
    name: "Nadi International Airport",
    city: "Nadi",
    country: "FJ",
    continent: "OC",
    lat: -17.7554,
    lon: 177.443,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NFNA": {
    icao: "NFNA",
    iata: "SUV",
    name: "Nausori International Airport",
    city: "Nausori",
    country: "FJ",
    continent: "OC",
    lat: -18.0433,
    lon: 178.559,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NFNL": {
    icao: "NFNL",
    iata: "LBS",
    name: "Labasa Airport",
    city: "Labasa",
    country: "FJ",
    continent: "OC",
    lat: -16.4667,
    lon: 179.34,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NFTF": {
    icao: "NFTF",
    iata: "TBU",
    name: "Fua\'amotu International Airport",
    city: "Nuku\'alofa",
    country: "TO",
    continent: "OC",
    lat: -21.2412,
    lon: -175.15,
    elevation: 126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NFTL": {
    icao: "NFTL",
    iata: "HPA",
    name: "Lifuka Island Airport",
    city: "Lifuka",
    country: "TO",
    continent: "OC",
    lat: -19.777,
    lon: -174.341,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NFTV": {
    icao: "NFTV",
    iata: "VAV",
    name: "Vava\'u International Airport",
    city: "Vava\'u Island",
    country: "TO",
    continent: "OC",
    lat: -18.5853,
    lon: -173.962,
    elevation: 236,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NGFU": {
    icao: "NGFU",
    iata: "FUN",
    name: "Funafuti International Airport",
    city: "Funafuti",
    country: "TV",
    continent: "OC",
    lat: -8.525,
    lon: 179.196,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NGTA": {
    icao: "NGTA",
    iata: "TRW",
    name: "Bonriki International Airport",
    city: "Tarawa",
    country: "KI",
    continent: "OC",
    lat: 1.3816,
    lon: 173.147,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NGTE": {
    icao: "NGTE",
    iata: "TBF",
    name: "Tabiteuea North Airport",
    city: "",
    country: "KI",
    continent: "OC",
    lat: -1.2245,
    lon: 174.776,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NIUE": {
    icao: "NIUE",
    iata: "IUE",
    name: "Niue International Airport",
    city: "Alofi",
    country: "NU",
    continent: "OC",
    lat: -19.079,
    lon: -169.9256,
    elevation: 209,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NLWW": {
    icao: "NLWW",
    iata: "WLS",
    name: "Hihifo Airport",
    city: "Wallis Island",
    country: "WF",
    continent: "OC",
    lat: -13.2383,
    lon: -176.199,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NSFA": {
    icao: "NSFA",
    iata: "APW",
    name: "Faleolo International Airport",
    city: "Apia",
    country: "WS",
    continent: "OC",
    lat: -13.83,
    lon: -172.008,
    elevation: 58,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NSTU": {
    icao: "NSTU",
    iata: "PPG",
    name: "Pago Pago International Airport",
    city: "Pago Pago",
    country: "AS",
    continent: "OC",
    lat: -14.331,
    lon: -170.71,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTAA": {
    icao: "NTAA",
    iata: "PPT",
    name: "Faa\'a International Airport",
    city: "Papeete",
    country: "PF",
    continent: "OC",
    lat: -17.5537,
    lon: -149.607,
    elevation: 5,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "NTAR": {
    icao: "NTAR",
    iata: "RUR",
    name: "Rurutu Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -22.4341,
    lon: -151.361,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTAT": {
    icao: "NTAT",
    iata: "TUB",
    name: "Tubuai Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -23.3654,
    lon: -149.524,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGA": {
    icao: "NTGA",
    iata: "AAA",
    name: "Anaa Airport",
    city: "Anaa",
    country: "PF",
    continent: "OC",
    lat: -17.3526,
    lon: -145.51,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGB": {
    icao: "NTGB",
    iata: "FGU",
    name: "Fangatau Airport",
    city: "Fangatau",
    country: "PF",
    continent: "OC",
    lat: -15.82,
    lon: -140.8881,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGC": {
    icao: "NTGC",
    iata: "TIH",
    name: "Tikehau Airport",
    city: "Tuherahera",
    country: "PF",
    continent: "OC",
    lat: -15.1196,
    lon: -148.231,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGE": {
    icao: "NTGE",
    iata: "REA",
    name: "Reao Airport",
    city: "Reao",
    country: "PF",
    continent: "OC",
    lat: -18.4665,
    lon: -136.4385,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGF": {
    icao: "NTGF",
    iata: "FAV",
    name: "Fakarava Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -16.0541,
    lon: -145.657,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGI": {
    icao: "NTGI",
    iata: "XMH",
    name: "Manihi Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -14.4368,
    lon: -146.07,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGJ": {
    icao: "NTGJ",
    iata: "GMR",
    name: "Totegegie Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -23.0799,
    lon: -134.89,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGK": {
    icao: "NTGK",
    iata: "KKR",
    name: "Kaukura Airport",
    city: "Raitahiti",
    country: "PF",
    continent: "OC",
    lat: -15.6633,
    lon: -146.885,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGM": {
    icao: "NTGM",
    iata: "MKP",
    name: "Makemo Airport",
    city: "Makemo",
    country: "PF",
    continent: "OC",
    lat: -16.5839,
    lon: -143.658,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGT": {
    icao: "NTGT",
    iata: "TKP",
    name: "Takapoto Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -14.7095,
    lon: -145.246,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGU": {
    icao: "NTGU",
    iata: "AXR",
    name: "Arutua Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -15.2483,
    lon: -146.617,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTGV": {
    icao: "NTGV",
    iata: "MVT",
    name: "Mataiva Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -14.8681,
    lon: -148.717,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTHE": {
    icao: "NTHE",
    iata: "AHE",
    name: "Ahe Airport",
    city: "Ahe Atoll",
    country: "PF",
    continent: "OC",
    lat: -14.4281,
    lon: -146.257,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTKR": {
    icao: "NTKR",
    iata: "TKX",
    name: "Takaroa Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -14.4558,
    lon: -145.025,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTMD": {
    icao: "NTMD",
    iata: "NHV",
    name: "Nuku Hiva Airport",
    city: "Nuku Hiva",
    country: "PF",
    continent: "OC",
    lat: -8.7956,
    lon: -140.229,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTMN": {
    icao: "NTMN",
    iata: "AUQ",
    name: "Hiva Oa-Atuona Airport",
    city: "Hiva Oa Island",
    country: "PF",
    continent: "OC",
    lat: -9.7688,
    lon: -139.011,
    elevation: 1481,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTB": {
    icao: "NTTB",
    iata: "BOB",
    name: "Bora Bora Airport",
    city: "Motu Mute",
    country: "PF",
    continent: "OC",
    lat: -16.4444,
    lon: -151.751,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTG": {
    icao: "NTTG",
    iata: "RGI",
    name: "Rangiroa Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -14.9543,
    lon: -147.661,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTH": {
    icao: "NTTH",
    iata: "HUH",
    name: "Huahine-Fare Airport",
    city: "Fare",
    country: "PF",
    continent: "OC",
    lat: -16.6871,
    lon: -151.0216,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTM": {
    icao: "NTTM",
    iata: "MOZ",
    name: "Moorea Temae Airport",
    city: "Moorea-Maiao",
    country: "PF",
    continent: "OC",
    lat: -17.4898,
    lon: -149.7618,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTO": {
    icao: "NTTO",
    iata: "HOI",
    name: "Hao Airport",
    city: "Otepa",
    country: "PF",
    continent: "OC",
    lat: -18.0748,
    lon: -140.946,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTP": {
    icao: "NTTP",
    iata: "MAU",
    name: "Maupiti Airport",
    city: "",
    country: "PF",
    continent: "OC",
    lat: -16.4265,
    lon: -152.244,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NTTR": {
    icao: "NTTR",
    iata: "RFP",
    name: "Raiatea Airport",
    city: "Uturoa",
    country: "PF",
    continent: "OC",
    lat: -16.7229,
    lon: -151.466,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NVSQ": {
    icao: "NVSQ",
    iata: "ZGU",
    name: "Gaua Island Airport",
    city: "Gaua Island",
    country: "VU",
    continent: "OC",
    lat: -14.2181,
    lon: 167.587,
    elevation: 100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NVSS": {
    icao: "NVSS",
    iata: "SON",
    name: "Santo Pekoa International Airport",
    city: "Luganville",
    country: "VU",
    continent: "OC",
    lat: -15.505,
    lon: 167.22,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NVVV": {
    icao: "NVVV",
    iata: "VLI",
    name: "Bauerfield International Airport",
    city: "Port Vila",
    country: "VU",
    continent: "OC",
    lat: -17.6993,
    lon: 168.32,
    elevation: 70,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "NVVW": {
    icao: "NVVW",
    iata: "TAH",
    name: "Whitegrass Airport",
    city: "Tanna Island",
    country: "VU",
    continent: "OC",
    lat: -19.4551,
    lon: 169.224,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWA": {
    icao: "NWWA",
    iata: "TGJ",
    name: "Tiga Airport",
    city: "Tiga",
    country: "NC",
    continent: "OC",
    lat: -21.0964,
    lon: 167.8038,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWD": {
    icao: "NWWD",
    iata: "KNQ",
    name: "Koné Airport",
    city: "Koné",
    country: "NC",
    continent: "OC",
    lat: -21.0536,
    lon: 164.8388,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWE": {
    icao: "NWWE",
    iata: "ILP",
    name: "Île des Pins Airport",
    city: "Île des Pins",
    country: "NC",
    continent: "OC",
    lat: -22.5889,
    lon: 167.456,
    elevation: 315,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWL": {
    icao: "NWWL",
    iata: "LIF",
    name: "Lifou Airport",
    city: "Lifou",
    country: "NC",
    continent: "OC",
    lat: -20.7746,
    lon: 167.2393,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWM": {
    icao: "NWWM",
    iata: "GEA",
    name: "Nouméa Magenta Airport",
    city: "Nouméa",
    country: "NC",
    continent: "OC",
    lat: -22.2581,
    lon: 166.4728,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWR": {
    icao: "NWWR",
    iata: "MEE",
    name: "Maré Airport",
    city: "Maré",
    country: "NC",
    continent: "OC",
    lat: -21.4824,
    lon: 168.0385,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWU": {
    icao: "NWWU",
    iata: "TOU",
    name: "Touho Airport",
    city: "Touho",
    country: "NC",
    continent: "OC",
    lat: -20.7901,
    lon: 165.2595,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWV": {
    icao: "NWWV",
    iata: "UVE",
    name: "Ouvéa Airport",
    city: "Ouvéa",
    country: "NC",
    continent: "OC",
    lat: -20.6409,
    lon: 166.573,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NWWW": {
    icao: "NWWW",
    iata: "NOU",
    name: "La Tontouta International Airport",
    city: "Nouméa (La Tontouta)",
    country: "NC",
    continent: "OC",
    lat: -22.0146,
    lon: 166.213,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZAA": {
    icao: "NZAA",
    iata: "AKL",
    name: "Auckland International Airport",
    city: "Auckland",
    country: "NZ",
    continent: "OC",
    lat: -37.012,
    lon: 174.7863,
    elevation: 23,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "NZAP": {
    icao: "NZAP",
    iata: "TUO",
    name: "Taupo Airport",
    city: "Taupo",
    country: "NZ",
    continent: "OC",
    lat: -38.7397,
    lon: 176.084,
    elevation: 1335,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZAR": {
    icao: "NZAR",
    iata: "AMZ",
    name: "Ardmore Airport",
    city: "Manurewa",
    country: "NZ",
    continent: "OC",
    lat: -37.0297,
    lon: 174.973,
    elevation: 111,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZCH": {
    icao: "NZCH",
    iata: "CHC",
    name: "Christchurch International Airport",
    city: "Christchurch",
    country: "NZ",
    continent: "OC",
    lat: -43.489,
    lon: 172.5321,
    elevation: 123,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "NZCI": {
    icao: "NZCI",
    iata: "CHT",
    name: "Chatham Islands / Tuuta Airport",
    city: "Te One",
    country: "NZ",
    continent: "OC",
    lat: -43.8119,
    lon: -176.4651,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZDN": {
    icao: "NZDN",
    iata: "DUD",
    name: "Dunedin International Airport",
    city: "Dunedin",
    country: "NZ",
    continent: "OC",
    lat: -45.9281,
    lon: 170.198,
    elevation: 4,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZGS": {
    icao: "NZGS",
    iata: "GIS",
    name: "Gisborne Airport",
    city: "Gisborne",
    country: "NZ",
    continent: "OC",
    lat: -38.6633,
    lon: 177.978,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZGT": {
    icao: "NZGT",
    iata: "GTN",
    name: "Glentanner Airport",
    city: "Glentanner Station",
    country: "NZ",
    continent: "OC",
    lat: -43.9067,
    lon: 170.128,
    elevation: 1824,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZHK": {
    icao: "NZHK",
    iata: "HKK",
    name: "Hokitika Airfield",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -42.7136,
    lon: 170.985,
    elevation: 146,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZHN": {
    icao: "NZHN",
    iata: "HLZ",
    name: "Hamilton International Airport",
    city: "Hamilton",
    country: "NZ",
    continent: "OC",
    lat: -37.8667,
    lon: 175.332,
    elevation: 172,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZKK": {
    icao: "NZKK",
    iata: "KKE",
    name: "Kerikeri Airport",
    city: "Kerikeri",
    country: "NZ",
    continent: "OC",
    lat: -35.2591,
    lon: 173.9133,
    elevation: 492,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZKT": {
    icao: "NZKT",
    iata: "KAT",
    name: "Kaitaia Airport",
    city: "Awanui",
    country: "NZ",
    continent: "OC",
    lat: -35.0698,
    lon: 173.2871,
    elevation: 270,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZLX": {
    icao: "NZLX",
    iata: "ALR",
    name: "Alexandra Aerodrome",
    city: "Alexandra",
    country: "NZ",
    continent: "OC",
    lat: -45.2105,
    lon: 169.3711,
    elevation: 752,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZMC": {
    icao: "NZMC",
    iata: "MON",
    name: "Mount Cook Airport",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -43.765,
    lon: 170.133,
    elevation: 2153,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZMO": {
    icao: "NZMO",
    iata: "TEU",
    name: "Manapouri Airport",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -45.5331,
    lon: 167.65,
    elevation: 687,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZMS": {
    icao: "NZMS",
    iata: "MRO",
    name: "Hood Airport",
    city: "Masterton",
    country: "NZ",
    continent: "OC",
    lat: -40.9746,
    lon: 175.6345,
    elevation: 364,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZNP": {
    icao: "NZNP",
    iata: "NPL",
    name: "New Plymouth Airport",
    city: "New Plymouth",
    country: "NZ",
    continent: "OC",
    lat: -39.0086,
    lon: 174.179,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZNR": {
    icao: "NZNR",
    iata: "NPE",
    name: "Hawke\'s Bay Airport",
    city: "Napier",
    country: "NZ",
    continent: "OC",
    lat: -39.4658,
    lon: 176.87,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZNS": {
    icao: "NZNS",
    iata: "NSN",
    name: "Nelson Airport",
    city: "Nelson",
    country: "NZ",
    continent: "OC",
    lat: -41.2983,
    lon: 173.221,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZNV": {
    icao: "NZNV",
    iata: "IVC",
    name: "Invercargill Airport",
    city: "Invercargill",
    country: "NZ",
    continent: "OC",
    lat: -46.4124,
    lon: 168.313,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZOH": {
    icao: "NZOH",
    iata: "OHA",
    name: "RNZAF Base Ohakea",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -40.206,
    lon: 175.388,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZOU": {
    icao: "NZOU",
    iata: "OAM",
    name: "Oamaru Airport",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -44.97,
    lon: 171.082,
    elevation: 99,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZPM": {
    icao: "NZPM",
    iata: "PMR",
    name: "Palmerston North Airport",
    city: "Palmerston North",
    country: "NZ",
    continent: "OC",
    lat: -40.3206,
    lon: 175.617,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZPP": {
    icao: "NZPP",
    iata: "PPQ",
    name: "Paraparaumu Airport",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -40.9047,
    lon: 174.989,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZQN": {
    icao: "NZQN",
    iata: "ZQN",
    name: "Queenstown International Airport",
    city: "Queenstown",
    country: "NZ",
    continent: "OC",
    lat: -45.0211,
    lon: 168.739,
    elevation: 1171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZRO": {
    icao: "NZRO",
    iata: "ROT",
    name: "Rotorua Regional Airport",
    city: "Rotorua",
    country: "NZ",
    continent: "OC",
    lat: -38.1092,
    lon: 176.317,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZSP": {
    icao: "NZSP",
    iata: "",
    name: "Amundsen–Scott South Pole Station Airport",
    city: "Amundsen-Scott South Pole Station",
    country: "AQ",
    continent: "AN",
    lat: -90.0,
    lon: -1.0,
    elevation: 9300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZTG": {
    icao: "NZTG",
    iata: "TRG",
    name: "Tauranga Airport",
    city: "Tauranga",
    country: "NZ",
    continent: "OC",
    lat: -37.6719,
    lon: 176.196,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZTU": {
    icao: "NZTU",
    iata: "TIU",
    name: "Timaru Airport",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -44.3028,
    lon: 171.225,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZUK": {
    icao: "NZUK",
    iata: "TWZ",
    name: "Pukaki Airport",
    city: "Twitzel",
    country: "NZ",
    continent: "OC",
    lat: -44.235,
    lon: 170.118,
    elevation: 1575,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWB": {
    icao: "NZWB",
    iata: "BHE",
    name: "Woodbourne Airport",
    city: "Blenheim",
    country: "NZ",
    continent: "OC",
    lat: -41.5183,
    lon: 173.87,
    elevation: 109,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWD": {
    icao: "NZWD",
    iata: "",
    name: "Williams Field Skiway",
    city: "McMurdo Station",
    country: "AQ",
    continent: "AN",
    lat: -77.8674,
    lon: 167.057,
    elevation: 68,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWF": {
    icao: "NZWF",
    iata: "WKA",
    name: "Wanaka Airport",
    city: "Wanaka",
    country: "NZ",
    continent: "OC",
    lat: -44.723,
    lon: 169.2484,
    elevation: 1142,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWK": {
    icao: "NZWK",
    iata: "WHK",
    name: "Whakatane Airport",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -37.9206,
    lon: 176.914,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWN": {
    icao: "NZWN",
    iata: "WLG",
    name: "Wellington International Airport",
    city: "Wellington",
    country: "NZ",
    continent: "OC",
    lat: -41.3272,
    lon: 174.805,
    elevation: 41,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "NZWO": {
    icao: "NZWO",
    iata: "WIR",
    name: "Wairoa Airport",
    city: "Wairoa",
    country: "NZ",
    continent: "OC",
    lat: -39.0121,
    lon: 177.4044,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWP": {
    icao: "NZWP",
    iata: "",
    name: "RNZAF Base Auckland-Whenuapai",
    city: "",
    country: "NZ",
    continent: "OC",
    lat: -36.7878,
    lon: 174.63,
    elevation: 103,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWR": {
    icao: "NZWR",
    iata: "WRE",
    name: "Whangarei Airport",
    city: "Whangarei",
    country: "NZ",
    continent: "OC",
    lat: -35.7693,
    lon: 174.3637,
    elevation: 133,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWS": {
    icao: "NZWS",
    iata: "WSZ",
    name: "Westport Airport",
    city: "Westport",
    country: "NZ",
    continent: "OC",
    lat: -41.7371,
    lon: 171.579,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "NZWU": {
    icao: "NZWU",
    iata: "WAG",
    name: "Wanganui Airport",
    city: "Wanganui",
    country: "NZ",
    continent: "OC",
    lat: -39.9635,
    lon: 175.0244,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAHR": {
    icao: "OAHR",
    iata: "HEA",
    name: "Herat - Khwaja Abdullah Ansari International Airport",
    city: "Guzara",
    country: "AF",
    continent: "AS",
    lat: 34.21,
    lon: 62.2283,
    elevation: 3206,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAIX": {
    icao: "OAIX",
    iata: "OAI",
    name: "Bagram Airfield",
    city: "Bagram",
    country: "AF",
    continent: "AS",
    lat: 34.9461,
    lon: 69.265,
    elevation: 4895,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAJL": {
    icao: "OAJL",
    iata: "JAA",
    name: "Jalalabad Airport",
    city: "Jalalabad",
    country: "AF",
    continent: "AS",
    lat: 34.3998,
    lon: 70.4986,
    elevation: 1814,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAKB": {
    icao: "OAKB",
    iata: "KBL",
    name: "Kabul International Airport",
    city: "Kabul",
    country: "AF",
    continent: "AS",
    lat: 34.5659,
    lon: 69.2123,
    elevation: 5877,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAKN": {
    icao: "OAKN",
    iata: "KDH",
    name: "Ahmad Shah Baba International Airport / Kandahar Airfield",
    city: "Khvoshab",
    country: "AF",
    continent: "AS",
    lat: 31.5058,
    lon: 65.8478,
    elevation: 3337,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAKS": {
    icao: "OAKS",
    iata: "KHT",
    name: "Khost International Airport",
    city: "Khost",
    country: "AF",
    continent: "AS",
    lat: 33.2846,
    lon: 69.8073,
    elevation: 4204,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAMN": {
    icao: "OAMN",
    iata: "MMZ",
    name: "Maymana Zahiraddin Faryabi Airport",
    city: "Maymana",
    country: "AF",
    continent: "AS",
    lat: 35.9308,
    lon: 64.7609,
    elevation: 2743,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAMS": {
    icao: "OAMS",
    iata: "MZR",
    name: "Mazar-i-Sharif International Airport",
    city: "Mazar-i-Sharif",
    country: "AF",
    continent: "AS",
    lat: 36.7069,
    lon: 67.2097,
    elevation: 1284,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OAUZ": {
    icao: "OAUZ",
    iata: "UND",
    name: "Kunduz Airport",
    city: "Kunduz",
    country: "AF",
    continent: "AS",
    lat: 36.6651,
    lon: 68.9108,
    elevation: 1457,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OBBI": {
    icao: "OBBI",
    iata: "BAH",
    name: "Bahrain International Airport",
    city: "Manama",
    country: "BH",
    continent: "AS",
    lat: 26.2673,
    lon: 50.6376,
    elevation: 6,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OBBS": {
    icao: "OBBS",
    iata: "",
    name: "Sheik Isa Air Base",
    city: "Sitrah",
    country: "BH",
    continent: "AS",
    lat: 25.9184,
    lon: 50.5906,
    elevation: 136,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEAB": {
    icao: "OEAB",
    iata: "AHB",
    name: "Abha International Airport",
    city: "Abha",
    country: "SA",
    continent: "AS",
    lat: 18.2404,
    lon: 42.6566,
    elevation: 6858,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OEAH": {
    icao: "OEAH",
    iata: "HOF",
    name: "Al-Ahsa International Airport",
    city: "Hofuf",
    country: "SA",
    continent: "AS",
    lat: 25.2853,
    lon: 49.4852,
    elevation: 588,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEAO": {
    icao: "OEAO",
    iata: "ULH",
    name: "Majeed Bin Abdulaziz Airport",
    city: "Al Ula",
    country: "SA",
    continent: "AS",
    lat: 26.4833,
    lon: 38.1169,
    elevation: 2050,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEBA": {
    icao: "OEBA",
    iata: "ABT",
    name: "King Saud Bin Abdulaziz (Al Baha) Airport",
    city: "Al-Baha",
    country: "SA",
    continent: "AS",
    lat: 20.2985,
    lon: 41.6362,
    elevation: 5486,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEBH": {
    icao: "OEBH",
    iata: "BHH",
    name: "Bisha Airport",
    city: "Bisha",
    country: "SA",
    continent: "AS",
    lat: 19.9844,
    lon: 42.6209,
    elevation: 3887,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEDF": {
    icao: "OEDF",
    iata: "DMM",
    name: "King Fahd International Airport",
    city: "Ad Dammam",
    country: "SA",
    continent: "AS",
    lat: 26.4712,
    lon: 49.7979,
    elevation: 72,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OEDM": {
    icao: "OEDM",
    iata: "DWD",
    name: "King Salman Abdulaziz Airport",
    city: "Dawadmi",
    country: "SA",
    continent: "AS",
    lat: 24.4499,
    lon: 44.1212,
    elevation: 3026,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEDR": {
    icao: "OEDR",
    iata: "DHA",
    name: "King Abdulaziz Air Base",
    city: "Dhahran",
    country: "SA",
    continent: "AS",
    lat: 26.2654,
    lon: 50.152,
    elevation: 84,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OEGN": {
    icao: "OEGN",
    iata: "GIZ",
    name: "Jizan Regional Airport / King Abdullah bin Abdulaziz Airport",
    city: "Jizan",
    country: "SA",
    continent: "AS",
    lat: 16.9011,
    lon: 42.5858,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEGS": {
    icao: "OEGS",
    iata: "ELQ",
    name: "Gassim Airport",
    city: "Buraidah",
    country: "SA",
    continent: "AS",
    lat: 26.3028,
    lon: 43.7744,
    elevation: 2126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEGT": {
    icao: "OEGT",
    iata: "URY",
    name: "Gurayat Domestic Airport",
    city: "Gurayat",
    country: "SA",
    continent: "AS",
    lat: 31.4124,
    lon: 37.2789,
    elevation: 1672,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEHL": {
    icao: "OEHL",
    iata: "HAS",
    name: "Ha\'il Airport",
    city: "Ha\'il",
    country: "SA",
    continent: "AS",
    lat: 27.4379,
    lon: 41.6863,
    elevation: 3331,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEJB": {
    icao: "OEJB",
    iata: "",
    name: "Jubail Airport",
    city: "Jubail",
    country: "SA",
    continent: "AS",
    lat: 27.039,
    lon: 49.4051,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEJF": {
    icao: "OEJF",
    iata: "",
    name: "King Faisal Naval Base",
    city: "Jeddah",
    country: "SA",
    continent: "AS",
    lat: 21.3481,
    lon: 39.173,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEJN": {
    icao: "OEJN",
    iata: "JED",
    name: "King Abdulaziz International Airport",
    city: "Jeddah",
    country: "SA",
    continent: "AS",
    lat: 21.6796,
    lon: 39.1565,
    elevation: 48,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OEKK": {
    icao: "OEKK",
    iata: "KMC",
    name: "King Khaled Military City Airport",
    city: "King Khaled Military City",
    country: "SA",
    continent: "AS",
    lat: 27.9009,
    lon: 45.5282,
    elevation: 1352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEKM": {
    icao: "OEKM",
    iata: "KMX",
    name: "King Khalid Air Base",
    city: "Khamis Mushait",
    country: "SA",
    continent: "AS",
    lat: 18.2973,
    lon: 42.8035,
    elevation: 6778,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEMA": {
    icao: "OEMA",
    iata: "MED",
    name: "Prince Mohammad Bin Abdulaziz Airport",
    city: "Medina",
    country: "SA",
    continent: "AS",
    lat: 24.5534,
    lon: 39.7051,
    elevation: 2151,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OENG": {
    icao: "OENG",
    iata: "EAM",
    name: "Najran Domestic Airport",
    city: "Najran",
    country: "SA",
    continent: "AS",
    lat: 17.6114,
    lon: 44.4192,
    elevation: 3982,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OENN": {
    icao: "OENN",
    iata: "NUM",
    name: "Neom Bay Airport",
    city: "Sharma",
    country: "SA",
    continent: "AS",
    lat: 27.9276,
    lon: 35.2887,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEPA": {
    icao: "OEPA",
    iata: "AQI",
    name: "Al Qaisumah/Hafr Al Batin Airport",
    city: "Qaisumah",
    country: "SA",
    continent: "AS",
    lat: 28.3352,
    lon: 46.1251,
    elevation: 1174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEPS": {
    icao: "OEPS",
    iata: "AKH",
    name: "Prince Sultan Air Base",
    city: "Al Kharj",
    country: "SA",
    continent: "AS",
    lat: 24.0627,
    lon: 47.5805,
    elevation: 1651,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OERF": {
    icao: "OERF",
    iata: "RAH",
    name: "Rafha Domestic Airport",
    city: "Rafha",
    country: "SA",
    continent: "AS",
    lat: 29.6264,
    lon: 43.4906,
    elevation: 1474,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OERK": {
    icao: "OERK",
    iata: "RUH",
    name: "King Khaled International Airport",
    city: "Riyadh",
    country: "SA",
    continent: "AS",
    lat: 24.9576,
    lon: 46.6988,
    elevation: 2049,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OERM": {
    icao: "OERM",
    iata: "",
    name: "Ras Mishab Airport",
    city: "Al Mishab",
    country: "SA",
    continent: "AS",
    lat: 28.0796,
    lon: 48.611,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OERR": {
    icao: "OERR",
    iata: "RAE",
    name: "Arar Domestic Airport",
    city: "Arar",
    country: "SA",
    continent: "AS",
    lat: 30.9066,
    lon: 41.1382,
    elevation: 1813,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OERT": {
    icao: "OERT",
    iata: "",
    name: "Ras Tanura Airport",
    city: "Ras Tanura",
    country: "SA",
    continent: "AS",
    lat: 26.7231,
    lon: 50.0308,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OESH": {
    icao: "OESH",
    iata: "SHW",
    name: "Sharurah Domestic Airport",
    city: "Sharurah",
    country: "SA",
    continent: "AS",
    lat: 17.4669,
    lon: 47.1214,
    elevation: 2363,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OESK": {
    icao: "OESK",
    iata: "AJF",
    name: "Al-Jawf Domestic Airport",
    city: "Al-Jawf",
    country: "SA",
    continent: "AS",
    lat: 29.7851,
    lon: 40.1,
    elevation: 2261,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OETB": {
    icao: "OETB",
    iata: "TUU",
    name: "Tabuk Airport",
    city: "Tabuk",
    country: "SA",
    continent: "AS",
    lat: 28.3654,
    lon: 36.6189,
    elevation: 2551,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OETF": {
    icao: "OETF",
    iata: "TIF",
    name: "Ta’if Regional Airport",
    city: "Ta’if",
    country: "SA",
    continent: "AS",
    lat: 21.483,
    lon: 40.5434,
    elevation: 4848,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OETN": {
    icao: "OETN",
    iata: "",
    name: "Ras Tanajib Airport",
    city: "As Saffaniyah",
    country: "SA",
    continent: "AS",
    lat: 27.8678,
    lon: 48.7691,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OETR": {
    icao: "OETR",
    iata: "TUI",
    name: "Turaif Domestic Airport",
    city: "Turaif",
    country: "SA",
    continent: "AS",
    lat: 31.6922,
    lon: 38.7315,
    elevation: 2803,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEWD": {
    icao: "OEWD",
    iata: "WAE",
    name: "Wadi Al Dawasir Domestic Airport",
    city: "Wadi Al Dawasir",
    country: "SA",
    continent: "AS",
    lat: 20.5043,
    lon: 45.1996,
    elevation: 2062,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEWJ": {
    icao: "OEWJ",
    iata: "EJH",
    name: "Al Wajh Domestic Airport",
    city: "Al Wajh",
    country: "SA",
    continent: "AS",
    lat: 26.1986,
    lon: 36.4764,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OEYN": {
    icao: "OEYN",
    iata: "YNB",
    name: "Prince Abdul Mohsin bin Abdulaziz International Airport / Yanbu Airport",
    city: "Yanbu",
    country: "SA",
    continent: "AS",
    lat: 24.1442,
    lon: 38.0634,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAA": {
    icao: "OIAA",
    iata: "ABD",
    name: "Abadan Airport",
    city: "Abadan",
    country: "IR",
    continent: "AS",
    lat: 30.3679,
    lon: 48.2301,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAD": {
    icao: "OIAD",
    iata: "DEF",
    name: "Dezful Airport",
    city: "Dezful",
    country: "IR",
    continent: "AS",
    lat: 32.4344,
    lon: 48.3976,
    elevation: 474,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAG": {
    icao: "OIAG",
    iata: "AKW",
    name: "Aghajari Airport",
    city: "Aghajari",
    country: "IR",
    continent: "AS",
    lat: 30.7444,
    lon: 49.6772,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAH": {
    icao: "OIAH",
    iata: "GCH",
    name: "Gachsaran Airport",
    city: "Gachsaran",
    country: "IR",
    continent: "AS",
    lat: 30.3339,
    lon: 50.8338,
    elevation: 2414,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAI": {
    icao: "OIAI",
    iata: "QMJ",
    name: "Shahid Asiyaee Airport",
    city: "Masjed Soleyman",
    country: "IR",
    continent: "AS",
    lat: 32.0017,
    lon: 49.2686,
    elevation: 1206,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAM": {
    icao: "OIAM",
    iata: "MRX",
    name: "Mahshahr Airport",
    city: "Mahshahr",
    country: "IR",
    continent: "AS",
    lat: 30.5562,
    lon: 49.1519,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIAW": {
    icao: "OIAW",
    iata: "AWZ",
    name: "Lieutenant General Qasem Soleimani International Airport",
    city: "Ahvaz",
    country: "IR",
    continent: "AS",
    lat: 31.3374,
    lon: 48.762,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBA": {
    icao: "OIBA",
    iata: "AEU",
    name: "Abu Musa Island Airport",
    city: "Abu Musa",
    country: "IR",
    continent: "AS",
    lat: 25.8757,
    lon: 55.033,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBB": {
    icao: "OIBB",
    iata: "BUZ",
    name: "Bushehr Airport",
    city: "Bushehr",
    country: "IR",
    continent: "AS",
    lat: 28.9448,
    lon: 50.8346,
    elevation: 68,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBJ": {
    icao: "OIBJ",
    iata: "KNR",
    name: "Jam Airport",
    city: "Jam",
    country: "IR",
    continent: "AS",
    lat: 27.8205,
    lon: 52.3522,
    elevation: 2173,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBK": {
    icao: "OIBK",
    iata: "KIH",
    name: "Kish International Airport",
    city: "Kish Island",
    country: "IR",
    continent: "AS",
    lat: 26.5262,
    lon: 53.9802,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBL": {
    icao: "OIBL",
    iata: "BDH",
    name: "Bandar Lengeh International Airport",
    city: "Bandar Lengeh",
    country: "IR",
    continent: "AS",
    lat: 26.5323,
    lon: 54.8248,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBP": {
    icao: "OIBP",
    iata: "PGU",
    name: "Persian Gulf International Airport",
    city: "Khiyaroo",
    country: "IR",
    continent: "AS",
    lat: 27.3796,
    lon: 52.7377,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBQ": {
    icao: "OIBQ",
    iata: "KHK",
    name: "Khark Airport",
    city: "Khark",
    country: "IR",
    continent: "AS",
    lat: 29.2605,
    lon: 50.3222,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBS": {
    icao: "OIBS",
    iata: "SXI",
    name: "Siri Airport",
    city: "Siri",
    country: "IR",
    continent: "AS",
    lat: 25.9089,
    lon: 54.5394,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIBV": {
    icao: "OIBV",
    iata: "LVP",
    name: "Lavan Airport",
    city: "Lavan Airport",
    country: "IR",
    continent: "AS",
    lat: 26.8107,
    lon: 53.3543,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OICC": {
    icao: "OICC",
    iata: "KSH",
    name: "Shahid Ashrafi Esfahani Airport",
    city: "Kermanshah",
    country: "IR",
    continent: "AS",
    lat: 34.3459,
    lon: 47.1581,
    elevation: 4307,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OICI": {
    icao: "OICI",
    iata: "IIL",
    name: "Ilam Airport",
    city: "Ilam",
    country: "IR",
    continent: "AS",
    lat: 33.5866,
    lon: 46.4048,
    elevation: 4404,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OICK": {
    icao: "OICK",
    iata: "KHD",
    name: "Khoram Abad Airport",
    city: "",
    country: "IR",
    continent: "AS",
    lat: 33.4354,
    lon: 48.2829,
    elevation: 3782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OICS": {
    icao: "OICS",
    iata: "SDG",
    name: "Sanandaj Airport",
    city: "",
    country: "IR",
    continent: "AS",
    lat: 35.2459,
    lon: 47.0092,
    elevation: 4522,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIFK": {
    icao: "OIFK",
    iata: "KKS",
    name: "Kashan Airport",
    city: "Kashan",
    country: "IR",
    continent: "AS",
    lat: 33.8953,
    lon: 51.577,
    elevation: 3465,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIFM": {
    icao: "OIFM",
    iata: "IFN",
    name: "Isfahan Shahid Beheshti International Airport",
    city: "Isfahan",
    country: "IR",
    continent: "AS",
    lat: 32.7508,
    lon: 51.8615,
    elevation: 5059,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIFP": {
    icao: "OIFP",
    iata: "",
    name: "Badr Air Base",
    city: "Esfahan",
    country: "IR",
    continent: "AS",
    lat: 32.6211,
    lon: 51.697,
    elevation: 5242,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIFS": {
    icao: "OIFS",
    iata: "CQD",
    name: "Shahrekord Airport",
    city: "Shahrekord",
    country: "IR",
    continent: "AS",
    lat: 32.2972,
    lon: 50.8422,
    elevation: 6723,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIGG": {
    icao: "OIGG",
    iata: "RAS",
    name: "Sardar-e-Jangal Airport",
    city: "Rasht",
    country: "IR",
    continent: "AS",
    lat: 37.3233,
    lon: 49.6178,
    elevation: -40,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIHH": {
    icao: "OIHH",
    iata: "HDM",
    name: "Hamadan Airport",
    city: "Hamadan",
    country: "IR",
    continent: "AS",
    lat: 34.8692,
    lon: 48.5525,
    elevation: 5755,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIHS": {
    icao: "OIHS",
    iata: "NUJ",
    name: "Nojeh Air Base",
    city: "Amirabad",
    country: "IR",
    continent: "AS",
    lat: 35.2116,
    lon: 48.6534,
    elevation: 5609,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIIE": {
    icao: "OIIE",
    iata: "IKA",
    name: "Imam Khomeini International Airport",
    city: "Tehran",
    country: "IR",
    continent: "AS",
    lat: 35.4161,
    lon: 51.1522,
    elevation: 3305,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OIII": {
    icao: "OIII",
    iata: "THR",
    name: "Mehrabad International Airport",
    city: "Tehran",
    country: "IR",
    continent: "AS",
    lat: 35.6892,
    lon: 51.3134,
    elevation: 3962,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OIIK": {
    icao: "OIIK",
    iata: "GZW",
    name: "Qazvin Airport",
    city: "Qazvin",
    country: "IR",
    continent: "AS",
    lat: 36.2401,
    lon: 50.0471,
    elevation: 4184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIIM": {
    icao: "OIIM",
    iata: "",
    name: "Naja Airport",
    city: "Karaj",
    country: "IR",
    continent: "AS",
    lat: 35.7763,
    lon: 50.881,
    elevation: 4040,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIIP": {
    icao: "OIIP",
    iata: "PYK",
    name: "Payam Karaj International Airport",
    city: "Karaj",
    country: "IR",
    continent: "AS",
    lat: 35.7761,
    lon: 50.8267,
    elevation: 4170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIKB": {
    icao: "OIKB",
    iata: "BND",
    name: "Bandar Abbas International Airport",
    city: "Bandar Abbas",
    country: "IR",
    continent: "AS",
    lat: 27.2183,
    lon: 56.3778,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIKJ": {
    icao: "OIKJ",
    iata: "JYR",
    name: "Jiroft Airport",
    city: "Jiroft",
    country: "IR",
    continent: "AS",
    lat: 28.7235,
    lon: 57.675,
    elevation: 2663,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIKK": {
    icao: "OIKK",
    iata: "KER",
    name: "Ayatollah Hashemi Rafsanjani International Airport",
    city: "Kerman",
    country: "IR",
    continent: "AS",
    lat: 30.2713,
    lon: 56.9497,
    elevation: 5741,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIKM": {
    icao: "OIKM",
    iata: "BXR",
    name: "Bam Airport",
    city: "Bam",
    country: "IR",
    continent: "AS",
    lat: 29.0842,
    lon: 58.45,
    elevation: 3231,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIKR": {
    icao: "OIKR",
    iata: "RJN",
    name: "Rafsanjan Airport",
    city: "Rafsanjan",
    country: "IR",
    continent: "AS",
    lat: 30.2983,
    lon: 56.049,
    elevation: 5298,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIKY": {
    icao: "OIKY",
    iata: "SYJ",
    name: "Sirjan Airport",
    city: "Sirjan",
    country: "IR",
    continent: "AS",
    lat: 29.5509,
    lon: 55.6727,
    elevation: 5846,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIMB": {
    icao: "OIMB",
    iata: "XBJ",
    name: "Birjand International Airport",
    city: "Birjand",
    country: "IR",
    continent: "AS",
    lat: 32.8965,
    lon: 59.2813,
    elevation: 4952,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIMC": {
    icao: "OIMC",
    iata: "CKT",
    name: "Sarakhs Airport",
    city: "Sarakhs",
    country: "IR",
    continent: "AS",
    lat: 36.5012,
    lon: 61.0649,
    elevation: 945,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIMM": {
    icao: "OIMM",
    iata: "MHD",
    name: "Mashhad International Airport",
    city: "Mashhad",
    country: "IR",
    continent: "AS",
    lat: 36.2352,
    lon: 59.641,
    elevation: 3263,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OIMN": {
    icao: "OIMN",
    iata: "BJB",
    name: "Bojnord Airport",
    city: "Bojnord",
    country: "IR",
    continent: "AS",
    lat: 37.493,
    lon: 57.3082,
    elevation: 3499,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIMS": {
    icao: "OIMS",
    iata: "AFZ",
    name: "Sabzevar National Airport",
    city: "Sabzevar",
    country: "IR",
    continent: "AS",
    lat: 36.1681,
    lon: 57.5952,
    elevation: 3010,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIMT": {
    icao: "OIMT",
    iata: "TCX",
    name: "Tabas Airport",
    city: "Tabas",
    country: "IR",
    continent: "AS",
    lat: 33.6678,
    lon: 56.8927,
    elevation: 2312,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OING": {
    icao: "OING",
    iata: "GBT",
    name: "Gorgan Airport",
    city: "Gorgan",
    country: "IR",
    continent: "AS",
    lat: 36.9094,
    lon: 54.4013,
    elevation: -24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OINN": {
    icao: "OINN",
    iata: "NSH",
    name: "Nowshahr Airport",
    city: "Nowshahr",
    country: "IR",
    continent: "AS",
    lat: 36.6643,
    lon: 51.4627,
    elevation: -61,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OINR": {
    icao: "OINR",
    iata: "RZR",
    name: "Ramsar Airport",
    city: "Ramsar",
    country: "IR",
    continent: "AS",
    lat: 36.907,
    lon: 50.6873,
    elevation: -70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OINZ": {
    icao: "OINZ",
    iata: "SRY",
    name: "Sari Dasht-e Naz International Airport",
    city: "Sari",
    country: "IR",
    continent: "AS",
    lat: 36.6444,
    lon: 53.1888,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OISF": {
    icao: "OISF",
    iata: "FAZ",
    name: "Fasa Airport",
    city: "Fasa",
    country: "IR",
    continent: "AS",
    lat: 28.8918,
    lon: 53.7233,
    elevation: 4261,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OISL": {
    icao: "OISL",
    iata: "LRR",
    name: "Lar Airport",
    city: "Lar",
    country: "IR",
    continent: "AS",
    lat: 27.6747,
    lon: 54.3833,
    elevation: 2641,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OISR": {
    icao: "OISR",
    iata: "LFM",
    name: "Lamerd Airport",
    city: "Lamerd",
    country: "IR",
    continent: "AS",
    lat: 27.3727,
    lon: 53.1888,
    elevation: 1337,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OISS": {
    icao: "OISS",
    iata: "SYZ",
    name: "Shiraz Shahid Dastghaib International Airport",
    city: "Shiraz",
    country: "IR",
    continent: "AS",
    lat: 29.5392,
    lon: 52.5898,
    elevation: 4927,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OISY": {
    icao: "OISY",
    iata: "YES",
    name: "Yasuj Airport",
    city: "Yasuj",
    country: "IR",
    continent: "AS",
    lat: 30.7022,
    lon: 51.543,
    elevation: 5939,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OITL": {
    icao: "OITL",
    iata: "ADU",
    name: "Ardabil Airport",
    city: "Ardabil",
    country: "IR",
    continent: "AS",
    lat: 38.3257,
    lon: 48.4244,
    elevation: 4315,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OITR": {
    icao: "OITR",
    iata: "OMH",
    name: "Urmia Airport",
    city: "Urmia",
    country: "IR",
    continent: "AS",
    lat: 37.6681,
    lon: 45.0687,
    elevation: 4343,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OITT": {
    icao: "OITT",
    iata: "TBZ",
    name: "Tabriz International Airport",
    city: "Tabriz",
    country: "IR",
    continent: "AS",
    lat: 38.1339,
    lon: 46.235,
    elevation: 4459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OITU": {
    icao: "OITU",
    iata: "IMQ",
    name: "Maku National Airport",
    city: "Showt",
    country: "IR",
    continent: "AS",
    lat: 39.1913,
    lon: 44.9285,
    elevation: 3136,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OITZ": {
    icao: "OITZ",
    iata: "JWN",
    name: "Zanjan Airport",
    city: "Zanjan",
    country: "IR",
    continent: "AS",
    lat: 36.7737,
    lon: 48.3594,
    elevation: 5382,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIYY": {
    icao: "OIYY",
    iata: "AZD",
    name: "Shahid Sadooghi Airport",
    city: "Yazd",
    country: "IR",
    continent: "AS",
    lat: 31.9049,
    lon: 54.2765,
    elevation: 4054,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIZB": {
    icao: "OIZB",
    iata: "ACZ",
    name: "Zabol Airport",
    city: "Zabol",
    country: "IR",
    continent: "AS",
    lat: 31.0983,
    lon: 61.5439,
    elevation: 1628,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIZC": {
    icao: "OIZC",
    iata: "ZBR",
    name: "Chabahar Konarak International Airport",
    city: "Konarak",
    country: "IR",
    continent: "AS",
    lat: 25.4432,
    lon: 60.3822,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIZH": {
    icao: "OIZH",
    iata: "ZAH",
    name: "Zahedan International Airport",
    city: "Zahedan",
    country: "IR",
    continent: "AS",
    lat: 29.4757,
    lon: 60.9062,
    elevation: 4564,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OIZI": {
    icao: "OIZI",
    iata: "IHR",
    name: "Iranshahr Airport",
    city: "Iranshahr",
    country: "IR",
    continent: "AS",
    lat: 27.2361,
    lon: 60.72,
    elevation: 2040,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OJAI": {
    icao: "OJAI",
    iata: "AMM",
    name: "Queen Alia International Airport",
    city: "Amman",
    country: "JO",
    continent: "AS",
    lat: 31.7226,
    lon: 35.9932,
    elevation: 2395,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OJAM": {
    icao: "OJAM",
    iata: "ADJ",
    name: "Amman Civil (Marka International) Airport",
    city: "Amman",
    country: "JO",
    continent: "AS",
    lat: 31.9727,
    lon: 35.9916,
    elevation: 2555,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OJAQ": {
    icao: "OJAQ",
    iata: "AQJ",
    name: "Aqaba King Hussein International Airport",
    city: "Aqaba",
    country: "JO",
    continent: "AS",
    lat: 29.6116,
    lon: 35.0181,
    elevation: 175,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OJMS": {
    icao: "OJMS",
    iata: "",
    name: "Muwaffaq Salti Air Base",
    city: "Al Azraq",
    country: "JO",
    continent: "AS",
    lat: 31.8256,
    lon: 36.782,
    elevation: 1706,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OKAJ": {
    icao: "OKAJ",
    iata: "XIJ",
    name: "Ahmed Al Jaber Air Base",
    city: "Ahmed Al Jaber AB",
    country: "KW",
    continent: "AS",
    lat: 28.9348,
    lon: 47.7919,
    elevation: 409,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OKAS": {
    icao: "OKAS",
    iata: "",
    name: "Ali Al Salem Air Base",
    city: "Al Damaikhi",
    country: "KW",
    continent: "AS",
    lat: 29.3446,
    lon: 47.5112,
    elevation: 472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OKKK": {
    icao: "OKKK",
    iata: "KWI",
    name: "Kuwait International Airport",
    city: "Kuwait City",
    country: "KW",
    continent: "AS",
    lat: 29.2266,
    lon: 47.9689,
    elevation: 206,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OLBA": {
    icao: "OLBA",
    iata: "BEY",
    name: "Beirut Rafic Hariri International Airport",
    city: "Beirut",
    country: "LB",
    continent: "AS",
    lat: 33.8209,
    lon: 35.4884,
    elevation: 87,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OLKA": {
    icao: "OLKA",
    iata: "KYE",
    name: "Rene Mouawad Air Base / Kleyate Airport",
    city: "Tripoli",
    country: "LB",
    continent: "AS",
    lat: 34.5893,
    lon: 36.0113,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OLRA": {
    icao: "OLRA",
    iata: "",
    name: "Rayak Air Base",
    city: "Rayak",
    country: "LB",
    continent: "AS",
    lat: 33.8508,
    lon: 35.9877,
    elevation: 3018,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMAA": {
    icao: "OMAA",
    iata: "AUH",
    name: "Zayed International Airport",
    city: "Abu Dhabi",
    country: "AE",
    continent: "AS",
    lat: 24.4438,
    lon: 54.6517,
    elevation: 88,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OMAD": {
    icao: "OMAD",
    iata: "AZI",
    name: "Al Bateen Executive Airport",
    city: "Abu Dhabi",
    country: "AE",
    continent: "AS",
    lat: 24.4283,
    lon: 54.4581,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMAL": {
    icao: "OMAL",
    iata: "AAN",
    name: "Al Ain International Airport",
    city: "Al Ain",
    country: "AE",
    continent: "AS",
    lat: 24.2617,
    lon: 55.6092,
    elevation: 869,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMAM": {
    icao: "OMAM",
    iata: "DHF",
    name: "Al Dhafra Air Base",
    city: "",
    country: "AE",
    continent: "AS",
    lat: 24.2482,
    lon: 54.5477,
    elevation: 77,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMBY": {
    icao: "OMBY",
    iata: "XSB",
    name: "Sir Bani Yas Airport",
    city: "Sir Bani Yas",
    country: "AE",
    continent: "AS",
    lat: 24.2836,
    lon: 52.5803,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMDB": {
    icao: "OMDB",
    iata: "DXB",
    name: "Dubai International Airport",
    city: "Dubai",
    country: "AE",
    continent: "AS",
    lat: 25.2528,
    lon: 55.3644,
    elevation: 62,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "OMDM": {
    icao: "OMDM",
    iata: "NHD",
    name: "Al Minhad Air Base",
    city: "Dubai",
    country: "AE",
    continent: "AS",
    lat: 25.0268,
    lon: 55.3662,
    elevation: 165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMDW": {
    icao: "OMDW",
    iata: "DWC",
    name: "Al Maktoum International Airport",
    city: "Jebel Ali",
    country: "AE",
    continent: "AS",
    lat: 24.8964,
    lon: 55.1614,
    elevation: 114,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OMFJ": {
    icao: "OMFJ",
    iata: "FJR",
    name: "Fujairah International Airport",
    city: "Fujairah",
    country: "AE",
    continent: "AS",
    lat: 25.1122,
    lon: 56.324,
    elevation: 152,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMRK": {
    icao: "OMRK",
    iata: "RKT",
    name: "Ras Al Khaimah International Airport",
    city: "Ras Al Khaimah",
    country: "AE",
    continent: "AS",
    lat: 25.6135,
    lon: 55.9388,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OMSJ": {
    icao: "OMSJ",
    iata: "SHJ",
    name: "Sharjah International Airport",
    city: "Sharjah",
    country: "AE",
    continent: "AS",
    lat: 25.3286,
    lon: 55.5172,
    elevation: 111,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OOKB": {
    icao: "OOKB",
    iata: "KHS",
    name: "Khasab Airport",
    city: "Khasab",
    country: "OM",
    continent: "AS",
    lat: 26.171,
    lon: 56.2406,
    elevation: 100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OOMA": {
    icao: "OOMA",
    iata: "MSH",
    name: "RAFO Masirah",
    city: "Masirah",
    country: "OM",
    continent: "AS",
    lat: 20.6754,
    lon: 58.8905,
    elevation: 64,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OOMS": {
    icao: "OOMS",
    iata: "MCT",
    name: "Muscat International Airport",
    city: "Muscat",
    country: "OM",
    continent: "AS",
    lat: 23.5933,
    lon: 58.2844,
    elevation: 48,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OOSA": {
    icao: "OOSA",
    iata: "SLL",
    name: "Salalah Airport",
    city: "Salalah",
    country: "OM",
    continent: "AS",
    lat: 17.0387,
    lon: 54.0913,
    elevation: 73,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OOTH": {
    icao: "OOTH",
    iata: "TTH",
    name: "Thumrait Air Base",
    city: "Thumrait",
    country: "OM",
    continent: "AS",
    lat: 17.666,
    lon: 54.0246,
    elevation: 1570,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OP12": {
    icao: "OP12",
    iata: "",
    name: "Shamsi Airfield",
    city: "Washuk",
    country: "PK",
    continent: "AS",
    lat: 27.8465,
    lon: 65.16,
    elevation: 2524,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPBW": {
    icao: "OPBW",
    iata: "BHV",
    name: "Bahawalpur Airport",
    city: "Bahawalpur",
    country: "PK",
    continent: "AS",
    lat: 29.3481,
    lon: 71.718,
    elevation: 392,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPCH": {
    icao: "OPCH",
    iata: "CJL",
    name: "Chitral Airport",
    city: "Chitral",
    country: "PK",
    continent: "AS",
    lat: 35.8862,
    lon: 71.7999,
    elevation: 4920,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPDG": {
    icao: "OPDG",
    iata: "DEA",
    name: "Dera Ghazi Khan Airport",
    city: "Dera Ghazi Khan",
    country: "PK",
    continent: "AS",
    lat: 29.961,
    lon: 70.4859,
    elevation: 492,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPDI": {
    icao: "OPDI",
    iata: "DSK",
    name: "Dera Ismael Khan Airport [IN-ACTIVE]",
    city: "Dera Ismael Khan",
    country: "PK",
    continent: "AS",
    lat: 31.9094,
    lon: 70.8966,
    elevation: 594,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPFA": {
    icao: "OPFA",
    iata: "LYP",
    name: "Faisalabad International Airport",
    city: "Faisalabad",
    country: "PK",
    continent: "AS",
    lat: 31.365,
    lon: 72.9948,
    elevation: 591,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPGD": {
    icao: "OPGD",
    iata: "GWD",
    name: "New Gwadar International Airport",
    city: "Gurandani",
    country: "PK",
    continent: "AS",
    lat: 25.2967,
    lon: 62.4988,
    elevation: 61,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPGT": {
    icao: "OPGT",
    iata: "GIL",
    name: "Gilgit Airport",
    city: "Gilgit",
    country: "PK",
    continent: "AS",
    lat: 35.9188,
    lon: 74.3336,
    elevation: 4796,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPGW": {
    icao: "OPGW",
    iata: "",
    name: "Gwadar International Airport",
    city: "Gwadar",
    country: "PK",
    continent: "AS",
    lat: 25.2324,
    lon: 62.3277,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPIS": {
    icao: "OPIS",
    iata: "ISB",
    name: "Islamabad International Airport",
    city: "Attock",
    country: "PK",
    continent: "AS",
    lat: 33.549,
    lon: 72.8257,
    elevation: 1761,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OPJA": {
    icao: "OPJA",
    iata: "JAG",
    name: "Shahbaz Air Base",
    city: "Jacobabad",
    country: "PK",
    continent: "AS",
    lat: 28.2842,
    lon: 68.4497,
    elevation: 185,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPKC": {
    icao: "OPKC",
    iata: "KHI",
    name: "Jinnah International Airport",
    city: "Karachi",
    country: "PK",
    continent: "AS",
    lat: 24.9065,
    lon: 67.1608,
    elevation: 100,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OPLA": {
    icao: "OPLA",
    iata: "LHE",
    name: "Allama Iqbal International Airport",
    city: "Lahore",
    country: "PK",
    continent: "AS",
    lat: 31.5216,
    lon: 74.4036,
    elevation: 712,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OPMA": {
    icao: "OPMA",
    iata: "XJM",
    name: "Mangla Airport",
    city: "Mangla",
    country: "PK",
    continent: "AS",
    lat: 33.0501,
    lon: 73.6384,
    elevation: 902,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPMF": {
    icao: "OPMF",
    iata: "MFG",
    name: "Muzaffarabad Airport",
    city: "Muzaffarabad",
    country: "PK",
    continent: "AS",
    lat: 34.339,
    lon: 73.5086,
    elevation: 2691,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPMI": {
    icao: "OPMI",
    iata: "MWD",
    name: "Mianwali Air Base",
    city: "Mianwali",
    country: "PK",
    continent: "AS",
    lat: 32.5631,
    lon: 71.5707,
    elevation: 690,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPMJ": {
    icao: "OPMJ",
    iata: "MJD",
    name: "Moenjodaro Airport",
    city: "Moenjodaro",
    country: "PK",
    continent: "AS",
    lat: 27.3352,
    lon: 68.1431,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPMR": {
    icao: "OPMR",
    iata: "",
    name: "Masroor Air Base",
    city: "Karachi",
    country: "PK",
    continent: "AS",
    lat: 24.8936,
    lon: 66.9388,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPMS": {
    icao: "OPMS",
    iata: "ATG",
    name: "Minhas Air Base",
    city: "Kamra",
    country: "PK",
    continent: "AS",
    lat: 33.8691,
    lon: 72.4009,
    elevation: 1023,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPMT": {
    icao: "OPMT",
    iata: "MUX",
    name: "Multan International Airport",
    city: "Multan",
    country: "PK",
    continent: "AS",
    lat: 30.2032,
    lon: 71.4191,
    elevation: 403,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPNH": {
    icao: "OPNH",
    iata: "WNS",
    name: "Shaheed Benazirabad Airport",
    city: "Nawabashah",
    country: "PK",
    continent: "AS",
    lat: 26.2194,
    lon: 68.3901,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPPG": {
    icao: "OPPG",
    iata: "PJG",
    name: "Panjgur Airport",
    city: "Panjgur",
    country: "PK",
    continent: "AS",
    lat: 26.9545,
    lon: 64.1325,
    elevation: 3289,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPPI": {
    icao: "OPPI",
    iata: "PSI",
    name: "Pasni Airport",
    city: "Pasni",
    country: "PK",
    continent: "AS",
    lat: 25.2905,
    lon: 63.3451,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPPS": {
    icao: "OPPS",
    iata: "PEW",
    name: "Peshawar International Airport",
    city: "Peshawar",
    country: "PK",
    continent: "AS",
    lat: 33.9939,
    lon: 71.5146,
    elevation: 1158,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPQT": {
    icao: "OPQT",
    iata: "UET",
    name: "Quetta International Airport",
    city: "Quetta",
    country: "PK",
    continent: "AS",
    lat: 30.2514,
    lon: 66.9378,
    elevation: 5267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPRK": {
    icao: "OPRK",
    iata: "RYK",
    name: "Shaikh Zaid Airport",
    city: "Rahim Yar Khan",
    country: "PK",
    continent: "AS",
    lat: 28.3839,
    lon: 70.2796,
    elevation: 271,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPRQ": {
    icao: "OPRQ",
    iata: "",
    name: "Rafiqui Air Base",
    city: "Shorkot",
    country: "PK",
    continent: "AS",
    lat: 30.7581,
    lon: 72.2825,
    elevation: 492,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPRS": {
    icao: "OPRS",
    iata: "",
    name: "Risalpur Air Base",
    city: "Risalpur",
    country: "PK",
    continent: "AS",
    lat: 34.0811,
    lon: 71.9726,
    elevation: 1050,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPRT": {
    icao: "OPRT",
    iata: "RAZ",
    name: "Rawalakot Airport",
    city: "Rawalakot",
    country: "PK",
    continent: "AS",
    lat: 33.8497,
    lon: 73.7981,
    elevation: 5479,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSD": {
    icao: "OPSD",
    iata: "KDU",
    name: "Skardu Airport",
    city: "Skardu",
    country: "PK",
    continent: "AS",
    lat: 35.3355,
    lon: 75.536,
    elevation: 7316,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSF": {
    icao: "OPSF",
    iata: "",
    name: "Faisal Air Base",
    city: "Karachi",
    country: "PK",
    continent: "AS",
    lat: 24.8742,
    lon: 67.1185,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSK": {
    icao: "OPSK",
    iata: "SKZ",
    name: "Sukkur Airport",
    city: "Mirpur Khas",
    country: "PK",
    continent: "AS",
    lat: 27.722,
    lon: 68.7917,
    elevation: 196,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSN": {
    icao: "OPSN",
    iata: "SYW",
    name: "Sehwan Sharif Airport",
    city: "Sehwan Sharif",
    country: "PK",
    continent: "AS",
    lat: 26.4731,
    lon: 67.7172,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSR": {
    icao: "OPSR",
    iata: "SGI",
    name: "Mushaf Air Base",
    city: "Sargodha",
    country: "PK",
    continent: "AS",
    lat: 32.0486,
    lon: 72.665,
    elevation: 614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSS": {
    icao: "OPSS",
    iata: "SDT",
    name: "Saidu Sharif Airport",
    city: "Saidu Sharif",
    country: "PK",
    continent: "AS",
    lat: 34.8136,
    lon: 72.3528,
    elevation: 3183,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPST": {
    icao: "OPST",
    iata: "SKT",
    name: "Sialkot International Airport",
    city: "Sialkot",
    country: "PK",
    continent: "AS",
    lat: 32.5356,
    lon: 74.3639,
    elevation: 837,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPSU": {
    icao: "OPSU",
    iata: "SUL",
    name: "Sui Airport",
    city: "Sui",
    country: "PK",
    continent: "AS",
    lat: 28.6451,
    lon: 69.1769,
    elevation: 763,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPTU": {
    icao: "OPTU",
    iata: "TUK",
    name: "Turbat International Airport",
    city: "Turbat",
    country: "PK",
    continent: "AS",
    lat: 25.9864,
    lon: 63.0302,
    elevation: 498,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OPZB": {
    icao: "OPZB",
    iata: "PZH",
    name: "Zhob Airport",
    city: "Fort Sandeman",
    country: "PK",
    continent: "AS",
    lat: 31.3584,
    lon: 69.4636,
    elevation: 4728,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORAA": {
    icao: "ORAA",
    iata: "IQA",
    name: "Al Asad Air Base",
    city: "Hīt",
    country: "IQ",
    continent: "AS",
    lat: 33.7856,
    lon: 42.4412,
    elevation: 618,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORAT": {
    icao: "ORAT",
    iata: "TQD",
    name: "Al Taqaddum Air Base",
    city: "Al Habbaniyah",
    country: "IQ",
    continent: "AS",
    lat: 33.3381,
    lon: 43.5971,
    elevation: 275,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORBD": {
    icao: "ORBD",
    iata: "",
    name: "Balad Southeast Airport / Joint Base Balad",
    city: "Al Bakr",
    country: "IQ",
    continent: "AS",
    lat: 33.9402,
    lon: 44.3616,
    elevation: 161,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORBI": {
    icao: "ORBI",
    iata: "BGW",
    name: "Baghdad International Airport / New Al Muthana Air Base",
    city: "Baghdad",
    country: "IQ",
    continent: "AS",
    lat: 33.2625,
    lon: 44.2346,
    elevation: 114,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ORBM": {
    icao: "ORBM",
    iata: "OSM",
    name: "Mosul International Airport",
    city: "Mosul",
    country: "IQ",
    continent: "AS",
    lat: 36.3058,
    lon: 43.1474,
    elevation: 719,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORER": {
    icao: "ORER",
    iata: "EBL",
    name: "Erbil International Airport",
    city: "Arbil",
    country: "IQ",
    continent: "AS",
    lat: 36.2376,
    lon: 43.9632,
    elevation: 1341,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORKK": {
    icao: "ORKK",
    iata: "KIK",
    name: "Kirkuk Air Base",
    city: "Kirkuk",
    country: "IQ",
    continent: "AS",
    lat: 35.4695,
    lon: 44.3489,
    elevation: 1061,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORMM": {
    icao: "ORMM",
    iata: "BSR",
    name: "Basra International Airport",
    city: "Basra",
    country: "IQ",
    continent: "AS",
    lat: 30.5491,
    lon: 47.6621,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORNI": {
    icao: "ORNI",
    iata: "NJF",
    name: "Al Najaf International Airport",
    city: "Najaf",
    country: "IQ",
    continent: "AS",
    lat: 31.9899,
    lon: 44.4043,
    elevation: 103,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORQW": {
    icao: "ORQW",
    iata: "RQW",
    name: "Qayyarah West Airport",
    city: "Qayyarah",
    country: "IQ",
    continent: "AS",
    lat: 35.7672,
    lon: 43.1251,
    elevation: 749,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORSH": {
    icao: "ORSH",
    iata: "",
    name: "Al Sahra Army Air Field",
    city: "Tikrit",
    country: "IQ",
    continent: "AS",
    lat: 34.6732,
    lon: 43.543,
    elevation: 451,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORSU": {
    icao: "ORSU",
    iata: "ISU",
    name: "Sulaymaniyah International Airport",
    city: "Sulaymaniyah",
    country: "IQ",
    continent: "AS",
    lat: 35.5617,
    lon: 45.3167,
    elevation: 2494,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORTF": {
    icao: "ORTF",
    iata: "",
    name: "Tall Afar Army Air Field",
    city: "Tall Afar",
    country: "IQ",
    continent: "AS",
    lat: 36.2831,
    lon: 42.403,
    elevation: 996,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORTI": {
    icao: "ORTI",
    iata: "",
    name: "Al Taji Army Air Field",
    city: "Taji",
    country: "IQ",
    continent: "AS",
    lat: 33.5239,
    lon: 44.2567,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORTL": {
    icao: "ORTL",
    iata: "XNH",
    name: "Ali Air Base",
    city: "Nasiriyah",
    country: "IQ",
    continent: "AS",
    lat: 30.9358,
    lon: 46.0901,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ORUB": {
    icao: "ORUB",
    iata: "",
    name: "Ubaydah Bin Al Jarrah Airport",
    city: "Al Kut",
    country: "IQ",
    continent: "AS",
    lat: 32.482,
    lon: 45.7571,
    elevation: 68,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OS57": {
    icao: "OS57",
    iata: "",
    name: "Abu ad Duhur Air Base",
    city: "Abu ad Duhur",
    country: "SY",
    continent: "AS",
    lat: 35.7322,
    lon: 37.1042,
    elevation: 846,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OS64": {
    icao: "OS64",
    iata: "",
    name: "An Nasiriyah Air Base",
    city: "",
    country: "SY",
    continent: "AS",
    lat: 33.919,
    lon: 36.8666,
    elevation: 2727,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OS69": {
    icao: "OS69",
    iata: "",
    name: "Khalkhalah Air Base",
    city: "Buraq",
    country: "SY",
    continent: "AS",
    lat: 33.0773,
    lon: 36.5582,
    elevation: 2310,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OS70": {
    icao: "OS70",
    iata: "",
    name: "Al Qusayr Air Base",
    city: "Al-Qusayr",
    country: "SY",
    continent: "AS",
    lat: 34.5691,
    lon: 36.5728,
    elevation: 1768,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OSAP": {
    icao: "OSAP",
    iata: "ALP",
    name: "Aleppo International Airport",
    city: "Aleppo",
    country: "SY",
    continent: "AS",
    lat: 36.1807,
    lon: 37.2244,
    elevation: 1276,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OSDI": {
    icao: "OSDI",
    iata: "DAM",
    name: "Damascus International Airport",
    city: "Damascus",
    country: "SY",
    continent: "AS",
    lat: 33.4115,
    lon: 36.5156,
    elevation: 2020,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "OSDZ": {
    icao: "OSDZ",
    iata: "DEZ",
    name: "Deir ez-Zor Airport",
    city: "Deir ez-Zor",
    country: "SY",
    continent: "AS",
    lat: 35.2854,
    lon: 40.176,
    elevation: 700,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OSKL": {
    icao: "OSKL",
    iata: "KAC",
    name: "Qamishli Airport",
    city: "Qamishly",
    country: "SY",
    continent: "AS",
    lat: 37.0206,
    lon: 41.1914,
    elevation: 1480,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OSLK": {
    icao: "OSLK",
    iata: "LTK",
    name: "Hmeimim Air Base",
    city: "Latakia",
    country: "SY",
    continent: "AS",
    lat: 35.4011,
    lon: 35.9487,
    elevation: 157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OSPR": {
    icao: "OSPR",
    iata: "PMS",
    name: "Palmyra Airport",
    city: "Tadmur",
    country: "SY",
    continent: "AS",
    lat: 34.5574,
    lon: 38.3169,
    elevation: 1322,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OTBD": {
    icao: "OTBD",
    iata: "DIA",
    name: "Doha International Airport",
    city: "Doha",
    country: "QA",
    continent: "AS",
    lat: 25.2611,
    lon: 51.5651,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OTBH": {
    icao: "OTBH",
    iata: "XJD",
    name: "Al Udeid Air Base",
    city: "Ar Rayyan",
    country: "QA",
    continent: "AS",
    lat: 25.1173,
    lon: 51.315,
    elevation: 130,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OTHH": {
    icao: "OTHH",
    iata: "DOH",
    name: "Hamad International Airport",
    city: "Doha",
    country: "QA",
    continent: "AS",
    lat: 25.2731,
    lon: 51.6081,
    elevation: 13,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "OY74": {
    icao: "OY74",
    iata: "",
    name: "Al Anad Air Base",
    city: "Al Anad",
    country: "YE",
    continent: "AS",
    lat: 13.1747,
    lon: 44.7651,
    elevation: 900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYAA": {
    icao: "OYAA",
    iata: "ADE",
    name: "Aden International Airport",
    city: "Aden",
    country: "YE",
    continent: "AS",
    lat: 12.8295,
    lon: 45.0288,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYAT": {
    icao: "OYAT",
    iata: "AXK",
    name: "Ataq Airport",
    city: "Ataq",
    country: "YE",
    continent: "AS",
    lat: 14.5513,
    lon: 46.8262,
    elevation: 3735,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYGD": {
    icao: "OYGD",
    iata: "AAY",
    name: "Al Ghaydah International Airport",
    city: "Al Ghaydah",
    country: "YE",
    continent: "AS",
    lat: 16.1933,
    lon: 52.1742,
    elevation: 134,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYRN": {
    icao: "OYRN",
    iata: "RIY",
    name: "Riyan Mukalla International Airport",
    city: "Riyan",
    country: "YE",
    continent: "AS",
    lat: 14.6626,
    lon: 49.375,
    elevation: 54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYSN": {
    icao: "OYSN",
    iata: "SAH",
    name: "Sanaa International Airport",
    city: "Sanaa",
    country: "YE",
    continent: "AS",
    lat: 15.4763,
    lon: 44.2197,
    elevation: 7216,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYSQ": {
    icao: "OYSQ",
    iata: "SCT",
    name: "Socotra International Airport",
    city: "Mori",
    country: "YE",
    continent: "AS",
    lat: 12.6307,
    lon: 53.9058,
    elevation: 146,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYSY": {
    icao: "OYSY",
    iata: "GXF",
    name: "Seiyun Hadhramaut International Airport",
    city: "Seiyun",
    country: "YE",
    continent: "AS",
    lat: 15.9661,
    lon: 48.7883,
    elevation: 2097,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "OYTZ": {
    icao: "OYTZ",
    iata: "TAI",
    name: "Ta\'izz International Airport",
    city: "Ta\'izz",
    country: "YE",
    continent: "AS",
    lat: 13.686,
    lon: 44.1391,
    elevation: 4838,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAAQ": {
    icao: "PAAQ",
    iata: "PAQ",
    name: "Warren \"Bud\" Woods Palmer Municipal Airport",
    city: "Palmer",
    country: "US",
    continent: "NA",
    lat: 61.5949,
    lon: -149.089,
    elevation: 242,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PABA": {
    icao: "PABA",
    iata: "BTI",
    name: "Barter Island Long Range Radar Station Airport",
    city: "Barter Island",
    country: "US",
    continent: "NA",
    lat: 70.134,
    lon: -143.582,
    elevation: 2,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PABE": {
    icao: "PABE",
    iata: "BET",
    name: "Bethel Airport",
    city: "Bethel",
    country: "US",
    continent: "NA",
    lat: 60.7798,
    lon: -161.838,
    elevation: 126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PABI": {
    icao: "PABI",
    iata: "BIG",
    name: "Allen Army Airfield",
    city: "Delta Junction Ft Greely",
    country: "US",
    continent: "NA",
    lat: 63.9945,
    lon: -145.722,
    elevation: 1291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PABR": {
    icao: "PABR",
    iata: "BRW",
    name: "Wiley Post Will Rogers Memorial Airport",
    city: "Utqiaġvik",
    country: "US",
    continent: "NA",
    lat: 71.2854,
    lon: -156.766,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PABV": {
    icao: "PABV",
    iata: "",
    name: "Birchwood Airport",
    city: "Birchwood",
    country: "US",
    continent: "NA",
    lat: 61.4165,
    lon: -149.507,
    elevation: 83,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PACD": {
    icao: "PACD",
    iata: "CDB",
    name: "Cold Bay Airport",
    city: "Cold Bay",
    country: "US",
    continent: "NA",
    lat: 55.2079,
    lon: -162.725,
    elevation: 96,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PACL": {
    icao: "PACL",
    iata: "",
    name: "Clear Airport",
    city: "Clear",
    country: "US",
    continent: "NA",
    lat: 64.2997,
    lon: -149.1174,
    elevation: 552,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PACV": {
    icao: "PACV",
    iata: "CDV",
    name: "Merle K (Mudhole) Smith Airport",
    city: "Cordova",
    country: "US",
    continent: "NA",
    lat: 60.4918,
    lon: -145.478,
    elevation: 54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PACZ": {
    icao: "PACZ",
    iata: "CZF",
    name: "Cape Romanzof LRRS Airport",
    city: "Cape Romanzof",
    country: "US",
    continent: "NA",
    lat: 61.7803,
    lon: -166.039,
    elevation: 464,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PADE": {
    icao: "PADE",
    iata: "DRG",
    name: "Deering Airport",
    city: "Deering",
    country: "US",
    continent: "NA",
    lat: 66.0689,
    lon: -162.7669,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PADK": {
    icao: "PADK",
    iata: "ADK",
    name: "Adak Airport",
    city: "Adak",
    country: "US",
    continent: "NA",
    lat: 51.8836,
    lon: -176.6428,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PADL": {
    icao: "PADL",
    iata: "DLG",
    name: "Dillingham Airport",
    city: "Dillingham",
    country: "US",
    continent: "NA",
    lat: 59.0447,
    lon: -158.505,
    elevation: 81,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PADQ": {
    icao: "PADQ",
    iata: "ADQ",
    name: "Kodiak Airport",
    city: "Kodiak",
    country: "US",
    continent: "NA",
    lat: 57.75,
    lon: -152.494,
    elevation: 78,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PADU": {
    icao: "PADU",
    iata: "DUT",
    name: "Tom Madsen (Dutch Harbor) Airport",
    city: "Unalaska",
    country: "US",
    continent: "NA",
    lat: 53.8988,
    lon: -166.545,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAED": {
    icao: "PAED",
    iata: "EDF",
    name: "Elmendorf Air Force Base",
    city: "Anchorage",
    country: "US",
    continent: "NA",
    lat: 61.2517,
    lon: -149.8071,
    elevation: 212,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAEH": {
    icao: "PAEH",
    iata: "EHM",
    name: "Cape Newenham LRRS Airport",
    city: "Cape Newenham",
    country: "US",
    continent: "NA",
    lat: 58.6464,
    lon: -162.063,
    elevation: 541,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAEI": {
    icao: "PAEI",
    iata: "EIL",
    name: "Eielson Air Force Base",
    city: "Fairbanks",
    country: "US",
    continent: "NA",
    lat: 64.6657,
    lon: -147.102,
    elevation: 547,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAEM": {
    icao: "PAEM",
    iata: "EMK",
    name: "Emmonak Airport",
    city: "Emmonak",
    country: "US",
    continent: "NA",
    lat: 62.7861,
    lon: -164.491,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAEN": {
    icao: "PAEN",
    iata: "ENA",
    name: "Kenai Municipal Airport",
    city: "Kenai",
    country: "US",
    continent: "NA",
    lat: 60.5709,
    lon: -151.2452,
    elevation: 99,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAFA": {
    icao: "PAFA",
    iata: "FAI",
    name: "Fairbanks International Airport",
    city: "Fairbanks",
    country: "US",
    continent: "NA",
    lat: 64.8151,
    lon: -147.856,
    elevation: 439,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAFB": {
    icao: "PAFB",
    iata: "FBK",
    name: "Ladd Army Airfield",
    city: "Fairbanks",
    country: "US",
    continent: "NA",
    lat: 64.8375,
    lon: -147.614,
    elevation: 454,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAFE": {
    icao: "PAFE",
    iata: "",
    name: "Kake Airport",
    city: "Kake",
    country: "US",
    continent: "NA",
    lat: 56.9613,
    lon: -133.9102,
    elevation: 172,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAFM": {
    icao: "PAFM",
    iata: "ABL",
    name: "Ambler Airport",
    city: "Ambler",
    country: "US",
    continent: "NA",
    lat: 67.1055,
    lon: -157.8553,
    elevation: 334,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAGA": {
    icao: "PAGA",
    iata: "GAL",
    name: "Edward G. Pitka Sr Airport",
    city: "Galena",
    country: "US",
    continent: "NA",
    lat: 64.7362,
    lon: -156.937,
    elevation: 153,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAGK": {
    icao: "PAGK",
    iata: "GKN",
    name: "Gulkana Airport",
    city: "Gulkana",
    country: "US",
    continent: "NA",
    lat: 62.1559,
    lon: -145.4547,
    elevation: 1586,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAGM": {
    icao: "PAGM",
    iata: "GAM",
    name: "Gambell Airport",
    city: "Gambell",
    country: "US",
    continent: "NA",
    lat: 63.7677,
    lon: -171.7333,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAGS": {
    icao: "PAGS",
    iata: "GST",
    name: "Gustavus Airport",
    city: "Gustavus",
    country: "US",
    continent: "NA",
    lat: 58.4253,
    lon: -135.707,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAHC": {
    icao: "PAHC",
    iata: "HCR",
    name: "Holy Cross Airport",
    city: "Holy Cross",
    country: "US",
    continent: "NA",
    lat: 62.1883,
    lon: -159.775,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAHL": {
    icao: "PAHL",
    iata: "HSL",
    name: "Huslia Airport",
    city: "Huslia",
    country: "US",
    continent: "NA",
    lat: 65.6979,
    lon: -156.351,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAHN": {
    icao: "PAHN",
    iata: "HNS",
    name: "Haines Airport",
    city: "Haines",
    country: "US",
    continent: "NA",
    lat: 59.2439,
    lon: -135.5239,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAHO": {
    icao: "PAHO",
    iata: "HOM",
    name: "Homer Airport",
    city: "Homer",
    country: "US",
    continent: "NA",
    lat: 59.6445,
    lon: -151.4792,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAII": {
    icao: "PAII",
    iata: "EGX",
    name: "Egegik Airport",
    city: "Egegik",
    country: "US",
    continent: "NA",
    lat: 58.1844,
    lon: -157.3749,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAIK": {
    icao: "PAIK",
    iata: "IAN",
    name: "Bob Baker Memorial Airport",
    city: "Kiana",
    country: "US",
    continent: "NA",
    lat: 66.9761,
    lon: -160.439,
    elevation: 166,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAIL": {
    icao: "PAIL",
    iata: "ILI",
    name: "Iliamna Airport",
    city: "Iliamna",
    country: "US",
    continent: "NA",
    lat: 59.7544,
    lon: -154.911,
    elevation: 192,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAIM": {
    icao: "PAIM",
    iata: "UTO",
    name: "Indian Mountain LRRS Airport",
    city: "Utopia Creek",
    country: "US",
    continent: "NA",
    lat: 65.9928,
    lon: -153.704,
    elevation: 1273,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAJN": {
    icao: "PAJN",
    iata: "JNU",
    name: "Juneau International Airport",
    city: "Juneau",
    country: "US",
    continent: "NA",
    lat: 58.355,
    lon: -134.576,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAKN": {
    icao: "PAKN",
    iata: "AKN",
    name: "King Salmon Airport",
    city: "King Salmon",
    country: "US",
    continent: "NA",
    lat: 58.6778,
    lon: -156.652,
    elevation: 73,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAKP": {
    icao: "PAKP",
    iata: "AKP",
    name: "Anaktuvuk Pass Airport",
    city: "Anaktuvuk Pass",
    country: "US",
    continent: "NA",
    lat: 68.1336,
    lon: -151.743,
    elevation: 2102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAKT": {
    icao: "PAKT",
    iata: "KTN",
    name: "Ketchikan International Airport",
    city: "Ketchikan",
    country: "US",
    continent: "NA",
    lat: 55.3556,
    lon: -131.714,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAKW": {
    icao: "PAKW",
    iata: "KLW",
    name: "Klawock Airport",
    city: "Klawock",
    country: "US",
    continent: "NA",
    lat: 55.5792,
    lon: -133.076,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PALU": {
    icao: "PALU",
    iata: "LUR",
    name: "Cape Lisburne LRRS Airport",
    city: "Cape Lisburne",
    country: "US",
    continent: "NA",
    lat: 68.8751,
    lon: -166.11,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAMC": {
    icao: "PAMC",
    iata: "MCG",
    name: "McGrath Airport",
    city: "McGrath",
    country: "US",
    continent: "NA",
    lat: 62.9529,
    lon: -155.606,
    elevation: 341,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAMR": {
    icao: "PAMR",
    iata: "MRI",
    name: "Merrill Field",
    city: "Anchorage",
    country: "US",
    continent: "NA",
    lat: 61.2128,
    lon: -149.844,
    elevation: 137,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAMY": {
    icao: "PAMY",
    iata: "MYU",
    name: "Mekoryuk Airport",
    city: "Mekoryuk",
    country: "US",
    continent: "NA",
    lat: 60.3723,
    lon: -166.2698,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PANC": {
    icao: "PANC",
    iata: "ANC",
    name: "Ted Stevens Anchorage International Airport",
    city: "Anchorage",
    country: "US",
    continent: "NA",
    lat: 61.179,
    lon: -149.9926,
    elevation: 152,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "PANI": {
    icao: "PANI",
    iata: "ANI",
    name: "Aniak Airport",
    city: "Aniak",
    country: "US",
    continent: "NA",
    lat: 61.5816,
    lon: -159.543,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PANN": {
    icao: "PANN",
    iata: "ENN",
    name: "Nenana Municipal Airport",
    city: "Nenana",
    country: "US",
    continent: "NA",
    lat: 64.5488,
    lon: -149.0745,
    elevation: 362,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PANT": {
    icao: "PANT",
    iata: "ANN",
    name: "Annette Island Airport",
    city: "Metlakatla",
    country: "US",
    continent: "NA",
    lat: 55.0377,
    lon: -131.5726,
    elevation: 119,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PANV": {
    icao: "PANV",
    iata: "ANV",
    name: "Anvik Airport",
    city: "Anvik",
    country: "US",
    continent: "NA",
    lat: 62.6467,
    lon: -160.191,
    elevation: 291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAOM": {
    icao: "PAOM",
    iata: "OME",
    name: "Nome Airport",
    city: "Nome",
    country: "US",
    continent: "NA",
    lat: 64.5122,
    lon: -165.445,
    elevation: 37,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAOR": {
    icao: "PAOR",
    iata: "ORT",
    name: "Northway Airport",
    city: "Northway",
    country: "US",
    continent: "NA",
    lat: 62.9613,
    lon: -141.929,
    elevation: 1715,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAOT": {
    icao: "PAOT",
    iata: "OTZ",
    name: "Ralph Wien Memorial Airport",
    city: "Kotzebue",
    country: "US",
    continent: "NA",
    lat: 66.8847,
    lon: -162.599,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAPB": {
    icao: "PAPB",
    iata: "STG",
    name: "St George Airport",
    city: "St George",
    country: "US",
    continent: "NA",
    lat: 56.5773,
    lon: -169.6638,
    elevation: 125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAPC": {
    icao: "PAPC",
    iata: "KPC",
    name: "Port Clarence Coast Guard Station",
    city: "Port Clarence",
    country: "US",
    continent: "NA",
    lat: 65.2537,
    lon: -166.859,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAPG": {
    icao: "PAPG",
    iata: "PSG",
    name: "Petersburg James A Johnson Airport",
    city: "Petersburg",
    country: "US",
    continent: "NA",
    lat: 56.8017,
    lon: -132.945,
    elevation: 111,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAPH": {
    icao: "PAPH",
    iata: "PTH",
    name: "Port Heiden Airport",
    city: "Port Heiden",
    country: "US",
    continent: "NA",
    lat: 56.9579,
    lon: -158.6302,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAPM": {
    icao: "PAPM",
    iata: "PTU",
    name: "Platinum Airport",
    city: "Platinum",
    country: "US",
    continent: "NA",
    lat: 59.0177,
    lon: -161.8279,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAQT": {
    icao: "PAQT",
    iata: "NUI",
    name: "Nuiqsut Airport",
    city: "Nuiqsut",
    country: "US",
    continent: "NA",
    lat: 70.21,
    lon: -151.006,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PARC": {
    icao: "PARC",
    iata: "ARC",
    name: "Arctic Village Airport",
    city: "Arctic Village",
    country: "US",
    continent: "NA",
    lat: 68.1147,
    lon: -145.579,
    elevation: 2092,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PARY": {
    icao: "PARY",
    iata: "RBY",
    name: "Ruby Airport",
    city: "Ruby",
    country: "US",
    continent: "NA",
    lat: 64.7272,
    lon: -155.47,
    elevation: 658,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASA": {
    icao: "PASA",
    iata: "SVA",
    name: "Savoonga Airport",
    city: "Savoonga",
    country: "US",
    continent: "NA",
    lat: 63.6864,
    lon: -170.493,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASC": {
    icao: "PASC",
    iata: "SCC",
    name: "Deadhorse Airport",
    city: "Deadhorse",
    country: "US",
    continent: "NA",
    lat: 70.1947,
    lon: -148.465,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASD": {
    icao: "PASD",
    iata: "SDP",
    name: "Sand Point Airport",
    city: "Sand Point",
    country: "US",
    continent: "NA",
    lat: 55.3139,
    lon: -160.5221,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASI": {
    icao: "PASI",
    iata: "SIT",
    name: "Sitka Rocky Gutierrez Airport",
    city: "Sitka",
    country: "US",
    continent: "NA",
    lat: 57.0471,
    lon: -135.362,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASN": {
    icao: "PASN",
    iata: "SNP",
    name: "St Paul Island Airport",
    city: "St Paul Island",
    country: "US",
    continent: "NA",
    lat: 57.1663,
    lon: -170.2226,
    elevation: 63,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASV": {
    icao: "PASV",
    iata: "SVW",
    name: "Sparrevohn LRRS Airport",
    city: "Sparrevohn",
    country: "US",
    continent: "NA",
    lat: 61.0974,
    lon: -155.574,
    elevation: 1585,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASX": {
    icao: "PASX",
    iata: "SXQ",
    name: "Soldotna Airport",
    city: "Soldotna",
    country: "US",
    continent: "NA",
    lat: 60.4749,
    lon: -151.0385,
    elevation: 113,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PASY": {
    icao: "PASY",
    iata: "SYA",
    name: "Eareckson Air Station",
    city: "Shemya",
    country: "US",
    continent: "NA",
    lat: 52.7123,
    lon: 174.114,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PATK": {
    icao: "PATK",
    iata: "TKA",
    name: "Talkeetna Airport",
    city: "Talkeetna",
    country: "US",
    continent: "NA",
    lat: 62.3205,
    lon: -150.094,
    elevation: 358,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PATL": {
    icao: "PATL",
    iata: "TLJ",
    name: "Tatalina LRRS Airport",
    city: "Takotna",
    country: "US",
    continent: "NA",
    lat: 62.8944,
    lon: -155.977,
    elevation: 964,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PATQ": {
    icao: "PATQ",
    iata: "ATK",
    name: "Atqasuk Edward Burnell Sr Memorial Airport",
    city: "Atqasuk",
    country: "US",
    continent: "NA",
    lat: 70.467,
    lon: -157.436,
    elevation: 96,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAUN": {
    icao: "PAUN",
    iata: "UNK",
    name: "Unalakleet Airport",
    city: "Unalakleet",
    country: "US",
    continent: "NA",
    lat: 63.8884,
    lon: -160.799,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAVD": {
    icao: "PAVD",
    iata: "VDZ",
    name: "Valdez Pioneer Field",
    city: "Valdez",
    country: "US",
    continent: "NA",
    lat: 61.1327,
    lon: -146.2466,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAWD": {
    icao: "PAWD",
    iata: "SWD",
    name: "Seward Airport",
    city: "Seward",
    country: "US",
    continent: "NA",
    lat: 60.1305,
    lon: -149.4186,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAWG": {
    icao: "PAWG",
    iata: "WRG",
    name: "Wrangell Airport",
    city: "Wrangell",
    country: "US",
    continent: "NA",
    lat: 56.4843,
    lon: -132.37,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAWI": {
    icao: "PAWI",
    iata: "AIN",
    name: "Wainwright Airport",
    city: "Wainwright",
    country: "US",
    continent: "NA",
    lat: 70.638,
    lon: -159.995,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAWS": {
    icao: "PAWS",
    iata: "WWA",
    name: "Wasilla Airport",
    city: "Wasilla",
    country: "US",
    continent: "NA",
    lat: 61.5717,
    lon: -149.54,
    elevation: 354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PAYA": {
    icao: "PAYA",
    iata: "YAK",
    name: "Yakutat Airport",
    city: "Yakutat",
    country: "US",
    continent: "NA",
    lat: 59.5087,
    lon: -139.6604,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PCIS": {
    icao: "PCIS",
    iata: "CIS",
    name: "Canton Island Airport",
    city: "Abariringa",
    country: "KI",
    continent: "OC",
    lat: -2.7681,
    lon: -171.71,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PFYU": {
    icao: "PFYU",
    iata: "FYU",
    name: "Fort Yukon Airport",
    city: "Fort Yukon",
    country: "US",
    continent: "NA",
    lat: 66.5717,
    lon: -145.25,
    elevation: 433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PGRO": {
    icao: "PGRO",
    iata: "ROP",
    name: "Rota International Airport",
    city: "Rota Island",
    country: "MP",
    continent: "OC",
    lat: 14.1743,
    lon: 145.243,
    elevation: 607,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PGSN": {
    icao: "PGSN",
    iata: "SPN",
    name: "Saipan International Airport",
    city: "I Fadang, Saipan",
    country: "MP",
    continent: "OC",
    lat: 15.119,
    lon: 145.729,
    elevation: 215,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PGUA": {
    icao: "PGUA",
    iata: "UAM",
    name: "Andersen Air Force Base",
    city: "Yigo",
    country: "GU",
    continent: "OC",
    lat: 13.584,
    lon: 144.93,
    elevation: 627,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PGUM": {
    icao: "PGUM",
    iata: "GUM",
    name: "Antonio B. Won Pat International Airport",
    city: "Hagåtña",
    country: "GU",
    continent: "OC",
    lat: 13.485,
    lon: 144.7973,
    elevation: 298,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "PGWT": {
    icao: "PGWT",
    iata: "TIQ",
    name: "Tinian International Airport",
    city: "Tinian Island",
    country: "MP",
    continent: "OC",
    lat: 14.9981,
    lon: 145.6192,
    elevation: 271,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHBK": {
    icao: "PHBK",
    iata: "BKH",
    name: "Barking Sands Airport",
    city: "Kekaha",
    country: "US",
    continent: "OC",
    lat: 22.0228,
    lon: -159.785,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHHN": {
    icao: "PHHN",
    iata: "HNM",
    name: "Hana Airport",
    city: "Hana",
    country: "US",
    continent: "OC",
    lat: 20.7956,
    lon: -156.014,
    elevation: 78,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHIK": {
    icao: "PHIK",
    iata: "",
    name: "Hickam Air Force Base",
    city: "Honolulu",
    country: "US",
    continent: "NA",
    lat: 21.3353,
    lon: -157.9483,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHJH": {
    icao: "PHJH",
    iata: "JHM",
    name: "Kapalua Airport",
    city: "Lahaina",
    country: "US",
    continent: "OC",
    lat: 20.9629,
    lon: -156.673,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHJR": {
    icao: "PHJR",
    iata: "JRF",
    name: "Kalaeloa Airport",
    city: "Kapolei",
    country: "US",
    continent: "OC",
    lat: 21.3074,
    lon: -158.07,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHKO": {
    icao: "PHKO",
    iata: "KOA",
    name: "Ellison Onizuka Kona International Airport at Keahole",
    city: "Kailua-Kona",
    country: "US",
    continent: "NA",
    lat: 19.7388,
    lon: -156.0456,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHLI": {
    icao: "PHLI",
    iata: "LIH",
    name: "Lihue Airport",
    city: "Lihue",
    country: "US",
    continent: "OC",
    lat: 21.976,
    lon: -159.339,
    elevation: 153,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHMK": {
    icao: "PHMK",
    iata: "MKK",
    name: "Molokai Airport",
    city: "Kaunakakai",
    country: "US",
    continent: "OC",
    lat: 21.1529,
    lon: -157.096,
    elevation: 454,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHMU": {
    icao: "PHMU",
    iata: "MUE",
    name: "Waimea Kohala Airport",
    city: "Waimea (Kamuela)",
    country: "US",
    continent: "OC",
    lat: 20.0013,
    lon: -155.668,
    elevation: 2671,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHNG": {
    icao: "PHNG",
    iata: "NGF",
    name: "Kaneohe Bay MCAS (Marion E. Carl Field) Airport",
    city: "Kaneohe",
    country: "US",
    continent: "OC",
    lat: 21.4505,
    lon: -157.768,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHNL": {
    icao: "PHNL",
    iata: "HNL",
    name: "Daniel K Inouye International Airport",
    city: "Honolulu, Oahu",
    country: "US",
    continent: "NA",
    lat: 21.3206,
    lon: -157.9242,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "PHNY": {
    icao: "PHNY",
    iata: "LNY",
    name: "Lanai Airport",
    city: "Lanai City",
    country: "US",
    continent: "OC",
    lat: 20.7857,
    lon: -156.9513,
    elevation: 1308,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PHOG": {
    icao: "PHOG",
    iata: "OGG",
    name: "Kahului International Airport",
    city: "Kahului",
    country: "US",
    continent: "NA",
    lat: 20.8963,
    lon: -156.4318,
    elevation: 54,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "PHTO": {
    icao: "PHTO",
    iata: "ITO",
    name: "Hilo International Airport",
    city: "Hilo",
    country: "US",
    continent: "OC",
    lat: 19.7214,
    lon: -155.048,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PKMJ": {
    icao: "PKMJ",
    iata: "MAJ",
    name: "Marshall Islands International Airport",
    city: "Majuro Atoll",
    country: "MH",
    continent: "OC",
    lat: 7.0648,
    lon: 171.272,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PKWA": {
    icao: "PKWA",
    iata: "KWA",
    name: "Bucholz Army Air Field",
    city: "Kwajalein",
    country: "MH",
    continent: "OC",
    lat: 8.7201,
    lon: 167.732,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PLCH": {
    icao: "PLCH",
    iata: "CXI",
    name: "Cassidy International Airport",
    city: "Kiritimati",
    country: "KI",
    continent: "OC",
    lat: 1.9863,
    lon: -157.35,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PMDY": {
    icao: "PMDY",
    iata: "MDY",
    name: "Henderson Field",
    city: "Sand Island",
    country: "UM",
    continent: "OC",
    lat: 28.2017,
    lon: -177.381,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PPIZ": {
    icao: "PPIZ",
    iata: "PIZ",
    name: "Point Lay LRRS Airport",
    city: "Point Lay",
    country: "US",
    continent: "NA",
    lat: 69.7329,
    lon: -163.005,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PTKK": {
    icao: "PTKK",
    iata: "TKK",
    name: "Chuuk International Airport",
    city: "Weno Island",
    country: "FM",
    continent: "OC",
    lat: 7.4619,
    lon: 151.843,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PTPN": {
    icao: "PTPN",
    iata: "PNI",
    name: "Pohnpei International Airport",
    city: "Pohnpei Island",
    country: "FM",
    continent: "OC",
    lat: 6.9851,
    lon: 158.209,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PTRO": {
    icao: "PTRO",
    iata: "ROR",
    name: "Palau International Airport",
    city: "Babelthuap Island",
    country: "PW",
    continent: "OC",
    lat: 7.3673,
    lon: 134.5442,
    elevation: 176,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PTSA": {
    icao: "PTSA",
    iata: "KSA",
    name: "Kosrae International Airport",
    city: "Okat",
    country: "FM",
    continent: "OC",
    lat: 5.357,
    lon: 162.958,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PTYA": {
    icao: "PTYA",
    iata: "YAP",
    name: "Yap International Airport",
    city: "Yap Island",
    country: "FM",
    continent: "OC",
    lat: 9.4989,
    lon: 138.083,
    elevation: 91,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "PWAK": {
    icao: "PWAK",
    iata: "AWK",
    name: "Wake Island Airfield",
    city: "Wake Island",
    country: "UM",
    continent: "OC",
    lat: 19.2824,
    lon: 166.6366,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCAY": {
    icao: "RCAY",
    iata: "",
    name: "Gangshan Air Force Base",
    city: "Kaohsiung (Gangshan)",
    country: "TW",
    continent: "AS",
    lat: 22.7825,
    lon: 120.263,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCBS": {
    icao: "RCBS",
    iata: "KNH",
    name: "Kinmen Airport",
    city: "Shang-I",
    country: "TW",
    continent: "AS",
    lat: 24.4279,
    lon: 118.359,
    elevation: 93,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCDC": {
    icao: "RCDC",
    iata: "",
    name: "Pingtung Air Force Base",
    city: "Pingtung",
    country: "TW",
    continent: "AS",
    lat: 22.6724,
    lon: 120.462,
    elevation: 78,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCDI": {
    icao: "RCDI",
    iata: "",
    name: "Longtan Air Base",
    city: "Longtan",
    country: "TW",
    continent: "AS",
    lat: 24.8536,
    lon: 121.2364,
    elevation: 790,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCFG": {
    icao: "RCFG",
    iata: "LZN",
    name: "Matsu Nangan Airport",
    city: "Matsu (Nangan)",
    country: "TW",
    continent: "AS",
    lat: 26.1597,
    lon: 119.9584,
    elevation: 232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCFN": {
    icao: "RCFN",
    iata: "TTT",
    name: "Taitung Airport",
    city: "Taitung City",
    country: "TW",
    continent: "AS",
    lat: 22.755,
    lon: 121.102,
    elevation: 143,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCKH": {
    icao: "RCKH",
    iata: "KHH",
    name: "Kaohsiung International Airport",
    city: "Kaohsiung (Xiaogang)",
    country: "TW",
    continent: "AS",
    lat: 22.5771,
    lon: 120.35,
    elevation: 31,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RCKU": {
    icao: "RCKU",
    iata: "CYI",
    name: "Chiayi Airport",
    city: "Shuishang",
    country: "TW",
    continent: "AS",
    lat: 23.4626,
    lon: 120.3905,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCKW": {
    icao: "RCKW",
    iata: "HCN",
    name: "Hengchun Airport",
    city: "Hengchun",
    country: "TW",
    continent: "AS",
    lat: 22.0411,
    lon: 120.73,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCLY": {
    icao: "RCLY",
    iata: "KYD",
    name: "Lanyu Airport",
    city: "Orchid Island",
    country: "TW",
    continent: "AS",
    lat: 22.027,
    lon: 121.535,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCMQ": {
    icao: "RCMQ",
    iata: "RMQ",
    name: "Taichung International Airport / Ching Chuang Kang Air Base",
    city: "Taichung (Qingshui)",
    country: "TW",
    continent: "AS",
    lat: 24.2647,
    lon: 120.621,
    elevation: 663,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCMT": {
    icao: "RCMT",
    iata: "MFK",
    name: "Matsu Beigan Airport",
    city: "Matsu (Beigan)",
    country: "TW",
    continent: "AS",
    lat: 26.2242,
    lon: 120.003,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCNN": {
    icao: "RCNN",
    iata: "TNN",
    name: "Tainan International Airport / Tainan Air Base",
    city: "Tainan (Rende)",
    country: "TW",
    continent: "AS",
    lat: 22.9504,
    lon: 120.206,
    elevation: 63,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCPO": {
    icao: "RCPO",
    iata: "HSZ",
    name: "Hsinchu Air Base",
    city: "Hsinchu City",
    country: "TW",
    continent: "AS",
    lat: 24.818,
    lon: 120.939,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCQC": {
    icao: "RCQC",
    iata: "MZG",
    name: "Penghu Magong Airport",
    city: "Huxi",
    country: "TW",
    continent: "AS",
    lat: 23.5687,
    lon: 119.628,
    elevation: 103,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCQS": {
    icao: "RCQS",
    iata: "",
    name: "Chihhang Air Base",
    city: "Taitung City",
    country: "TW",
    continent: "AS",
    lat: 22.7931,
    lon: 121.182,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCSQ": {
    icao: "RCSQ",
    iata: "PIF",
    name: "Pingtung Air Force Base North",
    city: "Pingtung",
    country: "TW",
    continent: "AS",
    lat: 22.7002,
    lon: 120.482,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCSS": {
    icao: "RCSS",
    iata: "TSA",
    name: "Taipei Songshan Airport",
    city: "Taipei (Songshan)",
    country: "TW",
    continent: "AS",
    lat: 25.0694,
    lon: 121.552,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RCTP": {
    icao: "RCTP",
    iata: "TPE",
    name: "Taiwan Taoyuan International Airport",
    city: "Taoyuan",
    country: "TW",
    continent: "AS",
    lat: 25.0777,
    lon: 121.233,
    elevation: 106,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RCYU": {
    icao: "RCYU",
    iata: "HUN",
    name: "Hualien Airport",
    city: "Hualien City",
    country: "TW",
    continent: "AS",
    lat: 24.0231,
    lon: 121.618,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJAA": {
    icao: "RJAA",
    iata: "NRT",
    name: "Narita International Airport",
    city: "Narita",
    country: "JP",
    continent: "AS",
    lat: 35.7647,
    lon: 140.386,
    elevation: 141,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJAF": {
    icao: "RJAF",
    iata: "MMJ",
    name: "Shinshu-Matsumoto Airport",
    city: "Matsumoto",
    country: "JP",
    continent: "AS",
    lat: 36.1668,
    lon: 137.923,
    elevation: 2182,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJAH": {
    icao: "RJAH",
    iata: "IBR",
    name: "Ibaraki Airport / JASDF Hyakuri Air Base",
    city: "Omitama",
    country: "JP",
    continent: "AS",
    lat: 36.1811,
    lon: 140.415,
    elevation: 105,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJAW": {
    icao: "RJAW",
    iata: "IWO",
    name: "Ioto (Iwo Jima) Airbase",
    city: "Ogasawara",
    country: "JP",
    continent: "AS",
    lat: 24.7842,
    lon: 141.3226,
    elevation: 384,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJBB": {
    icao: "RJBB",
    iata: "KIX",
    name: "Kansai International Airport",
    city: "Osaka",
    country: "JP",
    continent: "AS",
    lat: 34.4273,
    lon: 135.244,
    elevation: 26,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJBD": {
    icao: "RJBD",
    iata: "SHM",
    name: "Nanki Shirahama Airport",
    city: "Shirahama",
    country: "JP",
    continent: "AS",
    lat: 33.6622,
    lon: 135.364,
    elevation: 298,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJBE": {
    icao: "RJBE",
    iata: "UKB",
    name: "Kobe Airport",
    city: "Kobe",
    country: "JP",
    continent: "AS",
    lat: 34.6328,
    lon: 135.224,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJBT": {
    icao: "RJBT",
    iata: "TJH",
    name: "Konotori Tajima Airport",
    city: "Toyooka",
    country: "JP",
    continent: "AS",
    lat: 35.5128,
    lon: 134.787,
    elevation: 584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCB": {
    icao: "RJCB",
    iata: "OBO",
    name: "Tokachi-Obihiro Airport",
    city: "Obihiro",
    country: "JP",
    continent: "AS",
    lat: 42.7333,
    lon: 143.217,
    elevation: 505,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCC": {
    icao: "RJCC",
    iata: "CTS",
    name: "New Chitose Airport",
    city: "Sapporo",
    country: "JP",
    continent: "AS",
    lat: 42.7752,
    lon: 141.692,
    elevation: 82,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJCH": {
    icao: "RJCH",
    iata: "HKD",
    name: "Hakodate Airport",
    city: "Hakodate",
    country: "JP",
    continent: "AS",
    lat: 41.77,
    lon: 140.822,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCJ": {
    icao: "RJCJ",
    iata: "",
    name: "JASDF Chitose Air Base",
    city: "Chitose",
    country: "JP",
    continent: "AS",
    lat: 42.7945,
    lon: 141.666,
    elevation: 87,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCK": {
    icao: "RJCK",
    iata: "KUH",
    name: "Kushiro Airport",
    city: "Kushiro",
    country: "JP",
    continent: "AS",
    lat: 43.041,
    lon: 144.193,
    elevation: 327,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCM": {
    icao: "RJCM",
    iata: "MMB",
    name: "Memanbetsu Airport",
    city: "Ōzora",
    country: "JP",
    continent: "AS",
    lat: 43.8806,
    lon: 144.164,
    elevation: 135,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCN": {
    icao: "RJCN",
    iata: "SHB",
    name: "Nakashibetsu Airport",
    city: "Nakashibetsu",
    country: "JP",
    continent: "AS",
    lat: 43.5775,
    lon: 144.96,
    elevation: 234,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCO": {
    icao: "RJCO",
    iata: "OKD",
    name: "Sapporo Okadama Airport",
    city: "Sapporo",
    country: "JP",
    continent: "AS",
    lat: 43.1174,
    lon: 141.3813,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCS": {
    icao: "RJCS",
    iata: "",
    name: "JASDF Kenebetsu Airfield",
    city: "Betsukai",
    country: "JP",
    continent: "AS",
    lat: 43.4252,
    lon: 144.7414,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCT": {
    icao: "RJCT",
    iata: "",
    name: "Tokachi Airport",
    city: "Obihiro",
    country: "JP",
    continent: "AS",
    lat: 42.8905,
    lon: 143.158,
    elevation: 281,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJCW": {
    icao: "RJCW",
    iata: "WKJ",
    name: "Wakkanai Airport",
    city: "Wakkanai",
    country: "JP",
    continent: "AS",
    lat: 45.4042,
    lon: 141.801,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJDB": {
    icao: "RJDB",
    iata: "IKI",
    name: "Iki Airport",
    city: "Iki",
    country: "JP",
    continent: "AS",
    lat: 33.749,
    lon: 129.785,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJDC": {
    icao: "RJDC",
    iata: "UBJ",
    name: "Yamaguchi Ube Airport",
    city: "Ube",
    country: "JP",
    continent: "AS",
    lat: 33.93,
    lon: 131.279,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJDT": {
    icao: "RJDT",
    iata: "TSJ",
    name: "Tsushima Airport",
    city: "Tsushima",
    country: "JP",
    continent: "AS",
    lat: 34.2849,
    lon: 129.331,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJEB": {
    icao: "RJEB",
    iata: "MBE",
    name: "Monbetsu Airport",
    city: "Monbetsu",
    country: "JP",
    continent: "AS",
    lat: 44.3039,
    lon: 143.404,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJEC": {
    icao: "RJEC",
    iata: "AKJ",
    name: "Asahikawa Airport",
    city: "Higashikagura",
    country: "JP",
    continent: "AS",
    lat: 43.6708,
    lon: 142.447,
    elevation: 721,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJEO": {
    icao: "RJEO",
    iata: "OIR",
    name: "Okushiri Airport",
    city: "Okushiri Island",
    country: "JP",
    continent: "AS",
    lat: 42.0717,
    lon: 139.433,
    elevation: 161,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJER": {
    icao: "RJER",
    iata: "RIS",
    name: "Rishiri Airport",
    city: "Rishiri",
    country: "JP",
    continent: "AS",
    lat: 45.242,
    lon: 141.186,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFA": {
    icao: "RJFA",
    iata: "",
    name: "JASDF Ashiya Air Base",
    city: "Ashiya",
    country: "JP",
    continent: "AS",
    lat: 33.8831,
    lon: 130.653,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFC": {
    icao: "RJFC",
    iata: "KUM",
    name: "Yakushima Airport",
    city: "Yakushima",
    country: "JP",
    continent: "AS",
    lat: 30.3856,
    lon: 130.659,
    elevation: 124,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFE": {
    icao: "RJFE",
    iata: "FUJ",
    name: "Fukue Airport",
    city: "Goto",
    country: "JP",
    continent: "AS",
    lat: 32.6663,
    lon: 128.833,
    elevation: 273,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFF": {
    icao: "RJFF",
    iata: "FUK",
    name: "Fukuoka Airport",
    city: "Fukuoka",
    country: "JP",
    continent: "AS",
    lat: 33.5859,
    lon: 130.451,
    elevation: 32,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJFG": {
    icao: "RJFG",
    iata: "TNE",
    name: "New Tanegashima Airport",
    city: "Tanegashima",
    country: "JP",
    continent: "AS",
    lat: 30.6051,
    lon: 130.991,
    elevation: 768,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFK": {
    icao: "RJFK",
    iata: "KOJ",
    name: "Kagoshima Airport",
    city: "Kagoshima",
    country: "JP",
    continent: "AS",
    lat: 31.8034,
    lon: 130.719,
    elevation: 906,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJFM": {
    icao: "RJFM",
    iata: "KMI",
    name: "Miyazaki Airport",
    city: "Miyazaki",
    country: "JP",
    continent: "AS",
    lat: 31.8772,
    lon: 131.449,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFO": {
    icao: "RJFO",
    iata: "OIT",
    name: "Oita Airport",
    city: "Oita",
    country: "JP",
    continent: "AS",
    lat: 33.4794,
    lon: 131.737,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFR": {
    icao: "RJFR",
    iata: "KKJ",
    name: "Kitakyushu Airport",
    city: "Kitakyushu",
    country: "JP",
    continent: "AS",
    lat: 33.8459,
    lon: 131.035,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFS": {
    icao: "RJFS",
    iata: "HSG",
    name: "Saga Airport",
    city: "Saga",
    country: "JP",
    continent: "AS",
    lat: 33.1497,
    lon: 130.302,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFT": {
    icao: "RJFT",
    iata: "KMJ",
    name: "Kumamoto Airport",
    city: "Kumamoto",
    country: "JP",
    continent: "AS",
    lat: 32.8373,
    lon: 130.855,
    elevation: 642,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFU": {
    icao: "RJFU",
    iata: "NGS",
    name: "Nagasaki Airport",
    city: "Nagasaki",
    country: "JP",
    continent: "AS",
    lat: 32.9169,
    lon: 129.914,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFY": {
    icao: "RJFY",
    iata: "",
    name: "JMSDF Kanoya Air Base",
    city: "Kanoya",
    country: "JP",
    continent: "AS",
    lat: 31.3667,
    lon: 130.8388,
    elevation: 214,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJFZ": {
    icao: "RJFZ",
    iata: "",
    name: "JASDF Tsuiki Air Base",
    city: "Tsuiki",
    country: "JP",
    continent: "AS",
    lat: 33.685,
    lon: 131.04,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJGG": {
    icao: "RJGG",
    iata: "NGO",
    name: "Chubu Centrair International Airport",
    city: "Tokoname",
    country: "JP",
    continent: "AS",
    lat: 34.8584,
    lon: 136.805,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJKA": {
    icao: "RJKA",
    iata: "ASJ",
    name: "Amami Airport",
    city: "Amami",
    country: "JP",
    continent: "AS",
    lat: 28.4306,
    lon: 129.713,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJKB": {
    icao: "RJKB",
    iata: "OKE",
    name: "Okinoerabu Airport",
    city: "Wadomari",
    country: "JP",
    continent: "AS",
    lat: 27.4316,
    lon: 128.7056,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJKI": {
    icao: "RJKI",
    iata: "KKX",
    name: "Kikai Airport",
    city: "Kikai",
    country: "JP",
    continent: "AS",
    lat: 28.3213,
    lon: 129.928,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJKN": {
    icao: "RJKN",
    iata: "TKN",
    name: "Tokunoshima Airport",
    city: "Amagi",
    country: "JP",
    continent: "AS",
    lat: 27.8364,
    lon: 128.8814,
    elevation: 17,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNA": {
    icao: "RJNA",
    iata: "NKM",
    name: "Nagoya Airport / JASDF Komaki Air Base",
    city: "Nagoya",
    country: "JP",
    continent: "AS",
    lat: 35.2558,
    lon: 136.9241,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNF": {
    icao: "RJNF",
    iata: "FKJ",
    name: "Fukui Airport",
    city: "Fukui",
    country: "JP",
    continent: "AS",
    lat: 36.1428,
    lon: 136.224,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNG": {
    icao: "RJNG",
    iata: "QGU",
    name: "Gifu Airport",
    city: "Gifu",
    country: "JP",
    continent: "AS",
    lat: 35.3941,
    lon: 136.87,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNH": {
    icao: "RJNH",
    iata: "",
    name: "JASDF Hamamatsu Air Base",
    city: "Hamamatsu",
    country: "JP",
    continent: "AS",
    lat: 34.7502,
    lon: 137.703,
    elevation: 150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNK": {
    icao: "RJNK",
    iata: "KMQ",
    name: "Komatsu Airport / JASDF Komatsu Air Base",
    city: "Kanazawa",
    country: "JP",
    continent: "AS",
    lat: 36.3946,
    lon: 136.407,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNO": {
    icao: "RJNO",
    iata: "OKI",
    name: "Oki Global Geopark Airport",
    city: "Okinoshima",
    country: "JP",
    continent: "AS",
    lat: 36.1784,
    lon: 133.3236,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNS": {
    icao: "RJNS",
    iata: "FSZ",
    name: "Mount Fuji Shizuoka Airport",
    city: "Makinohara / Shimada",
    country: "JP",
    continent: "AS",
    lat: 34.796,
    lon: 138.1878,
    elevation: 433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNT": {
    icao: "RJNT",
    iata: "TOY",
    name: "Toyama Airport",
    city: "Toyama",
    country: "JP",
    continent: "AS",
    lat: 36.6483,
    lon: 137.188,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNW": {
    icao: "RJNW",
    iata: "NTQ",
    name: "Noto Satoyama Airport",
    city: "Wajima",
    country: "JP",
    continent: "AS",
    lat: 37.2931,
    lon: 136.962,
    elevation: 718,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJNY": {
    icao: "RJNY",
    iata: "",
    name: "JASDF Shizuhama Air Base",
    city: "Yaizu",
    country: "JP",
    continent: "AS",
    lat: 34.8128,
    lon: 138.298,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOA": {
    icao: "RJOA",
    iata: "HIJ",
    name: "Hiroshima Airport",
    city: "Hiroshima",
    country: "JP",
    continent: "AS",
    lat: 34.4361,
    lon: 132.919,
    elevation: 1088,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOB": {
    icao: "RJOB",
    iata: "OKJ",
    name: "Okayama Momotaro Airport",
    city: "Okayama",
    country: "JP",
    continent: "AS",
    lat: 34.7569,
    lon: 133.855,
    elevation: 806,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOC": {
    icao: "RJOC",
    iata: "IZO",
    name: "Izumo Enmusubi Airport",
    city: "Izumo",
    country: "JP",
    continent: "AS",
    lat: 35.4136,
    lon: 132.89,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOF": {
    icao: "RJOF",
    iata: "",
    name: "JASDF Hofu Airfield",
    city: "Hofu",
    country: "JP",
    continent: "AS",
    lat: 34.0347,
    lon: 131.5487,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOH": {
    icao: "RJOH",
    iata: "YGJ",
    name: "Yonago Kitaro Airport / JASDF Miho Air Base",
    city: "Yonago",
    country: "JP",
    continent: "AS",
    lat: 35.4922,
    lon: 133.236,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOI": {
    icao: "RJOI",
    iata: "IWK",
    name: "Iwakuni Kintaikyo Airport / Marine Corps Air Station Iwakuni",
    city: "Iwakuni",
    country: "JP",
    continent: "AS",
    lat: 34.1463,
    lon: 132.2472,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOK": {
    icao: "RJOK",
    iata: "KCZ",
    name: "Kochi Ryoma Airport",
    city: "Nankoku",
    country: "JP",
    continent: "AS",
    lat: 33.5461,
    lon: 133.669,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOM": {
    icao: "RJOM",
    iata: "MYJ",
    name: "Matsuyama Airport",
    city: "Matsuyama",
    country: "JP",
    continent: "AS",
    lat: 33.8272,
    lon: 132.7,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOO": {
    icao: "RJOO",
    iata: "ITM",
    name: "Osaka International Airport",
    city: "Osaka",
    country: "JP",
    continent: "AS",
    lat: 34.7855,
    lon: 135.438,
    elevation: 50,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJOR": {
    icao: "RJOR",
    iata: "TTJ",
    name: "Tottori Sand Dunes Conan Airport",
    city: "Tottori",
    country: "JP",
    continent: "AS",
    lat: 35.5301,
    lon: 134.167,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOS": {
    icao: "RJOS",
    iata: "TKS",
    name: "Tokushima Awaodori Airport / JMSDF Tokushima Air Base",
    city: "Tokushima",
    country: "JP",
    continent: "AS",
    lat: 34.1328,
    lon: 134.607,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOT": {
    icao: "RJOT",
    iata: "TAK",
    name: "Takamatsu Airport",
    city: "Takamatsu",
    country: "JP",
    continent: "AS",
    lat: 34.2142,
    lon: 134.016,
    elevation: 607,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOW": {
    icao: "RJOW",
    iata: "IWJ",
    name: "Iwami Airport",
    city: "Masuda",
    country: "JP",
    continent: "AS",
    lat: 34.6764,
    lon: 131.79,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJOY": {
    icao: "RJOY",
    iata: "",
    name: "Yao Airport",
    city: "Yao",
    country: "JP",
    continent: "AS",
    lat: 34.5963,
    lon: 135.603,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSA": {
    icao: "RJSA",
    iata: "AOJ",
    name: "Aomori Airport",
    city: "Aomori",
    country: "JP",
    continent: "AS",
    lat: 40.7347,
    lon: 140.691,
    elevation: 664,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSC": {
    icao: "RJSC",
    iata: "GAJ",
    name: "Yamagata Airport",
    city: "Higashine",
    country: "JP",
    continent: "AS",
    lat: 38.4119,
    lon: 140.371,
    elevation: 353,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSD": {
    icao: "RJSD",
    iata: "SDS",
    name: "Sado Airport",
    city: "Sado",
    country: "JP",
    continent: "AS",
    lat: 38.0602,
    lon: 138.414,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSF": {
    icao: "RJSF",
    iata: "FKS",
    name: "Fukushima Airport",
    city: "Sukagawa",
    country: "JP",
    continent: "AS",
    lat: 37.2274,
    lon: 140.431,
    elevation: 1221,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSH": {
    icao: "RJSH",
    iata: "HHE",
    name: "JMSDF Hachinohe Air Base / Hachinohe Airport",
    city: "Hachinohe",
    country: "JP",
    continent: "AS",
    lat: 40.5512,
    lon: 141.4654,
    elevation: 152,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSI": {
    icao: "RJSI",
    iata: "HNA",
    name: "Iwate Hanamaki Airport",
    city: "Hanamaki",
    country: "JP",
    continent: "AS",
    lat: 39.4286,
    lon: 141.135,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSK": {
    icao: "RJSK",
    iata: "AXT",
    name: "Akita Airport",
    city: "Akita",
    country: "JP",
    continent: "AS",
    lat: 39.6156,
    lon: 140.219,
    elevation: 313,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSM": {
    icao: "RJSM",
    iata: "MSJ",
    name: "Misawa Airport / Misawa Air Base",
    city: "Misawa",
    country: "JP",
    continent: "AS",
    lat: 40.7032,
    lon: 141.368,
    elevation: 119,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSN": {
    icao: "RJSN",
    iata: "KIJ",
    name: "Niigata Airport",
    city: "Niigata",
    country: "JP",
    continent: "AS",
    lat: 37.9559,
    lon: 139.121,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSR": {
    icao: "RJSR",
    iata: "ONJ",
    name: "Odate Noshiro Airport",
    city: "Kitaakita",
    country: "JP",
    continent: "AS",
    lat: 40.1919,
    lon: 140.371,
    elevation: 292,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSS": {
    icao: "RJSS",
    iata: "SDJ",
    name: "Sendai Airport",
    city: "Natori",
    country: "JP",
    continent: "AS",
    lat: 38.1397,
    lon: 140.917,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RJST": {
    icao: "RJST",
    iata: "",
    name: "JASDF Matsushima Air Base",
    city: "Ishinomaki",
    country: "JP",
    continent: "AS",
    lat: 38.4049,
    lon: 141.22,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJSY": {
    icao: "RJSY",
    iata: "SYO",
    name: "Shonai Airport",
    city: "Shonai",
    country: "JP",
    continent: "AS",
    lat: 38.8122,
    lon: 139.787,
    elevation: 86,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTA": {
    icao: "RJTA",
    iata: "NJA",
    name: "JMSDF Atsugi Air Base / Naval Air Facility Atsugi",
    city: "Ayase / Yamato",
    country: "JP",
    continent: "AS",
    lat: 35.4546,
    lon: 139.45,
    elevation: 205,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTE": {
    icao: "RJTE",
    iata: "",
    name: "JMSDF Tateyama Air Base",
    city: "Tateyama",
    country: "JP",
    continent: "AS",
    lat: 34.9871,
    lon: 139.829,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTF": {
    icao: "RJTF",
    iata: "",
    name: "Chofu Airport",
    city: "Chofu",
    country: "JP",
    continent: "AS",
    lat: 35.6717,
    lon: 139.528,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTH": {
    icao: "RJTH",
    iata: "HAC",
    name: "Hachijojima Airport",
    city: "Hachijojima",
    country: "JP",
    continent: "AS",
    lat: 33.115,
    lon: 139.786,
    elevation: 303,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTJ": {
    icao: "RJTJ",
    iata: "",
    name: "Iruma Air Base",
    city: "Sayama",
    country: "JP",
    continent: "AS",
    lat: 35.8419,
    lon: 139.411,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTK": {
    icao: "RJTK",
    iata: "",
    name: "JGSDF Kisarazu Airfield",
    city: "Kisarazu",
    country: "JP",
    continent: "AS",
    lat: 35.3983,
    lon: 139.91,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTL": {
    icao: "RJTL",
    iata: "",
    name: "JMSDF Shimofusa Air Base",
    city: "Matsudo",
    country: "JP",
    continent: "AS",
    lat: 35.7989,
    lon: 140.011,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTO": {
    icao: "RJTO",
    iata: "OIM",
    name: "Oshima Airport",
    city: "Izu Oshima",
    country: "JP",
    continent: "AS",
    lat: 34.782,
    lon: 139.36,
    elevation: 130,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTQ": {
    icao: "RJTQ",
    iata: "MYE",
    name: "Miyakejima Airport",
    city: "Miyakejima",
    country: "JP",
    continent: "AS",
    lat: 34.0736,
    lon: 139.56,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTT": {
    icao: "RJTT",
    iata: "HND",
    name: "Tokyo Haneda International Airport",
    city: "Tokyo",
    country: "JP",
    continent: "AS",
    lat: 35.5523,
    lon: 139.78,
    elevation: 35,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "RJTU": {
    icao: "RJTU",
    iata: "",
    name: "Utsunomiya Airport",
    city: "Utsunomiya",
    country: "JP",
    continent: "AS",
    lat: 36.5145,
    lon: 139.871,
    elevation: 334,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RJTY": {
    icao: "RJTY",
    iata: "OKO",
    name: "Yokota Air Base",
    city: "Fussa",
    country: "JP",
    continent: "AS",
    lat: 35.7485,
    lon: 139.348,
    elevation: 463,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RKJB": {
    icao: "RKJB",
    iata: "MWX",
    name: "Muan International Airport",
    city: "Muan (Piseo-ri)",
    country: "KR",
    continent: "AS",
    lat: 34.9914,
    lon: 126.3828,
    elevation: 35,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RKJJ": {
    icao: "RKJJ",
    iata: "KWJ",
    name: "Gwangju Airport",
    city: "Gwangju",
    country: "KR",
    continent: "AS",
    lat: 35.1232,
    lon: 126.8054,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKJK": {
    icao: "RKJK",
    iata: "KUV",
    name: "Gunsan Airport / Gunsan Air Base",
    city: "Gunsan",
    country: "KR",
    continent: "AS",
    lat: 35.9038,
    lon: 126.616,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKJY": {
    icao: "RKJY",
    iata: "RSU",
    name: "Yeosu Airport",
    city: "Yeosu",
    country: "KR",
    continent: "AS",
    lat: 34.8423,
    lon: 127.617,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKNN": {
    icao: "RKNN",
    iata: "KAG",
    name: "Gangneung Airport (K-18)",
    city: "Gangneung",
    country: "KR",
    continent: "AS",
    lat: 37.7536,
    lon: 128.9439,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKNW": {
    icao: "RKNW",
    iata: "WJU",
    name: "Wonju Airport / Hoengseong Air Base (K-38/K-46)",
    city: "Wonju",
    country: "KR",
    continent: "AS",
    lat: 37.4371,
    lon: 127.9601,
    elevation: 329,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKNY": {
    icao: "RKNY",
    iata: "YNY",
    name: "Yangyang International Airport",
    city: "Gonghang-ro",
    country: "KR",
    continent: "AS",
    lat: 38.0613,
    lon: 128.669,
    elevation: 241,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKPC": {
    icao: "RKPC",
    iata: "CJU",
    name: "Jeju International Airport",
    city: "Jeju City",
    country: "KR",
    continent: "AS",
    lat: 33.5121,
    lon: 126.4925,
    elevation: 118,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RKPD": {
    icao: "RKPD",
    iata: "JDG",
    name: "Jeongseok Airport",
    city: "Jeju Island",
    country: "KR",
    continent: "AS",
    lat: 33.3996,
    lon: 126.712,
    elevation: 1171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKPK": {
    icao: "RKPK",
    iata: "PUS",
    name: "Gimhae International Airport",
    city: "Busan",
    country: "KR",
    continent: "AS",
    lat: 35.1795,
    lon: 128.938,
    elevation: 6,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RKPS": {
    icao: "RKPS",
    iata: "HIN",
    name: "Sacheon Airport / Sacheon Air Base",
    city: "Sacheon",
    country: "KR",
    continent: "AS",
    lat: 35.0886,
    lon: 128.0717,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKPU": {
    icao: "RKPU",
    iata: "USN",
    name: "Ulsan Airport",
    city: "Ulsan",
    country: "KR",
    continent: "AS",
    lat: 35.5935,
    lon: 129.352,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKSG": {
    icao: "RKSG",
    iata: "",
    name: "Camp Humphreys (A-511) Desiderio Army Airfield",
    city: "Pyeongtaek",
    country: "KR",
    continent: "AS",
    lat: 36.9624,
    lon: 127.0311,
    elevation: 51,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKSI": {
    icao: "RKSI",
    iata: "ICN",
    name: "Incheon International Airport",
    city: "Seoul",
    country: "KR",
    continent: "AS",
    lat: 37.4691,
    lon: 126.451,
    elevation: 23,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "RKSM": {
    icao: "RKSM",
    iata: "SSN",
    name: "Seoul Air Base (K-16)",
    city: "Seongnam",
    country: "KR",
    continent: "AS",
    lat: 37.4447,
    lon: 127.1127,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKSO": {
    icao: "RKSO",
    iata: "OSN",
    name: "Osan Air Base",
    city: "Pyeongtaek",
    country: "KR",
    continent: "AS",
    lat: 37.0915,
    lon: 127.0294,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKSS": {
    icao: "RKSS",
    iata: "GMP",
    name: "Gimpo International Airport",
    city: "Seoul",
    country: "KR",
    continent: "AS",
    lat: 37.5583,
    lon: 126.791,
    elevation: 59,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RKSW": {
    icao: "RKSW",
    iata: "SWU",
    name: "Suwon Airport",
    city: "Suwon",
    country: "KR",
    continent: "AS",
    lat: 37.2394,
    lon: 127.007,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKTH": {
    icao: "RKTH",
    iata: "KPO",
    name: "Pohang Airport (G-815/K-3)",
    city: "Pohang",
    country: "KR",
    continent: "AS",
    lat: 35.988,
    lon: 129.4204,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKTI": {
    icao: "RKTI",
    iata: "JWO",
    name: "Jungwon Air Base/Chungju Airport",
    city: "Gimseang-ro",
    country: "KR",
    continent: "AS",
    lat: 37.0302,
    lon: 127.8864,
    elevation: 281,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKTN": {
    icao: "RKTN",
    iata: "TAE",
    name: "Daegu Airport",
    city: "Daegu",
    country: "KR",
    continent: "AS",
    lat: 35.8969,
    lon: 128.6553,
    elevation: 116,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKTU": {
    icao: "RKTU",
    iata: "CJJ",
    name: "Cheongju International Airport/Cheongju Air Base (K-59/G-513)",
    city: "Cheongju",
    country: "KR",
    continent: "AS",
    lat: 36.717,
    lon: 127.4987,
    elevation: 191,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RKTY": {
    icao: "RKTY",
    iata: "YEC",
    name: "Yecheon Airbase",
    city: "Yecheon-ri",
    country: "KR",
    continent: "AS",
    lat: 36.6304,
    lon: 128.3497,
    elevation: 354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ROAH": {
    icao: "ROAH",
    iata: "OKA",
    name: "Naha Airport / JASDF Naha Air Base",
    city: "Naha",
    country: "JP",
    continent: "AS",
    lat: 26.1958,
    lon: 127.646,
    elevation: 12,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RODN": {
    icao: "RODN",
    iata: "DNA",
    name: "Kadena Air Base",
    city: "Okinawa",
    country: "JP",
    continent: "AS",
    lat: 26.3517,
    lon: 127.7694,
    elevation: 143,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ROIG": {
    icao: "ROIG",
    iata: "ISG",
    name: "New Ishigaki Airport",
    city: "Ishigaki",
    country: "JP",
    continent: "AS",
    lat: 24.3964,
    lon: 124.245,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ROKJ": {
    icao: "ROKJ",
    iata: "UEO",
    name: "Kumejima Airport",
    city: "Kumejima",
    country: "JP",
    continent: "AS",
    lat: 26.3634,
    lon: 126.7138,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ROMD": {
    icao: "ROMD",
    iata: "MMD",
    name: "Minamidaito Airport",
    city: "Minamidaito",
    country: "JP",
    continent: "AS",
    lat: 25.8465,
    lon: 131.263,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ROMY": {
    icao: "ROMY",
    iata: "MMY",
    name: "Miyako Airport",
    city: "Miyakojima",
    country: "JP",
    continent: "AS",
    lat: 24.7828,
    lon: 125.295,
    elevation: 150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RORE": {
    icao: "RORE",
    iata: "IEJ",
    name: "Iejima Airport",
    city: "Ie",
    country: "JP",
    continent: "AS",
    lat: 26.7225,
    lon: 127.7868,
    elevation: 246,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RORK": {
    icao: "RORK",
    iata: "KTD",
    name: "Kitadaito Airport",
    city: "Kitadaitōjima",
    country: "JP",
    continent: "AS",
    lat: 25.9447,
    lon: 131.327,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RORS": {
    icao: "RORS",
    iata: "SHI",
    name: "Shimojishima Airport",
    city: "Miyakojima",
    country: "JP",
    continent: "AS",
    lat: 24.8267,
    lon: 125.145,
    elevation: 54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RORT": {
    icao: "RORT",
    iata: "TRA",
    name: "Tarama Airport",
    city: "Tarama",
    country: "JP",
    continent: "AS",
    lat: 24.6538,
    lon: 124.6755,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RORY": {
    icao: "RORY",
    iata: "RNJ",
    name: "Yoron Airport",
    city: "Yoron",
    country: "JP",
    continent: "AS",
    lat: 27.0438,
    lon: 128.4016,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ROTM": {
    icao: "ROTM",
    iata: "",
    name: "Futenma Marine Corps Air Station",
    city: "",
    country: "JP",
    continent: "AS",
    lat: 26.2743,
    lon: 127.756,
    elevation: 247,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ROYN": {
    icao: "ROYN",
    iata: "OGN",
    name: "Yonaguni Airport",
    city: "Yonaguni",
    country: "JP",
    continent: "AS",
    lat: 24.4673,
    lon: 122.9798,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLB": {
    icao: "RPLB",
    iata: "SFS",
    name: "Subic Bay International Airport / Naval Air Station Cubi Point",
    city: "Olongapo",
    country: "PH",
    continent: "AS",
    lat: 14.7944,
    lon: 120.271,
    elevation: 64,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLC": {
    icao: "RPLC",
    iata: "CRK",
    name: "Clark International Airport / Clark Air Base",
    city: "Mabalacat",
    country: "PH",
    continent: "AS",
    lat: 15.186,
    lon: 120.56,
    elevation: 484,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLH": {
    icao: "RPLH",
    iata: "LLC",
    name: "Cagayan North International Airport",
    city: "Lal-lo",
    country: "PH",
    continent: "AS",
    lat: 18.1824,
    lon: 121.7459,
    elevation: 148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLI": {
    icao: "RPLI",
    iata: "LAO",
    name: "Laoag International Airport",
    city: "Laoag City",
    country: "PH",
    continent: "AS",
    lat: 18.1761,
    lon: 120.531,
    elevation: 25,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLK": {
    icao: "RPLK",
    iata: "DRP",
    name: "Bicol International Airport",
    city: "Legazpi",
    country: "PH",
    continent: "AS",
    lat: 13.1119,
    lon: 123.6768,
    elevation: 319,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLL": {
    icao: "RPLL",
    iata: "MNL",
    name: "Ninoy Aquino International Airport",
    city: "Manila (Pasay)",
    country: "PH",
    continent: "AS",
    lat: 14.5086,
    lon: 121.02,
    elevation: 75,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RPLS": {
    icao: "RPLS",
    iata: "SGL",
    name: "Danilo Atienza Air Base",
    city: "Cavite",
    country: "PH",
    continent: "AS",
    lat: 14.4954,
    lon: 120.904,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLT": {
    icao: "RPLT",
    iata: "",
    name: "Itbayat Jorge Abad Airport",
    city: "Itbayat",
    country: "PH",
    continent: "AS",
    lat: 20.7225,
    lon: 121.81,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPLU": {
    icao: "RPLU",
    iata: "LBX",
    name: "Lubang Airport",
    city: "Lubang",
    country: "PH",
    continent: "AS",
    lat: 13.8554,
    lon: 120.105,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMA": {
    icao: "RPMA",
    iata: "AAV",
    name: "Allah Valley Airport",
    city: "Surallah",
    country: "PH",
    continent: "AS",
    lat: 6.3679,
    lon: 124.7524,
    elevation: 659,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMB": {
    icao: "RPMB",
    iata: "",
    name: "Rajah Buayan Air Base",
    city: "General Santos City",
    country: "PH",
    continent: "AS",
    lat: 6.1064,
    lon: 125.235,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMC": {
    icao: "RPMC",
    iata: "CBO",
    name: "Cotabato (Awang) Airport",
    city: "Datu Odin Sinsuat",
    country: "PH",
    continent: "AS",
    lat: 7.1648,
    lon: 124.2099,
    elevation: 189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMD": {
    icao: "RPMD",
    iata: "DVO",
    name: "Francisco Bangoy International Airport",
    city: "Davao",
    country: "PH",
    continent: "AS",
    lat: 7.1255,
    lon: 125.646,
    elevation: 96,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RPME": {
    icao: "RPME",
    iata: "BXU",
    name: "Bancasi Airport",
    city: "Butuan",
    country: "PH",
    continent: "AS",
    lat: 8.9515,
    lon: 125.4788,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMF": {
    icao: "RPMF",
    iata: "BPH",
    name: "Bislig Airport",
    city: "Bislig",
    country: "PH",
    continent: "AS",
    lat: 8.1951,
    lon: 126.321,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMG": {
    icao: "RPMG",
    iata: "DPL",
    name: "Dipolog Airport",
    city: "Dipolog",
    country: "PH",
    continent: "AS",
    lat: 8.602,
    lon: 123.3419,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMH": {
    icao: "RPMH",
    iata: "CGM",
    name: "Camiguin Airport",
    city: "Mambajao",
    country: "PH",
    continent: "AS",
    lat: 9.2539,
    lon: 124.7091,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMJ": {
    icao: "RPMJ",
    iata: "JOL",
    name: "Jolo Airport",
    city: "Jolo",
    country: "PH",
    continent: "AS",
    lat: 6.0537,
    lon: 121.011,
    elevation: 118,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMN": {
    icao: "RPMN",
    iata: "TWT",
    name: "Sanga Sanga Airport",
    city: "Bongao",
    country: "PH",
    continent: "AS",
    lat: 5.0482,
    lon: 119.7433,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMO": {
    icao: "RPMO",
    iata: "OZC",
    name: "Labo Airport",
    city: "Ozamiz",
    country: "PH",
    continent: "AS",
    lat: 8.1785,
    lon: 123.842,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMP": {
    icao: "RPMP",
    iata: "PAG",
    name: "Pagadian Airport",
    city: "Pagadian",
    country: "PH",
    continent: "AS",
    lat: 7.8256,
    lon: 123.4596,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMQ": {
    icao: "RPMQ",
    iata: "MXI",
    name: "Mati National Airport",
    city: "Mati",
    country: "PH",
    continent: "AS",
    lat: 6.9491,
    lon: 126.2737,
    elevation: 156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMR": {
    icao: "RPMR",
    iata: "GES",
    name: "General Santos International Airport",
    city: "General Santos",
    country: "PH",
    continent: "AS",
    lat: 6.058,
    lon: 125.096,
    elevation: 505,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMS": {
    icao: "RPMS",
    iata: "SUG",
    name: "Surigao Airport",
    city: "Surigao City",
    country: "PH",
    continent: "AS",
    lat: 9.7558,
    lon: 125.4809,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMW": {
    icao: "RPMW",
    iata: "TDG",
    name: "Tandag Airport",
    city: "Tandag",
    country: "PH",
    continent: "AS",
    lat: 9.072,
    lon: 126.1713,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMY": {
    icao: "RPMY",
    iata: "CGY",
    name: "Laguindingan International Airport",
    city: "Laguindingan",
    country: "PH",
    continent: "AS",
    lat: 8.6122,
    lon: 124.4565,
    elevation: 190,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPMZ": {
    icao: "RPMZ",
    iata: "ZAM",
    name: "Zamboanga International Airport",
    city: "Zamboanga",
    country: "PH",
    continent: "AS",
    lat: 6.9224,
    lon: 122.06,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPSP": {
    icao: "RPSP",
    iata: "TAG",
    name: "Bohol-Panglao International Airport",
    city: "Panglao",
    country: "PH",
    continent: "AS",
    lat: 9.573,
    lon: 123.7701,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUB": {
    icao: "RPUB",
    iata: "BAG",
    name: "Loakan Airport",
    city: "Baguio",
    country: "PH",
    continent: "AS",
    lat: 16.375,
    lon: 120.6199,
    elevation: 4251,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUD": {
    icao: "RPUD",
    iata: "DTE",
    name: "Daet Airport",
    city: "Daet",
    country: "PH",
    continent: "AS",
    lat: 14.1292,
    lon: 122.98,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUH": {
    icao: "RPUH",
    iata: "SJI",
    name: "San Jose Airport",
    city: "San Jose",
    country: "PH",
    continent: "AS",
    lat: 12.3615,
    lon: 121.047,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUM": {
    icao: "RPUM",
    iata: "MBO",
    name: "Mamburao Airport",
    city: "Mamburao",
    country: "PH",
    continent: "AS",
    lat: 13.208,
    lon: 120.6055,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUN": {
    icao: "RPUN",
    iata: "WNP",
    name: "Naga Airport",
    city: "Naga",
    country: "PH",
    continent: "AS",
    lat: 13.5849,
    lon: 123.27,
    elevation: 142,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUO": {
    icao: "RPUO",
    iata: "BSO",
    name: "Basco Airport",
    city: "Basco",
    country: "PH",
    continent: "AS",
    lat: 20.4513,
    lon: 121.98,
    elevation: 291,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUR": {
    icao: "RPUR",
    iata: "BQA",
    name: "Dr Juan C Angara Airport",
    city: "Baler",
    country: "PH",
    continent: "AS",
    lat: 15.7293,
    lon: 121.5,
    elevation: 108,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUS": {
    icao: "RPUS",
    iata: "SFE",
    name: "San Fernando Airport",
    city: "San Fernando",
    country: "PH",
    continent: "AS",
    lat: 16.5956,
    lon: 120.303,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUT": {
    icao: "RPUT",
    iata: "TUG",
    name: "Tuguegarao Airport",
    city: "Tuguegarao City",
    country: "PH",
    continent: "AS",
    lat: 17.6434,
    lon: 121.7332,
    elevation: 70,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUV": {
    icao: "RPUV",
    iata: "VRC",
    name: "Virac Airport",
    city: "Virac",
    country: "PH",
    continent: "AS",
    lat: 13.5764,
    lon: 124.206,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUW": {
    icao: "RPUW",
    iata: "MRQ",
    name: "Marinduque Airport",
    city: "Gasan",
    country: "PH",
    continent: "AS",
    lat: 13.361,
    lon: 121.826,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPUY": {
    icao: "RPUY",
    iata: "CYZ",
    name: "Cauayan Airport",
    city: "Cauayan City",
    country: "PH",
    continent: "AS",
    lat: 16.9299,
    lon: 121.753,
    elevation: 200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVA": {
    icao: "RPVA",
    iata: "TAC",
    name: "Daniel Z. Romualdez Airport",
    city: "Tacloban City",
    country: "PH",
    continent: "AS",
    lat: 11.2278,
    lon: 125.0278,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVB": {
    icao: "RPVB",
    iata: "BCD",
    name: "Bacolod-Silay Airport",
    city: "Bacolod City",
    country: "PH",
    continent: "AS",
    lat: 10.7764,
    lon: 123.015,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVC": {
    icao: "RPVC",
    iata: "CYP",
    name: "Calbayog Airport",
    city: "Calbayog City",
    country: "PH",
    continent: "AS",
    lat: 12.0726,
    lon: 124.5451,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVD": {
    icao: "RPVD",
    iata: "DGT",
    name: "Sibulan Airport",
    city: "Dumaguete City",
    country: "PH",
    continent: "AS",
    lat: 9.3342,
    lon: 123.3019,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVE": {
    icao: "RPVE",
    iata: "MPH",
    name: "Godofredo P. Ramos Airport",
    city: "Caticlan",
    country: "PH",
    continent: "AS",
    lat: 11.9245,
    lon: 121.954,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVF": {
    icao: "RPVF",
    iata: "CRM",
    name: "Catarman National Airport",
    city: "Catarman",
    country: "PH",
    continent: "AS",
    lat: 12.5016,
    lon: 124.6353,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVI": {
    icao: "RPVI",
    iata: "ILO",
    name: "Iloilo International Airport",
    city: "Cabatuan",
    country: "PH",
    continent: "AS",
    lat: 10.833,
    lon: 122.4934,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVJ": {
    icao: "RPVJ",
    iata: "MBT",
    name: "Moises R. Espinosa Airport",
    city: "Masbate",
    country: "PH",
    continent: "AS",
    lat: 12.3697,
    lon: 123.6301,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVK": {
    icao: "RPVK",
    iata: "KLO",
    name: "Kalibo International Airport",
    city: "Kalibo",
    country: "PH",
    continent: "AS",
    lat: 11.6794,
    lon: 122.376,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVM": {
    icao: "RPVM",
    iata: "CEB",
    name: "Mactan Cebu International Airport",
    city: "Lapu-Lapu City",
    country: "PH",
    continent: "AS",
    lat: 10.3093,
    lon: 123.9797,
    elevation: 31,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "RPVO": {
    icao: "RPVO",
    iata: "OMC",
    name: "Ormoc Airport",
    city: "Ormoc City",
    country: "PH",
    continent: "AS",
    lat: 11.0577,
    lon: 124.5656,
    elevation: 83,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVP": {
    icao: "RPVP",
    iata: "PPS",
    name: "Puerto Princesa International Airport / PAF Antonio Bautista Air Base",
    city: "Puerto Princesa",
    country: "PH",
    continent: "AS",
    lat: 9.7421,
    lon: 118.759,
    elevation: 71,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVR": {
    icao: "RPVR",
    iata: "RXS",
    name: "Roxas Airport",
    city: "Roxas City",
    country: "PH",
    continent: "AS",
    lat: 11.5977,
    lon: 122.752,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVS": {
    icao: "RPVS",
    iata: "EUQ",
    name: "Evelio Javier Airport",
    city: "San Jose",
    country: "PH",
    continent: "AS",
    lat: 10.7666,
    lon: 121.9325,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVU": {
    icao: "RPVU",
    iata: "TBH",
    name: "Tugdan Airport",
    city: "Tablas Island",
    country: "PH",
    continent: "AS",
    lat: 12.311,
    lon: 122.085,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "RPVV": {
    icao: "RPVV",
    iata: "USU",
    name: "Francisco B. Reyes (Busuanga) Airport",
    city: "Coron",
    country: "PH",
    continent: "AS",
    lat: 12.1219,
    lon: 120.1008,
    elevation: 148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAAC": {
    icao: "SAAC",
    iata: "COC",
    name: "Comodoro Pierrestegui Airport",
    city: "Concordia",
    country: "AR",
    continent: "SA",
    lat: -31.2969,
    lon: -57.9966,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAAG": {
    icao: "SAAG",
    iata: "GHU",
    name: "Gualeguaychu Airport",
    city: "Gualeguaychu",
    country: "AR",
    continent: "SA",
    lat: -33.0056,
    lon: -58.6128,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAAP": {
    icao: "SAAP",
    iata: "PRA",
    name: "General Urquiza Airport",
    city: "Parana",
    country: "AR",
    continent: "SA",
    lat: -31.7948,
    lon: -60.4804,
    elevation: 242,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAAR": {
    icao: "SAAR",
    iata: "ROS",
    name: "Rosario Islas Malvinas International Airport",
    city: "Rosario",
    country: "AR",
    continent: "SA",
    lat: -32.9036,
    lon: -60.785,
    elevation: 85,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAAV": {
    icao: "SAAV",
    iata: "SFN",
    name: "Sauce Viejo Airport",
    city: "Santa Fe",
    country: "AR",
    continent: "SA",
    lat: -31.7117,
    lon: -60.8117,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SABE": {
    icao: "SABE",
    iata: "AEP",
    name: "Jorge Newbery Airpark",
    city: "Buenos Aires",
    country: "AR",
    continent: "SA",
    lat: -34.5592,
    lon: -58.4156,
    elevation: 18,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SACO": {
    icao: "SACO",
    iata: "COR",
    name: "Ingeniero Ambrosio Taravella Airport",
    city: "Cordoba",
    country: "AR",
    continent: "SA",
    lat: -31.3236,
    lon: -64.208,
    elevation: 1604,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SADF": {
    icao: "SADF",
    iata: "",
    name: "San Fernando Airport",
    city: "San Fernando",
    country: "AR",
    continent: "SA",
    lat: -34.4532,
    lon: -58.5896,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SADL": {
    icao: "SADL",
    iata: "LPG",
    name: "La Plata Airport",
    city: "La Plata",
    country: "AR",
    continent: "SA",
    lat: -34.9722,
    lon: -57.8947,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SADP": {
    icao: "SADP",
    iata: "EPA",
    name: "El Palomar Airport",
    city: "El Palomar",
    country: "AR",
    continent: "SA",
    lat: -34.6099,
    lon: -58.6126,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAEZ": {
    icao: "SAEZ",
    iata: "EZE",
    name: "Minister Pistarini International Airport",
    city: "Buenos Aires (Ezeiza)",
    country: "AR",
    continent: "SA",
    lat: -34.8222,
    lon: -58.5358,
    elevation: 67,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SAHS": {
    icao: "SAHS",
    iata: "RDS",
    name: "Rincon De Los Sauces Airport",
    city: "Rincon de los Sauces",
    country: "AR",
    continent: "SA",
    lat: -37.3906,
    lon: -68.9042,
    elevation: 1968,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAHZ": {
    icao: "SAHZ",
    iata: "APZ",
    name: "Zapala Airport",
    city: "Zapala",
    country: "AR",
    continent: "SA",
    lat: -38.9755,
    lon: -70.1136,
    elevation: 3330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAME": {
    icao: "SAME",
    iata: "MDZ",
    name: "El Plumerillo Airport",
    city: "Mendoza",
    country: "AR",
    continent: "SA",
    lat: -32.8317,
    lon: -68.7929,
    elevation: 2310,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAMM": {
    icao: "SAMM",
    iata: "LGS",
    name: "Comodoro D.R. Salomón Airport",
    city: "Malargue",
    country: "AR",
    continent: "SA",
    lat: -35.4936,
    lon: -69.5743,
    elevation: 4685,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAMR": {
    icao: "SAMR",
    iata: "AFA",
    name: "Suboficial Ay Santiago Germano Airport",
    city: "San Rafael",
    country: "AR",
    continent: "SA",
    lat: -34.5883,
    lon: -68.4039,
    elevation: 2470,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SANC": {
    icao: "SANC",
    iata: "CTC",
    name: "Coronel Felipe Varela International Airport",
    city: "Catamarca",
    country: "AR",
    continent: "SA",
    lat: -28.5931,
    lon: -65.7512,
    elevation: 1522,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SANE": {
    icao: "SANE",
    iata: "SDE",
    name: "Vicecomodoro Angel D. La Paz Aragonés Airport",
    city: "Santiago del Estero",
    country: "AR",
    continent: "SA",
    lat: -27.7656,
    lon: -64.31,
    elevation: 656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SANL": {
    icao: "SANL",
    iata: "IRJ",
    name: "Capitan V A Almonacid Airport",
    city: "La Rioja",
    country: "AR",
    continent: "SA",
    lat: -29.3816,
    lon: -66.7958,
    elevation: 1437,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SANR": {
    icao: "SANR",
    iata: "RHD",
    name: "Termas de Río Hondo international Airport",
    city: "Termas de Río Hondo",
    country: "AR",
    continent: "SA",
    lat: -27.4966,
    lon: -64.936,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SANT": {
    icao: "SANT",
    iata: "TUC",
    name: "Teniente Benjamin Matienzo Airport",
    city: "San Miguel de Tucumán",
    country: "AR",
    continent: "SA",
    lat: -26.8409,
    lon: -65.1049,
    elevation: 1493,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SANU": {
    icao: "SANU",
    iata: "UAQ",
    name: "Domingo Faustino Sarmiento Airport",
    city: "San Juan",
    country: "AR",
    continent: "SA",
    lat: -31.5715,
    lon: -68.4182,
    elevation: 1958,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAOC": {
    icao: "SAOC",
    iata: "RCU",
    name: "Area De Material Airport",
    city: "Rio Cuarto",
    country: "AR",
    continent: "SA",
    lat: -33.0851,
    lon: -64.2613,
    elevation: 1380,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAOD": {
    icao: "SAOD",
    iata: "VDR",
    name: "Villa Dolores Airport",
    city: "Villa Dolores",
    country: "AR",
    continent: "SA",
    lat: -31.9452,
    lon: -65.1463,
    elevation: 1847,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAOR": {
    icao: "SAOR",
    iata: "VME",
    name: "Villa Reynolds Airport",
    city: "Villa Mercedes",
    country: "AR",
    continent: "SA",
    lat: -33.7299,
    lon: -65.3874,
    elevation: 1591,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAOU": {
    icao: "SAOU",
    iata: "LUQ",
    name: "Brigadier Mayor D Cesar Raul Ojeda Airport",
    city: "San Luis",
    country: "AR",
    continent: "SA",
    lat: -33.2732,
    lon: -66.3564,
    elevation: 2328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAOV": {
    icao: "SAOV",
    iata: "",
    name: "Presidente Néstor Kirchner Regional Airport",
    city: "Villa Maria",
    country: "AR",
    continent: "SA",
    lat: -32.3201,
    lon: -63.2266,
    elevation: 670,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARC": {
    icao: "SARC",
    iata: "CNQ",
    name: "Corrientes Airport",
    city: "Corrientes",
    country: "AR",
    continent: "SA",
    lat: -27.4455,
    lon: -58.7619,
    elevation: 202,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARE": {
    icao: "SARE",
    iata: "RES",
    name: "Resistencia International Airport",
    city: "Resistencia",
    country: "AR",
    continent: "SA",
    lat: -27.45,
    lon: -59.0561,
    elevation: 173,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARF": {
    icao: "SARF",
    iata: "FMA",
    name: "Formosa National Airport",
    city: "Formosa",
    country: "AR",
    continent: "SA",
    lat: -26.2127,
    lon: -58.2281,
    elevation: 193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARI": {
    icao: "SARI",
    iata: "IGR",
    name: "Cataratas Del Iguazú International Airport",
    city: "Puerto Iguazu",
    country: "AR",
    continent: "SA",
    lat: -25.7373,
    lon: -54.4734,
    elevation: 916,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARL": {
    icao: "SARL",
    iata: "AOL",
    name: "Paso De Los Libres Airport",
    city: "Paso de los Libres",
    country: "AR",
    continent: "SA",
    lat: -29.6894,
    lon: -57.1521,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARM": {
    icao: "SARM",
    iata: "MCS",
    name: "Monte Caseros Airport",
    city: "Monte Caseros",
    country: "AR",
    continent: "SA",
    lat: -30.2719,
    lon: -57.6402,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SARP": {
    icao: "SARP",
    iata: "PSS",
    name: "Libertador Gral D Jose De San Martin Airport",
    city: "Posadas",
    country: "AR",
    continent: "SA",
    lat: -27.3858,
    lon: -55.9707,
    elevation: 430,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SASA": {
    icao: "SASA",
    iata: "SLA",
    name: "Martin Miguel De Guemes International Airport",
    city: "Salta",
    country: "AR",
    continent: "SA",
    lat: -24.856,
    lon: -65.4862,
    elevation: 4088,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SASJ": {
    icao: "SASJ",
    iata: "JUJ",
    name: "Gobernador Horacio Guzman International Airport",
    city: "San Salvador de Jujuy",
    country: "AR",
    continent: "SA",
    lat: -24.3928,
    lon: -65.0978,
    elevation: 3019,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SASO": {
    icao: "SASO",
    iata: "ORA",
    name: "Orán Airport",
    city: "Orán",
    country: "AR",
    continent: "SA",
    lat: -23.1528,
    lon: -64.3292,
    elevation: 1171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAST": {
    icao: "SAST",
    iata: "TTG",
    name: "General Enrique Mosconi Airport",
    city: "Tartagal",
    country: "AR",
    continent: "SA",
    lat: -22.6169,
    lon: -63.793,
    elevation: 1472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SATG": {
    icao: "SATG",
    iata: "OYA",
    name: "Goya Airport",
    city: "Goya",
    country: "AR",
    continent: "SA",
    lat: -29.1058,
    lon: -59.2189,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SATR": {
    icao: "SATR",
    iata: "RCQ",
    name: "Reconquista Airport",
    city: "Reconquista",
    country: "AR",
    continent: "SA",
    lat: -29.2103,
    lon: -59.6833,
    elevation: 160,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SATU": {
    icao: "SATU",
    iata: "UZU",
    name: "Curuzu Cuatia Airport",
    city: "Curuzu Cuatia",
    country: "AR",
    continent: "SA",
    lat: -29.7706,
    lon: -57.9789,
    elevation: 229,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVB": {
    icao: "SAVB",
    iata: "EHL",
    name: "El Bolsón Airfield",
    city: "El Bolsón",
    country: "AR",
    continent: "SA",
    lat: -41.9432,
    lon: -71.5323,
    elevation: 1141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVC": {
    icao: "SAVC",
    iata: "CRD",
    name: "General E. Mosconi Airport",
    city: "Comodoro Rivadavia",
    country: "AR",
    continent: "SA",
    lat: -45.7853,
    lon: -67.4655,
    elevation: 189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVE": {
    icao: "SAVE",
    iata: "EQS",
    name: "Esquel Brigadier Antonio Parodi International Airport",
    city: "Esquel",
    country: "AR",
    continent: "SA",
    lat: -42.908,
    lon: -71.1395,
    elevation: 2621,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVH": {
    icao: "SAVH",
    iata: "LHS",
    name: "Las Heras Airport",
    city: "Las Heras",
    country: "AR",
    continent: "SA",
    lat: -46.5385,
    lon: -68.9653,
    elevation: 1082,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVT": {
    icao: "SAVT",
    iata: "REL",
    name: "Almirante Marco Andres Zar Airport",
    city: "Rawson",
    country: "AR",
    continent: "SA",
    lat: -43.2105,
    lon: -65.2703,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVV": {
    icao: "SAVV",
    iata: "VDM",
    name: "Gobernador Castello Airport",
    city: "Viedma / Carmen de Patagones",
    country: "AR",
    continent: "SA",
    lat: -40.8692,
    lon: -63.0004,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAVY": {
    icao: "SAVY",
    iata: "PMY",
    name: "El Tehuelche Airport",
    city: "Puerto Madryn",
    country: "AR",
    continent: "SA",
    lat: -42.7592,
    lon: -65.1027,
    elevation: 427,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWC": {
    icao: "SAWC",
    iata: "FTE",
    name: "El Calafate - Commander Armando Tola International Airport",
    city: "El Calafate",
    country: "AR",
    continent: "SA",
    lat: -50.2803,
    lon: -72.0531,
    elevation: 669,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWD": {
    icao: "SAWD",
    iata: "PUD",
    name: "Puerto Deseado Airport",
    city: "Puerto Deseado",
    country: "AR",
    continent: "SA",
    lat: -47.7353,
    lon: -65.9041,
    elevation: 268,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWE": {
    icao: "SAWE",
    iata: "RGA",
    name: "Gobernador Ramón Trejo Noel International Airport",
    city: "Rio Grande",
    country: "AR",
    continent: "SA",
    lat: -53.7777,
    lon: -67.7494,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWG": {
    icao: "SAWG",
    iata: "RGL",
    name: "Piloto Civil N. Fernández Airport",
    city: "Rio Gallegos",
    country: "AR",
    continent: "SA",
    lat: -51.6089,
    lon: -69.3126,
    elevation: 61,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWH": {
    icao: "SAWH",
    iata: "USH",
    name: "Ushuaia - Malvinas Argentinas International Airport",
    city: "Ushuaia",
    country: "AR",
    continent: "SA",
    lat: -54.8433,
    lon: -68.2958,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWJ": {
    icao: "SAWJ",
    iata: "ULA",
    name: "Capitan D Daniel Vazquez Airport",
    city: "San Julian",
    country: "AR",
    continent: "SA",
    lat: -49.3068,
    lon: -67.8026,
    elevation: 203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWP": {
    icao: "SAWP",
    iata: "PMQ",
    name: "Perito Moreno Jalil Hamer Airport",
    city: "Perito Moreno",
    country: "AR",
    continent: "SA",
    lat: -46.5379,
    lon: -70.9787,
    elevation: 1410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAWU": {
    icao: "SAWU",
    iata: "RZA",
    name: "Santa Cruz Airport",
    city: "Puerto Santa Cruz",
    country: "AR",
    continent: "SA",
    lat: -50.0165,
    lon: -68.5792,
    elevation: 364,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZB": {
    icao: "SAZB",
    iata: "BHI",
    name: "Comandante Espora Airport",
    city: "Bahía Blanca",
    country: "AR",
    continent: "SA",
    lat: -38.725,
    lon: -62.1693,
    elevation: 246,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZG": {
    icao: "SAZG",
    iata: "GPO",
    name: "General Pico Airport",
    city: "General Pico",
    country: "AR",
    continent: "SA",
    lat: -35.6962,
    lon: -63.7583,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZH": {
    icao: "SAZH",
    iata: "OYO",
    name: "Tres Arroyos Airport",
    city: "Tres Arroyos",
    country: "AR",
    continent: "SA",
    lat: -38.3869,
    lon: -60.3297,
    elevation: 400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZL": {
    icao: "SAZL",
    iata: "SST",
    name: "Santa Teresita Airport",
    city: "Santa Teresita",
    country: "AR",
    continent: "SA",
    lat: -36.5423,
    lon: -56.7218,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZM": {
    icao: "SAZM",
    iata: "MDQ",
    name: "Ástor Piazzola International Airport",
    city: "Mar del Plata",
    country: "AR",
    continent: "SA",
    lat: -37.9342,
    lon: -57.5733,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZN": {
    icao: "SAZN",
    iata: "NQN",
    name: "Presidente Peron Airport",
    city: "Neuquen",
    country: "AR",
    continent: "SA",
    lat: -38.949,
    lon: -68.1557,
    elevation: 895,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZO": {
    icao: "SAZO",
    iata: "NEC",
    name: "Necochea Airport",
    city: "Necochea",
    country: "AR",
    continent: "SA",
    lat: -38.4907,
    lon: -58.8163,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZP": {
    icao: "SAZP",
    iata: "PEH",
    name: "Comodoro Pedro Zanni Airport",
    city: "Pehuajó",
    country: "AR",
    continent: "SA",
    lat: -35.8446,
    lon: -61.8576,
    elevation: 278,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZR": {
    icao: "SAZR",
    iata: "RSA",
    name: "Santa Rosa Airport",
    city: "Santa Rosa",
    country: "AR",
    continent: "SA",
    lat: -36.5883,
    lon: -64.2757,
    elevation: 630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZS": {
    icao: "SAZS",
    iata: "BRC",
    name: "San Carlos de Bariloche Airport",
    city: "San Carlos de Bariloche",
    country: "AR",
    continent: "SA",
    lat: -41.1512,
    lon: -71.1575,
    elevation: 2774,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZT": {
    icao: "SAZT",
    iata: "TDL",
    name: "Héroes de Malvinas Airport",
    city: "Tandil",
    country: "AR",
    continent: "SA",
    lat: -37.2346,
    lon: -59.2286,
    elevation: 574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZV": {
    icao: "SAZV",
    iata: "VLG",
    name: "Villa Gesell Airport",
    city: "Villa Gesell",
    country: "AR",
    continent: "SA",
    lat: -37.2354,
    lon: -57.0292,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZW": {
    icao: "SAZW",
    iata: "CUT",
    name: "Cutral-Co Airport",
    city: "Cutral-Co",
    country: "AR",
    continent: "SA",
    lat: -38.9397,
    lon: -69.2646,
    elevation: 2132,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SAZY": {
    icao: "SAZY",
    iata: "CPC",
    name: "Aviador C. Campos Airport",
    city: "Chapelco/San Martin de los Andes",
    country: "AR",
    continent: "SA",
    lat: -40.0754,
    lon: -71.1373,
    elevation: 2569,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAA": {
    icao: "SBAA",
    iata: "CDJ",
    name: "Conceição do Araguaia Airport",
    city: "Conceição do Araguaia",
    country: "BR",
    continent: "SA",
    lat: -8.3483,
    lon: -49.3015,
    elevation: 653,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAC": {
    icao: "SBAC",
    iata: "ARX",
    name: "Aracati Dragão do Mar Regional Airport",
    city: "Aracati",
    country: "BR",
    continent: "SA",
    lat: -4.5689,
    lon: -37.8051,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAE": {
    icao: "SBAE",
    iata: "JTC",
    name: "Bauru/Arealva–Moussa Nakhal Tobias State Airport",
    city: "Bauru",
    country: "BR",
    continent: "SA",
    lat: -22.1608,
    lon: -49.0703,
    elevation: 1962,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAF": {
    icao: "SBAF",
    iata: "",
    name: "Campo Délio Jardim de Mattos Airport",
    city: "Rio de Janeiro",
    country: "BR",
    continent: "SA",
    lat: -22.8751,
    lon: -43.3847,
    elevation: 110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAN": {
    icao: "SBAN",
    iata: "",
    name: "Anápolis Airbase",
    city: "Anápolis",
    country: "BR",
    continent: "SA",
    lat: -16.2292,
    lon: -48.9643,
    elevation: 3731,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAQ": {
    icao: "SBAQ",
    iata: "AQA",
    name: "Araraquara Airport",
    city: "Araraquara",
    country: "BR",
    continent: "SA",
    lat: -21.812,
    lon: -48.133,
    elevation: 2334,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAR": {
    icao: "SBAR",
    iata: "AJU",
    name: "Aracaju - Santa Maria International Airport",
    city: "Aracaju",
    country: "BR",
    continent: "SA",
    lat: -10.984,
    lon: -37.0703,
    elevation: 139,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAT": {
    icao: "SBAT",
    iata: "AFL",
    name: "Piloto Osvaldo Marques Dias Airport",
    city: "Alta Floresta",
    country: "BR",
    continent: "SA",
    lat: -9.8664,
    lon: -56.1063,
    elevation: 948,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAU": {
    icao: "SBAU",
    iata: "ARU",
    name: "Araçatuba Airport",
    city: "Araçatuba",
    country: "BR",
    continent: "SA",
    lat: -21.1415,
    lon: -50.4246,
    elevation: 1361,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBAX": {
    icao: "SBAX",
    iata: "AAX",
    name: "Romeu Zema Airport",
    city: "Araxá",
    country: "BR",
    continent: "SA",
    lat: -19.5632,
    lon: -46.9604,
    elevation: 3276,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBE": {
    icao: "SBBE",
    iata: "BEL",
    name: "Val de Cans/Júlio Cezar Ribeiro International Airport",
    city: "Belém",
    country: "BR",
    continent: "SA",
    lat: -1.3793,
    lon: -48.4762,
    elevation: 54,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBBG": {
    icao: "SBBG",
    iata: "BGX",
    name: "Comandante Gustavo Kraemer Airport",
    city: "Bagé",
    country: "BR",
    continent: "SA",
    lat: -31.3905,
    lon: -54.1122,
    elevation: 600,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBH": {
    icao: "SBBH",
    iata: "PLU",
    name: "Pampulha - Carlos Drummond de Andrade Airport",
    city: "Belo Horizonte",
    country: "BR",
    continent: "SA",
    lat: -19.8507,
    lon: -43.9503,
    elevation: 2589,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBI": {
    icao: "SBBI",
    iata: "BFH",
    name: "Bacacheri Airport",
    city: "Curitiba",
    country: "BR",
    continent: "SA",
    lat: -25.4051,
    lon: -49.232,
    elevation: 3057,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBQ": {
    icao: "SBBQ",
    iata: "",
    name: "Major Brigadeiro Doorgal Borges Airport",
    city: "Barbacena",
    country: "BR",
    continent: "SA",
    lat: -21.2672,
    lon: -43.761,
    elevation: 3657,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBR": {
    icao: "SBBR",
    iata: "BSB",
    name: "Presidente Juscelino Kubitschek International Airport",
    city: "Brasília",
    country: "BR",
    continent: "SA",
    lat: -15.8692,
    lon: -47.9208,
    elevation: 3497,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBBT": {
    icao: "SBBT",
    iata: "BAT",
    name: "Chafei Amsei Airport",
    city: "Barretos",
    country: "BR",
    continent: "SA",
    lat: -20.5846,
    lon: -48.5941,
    elevation: 1903,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBV": {
    icao: "SBBV",
    iata: "BVB",
    name: "Atlas Brasil Cantanhede Airport",
    city: "Boa Vista",
    country: "BR",
    continent: "SA",
    lat: 2.8459,
    lon: -60.6909,
    elevation: 276,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBW": {
    icao: "SBBW",
    iata: "BPG",
    name: "Barra do Garças Airport",
    city: "Barra do Garças",
    country: "BR",
    continent: "SA",
    lat: -15.8614,
    lon: -52.389,
    elevation: 1147,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBBZ": {
    icao: "SBBZ",
    iata: "BZC",
    name: "Umberto Modiano Airport",
    city: "Cabo Frio",
    country: "BR",
    continent: "SA",
    lat: -22.7709,
    lon: -41.9631,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCA": {
    icao: "SBCA",
    iata: "CAC",
    name: "Coronel Adalberto Mendes da Silva Airport",
    city: "Cascavel",
    country: "BR",
    continent: "SA",
    lat: -25.0003,
    lon: -53.5012,
    elevation: 2481,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCC": {
    icao: "SBCC",
    iata: "",
    name: "Campo de Provas Brigadeiro Veloso",
    city: "Novo Progresso",
    country: "BR",
    continent: "SA",
    lat: -9.3339,
    lon: -54.9654,
    elevation: 1777,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCF": {
    icao: "SBCF",
    iata: "CNF",
    name: "Tancredo Neves International Airport",
    city: "Belo Horizonte",
    country: "BR",
    continent: "SA",
    lat: -19.6357,
    lon: -43.9669,
    elevation: 2721,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBCG": {
    icao: "SBCG",
    iata: "CGR",
    name: "Campo Grande Airport",
    city: "Campo Grande",
    country: "BR",
    continent: "SA",
    lat: -20.47,
    lon: -54.674,
    elevation: 1833,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCH": {
    icao: "SBCH",
    iata: "XAP",
    name: "Serafin Enoss Bertaso Airport",
    city: "Chapecó",
    country: "BR",
    continent: "SA",
    lat: -27.1342,
    lon: -52.6566,
    elevation: 2154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCI": {
    icao: "SBCI",
    iata: "CLN",
    name: "Brig. Lysias Augusto Rodrigues Airport",
    city: "Carolina",
    country: "BR",
    continent: "SA",
    lat: -7.3204,
    lon: -47.4587,
    elevation: 565,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCJ": {
    icao: "SBCJ",
    iata: "CKS",
    name: "Carajás Airport",
    city: "Parauapebas",
    country: "BR",
    continent: "SA",
    lat: -6.1178,
    lon: -50.0034,
    elevation: 2064,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCM": {
    icao: "SBCM",
    iata: "CCM",
    name: "Forquilhinha - Criciúma  Airport",
    city: "Criciúma",
    country: "BR",
    continent: "SA",
    lat: -28.7257,
    lon: -49.4245,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCO": {
    icao: "SBCO",
    iata: "QNS",
    name: "Canoas Air Force Base",
    city: "Porto Alegre",
    country: "BR",
    continent: "SA",
    lat: -29.9459,
    lon: -51.1444,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCP": {
    icao: "SBCP",
    iata: "CAW",
    name: "Bartolomeu Lisandro Airport",
    city: "Campos dos Goytacazes",
    country: "BR",
    continent: "SA",
    lat: -21.6983,
    lon: -41.3017,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCR": {
    icao: "SBCR",
    iata: "CMG",
    name: "Corumbá International Airport",
    city: "Corumbá",
    country: "BR",
    continent: "SA",
    lat: -19.0119,
    lon: -57.6728,
    elevation: 463,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCT": {
    icao: "SBCT",
    iata: "CWB",
    name: "Afonso Pena Airport",
    city: "Curitiba",
    country: "BR",
    continent: "SA",
    lat: -25.5285,
    lon: -49.1758,
    elevation: 2988,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCV": {
    icao: "SBCV",
    iata: "CRQ",
    name: "Caravelas Airport",
    city: "Caravelas",
    country: "BR",
    continent: "SA",
    lat: -17.6523,
    lon: -39.2531,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCX": {
    icao: "SBCX",
    iata: "CXJ",
    name: "Hugo Cantergiani Regional Airport",
    city: "Caxias Do Sul",
    country: "BR",
    continent: "SA",
    lat: -29.1972,
    lon: -51.1876,
    elevation: 2472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCY": {
    icao: "SBCY",
    iata: "CGB",
    name: "Marechal Rondon Airport",
    city: "Cuiabá",
    country: "BR",
    continent: "SA",
    lat: -15.6529,
    lon: -56.1167,
    elevation: 617,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBCZ": {
    icao: "SBCZ",
    iata: "CZS",
    name: "Cruzeiro do Sul Airport",
    city: "Cruzeiro Do Sul",
    country: "BR",
    continent: "SA",
    lat: -7.5999,
    lon: -72.7695,
    elevation: 637,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBDN": {
    icao: "SBDN",
    iata: "PPB",
    name: "Presidente Prudente Airport",
    city: "Presidente Prudente",
    country: "BR",
    continent: "SA",
    lat: -22.1751,
    lon: -51.4246,
    elevation: 1477,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBEG": {
    icao: "SBEG",
    iata: "MAO",
    name: "Eduardo Gomes International Airport",
    city: "Manaus",
    country: "BR",
    continent: "SA",
    lat: -3.0386,
    lon: -60.0497,
    elevation: 264,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBEK": {
    icao: "SBEK",
    iata: "JCR",
    name: "Jacareacanga Airport",
    city: "Jacareacanga",
    country: "BR",
    continent: "SA",
    lat: -6.2332,
    lon: -57.7769,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBFI": {
    icao: "SBFI",
    iata: "IGU",
    name: "Cataratas International Airport",
    city: "Foz do Iguaçu",
    country: "BR",
    continent: "SA",
    lat: -25.5942,
    lon: -54.4894,
    elevation: 786,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBFL": {
    icao: "SBFL",
    iata: "FLN",
    name: "Hercílio Luz International Airport",
    city: "Florianópolis",
    country: "BR",
    continent: "SA",
    lat: -27.6703,
    lon: -48.5525,
    elevation: 16,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBFN": {
    icao: "SBFN",
    iata: "FEN",
    name: "Fernando de Noronha Airport",
    city: "Fernando de Noronha",
    country: "BR",
    continent: "SA",
    lat: -3.8545,
    lon: -32.4233,
    elevation: 193,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBFZ": {
    icao: "SBFZ",
    iata: "FOR",
    name: "Pinto Martins International Airport",
    city: "Fortaleza",
    country: "BR",
    continent: "SA",
    lat: -3.7758,
    lon: -38.5322,
    elevation: 83,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBGL": {
    icao: "SBGL",
    iata: "GIG",
    name: "Rio Galeão – Tom Jobim International Airport",
    city: "Rio De Janeiro",
    country: "BR",
    continent: "SA",
    lat: -22.81,
    lon: -43.2506,
    elevation: 28,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBGM": {
    icao: "SBGM",
    iata: "GJM",
    name: "Guajará-Mirim Airport",
    city: "Guajará-Mirim",
    country: "BR",
    continent: "SA",
    lat: -10.7864,
    lon: -65.2849,
    elevation: 478,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBGO": {
    icao: "SBGO",
    iata: "GYN",
    name: "Santa Genoveva Airport",
    city: "Goiânia",
    country: "BR",
    continent: "SA",
    lat: -16.632,
    lon: -49.2207,
    elevation: 2450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBGR": {
    icao: "SBGR",
    iata: "GRU",
    name: "Guarulhos - Governador André Franco Montoro International Airport",
    city: "São Paulo",
    country: "BR",
    continent: "SA",
    lat: -23.4319,
    lon: -46.4678,
    elevation: 2461,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "SBGV": {
    icao: "SBGV",
    iata: "GVR",
    name: "Coronel Altino Machado Airport",
    city: "Governador Valadares",
    country: "BR",
    continent: "SA",
    lat: -18.8959,
    lon: -41.9829,
    elevation: 561,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBGW": {
    icao: "SBGW",
    iata: "GUJ",
    name: "Edu Chaves Field",
    city: "Guaratinguetá",
    country: "BR",
    continent: "SA",
    lat: -22.7916,
    lon: -45.2048,
    elevation: 1761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBHT": {
    icao: "SBHT",
    iata: "ATM",
    name: "Altamira Interstate Airport",
    city: "Altamira",
    country: "BR",
    continent: "SA",
    lat: -3.2531,
    lon: -52.2539,
    elevation: 368,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBIC": {
    icao: "SBIC",
    iata: "ITA",
    name: "Itacoatiara Airport",
    city: "Itacoatiara",
    country: "BR",
    continent: "SA",
    lat: -3.1265,
    lon: -58.4817,
    elevation: 142,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBIH": {
    icao: "SBIH",
    iata: "ITB",
    name: "Itaituba Airport",
    city: "Itaituba",
    country: "BR",
    continent: "SA",
    lat: -4.2421,
    lon: -56.0007,
    elevation: 110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBIL": {
    icao: "SBIL",
    iata: "IOS",
    name: "Bahia - Jorge Amado Airport",
    city: "Ilhéus",
    country: "BR",
    continent: "SA",
    lat: -14.8159,
    lon: -39.0335,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBIP": {
    icao: "SBIP",
    iata: "IPN",
    name: "Usiminas Airport",
    city: "Ipatinga",
    country: "BR",
    continent: "SA",
    lat: -19.4707,
    lon: -42.4876,
    elevation: 786,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBIZ": {
    icao: "SBIZ",
    iata: "IMP",
    name: "Prefeito Renato Moreira Airport",
    city: "Imperatriz",
    country: "BR",
    continent: "SA",
    lat: -5.5313,
    lon: -47.46,
    elevation: 430,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBJE": {
    icao: "SBJE",
    iata: "JJD",
    name: "Comandante Ariston Pessoa Airport",
    city: "Cruz",
    country: "BR",
    continent: "SA",
    lat: -2.9064,
    lon: -40.3573,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBJF": {
    icao: "SBJF",
    iata: "JDF",
    name: "Francisco de Assis Airport",
    city: "Juiz de Fora",
    country: "BR",
    continent: "SA",
    lat: -21.7915,
    lon: -43.3861,
    elevation: 2989,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBJH": {
    icao: "SBJH",
    iata: "JHF",
    name: "São Paulo Catarina Executive Airport",
    city: "São Roque",
    country: "BR",
    continent: "SA",
    lat: -23.4269,
    lon: -47.1657,
    elevation: 2547,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBJP": {
    icao: "SBJP",
    iata: "JPA",
    name: "Presidente Castro Pinto International Airport",
    city: "João Pessoa",
    country: "BR",
    continent: "SA",
    lat: -7.1487,
    lon: -34.9506,
    elevation: 217,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBJV": {
    icao: "SBJV",
    iata: "JOI",
    name: "Lauro Carneiro de Loyola Airport",
    city: "Joinville",
    country: "BR",
    continent: "SA",
    lat: -26.2245,
    lon: -48.7974,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBKG": {
    icao: "SBKG",
    iata: "CPV",
    name: "Presidente João Suassuna Airport",
    city: "Campina Grande",
    country: "BR",
    continent: "SA",
    lat: -7.2697,
    lon: -35.8961,
    elevation: 1646,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBKP": {
    icao: "SBKP",
    iata: "VCP",
    name: "Viracopos International Airport",
    city: "Campinas",
    country: "BR",
    continent: "SA",
    lat: -23.0074,
    lon: -47.1345,
    elevation: 2170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBLJ": {
    icao: "SBLJ",
    iata: "LAJ",
    name: "Lages Airport",
    city: "Lages",
    country: "BR",
    continent: "SA",
    lat: -27.7821,
    lon: -50.2815,
    elevation: 3065,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBLN": {
    icao: "SBLN",
    iata: "LIP",
    name: "Lins Airport",
    city: "Lins",
    country: "BR",
    continent: "SA",
    lat: -21.6635,
    lon: -49.73,
    elevation: 1575,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBLO": {
    icao: "SBLO",
    iata: "LDB",
    name: "Governor José Richa Airport",
    city: "Londrina",
    country: "BR",
    continent: "SA",
    lat: -23.3344,
    lon: -51.1284,
    elevation: 1867,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBLP": {
    icao: "SBLP",
    iata: "LAZ",
    name: "Bom Jesus da Lapa Airport",
    city: "Bom Jesus da Lapa",
    country: "BR",
    continent: "SA",
    lat: -13.2621,
    lon: -43.4081,
    elevation: 1454,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMA": {
    icao: "SBMA",
    iata: "MAB",
    name: "João Correa da Rocha Airport",
    city: "Marabá",
    country: "BR",
    continent: "SA",
    lat: -5.3686,
    lon: -49.138,
    elevation: 357,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMC": {
    icao: "SBMC",
    iata: "MQH",
    name: "Minaçu Airport",
    city: "Minaçu",
    country: "BR",
    continent: "SA",
    lat: -13.5491,
    lon: -48.1953,
    elevation: 1401,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMD": {
    icao: "SBMD",
    iata: "MEU",
    name: "Monte Dourado - Serra do Areão Airport",
    city: "Almeirim",
    country: "BR",
    continent: "SA",
    lat: -0.8898,
    lon: -52.6022,
    elevation: 677,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBME": {
    icao: "SBME",
    iata: "MEA",
    name: "Macaé Benedito Lacerda Airport",
    city: "Macaé",
    country: "BR",
    continent: "SA",
    lat: -22.343,
    lon: -41.766,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMG": {
    icao: "SBMG",
    iata: "MGF",
    name: "Regional de Maringá - Sílvio Name Júnior Airport",
    city: "Maringá",
    country: "BR",
    continent: "SA",
    lat: -23.4761,
    lon: -52.0162,
    elevation: 1801,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMK": {
    icao: "SBMK",
    iata: "MOC",
    name: "Mário Ribeiro Airport",
    city: "Montes Claros",
    country: "BR",
    continent: "SA",
    lat: -16.7069,
    lon: -43.8189,
    elevation: 2191,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBML": {
    icao: "SBML",
    iata: "MII",
    name: "Frank Miloye Milenkowichi–Marília State Airport",
    city: "Marília",
    country: "BR",
    continent: "SA",
    lat: -22.1969,
    lon: -49.9265,
    elevation: 2134,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMN": {
    icao: "SBMN",
    iata: "PLL",
    name: "Ponta Pelada Airport / Manaus Air Base",
    city: "Manaus",
    country: "BR",
    continent: "SA",
    lat: -3.146,
    lon: -59.9863,
    elevation: 267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMO": {
    icao: "SBMO",
    iata: "MCZ",
    name: "Zumbi dos Palmares Airport",
    city: "Maceió",
    country: "BR",
    continent: "SA",
    lat: -9.5108,
    lon: -35.7917,
    elevation: 387,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMQ": {
    icao: "SBMQ",
    iata: "MCP",
    name: "Macapá - Alberto Alcolumbre International Airport",
    city: "Macapá",
    country: "BR",
    continent: "SA",
    lat: 0.0507,
    lon: -51.0722,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMS": {
    icao: "SBMS",
    iata: "MVF",
    name: "Dix-Sept Rosado Airport",
    city: "Mossoró",
    country: "BR",
    continent: "SA",
    lat: -5.2019,
    lon: -37.3643,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMT": {
    icao: "SBMT",
    iata: "RTE",
    name: "Campo de Marte Airport",
    city: "São Paulo",
    country: "BR",
    continent: "SA",
    lat: -23.5091,
    lon: -46.6378,
    elevation: 2371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBMY": {
    icao: "SBMY",
    iata: "MNX",
    name: "Manicoré Airport",
    city: "Manicoré",
    country: "BR",
    continent: "SA",
    lat: -5.8114,
    lon: -61.2783,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBNF": {
    icao: "SBNF",
    iata: "NVT",
    name: "Ministro Victor Konder International Airport",
    city: "Navegantes",
    country: "BR",
    continent: "SA",
    lat: -26.8794,
    lon: -48.651,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBNM": {
    icao: "SBNM",
    iata: "GEL",
    name: "Santo Ângelo Airport",
    city: "Santo Ângelo",
    country: "BR",
    continent: "SA",
    lat: -28.2825,
    lon: -54.1696,
    elevation: 1056,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBNT": {
    icao: "SBNT",
    iata: "",
    name: "Natal Air Force Base",
    city: "Natal",
    country: "BR",
    continent: "SA",
    lat: -5.9114,
    lon: -35.2477,
    elevation: 171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBOI": {
    icao: "SBOI",
    iata: "OYK",
    name: "Oiapoque Airport",
    city: "Oiapoque",
    country: "BR",
    continent: "SA",
    lat: 3.8541,
    lon: -51.7971,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPA": {
    icao: "SBPA",
    iata: "POA",
    name: "Salgado Filho International Airport",
    city: "Porto Alegre",
    country: "BR",
    continent: "SA",
    lat: -29.9947,
    lon: -51.1666,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPB": {
    icao: "SBPB",
    iata: "PHB",
    name: "Parnaíba - Prefeito Doutor João Silva Filho International Airport",
    city: "Parnaíba",
    country: "BR",
    continent: "SA",
    lat: -2.8937,
    lon: -41.732,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPC": {
    icao: "SBPC",
    iata: "POO",
    name: "Poços de Caldas - Embaixador Walther Moreira Salles Airport",
    city: "Poços De Caldas",
    country: "BR",
    continent: "SA",
    lat: -21.8425,
    lon: -46.5698,
    elevation: 4138,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPF": {
    icao: "SBPF",
    iata: "PFB",
    name: "Lauro Kurtz Airport",
    city: "Passo Fundo",
    country: "BR",
    continent: "SA",
    lat: -28.244,
    lon: -52.3278,
    elevation: 2380,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPG": {
    icao: "SBPG",
    iata: "PGZ",
    name: "Ponta Grossa Airport - Comandante Antonio Amilton Beraldo",
    city: "Ponta Grossa",
    country: "BR",
    continent: "SA",
    lat: -25.1845,
    lon: -50.1438,
    elevation: 2588,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPJ": {
    icao: "SBPJ",
    iata: "PMW",
    name: "Brigadeiro Lysias Rodrigues Airport",
    city: "Palmas",
    country: "BR",
    continent: "SA",
    lat: -10.2915,
    lon: -48.357,
    elevation: 774,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPK": {
    icao: "SBPK",
    iata: "PET",
    name: "João Simões Lopes Neto International Airport",
    city: "Pelotas",
    country: "BR",
    continent: "SA",
    lat: -31.7173,
    lon: -52.328,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPL": {
    icao: "SBPL",
    iata: "PNZ",
    name: "Senador Nilo Coelho Airport",
    city: "Petrolina",
    country: "BR",
    continent: "SA",
    lat: -9.3624,
    lon: -40.5691,
    elevation: 1263,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPN": {
    icao: "SBPN",
    iata: "PNB",
    name: "Porto Nacional Airport",
    city: "Porto Nacional",
    country: "BR",
    continent: "SA",
    lat: -10.7194,
    lon: -48.3997,
    elevation: 870,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPP": {
    icao: "SBPP",
    iata: "PMG",
    name: "Ponta Porã Airport",
    city: "Ponta Porã",
    country: "BR",
    continent: "SA",
    lat: -22.5496,
    lon: -55.7026,
    elevation: 2156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBPS": {
    icao: "SBPS",
    iata: "BPS",
    name: "Porto Seguro Airport",
    city: "Porto Seguro",
    country: "BR",
    continent: "SA",
    lat: -16.4384,
    lon: -39.0806,
    elevation: 169,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBPV": {
    icao: "SBPV",
    iata: "PVH",
    name: "Governador Jorge Teixeira de Oliveira Airport",
    city: "Porto Velho",
    country: "BR",
    continent: "SA",
    lat: -8.7079,
    lon: -63.9024,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBRB": {
    icao: "SBRB",
    iata: "RBR",
    name: "Rio Branco-Plácido de Castro International Airport",
    city: "Rio Branco",
    country: "BR",
    continent: "SA",
    lat: -9.869,
    lon: -67.894,
    elevation: 633,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBRD": {
    icao: "SBRD",
    iata: "ROO",
    name: "Maestro Marinho Franco Airport",
    city: "Rondonópolis",
    country: "BR",
    continent: "SA",
    lat: -16.5843,
    lon: -54.7248,
    elevation: 1467,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBRF": {
    icao: "SBRF",
    iata: "REC",
    name: "Recife/Guararapes - Gilberto Freyre International Airport",
    city: "Recife",
    country: "BR",
    continent: "SA",
    lat: -8.126,
    lon: -34.9233,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBRJ": {
    icao: "SBRJ",
    iata: "SDU",
    name: "Santos Dumont Airport",
    city: "Rio de Janeiro",
    country: "BR",
    continent: "SA",
    lat: -22.9105,
    lon: -43.1631,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBRP": {
    icao: "SBRP",
    iata: "RAO",
    name: "Leite Lopes Airport",
    city: "Ribeirão Preto",
    country: "BR",
    continent: "SA",
    lat: -21.1343,
    lon: -47.7741,
    elevation: 1805,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSC": {
    icao: "SBSC",
    iata: "SNZ",
    name: "Santa Cruz Air Force Base",
    city: "Rio de Janeiro",
    country: "BR",
    continent: "SA",
    lat: -22.9324,
    lon: -43.7191,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSG": {
    icao: "SBSG",
    iata: "NAT",
    name: "São Gonçalo do Amarante - Governador Aluízio Alves International Airport",
    city: "Natal",
    country: "BR",
    continent: "SA",
    lat: -5.7698,
    lon: -35.3666,
    elevation: 272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSJ": {
    icao: "SBSJ",
    iata: "SJK",
    name: "Professor Urbano Ernesto Stumpf Airport",
    city: "São José Dos Campos",
    country: "BR",
    continent: "SA",
    lat: -23.2292,
    lon: -45.8615,
    elevation: 2120,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSL": {
    icao: "SBSL",
    iata: "SLZ",
    name: "Marechal Cunha Machado International Airport",
    city: "São Luís",
    country: "BR",
    continent: "SA",
    lat: -2.5854,
    lon: -44.2341,
    elevation: 178,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSM": {
    icao: "SBSM",
    iata: "RIA",
    name: "Santa Maria Airport",
    city: "Santa Maria",
    country: "BR",
    continent: "SA",
    lat: -29.7114,
    lon: -53.6882,
    elevation: 287,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSN": {
    icao: "SBSN",
    iata: "STM",
    name: "Santarém - Maestro Wilson Fonseca International Airport",
    city: "Santarém",
    country: "BR",
    continent: "SA",
    lat: -2.4224,
    lon: -54.7931,
    elevation: 198,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSP": {
    icao: "SBSP",
    iata: "CGH",
    name: "Congonhas Airport",
    city: "São Paulo",
    country: "BR",
    continent: "SA",
    lat: -23.6277,
    lon: -46.6546,
    elevation: 2631,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSR": {
    icao: "SBSR",
    iata: "SJP",
    name: "Prof. Eribelto Manoel Reino State Airport",
    city: "São José do Rio Preto",
    country: "BR",
    continent: "SA",
    lat: -20.8171,
    lon: -49.407,
    elevation: 1784,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBST": {
    icao: "SBST",
    iata: "SSZ",
    name: "Santos Nero Moura Air Base / Guarujá Airport",
    city: "Guarujá",
    country: "BR",
    continent: "SA",
    lat: -23.9282,
    lon: -46.3002,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBSV": {
    icao: "SBSV",
    iata: "SSA",
    name: "Deputado Luiz Eduardo Magalhães International Airport",
    city: "Salvador",
    country: "BR",
    continent: "SA",
    lat: -12.9086,
    lon: -38.3225,
    elevation: 64,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBTA": {
    icao: "SBTA",
    iata: "",
    name: "Base de Aviação de Taubaté",
    city: "Taubaté",
    country: "BR",
    continent: "SA",
    lat: -23.0401,
    lon: -45.5162,
    elevation: 1902,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTB": {
    icao: "SBTB",
    iata: "TMT",
    name: "Trombetas Airport",
    city: "Oriximiná",
    country: "BR",
    continent: "SA",
    lat: -1.4896,
    lon: -56.3968,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTE": {
    icao: "SBTE",
    iata: "THE",
    name: "Senador Petrônio Portela Airport",
    city: "Teresina",
    country: "BR",
    continent: "SA",
    lat: -5.0602,
    lon: -42.8237,
    elevation: 219,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTF": {
    icao: "SBTF",
    iata: "TFF",
    name: "Tefé Airport",
    city: "Tefé",
    country: "BR",
    continent: "SA",
    lat: -3.3829,
    lon: -64.7241,
    elevation: 186,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTK": {
    icao: "SBTK",
    iata: "TRQ",
    name: "Tarauacá Airport",
    city: "Tarauacá",
    country: "BR",
    continent: "SA",
    lat: -8.1555,
    lon: -70.783,
    elevation: 646,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTL": {
    icao: "SBTL",
    iata: "TEC",
    name: "Telêmaco Borba Airport",
    city: "Telêmaco Borba",
    country: "BR",
    continent: "SA",
    lat: -24.3178,
    lon: -50.6516,
    elevation: 2610,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTS": {
    icao: "SBTS",
    iata: "",
    name: "Tiriós Airport",
    city: "Aldeia Tiriós",
    country: "BR",
    continent: "SA",
    lat: 2.2245,
    lon: -55.9447,
    elevation: 1127,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTT": {
    icao: "SBTT",
    iata: "TBT",
    name: "Tabatinga Airport",
    city: "Tabatinga",
    country: "BR",
    continent: "SA",
    lat: -4.2557,
    lon: -69.9358,
    elevation: 263,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBTU": {
    icao: "SBTU",
    iata: "TUR",
    name: "Tucuruí Airport",
    city: "Tucuruí",
    country: "BR",
    continent: "SA",
    lat: -3.786,
    lon: -49.7203,
    elevation: 830,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBUA": {
    icao: "SBUA",
    iata: "SJL",
    name: "São Gabriel da Cachoeira Airport",
    city: "São Gabriel da Cachoeira",
    country: "BR",
    continent: "SA",
    lat: -0.1484,
    lon: -66.9855,
    elevation: 249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBUF": {
    icao: "SBUF",
    iata: "PAV",
    name: "Paulo Afonso Airport",
    city: "Paulo Afonso",
    country: "BR",
    continent: "SA",
    lat: -9.4009,
    lon: -38.2506,
    elevation: 883,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBUG": {
    icao: "SBUG",
    iata: "URG",
    name: "Rubem Berta Airport",
    city: "Uruguaiana",
    country: "BR",
    continent: "SA",
    lat: -29.7822,
    lon: -57.0382,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBUL": {
    icao: "SBUL",
    iata: "UDI",
    name: "Ten. Cel. Aviador César Bombonato Airport",
    city: "Uberlândia",
    country: "BR",
    continent: "SA",
    lat: -18.8836,
    lon: -48.2259,
    elevation: 3094,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBUR": {
    icao: "SBUR",
    iata: "UBA",
    name: "Mário de Almeida Franco Airport",
    city: "Uberaba",
    country: "BR",
    continent: "SA",
    lat: -19.765,
    lon: -47.9648,
    elevation: 2655,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBVG": {
    icao: "SBVG",
    iata: "VAG",
    name: "Major Brigadeiro Trompowsky Airport",
    city: "Varginha",
    country: "BR",
    continent: "SA",
    lat: -21.5914,
    lon: -45.4741,
    elevation: 3025,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBVH": {
    icao: "SBVH",
    iata: "BVH",
    name: "Brigadeiro Camarão Airport",
    city: "Vilhena",
    country: "BR",
    continent: "SA",
    lat: -12.6944,
    lon: -60.0983,
    elevation: 2018,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBVT": {
    icao: "SBVT",
    iata: "VIX",
    name: "Eurico de Aguiar Salles Airport",
    city: "Vitória",
    country: "BR",
    continent: "SA",
    lat: -20.258,
    lon: -40.285,
    elevation: 34,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SBYS": {
    icao: "SBYS",
    iata: "QPS",
    name: "Campo Fontenelle",
    city: "Pirassununga",
    country: "BR",
    continent: "SA",
    lat: -21.9847,
    lon: -47.3412,
    elevation: 1968,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SBZM": {
    icao: "SBZM",
    iata: "IZA",
    name: "Presidente Itamar Franco Airport",
    city: "Juiz de Fora",
    country: "BR",
    continent: "SA",
    lat: -21.5131,
    lon: -43.1731,
    elevation: 1348,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCAR": {
    icao: "SCAR",
    iata: "ARI",
    name: "Chacalluta Airport",
    city: "Arica",
    country: "CL",
    continent: "SA",
    lat: -18.3485,
    lon: -70.3387,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCAT": {
    icao: "SCAT",
    iata: "CPO",
    name: "Desierto de Atacama Airport",
    city: "Copiapo",
    country: "CL",
    continent: "SA",
    lat: -27.2612,
    lon: -70.7792,
    elevation: 670,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCBA": {
    icao: "SCBA",
    iata: "BBA",
    name: "Balmaceda Airport",
    city: "Balmaceda",
    country: "CL",
    continent: "SA",
    lat: -45.916,
    lon: -71.6895,
    elevation: 1722,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCBE": {
    icao: "SCBE",
    iata: "TOQ",
    name: "Barriles Airport",
    city: "Tocopilla",
    country: "CL",
    continent: "SA",
    lat: -22.1411,
    lon: -70.0629,
    elevation: 3475,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCCC": {
    icao: "SCCC",
    iata: "CCH",
    name: "Chile Chico Airport",
    city: "Chile Chico",
    country: "CL",
    continent: "SA",
    lat: -46.5831,
    lon: -71.6863,
    elevation: 1070,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCCF": {
    icao: "SCCF",
    iata: "CJC",
    name: "El Loa Airport",
    city: "Calama",
    country: "CL",
    continent: "SA",
    lat: -22.4982,
    lon: -68.9036,
    elevation: 7543,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCCH": {
    icao: "SCCH",
    iata: "YAI",
    name: "Gral. Bernardo O´Higgins Airport",
    city: "Chillan",
    country: "CL",
    continent: "SA",
    lat: -36.5825,
    lon: -72.0314,
    elevation: 495,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCCI": {
    icao: "SCCI",
    iata: "PUQ",
    name: "President Carlos Ibañez del Campo International Airport",
    city: "Punta Arenas",
    country: "CL",
    continent: "SA",
    lat: -53.0026,
    lon: -70.8546,
    elevation: 139,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCCY": {
    icao: "SCCY",
    iata: "GXQ",
    name: "Teniente Vidal Airport",
    city: "Coyhaique",
    country: "CL",
    continent: "SA",
    lat: -45.5942,
    lon: -72.1061,
    elevation: 1020,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCDA": {
    icao: "SCDA",
    iata: "IQQ",
    name: "Diego Aracena Airport",
    city: "Iquique",
    country: "CL",
    continent: "SA",
    lat: -20.5352,
    lon: -70.1813,
    elevation: 155,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCEL": {
    icao: "SCEL",
    iata: "SCL",
    name: "Comodoro Arturo Merino Benítez International Airport",
    city: "Santiago",
    country: "CL",
    continent: "SA",
    lat: -33.393,
    lon: -70.7858,
    elevation: 1555,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SCES": {
    icao: "SCES",
    iata: "ESR",
    name: "Ricardo García Posada Airport",
    city: "El Salvador",
    country: "CL",
    continent: "SA",
    lat: -26.3111,
    lon: -69.7652,
    elevation: 5240,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCFA": {
    icao: "SCFA",
    iata: "ANF",
    name: "Andrés Sabella Gálvez International Airport",
    city: "Antofagasta",
    country: "CL",
    continent: "SA",
    lat: -23.4445,
    lon: -70.4451,
    elevation: 455,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCFM": {
    icao: "SCFM",
    iata: "WPR",
    name: "Captain Fuentes Martinez Airport",
    city: "Porvenir",
    country: "CL",
    continent: "SA",
    lat: -53.2537,
    lon: -70.3192,
    elevation: 104,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCGZ": {
    icao: "SCGZ",
    iata: "WPU",
    name: "Guardia Marina Zañartu Airport",
    city: "Puerto Williams",
    country: "CL",
    continent: "SA",
    lat: -54.9311,
    lon: -67.6263,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCHR": {
    icao: "SCHR",
    iata: "LGR",
    name: "Cochrane Airport",
    city: "Cochrane",
    country: "CL",
    continent: "SA",
    lat: -47.2436,
    lon: -72.5881,
    elevation: 643,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCIE": {
    icao: "SCIE",
    iata: "CCP",
    name: "Carriel Sur Airport",
    city: "Concepcion",
    country: "CL",
    continent: "SA",
    lat: -36.7727,
    lon: -73.0631,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCIP": {
    icao: "SCIP",
    iata: "IPC",
    name: "Mataveri Airport",
    city: "Isla De Pascua",
    country: "CL",
    continent: "SA",
    lat: -27.1648,
    lon: -109.422,
    elevation: 227,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCJO": {
    icao: "SCJO",
    iata: "ZOS",
    name: "Cañal Bajo Carlos Hott Siebert Airport",
    city: "Osorno",
    country: "CL",
    continent: "SA",
    lat: -40.6112,
    lon: -73.061,
    elevation: 187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCLL": {
    icao: "SCLL",
    iata: "VLR",
    name: "Vallenar Airport",
    city: "Vallenar",
    country: "CL",
    continent: "SA",
    lat: -28.5964,
    lon: -70.756,
    elevation: 1725,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCNT": {
    icao: "SCNT",
    iata: "PNT",
    name: "Lieutenant Julio Gallardo Airport",
    city: "Puerto Natales",
    country: "CL",
    continent: "SA",
    lat: -51.6707,
    lon: -72.5291,
    elevation: 217,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCQP": {
    icao: "SCQP",
    iata: "ZCO",
    name: "La Araucanía Airport",
    city: "Temuco",
    country: "CL",
    continent: "SA",
    lat: -38.9259,
    lon: -72.6515,
    elevation: 333,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCRA": {
    icao: "SCRA",
    iata: "CNR",
    name: "Chañaral Airport",
    city: "Chañaral",
    country: "CL",
    continent: "SA",
    lat: -26.3325,
    lon: -70.6073,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCRG": {
    icao: "SCRG",
    iata: "",
    name: "La Independencia Airport",
    city: "Rancagua",
    country: "CL",
    continent: "SA",
    lat: -34.1737,
    lon: -70.7757,
    elevation: 1610,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCSE": {
    icao: "SCSE",
    iata: "LSC",
    name: "La Florida Airport",
    city: "La Serena-Coquimbo",
    country: "CL",
    continent: "SA",
    lat: -29.9162,
    lon: -71.1995,
    elevation: 481,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCTC": {
    icao: "SCTC",
    iata: "PZS",
    name: "Maquehue Airport",
    city: "Temuco",
    country: "CL",
    continent: "SA",
    lat: -38.7668,
    lon: -72.6371,
    elevation: 304,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCTE": {
    icao: "SCTE",
    iata: "PMC",
    name: "El Tepual Airport",
    city: "Puerto Montt",
    country: "CL",
    continent: "SA",
    lat: -41.4389,
    lon: -73.094,
    elevation: 294,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCTL": {
    icao: "SCTL",
    iata: "TLX",
    name: "Panguilemo Airport",
    city: "Talca",
    country: "CL",
    continent: "SA",
    lat: -35.3778,
    lon: -71.6017,
    elevation: 371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCTN": {
    icao: "SCTN",
    iata: "WCH",
    name: "Nuevo Chaitén Airport",
    city: "Chaitén",
    country: "CL",
    continent: "SA",
    lat: -42.7819,
    lon: -72.835,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCTO": {
    icao: "SCTO",
    iata: "ZIC",
    name: "Victoria Airport",
    city: "Victoria",
    country: "CL",
    continent: "SA",
    lat: -38.2456,
    lon: -72.3486,
    elevation: 1148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCTT": {
    icao: "SCTT",
    iata: "TTC",
    name: "Las Breas Airport",
    city: "Taltal",
    country: "CL",
    continent: "SA",
    lat: -25.5643,
    lon: -70.3759,
    elevation: 2580,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCVD": {
    icao: "SCVD",
    iata: "ZAL",
    name: "Pichoy Airport",
    city: "Valdivia",
    country: "CL",
    continent: "SA",
    lat: -39.65,
    lon: -73.0861,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SCVM": {
    icao: "SCVM",
    iata: "KNA",
    name: "Viña del Mar Airport",
    city: "Viña del Mar",
    country: "CL",
    continent: "SA",
    lat: -32.9496,
    lon: -71.4786,
    elevation: 461,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEAM": {
    icao: "SEAM",
    iata: "ATF",
    name: "Chachoán Regional Airport",
    city: "Ambato",
    country: "EC",
    continent: "SA",
    lat: -1.2121,
    lon: -78.5746,
    elevation: 8502,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SECO": {
    icao: "SECO",
    iata: "OCC",
    name: "Francisco De Orellana Airport",
    city: "Coca",
    country: "EC",
    continent: "SA",
    lat: -0.4629,
    lon: -76.9868,
    elevation: 834,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SECU": {
    icao: "SECU",
    iata: "CUE",
    name: "Mariscal Lamar Airport",
    city: "Cuenca",
    country: "EC",
    continent: "SA",
    lat: -2.8895,
    lon: -78.9844,
    elevation: 8306,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEGU": {
    icao: "SEGU",
    iata: "GYE",
    name: "José Joaquín de Olmedo International Airport",
    city: "Guayaquil",
    country: "EC",
    continent: "SA",
    lat: -2.1574,
    lon: -79.8836,
    elevation: 19,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SEJD": {
    icao: "SEJD",
    iata: "TNW",
    name: "Jumandy Airport",
    city: "Ahuano",
    country: "EC",
    continent: "SA",
    lat: -1.0602,
    lon: -77.5805,
    elevation: 1234,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SELT": {
    icao: "SELT",
    iata: "LTX",
    name: "Cotopaxi International Airport",
    city: "Latacunga",
    country: "EC",
    continent: "SA",
    lat: -0.9068,
    lon: -78.6158,
    elevation: 9205,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEMA": {
    icao: "SEMA",
    iata: "MRR",
    name: "Jose Maria Velasco Ibarra Airport",
    city: "Macará",
    country: "EC",
    continent: "SA",
    lat: -4.3782,
    lon: -79.941,
    elevation: 1508,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEMC": {
    icao: "SEMC",
    iata: "XMS",
    name: "Coronel E Carvajal Airport",
    city: "Macas",
    country: "EC",
    continent: "SA",
    lat: -2.2992,
    lon: -78.1208,
    elevation: 3452,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEMT": {
    icao: "SEMT",
    iata: "MEC",
    name: "Eloy Alfaro International Airport",
    city: "Manta",
    country: "EC",
    continent: "SA",
    lat: -0.9461,
    lon: -80.6788,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEPV": {
    icao: "SEPV",
    iata: "PVO",
    name: "Reales Tamarindos Airport",
    city: "Portoviejo",
    country: "EC",
    continent: "SA",
    lat: -1.0416,
    lon: -80.4722,
    elevation: 130,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SEQM": {
    icao: "SEQM",
    iata: "UIO",
    name: "Mariscal Sucre International Airport",
    city: "Quito",
    country: "EC",
    continent: "SA",
    lat: -0.1254,
    lon: -78.3543,
    elevation: 7841,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SERO": {
    icao: "SERO",
    iata: "ETR",
    name: "Santa Rosa - Artillery Colonel Victor Larrea International Airport",
    city: "Santa Rosa",
    country: "EC",
    continent: "SA",
    lat: -3.442,
    lon: -79.997,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SESA": {
    icao: "SESA",
    iata: "SNC",
    name: "General Ulpiano Paez Airport",
    city: "Salinas",
    country: "EC",
    continent: "SA",
    lat: -2.2101,
    lon: -80.9851,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SETN": {
    icao: "SETN",
    iata: "ESM",
    name: "Carlos Concha Torres International Airport",
    city: "Tachina",
    country: "EC",
    continent: "SA",
    lat: 0.9785,
    lon: -79.6266,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SETR": {
    icao: "SETR",
    iata: "TPC",
    name: "Tarapoa Airport",
    city: "Tarapoa",
    country: "EC",
    continent: "SA",
    lat: -0.123,
    lon: -76.3378,
    elevation: 814,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SETU": {
    icao: "SETU",
    iata: "TUA",
    name: "Lieutenant Colonel Luis A. Mantilla International Airport",
    city: "Tulcán",
    country: "EC",
    continent: "SA",
    lat: 0.8095,
    lon: -77.7081,
    elevation: 9649,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SFAL": {
    icao: "SFAL",
    iata: "PSY",
    name: "Port Stanley Airport",
    city: "Stanley",
    country: "FK",
    continent: "SA",
    lat: -51.6857,
    lon: -57.7776,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SGAS": {
    icao: "SGAS",
    iata: "ASU",
    name: "Aeropuerto Internacional Silvio Pettirossi",
    city: "Asunción",
    country: "PY",
    continent: "SA",
    lat: -25.2402,
    lon: -57.5192,
    elevation: 292,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SGAY": {
    icao: "SGAY",
    iata: "AYO",
    name: "Aeropuerto Nacional Juan de Ayolas",
    city: "Ayolas",
    country: "PY",
    continent: "SA",
    lat: -27.3784,
    lon: -56.8568,
    elevation: 223,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SGCO": {
    icao: "SGCO",
    iata: "CIO",
    name: "Aeropuerto Nacional Tte. Cnel. Carmelo Peralta",
    city: "Concepción",
    country: "PY",
    continent: "SA",
    lat: -23.4403,
    lon: -57.4292,
    elevation: 253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SGEN": {
    icao: "SGEN",
    iata: "ENO",
    name: "Aeropuerto Internacional Tte. Amín Ayub González",
    city: "Encarnación",
    country: "PY",
    continent: "SA",
    lat: -27.2275,
    lon: -55.8376,
    elevation: 659,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SGES": {
    icao: "SGES",
    iata: "AGT",
    name: "Aeropuerto Internacional Guaraní",
    city: "Ciudad del Este",
    country: "PY",
    continent: "SA",
    lat: -25.4572,
    lon: -54.8395,
    elevation: 846,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SGGR": {
    icao: "SGGR",
    iata: "",
    name: "Aeropuerto Nacional de Salto del Guaira",
    city: "Salto del Guaira",
    country: "PY",
    continent: "SA",
    lat: -24.0328,
    lon: -54.3527,
    elevation: 990,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SGIB": {
    icao: "SGIB",
    iata: "",
    name: "Aeropuerto Nacional de Itaipú",
    city: "Itaipú",
    country: "PY",
    continent: "SA",
    lat: -25.4078,
    lon: -54.6195,
    elevation: 762,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SGME": {
    icao: "SGME",
    iata: "ESG",
    name: "Aeropuerto Internacional Dr. Luis Maria Argaña",
    city: "Mariscal Estigarribia",
    country: "PY",
    continent: "SA",
    lat: -22.0465,
    lon: -60.6217,
    elevation: 553,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SGPI": {
    icao: "SGPI",
    iata: "PIL",
    name: "Aeródromo Don Carlos Miguel Gimenez",
    city: "Pilar",
    country: "PY",
    continent: "SA",
    lat: -26.882,
    lon: -58.3191,
    elevation: 249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SGPJ": {
    icao: "SGPJ",
    iata: "PJC",
    name: "Aeropuerto Nacional Dr. Augusto Roberto Fuster",
    city: "Pedro Juan Caballero",
    country: "PY",
    continent: "SA",
    lat: -22.6414,
    lon: -55.83,
    elevation: 1873,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKAP": {
    icao: "SKAP",
    iata: "API",
    name: "Gomez Nino Apiay Air Base",
    city: "Apiay",
    country: "CO",
    continent: "SA",
    lat: 4.0761,
    lon: -73.5627,
    elevation: 1207,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKAR": {
    icao: "SKAR",
    iata: "AXM",
    name: "El Eden Airport",
    city: "Armenia",
    country: "CO",
    continent: "SA",
    lat: 4.4528,
    lon: -75.7664,
    elevation: 3990,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKAS": {
    icao: "SKAS",
    iata: "PUU",
    name: "Tres De Mayo Airport",
    city: "Puerto Asís",
    country: "CO",
    continent: "SA",
    lat: 0.5052,
    lon: -76.5008,
    elevation: 815,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKBC": {
    icao: "SKBC",
    iata: "ELB",
    name: "Las Flores Airport",
    city: "El Banco",
    country: "CO",
    continent: "SA",
    lat: 9.0455,
    lon: -73.9749,
    elevation: 111,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKBG": {
    icao: "SKBG",
    iata: "BGA",
    name: "Palonegro Airport",
    city: "Bucaramanga",
    country: "CO",
    continent: "SA",
    lat: 7.1265,
    lon: -73.1848,
    elevation: 3897,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKBO": {
    icao: "SKBO",
    iata: "BOG",
    name: "El Dorado International Airport",
    city: "Bogota",
    country: "CO",
    continent: "SA",
    lat: 4.7016,
    lon: -74.1469,
    elevation: 8361,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SKBQ": {
    icao: "SKBQ",
    iata: "BAQ",
    name: "Ernesto Cortissoz International Airport",
    city: "Barranquilla",
    country: "CO",
    continent: "SA",
    lat: 10.8896,
    lon: -74.7808,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKBS": {
    icao: "SKBS",
    iata: "BSC",
    name: "José Celestino Mutis Airport",
    city: "Bahía Solano",
    country: "CO",
    continent: "SA",
    lat: 6.2029,
    lon: -77.3947,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKBU": {
    icao: "SKBU",
    iata: "BUN",
    name: "Gerardo Tobar López Airport",
    city: "Buenaventura",
    country: "CO",
    continent: "SA",
    lat: 3.8196,
    lon: -76.9898,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCC": {
    icao: "SKCC",
    iata: "CUC",
    name: "Camilo Daza International Airport",
    city: "Cúcuta",
    country: "CO",
    continent: "SA",
    lat: 7.9276,
    lon: -72.5115,
    elevation: 1096,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCG": {
    icao: "SKCG",
    iata: "CTG",
    name: "Rafael Nuñez International Airport",
    city: "Cartagena",
    country: "CO",
    continent: "SA",
    lat: 10.4424,
    lon: -75.513,
    elevation: 4,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCL": {
    icao: "SKCL",
    iata: "CLO",
    name: "Alfonso Bonilla Aragon International Airport",
    city: "Cali",
    country: "CO",
    continent: "SA",
    lat: 3.5432,
    lon: -76.3816,
    elevation: 3162,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCO": {
    icao: "SKCO",
    iata: "TCO",
    name: "La Florida Airport",
    city: "Tumaco",
    country: "CO",
    continent: "SA",
    lat: 1.8144,
    lon: -78.7492,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCU": {
    icao: "SKCU",
    iata: "CAQ",
    name: "Juan H White Airport",
    city: "Caucasia",
    country: "CO",
    continent: "SA",
    lat: 7.9685,
    lon: -75.1985,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCV": {
    icao: "SKCV",
    iata: "CVE",
    name: "Coveñas Airport",
    city: "Coveñas",
    country: "CO",
    continent: "SA",
    lat: 9.4009,
    lon: -75.6913,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKCZ": {
    icao: "SKCZ",
    iata: "CZU",
    name: "Las Brujas Airport",
    city: "Corozal",
    country: "CO",
    continent: "SA",
    lat: 9.3327,
    lon: -75.2856,
    elevation: 528,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKEB": {
    icao: "SKEB",
    iata: "EBG",
    name: "El Bagre Airport",
    city: "El Bagre",
    country: "CO",
    continent: "SA",
    lat: 7.5965,
    lon: -74.8089,
    elevation: 180,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKEJ": {
    icao: "SKEJ",
    iata: "EJA",
    name: "Yariguíes Airport",
    city: "Barrancabermeja",
    country: "CO",
    continent: "SA",
    lat: 7.0243,
    lon: -73.8068,
    elevation: 412,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKFL": {
    icao: "SKFL",
    iata: "FLA",
    name: "Gustavo Artunduaga Paredes Airport",
    city: "Florencia",
    country: "CO",
    continent: "SA",
    lat: 1.5892,
    lon: -75.5644,
    elevation: 803,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKGI": {
    icao: "SKGI",
    iata: "GIR",
    name: "Santiago Vila Airport",
    city: "Girardot",
    country: "CO",
    continent: "SA",
    lat: 4.2762,
    lon: -74.7967,
    elevation: 900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKGO": {
    icao: "SKGO",
    iata: "CRC",
    name: "Santa Ana Airport",
    city: "Cartago",
    country: "CO",
    continent: "SA",
    lat: 4.7582,
    lon: -75.9557,
    elevation: 2979,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKGP": {
    icao: "SKGP",
    iata: "GPI",
    name: "Juan Casiano Airport",
    city: "Guapi",
    country: "CO",
    continent: "SA",
    lat: 2.5701,
    lon: -77.898,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKIB": {
    icao: "SKIB",
    iata: "IBE",
    name: "Perales Airport",
    city: "Ibagué",
    country: "CO",
    continent: "SA",
    lat: 4.4216,
    lon: -75.1333,
    elevation: 2999,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKIP": {
    icao: "SKIP",
    iata: "IPI",
    name: "San Luis Airport",
    city: "Ipiales",
    country: "CO",
    continent: "SA",
    lat: 0.8619,
    lon: -77.6718,
    elevation: 9765,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKLC": {
    icao: "SKLC",
    iata: "APO",
    name: "Antonio Roldán Betancur Airport",
    city: "Carepa",
    country: "CO",
    continent: "SA",
    lat: 7.812,
    lon: -76.7164,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKLM": {
    icao: "SKLM",
    iata: "MCJ",
    name: "Jorge Isaac Airport",
    city: "La Mina-Maicao",
    country: "CO",
    continent: "SA",
    lat: 11.2325,
    lon: -72.4901,
    elevation: 281,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKLT": {
    icao: "SKLT",
    iata: "LET",
    name: "Alfredo Vásquez Cobo International Airport",
    city: "Leticia",
    country: "CO",
    continent: "SA",
    lat: -4.1936,
    lon: -69.9432,
    elevation: 277,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKMD": {
    icao: "SKMD",
    iata: "EOH",
    name: "Enrique Olaya Herrera Airport",
    city: "Medellín",
    country: "CO",
    continent: "SA",
    lat: 6.2197,
    lon: -75.5906,
    elevation: 4949,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKMG": {
    icao: "SKMG",
    iata: "MGN",
    name: "Baracoa Airport",
    city: "Magangué",
    country: "CO",
    continent: "SA",
    lat: 9.2847,
    lon: -74.8461,
    elevation: 178,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKMR": {
    icao: "SKMR",
    iata: "MTR",
    name: "Los Garzones Airport",
    city: "Montería",
    country: "CO",
    continent: "SA",
    lat: 8.8237,
    lon: -75.8258,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKMU": {
    icao: "SKMU",
    iata: "MVP",
    name: "Fabio Alberto Leon Bentley Airport",
    city: "Mitú",
    country: "CO",
    continent: "SA",
    lat: 1.2537,
    lon: -70.2339,
    elevation: 680,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKMZ": {
    icao: "SKMZ",
    iata: "MZL",
    name: "La Nubia Airport",
    city: "Manizales",
    country: "CO",
    continent: "SA",
    lat: 5.0296,
    lon: -75.4647,
    elevation: 6871,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKNV": {
    icao: "SKNV",
    iata: "NVA",
    name: "Benito Salas Airport",
    city: "Neiva",
    country: "CO",
    continent: "SA",
    lat: 2.9501,
    lon: -75.294,
    elevation: 1464,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKOC": {
    icao: "SKOC",
    iata: "OCV",
    name: "Aguas Claras Airport",
    city: "Ocaña",
    country: "CO",
    continent: "SA",
    lat: 8.3151,
    lon: -73.3583,
    elevation: 3850,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPC": {
    icao: "SKPC",
    iata: "PCR",
    name: "German Olano Airport",
    city: "Puerto Carreño",
    country: "CO",
    continent: "SA",
    lat: 6.1847,
    lon: -67.4932,
    elevation: 177,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPD": {
    icao: "SKPD",
    iata: "PDA",
    name: "Obando Cesar Gaviria Trujillo Airport",
    city: "Puerto Inírida",
    country: "CO",
    continent: "SA",
    lat: 3.8535,
    lon: -67.9062,
    elevation: 460,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPE": {
    icao: "SKPE",
    iata: "PEI",
    name: "Matecaña International Airport",
    city: "Pereira",
    country: "CO",
    continent: "SA",
    lat: 4.8127,
    lon: -75.7395,
    elevation: 4416,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPI": {
    icao: "SKPI",
    iata: "PTX",
    name: "Pitalito Airport",
    city: "Pitalito",
    country: "CO",
    continent: "SA",
    lat: 1.8578,
    lon: -76.0857,
    elevation: 4212,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPP": {
    icao: "SKPP",
    iata: "PPN",
    name: "Guillermo León Valencia Airport",
    city: "Popayán",
    country: "CO",
    continent: "SA",
    lat: 2.4544,
    lon: -76.6093,
    elevation: 5687,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPQ": {
    icao: "SKPQ",
    iata: "PAL",
    name: "German Olano Air Base",
    city: "La Dorada",
    country: "CO",
    continent: "SA",
    lat: 5.4836,
    lon: -74.6574,
    elevation: 566,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPS": {
    icao: "SKPS",
    iata: "PSO",
    name: "Antonio Nariño Airport",
    city: "Chachagüí",
    country: "CO",
    continent: "SA",
    lat: 1.3962,
    lon: -77.2915,
    elevation: 5951,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPV": {
    icao: "SKPV",
    iata: "PVA",
    name: "El Embrujo Airport",
    city: "Providencia",
    country: "CO",
    continent: "NA",
    lat: 13.3575,
    lon: -81.358,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKPZ": {
    icao: "SKPZ",
    iata: "PZA",
    name: "Paz De Ariporo Airport",
    city: "Paz De Ariporo",
    country: "CO",
    continent: "SA",
    lat: 5.8761,
    lon: -71.8866,
    elevation: 900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKQU": {
    icao: "SKQU",
    iata: "MQU",
    name: "Mariquita Airport",
    city: "Mariquita",
    country: "CO",
    continent: "SA",
    lat: 5.2126,
    lon: -74.8836,
    elevation: 1531,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKRG": {
    icao: "SKRG",
    iata: "MDE",
    name: "Jose Maria Córdova International Airport",
    city: "Medellín",
    country: "CO",
    continent: "SA",
    lat: 6.1645,
    lon: -75.4231,
    elevation: 6955,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKRH": {
    icao: "SKRH",
    iata: "RCH",
    name: "Almirante Padilla Airport",
    city: "Riohacha",
    country: "CO",
    continent: "SA",
    lat: 11.5262,
    lon: -72.926,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKSJ": {
    icao: "SKSJ",
    iata: "SJE",
    name: "Jorge E. Gonzalez Torres Airport",
    city: "San José Del Guaviare",
    country: "CO",
    continent: "SA",
    lat: 2.5797,
    lon: -72.6394,
    elevation: 605,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKSM": {
    icao: "SKSM",
    iata: "SMR",
    name: "Simón Bolívar International Airport",
    city: "Santa Marta",
    country: "CO",
    continent: "SA",
    lat: 11.1196,
    lon: -74.2306,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKSP": {
    icao: "SKSP",
    iata: "ADZ",
    name: "Gustavo Rojas Pinilla International Airport",
    city: "San Andrés",
    country: "CO",
    continent: "NA",
    lat: 12.5836,
    lon: -81.7112,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKSV": {
    icao: "SKSV",
    iata: "SVI",
    name: "Eduardo Falla Solano Airport",
    city: "San Vicente Del Caguán",
    country: "CO",
    continent: "SA",
    lat: 2.1522,
    lon: -74.7663,
    elevation: 920,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKTJ": {
    icao: "SKTJ",
    iata: "",
    name: "Tunja Airport",
    city: "Tunja",
    country: "CO",
    continent: "SA",
    lat: 5.5414,
    lon: -73.3445,
    elevation: 8940,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKTM": {
    icao: "SKTM",
    iata: "TME",
    name: "Gustavo Vargas Airport",
    city: "Tame",
    country: "CO",
    continent: "SA",
    lat: 6.4511,
    lon: -71.7603,
    elevation: 1050,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKTQ": {
    icao: "SKTQ",
    iata: "TQS",
    name: "Captain Ernesto Esguerra Cubides Air Base",
    city: "Tres Esquinas",
    country: "CO",
    continent: "SA",
    lat: 0.7459,
    lon: -75.234,
    elevation: 585,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKUA": {
    icao: "SKUA",
    iata: "",
    name: "Marandúa Air Base",
    city: "Marandúa",
    country: "CO",
    continent: "SA",
    lat: 5.5245,
    lon: -68.6856,
    elevation: 285,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKUC": {
    icao: "SKUC",
    iata: "AUC",
    name: "Santiago Perez Airport",
    city: "Arauca",
    country: "CO",
    continent: "SA",
    lat: 7.0689,
    lon: -70.7369,
    elevation: 420,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKUI": {
    icao: "SKUI",
    iata: "UIB",
    name: "El Caraño Airport",
    city: "Quibdó",
    country: "CO",
    continent: "SA",
    lat: 5.6908,
    lon: -76.6412,
    elevation: 204,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKUL": {
    icao: "SKUL",
    iata: "ULQ",
    name: "Heriberto Gíl Martínez Airport",
    city: "Tuluá",
    country: "CO",
    continent: "SA",
    lat: 4.0884,
    lon: -76.2351,
    elevation: 3132,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKVP": {
    icao: "SKVP",
    iata: "VUP",
    name: "Alfonso López Pumarejo Airport",
    city: "Valledupar",
    country: "CO",
    continent: "SA",
    lat: 10.435,
    lon: -73.2495,
    elevation: 483,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKVV": {
    icao: "SKVV",
    iata: "VVC",
    name: "Vanguardia Airport",
    city: "Villavicencio",
    country: "CO",
    continent: "SA",
    lat: 4.1679,
    lon: -73.6138,
    elevation: 1394,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SKYP": {
    icao: "SKYP",
    iata: "EYP",
    name: "El Alcaravan - Yopal Airport",
    city: "Yopal",
    country: "CO",
    continent: "SA",
    lat: 5.3191,
    lon: -72.384,
    elevation: 1028,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLAL": {
    icao: "SLAL",
    iata: "SRE",
    name: "Alcantarí Airport",
    city: "Sucre",
    country: "BO",
    continent: "SA",
    lat: -19.2468,
    lon: -65.1496,
    elevation: 10184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLBJ": {
    icao: "SLBJ",
    iata: "BJO",
    name: "Bermejo Airport",
    city: "Bermejo",
    country: "BO",
    continent: "SA",
    lat: -22.7733,
    lon: -64.3129,
    elevation: 1249,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLCB": {
    icao: "SLCB",
    iata: "CBB",
    name: "Jorge Wilsterman International Airport",
    city: "Cochabamba",
    country: "BO",
    continent: "SA",
    lat: -17.4211,
    lon: -66.1771,
    elevation: 8360,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLCO": {
    icao: "SLCO",
    iata: "CIJ",
    name: "Capitán Aníbal Arab Airport",
    city: "Cobija",
    country: "BO",
    continent: "SA",
    lat: -11.0404,
    lon: -68.783,
    elevation: 889,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLET": {
    icao: "SLET",
    iata: "SRZ",
    name: "El Trompillo Airport",
    city: "Santa Cruz",
    country: "BO",
    continent: "SA",
    lat: -17.8116,
    lon: -63.1715,
    elevation: 1371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLGM": {
    icao: "SLGM",
    iata: "GYA",
    name: "Guayaramerín Airport",
    city: "Guayaramerín",
    country: "BO",
    continent: "SA",
    lat: -10.8886,
    lon: -65.381,
    elevation: 456,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLLP": {
    icao: "SLLP",
    iata: "LPB",
    name: "El Alto International Airport",
    city: "La Paz / El Alto",
    country: "BO",
    continent: "SA",
    lat: -16.5133,
    lon: -68.1923,
    elevation: 13355,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLOR": {
    icao: "SLOR",
    iata: "ORU",
    name: "Juan Mendoza Airport",
    city: "Oruro",
    country: "BO",
    continent: "SA",
    lat: -17.9626,
    lon: -67.0762,
    elevation: 12152,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLPO": {
    icao: "SLPO",
    iata: "POI",
    name: "Capitan Nicolas Rojas Airport",
    city: "Potosí",
    country: "BO",
    continent: "SA",
    lat: -19.5433,
    lon: -65.7237,
    elevation: 12922,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLPS": {
    icao: "SLPS",
    iata: "PSZ",
    name: "Capitán Av. Salvador Ogaya G. airport",
    city: "Puerto Suárez",
    country: "BO",
    continent: "SA",
    lat: -18.9753,
    lon: -57.8206,
    elevation: 440,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLRI": {
    icao: "SLRI",
    iata: "RIB",
    name: "Capitán Av. Selin Zeitun Lopez Airport",
    city: "Riberalta",
    country: "BO",
    continent: "SA",
    lat: -11.0094,
    lon: -66.0755,
    elevation: 462,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLSA": {
    icao: "SLSA",
    iata: "SBL",
    name: "Santa Ana Del Yacuma Airport",
    city: "Santa Ana del Yacuma",
    country: "BO",
    continent: "SA",
    lat: -13.7622,
    lon: -65.4352,
    elevation: 472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLSU": {
    icao: "SLSU",
    iata: "",
    name: "Juana Azurduy de Padilla Airport",
    city: "Sucre",
    country: "BO",
    continent: "SA",
    lat: -19.0071,
    lon: -65.2887,
    elevation: 9540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLSV": {
    icao: "SLSV",
    iata: "",
    name: "San Ignacio de Velasco Airport",
    city: "San Ignacio de Velasco",
    country: "BO",
    continent: "SA",
    lat: -16.4012,
    lon: -61.0452,
    elevation: 1477,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLTJ": {
    icao: "SLTJ",
    iata: "TJA",
    name: "Capitan Oriel Lea Plaza Airport",
    city: "Tarija",
    country: "BO",
    continent: "SA",
    lat: -21.5557,
    lon: -64.7013,
    elevation: 6079,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLTR": {
    icao: "SLTR",
    iata: "TDD",
    name: "Teniente Av. Jorge Henrich Arauz Airport",
    city: "Trinidad",
    country: "BO",
    continent: "SA",
    lat: -14.8187,
    lon: -64.918,
    elevation: 509,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLVM": {
    icao: "SLVM",
    iata: "VLM",
    name: "Teniente Coronel Rafael Pabón Airport",
    city: "Villamontes",
    country: "BO",
    continent: "SA",
    lat: -21.2552,
    lon: -63.4056,
    elevation: 1305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SLVR": {
    icao: "SLVR",
    iata: "VVI",
    name: "Viru Viru International Airport",
    city: "Santa Cruz",
    country: "BO",
    continent: "SA",
    lat: -17.6448,
    lon: -63.1354,
    elevation: 1224,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SLYA": {
    icao: "SLYA",
    iata: "BYC",
    name: "Yacuiba Airport",
    city: "Yacuíba",
    country: "BO",
    continent: "SA",
    lat: -21.9609,
    lon: -63.6517,
    elevation: 2112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SMJP": {
    icao: "SMJP",
    iata: "PBM",
    name: "Johan Adolf Pengel International Airport",
    city: "Zandery",
    country: "SR",
    continent: "SA",
    lat: 5.4528,
    lon: -55.1878,
    elevation: 59,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SN6L": {
    icao: "SN6L",
    iata: "JSO",
    name: "Dr. Luciano de Arruda Coelho Regional Airport",
    city: "Sobral",
    country: "BR",
    continent: "SA",
    lat: -3.6145,
    lon: -40.2314,
    elevation: 299,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SNCP": {
    icao: "SNCP",
    iata: "EEA",
    name: "Planalto Serrano Regional Airport",
    city: "Correia Pinto",
    country: "BR",
    continent: "SA",
    lat: -27.6341,
    lon: -50.3583,
    elevation: 2887,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SNLN": {
    icao: "SNLN",
    iata: "LHN",
    name: "Linhares Municipal Airport",
    city: "Linhares",
    country: "BR",
    continent: "SA",
    lat: -19.3552,
    lon: -40.0713,
    elevation: 138,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SNQX": {
    icao: "SNQX",
    iata: "",
    name: "Quixadá Airport",
    city: "Quixadá",
    country: "BR",
    continent: "SA",
    lat: -4.979,
    lon: -38.9876,
    elevation: 735,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SOCA": {
    icao: "SOCA",
    iata: "CAY",
    name: "Cayenne – Félix Eboué Airport",
    city: "Matoury",
    country: "GF",
    continent: "SA",
    lat: 4.82,
    lon: -52.3613,
    elevation: 26,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SOOG": {
    icao: "SOOG",
    iata: "OYP",
    name: "Saint-Georges-de-l\'Oyapock Airport",
    city: "Saint-Georges-de-l\'Oyapock",
    country: "GF",
    continent: "SA",
    lat: 3.8976,
    lon: -51.8041,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPAY": {
    icao: "SPAY",
    iata: "AYX",
    name: "Teniente General Gerardo Pérez Pinedo Airport",
    city: "Atalaya",
    country: "PE",
    continent: "SA",
    lat: -10.7291,
    lon: -73.7665,
    elevation: 751,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPBC": {
    icao: "SPBC",
    iata: "",
    name: "Caballococha Airport",
    city: "Caballococha",
    country: "PE",
    continent: "SA",
    lat: -3.9169,
    lon: -70.5082,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPBR": {
    icao: "SPBR",
    iata: "IBP",
    name: "Iberia Airport",
    city: "Iberia",
    country: "PE",
    continent: "SA",
    lat: -11.4116,
    lon: -69.4887,
    elevation: 750,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPCL": {
    icao: "SPCL",
    iata: "PCL",
    name: "Cap FAP David Abenzur Rengifo International Airport",
    city: "Pucallpa",
    country: "PE",
    continent: "SA",
    lat: -8.3779,
    lon: -74.5743,
    elevation: 513,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPEO": {
    icao: "SPEO",
    iata: "CHM",
    name: "FAP Lieutenant Jaime Andres de Montreuil Morales Airport",
    city: "Chimbote",
    country: "PE",
    continent: "SA",
    lat: -9.1496,
    lon: -78.5238,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPHI": {
    icao: "SPHI",
    iata: "CIX",
    name: "Air Force Captain Jose A Quinones Gonzales International Airport",
    city: "Chiclayo",
    country: "PE",
    continent: "SA",
    lat: -6.7875,
    lon: -79.8281,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPHO": {
    icao: "SPHO",
    iata: "AYP",
    name: "Air Force Colonel Alfredo Mendivil Duarte Airport",
    city: "Ayacucho",
    country: "PE",
    continent: "SA",
    lat: -13.1548,
    lon: -74.2044,
    elevation: 8917,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPHZ": {
    icao: "SPHZ",
    iata: "ATA",
    name: "Comandante FAP German Arias Graziani Airport",
    city: "Anta",
    country: "PE",
    continent: "SA",
    lat: -9.3474,
    lon: -77.5984,
    elevation: 9097,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPIM": {
    icao: "SPIM",
    iata: "LIM",
    name: "Jorge Chávez International Airport",
    city: "Lima",
    country: "PE",
    continent: "SA",
    lat: -12.0219,
    lon: -77.1143,
    elevation: 113,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SPJA": {
    icao: "SPJA",
    iata: "RIJ",
    name: "Juan Simons Vela Airport",
    city: "Rioja",
    country: "PE",
    continent: "SA",
    lat: -6.0679,
    lon: -77.16,
    elevation: 2707,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPJE": {
    icao: "SPJE",
    iata: "JAE",
    name: "Shumba Airport",
    city: "Jaén",
    country: "PE",
    continent: "SA",
    lat: -5.5925,
    lon: -78.774,
    elevation: 2477,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPJI": {
    icao: "SPJI",
    iata: "JJI",
    name: "Juanjui Airport",
    city: "Juanjuí",
    country: "PE",
    continent: "SA",
    lat: -7.1691,
    lon: -76.7286,
    elevation: 1148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPJJ": {
    icao: "SPJJ",
    iata: "JAU",
    name: "Francisco Carle Airport",
    city: "Jauja",
    country: "PE",
    continent: "SA",
    lat: -11.7831,
    lon: -75.4734,
    elevation: 11034,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPJL": {
    icao: "SPJL",
    iata: "JUL",
    name: "Inca Manco Capac International Airport",
    city: "Juliaca",
    country: "PE",
    continent: "SA",
    lat: -15.4671,
    lon: -70.1582,
    elevation: 12552,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPJR": {
    icao: "SPJR",
    iata: "CJA",
    name: "Mayor General FAP Armando Revoredo Iglesias Airport",
    city: "Cajamarca",
    country: "PE",
    continent: "SA",
    lat: -7.1392,
    lon: -78.4894,
    elevation: 8781,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPLO": {
    icao: "SPLO",
    iata: "ILQ",
    name: "General Jorge Fernandez Maldon Airport",
    city: "Ilo",
    country: "PE",
    continent: "SA",
    lat: -17.695,
    lon: -71.344,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPME": {
    icao: "SPME",
    iata: "TBP",
    name: "Captain Pedro Canga Rodríguez International Airport",
    city: "Tumbes",
    country: "PE",
    continent: "SA",
    lat: -3.5521,
    lon: -80.3811,
    elevation: 115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPMS": {
    icao: "SPMS",
    iata: "YMS",
    name: "Moises Benzaquen Rengifo Airport",
    city: "Yurimaguas",
    country: "PE",
    continent: "SA",
    lat: -5.8938,
    lon: -76.1182,
    elevation: 587,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPNC": {
    icao: "SPNC",
    iata: "HUU",
    name: "Alferez Fap David Figueroa Fernandini Airport",
    city: "Huánuco",
    country: "PE",
    continent: "SA",
    lat: -9.8788,
    lon: -76.2048,
    elevation: 6070,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPPY": {
    icao: "SPPY",
    iata: "CHH",
    name: "Chachapoyas Airport",
    city: "Chachapoyas",
    country: "PE",
    continent: "SA",
    lat: -6.2019,
    lon: -77.8562,
    elevation: 8333,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPQT": {
    icao: "SPQT",
    iata: "IQT",
    name: "Coronel FAP Francisco Secada Vignetta International Airport",
    city: "Iquitos",
    country: "PE",
    continent: "SA",
    lat: -3.7847,
    lon: -73.3088,
    elevation: 306,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPQU": {
    icao: "SPQU",
    iata: "AQP",
    name: "Rodríguez Ballón International Airport",
    city: "Arequipa",
    country: "PE",
    continent: "SA",
    lat: -16.3411,
    lon: -71.5831,
    elevation: 8405,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPRU": {
    icao: "SPRU",
    iata: "TRU",
    name: "Capitan FAP Carlos Martinez De Pinillos International Airport",
    city: "Trujillo",
    country: "PE",
    continent: "SA",
    lat: -8.0814,
    lon: -79.1088,
    elevation: 106,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPSO": {
    icao: "SPSO",
    iata: "PIO",
    name: "Captain Renán Elías Olivera International Airport",
    city: "Pisco",
    country: "PE",
    continent: "SA",
    lat: -13.7449,
    lon: -76.2203,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPST": {
    icao: "SPST",
    iata: "TPP",
    name: "Cadete FAP Guillermo Del Castillo Paredes Airport",
    city: "Tarapoto",
    country: "PE",
    continent: "SA",
    lat: -6.5087,
    lon: -76.3732,
    elevation: 869,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPTN": {
    icao: "SPTN",
    iata: "TCQ",
    name: "Coronel FAP Carlos Ciriani Santa Rosa International Airport",
    city: "Tacna",
    country: "PE",
    continent: "SA",
    lat: -18.0533,
    lon: -70.2758,
    elevation: 1538,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPTU": {
    icao: "SPTU",
    iata: "PEM",
    name: "Padre Aldamiz International Airport",
    city: "Puerto Maldonado",
    country: "PE",
    continent: "SA",
    lat: -12.6136,
    lon: -69.2286,
    elevation: 659,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPUR": {
    icao: "SPUR",
    iata: "PIU",
    name: "Capitán FAP Guillermo Concha Iberico International Airport",
    city: "Piura",
    country: "PE",
    continent: "SA",
    lat: -5.2057,
    lon: -80.6164,
    elevation: 120,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPYL": {
    icao: "SPYL",
    iata: "TYL",
    name: "Captain Victor Montes Arias International Airport",
    city: "Talara",
    country: "PE",
    continent: "SA",
    lat: -4.5766,
    lon: -81.2541,
    elevation: 282,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPZA": {
    icao: "SPZA",
    iata: "NZC",
    name: "Maria Reiche Neuman Airport",
    city: "Nazca",
    country: "PE",
    continent: "SA",
    lat: -14.854,
    lon: -74.9615,
    elevation: 1860,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SPZO": {
    icao: "SPZO",
    iata: "CUZ",
    name: "Alejandro Velasco Astete International Airport",
    city: "Cusco",
    country: "PE",
    continent: "SA",
    lat: -13.5357,
    lon: -71.9388,
    elevation: 10860,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SUAA": {
    icao: "SUAA",
    iata: "",
    name: "Ángel S. Adami International Airport",
    city: "Montevideo",
    country: "UY",
    continent: "SA",
    lat: -34.7892,
    lon: -56.2647,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SUDU": {
    icao: "SUDU",
    iata: "DZO",
    name: "Santa Bernardina International Airport",
    city: "Durazno",
    country: "UY",
    continent: "SA",
    lat: -33.3589,
    lon: -56.4992,
    elevation: 305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SULS": {
    icao: "SULS",
    iata: "PDP",
    name: "Capitan Corbeta CA Curbelo International Airport",
    city: "Punta del Este",
    country: "UY",
    continent: "SA",
    lat: -34.8551,
    lon: -55.0943,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SUMU": {
    icao: "SUMU",
    iata: "MVD",
    name: "Carrasco General Cesáreo L. Berisso International Airport",
    city: "Ciudad de la Costa",
    country: "UY",
    continent: "SA",
    lat: -34.8356,
    lon: -56.0265,
    elevation: 105,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SUPU": {
    icao: "SUPU",
    iata: "PDU",
    name: "Tydeo Larre Borges Airport",
    city: "Paysandú",
    country: "UY",
    continent: "SA",
    lat: -32.3633,
    lon: -58.0619,
    elevation: 138,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SUSO": {
    icao: "SUSO",
    iata: "STY",
    name: "Nueva Hesperides International Airport",
    city: "Salto",
    country: "UY",
    continent: "SA",
    lat: -31.4385,
    lon: -57.9853,
    elevation: 187,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVAC": {
    icao: "SVAC",
    iata: "AGV",
    name: "Oswaldo Guevara Mujica Airport",
    city: "Acarigua",
    country: "VE",
    continent: "SA",
    lat: 9.5534,
    lon: -69.2379,
    elevation: 640,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVAN": {
    icao: "SVAN",
    iata: "AAO",
    name: "Anaco Airport",
    city: "Anaco",
    country: "VE",
    continent: "SA",
    lat: 9.4302,
    lon: -64.4707,
    elevation: 721,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVBC": {
    icao: "SVBC",
    iata: "BLA",
    name: "General José Antonio Anzoategui International Airport",
    city: "Barcelona",
    country: "VE",
    continent: "SA",
    lat: 10.1111,
    lon: -64.6922,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SVBI": {
    icao: "SVBI",
    iata: "BNS",
    name: "Barinas Airport",
    city: "Barinas",
    country: "VE",
    continent: "SA",
    lat: 8.615,
    lon: -70.2142,
    elevation: 615,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVBL": {
    icao: "SVBL",
    iata: "",
    name: "El Libertador Airbase",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 10.1834,
    lon: -67.5573,
    elevation: 1450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVBM": {
    icao: "SVBM",
    iata: "BRM",
    name: "Barquisimeto International Airport",
    city: "Barquisimeto",
    country: "VE",
    continent: "SA",
    lat: 10.0427,
    lon: -69.3586,
    elevation: 2042,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVBS": {
    icao: "SVBS",
    iata: "MYC",
    name: "Escuela Mariscal Sucre Airport",
    city: "Maracay",
    country: "VE",
    continent: "SA",
    lat: 10.25,
    lon: -67.6494,
    elevation: 1338,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCB": {
    icao: "SVCB",
    iata: "CBL",
    name: "General Tomas de Heres Airport",
    city: "Ciudad Bolivar",
    country: "VE",
    continent: "SA",
    lat: 8.1222,
    lon: -63.537,
    elevation: 197,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCD": {
    icao: "SVCD",
    iata: "CXA",
    name: "Caicara del Orinoco Airport",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 7.6255,
    lon: -66.1628,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCL": {
    icao: "SVCL",
    iata: "CLZ",
    name: "Calabozo Airport",
    city: "Guarico",
    country: "VE",
    continent: "SA",
    lat: 8.9247,
    lon: -67.4171,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCN": {
    icao: "SVCN",
    iata: "CAJ",
    name: "Canaima Airport",
    city: "Canaima",
    country: "VE",
    continent: "SA",
    lat: 6.232,
    lon: -62.8548,
    elevation: 1450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCP": {
    icao: "SVCP",
    iata: "CUP",
    name: "General Francisco Bermúdez Airport",
    city: "Carúpano",
    country: "VE",
    continent: "SA",
    lat: 10.66,
    lon: -63.2617,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCR": {
    icao: "SVCR",
    iata: "CZE",
    name: "José Leonardo Chirinos Airport",
    city: "Coro",
    country: "VE",
    continent: "SA",
    lat: 11.4149,
    lon: -69.6809,
    elevation: 52,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCS": {
    icao: "SVCS",
    iata: "",
    name: "Caracas Óscar Machado Zuloaga International Airport",
    city: "Charallave",
    country: "VE",
    continent: "SA",
    lat: 10.2869,
    lon: -66.8158,
    elevation: 2145,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVCU": {
    icao: "SVCU",
    iata: "CUM",
    name: "Antonio José de Sucre Airport",
    city: "Cumaná",
    country: "VE",
    continent: "SA",
    lat: 10.4503,
    lon: -64.1305,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVED": {
    icao: "SVED",
    iata: "EOR",
    name: "El Dorado Airport",
    city: "Bolivar",
    country: "VE",
    continent: "SA",
    lat: 6.7157,
    lon: -61.6388,
    elevation: 318,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVEZ": {
    icao: "SVEZ",
    iata: "EOZ",
    name: "Elorza Airport",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 7.0597,
    lon: -69.4967,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVFM": {
    icao: "SVFM",
    iata: "",
    name: "Generalissimo Francisco de Miranda Air Base",
    city: "Caracas",
    country: "VE",
    continent: "SA",
    lat: 10.485,
    lon: -66.8435,
    elevation: 2739,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVGD": {
    icao: "SVGD",
    iata: "GDO",
    name: "Guasdualito Airport",
    city: "Guasdualito",
    country: "VE",
    continent: "SA",
    lat: 7.2108,
    lon: -70.7564,
    elevation: 427,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVGI": {
    icao: "SVGI",
    iata: "GUI",
    name: "Guiria Airport",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 10.5741,
    lon: -62.3127,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVGU": {
    icao: "SVGU",
    iata: "GUQ",
    name: "Guanare Airport",
    city: "Guanare",
    country: "VE",
    continent: "SA",
    lat: 9.0269,
    lon: -69.7552,
    elevation: 606,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVJC": {
    icao: "SVJC",
    iata: "LSP",
    name: "Josefa Camejo International Airport",
    city: "Paraguaná",
    country: "VE",
    continent: "SA",
    lat: 11.7808,
    lon: -70.1515,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVJM": {
    icao: "SVJM",
    iata: "",
    name: "San Juan de Los Morros Airport",
    city: "San Juan de los Morros",
    country: "VE",
    continent: "SA",
    lat: 9.907,
    lon: -67.3796,
    elevation: 1404,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVLF": {
    icao: "SVLF",
    iata: "LFR",
    name: "La Fria Airport",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 8.2392,
    lon: -72.271,
    elevation: 305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVMC": {
    icao: "SVMC",
    iata: "MAR",
    name: "La Chinita International Airport",
    city: "Maracaibo",
    country: "VE",
    continent: "SA",
    lat: 10.5582,
    lon: -71.7279,
    elevation: 239,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVMD": {
    icao: "SVMD",
    iata: "MRD",
    name: "Alberto Carnevalli Airport",
    city: "Mérida",
    country: "VE",
    continent: "SA",
    lat: 8.5821,
    lon: -71.161,
    elevation: 5007,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVMG": {
    icao: "SVMG",
    iata: "PMV",
    name: "Del Caribe Santiago Mariño International Airport",
    city: "Isla Margarita",
    country: "VE",
    continent: "SA",
    lat: 10.9126,
    lon: -63.9666,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVMI": {
    icao: "SVMI",
    iata: "CCS",
    name: "Maiquetía Simón Bolívar International Airport",
    city: "Maiquetía",
    country: "VE",
    continent: "SA",
    lat: 10.6012,
    lon: -66.9912,
    elevation: 234,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "SVMP": {
    icao: "SVMP",
    iata: "",
    name: "Metropolitano International Airport",
    city: "Ocumare del Tuy",
    country: "VE",
    continent: "SA",
    lat: 10.1332,
    lon: -66.7878,
    elevation: 574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVMT": {
    icao: "SVMT",
    iata: "MUN",
    name: "José Tadeo Monagas International Airport",
    city: "Maturín",
    country: "VE",
    continent: "SA",
    lat: 9.749,
    lon: -63.1533,
    elevation: 224,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVPA": {
    icao: "SVPA",
    iata: "PYH",
    name: "Cacique Aramare Airport",
    city: "Puerto Ayacucho",
    country: "VE",
    continent: "SA",
    lat: 5.62,
    lon: -67.6061,
    elevation: 245,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVPC": {
    icao: "SVPC",
    iata: "PBL",
    name: "General Bartolome Salom International Airport",
    city: "Puerto Cabello",
    country: "VE",
    continent: "SA",
    lat: 10.4805,
    lon: -68.073,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVPM": {
    icao: "SVPM",
    iata: "SCI",
    name: "Paramillo Airport",
    city: "San Cristóbal",
    country: "VE",
    continent: "SA",
    lat: 7.8013,
    lon: -72.2029,
    elevation: 3314,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVPR": {
    icao: "SVPR",
    iata: "PZO",
    name: "General Manuel Carlos Piar International Airport",
    city: "Puerto Ordaz-Ciudad Guayana",
    country: "VE",
    continent: "SA",
    lat: 8.2885,
    lon: -62.7604,
    elevation: 472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVPT": {
    icao: "SVPT",
    iata: "PTM",
    name: "Palmarito Airport",
    city: "Palmarito",
    country: "VE",
    continent: "SA",
    lat: 7.5755,
    lon: -70.1744,
    elevation: 347,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVSA": {
    icao: "SVSA",
    iata: "SVZ",
    name: "Juan Vicente Gómez International Airport",
    city: "San Antonio del Tachira",
    country: "VE",
    continent: "SA",
    lat: 7.8408,
    lon: -72.4399,
    elevation: 1312,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVSE": {
    icao: "SVSE",
    iata: "SNV",
    name: "Santa Elena de Uairén Airport",
    city: "Santa Elena de Uairén",
    country: "VE",
    continent: "SA",
    lat: 4.5547,
    lon: -61.1452,
    elevation: 2938,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVSO": {
    icao: "SVSO",
    iata: "STD",
    name: "Mayor Buenaventura Vivas International Airport",
    city: "Santo Domingo",
    country: "VE",
    continent: "SA",
    lat: 7.5654,
    lon: -72.0351,
    elevation: 1083,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVSP": {
    icao: "SVSP",
    iata: "SNF",
    name: "Sub Teniente Nestor Arias Airport",
    city: "San Felipe",
    country: "VE",
    continent: "SA",
    lat: 10.2787,
    lon: -68.7552,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVSR": {
    icao: "SVSR",
    iata: "SFD",
    name: "San Fernando de Apure Las Flecheras National Airport",
    city: "San Fernando de Apure",
    country: "VE",
    continent: "SA",
    lat: 7.8833,
    lon: -67.444,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVST": {
    icao: "SVST",
    iata: "SOM",
    name: "San Tomé Airport",
    city: "El Tigre",
    country: "VE",
    continent: "SA",
    lat: 8.9451,
    lon: -64.1511,
    elevation: 861,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVSZ": {
    icao: "SVSZ",
    iata: "STB",
    name: "Miguel Urdaneta Fernández Airport",
    city: "San Carlos del Zulia",
    country: "VE",
    continent: "SA",
    lat: 8.9746,
    lon: -71.9433,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVTC": {
    icao: "SVTC",
    iata: "TUV",
    name: "Tucupita Airport",
    city: "Tucupita",
    country: "VE",
    continent: "SA",
    lat: 9.089,
    lon: -62.0942,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVTM": {
    icao: "SVTM",
    iata: "TMO",
    name: "Tumeremo Airport",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 7.2494,
    lon: -61.5289,
    elevation: 345,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVVA": {
    icao: "SVVA",
    iata: "VLN",
    name: "Arturo Michelena International Airport",
    city: "Valencia",
    country: "VE",
    continent: "SA",
    lat: 10.1497,
    lon: -67.9284,
    elevation: 1411,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVVG": {
    icao: "SVVG",
    iata: "VIG",
    name: "Juan Pablo Pérez Alfonso Airport",
    city: "El Vigía",
    country: "VE",
    continent: "SA",
    lat: 8.6241,
    lon: -71.6727,
    elevation: 250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVVL": {
    icao: "SVVL",
    iata: "VLV",
    name: "Dr. Antonio Nicolás Briceño Airport",
    city: "Valera",
    country: "VE",
    continent: "SA",
    lat: 9.3405,
    lon: -70.5841,
    elevation: 2060,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SVVP": {
    icao: "SVVP",
    iata: "VDP",
    name: "Valle de La Pascua Airport",
    city: "",
    country: "VE",
    continent: "SA",
    lat: 9.222,
    lon: -65.9936,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SWGN": {
    icao: "SWGN",
    iata: "AUX",
    name: "Araguaína Airport",
    city: "Araguaína",
    country: "BR",
    continent: "SA",
    lat: -7.2279,
    lon: -48.2405,
    elevation: 771,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SYCJ": {
    icao: "SYCJ",
    iata: "GEO",
    name: "Cheddi Jagan International Airport",
    city: "Georgetown",
    country: "GY",
    continent: "SA",
    lat: 6.4985,
    lon: -58.2541,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SYGO": {
    icao: "SYGO",
    iata: "OGL",
    name: "Eugene F. Correia International Airport",
    city: "Ogle",
    country: "GY",
    continent: "SA",
    lat: 6.8063,
    lon: -58.1059,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SYKA": {
    icao: "SYKA",
    iata: "KAI",
    name: "Kaieteur International Airport",
    city: "Kaieteur Falls",
    country: "GY",
    continent: "SA",
    lat: 5.1773,
    lon: -59.489,
    elevation: 1520,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "SYLT": {
    icao: "SYLT",
    iata: "LTM",
    name: "Lethem Airport",
    city: "Lethem",
    country: "GY",
    continent: "SA",
    lat: 3.3728,
    lon: -59.7894,
    elevation: 351,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TAPA": {
    icao: "TAPA",
    iata: "ANU",
    name: "V C Bird International Airport",
    city: "Osbourn",
    country: "AG",
    continent: "NA",
    lat: 17.1367,
    lon: -61.7927,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TAPH": {
    icao: "TAPH",
    iata: "BBQ",
    name: "Codrington Airport",
    city: "Codrington",
    country: "AG",
    continent: "NA",
    lat: 17.6358,
    lon: -61.8286,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TBPB": {
    icao: "TBPB",
    iata: "BGI",
    name: "Grantley Adams International Airport",
    city: "Bridgetown",
    country: "BB",
    continent: "NA",
    lat: 13.0746,
    lon: -59.4925,
    elevation: 169,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TDCF": {
    icao: "TDCF",
    iata: "DCF",
    name: "Canefield Airport",
    city: "Canefield",
    country: "DM",
    continent: "NA",
    lat: 15.3367,
    lon: -61.3921,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TDPD": {
    icao: "TDPD",
    iata: "DOM",
    name: "Douglas-Charles Airport",
    city: "Marigot",
    country: "DM",
    continent: "NA",
    lat: 15.547,
    lon: -61.3,
    elevation: 73,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TFFF": {
    icao: "TFFF",
    iata: "FDF",
    name: "Martinique Aimé Césaire International Airport",
    city: "Fort-de-France",
    country: "MQ",
    continent: "NA",
    lat: 14.591,
    lon: -61.0032,
    elevation: 16,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TFFG": {
    icao: "TFFG",
    iata: "SFG",
    name: "Grand Case-l\'Espérance Airport",
    city: "Grand Case",
    country: "MF",
    continent: "NA",
    lat: 18.1001,
    lon: -63.0474,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TFFJ": {
    icao: "TFFJ",
    iata: "SBH",
    name: "Saint Barthélemy - Gustaf III Airport",
    city: "Gustavia",
    country: "BL",
    continent: "NA",
    lat: 17.9044,
    lon: -62.8436,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TFFM": {
    icao: "TFFM",
    iata: "GBJ",
    name: "Marie-Galante Airport",
    city: "Grand-Bourg",
    country: "GP",
    continent: "NA",
    lat: 15.8689,
    lon: -61.2701,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TFFR": {
    icao: "TFFR",
    iata: "PTP",
    name: "Guadeloupe - Maryse Condé International Airport",
    city: "Pointe-à-Pitre",
    country: "GP",
    continent: "NA",
    lat: 16.2653,
    lon: -61.5318,
    elevation: 36,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TGPY": {
    icao: "TGPY",
    iata: "GND",
    name: "Maurice Bishop International Airport",
    city: "Saint George\'s",
    country: "GD",
    continent: "NA",
    lat: 12.0042,
    lon: -61.7862,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TIST": {
    icao: "TIST",
    iata: "STT",
    name: "Cyril E. King Airport",
    city: "Charlotte Amalie",
    country: "VI",
    continent: "NA",
    lat: 18.3371,
    lon: -64.9773,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TISX": {
    icao: "TISX",
    iata: "STX",
    name: "Henry E Rohlsen Airport",
    city: "Christiansted",
    country: "VI",
    continent: "NA",
    lat: 17.7014,
    lon: -64.8026,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJAB": {
    icao: "TJAB",
    iata: "ARE",
    name: "Antonio Nery Juarbe Pol Airport",
    city: "Arecibo",
    country: "PR",
    continent: "NA",
    lat: 18.4508,
    lon: -66.6758,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJBQ": {
    icao: "TJBQ",
    iata: "BQN",
    name: "Rafael Hernández International Airport",
    city: "Aguadilla",
    country: "PR",
    continent: "NA",
    lat: 18.4949,
    lon: -67.1294,
    elevation: 237,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJCP": {
    icao: "TJCP",
    iata: "CPX",
    name: "Benjamin Rivera Noriega Airport",
    city: "Culebra",
    country: "PR",
    continent: "NA",
    lat: 18.313,
    lon: -65.3039,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJIG": {
    icao: "TJIG",
    iata: "SIG",
    name: "Fernando Luis Ribas Dominicci Airport",
    city: "San Juan",
    country: "PR",
    continent: "NA",
    lat: 18.4568,
    lon: -66.0981,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJMZ": {
    icao: "TJMZ",
    iata: "MAZ",
    name: "Eugenio Maria De Hostos Airport",
    city: "Mayaguez",
    country: "PR",
    continent: "NA",
    lat: 18.2557,
    lon: -67.1485,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJPS": {
    icao: "TJPS",
    iata: "PSE",
    name: "Mercedita Airport",
    city: "Ponce",
    country: "PR",
    continent: "NA",
    lat: 18.0083,
    lon: -66.563,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJRV": {
    icao: "TJRV",
    iata: "NRR",
    name: "José Aponte de la Torre Airport",
    city: "Ceiba",
    country: "PR",
    continent: "NA",
    lat: 18.2453,
    lon: -65.6434,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TJSJ": {
    icao: "TJSJ",
    iata: "SJU",
    name: "Luis Munoz Marin International Airport",
    city: "San Juan",
    country: "PR",
    continent: "NA",
    lat: 18.4394,
    lon: -66.0018,
    elevation: 9,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TJVQ": {
    icao: "TJVQ",
    iata: "VQS",
    name: "Antonio Rivera Rodriguez Airport",
    city: "Vieques",
    country: "PR",
    continent: "NA",
    lat: 18.1348,
    lon: -65.4936,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TKPK": {
    icao: "TKPK",
    iata: "SKB",
    name: "Robert L. Bradshaw International Airport",
    city: "Basseterre",
    country: "KN",
    continent: "NA",
    lat: 17.3112,
    lon: -62.7187,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TKPN": {
    icao: "TKPN",
    iata: "NEV",
    name: "Vance W. Amory International Airport",
    city: "Charlestown",
    country: "KN",
    continent: "NA",
    lat: 17.2057,
    lon: -62.5899,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TLPC": {
    icao: "TLPC",
    iata: "SLU",
    name: "George F. L. Charles Airport",
    city: "Castries",
    country: "LC",
    continent: "NA",
    lat: 14.0202,
    lon: -60.9929,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TLPL": {
    icao: "TLPL",
    iata: "UVF",
    name: "Hewanorra International Airport",
    city: "Vieux Fort",
    country: "LC",
    continent: "NA",
    lat: 13.7332,
    lon: -60.9526,
    elevation: 14,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TNCA": {
    icao: "TNCA",
    iata: "AUA",
    name: "Queen Beatrix International Airport",
    city: "Oranjestad",
    country: "AW",
    continent: "NA",
    lat: 12.5014,
    lon: -70.0152,
    elevation: 60,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TNCB": {
    icao: "TNCB",
    iata: "BON",
    name: "Flamingo International Airport",
    city: "Kralendijk",
    country: "BQ",
    continent: "NA",
    lat: 12.131,
    lon: -68.2685,
    elevation: 20,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TNCC": {
    icao: "TNCC",
    iata: "CUR",
    name: "Hato International Airport",
    city: "Willemstad",
    country: "CW",
    continent: "NA",
    lat: 12.1889,
    lon: -68.9598,
    elevation: 29,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TNCE": {
    icao: "TNCE",
    iata: "EUX",
    name: "F. D. Roosevelt Airport",
    city: "Oranjestad",
    country: "BQ",
    continent: "NA",
    lat: 17.4965,
    lon: -62.9794,
    elevation: 129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TNCM": {
    icao: "TNCM",
    iata: "SXM",
    name: "Princess Juliana International Airport",
    city: "Sint Maarten",
    country: "SX",
    continent: "NA",
    lat: 18.041,
    lon: -63.1089,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "TNCS": {
    icao: "TNCS",
    iata: "SAB",
    name: "Juancho E. Yrausquin Airport",
    city: "Zion\'s Hill",
    country: "BQ",
    continent: "NA",
    lat: 17.6454,
    lon: -63.2206,
    elevation: 60,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TQPF": {
    icao: "TQPF",
    iata: "AXA",
    name: "Clayton J Lloyd International Airport",
    city: "The Valley",
    country: "AI",
    continent: "NA",
    lat: 18.2048,
    lon: -63.0538,
    elevation: 127,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TRPG": {
    icao: "TRPG",
    iata: "MNI",
    name: "John A. Osborne Airport",
    city: "Gerald\'s Park",
    country: "MS",
    continent: "NA",
    lat: 16.7914,
    lon: -62.1933,
    elevation: 550,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TTCP": {
    icao: "TTCP",
    iata: "TAB",
    name: "A.N.R. Robinson International Airport",
    city: "Scarborough",
    country: "TT",
    continent: "NA",
    lat: 11.1497,
    lon: -60.8322,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TTPP": {
    icao: "TTPP",
    iata: "POS",
    name: "Piarco International Airport",
    city: "Port of Spain",
    country: "TT",
    continent: "NA",
    lat: 10.5954,
    lon: -61.3372,
    elevation: 58,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TUPJ": {
    icao: "TUPJ",
    iata: "EIS",
    name: "Terrance B. Lettsome International Airport",
    city: "Beef Island",
    country: "VG",
    continent: "NA",
    lat: 18.4455,
    lon: -64.5417,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TVSA": {
    icao: "TVSA",
    iata: "SVD",
    name: "Argyle International Airport",
    city: "Kingstown",
    country: "VC",
    continent: "NA",
    lat: 13.1567,
    lon: -61.1499,
    elevation: 136,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TVSB": {
    icao: "TVSB",
    iata: "BQU",
    name: "J F Mitchell Airport",
    city: "Bequia",
    country: "VC",
    continent: "NA",
    lat: 12.9884,
    lon: -61.262,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TVSC": {
    icao: "TVSC",
    iata: "CIW",
    name: "Canouan Airport",
    city: "Canouan",
    country: "VC",
    continent: "NA",
    lat: 12.699,
    lon: -61.3424,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TVSM": {
    icao: "TVSM",
    iata: "MQS",
    name: "Mustique Airport",
    city: "Lovell",
    country: "VC",
    continent: "NA",
    lat: 12.8879,
    lon: -61.1802,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TVSU": {
    icao: "TVSU",
    iata: "UNI",
    name: "Union Island International Airport",
    city: "Union Island",
    country: "VC",
    continent: "NA",
    lat: 12.6001,
    lon: -61.4119,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "TXKF": {
    icao: "TXKF",
    iata: "BDA",
    name: "L.F. Wade International Airport",
    city: "Hamilton",
    country: "BM",
    continent: "NA",
    lat: 32.364,
    lon: -64.6787,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UA30": {
    icao: "UA30",
    iata: "",
    name: "Batken Airport",
    city: "Batken",
    country: "KG",
    continent: "AS",
    lat: 40.0429,
    lon: 70.8378,
    elevation: 3602,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAAA": {
    icao: "UAAA",
    iata: "ALA",
    name: "Almaty International Airport",
    city: "Almaty",
    country: "KZ",
    continent: "AS",
    lat: 43.3543,
    lon: 77.0428,
    elevation: 2234,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UAAH": {
    icao: "UAAH",
    iata: "BXH",
    name: "Balkhash Airport",
    city: "Balkhash",
    country: "KZ",
    continent: "AS",
    lat: 46.8942,
    lon: 75.0045,
    elevation: 1446,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAAT": {
    icao: "UAAT",
    iata: "TDK",
    name: "Taldykorgan Airport",
    city: "Taldykorgan",
    country: "KZ",
    continent: "AS",
    lat: 45.1225,
    lon: 78.4428,
    elevation: 1925,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UACC": {
    icao: "UACC",
    iata: "NQZ",
    name: "Nursultan Nazarbayev International Airport",
    city: "Astana",
    country: "KZ",
    continent: "AS",
    lat: 51.027,
    lon: 71.4671,
    elevation: 1165,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UACK": {
    icao: "UACK",
    iata: "KOV",
    name: "Kokshetau Airport",
    city: "Kokshetau",
    country: "KZ",
    continent: "AS",
    lat: 53.3291,
    lon: 69.5946,
    elevation: 900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UACP": {
    icao: "UACP",
    iata: "PPK",
    name: "Petropavl Airport",
    city: "Petropavl",
    country: "KZ",
    continent: "AS",
    lat: 54.7747,
    lon: 69.1833,
    elevation: 453,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UADD": {
    icao: "UADD",
    iata: "DMB",
    name: "Taraz Airport",
    city: "Taraz",
    country: "KZ",
    continent: "AS",
    lat: 42.8536,
    lon: 71.3036,
    elevation: 2184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAFM": {
    icao: "UAFM",
    iata: "BSZ",
    name: "Manas International Airport",
    city: "Bishkek",
    country: "KG",
    continent: "AS",
    lat: 43.0613,
    lon: 74.4776,
    elevation: 2058,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UAFO": {
    icao: "UAFO",
    iata: "OSS",
    name: "Osh Airport",
    city: "Osh",
    country: "KG",
    continent: "AS",
    lat: 40.609,
    lon: 72.7933,
    elevation: 2927,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAFW": {
    icao: "UAFW",
    iata: "",
    name: "Kant Air Base",
    city: "Kant",
    country: "KG",
    continent: "AS",
    lat: 42.8532,
    lon: 74.8465,
    elevation: 2549,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAII": {
    icao: "UAII",
    iata: "CIT",
    name: "Shymkent Airport",
    city: "Shymkent",
    country: "KZ",
    continent: "AS",
    lat: 42.3642,
    lon: 69.4789,
    elevation: 1385,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAIT": {
    icao: "UAIT",
    iata: "HSA",
    name: "Hazrat Sultan International Airport",
    city: "Turkıstan",
    country: "KZ",
    continent: "AS",
    lat: 43.3131,
    lon: 68.5499,
    elevation: 951,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAKD": {
    icao: "UAKD",
    iata: "DZN",
    name: "Zhezkazgan National Airport",
    city: "Zhezkazgan",
    country: "KZ",
    continent: "AS",
    lat: 47.709,
    lon: 67.7381,
    elevation: 1250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAKK": {
    icao: "UAKK",
    iata: "KGF",
    name: "Sary-Arka Airport",
    city: "Karaganda",
    country: "KZ",
    continent: "AS",
    lat: 49.6708,
    lon: 73.3344,
    elevation: 1765,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAOL": {
    icao: "UAOL",
    iata: "BXY",
    name: "Baikonur Krayniy Airport",
    city: "Baikonur",
    country: "KZ",
    continent: "AS",
    lat: 45.622,
    lon: 63.2108,
    elevation: 317,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAON": {
    icao: "UAON",
    iata: "",
    name: "Yubileyniy Airfield",
    city: "Töretam",
    country: "KZ",
    continent: "AS",
    lat: 46.0524,
    lon: 63.2492,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UARR": {
    icao: "UARR",
    iata: "URA",
    name: "Uralsk Airport",
    city: "Uralsk",
    country: "KZ",
    continent: "AS",
    lat: 51.1508,
    lon: 51.5431,
    elevation: 125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UASA": {
    icao: "UASA",
    iata: "",
    name: "Ayaguz Airport",
    city: "Ayaguz",
    country: "KZ",
    continent: "AS",
    lat: 47.9192,
    lon: 80.4522,
    elevation: 2119,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UASB": {
    icao: "UASB",
    iata: "EKB",
    name: "Ekibastuz Airport",
    city: "Ekibastuz",
    country: "KZ",
    continent: "AS",
    lat: 51.591,
    lon: 75.215,
    elevation: 621,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UASK": {
    icao: "UASK",
    iata: "UKK",
    name: "Ust-Kamenogorsk Airport",
    city: "Ust-Kamenogorsk (Oskemen)",
    country: "KZ",
    continent: "AS",
    lat: 50.0366,
    lon: 82.4935,
    elevation: 939,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UASP": {
    icao: "UASP",
    iata: "PWQ",
    name: "Pavlodar Airport",
    city: "Pavlodar",
    country: "KZ",
    continent: "AS",
    lat: 52.195,
    lon: 77.0739,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UASS": {
    icao: "UASS",
    iata: "PLX",
    name: "Semey Airport",
    city: "Semey",
    country: "KZ",
    continent: "AS",
    lat: 50.3513,
    lon: 80.2344,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UATE": {
    icao: "UATE",
    iata: "SCO",
    name: "Aktau Airport",
    city: "Aktau",
    country: "KZ",
    continent: "AS",
    lat: 43.8601,
    lon: 51.0909,
    elevation: 73,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UATG": {
    icao: "UATG",
    iata: "GUW",
    name: "Atyrau International Airport",
    city: "Atyrau",
    country: "KZ",
    continent: "AS",
    lat: 47.1226,
    lon: 51.8193,
    elevation: -72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UATR": {
    icao: "UATR",
    iata: "",
    name: "Shalkar Airport",
    city: "Shalkar",
    country: "KZ",
    continent: "AS",
    lat: 47.905,
    lon: 59.62,
    elevation: 561,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UATT": {
    icao: "UATT",
    iata: "AKX",
    name: "Aktobe Airport",
    city: "Aktobe",
    country: "KZ",
    continent: "AS",
    lat: 50.2458,
    lon: 57.2067,
    elevation: 738,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UAUU": {
    icao: "UAUU",
    iata: "KSN",
    name: "Kostanay West Airport",
    city: "Kostanay",
    country: "KZ",
    continent: "AS",
    lat: 53.2069,
    lon: 63.5503,
    elevation: 595,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UB12": {
    icao: "UB12",
    iata: "",
    name: "Nasosnaya Air Base",
    city: "Sumqayit",
    country: "AZ",
    continent: "AS",
    lat: 40.5916,
    lon: 49.5574,
    elevation: -13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UB13": {
    icao: "UB13",
    iata: "",
    name: "Khojaly Airport",
    city: "Khojaly",
    country: "AZ",
    continent: "AS",
    lat: 39.9014,
    lon: 46.787,
    elevation: 2001,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UB14": {
    icao: "UB14",
    iata: "",
    name: "Kyurdamir Air Base",
    city: "Kyurdamir",
    country: "AZ",
    continent: "AS",
    lat: 40.2736,
    lon: 48.1636,
    elevation: -35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UB18": {
    icao: "UB18",
    iata: "",
    name: "Baku Kala Air Base",
    city: "Baku",
    country: "AZ",
    continent: "AS",
    lat: 40.4084,
    lon: 50.2003,
    elevation: 40,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UBBB": {
    icao: "UBBB",
    iata: "GYD",
    name: "Heydar Aliyev International Airport",
    city: "Baku",
    country: "AZ",
    continent: "AS",
    lat: 40.4675,
    lon: 50.0467,
    elevation: 10,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UBBG": {
    icao: "UBBG",
    iata: "GNJ",
    name: "Ganja International Airport",
    city: "Ganja",
    country: "AZ",
    continent: "AS",
    lat: 40.7389,
    lon: 46.3201,
    elevation: 1083,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UBBN": {
    icao: "UBBN",
    iata: "NAJ",
    name: "Nakhchivan Airport",
    city: "Nakhchivan",
    country: "AZ",
    continent: "AS",
    lat: 39.1888,
    lon: 45.4584,
    elevation: 2863,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UBBQ": {
    icao: "UBBQ",
    iata: "GBB",
    name: "Gabala International Airport",
    city: "Gabala",
    country: "AZ",
    continent: "AS",
    lat: 40.8086,
    lon: 47.7254,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UBBY": {
    icao: "UBBY",
    iata: "ZTU",
    name: "Zaqatala International Airport",
    city: "Zaqatala",
    country: "AZ",
    continent: "AS",
    lat: 41.5578,
    lon: 46.6695,
    elevation: 1279,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UCFL": {
    icao: "UCFL",
    iata: "IKU",
    name: "Issyk-Kul International Airport",
    city: "Tamchy",
    country: "KG",
    continent: "AS",
    lat: 42.5856,
    lon: 76.7012,
    elevation: 5425,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UDSG": {
    icao: "UDSG",
    iata: "LWN",
    name: "Shirak International Airport",
    city: "Gyumri",
    country: "AM",
    continent: "AS",
    lat: 40.7504,
    lon: 43.8593,
    elevation: 5000,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UDYE": {
    icao: "UDYE",
    iata: "",
    name: "Erebuni Airport",
    city: "Yerevan",
    country: "AM",
    continent: "AS",
    lat: 40.1221,
    lon: 44.465,
    elevation: 2948,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UDYZ": {
    icao: "UDYZ",
    iata: "EVN",
    name: "Zvartnots International Airport",
    city: "Yerevan",
    country: "AM",
    continent: "AS",
    lat: 40.1473,
    lon: 44.3959,
    elevation: 2838,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UEEE": {
    icao: "UEEE",
    iata: "YKS",
    name: "Yakutsk Airport",
    city: "Yakutsk",
    country: "RU",
    continent: "AS",
    lat: 62.0933,
    lon: 129.771,
    elevation: 325,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UELL": {
    icao: "UELL",
    iata: "NER",
    name: "Chulman Airport",
    city: "Neryungri",
    country: "RU",
    continent: "AS",
    lat: 56.9139,
    lon: 124.914,
    elevation: 2812,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UEMA": {
    icao: "UEMA",
    iata: "MQJ",
    name: "Moma Airport",
    city: "Khonuu",
    country: "RU",
    continent: "AS",
    lat: 66.4509,
    lon: 143.2616,
    elevation: 656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UEMM": {
    icao: "UEMM",
    iata: "GYG",
    name: "Magan Airport",
    city: "Magan",
    country: "RU",
    continent: "AS",
    lat: 62.1035,
    lon: 129.5453,
    elevation: 577,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UEMO": {
    icao: "UEMO",
    iata: "OLZ",
    name: "Olyokminsk Airport",
    city: "Olyokminsk",
    country: "RU",
    continent: "AS",
    lat: 60.4018,
    lon: 120.4761,
    elevation: 656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UEMT": {
    icao: "UEMT",
    iata: "USR",
    name: "Ust-Nera Airport",
    city: "Ust-Nera",
    country: "RU",
    continent: "AS",
    lat: 64.55,
    lon: 143.115,
    elevation: 1805,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UENK": {
    icao: "UENK",
    iata: "",
    name: "Kyzyl-Syr Airport",
    city: "Kyzyl-Syr",
    country: "RU",
    continent: "AS",
    lat: 63.885,
    lon: 122.777,
    elevation: 331,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UENW": {
    icao: "UENW",
    iata: "VYI",
    name: "Vilyuisk Airport",
    city: "Vilyuisk",
    country: "RU",
    continent: "AS",
    lat: 63.7567,
    lon: 121.6933,
    elevation: 361,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UERA": {
    icao: "UERA",
    iata: "",
    name: "Aykhal Airport",
    city: "",
    country: "RU",
    continent: "AS",
    lat: 65.9592,
    lon: 111.5465,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UERL": {
    icao: "UERL",
    iata: "ULK",
    name: "Lensk Airport",
    city: "Lensk",
    country: "RU",
    continent: "AS",
    lat: 60.7206,
    lon: 114.826,
    elevation: 801,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UERP": {
    icao: "UERP",
    iata: "PYJ",
    name: "Polyarny Airport",
    city: "Yakutia",
    country: "RU",
    continent: "AS",
    lat: 66.4004,
    lon: 112.03,
    elevation: 1660,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UERR": {
    icao: "UERR",
    iata: "MJZ",
    name: "Mirny Airport",
    city: "Mirny",
    country: "RU",
    continent: "AS",
    lat: 62.5347,
    lon: 114.039,
    elevation: 1156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UERS": {
    icao: "UERS",
    iata: "SYS",
    name: "Saskylakh Airport",
    city: "Saskylakh",
    country: "RU",
    continent: "EU",
    lat: 71.9279,
    lon: 114.08,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UESG": {
    icao: "UESG",
    iata: "BGN",
    name: "Belaya Gora Airport",
    city: "Belaya Gora",
    country: "RU",
    continent: "AS",
    lat: 68.5562,
    lon: 146.2278,
    elevation: 118,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UESK": {
    icao: "UESK",
    iata: "SEK",
    name: "Srednekolymsk Airport",
    city: "Srednekolymsk",
    country: "RU",
    continent: "AS",
    lat: 67.4805,
    lon: 153.7364,
    elevation: 60,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UESO": {
    icao: "UESO",
    iata: "CKH",
    name: "Chokurdakh Airport",
    city: "Chokurdah",
    country: "RU",
    continent: "AS",
    lat: 70.6231,
    lon: 147.902,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UESS": {
    icao: "UESS",
    iata: "CYX",
    name: "Cherskiy Airport",
    city: "Cherskiy",
    country: "RU",
    continent: "AS",
    lat: 68.7406,
    lon: 161.338,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UEST": {
    icao: "UEST",
    iata: "IKS",
    name: "Tiksi Airport",
    city: "Tiksi",
    country: "RU",
    continent: "AS",
    lat: 71.6977,
    lon: 128.903,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UESU": {
    icao: "UESU",
    iata: "ZKP",
    name: "Zyryanka Airport",
    city: "Zyryanka",
    country: "RU",
    continent: "AS",
    lat: 65.7485,
    lon: 150.8889,
    elevation: 140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UEVV": {
    icao: "UEVV",
    iata: "ZIX",
    name: "Zhigansk Airport",
    city: "Zhigansk",
    country: "RU",
    continent: "AS",
    lat: 66.7965,
    lon: 123.361,
    elevation: 292,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UG0U": {
    icao: "UG0U",
    iata: "",
    name: "Gudauta Air Base",
    city: "Gudauta",
    country: "GE",
    continent: "AS",
    lat: 43.104,
    lon: 40.5793,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UG11": {
    icao: "UG11",
    iata: "",
    name: "Dollyar Air Base",
    city: "Dollyar",
    country: "AZ",
    continent: "AS",
    lat: 40.8876,
    lon: 45.957,
    elevation: 1099,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UG22": {
    icao: "UG22",
    iata: "",
    name: "Tbilisi Marneuli Air Base",
    city: "Tbilisi",
    country: "GE",
    continent: "AS",
    lat: 41.4592,
    lon: 44.7832,
    elevation: 1305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UG24": {
    icao: "UG24",
    iata: "",
    name: "Tbilisi Soganlug Air Base",
    city: "Tbilisi",
    country: "GE",
    continent: "AS",
    lat: 41.6492,
    lon: 44.9364,
    elevation: 1250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UG27": {
    icao: "UG27",
    iata: "",
    name: "Vaziani Air Base",
    city: "Gamarjveba 1",
    country: "GE",
    continent: "AS",
    lat: 41.628,
    lon: 45.0308,
    elevation: 1460,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UG28": {
    icao: "UG28",
    iata: "",
    name: "Bolshiye Shiraki Air Base",
    city: "Bolshiye Shiraki",
    country: "GE",
    continent: "AS",
    lat: 41.3795,
    lon: 46.3673,
    elevation: 1795,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UGAM": {
    icao: "UGAM",
    iata: "",
    name: "Ambrolauri Airport",
    city: "Ambrolauri",
    country: "GE",
    continent: "AS",
    lat: 42.5269,
    lon: 43.1354,
    elevation: 1784,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UGKO": {
    icao: "UGKO",
    iata: "KUT",
    name: "David the Builder Kutaisi International Airport",
    city: "Kopitnari",
    country: "GE",
    continent: "AS",
    lat: 42.1768,
    lon: 42.4824,
    elevation: 223,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UGSB": {
    icao: "UGSB",
    iata: "BUS",
    name: "Batumi International Airport",
    city: "Batumi",
    country: "GE",
    continent: "AS",
    lat: 41.6103,
    lon: 41.5997,
    elevation: 105,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UGSS": {
    icao: "UGSS",
    iata: "SUI",
    name: "Sukhumi Babushara /  Vladislav Ardzinba International Airport",
    city: "Sukhumi",
    country: "GE",
    continent: "AS",
    lat: 42.8582,
    lon: 41.1281,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UGTB": {
    icao: "UGTB",
    iata: "TBS",
    name: "Tbilisi International Airport",
    city: "Tbilisi",
    country: "GE",
    continent: "AS",
    lat: 41.6692,
    lon: 44.9547,
    elevation: 1624,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UHBB": {
    icao: "UHBB",
    iata: "BQS",
    name: "Ignatyevo Airport",
    city: "Blagoveschensk",
    country: "RU",
    continent: "AS",
    lat: 50.4254,
    lon: 127.412,
    elevation: 638,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHHH": {
    icao: "UHHH",
    iata: "KHV",
    name: "Khabarovsk Novy Airport",
    city: "Khabarovsk",
    country: "RU",
    continent: "AS",
    lat: 48.5283,
    lon: 135.1886,
    elevation: 244,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHKD": {
    icao: "UHKD",
    iata: "",
    name: "Dzemgi Airport",
    city: "Komsomolsk-na-Amur",
    country: "RU",
    continent: "AS",
    lat: 50.6056,
    lon: 137.081,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHKG": {
    icao: "UHKG",
    iata: "",
    name: "Kamenny Ruchey Naval Air Base",
    city: "Sovetskaya Gavan",
    country: "RU",
    continent: "AS",
    lat: 49.2357,
    lon: 140.1931,
    elevation: 659,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHKK": {
    icao: "UHKK",
    iata: "KXK",
    name: "Komsomolsk-on-Amur Airport",
    city: "Komsomolsk-on-Amur",
    country: "RU",
    continent: "AS",
    lat: 50.409,
    lon: 136.934,
    elevation: 92,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHKM": {
    icao: "UHKM",
    iata: "GVN",
    name: "Sovetskaya Gavan (Maygatka) Airport",
    city: "Sovetskaya Gavan",
    country: "RU",
    continent: "AS",
    lat: 48.9251,
    lon: 140.0353,
    elevation: 768,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMA": {
    icao: "UHMA",
    iata: "DYR",
    name: "Ugolny Yuri Ryktheu Airport",
    city: "Anadyr",
    country: "RU",
    continent: "AS",
    lat: 64.7349,
    lon: 177.741,
    elevation: 194,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMD": {
    icao: "UHMD",
    iata: "PVS",
    name: "Provideniya Bay Airport",
    city: "Chukotka",
    country: "RU",
    continent: "EU",
    lat: 64.3781,
    lon: -173.243,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMF": {
    icao: "UHMF",
    iata: "",
    name: "Omsukchan Airport",
    city: "Omsukchan",
    country: "RU",
    continent: "AS",
    lat: 62.457,
    lon: 155.745,
    elevation: 1732,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMG": {
    icao: "UHMG",
    iata: "",
    name: "Chaybukha Airport",
    city: "Chaybukha",
    country: "RU",
    continent: "AS",
    lat: 61.835,
    lon: 160.548,
    elevation: 207,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMK": {
    icao: "UHMK",
    iata: "KPW",
    name: "Keperveem Airport",
    city: "Keperveem",
    country: "RU",
    continent: "AS",
    lat: 67.845,
    lon: 166.14,
    elevation: 623,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMM": {
    icao: "UHMM",
    iata: "GDX",
    name: "Sokol Airport",
    city: "Magadan",
    country: "RU",
    continent: "AS",
    lat: 59.911,
    lon: 150.72,
    elevation: 574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMP": {
    icao: "UHMP",
    iata: "PWE",
    name: "Pevek Airport",
    city: "Apapelgino",
    country: "RU",
    continent: "AS",
    lat: 69.7833,
    lon: 170.597,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMS": {
    icao: "UHMS",
    iata: "",
    name: "Seymchan Airport",
    city: "Seymchan",
    country: "RU",
    continent: "AS",
    lat: 62.9208,
    lon: 152.4228,
    elevation: 679,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMT": {
    icao: "UHMT",
    iata: "",
    name: "Magadan-13 Airport",
    city: "Magadan",
    country: "RU",
    continent: "AS",
    lat: 59.6233,
    lon: 150.922,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHMW": {
    icao: "UHMW",
    iata: "SWV",
    name: "Severo-Evensk Airport",
    city: "Evensk",
    country: "RU",
    continent: "AS",
    lat: 61.9218,
    lon: 159.2291,
    elevation: 32,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHNN": {
    icao: "UHNN",
    iata: "NLI",
    name: "Nikolayevsk-na-Amure Airport",
    city: "Nikolayevsk-na-Amure Airport",
    country: "RU",
    continent: "AS",
    lat: 53.155,
    lon: 140.65,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHOO": {
    icao: "UHOO",
    iata: "OHO",
    name: "Okhotsk Airport",
    city: "Okhotsk",
    country: "RU",
    continent: "AS",
    lat: 59.4101,
    lon: 143.0565,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHPL": {
    icao: "UHPL",
    iata: "",
    name: "Palana Airport",
    city: "Palana",
    country: "RU",
    continent: "AS",
    lat: 59.0821,
    lon: 159.8916,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHPP": {
    icao: "UHPP",
    iata: "PKC",
    name: "Yelizovo Airport",
    city: "Petropavlovsk-Kamchatsky",
    country: "RU",
    continent: "AS",
    lat: 53.1687,
    lon: 158.4511,
    elevation: 131,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHSS": {
    icao: "UHSS",
    iata: "UUS",
    name: "Yuzhno-Sakhalinsk Airport",
    city: "Yuzhno-Sakhalinsk",
    country: "RU",
    continent: "AS",
    lat: 46.8855,
    lon: 142.7175,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UHWW": {
    icao: "UHWW",
    iata: "VVO",
    name: "Vladivostok International Airport",
    city: "Artyom",
    country: "RU",
    continent: "AS",
    lat: 43.3963,
    lon: 132.1482,
    elevation: 59,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UIAA": {
    icao: "UIAA",
    iata: "HTA",
    name: "Chita-Kadala International Airport",
    city: "Chita",
    country: "RU",
    continent: "EU",
    lat: 52.0263,
    lon: 113.306,
    elevation: 2272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UIAE": {
    icao: "UIAE",
    iata: "",
    name: "Krasnokamensk Airport",
    city: "Krasnokamensk",
    country: "RU",
    continent: "AS",
    lat: 50.0331,
    lon: 118.0611,
    elevation: 2139,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UIBB": {
    icao: "UIBB",
    iata: "BTK",
    name: "Bratsk Airport",
    city: "Bratsk",
    country: "RU",
    continent: "AS",
    lat: 56.3706,
    lon: 101.698,
    elevation: 1610,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UIBV": {
    icao: "UIBV",
    iata: "",
    name: "Zheleznogorsk Airport",
    city: "Zheleznogorsk-Ilimsky",
    country: "RU",
    continent: "AS",
    lat: 56.4877,
    lon: 104.106,
    elevation: 1946,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UIII": {
    icao: "UIII",
    iata: "IKT",
    name: "Irkutsk International Airport",
    city: "Irkutsk",
    country: "RU",
    continent: "EU",
    lat: 52.268,
    lon: 104.389,
    elevation: 1675,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UITT": {
    icao: "UITT",
    iata: "UKX",
    name: "Ust-Kut Airport",
    city: "Ust-Kut",
    country: "RU",
    continent: "AS",
    lat: 56.8567,
    lon: 105.73,
    elevation: 2188,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UIUU": {
    icao: "UIUU",
    iata: "UUD",
    name: "Baikal International Airport",
    city: "Ulan Ude",
    country: "RU",
    continent: "EU",
    lat: 51.8086,
    lon: 107.4397,
    elevation: 1690,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKBB": {
    icao: "UKBB",
    iata: "KBP",
    name: "Boryspil International Airport",
    city: "Boryspil",
    country: "UA",
    continent: "EU",
    lat: 50.345,
    lon: 30.8947,
    elevation: 427,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UKCM": {
    icao: "UKCM",
    iata: "MPW",
    name: "Mariupol International Airport",
    city: "Mariupol",
    country: "UA",
    continent: "EU",
    lat: 47.0761,
    lon: 37.4496,
    elevation: 251,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKDB": {
    icao: "UKDB",
    iata: "ERD",
    name: "Berdyansk Airport",
    city: "Berdyansk",
    country: "UA",
    continent: "EU",
    lat: 46.815,
    lon: 36.7581,
    elevation: 171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKDD": {
    icao: "UKDD",
    iata: "DNK",
    name: "Dnipro International Airport",
    city: "Dnipro",
    country: "UA",
    continent: "EU",
    lat: 48.3572,
    lon: 35.1006,
    elevation: 481,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKDE": {
    icao: "UKDE",
    iata: "OZH",
    name: "Zaporizhzhia International Airport",
    city: "Zaporizhia",
    country: "UA",
    continent: "EU",
    lat: 47.867,
    lon: 35.3157,
    elevation: 373,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKDR": {
    icao: "UKDR",
    iata: "KWG",
    name: "Kryvyi Rih International Airport",
    city: "Kryvyi Rih",
    country: "UA",
    continent: "EU",
    lat: 48.0433,
    lon: 33.21,
    elevation: 408,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKFB": {
    icao: "UKFB",
    iata: "UKS",
    name: "Sevastopol International Airport / Belbek Air Base",
    city: "Sevastopol",
    country: "UA",
    continent: "EU",
    lat: 44.6918,
    lon: 33.5746,
    elevation: 344,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKFF": {
    icao: "UKFF",
    iata: "SIP",
    name: "Simferopol International Airport",
    city: "Simferopol",
    country: "UA",
    continent: "EU",
    lat: 45.0522,
    lon: 33.9751,
    elevation: 639,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKFG": {
    icao: "UKFG",
    iata: "",
    name: "Gvardeyskoye (Hvardiiske) Air Base",
    city: "Hvardiiske",
    country: "UA",
    continent: "EU",
    lat: 45.1162,
    lon: 33.9766,
    elevation: 721,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKFI": {
    icao: "UKFI",
    iata: "",
    name: "Saky Air Base",
    city: "Novofedorivka",
    country: "UA",
    continent: "EU",
    lat: 45.0906,
    lon: 33.5985,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKFY": {
    icao: "UKFY",
    iata: "",
    name: "Dzhankoy Air Base",
    city: "Dzhankoy",
    country: "UA",
    continent: "EU",
    lat: 45.7009,
    lon: 34.4189,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKHH": {
    icao: "UKHH",
    iata: "HRK",
    name: "Kharkiv International Airport",
    city: "Kharkiv",
    country: "UA",
    continent: "EU",
    lat: 49.9269,
    lon: 36.2908,
    elevation: 508,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKKE": {
    icao: "UKKE",
    iata: "CKC",
    name: "Cherkasy International Airport",
    city: "Cherkasy",
    country: "UA",
    continent: "EU",
    lat: 49.4156,
    lon: 31.9953,
    elevation: 375,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKKK": {
    icao: "UKKK",
    iata: "IEV",
    name: "Ihor Sikorsky Kyiv International Airport (Zhuliany)",
    city: "Kyiv",
    country: "UA",
    continent: "EU",
    lat: 50.4019,
    lon: 30.4519,
    elevation: 587,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKKM": {
    icao: "UKKM",
    iata: "",
    name: "Hostomel Airport",
    city: "Kiev",
    country: "UA",
    continent: "EU",
    lat: 50.6035,
    lon: 30.1919,
    elevation: 517,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKKO": {
    icao: "UKKO",
    iata: "",
    name: "Ozerne Air Base",
    city: "Zhytomyr",
    country: "UA",
    continent: "EU",
    lat: 50.1583,
    lon: 28.7383,
    elevation: 761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKLH": {
    icao: "UKLH",
    iata: "HMJ",
    name: "Khmelnytskyi Airport",
    city: "Khmelnytskyi",
    country: "UA",
    continent: "EU",
    lat: 49.3597,
    lon: 26.9334,
    elevation: 1150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKLI": {
    icao: "UKLI",
    iata: "IFO",
    name: "Ivano-Frankivsk International Airport",
    city: "Ivano-Frankivsk",
    country: "UA",
    continent: "EU",
    lat: 48.8842,
    lon: 24.6861,
    elevation: 919,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKLL": {
    icao: "UKLL",
    iata: "LWO",
    name: "Lviv International Airport",
    city: "Lviv",
    country: "UA",
    continent: "EU",
    lat: 49.8125,
    lon: 23.9561,
    elevation: 1071,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UKLN": {
    icao: "UKLN",
    iata: "CWC",
    name: "Chernivtsi International Airport",
    city: "Chernivtsi",
    country: "UA",
    continent: "EU",
    lat: 48.2593,
    lon: 25.9808,
    elevation: 826,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKLR": {
    icao: "UKLR",
    iata: "RWN",
    name: "Rivne International Airport",
    city: "Rivne",
    country: "UA",
    continent: "EU",
    lat: 50.6071,
    lon: 26.1416,
    elevation: 755,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKLU": {
    icao: "UKLU",
    iata: "UDJ",
    name: "Uzhhorod International Airport",
    city: "Uzhhorod",
    country: "UA",
    continent: "EU",
    lat: 48.6343,
    lon: 22.2634,
    elevation: 383,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKOH": {
    icao: "UKOH",
    iata: "KHE",
    name: "Kherson International Airport",
    city: "Kherson",
    country: "UA",
    continent: "EU",
    lat: 46.6758,
    lon: 32.5064,
    elevation: 148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKON": {
    icao: "UKON",
    iata: "NLV",
    name: "Mykolaiv International Airport",
    city: "Nikolayev",
    country: "UA",
    continent: "EU",
    lat: 47.0579,
    lon: 31.9198,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKOO": {
    icao: "UKOO",
    iata: "ODS",
    name: "Odessa International Airport",
    city: "Odessa",
    country: "UA",
    continent: "EU",
    lat: 46.4268,
    lon: 30.6765,
    elevation: 172,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UKWW": {
    icao: "UKWW",
    iata: "VIN",
    name: "Vinnytsia/Gavyryshivka International Airport",
    city: "Vinnitsa",
    country: "UA",
    continent: "EU",
    lat: 49.2425,
    lon: 28.6138,
    elevation: 961,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULAA": {
    icao: "ULAA",
    iata: "ARH",
    name: "Talagi Airport",
    city: "Archangelsk",
    country: "RU",
    continent: "EU",
    lat: 64.6003,
    lon: 40.7167,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULAH": {
    icao: "ULAH",
    iata: "VKV",
    name: "Vaskovo Airport",
    city: "Arkhangelsk",
    country: "RU",
    continent: "EU",
    lat: 64.4417,
    lon: 40.4217,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULAM": {
    icao: "ULAM",
    iata: "NNM",
    name: "Naryan Mar Airport",
    city: "Naryan Mar",
    country: "RU",
    continent: "EU",
    lat: 67.64,
    lon: 53.1219,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULDD": {
    icao: "ULDD",
    iata: "AMV",
    name: "Amderma Airport",
    city: "Amderma",
    country: "RU",
    continent: "AS",
    lat: 69.7633,
    lon: 61.5564,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULKK": {
    icao: "ULKK",
    iata: "KSZ",
    name: "Kotlas Airport",
    city: "Kotlas",
    country: "RU",
    continent: "EU",
    lat: 61.2358,
    lon: 46.6975,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULLI": {
    icao: "ULLI",
    iata: "LED",
    name: "Pulkovo Airport",
    city: "St. Petersburg",
    country: "RU",
    continent: "EU",
    lat: 59.8003,
    lon: 30.2625,
    elevation: 78,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ULLP": {
    icao: "ULLP",
    iata: "",
    name: "Pushkin Airport",
    city: "St. Petersburg",
    country: "RU",
    continent: "EU",
    lat: 59.685,
    lon: 30.3383,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULMM": {
    icao: "ULMM",
    iata: "MMK",
    name: "Murmansk Airport",
    city: "Murmansk",
    country: "RU",
    continent: "EU",
    lat: 68.7817,
    lon: 32.7508,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULOO": {
    icao: "ULOO",
    iata: "PKV",
    name: "Pskov Airport",
    city: "Pskov",
    country: "RU",
    continent: "EU",
    lat: 57.7839,
    lon: 28.3956,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULPB": {
    icao: "ULPB",
    iata: "PES",
    name: "Petrozavodsk Airport",
    city: "Petrozavodsk",
    country: "RU",
    continent: "EU",
    lat: 61.8852,
    lon: 34.1547,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULPP": {
    icao: "ULPP",
    iata: "",
    name: "Peski Airfield",
    city: "Petrozavodsk",
    country: "RU",
    continent: "EU",
    lat: 61.8319,
    lon: 34.2956,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULWC": {
    icao: "ULWC",
    iata: "CEE",
    name: "Cherepovets Airport",
    city: "Cherepovets",
    country: "RU",
    continent: "EU",
    lat: 59.2736,
    lon: 38.0158,
    elevation: 377,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULWU": {
    icao: "ULWU",
    iata: "VUS",
    name: "Velikiy Ustyug Airport",
    city: "Velikiy Ustyug",
    country: "RU",
    continent: "AS",
    lat: 60.7883,
    lon: 46.26,
    elevation: 331,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ULWW": {
    icao: "ULWW",
    iata: "VGD",
    name: "Vologda Airport",
    city: "Vologda",
    country: "RU",
    continent: "EU",
    lat: 59.2825,
    lon: 39.9444,
    elevation: 387,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMBB": {
    icao: "UMBB",
    iata: "BQT",
    name: "Brest Airport",
    city: "Brest",
    country: "BY",
    continent: "EU",
    lat: 52.1083,
    lon: 23.8981,
    elevation: 468,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMGG": {
    icao: "UMGG",
    iata: "GME",
    name: "Gomel Airport",
    city: "Gomel",
    country: "BY",
    continent: "EU",
    lat: 52.527,
    lon: 31.0167,
    elevation: 472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMII": {
    icao: "UMII",
    iata: "VTB",
    name: "Vitebsk Vostochny Airport",
    city: "Vitebsk",
    country: "BY",
    continent: "EU",
    lat: 55.1265,
    lon: 30.3496,
    elevation: 682,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMKK": {
    icao: "UMKK",
    iata: "KGD",
    name: "Khrabrovo Airport",
    city: "Kaliningrad",
    country: "RU",
    continent: "AS",
    lat: 54.8916,
    lon: 20.5986,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMMA": {
    icao: "UMMA",
    iata: "",
    name: "Baranavichi Air Base",
    city: "Baranavichi",
    country: "BY",
    continent: "EU",
    lat: 53.1,
    lon: 26.05,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMMG": {
    icao: "UMMG",
    iata: "GNA",
    name: "Hrodna Airport",
    city: "Hrodna",
    country: "BY",
    continent: "EU",
    lat: 53.602,
    lon: 24.0538,
    elevation: 443,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMMS": {
    icao: "UMMS",
    iata: "MSQ",
    name: "Minsk National Airport",
    city: "Minsk",
    country: "BY",
    continent: "EU",
    lat: 53.8881,
    lon: 28.04,
    elevation: 670,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UMNB": {
    icao: "UMNB",
    iata: "",
    name: "Babruisk Air Base",
    city: "Babruisk",
    country: "BY",
    continent: "EU",
    lat: 53.105,
    lon: 29.205,
    elevation: 502,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UMOO": {
    icao: "UMOO",
    iata: "MVQ",
    name: "Mogilev Airport",
    city: "Mogilev",
    country: "BY",
    continent: "EU",
    lat: 53.9549,
    lon: 30.0951,
    elevation: 637,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNAA": {
    icao: "UNAA",
    iata: "ABA",
    name: "Abakan International Airport",
    city: "Abakan",
    country: "RU",
    continent: "AS",
    lat: 53.74,
    lon: 91.385,
    elevation: 831,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNBB": {
    icao: "UNBB",
    iata: "BAX",
    name: "Barnaul Airport",
    city: "Barnaul",
    country: "RU",
    continent: "AS",
    lat: 53.3638,
    lon: 83.5385,
    elevation: 837,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNBG": {
    icao: "UNBG",
    iata: "RGK",
    name: "Gorno-Altaysk Airport",
    city: "Gorno-Altaysk",
    country: "RU",
    continent: "EU",
    lat: 51.9692,
    lon: 85.8365,
    elevation: 965,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNEE": {
    icao: "UNEE",
    iata: "KEJ",
    name: "Kemerovo Airport",
    city: "Kemerovo",
    country: "RU",
    continent: "AS",
    lat: 55.2701,
    lon: 86.1072,
    elevation: 863,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNIB": {
    icao: "UNIB",
    iata: "BKA",
    name: "Baykit Airport",
    city: "Baykit",
    country: "RU",
    continent: "AS",
    lat: 61.6767,
    lon: 96.355,
    elevation: 853,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNII": {
    icao: "UNII",
    iata: "EIE",
    name: "Yeniseysk Airport",
    city: "Yeniseysk",
    country: "RU",
    continent: "AS",
    lat: 58.4742,
    lon: 92.1125,
    elevation: 253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNIP": {
    icao: "UNIP",
    iata: "TGP",
    name: "Podkamennaya Tunguska Airport",
    city: "Bor",
    country: "RU",
    continent: "EU",
    lat: 61.5897,
    lon: 89.994,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNIS": {
    icao: "UNIS",
    iata: "VEO",
    name: "Severo-Yeniseysk Airport",
    city: "Severo-Yeniseysk",
    country: "RU",
    continent: "AS",
    lat: 60.3733,
    lon: 93.0117,
    elevation: 1706,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNIW": {
    icao: "UNIW",
    iata: "VAQ",
    name: "Vanavara Airport",
    city: "Vanavara",
    country: "RU",
    continent: "AS",
    lat: 60.3562,
    lon: 102.3096,
    elevation: 892,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNKL": {
    icao: "UNKL",
    iata: "KJA",
    name: "Krasnoyarsk International Airport",
    city: "Krasnoyarsk",
    country: "RU",
    continent: "EU",
    lat: 56.1731,
    lon: 92.4924,
    elevation: 942,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UNKM": {
    icao: "UNKM",
    iata: "KCY",
    name: "Krasnoyarsk Cheremshanka Airport",
    city: "Krasnoyarsk",
    country: "RU",
    continent: "AS",
    lat: 56.1776,
    lon: 92.5459,
    elevation: 833,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNKS": {
    icao: "UNKS",
    iata: "ACS",
    name: "Achinsk Airport",
    city: "Achinsk",
    country: "RU",
    continent: "AS",
    lat: 56.2692,
    lon: 90.5751,
    elevation: 1033,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNKY": {
    icao: "UNKY",
    iata: "KYZ",
    name: "Kyzyl Airport",
    city: "Kyzyl",
    country: "RU",
    continent: "AS",
    lat: 51.6694,
    lon: 94.4006,
    elevation: 2123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNNE": {
    icao: "UNNE",
    iata: "",
    name: "Yeltsovka Airport",
    city: "Novosibirsk",
    country: "RU",
    continent: "AS",
    lat: 55.0924,
    lon: 83.0045,
    elevation: 617,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNNT": {
    icao: "UNNT",
    iata: "OVB",
    name: "Novosibirsk Tolmachevo Airport",
    city: "Novosibirsk",
    country: "RU",
    continent: "EU",
    lat: 55.0198,
    lon: 82.6187,
    elevation: 365,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UNOO": {
    icao: "UNOO",
    iata: "OMS",
    name: "Omsk Central Airport",
    city: "Omsk",
    country: "RU",
    continent: "AS",
    lat: 54.967,
    lon: 73.3105,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNOS": {
    icao: "UNOS",
    iata: "",
    name: "Omsk Severny Airport",
    city: "Omsk",
    country: "RU",
    continent: "AS",
    lat: 54.975,
    lon: 73.555,
    elevation: 380,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNSS": {
    icao: "UNSS",
    iata: "SWT",
    name: "Strezhevoy Airport",
    city: "Strezhevoy",
    country: "RU",
    continent: "AS",
    lat: 60.7094,
    lon: 77.66,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNTT": {
    icao: "UNTT",
    iata: "TOF",
    name: "Bogashevo Airport",
    city: "Tomsk",
    country: "RU",
    continent: "AS",
    lat: 56.3803,
    lon: 85.2083,
    elevation: 597,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UNWW": {
    icao: "UNWW",
    iata: "NOZ",
    name: "Spichenkovo Airport",
    city: "Novokuznetsk",
    country: "RU",
    continent: "EU",
    lat: 53.8114,
    lon: 86.8772,
    elevation: 1024,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UODD": {
    icao: "UODD",
    iata: "DKS",
    name: "Dikson Airport",
    city: "Dikson",
    country: "RU",
    continent: "AS",
    lat: 73.5178,
    lon: 80.3797,
    elevation: 47,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UODN": {
    icao: "UODN",
    iata: "",
    name: "Nagurskoye",
    city: "Murmansk",
    country: "RU",
    continent: "AS",
    lat: 80.8032,
    lon: 47.6636,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UOHH": {
    icao: "UOHH",
    iata: "HTG",
    name: "Khatanga Airport",
    city: "Khatanga",
    country: "RU",
    continent: "AS",
    lat: 71.9781,
    lon: 102.491,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UOIG": {
    icao: "UOIG",
    iata: "SES",
    name: "Svetlogorsk Airport",
    city: "Svetlogorsk",
    country: "RU",
    continent: "AS",
    lat: 66.84,
    lon: 88.4033,
    elevation: 394,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UOII": {
    icao: "UOII",
    iata: "IAA",
    name: "Igarka Airport",
    city: "Igarka",
    country: "RU",
    continent: "AS",
    lat: 67.4372,
    lon: 86.6219,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UOOO": {
    icao: "UOOO",
    iata: "NSK",
    name: "Norilsk-Alykel Airport",
    city: "Norilsk",
    country: "RU",
    continent: "AS",
    lat: 69.3111,
    lon: 87.3322,
    elevation: 574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URKA": {
    icao: "URKA",
    iata: "AAQ",
    name: "Anapa Vityazevo Airport",
    city: "Krasnyi Kurgan",
    country: "RU",
    continent: "EU",
    lat: 45.0021,
    lon: 37.3473,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URKG": {
    icao: "URKG",
    iata: "GDZ",
    name: "Gelendzhik Airport",
    city: "Gelendzhik",
    country: "RU",
    continent: "EU",
    lat: 44.5821,
    lon: 38.0125,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URKK": {
    icao: "URKK",
    iata: "KRR",
    name: "Krasnodar Pashkovsky International Airport",
    city: "Krasnodar",
    country: "RU",
    continent: "EU",
    lat: 45.0347,
    lon: 39.1705,
    elevation: 118,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URMG": {
    icao: "URMG",
    iata: "GRV",
    name: "Grozny Airport",
    city: "Grozny",
    country: "RU",
    continent: "EU",
    lat: 43.3881,
    lon: 45.6998,
    elevation: 548,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URML": {
    icao: "URML",
    iata: "MCX",
    name: "Makhachkala Uytash International Airport",
    city: "Makhachkala",
    country: "RU",
    continent: "EU",
    lat: 42.8168,
    lon: 47.6523,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URMM": {
    icao: "URMM",
    iata: "MRV",
    name: "Mineralnyye Vody Airport",
    city: "Mineralnyye Vody",
    country: "RU",
    continent: "EU",
    lat: 44.2251,
    lon: 43.0819,
    elevation: 1054,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URMN": {
    icao: "URMN",
    iata: "NAL",
    name: "Nalchik Airport",
    city: "Nalchik",
    country: "RU",
    continent: "EU",
    lat: 43.5129,
    lon: 43.6366,
    elevation: 1461,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URMO": {
    icao: "URMO",
    iata: "OGZ",
    name: "Vladikavkaz Beslan International Airport",
    city: "Beslan",
    country: "RU",
    continent: "EU",
    lat: 43.2051,
    lon: 44.6066,
    elevation: 1673,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URMS": {
    icao: "URMS",
    iata: "IGT",
    name: "Magas Airport",
    city: "Sunzha",
    country: "RU",
    continent: "AS",
    lat: 43.3233,
    lon: 45.0126,
    elevation: 1165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URMT": {
    icao: "URMT",
    iata: "STW",
    name: "Stavropol Shpakovskoye Airport",
    city: "Stavropol",
    country: "RU",
    continent: "EU",
    lat: 45.1092,
    lon: 42.1128,
    elevation: 1486,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UROD": {
    icao: "UROD",
    iata: "",
    name: "Dudinka Airport",
    city: "Dudinka",
    country: "RU",
    continent: "AS",
    lat: 69.375,
    lon: 86.1567,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URRP": {
    icao: "URRP",
    iata: "ROV",
    name: "Platov International Airport",
    city: "Rostov-on-Don",
    country: "RU",
    continent: "EU",
    lat: 47.4939,
    lon: 39.9247,
    elevation: 213,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "URRT": {
    icao: "URRT",
    iata: "TGK",
    name: "Taganrog Yuzhny Airport",
    city: "Taganrog",
    country: "RU",
    continent: "EU",
    lat: 47.1983,
    lon: 38.8492,
    elevation: 117,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URSS": {
    icao: "URSS",
    iata: "AER",
    name: "Sochi International Airport",
    city: "Sochi",
    country: "RU",
    continent: "EU",
    lat: 43.4499,
    lon: 39.9566,
    elevation: 89,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "URWA": {
    icao: "URWA",
    iata: "ASF",
    name: "Astrakhan Narimanovo Boris M. Kustodiev International Airport",
    city: "Astrakhan",
    country: "RU",
    continent: "AS",
    lat: 46.2828,
    lon: 48.0105,
    elevation: -65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URWI": {
    icao: "URWI",
    iata: "ESL",
    name: "Elista Airport",
    city: "Elista",
    country: "RU",
    continent: "EU",
    lat: 46.3739,
    lon: 44.3309,
    elevation: 501,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "URWW": {
    icao: "URWW",
    iata: "VOG",
    name: "Volgograd International Airport",
    city: "Volgograd",
    country: "RU",
    continent: "EU",
    lat: 48.7825,
    lon: 44.3455,
    elevation: 482,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USCC": {
    icao: "USCC",
    iata: "CEK",
    name: "Chelyabinsk Balandino Airport",
    city: "Chelyabinsk",
    country: "RU",
    continent: "EU",
    lat: 55.3058,
    lon: 61.5033,
    elevation: 769,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USCM": {
    icao: "USCM",
    iata: "MQF",
    name: "Magnitogorsk International Airport",
    city: "Magnitogorsk",
    country: "RU",
    continent: "EU",
    lat: 53.3931,
    lon: 58.7557,
    elevation: 1430,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USDA": {
    icao: "USDA",
    iata: "SBT",
    name: "Sabetta International Airport",
    city: "Sabetta",
    country: "RU",
    continent: "AS",
    lat: 71.2192,
    lon: 72.0522,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USDB": {
    icao: "USDB",
    iata: "BVJ",
    name: "Bovanenkovo Airport",
    city: "Bovanenkovo",
    country: "RU",
    continent: "AS",
    lat: 70.3153,
    lon: 68.3336,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USDD": {
    icao: "USDD",
    iata: "SLY",
    name: "Salekhard Airport",
    city: "Salekhard",
    country: "RU",
    continent: "AS",
    lat: 66.5908,
    lon: 66.611,
    elevation: 218,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USHB": {
    icao: "USHB",
    iata: "EZV",
    name: "Berezovo Airport",
    city: "",
    country: "RU",
    continent: "AS",
    lat: 63.921,
    lon: 65.0305,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USHH": {
    icao: "USHH",
    iata: "HMA",
    name: "Khanty Mansiysk Airport",
    city: "Khanty-Mansiysk",
    country: "RU",
    continent: "AS",
    lat: 61.0285,
    lon: 69.0861,
    elevation: 76,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USHN": {
    icao: "USHN",
    iata: "NYA",
    name: "Nyagan Airport",
    city: "Nyagan",
    country: "RU",
    continent: "EU",
    lat: 62.11,
    lon: 65.615,
    elevation: 361,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USHQ": {
    icao: "USHQ",
    iata: "EYK",
    name: "Beloyarskiy Airport",
    city: "",
    country: "RU",
    continent: "EU",
    lat: 63.6869,
    lon: 66.6986,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USHS": {
    icao: "USHS",
    iata: "OVS",
    name: "Sovetskiy Airport",
    city: "Sovetskiy",
    country: "RU",
    continent: "AS",
    lat: 61.3266,
    lon: 63.6019,
    elevation: 351,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USHU": {
    icao: "USHU",
    iata: "URJ",
    name: "Uray Airport",
    city: "Uray",
    country: "RU",
    continent: "AS",
    lat: 60.1033,
    lon: 64.8267,
    elevation: 190,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USII": {
    icao: "USII",
    iata: "IJK",
    name: "Izhevsk Airport",
    city: "Izhevsk",
    country: "RU",
    continent: "EU",
    lat: 56.8281,
    lon: 53.4575,
    elevation: 531,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USKK": {
    icao: "USKK",
    iata: "KVX",
    name: "Pobedilovo Airport",
    city: "Kirov",
    country: "RU",
    continent: "EU",
    lat: 58.5039,
    lon: 49.3478,
    elevation: 479,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USMM": {
    icao: "USMM",
    iata: "NYM",
    name: "Nadym Airport",
    city: "Nadym",
    country: "RU",
    continent: "AS",
    lat: 65.4809,
    lon: 72.6989,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USMU": {
    icao: "USMU",
    iata: "NUX",
    name: "Novy Urengoy Airport",
    city: "Novy Urengoy",
    country: "RU",
    continent: "AS",
    lat: 66.0694,
    lon: 76.5203,
    elevation: 210,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USNN": {
    icao: "USNN",
    iata: "NJC",
    name: "Nizhnevartovsk Airport",
    city: "Nizhnevartovsk",
    country: "RU",
    continent: "AS",
    lat: 60.9493,
    lon: 76.4836,
    elevation: 177,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USPP": {
    icao: "USPP",
    iata: "PEE",
    name: "Perm International Airport",
    city: "Perm",
    country: "RU",
    continent: "EU",
    lat: 57.9145,
    lon: 56.0212,
    elevation: 404,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USRK": {
    icao: "USRK",
    iata: "KGP",
    name: "Kogalym International Airport",
    city: "Kogalym",
    country: "RU",
    continent: "AS",
    lat: 62.1904,
    lon: 74.5338,
    elevation: 220,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USRN": {
    icao: "USRN",
    iata: "NFG",
    name: "Nefteyugansk Airport",
    city: "Nefteyugansk",
    country: "RU",
    continent: "AS",
    lat: 61.1083,
    lon: 72.65,
    elevation: 115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USRO": {
    icao: "USRO",
    iata: "NOJ",
    name: "Noyabrsk Airport",
    city: "Noyabrsk",
    country: "RU",
    continent: "AS",
    lat: 63.1833,
    lon: 75.27,
    elevation: 446,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USRR": {
    icao: "USRR",
    iata: "SGC",
    name: "Surgut Airport",
    city: "Surgut",
    country: "RU",
    continent: "AS",
    lat: 61.3437,
    lon: 73.4018,
    elevation: 200,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USSK": {
    icao: "USSK",
    iata: "",
    name: "Uktus Airport",
    city: "Yekaterinburg",
    country: "RU",
    continent: "AS",
    lat: 56.7017,
    lon: 60.79,
    elevation: 643,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USSS": {
    icao: "USSS",
    iata: "SVX",
    name: "Koltsovo Airport",
    city: "Yekaterinburg",
    country: "RU",
    continent: "AS",
    lat: 56.7431,
    lon: 60.8027,
    elevation: 764,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "USTJ": {
    icao: "USTJ",
    iata: "RMZ",
    name: "Remezov Airport",
    city: "Tobolsk",
    country: "RU",
    continent: "AS",
    lat: 58.0584,
    lon: 68.3488,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USTR": {
    icao: "USTR",
    iata: "TJM",
    name: "Roshchino International Airport",
    city: "Tyumen",
    country: "RU",
    continent: "AS",
    lat: 57.179,
    lon: 65.3277,
    elevation: 378,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "USUU": {
    icao: "USUU",
    iata: "KRO",
    name: "Kurgan Airport",
    city: "Kurgan",
    country: "RU",
    continent: "AS",
    lat: 55.4753,
    lon: 65.4156,
    elevation: 240,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UT1G": {
    icao: "UT1G",
    iata: "",
    name: "Ashgabat Bezmein Air Base",
    city: "Ashgabat",
    country: "TM",
    continent: "AS",
    lat: 38.012,
    lon: 58.195,
    elevation: 920,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTAA": {
    icao: "UTAA",
    iata: "ASB",
    name: "Ashgabat International Airport",
    city: "Ashgabat",
    country: "TM",
    continent: "AS",
    lat: 37.9868,
    lon: 58.361,
    elevation: 692,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UTAK": {
    icao: "UTAK",
    iata: "KRW",
    name: "Turkmenbashi International Airport",
    city: "Turkmenbashi",
    country: "TM",
    continent: "AS",
    lat: 40.0633,
    lon: 53.0072,
    elevation: 279,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTAM": {
    icao: "UTAM",
    iata: "MYP",
    name: "Mary International Airport",
    city: "Mary",
    country: "TM",
    continent: "AS",
    lat: 37.6235,
    lon: 61.8957,
    elevation: 728,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTAT": {
    icao: "UTAT",
    iata: "TAZ",
    name: "Daşoguz Airport",
    city: "Daşoguz",
    country: "TM",
    continent: "AS",
    lat: 41.7599,
    lon: 59.8361,
    elevation: 272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTAV": {
    icao: "UTAV",
    iata: "CRZ",
    name: "Türkmenabat International Airport",
    city: "Türkmenabat",
    country: "TM",
    continent: "AS",
    lat: 38.9307,
    lon: 63.564,
    elevation: 649,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTDD": {
    icao: "UTDD",
    iata: "DYU",
    name: "Dushanbe International Airport",
    city: "Dushanbe",
    country: "TJ",
    continent: "AS",
    lat: 38.5437,
    lon: 68.823,
    elevation: 2575,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTDK": {
    icao: "UTDK",
    iata: "TJU",
    name: "Kulob Airport",
    city: "Kulyab",
    country: "TJ",
    continent: "AS",
    lat: 37.9881,
    lon: 69.805,
    elevation: 2293,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTDL": {
    icao: "UTDL",
    iata: "LBD",
    name: "Khujand Airport",
    city: "Khujand",
    country: "TJ",
    continent: "AS",
    lat: 40.2154,
    lon: 69.6947,
    elevation: 1450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTDT": {
    icao: "UTDT",
    iata: "KQT",
    name: "Qurghonteppa International Airport",
    city: "Kurgan-Tyube",
    country: "TJ",
    continent: "AS",
    lat: 37.8664,
    lon: 68.8647,
    elevation: 1473,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTKA": {
    icao: "UTKA",
    iata: "AZN",
    name: "Andizhan Airport",
    city: "Andizhan",
    country: "UZ",
    continent: "AS",
    lat: 40.7277,
    lon: 72.294,
    elevation: 1515,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTKF": {
    icao: "UTKF",
    iata: "FEG",
    name: "Fergana International Airport",
    city: "Fergana",
    country: "UZ",
    continent: "AS",
    lat: 40.3588,
    lon: 71.745,
    elevation: 1980,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTNN": {
    icao: "UTNN",
    iata: "NCU",
    name: "Nukus Airport",
    city: "Nukus",
    country: "UZ",
    continent: "AS",
    lat: 42.4884,
    lon: 59.6233,
    elevation: 246,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTNU": {
    icao: "UTNU",
    iata: "UGC",
    name: "Urgench Airport",
    city: "Urgench",
    country: "UZ",
    continent: "AS",
    lat: 41.5843,
    lon: 60.6417,
    elevation: 320,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTSA": {
    icao: "UTSA",
    iata: "NVI",
    name: "Navoi Airport",
    city: "Navoi",
    country: "UZ",
    continent: "AS",
    lat: 40.1172,
    lon: 65.1708,
    elevation: 1140,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTSB": {
    icao: "UTSB",
    iata: "BHK",
    name: "Bukhara International Airport",
    city: "Bukhara",
    country: "UZ",
    continent: "AS",
    lat: 39.775,
    lon: 64.4833,
    elevation: 751,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTSS": {
    icao: "UTSS",
    iata: "SKD",
    name: "Samarkand Airport",
    city: "Samarkand",
    country: "UZ",
    continent: "AS",
    lat: 39.7005,
    lon: 66.9838,
    elevation: 2224,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTST": {
    icao: "UTST",
    iata: "TMJ",
    name: "Termez Airport",
    city: "Termez",
    country: "UZ",
    continent: "AS",
    lat: 37.2873,
    lon: 67.3119,
    elevation: 1027,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTTP": {
    icao: "UTTP",
    iata: "",
    name: "Tashkent East Airport",
    city: "Tashkent",
    country: "UZ",
    continent: "AS",
    lat: 41.3129,
    lon: 69.3955,
    elevation: 1574,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UTTT": {
    icao: "UTTT",
    iata: "TAS",
    name: "Tashkent International Airport",
    city: "Tashkent",
    country: "UZ",
    continent: "AS",
    lat: 41.2579,
    lon: 69.2812,
    elevation: 1417,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UTTZ": {
    icao: "UTTZ",
    iata: "OMN",
    name: "Zomin Airport",
    city: "Zaamin",
    country: "UZ",
    continent: "AS",
    lat: 40.014,
    lon: 68.411,
    elevation: 1760,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUBA": {
    icao: "UUBA",
    iata: "KMW",
    name: "Kostroma Sokerkino Airport",
    city: "Kostroma",
    country: "RU",
    continent: "EU",
    lat: 57.7969,
    lon: 41.0194,
    elevation: 446,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUBC": {
    icao: "UUBC",
    iata: "KLF",
    name: "Grabtsevo Airport",
    city: "Kaluga",
    country: "RU",
    continent: "EU",
    lat: 54.55,
    lon: 36.3667,
    elevation: 656,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUBI": {
    icao: "UUBI",
    iata: "IWA",
    name: "Ivanovo South Airport",
    city: "Ivanovo",
    country: "RU",
    continent: "EU",
    lat: 56.9394,
    lon: 40.9408,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUBK": {
    icao: "UUBK",
    iata: "RYB",
    name: "Staroselye Airport",
    city: "Rybinsk",
    country: "RU",
    continent: "EU",
    lat: 58.1042,
    lon: 38.9294,
    elevation: 423,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUBP": {
    icao: "UUBP",
    iata: "BZK",
    name: "Bryansk Airport",
    city: "Bryansk",
    country: "RU",
    continent: "EU",
    lat: 53.2142,
    lon: 34.1764,
    elevation: 663,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUBW": {
    icao: "UUBW",
    iata: "ZIA",
    name: "Zhukovsky International Airport",
    city: "Moscow",
    country: "RU",
    continent: "EU",
    lat: 55.5533,
    lon: 38.15,
    elevation: 377,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UUDD": {
    icao: "UUDD",
    iata: "DME",
    name: "Domodedovo International Airport",
    city: "Moscow",
    country: "RU",
    continent: "EU",
    lat: 55.4088,
    lon: 37.9063,
    elevation: 588,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UUEE": {
    icao: "UUEE",
    iata: "SVO",
    name: "Sheremetyevo International Airport",
    city: "Moscow",
    country: "RU",
    continent: "EU",
    lat: 55.9726,
    lon: 37.4146,
    elevation: 622,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UUEM": {
    icao: "UUEM",
    iata: "KLD",
    name: "Migalovo Air Base",
    city: "Tver",
    country: "RU",
    continent: "EU",
    lat: 56.8247,
    lon: 35.7577,
    elevation: 469,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUMO": {
    icao: "UUMO",
    iata: "OSF",
    name: "Ostafyevo International Airport",
    city: "Moscow",
    country: "RU",
    continent: "EU",
    lat: 55.5117,
    lon: 37.5072,
    elevation: 568,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUMT": {
    icao: "UUMT",
    iata: "",
    name: "Tretyakovo Airport",
    city: "Lukhovitsy",
    country: "RU",
    continent: "EU",
    lat: 54.905,
    lon: 39.0267,
    elevation: 515,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUMU": {
    icao: "UUMU",
    iata: "CKL",
    name: "Chkalovskiy Air Base",
    city: "Moscow",
    country: "RU",
    continent: "EU",
    lat: 55.8783,
    lon: 38.0617,
    elevation: 499,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUOB": {
    icao: "UUOB",
    iata: "EGO",
    name: "Belgorod International Airport",
    city: "Belgorod",
    country: "RU",
    continent: "EU",
    lat: 50.6438,
    lon: 36.5901,
    elevation: 735,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUOK": {
    icao: "UUOK",
    iata: "URS",
    name: "Kursk East Airport",
    city: "Kursk",
    country: "RU",
    continent: "EU",
    lat: 51.7506,
    lon: 36.2956,
    elevation: 686,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUOL": {
    icao: "UUOL",
    iata: "LPK",
    name: "Lipetsk Airport",
    city: "Lipetsk",
    country: "RU",
    continent: "EU",
    lat: 52.7028,
    lon: 39.5378,
    elevation: 584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUOO": {
    icao: "UUOO",
    iata: "VOZ",
    name: "Voronezh International Airport",
    city: "Voronezh",
    country: "RU",
    continent: "EU",
    lat: 51.8142,
    lon: 39.2296,
    elevation: 514,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUOT": {
    icao: "UUOT",
    iata: "TBW",
    name: "Donskoye Airport",
    city: "Tambov",
    country: "RU",
    continent: "EU",
    lat: 52.8061,
    lon: 41.4828,
    elevation: 413,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUWW": {
    icao: "UUWW",
    iata: "VKO",
    name: "Vnukovo International Airport",
    city: "Moscow",
    country: "RU",
    continent: "EU",
    lat: 55.5915,
    lon: 37.2615,
    elevation: 685,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UUYH": {
    icao: "UUYH",
    iata: "UCT",
    name: "Ukhta Airport",
    city: "Ukhta",
    country: "RU",
    continent: "AS",
    lat: 63.5669,
    lon: 53.8047,
    elevation: 482,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYI": {
    icao: "UUYI",
    iata: "INA",
    name: "Inta Airport",
    city: "Inta",
    country: "RU",
    continent: "EU",
    lat: 66.0534,
    lon: 60.1058,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYK": {
    icao: "UUYK",
    iata: "",
    name: "Vuktyl Airport",
    city: "Vuktyl",
    country: "RU",
    continent: "AS",
    lat: 63.8233,
    lon: 57.28,
    elevation: 358,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYP": {
    icao: "UUYP",
    iata: "PEX",
    name: "Pechora Airport",
    city: "Pechora",
    country: "RU",
    continent: "EU",
    lat: 65.1211,
    lon: 57.1308,
    elevation: 98,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYS": {
    icao: "UUYS",
    iata: "USK",
    name: "Usinsk Airport",
    city: "Usinsk",
    country: "RU",
    continent: "AS",
    lat: 66.0047,
    lon: 57.3672,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYV": {
    icao: "UUYV",
    iata: "",
    name: "Izhma Airport",
    city: "Izhma",
    country: "RU",
    continent: "AS",
    lat: 65.0317,
    lon: 53.97,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYW": {
    icao: "UUYW",
    iata: "VKT",
    name: "Vorkuta Airport",
    city: "Vorkuta",
    country: "RU",
    continent: "AS",
    lat: 67.4886,
    lon: 63.9931,
    elevation: 604,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYX": {
    icao: "UUYX",
    iata: "UTS",
    name: "Ust-Tsylma Airport",
    city: "Ust-Tsylma",
    country: "RU",
    continent: "AS",
    lat: 65.4373,
    lon: 52.2003,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UUYY": {
    icao: "UUYY",
    iata: "SCW",
    name: "Syktyvkar Airport",
    city: "Syktyvkar",
    country: "RU",
    continent: "EU",
    lat: 61.647,
    lon: 50.8451,
    elevation: 342,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWGG": {
    icao: "UWGG",
    iata: "GOJ",
    name: "Nizhny Novgorod / Strigino International Airport",
    city: "Nizhny Novgorod",
    country: "RU",
    continent: "EU",
    lat: 56.2283,
    lon: 43.7852,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWKB": {
    icao: "UWKB",
    iata: "UUA",
    name: "Bugulma Airport",
    city: "Bugulma",
    country: "RU",
    continent: "AS",
    lat: 54.6412,
    lon: 52.8002,
    elevation: 991,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWKD": {
    icao: "UWKD",
    iata: "KZN",
    name: "Kazan International Airport",
    city: "Kazan",
    country: "RU",
    continent: "AS",
    lat: 55.6062,
    lon: 49.2787,
    elevation: 411,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UWKE": {
    icao: "UWKE",
    iata: "NBC",
    name: "Begishevo Airport",
    city: "Nizhnekamsk",
    country: "RU",
    continent: "AS",
    lat: 55.5647,
    lon: 52.0925,
    elevation: 643,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWKG": {
    icao: "UWKG",
    iata: "",
    name: "Borisoglebskoye Airport",
    city: "Kazan",
    country: "RU",
    continent: "AS",
    lat: 55.8667,
    lon: 49.1333,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWKJ": {
    icao: "UWKJ",
    iata: "JOK",
    name: "Yoshkar-Ola Airport",
    city: "Yoshkar-Ola",
    country: "RU",
    continent: "AS",
    lat: 56.7006,
    lon: 47.9047,
    elevation: 348,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWKS": {
    icao: "UWKS",
    iata: "CSY",
    name: "Cheboksary Airport",
    city: "Cheboksary",
    country: "RU",
    continent: "AS",
    lat: 56.0903,
    lon: 47.3473,
    elevation: 558,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWLL": {
    icao: "UWLL",
    iata: "ULV",
    name: "Ulyanovsk Baratayevka Airport",
    city: "Ulyanovsk",
    country: "RU",
    continent: "EU",
    lat: 54.2683,
    lon: 48.2267,
    elevation: 449,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWLW": {
    icao: "UWLW",
    iata: "ULY",
    name: "Ulyanovsk East Airport",
    city: "Cherdakly",
    country: "RU",
    continent: "EU",
    lat: 54.401,
    lon: 48.8027,
    elevation: 252,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWOO": {
    icao: "UWOO",
    iata: "REN",
    name: "Orenburg Central Airport",
    city: "Orenburg",
    country: "RU",
    continent: "EU",
    lat: 51.7958,
    lon: 55.4567,
    elevation: 387,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWOR": {
    icao: "UWOR",
    iata: "OSW",
    name: "Orsk Airport",
    city: "Orsk",
    country: "RU",
    continent: "AS",
    lat: 51.0725,
    lon: 58.5956,
    elevation: 909,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWPP": {
    icao: "UWPP",
    iata: "PEZ",
    name: "Penza Airport",
    city: "Penza",
    country: "RU",
    continent: "EU",
    lat: 53.1106,
    lon: 45.0211,
    elevation: 614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWPS": {
    icao: "UWPS",
    iata: "SKX",
    name: "Saransk Airport",
    city: "Saransk",
    country: "RU",
    continent: "EU",
    lat: 54.1251,
    lon: 45.2123,
    elevation: 676,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWSB": {
    icao: "UWSB",
    iata: "BWO",
    name: "Balakovo Airport",
    city: "Balakovo",
    country: "RU",
    continent: "AS",
    lat: 51.8583,
    lon: 47.7456,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWSG": {
    icao: "UWSG",
    iata: "GSV",
    name: "Gagarin International Airport",
    city: "Saratov",
    country: "RU",
    continent: "AS",
    lat: 51.7128,
    lon: 46.1711,
    elevation: 103,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UWUU": {
    icao: "UWUU",
    iata: "UFA",
    name: "Ufa International Airport",
    city: "Ufa",
    country: "RU",
    continent: "EU",
    lat: 54.5575,
    lon: 55.8744,
    elevation: 449,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "UWWB": {
    icao: "UWWB",
    iata: "",
    name: "Buguruslan Severny Airport",
    city: "Buguruslan",
    country: "RU",
    continent: "AS",
    lat: 53.7184,
    lon: 52.3719,
    elevation: 728,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWWG": {
    icao: "UWWG",
    iata: "",
    name: "Bezymyanka Airfield",
    city: "Samara",
    country: "RU",
    continent: "AS",
    lat: 53.22,
    lon: 50.325,
    elevation: 135,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "UWWW": {
    icao: "UWWW",
    iata: "KUF",
    name: "Kurumoch International Airport",
    city: "Samara",
    country: "RU",
    continent: "EU",
    lat: 53.5049,
    lon: 50.1643,
    elevation: 477,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VA1G": {
    icao: "VA1G",
    iata: "REW",
    name: "Rewa Airport, Chorhata, REWA",
    city: "Rewa",
    country: "IN",
    continent: "AS",
    lat: 24.5034,
    lon: 81.2203,
    elevation: 1000,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VA2C": {
    icao: "VA2C",
    iata: "GDB",
    name: "Gondia Airport",
    city: "Gondia",
    country: "IN",
    continent: "AS",
    lat: 21.5268,
    lon: 80.2903,
    elevation: 987,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAAH": {
    icao: "VAAH",
    iata: "AMD",
    name: "Sardar Vallabh Bhai Patel International Airport",
    city: "Ahmedabad",
    country: "IN",
    continent: "AS",
    lat: 23.0772,
    lon: 72.6347,
    elevation: 189,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAAK": {
    icao: "VAAK",
    iata: "AKD",
    name: "Akola Airport",
    city: "Akola",
    country: "IN",
    continent: "AS",
    lat: 20.6989,
    lon: 77.0569,
    elevation: 999,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAAU": {
    icao: "VAAU",
    iata: "IXU",
    name: "Aurangabad Airport",
    city: "Aurangabad",
    country: "IN",
    continent: "AS",
    lat: 19.8627,
    lon: 75.3981,
    elevation: 1911,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VABB": {
    icao: "VABB",
    iata: "BOM",
    name: "Chhatrapati Shivaji International Airport",
    city: "Mumbai",
    country: "IN",
    continent: "AS",
    lat: 19.0887,
    lon: 72.8679,
    elevation: 39,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VABJ": {
    icao: "VABJ",
    iata: "BHJ",
    name: "Bhuj Airport",
    city: "Bhuj",
    country: "IN",
    continent: "AS",
    lat: 23.2878,
    lon: 69.6702,
    elevation: 268,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VABM": {
    icao: "VABM",
    iata: "IXG",
    name: "Belagavi Airport",
    city: "Belgaum",
    country: "IN",
    continent: "AS",
    lat: 15.8593,
    lon: 74.6183,
    elevation: 2487,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VABO": {
    icao: "VABO",
    iata: "BDQ",
    name: "Vadodara Airport",
    city: "Vadodara",
    country: "IN",
    continent: "AS",
    lat: 22.3362,
    lon: 73.2263,
    elevation: 129,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VABP": {
    icao: "VABP",
    iata: "BHO",
    name: "Raja Bhoj International Airport",
    city: "Bhopal",
    country: "IN",
    continent: "AS",
    lat: 23.2875,
    lon: 77.3374,
    elevation: 1711,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VABV": {
    icao: "VABV",
    iata: "BHU",
    name: "Bhavnagar Airport",
    city: "Bhavnagar",
    country: "IN",
    continent: "AS",
    lat: 21.7522,
    lon: 72.1852,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VADN": {
    icao: "VADN",
    iata: "NMB",
    name: "Daman Airport",
    city: "Daman",
    country: "IN",
    continent: "AS",
    lat: 20.4344,
    lon: 72.8432,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAHB": {
    icao: "VAHB",
    iata: "HBX",
    name: "Hubli Airport",
    city: "Hubli",
    country: "IN",
    continent: "AS",
    lat: 15.3617,
    lon: 75.0849,
    elevation: 2171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAHS": {
    icao: "VAHS",
    iata: "HSR",
    name: "Rajkot International Airport",
    city: "Rajkot",
    country: "IN",
    continent: "AS",
    lat: 22.3788,
    lon: 71.0394,
    elevation: 647,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VAID": {
    icao: "VAID",
    iata: "IDR",
    name: "Devi Ahilyabai Holkar Airport",
    city: "Indore",
    country: "IN",
    continent: "AS",
    lat: 22.7218,
    lon: 75.8011,
    elevation: 1850,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAJB": {
    icao: "VAJB",
    iata: "JLR",
    name: "Jabalpur Airport",
    city: "Jabalpur",
    country: "IN",
    continent: "AS",
    lat: 23.1778,
    lon: 80.052,
    elevation: 1624,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAJM": {
    icao: "VAJM",
    iata: "JGA",
    name: "Jamnagar Airport",
    city: "Jamnagar",
    country: "IN",
    continent: "AS",
    lat: 22.4655,
    lon: 70.0126,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAKE": {
    icao: "VAKE",
    iata: "IXY",
    name: "Kandla Airport",
    city: "Kandla",
    country: "IN",
    continent: "AS",
    lat: 23.1127,
    lon: 70.1003,
    elevation: 96,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAKJ": {
    icao: "VAKJ",
    iata: "HJR",
    name: "Khajuraho Airport",
    city: "Khajuraho",
    country: "IN",
    continent: "AS",
    lat: 24.8172,
    lon: 79.9186,
    elevation: 728,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAKP": {
    icao: "VAKP",
    iata: "KLH",
    name: "Kolhapur Airport",
    city: "Kolhapur",
    country: "IN",
    continent: "AS",
    lat: 16.6647,
    lon: 74.2894,
    elevation: 1996,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAKS": {
    icao: "VAKS",
    iata: "IXK",
    name: "Keshod Airport",
    city: "Keshod",
    country: "IN",
    continent: "AS",
    lat: 21.3171,
    lon: 70.2704,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VALT": {
    icao: "VALT",
    iata: "LTU",
    name: "Murod Kond Airport",
    city: "Latur",
    country: "IN",
    continent: "AS",
    lat: 18.4115,
    lon: 76.4647,
    elevation: 2136,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAND": {
    icao: "VAND",
    iata: "NDC",
    name: "Nanded Airport",
    city: "Nanded",
    country: "IN",
    continent: "AS",
    lat: 19.1833,
    lon: 77.3167,
    elevation: 1250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VANP": {
    icao: "VANP",
    iata: "NAG",
    name: "Dr. Babasaheb Ambedkar International Airport",
    city: "Nagpur",
    country: "IN",
    continent: "AS",
    lat: 21.0922,
    lon: 79.0472,
    elevation: 1033,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAOZ": {
    icao: "VAOZ",
    iata: "ISK",
    name: "Nashik Airport",
    city: "Nasik",
    country: "IN",
    continent: "AS",
    lat: 20.1191,
    lon: 73.9129,
    elevation: 1900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAPO": {
    icao: "VAPO",
    iata: "PNQ",
    name: "Pune Airport / Lohagaon Air Force Station",
    city: "Pune",
    country: "IN",
    continent: "AS",
    lat: 18.5821,
    lon: 73.9197,
    elevation: 1942,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAPR": {
    icao: "VAPR",
    iata: "PBD",
    name: "Porbandar Airport",
    city: "Porbandar",
    country: "IN",
    continent: "AS",
    lat: 21.6495,
    lon: 69.6564,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VARG": {
    icao: "VARG",
    iata: "RTC",
    name: "Ratnagiri Airport",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 17.0136,
    lon: 73.3278,
    elevation: 305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VARK": {
    icao: "VARK",
    iata: "RAJ",
    name: "Rajkot Airport",
    city: "Rajkot",
    country: "IN",
    continent: "AS",
    lat: 22.3092,
    lon: 70.7795,
    elevation: 441,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VARP": {
    icao: "VARP",
    iata: "RPR",
    name: "Swami Vivekananda Airport",
    city: "Raipur",
    country: "IN",
    continent: "AS",
    lat: 21.1804,
    lon: 81.7388,
    elevation: 1041,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VASD": {
    icao: "VASD",
    iata: "SAG",
    name: "Shirdi Airport",
    city: "Kakadi",
    country: "IN",
    continent: "AS",
    lat: 19.6888,
    lon: 74.3774,
    elevation: 1926,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VASL": {
    icao: "VASL",
    iata: "SSE",
    name: "Solapur Airport",
    city: "Solapur",
    country: "IN",
    continent: "AS",
    lat: 17.628,
    lon: 75.9348,
    elevation: 1584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VASU": {
    icao: "VASU",
    iata: "STV",
    name: "Surat Airport",
    city: "Surat",
    country: "IN",
    continent: "AS",
    lat: 21.1141,
    lon: 72.7418,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VAUD": {
    icao: "VAUD",
    iata: "UDR",
    name: "Maharana Pratap Airport",
    city: "Udaipur",
    country: "IN",
    continent: "AS",
    lat: 24.6177,
    lon: 73.8961,
    elevation: 1684,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCBI": {
    icao: "VCBI",
    iata: "CMB",
    name: "Bandaranaike International Colombo Airport",
    city: "Colombo",
    country: "LK",
    continent: "AS",
    lat: 7.1808,
    lon: 79.8841,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VCCA": {
    icao: "VCCA",
    iata: "ACJ",
    name: "Anuradhapura Airport",
    city: "Anuradhapura",
    country: "LK",
    continent: "AS",
    lat: 8.3015,
    lon: 80.4285,
    elevation: 324,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCB": {
    icao: "VCCB",
    iata: "BTC",
    name: "Batticaloa Airport",
    city: "Batticaloa",
    country: "LK",
    continent: "AS",
    lat: 7.7058,
    lon: 81.6788,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCC": {
    icao: "VCCC",
    iata: "RML",
    name: "Colombo Ratmalana Airport",
    city: "Colombo",
    country: "LK",
    continent: "AS",
    lat: 6.822,
    lon: 79.8862,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCG": {
    icao: "VCCG",
    iata: "ADP",
    name: "Ampara Airport",
    city: "Ampara",
    country: "LK",
    continent: "AS",
    lat: 7.3367,
    lon: 81.6239,
    elevation: 150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCH": {
    icao: "VCCH",
    iata: "HIM",
    name: "Hingurakgoda Air Force Base",
    city: "Polonnaruwa Town",
    country: "LK",
    continent: "AS",
    lat: 8.0498,
    lon: 80.9814,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCJ": {
    icao: "VCCJ",
    iata: "JAF",
    name: "Jaffna International Airport",
    city: "Jaffna",
    country: "LK",
    continent: "AS",
    lat: 9.7923,
    lon: 80.0701,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCK": {
    icao: "VCCK",
    iata: "KCT",
    name: "Koggala Airport",
    city: "Galle",
    country: "LK",
    continent: "AS",
    lat: 5.9937,
    lon: 80.3203,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCCT": {
    icao: "VCCT",
    iata: "TRR",
    name: "China Bay Airport",
    city: "Trincomalee",
    country: "LK",
    continent: "AS",
    lat: 8.5392,
    lon: 81.1813,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VCRI": {
    icao: "VCRI",
    iata: "HRI",
    name: "Mattala Rajapaksa International Airport",
    city: "Mattala",
    country: "LK",
    continent: "AS",
    lat: 6.2845,
    lon: 81.1241,
    elevation: 157,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VDBG": {
    icao: "VDBG",
    iata: "BBM",
    name: "Battambang Airport",
    city: "Battambang",
    country: "KH",
    continent: "AS",
    lat: 13.0956,
    lon: 103.224,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VDPP": {
    icao: "VDPP",
    iata: "PNH",
    name: "Phnom Penh International Airport",
    city: "Phnom Penh (Pou Senchey)",
    country: "KH",
    continent: "AS",
    lat: 11.5466,
    lon: 104.844,
    elevation: 40,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VDRK": {
    icao: "VDRK",
    iata: "RBE",
    name: "Ratanakiri Airport",
    city: "Ratanakiri",
    country: "KH",
    continent: "AS",
    lat: 13.73,
    lon: 106.987,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VDSA": {
    icao: "VDSA",
    iata: "SAI",
    name: "Siem Reap-Angkor International Airport",
    city: "Siem Reap",
    country: "KH",
    continent: "AS",
    lat: 13.3692,
    lon: 104.2231,
    elevation: 191,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VEAN": {
    icao: "VEAN",
    iata: "IXV",
    name: "Along Airport",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 28.1753,
    lon: 94.802,
    elevation: 900,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEAT": {
    icao: "VEAT",
    iata: "IXA",
    name: "Agartala - Maharaja Bir Bikram Airport",
    city: "Agartala",
    country: "IN",
    continent: "AS",
    lat: 23.887,
    lon: 91.2404,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEBD": {
    icao: "VEBD",
    iata: "IXB",
    name: "Bagdogra Airport",
    city: "Siliguri",
    country: "IN",
    continent: "AS",
    lat: 26.6812,
    lon: 88.3286,
    elevation: 412,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEBI": {
    icao: "VEBI",
    iata: "SHL",
    name: "Shillong Airport",
    city: "Shillong",
    country: "IN",
    continent: "AS",
    lat: 25.7036,
    lon: 91.9787,
    elevation: 2910,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEBN": {
    icao: "VEBN",
    iata: "VNS",
    name: "Lal Bahadur Shastri Airport",
    city: "Varanasi",
    country: "IN",
    continent: "AS",
    lat: 25.4521,
    lon: 82.8618,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEBS": {
    icao: "VEBS",
    iata: "BBI",
    name: "Biju Patnaik International Airport",
    city: "Bhubaneswar",
    country: "IN",
    continent: "AS",
    lat: 20.2444,
    lon: 85.8178,
    elevation: 138,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEBU": {
    icao: "VEBU",
    iata: "PAB",
    name: "Bilaspur Airport",
    city: "Bilaspur",
    country: "IN",
    continent: "AS",
    lat: 21.9884,
    lon: 82.111,
    elevation: 899,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VECC": {
    icao: "VECC",
    iata: "CCU",
    name: "Netaji Subhash Chandra Bose International Airport",
    city: "Kolkata",
    country: "IN",
    continent: "AS",
    lat: 22.6547,
    lon: 88.4467,
    elevation: 16,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VEDB": {
    icao: "VEDB",
    iata: "DBD",
    name: "Dhanbad Airport",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 23.834,
    lon: 86.4253,
    elevation: 847,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEDG": {
    icao: "VEDG",
    iata: "RDP",
    name: "Kazi Nazrul Islam Airport",
    city: "Durgapur",
    country: "IN",
    continent: "AS",
    lat: 23.6225,
    lon: 87.243,
    elevation: 300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEDH": {
    icao: "VEDH",
    iata: "DBR",
    name: "Darbhanga Airport",
    city: "Darbhanga",
    country: "IN",
    continent: "AS",
    lat: 26.1928,
    lon: 85.9169,
    elevation: 156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEGK": {
    icao: "VEGK",
    iata: "GOP",
    name: "Gorakhpur Airport",
    city: "Gorakhpur",
    country: "IN",
    continent: "AS",
    lat: 26.7397,
    lon: 83.4497,
    elevation: 259,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEGT": {
    icao: "VEGT",
    iata: "GAU",
    name: "Lokpriya Gopinath Bordoloi International Airport",
    city: "Guwahati",
    country: "IN",
    continent: "AS",
    lat: 26.1061,
    lon: 91.5859,
    elevation: 162,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEGY": {
    icao: "VEGY",
    iata: "GAY",
    name: "Gaya Airport",
    city: "Gaya",
    country: "IN",
    continent: "AS",
    lat: 24.7443,
    lon: 84.9512,
    elevation: 380,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEHX": {
    icao: "VEHX",
    iata: "",
    name: "Hashimara Air Force Station",
    city: "Jalpaiguri",
    country: "IN",
    continent: "AS",
    lat: 26.6983,
    lon: 89.3691,
    elevation: 340,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEIM": {
    icao: "VEIM",
    iata: "IMF",
    name: "Imphal Airport",
    city: "Imphal",
    country: "IN",
    continent: "AS",
    lat: 24.76,
    lon: 93.8967,
    elevation: 2540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEJS": {
    icao: "VEJS",
    iata: "IXW",
    name: "Sonari Airport",
    city: "Jamshedpur",
    country: "IN",
    continent: "AS",
    lat: 22.8137,
    lon: 86.169,
    elevation: 475,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEJT": {
    icao: "VEJT",
    iata: "JRH",
    name: "Jorhat Airport",
    city: "Jorhat",
    country: "IN",
    continent: "AS",
    lat: 26.7305,
    lon: 94.1754,
    elevation: 311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEKI": {
    icao: "VEKI",
    iata: "KBK",
    name: "Kushinagar International Airport",
    city: "Kushinagar",
    country: "IN",
    continent: "AS",
    lat: 26.7765,
    lon: 83.8892,
    elevation: 266,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEKR": {
    icao: "VEKR",
    iata: "IXH",
    name: "Kailashahar Airport",
    city: "Kailashahar",
    country: "IN",
    continent: "AS",
    lat: 24.3087,
    lon: 92.0077,
    elevation: 79,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEKU": {
    icao: "VEKU",
    iata: "IXS",
    name: "Silchar Airport",
    city: "Silchar",
    country: "IN",
    continent: "AS",
    lat: 24.9129,
    lon: 92.9787,
    elevation: 352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VELP": {
    icao: "VELP",
    iata: "AJL",
    name: "Lengpui Airport",
    city: "Aizawl (Lengpui)",
    country: "IN",
    continent: "AS",
    lat: 23.8406,
    lon: 92.6197,
    elevation: 1398,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VELR": {
    icao: "VELR",
    iata: "IXI",
    name: "Lilabari North Lakhimpur Airport",
    city: "Lilabari",
    country: "IN",
    continent: "AS",
    lat: 27.2957,
    lon: 94.0973,
    elevation: 330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEMN": {
    icao: "VEMN",
    iata: "DIB",
    name: "Dibrugarh Airport",
    city: "Dibrugarh",
    country: "IN",
    continent: "AS",
    lat: 27.4839,
    lon: 95.0169,
    elevation: 362,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEMR": {
    icao: "VEMR",
    iata: "DMU",
    name: "Dimapur Airport",
    city: "Dimapur",
    country: "IN",
    continent: "AS",
    lat: 25.8839,
    lon: 93.7711,
    elevation: 487,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEMZ": {
    icao: "VEMZ",
    iata: "MZU",
    name: "Muzaffarpur Airport",
    city: "Muzaffarpur",
    country: "IN",
    continent: "AS",
    lat: 26.1191,
    lon: 85.3137,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEPH": {
    icao: "VEPH",
    iata: "",
    name: "Panagarh Air Force Station",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 23.4743,
    lon: 87.4275,
    elevation: 240,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEPT": {
    icao: "VEPT",
    iata: "PAT",
    name: "Jay Prakash Narayan Airport",
    city: "Patna",
    country: "IN",
    continent: "AS",
    lat: 25.5913,
    lon: 85.088,
    elevation: 170,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VERC": {
    icao: "VERC",
    iata: "IXR",
    name: "Birsa Munda Airport",
    city: "Ranchi",
    country: "IN",
    continent: "AS",
    lat: 23.3143,
    lon: 85.3217,
    elevation: 2148,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VERK": {
    icao: "VERK",
    iata: "RRK",
    name: "Rourkela Airport",
    city: "Rourkela",
    country: "IN",
    continent: "AS",
    lat: 22.2566,
    lon: 84.8152,
    elevation: 659,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VETZ": {
    icao: "VETZ",
    iata: "TEZ",
    name: "Tezpur Airport",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 26.7091,
    lon: 92.7847,
    elevation: 240,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEVZ": {
    icao: "VEVZ",
    iata: "VTZ",
    name: "Visakhapatnam Airport",
    city: "Visakhapatnam",
    country: "IN",
    continent: "AS",
    lat: 17.7235,
    lon: 83.2277,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VEZO": {
    icao: "VEZO",
    iata: "ZER",
    name: "Ziro Airport",
    city: "Ziro",
    country: "IN",
    continent: "AS",
    lat: 27.5883,
    lon: 93.8281,
    elevation: 5403,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGBR": {
    icao: "VGBR",
    iata: "BZL",
    name: "Barisal Airport",
    city: "Barisal",
    country: "BD",
    continent: "AS",
    lat: 22.801,
    lon: 90.3012,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGCB": {
    icao: "VGCB",
    iata: "CXB",
    name: "Cox\'s Bazar Airport",
    city: "Cox\'s Bazar",
    country: "BD",
    continent: "AS",
    lat: 21.4575,
    lon: 91.9633,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGEG": {
    icao: "VGEG",
    iata: "CGP",
    name: "Shah Amanat International Airport",
    city: "Chattogram (Chittagong)",
    country: "BD",
    continent: "AS",
    lat: 22.2496,
    lon: 91.8133,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGHS": {
    icao: "VGHS",
    iata: "DAC",
    name: "Hazrat Shahjalal International Airport",
    city: "Dhaka",
    country: "BD",
    continent: "AS",
    lat: 23.8433,
    lon: 90.3978,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VGIS": {
    icao: "VGIS",
    iata: "IRD",
    name: "Ishurdi Airport",
    city: "Ishurdi",
    country: "BD",
    continent: "AS",
    lat: 24.1525,
    lon: 89.0494,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGJR": {
    icao: "VGJR",
    iata: "JSR",
    name: "Jessore Airport",
    city: "Jashore (Jessore)",
    country: "BD",
    continent: "AS",
    lat: 23.1838,
    lon: 89.1608,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGRJ": {
    icao: "VGRJ",
    iata: "RJH",
    name: "Shah Mokhdum Airport",
    city: "Rajshahi",
    country: "BD",
    continent: "AS",
    lat: 24.4372,
    lon: 88.6165,
    elevation: 64,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGSD": {
    icao: "VGSD",
    iata: "SPD",
    name: "Saidpur Airport",
    city: "Saidpur",
    country: "BD",
    continent: "AS",
    lat: 25.7592,
    lon: 88.9089,
    elevation: 125,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VGSY": {
    icao: "VGSY",
    iata: "ZYL",
    name: "Osmany International Airport",
    city: "Sylhet",
    country: "BD",
    continent: "AS",
    lat: 24.9638,
    lon: 91.8648,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VHHH": {
    icao: "VHHH",
    iata: "HKG",
    name: "Hong Kong International Airport",
    city: "Hong Kong",
    country: "HK",
    continent: "AS",
    lat: 22.3089,
    lon: 113.915,
    elevation: 28,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "VHSK": {
    icao: "VHSK",
    iata: "",
    name: "Shek Kong Air Base",
    city: "Islands",
    country: "HK",
    continent: "AS",
    lat: 22.4366,
    lon: 114.08,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIAG": {
    icao: "VIAG",
    iata: "AGR",
    name: "Agra Airport / Agra Air Force Station",
    city: "Agra",
    country: "IN",
    continent: "AS",
    lat: 27.1577,
    lon: 77.9609,
    elevation: 551,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIAL": {
    icao: "VIAL",
    iata: "IXD",
    name: "Prayagraj Airport",
    city: "Allahabad",
    country: "IN",
    continent: "AS",
    lat: 25.4401,
    lon: 81.7339,
    elevation: 322,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIAM": {
    icao: "VIAM",
    iata: "",
    name: "Ambala Air Force Station",
    city: "Ambala",
    country: "IN",
    continent: "AS",
    lat: 30.3681,
    lon: 76.8167,
    elevation: 909,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIAR": {
    icao: "VIAR",
    iata: "ATQ",
    name: "Sri Guru Ram Dass Jee International Airport",
    city: "Amritsar",
    country: "IN",
    continent: "AS",
    lat: 31.7096,
    lon: 74.7973,
    elevation: 756,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIBK": {
    icao: "VIBK",
    iata: "BKB",
    name: "Nal Airport",
    city: "Bikaner",
    country: "IN",
    continent: "AS",
    lat: 28.0706,
    lon: 73.2072,
    elevation: 750,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIBR": {
    icao: "VIBR",
    iata: "KUU",
    name: "Kullu Manali Airport",
    city: "Bhuntar",
    country: "IN",
    continent: "AS",
    lat: 31.8767,
    lon: 77.1544,
    elevation: 3573,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIBT": {
    icao: "VIBT",
    iata: "BUP",
    name: "Bhatinda Air Force Station",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 30.2701,
    lon: 74.7558,
    elevation: 662,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIBY": {
    icao: "VIBY",
    iata: "BEK",
    name: "Bareilly Air Force Station",
    city: "Bareilly",
    country: "IN",
    continent: "AS",
    lat: 28.4221,
    lon: 79.4508,
    elevation: 580,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VICG": {
    icao: "VICG",
    iata: "IXC",
    name: "Chandigarh International Airport",
    city: "Chandigarh",
    country: "IN",
    continent: "AS",
    lat: 30.6735,
    lon: 76.7885,
    elevation: 1012,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VICX": {
    icao: "VICX",
    iata: "KNU",
    name: "Kanpur Airport",
    city: "Kanpur",
    country: "IN",
    continent: "AS",
    lat: 26.4043,
    lon: 80.4101,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIDD": {
    icao: "VIDD",
    iata: "",
    name: "Safdarjung Airport",
    city: "New Delhi",
    country: "IN",
    continent: "AS",
    lat: 28.5855,
    lon: 77.2036,
    elevation: 705,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIDN": {
    icao: "VIDN",
    iata: "DED",
    name: "Dehradun Jolly Grant Airport",
    city: "Dehradun (Jauligrant)",
    country: "IN",
    continent: "AS",
    lat: 30.1892,
    lon: 78.1767,
    elevation: 1831,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIDP": {
    icao: "VIDP",
    iata: "DEL",
    name: "Indira Gandhi International Airport",
    city: "New Delhi",
    country: "IN",
    continent: "AS",
    lat: 28.5556,
    lon: 77.0952,
    elevation: 777,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VIGG": {
    icao: "VIGG",
    iata: "DHM",
    name: "Kangra Airport",
    city: "Kangra",
    country: "IN",
    continent: "AS",
    lat: 32.1649,
    lon: 76.263,
    elevation: 2525,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIGR": {
    icao: "VIGR",
    iata: "GWL",
    name: "Gwalior Airport",
    city: "Gwalior",
    country: "IN",
    continent: "AS",
    lat: 26.2933,
    lon: 78.2278,
    elevation: 617,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIHR": {
    icao: "VIHR",
    iata: "HSS",
    name: "Hisar Airport",
    city: "Hisar",
    country: "IN",
    continent: "AS",
    lat: 29.1794,
    lon: 75.7553,
    elevation: 700,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIJO": {
    icao: "VIJO",
    iata: "JDH",
    name: "Jodhpur Airport",
    city: "Jodhpur",
    country: "IN",
    continent: "AS",
    lat: 26.2511,
    lon: 73.0489,
    elevation: 717,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIJP": {
    icao: "VIJP",
    iata: "JAI",
    name: "Jaipur International Airport",
    city: "Jaipur",
    country: "IN",
    continent: "AS",
    lat: 26.8242,
    lon: 75.8122,
    elevation: 1263,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIJR": {
    icao: "VIJR",
    iata: "JSA",
    name: "Jaisalmer Airport",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 26.8887,
    lon: 70.865,
    elevation: 751,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIJU": {
    icao: "VIJU",
    iata: "IXJ",
    name: "Jammu Airport",
    city: "Jammu",
    country: "IN",
    continent: "AS",
    lat: 32.6888,
    lon: 74.8382,
    elevation: 996,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIKG": {
    icao: "VIKG",
    iata: "KQH",
    name: "Kishangarh Airport Ajmer",
    city: "Ajmer (Kishangarh)",
    country: "IN",
    continent: "AS",
    lat: 26.591,
    lon: 74.813,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIKO": {
    icao: "VIKO",
    iata: "KTU",
    name: "Kota Airport",
    city: "Kota",
    country: "IN",
    continent: "AS",
    lat: 25.1602,
    lon: 75.8456,
    elevation: 896,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VILD": {
    icao: "VILD",
    iata: "LUH",
    name: "Ludhiana Airport",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 30.8547,
    lon: 75.9526,
    elevation: 834,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VILH": {
    icao: "VILH",
    iata: "IXL",
    name: "Leh Kushok Bakula Rimpochee Airport",
    city: "Leh",
    country: "IN",
    continent: "AS",
    lat: 34.1359,
    lon: 77.5465,
    elevation: 10682,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VILK": {
    icao: "VILK",
    iata: "LKO",
    name: "Chaudhary Charan Singh International Airport",
    city: "Lucknow",
    country: "IN",
    continent: "AS",
    lat: 26.7606,
    lon: 80.8893,
    elevation: 410,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIMB": {
    icao: "VIMB",
    iata: "MZS",
    name: "Moradabad Airport",
    city: "Moradabad",
    country: "IN",
    continent: "AS",
    lat: 28.8175,
    lon: 78.9219,
    elevation: 637,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIPK": {
    icao: "VIPK",
    iata: "IXP",
    name: "Pathankot Airport",
    city: "Pathankot",
    country: "IN",
    continent: "AS",
    lat: 32.2336,
    lon: 75.6344,
    elevation: 1017,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIPT": {
    icao: "VIPT",
    iata: "PGH",
    name: "Pantnagar Airport",
    city: "Pantnagar",
    country: "IN",
    continent: "AS",
    lat: 29.0334,
    lon: 79.4737,
    elevation: 769,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VISA": {
    icao: "VISA",
    iata: "",
    name: "Sirsa Air Force Station",
    city: "",
    country: "IN",
    continent: "AS",
    lat: 29.5606,
    lon: 75.0061,
    elevation: 650,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VISR": {
    icao: "VISR",
    iata: "SXR",
    name: "Sheikh ul Alam International Airport",
    city: "Srinagar",
    country: "IN",
    continent: "AS",
    lat: 33.9871,
    lon: 74.7742,
    elevation: 5429,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VIUX": {
    icao: "VIUX",
    iata: "",
    name: "Udhampur Air Force Station",
    city: "Udhampur",
    country: "IN",
    continent: "AS",
    lat: 32.9022,
    lon: 75.1557,
    elevation: 2066,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VLLB": {
    icao: "VLLB",
    iata: "LPQ",
    name: "Luang Phabang International Airport",
    city: "Luang Phabang",
    country: "LA",
    continent: "AS",
    lat: 19.8973,
    lon: 102.161,
    elevation: 955,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VLPS": {
    icao: "VLPS",
    iata: "PKZ",
    name: "Pakse International Airport",
    city: "Pakse",
    country: "LA",
    continent: "AS",
    lat: 15.1321,
    lon: 105.781,
    elevation: 351,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VLSK": {
    icao: "VLSK",
    iata: "ZVK",
    name: "Savannakhet Airport",
    city: "",
    country: "LA",
    continent: "AS",
    lat: 16.5566,
    lon: 104.76,
    elevation: 509,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VLSN": {
    icao: "VLSN",
    iata: "NEU",
    name: "Sam Neua Airport",
    city: "",
    country: "LA",
    continent: "AS",
    lat: 20.4184,
    lon: 104.067,
    elevation: 3281,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VLVT": {
    icao: "VLVT",
    iata: "VTE",
    name: "Wattay International Airport",
    city: "Vientiane",
    country: "LA",
    continent: "AS",
    lat: 17.9883,
    lon: 102.563,
    elevation: 564,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VMMC": {
    icao: "VMMC",
    iata: "MFM",
    name: "Macau International Airport",
    city: "Nossa Senhora do Carmo",
    country: "MO",
    continent: "AS",
    lat: 22.1496,
    lon: 113.592,
    elevation: 20,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VNBW": {
    icao: "VNBW",
    iata: "BWA",
    name: "Gautam Buddha International Airport",
    city: "Siddharthanagar (Bhairahawa)",
    country: "NP",
    continent: "AS",
    lat: 27.5053,
    lon: 83.4126,
    elevation: 358,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VNJP": {
    icao: "VNJP",
    iata: "JKR",
    name: "Janakpur Airport",
    city: "Janakpur",
    country: "NP",
    continent: "AS",
    lat: 26.7088,
    lon: 85.9224,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VNKT": {
    icao: "VNKT",
    iata: "KTM",
    name: "Tribhuvan International Airport",
    city: "Kathmandu",
    country: "NP",
    continent: "AS",
    lat: 27.6966,
    lon: 85.3591,
    elevation: 4390,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VNNG": {
    icao: "VNNG",
    iata: "KEP",
    name: "Nepalgunj Airport",
    city: "Nepalgunj",
    country: "NP",
    continent: "AS",
    lat: 28.1036,
    lon: 81.667,
    elevation: 540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VNPK": {
    icao: "VNPK",
    iata: "PKR",
    name: "Pokhara Airport",
    city: "Pokhara",
    country: "NP",
    continent: "AS",
    lat: 28.2006,
    lon: 83.9812,
    elevation: 2712,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VNTJ": {
    icao: "VNTJ",
    iata: "TPJ",
    name: "Taplejung Airport",
    city: "Taplejung",
    country: "NP",
    continent: "AS",
    lat: 27.3509,
    lon: 87.6953,
    elevation: 7990,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VNVT": {
    icao: "VNVT",
    iata: "BIR",
    name: "Biratnagar Airport",
    city: "Biratnagar",
    country: "NP",
    continent: "AS",
    lat: 26.4815,
    lon: 87.264,
    elevation: 236,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VO94": {
    icao: "VO94",
    iata: "",
    name: "Campbell Bay Airport / INS Baaz",
    city: "Campbell Bay",
    country: "IN",
    continent: "AS",
    lat: 7.013,
    lon: 93.9228,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOAT": {
    icao: "VOAT",
    iata: "AGX",
    name: "Agatti Airport",
    city: "Agatti",
    country: "IN",
    continent: "AS",
    lat: 10.8237,
    lon: 72.176,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOBG": {
    icao: "VOBG",
    iata: "",
    name: "HAL Airport",
    city: "Bangalore",
    country: "IN",
    continent: "AS",
    lat: 12.95,
    lon: 77.6682,
    elevation: 2912,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOBI": {
    icao: "VOBI",
    iata: "BEP",
    name: "Bellary Airport",
    city: "Bellary",
    country: "IN",
    continent: "AS",
    lat: 15.1628,
    lon: 76.8828,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOBL": {
    icao: "VOBL",
    iata: "BLR",
    name: "Kempegowda International Airport",
    city: "Bangalore",
    country: "IN",
    continent: "AS",
    lat: 13.1979,
    lon: 77.7063,
    elevation: 3000,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VOBR": {
    icao: "VOBR",
    iata: "IXX",
    name: "Bidar Airport / Bidar Air Force Station",
    city: "Bidar",
    country: "IN",
    continent: "AS",
    lat: 17.9081,
    lon: 77.4871,
    elevation: 2178,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOBZ": {
    icao: "VOBZ",
    iata: "VGA",
    name: "Vijayawada Airport",
    city: "Gannavaram",
    country: "IN",
    continent: "AS",
    lat: 16.5304,
    lon: 80.7968,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOCB": {
    icao: "VOCB",
    iata: "CJB",
    name: "Coimbatore International Airport",
    city: "Coimbatore",
    country: "IN",
    continent: "AS",
    lat: 11.03,
    lon: 77.0434,
    elevation: 1324,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOCI": {
    icao: "VOCI",
    iata: "COK",
    name: "Cochin International Airport",
    city: "Kochi",
    country: "IN",
    continent: "AS",
    lat: 10.151,
    lon: 76.4008,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VOCL": {
    icao: "VOCL",
    iata: "CCJ",
    name: "Calicut International Airport",
    city: "Calicut",
    country: "IN",
    continent: "AS",
    lat: 11.1368,
    lon: 75.9553,
    elevation: 342,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOCP": {
    icao: "VOCP",
    iata: "CDP",
    name: "Kadapa Airport",
    city: "Kadapa",
    country: "IN",
    continent: "AS",
    lat: 14.5132,
    lon: 78.7692,
    elevation: 430,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOCX": {
    icao: "VOCX",
    iata: "CBD",
    name: "Car Nicobar Air Force Base",
    city: "IAF Camp",
    country: "IN",
    continent: "AS",
    lat: 9.1531,
    lon: 92.8193,
    elevation: 5,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VODG": {
    icao: "VODG",
    iata: "",
    name: "Dundigul Air Force Academy",
    city: "Hyderabad",
    country: "IN",
    continent: "AS",
    lat: 17.6272,
    lon: 78.4034,
    elevation: 2013,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOGA": {
    icao: "VOGA",
    iata: "GOX",
    name: "Manohar International Airport",
    city: "Mopa",
    country: "IN",
    continent: "AS",
    lat: 15.7443,
    lon: 73.8606,
    elevation: 552,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VOGO": {
    icao: "VOGO",
    iata: "GOI",
    name: "Dabolim Airport",
    city: "Vasco da Gama",
    country: "IN",
    continent: "AS",
    lat: 15.3808,
    lon: 73.8314,
    elevation: 150,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VOHS": {
    icao: "VOHS",
    iata: "HYD",
    name: "Rajiv Gandhi International Airport",
    city: "Hyderabad",
    country: "IN",
    continent: "AS",
    lat: 17.2313,
    lon: 78.4299,
    elevation: 2024,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VOHY": {
    icao: "VOHY",
    iata: "BPM",
    name: "Begumpet Airport",
    city: "Hyderabad",
    country: "IN",
    continent: "AS",
    lat: 17.4531,
    lon: 78.4676,
    elevation: 1742,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOKN": {
    icao: "VOKN",
    iata: "CNN",
    name: "Kannur International Airport",
    city: "Kannur",
    country: "IN",
    continent: "AS",
    lat: 11.9186,
    lon: 75.5472,
    elevation: 330,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOKU": {
    icao: "VOKU",
    iata: "KJB",
    name: "Kurnool Airport",
    city: "Orvakal",
    country: "IN",
    continent: "AS",
    lat: 15.7163,
    lon: 78.1692,
    elevation: 920,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOMD": {
    icao: "VOMD",
    iata: "IXM",
    name: "Madurai Airport",
    city: "Madurai",
    country: "IN",
    continent: "AS",
    lat: 9.8345,
    lon: 78.0934,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOML": {
    icao: "VOML",
    iata: "IXE",
    name: "Mangalore International Airport",
    city: "Mangalore",
    country: "IN",
    continent: "AS",
    lat: 12.9613,
    lon: 74.8901,
    elevation: 337,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOMM": {
    icao: "VOMM",
    iata: "MAA",
    name: "Chennai International Airport",
    city: "Chennai",
    country: "IN",
    continent: "AS",
    lat: 12.99,
    lon: 80.1693,
    elevation: 52,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VOPB": {
    icao: "VOPB",
    iata: "IXZ",
    name: "Veer Savarkar International Airport / INS Utkrosh",
    city: "Port Blair",
    country: "IN",
    continent: "AS",
    lat: 11.6412,
    lon: 92.7296,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOPC": {
    icao: "VOPC",
    iata: "PNY",
    name: "Pondicherry Airport",
    city: "Puducherry (Pondicherry)",
    country: "IN",
    continent: "AS",
    lat: 11.968,
    lon: 79.812,
    elevation: 134,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOPN": {
    icao: "VOPN",
    iata: "PUT",
    name: "Sri Sathya Sai Airport",
    city: "Puttaparthi",
    country: "IN",
    continent: "AS",
    lat: 14.1493,
    lon: 77.7911,
    elevation: 1558,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VORY": {
    icao: "VORY",
    iata: "RJA",
    name: "Rajahmundry Airport",
    city: "Madhurapudi",
    country: "IN",
    continent: "AS",
    lat: 17.1058,
    lon: 81.8132,
    elevation: 151,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOSM": {
    icao: "VOSM",
    iata: "SXV",
    name: "Salem Airport",
    city: "Salem",
    country: "IN",
    continent: "AS",
    lat: 11.7833,
    lon: 78.0656,
    elevation: 1008,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOTR": {
    icao: "VOTR",
    iata: "TRZ",
    name: "Tiruchirappalli International Airport",
    city: "Tiruchirappalli",
    country: "IN",
    continent: "AS",
    lat: 10.7662,
    lon: 78.7177,
    elevation: 288,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VOTV": {
    icao: "VOTV",
    iata: "TRV",
    name: "Thiruvananthapuram International Airport",
    city: "Thiruvananthapuram",
    country: "IN",
    continent: "AS",
    lat: 8.4821,
    lon: 76.9201,
    elevation: 15,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VQGP": {
    icao: "VQGP",
    iata: "GLU",
    name: "Gelephu Airport",
    city: "Gelephu",
    country: "BT",
    continent: "AS",
    lat: 26.8846,
    lon: 90.4641,
    elevation: 980,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VQPR": {
    icao: "VQPR",
    iata: "PBH",
    name: "Paro International Airport",
    city: "Paro",
    country: "BT",
    continent: "AS",
    lat: 27.4032,
    lon: 89.4246,
    elevation: 7364,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VRDA": {
    icao: "VRDA",
    iata: "NMF",
    name: "Maafaru International Airport",
    city: "Noonu Atoll",
    country: "MV",
    continent: "AS",
    lat: 5.8184,
    lon: 73.4692,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VRMG": {
    icao: "VRMG",
    iata: "GAN",
    name: "Gan International Airport",
    city: "Gan",
    country: "MV",
    continent: "AS",
    lat: -0.6927,
    lon: 73.1516,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VRMH": {
    icao: "VRMH",
    iata: "HAQ",
    name: "Hanimaadhoo Airport",
    city: "Haa Dhaalu Atoll",
    country: "MV",
    continent: "AS",
    lat: 6.7442,
    lon: 73.1705,
    elevation: 4,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VRMK": {
    icao: "VRMK",
    iata: "KDO",
    name: "Kadhdhoo Airport",
    city: "Kadhdhoo",
    country: "MV",
    continent: "AS",
    lat: 1.8592,
    lon: 73.5219,
    elevation: 4,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VRMM": {
    icao: "VRMM",
    iata: "MLE",
    name: "Malé International Airport",
    city: "Malé",
    country: "MV",
    continent: "AS",
    lat: 4.1918,
    lon: 73.5291,
    elevation: 6,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VRMT": {
    icao: "VRMT",
    iata: "KDM",
    name: "Kaadedhdhoo Airport",
    city: "Huvadhu Atoll",
    country: "MV",
    continent: "AS",
    lat: 0.4881,
    lon: 72.9969,
    elevation: 2,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VRMV": {
    icao: "VRMV",
    iata: "VAM",
    name: "Villa International Airport Maamigili",
    city: "Maamigili",
    country: "MV",
    continent: "AS",
    lat: 3.4706,
    lon: 72.8358,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTBD": {
    icao: "VTBD",
    iata: "DMK",
    name: "Don Mueang International Airport",
    city: "Bangkok",
    country: "TH",
    continent: "AS",
    lat: 13.9126,
    lon: 100.607,
    elevation: 9,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VTBK": {
    icao: "VTBK",
    iata: "KDT",
    name: "Kamphaeng Saen Airport",
    city: "Nakhon Pathom",
    country: "TH",
    continent: "AS",
    lat: 14.102,
    lon: 99.9172,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTBL": {
    icao: "VTBL",
    iata: "KKM",
    name: "Khok Kathiam Airport",
    city: "Lop Buri",
    country: "TH",
    continent: "AS",
    lat: 14.8746,
    lon: 100.6634,
    elevation: 123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTBO": {
    icao: "VTBO",
    iata: "TDX",
    name: "Trat Airport",
    city: "Laem Ngop",
    country: "TH",
    continent: "AS",
    lat: 12.2746,
    lon: 102.319,
    elevation: 105,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTBS": {
    icao: "VTBS",
    iata: "BKK",
    name: "Suvarnabhumi Airport",
    city: "Bangkok",
    country: "TH",
    continent: "AS",
    lat: 13.6811,
    lon: 100.747,
    elevation: 5,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VTBU": {
    icao: "VTBU",
    iata: "UTP",
    name: "U-Tapao International Airport",
    city: "Rayong",
    country: "TH",
    continent: "AS",
    lat: 12.6799,
    lon: 101.005,
    elevation: 42,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTCC": {
    icao: "VTCC",
    iata: "CNX",
    name: "Chiang Mai International Airport",
    city: "Chiang Mai",
    country: "TH",
    continent: "AS",
    lat: 18.7668,
    lon: 98.9626,
    elevation: 1036,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VTCH": {
    icao: "VTCH",
    iata: "HGN",
    name: "Mae Hong Son Airport",
    city: "Mae Hong Son",
    country: "TH",
    continent: "AS",
    lat: 19.3013,
    lon: 97.9758,
    elevation: 929,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTCL": {
    icao: "VTCL",
    iata: "LPT",
    name: "Lampang Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 18.2709,
    lon: 99.5042,
    elevation: 811,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTCN": {
    icao: "VTCN",
    iata: "NNT",
    name: "Nan Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 18.8079,
    lon: 100.783,
    elevation: 685,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTCP": {
    icao: "VTCP",
    iata: "PRH",
    name: "Phrae Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 18.1322,
    lon: 100.165,
    elevation: 538,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTCT": {
    icao: "VTCT",
    iata: "CEI",
    name: "Mae Fah Luang - Chiang Rai International Airport",
    city: "Chiang Rai",
    country: "TH",
    continent: "AS",
    lat: 19.9523,
    lon: 99.8829,
    elevation: 1280,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPB": {
    icao: "VTPB",
    iata: "PHY",
    name: "Phetchabun Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 16.676,
    lon: 101.195,
    elevation: 450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPH": {
    icao: "VTPH",
    iata: "HHQ",
    name: "Hua Hin Airport",
    city: "Hua Hin",
    country: "TH",
    continent: "AS",
    lat: 12.6362,
    lon: 99.9515,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPI": {
    icao: "VTPI",
    iata: "TKH",
    name: "Takhli Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 15.2773,
    lon: 100.296,
    elevation: 107,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPM": {
    icao: "VTPM",
    iata: "MAQ",
    name: "Mae Sot Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 16.6999,
    lon: 98.5451,
    elevation: 690,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPO": {
    icao: "VTPO",
    iata: "THS",
    name: "Sukhothai Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 17.238,
    lon: 99.8182,
    elevation: 179,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPP": {
    icao: "VTPP",
    iata: "PHS",
    name: "Phitsanulok Airport",
    city: "Phitsanulok",
    country: "TH",
    continent: "AS",
    lat: 16.7829,
    lon: 100.279,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTPT": {
    icao: "VTPT",
    iata: "TKT",
    name: "Tak Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 16.896,
    lon: 99.2533,
    elevation: 478,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSB": {
    icao: "VTSB",
    iata: "URT",
    name: "Surat Thani Airport",
    city: "Surat Thani",
    country: "TH",
    continent: "AS",
    lat: 9.1326,
    lon: 99.1356,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSC": {
    icao: "VTSC",
    iata: "NAW",
    name: "Narathiwat Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 6.5199,
    lon: 101.743,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSE": {
    icao: "VTSE",
    iata: "CJM",
    name: "Chumphon Airport",
    city: "Chumphon",
    country: "TH",
    continent: "AS",
    lat: 10.7112,
    lon: 99.3617,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSF": {
    icao: "VTSF",
    iata: "NST",
    name: "Nakhon Si Thammarat Airport",
    city: "Nakhon Si Thammarat",
    country: "TH",
    continent: "AS",
    lat: 8.5396,
    lon: 99.9447,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSG": {
    icao: "VTSG",
    iata: "KBV",
    name: "Krabi Airport",
    city: "Krabi",
    country: "TH",
    continent: "AS",
    lat: 8.0991,
    lon: 98.9862,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSH": {
    icao: "VTSH",
    iata: "SGZ",
    name: "Songkhla Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 7.1866,
    lon: 100.608,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSK": {
    icao: "VTSK",
    iata: "PAN",
    name: "Pattani Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 6.7855,
    lon: 101.154,
    elevation: 8,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSM": {
    icao: "VTSM",
    iata: "USM",
    name: "Samui Airport",
    city: "Na Thon (Ko Samui Island)",
    country: "TH",
    continent: "AS",
    lat: 9.5478,
    lon: 100.062,
    elevation: 64,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSN": {
    icao: "VTSN",
    iata: "",
    name: "Cha Eian Airport",
    city: "Nakhon Si Thammarat",
    country: "TH",
    continent: "AS",
    lat: 8.4711,
    lon: 99.9556,
    elevation: 44,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSP": {
    icao: "VTSP",
    iata: "HKT",
    name: "Phuket International Airport",
    city: "Phuket",
    country: "TH",
    continent: "AS",
    lat: 8.1132,
    lon: 98.3169,
    elevation: 82,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VTSR": {
    icao: "VTSR",
    iata: "UNN",
    name: "Ranong Airport",
    city: "Ranong",
    country: "TH",
    continent: "AS",
    lat: 9.7776,
    lon: 98.5855,
    elevation: 57,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTSS": {
    icao: "VTSS",
    iata: "HDY",
    name: "Hat Yai International Airport",
    city: "Hat Yai",
    country: "TH",
    continent: "AS",
    lat: 6.9332,
    lon: 100.393,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTST": {
    icao: "VTST",
    iata: "TST",
    name: "Trang Airport",
    city: "Trang",
    country: "TH",
    continent: "AS",
    lat: 7.5087,
    lon: 99.6166,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUD": {
    icao: "VTUD",
    iata: "UTH",
    name: "Udon Thani Airport",
    city: "Udon Thani",
    country: "TH",
    continent: "AS",
    lat: 17.3864,
    lon: 102.788,
    elevation: 579,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUI": {
    icao: "VTUI",
    iata: "SNO",
    name: "Sakon Nakhon Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 17.1951,
    lon: 104.119,
    elevation: 529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUJ": {
    icao: "VTUJ",
    iata: "PXR",
    name: "Surin Airport",
    city: "Surin",
    country: "TH",
    continent: "AS",
    lat: 14.8683,
    lon: 103.498,
    elevation: 478,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUK": {
    icao: "VTUK",
    iata: "KKC",
    name: "Khon Kaen Airport",
    city: "Khon Kaen",
    country: "TH",
    continent: "AS",
    lat: 16.4666,
    lon: 102.784,
    elevation: 670,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUL": {
    icao: "VTUL",
    iata: "LOE",
    name: "Loei Airport",
    city: "",
    country: "TH",
    continent: "AS",
    lat: 17.4391,
    lon: 101.722,
    elevation: 860,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUO": {
    icao: "VTUO",
    iata: "BFV",
    name: "Buri Ram Airport",
    city: "Buriram",
    country: "TH",
    continent: "AS",
    lat: 15.2295,
    lon: 103.253,
    elevation: 590,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUQ": {
    icao: "VTUQ",
    iata: "NAK",
    name: "Nakhon Ratchasima Airport",
    city: "Chaloem Phra Kiat",
    country: "TH",
    continent: "AS",
    lat: 14.9495,
    lon: 102.313,
    elevation: 765,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUU": {
    icao: "VTUU",
    iata: "UBP",
    name: "Ubon Ratchathani Airport",
    city: "Ubon Ratchathani",
    country: "TH",
    continent: "AS",
    lat: 15.2513,
    lon: 104.87,
    elevation: 406,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUV": {
    icao: "VTUV",
    iata: "ROI",
    name: "Roi Et Airport",
    city: "Roi Et",
    country: "TH",
    continent: "AS",
    lat: 16.1168,
    lon: 103.774,
    elevation: 451,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VTUW": {
    icao: "VTUW",
    iata: "KOP",
    name: "Nakhon Phanom Airport",
    city: "Nakhon Phanom",
    country: "TH",
    continent: "AS",
    lat: 17.3838,
    lon: 104.643,
    elevation: 587,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVBM": {
    icao: "VVBM",
    iata: "BMV",
    name: "Buon Ma Thuot Airport",
    city: "Buon Ma Thuot",
    country: "VN",
    continent: "AS",
    lat: 12.6683,
    lon: 108.12,
    elevation: 1729,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVCI": {
    icao: "VVCI",
    iata: "HPH",
    name: "Cat Bi International Airport",
    city: "Haiphong (Hai An)",
    country: "VN",
    continent: "AS",
    lat: 20.8169,
    lon: 106.723,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVCM": {
    icao: "VVCM",
    iata: "CAH",
    name: "Cà Mau Airport",
    city: "Ca Mau City",
    country: "VN",
    continent: "AS",
    lat: 9.1777,
    lon: 105.1778,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVCR": {
    icao: "VVCR",
    iata: "CXR",
    name: "Cam Ranh International Airport / Cam Ranh Air Base",
    city: "Cam Ranh",
    country: "VN",
    continent: "AS",
    lat: 11.9982,
    lon: 109.219,
    elevation: 40,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVCS": {
    icao: "VVCS",
    iata: "VCS",
    name: "Con Dao Airport",
    city: "Con Dao",
    country: "VN",
    continent: "AS",
    lat: 8.7318,
    lon: 106.633,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVCT": {
    icao: "VVCT",
    iata: "VCA",
    name: "Can Tho International Airport",
    city: "Can Tho",
    country: "VN",
    continent: "AS",
    lat: 10.0851,
    lon: 105.712,
    elevation: 9,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVDB": {
    icao: "VVDB",
    iata: "DIN",
    name: "Dien Bien Phu Airport",
    city: "Dien Bien Phu",
    country: "VN",
    continent: "AS",
    lat: 21.3975,
    lon: 103.008,
    elevation: 1611,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVDH": {
    icao: "VVDH",
    iata: "VDH",
    name: "Dong Hoi Airport",
    city: "Dong Hoi",
    country: "VN",
    continent: "AS",
    lat: 17.515,
    lon: 106.5906,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVDL": {
    icao: "VVDL",
    iata: "DLI",
    name: "Lien Khuong Airport",
    city: "Da Lat",
    country: "VN",
    continent: "AS",
    lat: 11.7506,
    lon: 108.367,
    elevation: 3156,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVDN": {
    icao: "VVDN",
    iata: "DAD",
    name: "Da Nang International Airport",
    city: "Da Nang",
    country: "VN",
    continent: "AS",
    lat: 16.0439,
    lon: 108.199,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVGL": {
    icao: "VVGL",
    iata: "",
    name: "Gia Lam Air Base",
    city: "Hanoi  (Long Bien)",
    country: "VN",
    continent: "AS",
    lat: 21.0405,
    lon: 105.886,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVNB": {
    icao: "VVNB",
    iata: "HAN",
    name: "Noi Bai International Airport",
    city: "Hanoi (Soc Son)",
    country: "VN",
    continent: "AS",
    lat: 21.2212,
    lon: 105.807,
    elevation: 39,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VVPB": {
    icao: "VVPB",
    iata: "HUI",
    name: "Phu Bai International Airport",
    city: "Huế",
    country: "VN",
    continent: "AS",
    lat: 16.4006,
    lon: 107.7031,
    elevation: 48,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVPC": {
    icao: "VVPC",
    iata: "UIH",
    name: "Phu Cat Airport",
    city: "Quy Nohn",
    country: "VN",
    continent: "AS",
    lat: 13.955,
    lon: 109.042,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVPK": {
    icao: "VVPK",
    iata: "PXU",
    name: "Pleiku Airport",
    city: "Pleiku",
    country: "VN",
    continent: "AS",
    lat: 14.0045,
    lon: 108.017,
    elevation: 2434,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVPQ": {
    icao: "VVPQ",
    iata: "PQC",
    name: "Phu Quoc International Airport",
    city: "Phu Quoc Island",
    country: "VN",
    continent: "AS",
    lat: 10.1698,
    lon: 103.9931,
    elevation: 37,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVRG": {
    icao: "VVRG",
    iata: "VKG",
    name: "Rach Gia Airport",
    city: "Rach Gia",
    country: "VN",
    continent: "AS",
    lat: 9.958,
    lon: 105.1324,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVTH": {
    icao: "VVTH",
    iata: "TBB",
    name: "Dong Tac Airport",
    city: "Tuy Hoa",
    country: "VN",
    continent: "AS",
    lat: 13.0496,
    lon: 109.334,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVTS": {
    icao: "VVTS",
    iata: "SGN",
    name: "Tan Son Nhat International Airport",
    city: "Ho Chi Minh City",
    country: "VN",
    continent: "AS",
    lat: 10.8188,
    lon: 106.652,
    elevation: 33,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VVVD": {
    icao: "VVVD",
    iata: "VDO",
    name: "Van Don International Airport",
    city: "Van Don",
    country: "VN",
    continent: "AS",
    lat: 21.1207,
    lon: 107.4154,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VVVH": {
    icao: "VVVH",
    iata: "VII",
    name: "Vinh Airport",
    city: "Vinh",
    country: "VN",
    continent: "AS",
    lat: 18.7376,
    lon: 105.671,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYDW": {
    icao: "VYDW",
    iata: "TVY",
    name: "Dawei Airport",
    city: "Dawei",
    country: "MM",
    continent: "AS",
    lat: 14.1039,
    lon: 98.2036,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYKG": {
    icao: "VYKG",
    iata: "KET",
    name: "Kengtung Airport",
    city: "Kengtung",
    country: "MM",
    continent: "AS",
    lat: 21.3016,
    lon: 99.636,
    elevation: 2798,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYKP": {
    icao: "VYKP",
    iata: "KYP",
    name: "Kyaukpyu Airport",
    city: "Kyaukpyu",
    country: "MM",
    continent: "AS",
    lat: 19.4264,
    lon: 93.5348,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYKT": {
    icao: "VYKT",
    iata: "KAW",
    name: "Kawthoung Airport",
    city: "Kawthoung",
    country: "MM",
    continent: "AS",
    lat: 10.0493,
    lon: 98.538,
    elevation: 180,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYLK": {
    icao: "VYLK",
    iata: "LIW",
    name: "Loikaw Airport",
    city: "Loikaw",
    country: "MM",
    continent: "AS",
    lat: 19.6915,
    lon: 97.2148,
    elevation: 2940,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYLS": {
    icao: "VYLS",
    iata: "LSH",
    name: "Lashio Airport",
    city: "Lashio",
    country: "MM",
    continent: "AS",
    lat: 22.9779,
    lon: 97.7522,
    elevation: 2450,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYMD": {
    icao: "VYMD",
    iata: "MDL",
    name: "Mandalay International Airport",
    city: "Mandalay",
    country: "MM",
    continent: "AS",
    lat: 21.7022,
    lon: 95.9779,
    elevation: 300,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "VYME": {
    icao: "VYME",
    iata: "MGZ",
    name: "Myeik Airport",
    city: "Mkeik",
    country: "MM",
    continent: "AS",
    lat: 12.4398,
    lon: 98.6215,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYMK": {
    icao: "VYMK",
    iata: "MYT",
    name: "Myitkyina Airport",
    city: "Myitkyina",
    country: "MM",
    continent: "AS",
    lat: 25.3836,
    lon: 97.3519,
    elevation: 475,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYML": {
    icao: "VYML",
    iata: "",
    name: "Meiktila Air Base",
    city: "Meiktila",
    country: "MM",
    continent: "AS",
    lat: 20.8864,
    lon: 95.8928,
    elevation: 699,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYMO": {
    icao: "VYMO",
    iata: "MOE",
    name: "Momeik Airport",
    city: "",
    country: "MM",
    continent: "AS",
    lat: 23.0925,
    lon: 96.6453,
    elevation: 600,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYMS": {
    icao: "VYMS",
    iata: "MOG",
    name: "Mong Hsat Airport",
    city: "Mong Hsat",
    country: "MM",
    continent: "AS",
    lat: 20.5168,
    lon: 99.2568,
    elevation: 1875,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYNP": {
    icao: "VYNP",
    iata: "",
    name: "Nampong Air Base",
    city: "Myitkyina",
    country: "MM",
    continent: "AS",
    lat: 25.3544,
    lon: 97.2952,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYNS": {
    icao: "VYNS",
    iata: "NMS",
    name: "Namsang Airport",
    city: "Namsang",
    country: "MM",
    continent: "AS",
    lat: 20.8905,
    lon: 97.7359,
    elevation: 3100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYNT": {
    icao: "VYNT",
    iata: "NYT",
    name: "Nay Pyi Taw International Airport",
    city: "Pyinmana",
    country: "MM",
    continent: "AS",
    lat: 19.6235,
    lon: 96.201,
    elevation: 302,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYPT": {
    icao: "VYPT",
    iata: "PBU",
    name: "Putao Airport",
    city: "Putao",
    country: "MM",
    continent: "AS",
    lat: 27.3299,
    lon: 97.4263,
    elevation: 1500,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYST": {
    icao: "VYST",
    iata: "",
    name: "Shante Air Base",
    city: "Meiktila",
    country: "MM",
    continent: "AS",
    lat: 20.9417,
    lon: 95.9145,
    elevation: 630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYSW": {
    icao: "VYSW",
    iata: "AKY",
    name: "Sittwe Airport",
    city: "Sittwe",
    country: "MM",
    continent: "AS",
    lat: 20.1332,
    lon: 92.8707,
    elevation: 27,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYTD": {
    icao: "VYTD",
    iata: "SNW",
    name: "Thandwe Airport",
    city: "Thandwe",
    country: "MM",
    continent: "AS",
    lat: 18.4607,
    lon: 94.3001,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYTL": {
    icao: "VYTL",
    iata: "THL",
    name: "Tachileik Airport",
    city: "Tachileik",
    country: "MM",
    continent: "AS",
    lat: 20.4838,
    lon: 99.9354,
    elevation: 1280,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "VYYY": {
    icao: "VYYY",
    iata: "RGN",
    name: "Yangon International Airport",
    city: "Yangon",
    country: "MM",
    continent: "AS",
    lat: 16.9073,
    lon: 96.1332,
    elevation: 109,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WAAA": {
    icao: "WAAA",
    iata: "UPG",
    name: "Hasanuddin International Airport",
    city: "Ujung Pandang",
    country: "ID",
    continent: "AS",
    lat: -5.0616,
    lon: 119.554,
    elevation: 47,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WABB": {
    icao: "WABB",
    iata: "BIK",
    name: "Frans Kaisiepo Airport",
    city: "Biak",
    country: "ID",
    continent: "AS",
    lat: -1.19,
    lon: 136.108,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WABI": {
    icao: "WABI",
    iata: "NBX",
    name: "Douw Aturure Airport",
    city: "Nabire",
    country: "ID",
    continent: "OC",
    lat: -3.398,
    lon: 135.3931,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WABO": {
    icao: "WABO",
    iata: "ZRI",
    name: "Stevanus Rumbewas Airport",
    city: "Serui",
    country: "ID",
    continent: "AS",
    lat: -1.8284,
    lon: 136.0624,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WABP": {
    icao: "WABP",
    iata: "TIM",
    name: "Mozes Kilangin Airport",
    city: "Timika",
    country: "ID",
    continent: "AS",
    lat: -4.5298,
    lon: 136.8874,
    elevation: 103,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WADD": {
    icao: "WADD",
    iata: "DPS",
    name: "Denpasar I Gusti Ngurah Rai International Airport",
    city: "Kuta, Badung",
    country: "ID",
    continent: "AS",
    lat: -8.7484,
    lon: 115.1671,
    elevation: 14,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WADL": {
    icao: "WADL",
    iata: "LOP",
    name: "Lombok International Airport",
    city: "Mataram (Pujut, Lombok Tengah)",
    country: "ID",
    continent: "AS",
    lat: -8.76,
    lon: 116.2782,
    elevation: 319,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAEE": {
    icao: "WAEE",
    iata: "TTE",
    name: "Sultan Babullah Airport",
    city: "Ternate",
    country: "ID",
    continent: "AS",
    lat: 0.831,
    lon: 127.3816,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAEW": {
    icao: "WAEW",
    iata: "OTI",
    name: "Pitu Airport",
    city: "Gotalalamo-Morotai Island",
    country: "ID",
    continent: "AS",
    lat: 2.046,
    lon: 128.325,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAFB": {
    icao: "WAFB",
    iata: "TRT",
    name: "Toraja Airport",
    city: "Toraja",
    country: "ID",
    continent: "AS",
    lat: -3.1858,
    lon: 119.9177,
    elevation: 2884,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAFF": {
    icao: "WAFF",
    iata: "PLW",
    name: "Mutiara - SIS Al-Jufrie Airport",
    city: "Palu",
    country: "ID",
    continent: "AS",
    lat: -0.9165,
    lon: 119.9086,
    elevation: 284,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAFP": {
    icao: "WAFP",
    iata: "PSJ",
    name: "Kasiguncu Airport",
    city: "Poso-Celebes Island",
    country: "ID",
    continent: "AS",
    lat: -1.4141,
    lon: 120.6592,
    elevation: 174,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAFW": {
    icao: "WAFW",
    iata: "LUW",
    name: "Syukuran Aminuddin Amir Airport",
    city: "Luwok",
    country: "ID",
    continent: "AS",
    lat: -1.0359,
    lon: 122.7739,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAGG": {
    icao: "WAGG",
    iata: "PKY",
    name: "Tjilik Riwut Airport",
    city: "Palangkaraya",
    country: "ID",
    continent: "AS",
    lat: -2.2271,
    lon: 113.9434,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAHI": {
    icao: "WAHI",
    iata: "YIA",
    name: "Yogyakarta International Airport",
    city: "Yogyakarta",
    country: "ID",
    continent: "AS",
    lat: -7.9053,
    lon: 110.0573,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAHL": {
    icao: "WAHL",
    iata: "CXP",
    name: "Tunggul Wulung Airport",
    city: "Cilacap",
    country: "ID",
    continent: "AS",
    lat: -7.6451,
    lon: 109.034,
    elevation: 69,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAJJ": {
    icao: "WAJJ",
    iata: "DJJ",
    name: "Dortheys Hiyo Eluay International Airport",
    city: "Sentani",
    country: "ID",
    continent: "AS",
    lat: -2.5796,
    lon: 140.5199,
    elevation: 289,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WAJO": {
    icao: "WAJO",
    iata: "OKL",
    name: "Oksibil Airport",
    city: "Oksibil",
    country: "ID",
    continent: "AS",
    lat: -4.9071,
    lon: 140.6277,
    elevation: 4315,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAKK": {
    icao: "WAKK",
    iata: "MKQ",
    name: "Mopah International Airport",
    city: "Merauke",
    country: "ID",
    continent: "AS",
    lat: -8.5239,
    lon: 140.4197,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAKT": {
    icao: "WAKT",
    iata: "TMH",
    name: "Tanah Merah Airport",
    city: "Tanah Merah",
    country: "ID",
    continent: "AS",
    lat: -6.0967,
    lon: 140.3035,
    elevation: 57,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WALL": {
    icao: "WALL",
    iata: "BPN",
    name: "Sultan Aji Muhammad Sulaiman Sepinggan International Airport",
    city: "Balikpapan",
    country: "ID",
    continent: "AS",
    lat: -1.2683,
    lon: 116.8945,
    elevation: 12,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WALR": {
    icao: "WALR",
    iata: "TRK",
    name: "Juwata International Airport / Suharnoko Harbani AFB",
    city: "Tarakan",
    country: "ID",
    continent: "AS",
    lat: 3.3251,
    lon: 117.5642,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WALS": {
    icao: "WALS",
    iata: "AAP",
    name: "Aji Pangeran Tumenggung Pranoto International Airport",
    city: "Samarinda",
    country: "ID",
    continent: "AS",
    lat: -0.3745,
    lon: 117.2501,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAMH": {
    icao: "WAMH",
    iata: "NAH",
    name: "Naha Airport",
    city: "Tabukan Utara, Sangihe Islands",
    country: "ID",
    continent: "AS",
    lat: 3.6848,
    lon: 125.5272,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAMM": {
    icao: "WAMM",
    iata: "MDC",
    name: "Sam Ratulangi Airport",
    city: "Manado",
    country: "ID",
    continent: "AS",
    lat: 1.5493,
    lon: 124.9263,
    elevation: 264,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAON": {
    icao: "WAON",
    iata: "TJG",
    name: "Warukin Airport",
    city: "Tanta-Tabalong",
    country: "ID",
    continent: "AS",
    lat: -2.2166,
    lon: 115.436,
    elevation: 197,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAOO": {
    icao: "WAOO",
    iata: "BDJ",
    name: "Syamsudin Noor International Airport",
    city: "Landasan Ulin",
    country: "ID",
    continent: "AS",
    lat: -3.4424,
    lon: 114.763,
    elevation: 66,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAPF": {
    icao: "WAPF",
    iata: "LUV",
    name: "Karel Sadsuitubun Airport",
    city: "Langgur",
    country: "ID",
    continent: "AS",
    lat: -5.7603,
    lon: 132.7594,
    elevation: 78,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAPN": {
    icao: "WAPN",
    iata: "NAM",
    name: "Namniwel Airport",
    city: "Namniwel",
    country: "ID",
    continent: "AS",
    lat: -3.1432,
    lon: 126.9765,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAPP": {
    icao: "WAPP",
    iata: "AMQ",
    name: "Pattimura International Airport",
    city: "Ambon",
    country: "ID",
    continent: "AS",
    lat: -3.7103,
    lon: 128.089,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAQT": {
    icao: "WAQT",
    iata: "BEJ",
    name: "Kalimarau Airport",
    city: "Tanjung Redeb - Borneo Island",
    country: "ID",
    continent: "AS",
    lat: 2.1478,
    lon: 117.4307,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WARA": {
    icao: "WARA",
    iata: "MLG",
    name: "Abdul Rachman Saleh Airport",
    city: "Malang",
    country: "ID",
    continent: "AS",
    lat: -7.9291,
    lon: 112.7142,
    elevation: 1726,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WARJ": {
    icao: "WARJ",
    iata: "JOG",
    name: "Adisutjipto Airport",
    city: "Yogyakarta",
    country: "ID",
    continent: "AS",
    lat: -7.7882,
    lon: 110.432,
    elevation: 379,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WARQ": {
    icao: "WARQ",
    iata: "SOC",
    name: "Adisumarmo Airport",
    city: "Surakarta",
    country: "ID",
    continent: "AS",
    lat: -7.516,
    lon: 110.7575,
    elevation: 421,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WARR": {
    icao: "WARR",
    iata: "SUB",
    name: "Juanda International Airport",
    city: "Surabaya",
    country: "ID",
    continent: "AS",
    lat: -7.3798,
    lon: 112.787,
    elevation: 9,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WARS": {
    icao: "WARS",
    iata: "SRG",
    name: "Achmad Yani Airport",
    city: "Semarang",
    country: "ID",
    continent: "AS",
    lat: -6.9707,
    lon: 110.3732,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WASF": {
    icao: "WASF",
    iata: "FKQ",
    name: "Fakfak Airport",
    city: "Fakfak",
    country: "ID",
    continent: "AS",
    lat: -2.9205,
    lon: 132.267,
    elevation: 462,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WASK": {
    icao: "WASK",
    iata: "KNG",
    name: "Utarom Airport",
    city: "Kaimana",
    country: "ID",
    continent: "AS",
    lat: -3.6446,
    lon: 133.6951,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WASO": {
    icao: "WASO",
    iata: "BXB",
    name: "Babo Airport",
    city: "Babo",
    country: "ID",
    continent: "AS",
    lat: -2.5322,
    lon: 133.439,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WASR": {
    icao: "WASR",
    iata: "MKW",
    name: "Rendani Airport",
    city: "Manokwari",
    country: "ID",
    continent: "AS",
    lat: -0.8918,
    lon: 134.049,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WASS": {
    icao: "WASS",
    iata: "SOQ",
    name: "Domine Eduard Osok Airport",
    city: "Sorong",
    country: "ID",
    continent: "AS",
    lat: -0.894,
    lon: 131.287,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAVV": {
    icao: "WAVV",
    iata: "WMX",
    name: "Wamena Airport",
    city: "Wamena",
    country: "ID",
    continent: "AS",
    lat: -4.0973,
    lon: 138.9524,
    elevation: 5435,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAWD": {
    icao: "WAWD",
    iata: "WNI",
    name: "Matahora Airport",
    city: "Wangi-wangi Island",
    country: "ID",
    continent: "AS",
    lat: -5.294,
    lon: 123.634,
    elevation: 88,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WAWP": {
    icao: "WAWP",
    iata: "KXB",
    name: "Sangia Nibandera Airport",
    city: "Kolaka",
    country: "ID",
    continent: "AS",
    lat: -4.3382,
    lon: 121.524,
    elevation: 40,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGB": {
    icao: "WBGB",
    iata: "BTU",
    name: "Bintulu Airport",
    city: "Bintulu",
    country: "MY",
    continent: "AS",
    lat: 3.1239,
    lon: 113.02,
    elevation: 74,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGG": {
    icao: "WBGG",
    iata: "KCH",
    name: "Kuching International Airport",
    city: "Kuching",
    country: "MY",
    continent: "AS",
    lat: 1.4874,
    lon: 110.3529,
    elevation: 89,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGJ": {
    icao: "WBGJ",
    iata: "LMN",
    name: "Limbang Airport",
    city: "Limbang",
    country: "MY",
    continent: "AS",
    lat: 4.8083,
    lon: 115.01,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGK": {
    icao: "WBGK",
    iata: "MKM",
    name: "Mukah Airport",
    city: "Mukah",
    country: "MY",
    continent: "AS",
    lat: 2.8819,
    lon: 112.0433,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGM": {
    icao: "WBGM",
    iata: "MUR",
    name: "Marudi Airport",
    city: "Marudi",
    country: "MY",
    continent: "AS",
    lat: 4.1787,
    lon: 114.3303,
    elevation: 103,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGR": {
    icao: "WBGR",
    iata: "MYY",
    name: "Miri Airport",
    city: "Miri",
    country: "MY",
    continent: "AS",
    lat: 4.322,
    lon: 113.987,
    elevation: 59,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGS": {
    icao: "WBGS",
    iata: "SBW",
    name: "Sibu Airport",
    city: "Sibu",
    country: "MY",
    continent: "AS",
    lat: 2.2616,
    lon: 111.985,
    elevation: 122,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBGZ": {
    icao: "WBGZ",
    iata: "BBN",
    name: "Bario Airport",
    city: "Bario",
    country: "MY",
    continent: "AS",
    lat: 3.7346,
    lon: 115.4785,
    elevation: 3350,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBKD": {
    icao: "WBKD",
    iata: "LDU",
    name: "Lahad Datu Airport",
    city: "Lahad Datu",
    country: "MY",
    continent: "AS",
    lat: 5.0324,
    lon: 118.3238,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBKK": {
    icao: "WBKK",
    iata: "BKI",
    name: "Kota Kinabalu International Airport",
    city: "Kota Kinabalu",
    country: "MY",
    continent: "AS",
    lat: 5.9327,
    lon: 116.0493,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBKL": {
    icao: "WBKL",
    iata: "LBU",
    name: "Labuan Airport",
    city: "Labuan",
    country: "MY",
    continent: "AS",
    lat: 5.3017,
    lon: 115.2483,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBKS": {
    icao: "WBKS",
    iata: "SDK",
    name: "Sandakan Airport",
    city: "Sandakan",
    country: "MY",
    continent: "AS",
    lat: 5.9009,
    lon: 118.059,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBKW": {
    icao: "WBKW",
    iata: "TWU",
    name: "Tawau Airport",
    city: "Tawau",
    country: "MY",
    continent: "AS",
    lat: 4.3134,
    lon: 118.1215,
    elevation: 57,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBMU": {
    icao: "WBMU",
    iata: "MZV",
    name: "Mulu Airport",
    city: "Mulu",
    country: "MY",
    continent: "AS",
    lat: 4.0483,
    lon: 114.805,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WBSB": {
    icao: "WBSB",
    iata: "BWN",
    name: "Brunei International Airport",
    city: "Bandar Seri Begawan",
    country: "BN",
    continent: "AS",
    lat: 4.9442,
    lon: 114.928,
    elevation: 73,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WIBB": {
    icao: "WIBB",
    iata: "PKU",
    name: "Sultan Syarif Kasim II International Airport / Roesmin Nurjadin AFB",
    city: "Pekanbaru",
    country: "ID",
    continent: "AS",
    lat: 0.4586,
    lon: 101.4443,
    elevation: 102,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIBD": {
    icao: "WIBD",
    iata: "DUM",
    name: "Pinang Kampai Airport",
    city: "Dumai",
    country: "ID",
    continent: "AS",
    lat: 1.6091,
    lon: 101.4335,
    elevation: 55,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIBJ": {
    icao: "WIBJ",
    iata: "RGT",
    name: "Japura Airport",
    city: "Rengat-Sumatra Island",
    country: "ID",
    continent: "AS",
    lat: -0.3528,
    lon: 102.335,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WICA": {
    icao: "WICA",
    iata: "KJT",
    name: "Kertajati International Airport",
    city: "Kertajati",
    country: "ID",
    continent: "AS",
    lat: -6.6474,
    lon: 108.1656,
    elevation: 134,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WICC": {
    icao: "WICC",
    iata: "BDO",
    name: "Husein Sastranegara International Airport",
    city: "Bandung",
    country: "ID",
    continent: "AS",
    lat: -6.9006,
    lon: 107.576,
    elevation: 2436,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIDD": {
    icao: "WIDD",
    iata: "BTH",
    name: "Hang Nadim International Airport",
    city: "Batam",
    country: "ID",
    continent: "AS",
    lat: 1.121,
    lon: 104.119,
    elevation: 126,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIHH": {
    icao: "WIHH",
    iata: "HLP",
    name: "Halim Perdanakusuma International Airport",
    city: "Jakarta",
    country: "ID",
    continent: "AS",
    lat: -6.2666,
    lon: 106.891,
    elevation: 84,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIII": {
    icao: "WIII",
    iata: "CGK",
    name: "Soekarno-Hatta International Airport",
    city: "Jakarta",
    country: "ID",
    continent: "AS",
    lat: -6.1256,
    lon: 106.656,
    elevation: 34,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WILL": {
    icao: "WILL",
    iata: "TKG",
    name: "Radin Inten II International Airport",
    city: "Bandar Lampung",
    country: "ID",
    continent: "AS",
    lat: -5.2468,
    lon: 105.1825,
    elevation: 282,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIMB": {
    icao: "WIMB",
    iata: "GNS",
    name: "Binaka Airport",
    city: "Gunungsitoli",
    country: "ID",
    continent: "AS",
    lat: 1.1663,
    lon: 97.7043,
    elevation: 20,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIME": {
    icao: "WIME",
    iata: "AEG",
    name: "Aek Godang Airport",
    city: "Padang Sidempuan",
    country: "ID",
    continent: "AS",
    lat: 1.4001,
    lon: 99.4305,
    elevation: 922,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIMK": {
    icao: "WIMK",
    iata: "MES",
    name: "Soewondo Air Force Base",
    city: "Medan",
    country: "ID",
    continent: "AS",
    lat: 3.5584,
    lon: 98.6723,
    elevation: 114,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIMM": {
    icao: "WIMM",
    iata: "KNO",
    name: "Kualanamu International Airport",
    city: "Beringin",
    country: "ID",
    continent: "AS",
    lat: 3.6378,
    lon: 98.8706,
    elevation: 23,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WIMS": {
    icao: "WIMS",
    iata: "FLZ",
    name: "Dr. Ferdinand Lumban Tobing Airport",
    city: "Sibolga (Pinangsori)",
    country: "ID",
    continent: "AS",
    lat: 1.5571,
    lon: 98.8871,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIMU": {
    icao: "WIMU",
    iata: "LSR",
    name: "Alas Leuser Airport",
    city: "Kutacane",
    country: "ID",
    continent: "AS",
    lat: 3.3915,
    lon: 97.8637,
    elevation: 419,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIOG": {
    icao: "WIOG",
    iata: "NPO",
    name: "Nanga Pinoh Airport",
    city: "Nanga Pinoh-Borneo Island",
    country: "ID",
    continent: "AS",
    lat: -0.3486,
    lon: 111.7462,
    elevation: 123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIOK": {
    icao: "WIOK",
    iata: "KTG",
    name: "Rahadi Osman Airport",
    city: "Ketapang",
    country: "ID",
    continent: "AS",
    lat: -1.8172,
    lon: 109.9635,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WION": {
    icao: "WION",
    iata: "NTX",
    name: "Ranai Airport",
    city: "Ranai-Natuna Besar Island",
    country: "ID",
    continent: "AS",
    lat: 3.9087,
    lon: 108.388,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIOO": {
    icao: "WIOO",
    iata: "PNK",
    name: "Supadio Airport",
    city: "Pontianak",
    country: "ID",
    continent: "AS",
    lat: -0.1507,
    lon: 109.404,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIOP": {
    icao: "WIOP",
    iata: "PSU",
    name: "Pangsuma Airport",
    city: "Putussibau-Borneo Island",
    country: "ID",
    continent: "AS",
    lat: 0.8346,
    lon: 112.9402,
    elevation: 297,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIOS": {
    icao: "WIOS",
    iata: "SQG",
    name: "Tebelian Airport",
    city: "Sintang",
    country: "ID",
    continent: "AS",
    lat: -0.0452,
    lon: 111.458,
    elevation: 97,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIPK": {
    icao: "WIPK",
    iata: "PGK",
    name: "Depati Amir Airport",
    city: "Pangkal Pinang",
    country: "ID",
    continent: "AS",
    lat: -2.1622,
    lon: 106.139,
    elevation: 109,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIPL": {
    icao: "WIPL",
    iata: "BKS",
    name: "Fatmawati Soekarno Airport",
    city: "Bengkulu",
    country: "ID",
    continent: "AS",
    lat: -3.8637,
    lon: 102.339,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIPP": {
    icao: "WIPP",
    iata: "PLM",
    name: "Sultan Mahmud Badaruddin II Airport",
    city: "Palembang",
    country: "ID",
    continent: "AS",
    lat: -2.8977,
    lon: 104.6981,
    elevation: 49,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIPQ": {
    icao: "WIPQ",
    iata: "PDO",
    name: "Pendopo Airport",
    city: "Talang Gudang-Sumatra Island",
    country: "ID",
    continent: "AS",
    lat: -3.2861,
    lon: 103.88,
    elevation: 184,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WIPT": {
    icao: "WIPT",
    iata: "PDG",
    name: "Minangkabau International Airport",
    city: "Padang (Katapiang)",
    country: "ID",
    continent: "AS",
    lat: -0.7869,
    lon: 100.281,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WITC": {
    icao: "WITC",
    iata: "MEQ",
    name: "Cut Nyak Dhien Airport",
    city: "Kuala Pesisir",
    country: "ID",
    continent: "AS",
    lat: 4.041,
    lon: 96.2533,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WITK": {
    icao: "WITK",
    iata: "TXE",
    name: "Rembele Airport",
    city: "Takengon",
    country: "ID",
    continent: "AS",
    lat: 4.7211,
    lon: 96.8519,
    elevation: 4648,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WITL": {
    icao: "WITL",
    iata: "LSX",
    name: "Lhok Sukon Airport",
    city: "Lhok Sukon-Sumatra Island",
    country: "ID",
    continent: "AS",
    lat: 5.0695,
    lon: 97.2592,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WITT": {
    icao: "WITT",
    iata: "BTJ",
    name: "Sultan Iskandar Muda International Airport",
    city: "Banda Aceh",
    country: "ID",
    continent: "AS",
    lat: 5.5251,
    lon: 95.42,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMAP": {
    icao: "WMAP",
    iata: "",
    name: "Kluang Airport",
    city: "Kluang",
    country: "MY",
    continent: "AS",
    lat: 2.0414,
    lon: 103.307,
    elevation: 150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMBT": {
    icao: "WMBT",
    iata: "TOD",
    name: "Tioman Airport",
    city: "Tioman Island",
    country: "MY",
    continent: "AS",
    lat: 2.8182,
    lon: 104.16,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKA": {
    icao: "WMKA",
    iata: "AOR",
    name: "Sultan Abdul Halim Airport",
    city: "Alor Satar",
    country: "MY",
    continent: "AS",
    lat: 6.1897,
    lon: 100.398,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKB": {
    icao: "WMKB",
    iata: "BWH",
    name: "RMAF Butterworth Air Base",
    city: "Butterworth",
    country: "MY",
    continent: "AS",
    lat: 5.4659,
    lon: 100.391,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKC": {
    icao: "WMKC",
    iata: "KBR",
    name: "Sultan Ismail Petra Airport",
    city: "Kota Baharu",
    country: "MY",
    continent: "AS",
    lat: 6.1669,
    lon: 102.293,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKD": {
    icao: "WMKD",
    iata: "KUA",
    name: "Kuantan Airport",
    city: "Kuantan",
    country: "MY",
    continent: "AS",
    lat: 3.7754,
    lon: 103.209,
    elevation: 58,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKE": {
    icao: "WMKE",
    iata: "KTE",
    name: "Kerteh Airport",
    city: "Kerteh",
    country: "MY",
    continent: "AS",
    lat: 4.5372,
    lon: 103.427,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKI": {
    icao: "WMKI",
    iata: "IPH",
    name: "Sultan Azlan Shah Airport",
    city: "Ipoh",
    country: "MY",
    continent: "AS",
    lat: 4.568,
    lon: 101.092,
    elevation: 130,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKJ": {
    icao: "WMKJ",
    iata: "JHB",
    name: "Senai International Airport",
    city: "Johor Bahru",
    country: "MY",
    continent: "AS",
    lat: 1.6413,
    lon: 103.67,
    elevation: 135,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKK": {
    icao: "WMKK",
    iata: "KUL",
    name: "Kuala Lumpur International Airport",
    city: "Sepang",
    country: "MY",
    continent: "AS",
    lat: 2.7456,
    lon: 101.71,
    elevation: 69,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "WMKL": {
    icao: "WMKL",
    iata: "LGK",
    name: "Langkawi International Airport",
    city: "Langkawi",
    country: "MY",
    continent: "AS",
    lat: 6.3297,
    lon: 99.7287,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKM": {
    icao: "WMKM",
    iata: "MKZ",
    name: "Malacca International Airport",
    city: "Malacca",
    country: "MY",
    continent: "AS",
    lat: 2.2656,
    lon: 102.2528,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKN": {
    icao: "WMKN",
    iata: "TGG",
    name: "Sultan Mahmud Airport",
    city: "Kuala Terengganu",
    country: "MY",
    continent: "AS",
    lat: 5.3826,
    lon: 103.103,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMKP": {
    icao: "WMKP",
    iata: "PEN",
    name: "Penang International Airport",
    city: "Penang",
    country: "MY",
    continent: "AS",
    lat: 5.2971,
    lon: 100.277,
    elevation: 11,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WMSA": {
    icao: "WMSA",
    iata: "SZB",
    name: "Sultan Abdul Aziz Shah International Airport",
    city: "Subang",
    country: "MY",
    continent: "AS",
    lat: 3.1306,
    lon: 101.549,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WPDB": {
    icao: "WPDB",
    iata: "UAI",
    name: "Suai Airport",
    city: "Suai",
    country: "TL",
    continent: "AS",
    lat: -9.3033,
    lon: 125.287,
    elevation: 96,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WPDL": {
    icao: "WPDL",
    iata: "DIL",
    name: "Presidente Nicolau Lobato International Airport",
    city: "Dili",
    country: "TL",
    continent: "AS",
    lat: -8.5466,
    lon: 125.5245,
    elevation: 154,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WPEC": {
    icao: "WPEC",
    iata: "BCH",
    name: "Cakung Airport",
    city: "Baucau",
    country: "TL",
    continent: "AS",
    lat: -8.4865,
    lon: 126.4,
    elevation: 1771,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WPOC": {
    icao: "WPOC",
    iata: "OEC",
    name: "Rota Do Sândalo Oecusse Airport",
    city: "Oecussi-Ambeno",
    country: "TL",
    continent: "AS",
    lat: -9.1981,
    lon: 124.343,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WSAC": {
    icao: "WSAC",
    iata: "",
    name: "Changi Air Base (East)",
    city: "Singapore",
    country: "SG",
    continent: "AS",
    lat: 1.3441,
    lon: 104.009,
    elevation: 22,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WSAG": {
    icao: "WSAG",
    iata: "",
    name: "Sembawang Air Base",
    city: "Sembawang",
    country: "SG",
    continent: "AS",
    lat: 1.4253,
    lon: 103.813,
    elevation: 86,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WSAP": {
    icao: "WSAP",
    iata: "QPG",
    name: "Paya Lebar Air Base",
    city: "Paya Lebar",
    country: "SG",
    continent: "AS",
    lat: 1.3604,
    lon: 103.91,
    elevation: 65,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WSAT": {
    icao: "WSAT",
    iata: "TGA",
    name: "Tengah Air Base",
    city: "Western Water Catchment",
    country: "SG",
    continent: "AS",
    lat: 1.3876,
    lon: 103.7083,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WSSL": {
    icao: "WSSL",
    iata: "XSP",
    name: "Seletar Airport",
    city: "Seletar",
    country: "SG",
    continent: "AS",
    lat: 1.4156,
    lon: 103.8667,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "WSSS": {
    icao: "WSSS",
    iata: "SIN",
    name: "Singapore Changi Airport",
    city: "Singapore",
    country: "SG",
    continent: "AS",
    lat: 1.3502,
    lon: 103.994,
    elevation: 22,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "XRMU": {
    icao: "XRMU",
    iata: "",
    name: "Khankala Air Base",
    city: "Grozny",
    country: "RU",
    continent: "EU",
    lat: 43.2981,
    lon: 45.7841,
    elevation: 548,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "XRWL": {
    icao: "XRWL",
    iata: "",
    name: "Lebyazhye Air Base",
    city: "Kamyshin",
    country: "RU",
    continent: "AS",
    lat: 50.2017,
    lon: 45.2083,
    elevation: 381,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YABA": {
    icao: "YABA",
    iata: "ALH",
    name: "Albany Airport",
    city: "Albany",
    country: "AU",
    continent: "OC",
    lat: -34.9433,
    lon: 117.8089,
    elevation: 233,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YAMB": {
    icao: "YAMB",
    iata: "",
    name: "RAAF Base Amberley",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -27.6354,
    lon: 152.7112,
    elevation: 91,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YARA": {
    icao: "YARA",
    iata: "ARY",
    name: "Ararat Airport",
    city: "Ararat",
    country: "AU",
    continent: "OC",
    lat: -37.31,
    lon: 142.9887,
    elevation: 1008,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YARM": {
    icao: "YARM",
    iata: "ARM",
    name: "Armidale Airport",
    city: "Armidale",
    country: "AU",
    continent: "OC",
    lat: -30.5281,
    lon: 151.617,
    elevation: 3556,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YAYE": {
    icao: "YAYE",
    iata: "AYQ",
    name: "Ayers Rock Connellan Airport",
    city: "Yulara",
    country: "AU",
    continent: "OC",
    lat: -25.1859,
    lon: 130.977,
    elevation: 1626,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBAR": {
    icao: "YBAR",
    iata: "BCI",
    name: "Barcaldine Airport",
    city: "Barcaldine",
    country: "AU",
    continent: "OC",
    lat: -23.5663,
    lon: 145.3021,
    elevation: 878,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBAS": {
    icao: "YBAS",
    iata: "ASP",
    name: "Alice Springs Airport",
    city: "Alice Springs",
    country: "AU",
    continent: "OC",
    lat: -23.8066,
    lon: 133.9034,
    elevation: 1789,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBBN": {
    icao: "YBBN",
    iata: "BNE",
    name: "Brisbane International Airport",
    city: "Brisbane",
    country: "AU",
    continent: "OC",
    lat: -27.3842,
    lon: 153.117,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "YBCG": {
    icao: "YBCG",
    iata: "OOL",
    name: "Gold Coast Airport",
    city: "Gold Coast",
    country: "AU",
    continent: "OC",
    lat: -28.166,
    lon: 153.5066,
    elevation: 21,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBCK": {
    icao: "YBCK",
    iata: "BKQ",
    name: "Blackall Airport",
    city: "Blackall",
    country: "AU",
    continent: "OC",
    lat: -24.4317,
    lon: 145.4297,
    elevation: 928,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBCS": {
    icao: "YBCS",
    iata: "CNS",
    name: "Cairns International Airport",
    city: "Cairns",
    country: "AU",
    continent: "OC",
    lat: -16.8789,
    lon: 145.7495,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBCV": {
    icao: "YBCV",
    iata: "CTL",
    name: "Charleville Airport",
    city: "Charleville",
    country: "AU",
    continent: "OC",
    lat: -26.4133,
    lon: 146.262,
    elevation: 1003,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBDV": {
    icao: "YBDV",
    iata: "BVI",
    name: "Birdsville Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -25.8975,
    lon: 139.348,
    elevation: 159,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBHI": {
    icao: "YBHI",
    iata: "BHQ",
    name: "Broken Hill Airport",
    city: "Broken Hill",
    country: "AU",
    continent: "OC",
    lat: -32.0014,
    lon: 141.472,
    elevation: 958,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBHM": {
    icao: "YBHM",
    iata: "HTI",
    name: "Hamilton Island Airport",
    city: "Hamilton Island",
    country: "AU",
    continent: "OC",
    lat: -20.3581,
    lon: 148.952,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBIE": {
    icao: "YBIE",
    iata: "BEU",
    name: "Bedourie Airport",
    city: "Bedourie",
    country: "AU",
    continent: "OC",
    lat: -24.3461,
    lon: 139.46,
    elevation: 300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBKE": {
    icao: "YBKE",
    iata: "BRK",
    name: "Bourke Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -30.0392,
    lon: 145.952,
    elevation: 352,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBLA": {
    icao: "YBLA",
    iata: "BLN",
    name: "Benalla Airport",
    city: "Benalla",
    country: "AU",
    continent: "OC",
    lat: -36.5519,
    lon: 146.007,
    elevation: 569,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBMA": {
    icao: "YBMA",
    iata: "ISA",
    name: "Mount Isa Airport",
    city: "Mount Isa",
    country: "AU",
    continent: "OC",
    lat: -20.6664,
    lon: 139.4885,
    elevation: 1121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBMK": {
    icao: "YBMK",
    iata: "MKY",
    name: "Mackay Airport",
    city: "Mackay",
    country: "AU",
    continent: "OC",
    lat: -21.1708,
    lon: 149.1826,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBNA": {
    icao: "YBNA",
    iata: "BNK",
    name: "Ballina Byron Gateway Airport",
    city: "Ballina",
    country: "AU",
    continent: "OC",
    lat: -28.8332,
    lon: 153.5615,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBNS": {
    icao: "YBNS",
    iata: "BSJ",
    name: "Bairnsdale Airport",
    city: "Bairnsdale",
    country: "AU",
    continent: "OC",
    lat: -37.8875,
    lon: 147.5694,
    elevation: 165,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBOK": {
    icao: "YBOK",
    iata: "OKY",
    name: "Oakey Army Aviation Centre",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -27.4093,
    lon: 151.7367,
    elevation: 1335,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBOU": {
    icao: "YBOU",
    iata: "BQL",
    name: "Boulia Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -22.9133,
    lon: 139.9,
    elevation: 542,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBPN": {
    icao: "YBPN",
    iata: "PPP",
    name: "Proserpine Whitsunday Coast Airport",
    city: "Proserpine",
    country: "AU",
    continent: "OC",
    lat: -20.4944,
    lon: 148.5536,
    elevation: 82,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBRK": {
    icao: "YBRK",
    iata: "ROK",
    name: "Rockhampton Airport",
    city: "Rockhampton",
    country: "AU",
    continent: "OC",
    lat: -23.38,
    lon: 150.4754,
    elevation: 34,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBRM": {
    icao: "YBRM",
    iata: "BME",
    name: "Broome International Airport",
    city: "Broome",
    country: "AU",
    continent: "OC",
    lat: -17.9494,
    lon: 122.2278,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBRN": {
    icao: "YBRN",
    iata: "BZD",
    name: "Balranald Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -34.6248,
    lon: 143.5771,
    elevation: 210,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBRW": {
    icao: "YBRW",
    iata: "BWQ",
    name: "Brewarrina Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -29.9758,
    lon: 146.8144,
    elevation: 414,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBSU": {
    icao: "YBSU",
    iata: "MCY",
    name: "Sunshine Coast Airport",
    city: "Maroochydore",
    country: "AU",
    continent: "OC",
    lat: -26.5933,
    lon: 153.0832,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBTH": {
    icao: "YBTH",
    iata: "BHS",
    name: "Bathurst Airport",
    city: "Bathurst",
    country: "AU",
    continent: "OC",
    lat: -33.4068,
    lon: 149.6512,
    elevation: 2435,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBTI": {
    icao: "YBTI",
    iata: "BRT",
    name: "Bathurst Island Airport",
    city: "Wurrumiyanga",
    country: "AU",
    continent: "OC",
    lat: -11.765,
    lon: 130.6158,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBTL": {
    icao: "YBTL",
    iata: "TSV",
    name: "Townsville Airport / RAAF Base Townsville",
    city: "Townsville",
    country: "AU",
    continent: "OC",
    lat: -19.2529,
    lon: 146.7665,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBTR": {
    icao: "YBTR",
    iata: "BLT",
    name: "Blackwater Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -23.6031,
    lon: 148.807,
    elevation: 657,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBUD": {
    icao: "YBUD",
    iata: "BDB",
    name: "Bundaberg Airport",
    city: "Bundaberg",
    country: "AU",
    continent: "OC",
    lat: -24.905,
    lon: 152.3226,
    elevation: 107,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBWP": {
    icao: "YBWP",
    iata: "WEI",
    name: "Weipa Airport",
    city: "Weipa",
    country: "AU",
    continent: "OC",
    lat: -12.6775,
    lon: 141.9226,
    elevation: 63,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YBWW": {
    icao: "YBWW",
    iata: "WTB",
    name: "Toowoomba Wellcamp Airport",
    city: "Toowoomba",
    country: "AU",
    continent: "OC",
    lat: -27.5583,
    lon: 151.7933,
    elevation: 1509,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCAR": {
    icao: "YCAR",
    iata: "CVQ",
    name: "Carnarvon Airport",
    city: "Carnarvon",
    country: "AU",
    continent: "OC",
    lat: -24.8843,
    lon: 113.6664,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCBA": {
    icao: "YCBA",
    iata: "CAZ",
    name: "Cobar Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -31.5383,
    lon: 145.794,
    elevation: 724,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCBB": {
    icao: "YCBB",
    iata: "COJ",
    name: "Coonabarabran Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -31.3325,
    lon: 149.267,
    elevation: 2117,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCBP": {
    icao: "YCBP",
    iata: "CPD",
    name: "Coober Pedy Airport",
    city: "Coober Pedy",
    country: "AU",
    continent: "OC",
    lat: -29.0383,
    lon: 134.7222,
    elevation: 740,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCCA": {
    icao: "YCCA",
    iata: "CCL",
    name: "Chinchilla Airport",
    city: "Chinchilla",
    country: "AU",
    continent: "OC",
    lat: -26.7719,
    lon: 150.6176,
    elevation: 1028,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCCY": {
    icao: "YCCY",
    iata: "CNJ",
    name: "Cloncurry Airport",
    city: "Cloncurry",
    country: "AU",
    continent: "OC",
    lat: -20.6686,
    lon: 140.504,
    elevation: 616,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCDU": {
    icao: "YCDU",
    iata: "CED",
    name: "Ceduna Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -32.1306,
    lon: 133.71,
    elevation: 77,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCEE": {
    icao: "YCEE",
    iata: "CVC",
    name: "Cleve Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -33.7097,
    lon: 136.505,
    elevation: 589,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCFS": {
    icao: "YCFS",
    iata: "CFS",
    name: "Coffs Harbour Airport",
    city: "Coffs Harbour",
    country: "AU",
    continent: "OC",
    lat: -30.3206,
    lon: 153.116,
    elevation: 18,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCIN": {
    icao: "YCIN",
    iata: "DCN",
    name: "RAAF Base Curtin",
    city: "Derby",
    country: "AU",
    continent: "OC",
    lat: -17.5814,
    lon: 123.8283,
    elevation: 300,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCKN": {
    icao: "YCKN",
    iata: "CTN",
    name: "Cooktown Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -15.4436,
    lon: 145.1832,
    elevation: 26,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCMT": {
    icao: "YCMT",
    iata: "CMQ",
    name: "Clermont Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -22.7731,
    lon: 147.621,
    elevation: 908,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCMU": {
    icao: "YCMU",
    iata: "CMA",
    name: "Cunnamulla Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -28.03,
    lon: 145.622,
    elevation: 630,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCNM": {
    icao: "YCNM",
    iata: "CNB",
    name: "Coonamble Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -30.9809,
    lon: 148.3778,
    elevation: 604,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCOE": {
    icao: "YCOE",
    iata: "CUQ",
    name: "Coen Airport",
    city: "Coen",
    country: "AU",
    continent: "OC",
    lat: -13.7611,
    lon: 143.1133,
    elevation: 532,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCOM": {
    icao: "YCOM",
    iata: "OOM",
    name: "Cooma Snowy Mountains Airport",
    city: "Cooma",
    country: "AU",
    continent: "OC",
    lat: -36.3004,
    lon: 148.9724,
    elevation: 3088,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCOR": {
    icao: "YCOR",
    iata: "CWW",
    name: "Corowa Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -35.9947,
    lon: 146.357,
    elevation: 469,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCRG": {
    icao: "YCRG",
    iata: "CYG",
    name: "Corryong Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -36.1828,
    lon: 147.888,
    elevation: 963,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCTM": {
    icao: "YCTM",
    iata: "CMD",
    name: "Cootamundra Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -34.6243,
    lon: 148.0366,
    elevation: 1110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YCWR": {
    icao: "YCWR",
    iata: "CWT",
    name: "Cowra Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -33.8469,
    lon: 148.648,
    elevation: 966,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YDBI": {
    icao: "YDBI",
    iata: "DRN",
    name: "Dirranbandi Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -28.5879,
    lon: 148.2172,
    elevation: 567,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YDBY": {
    icao: "YDBY",
    iata: "DRB",
    name: "Derby Airport",
    city: "Derby",
    country: "AU",
    continent: "OC",
    lat: -17.3719,
    lon: 123.6622,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YDLQ": {
    icao: "YDLQ",
    iata: "DNQ",
    name: "Deniliquin Airport",
    city: "Deniliquin",
    country: "AU",
    continent: "OC",
    lat: -35.5594,
    lon: 144.946,
    elevation: 316,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YDPO": {
    icao: "YDPO",
    iata: "DPO",
    name: "Devonport Airport",
    city: "Devonport",
    country: "AU",
    continent: "OC",
    lat: -41.1697,
    lon: 146.43,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YDYS": {
    icao: "YDYS",
    iata: "DYA",
    name: "Dysart Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -22.6222,
    lon: 148.364,
    elevation: 670,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YECH": {
    icao: "YECH",
    iata: "ECH",
    name: "Echuca Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -36.1572,
    lon: 144.762,
    elevation: 323,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YELD": {
    icao: "YELD",
    iata: "ELC",
    name: "Elcho Island Airport",
    city: "Elcho Island",
    country: "AU",
    continent: "OC",
    lat: -12.0194,
    lon: 135.571,
    elevation: 101,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YEML": {
    icao: "YEML",
    iata: "EMD",
    name: "Emerald Airport",
    city: "Emerald",
    country: "AU",
    continent: "OC",
    lat: -23.5675,
    lon: 148.179,
    elevation: 624,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YESP": {
    icao: "YESP",
    iata: "EPR",
    name: "Esperance Airport",
    city: "Esperance",
    country: "AU",
    continent: "OC",
    lat: -33.6844,
    lon: 121.823,
    elevation: 470,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YEWA": {
    icao: "YEWA",
    iata: "WHB",
    name: "Eliwana",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -22.4284,
    lon: 116.8879,
    elevation: 1576,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YFBS": {
    icao: "YFBS",
    iata: "FRB",
    name: "Forbes Airport",
    city: "Forbes",
    country: "AU",
    continent: "OC",
    lat: -33.3636,
    lon: 147.935,
    elevation: 760,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YFRT": {
    icao: "YFRT",
    iata: "FOS",
    name: "Forrest Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -30.8366,
    lon: 128.1128,
    elevation: 511,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YFTZ": {
    icao: "YFTZ",
    iata: "FIZ",
    name: "Fitzroy Crossing Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -18.1836,
    lon: 125.5598,
    elevation: 368,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGDH": {
    icao: "YGDH",
    iata: "GUH",
    name: "Gunnedah Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -30.9575,
    lon: 150.249,
    elevation: 863,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGEL": {
    icao: "YGEL",
    iata: "GET",
    name: "Geraldton Airport",
    city: "Moonyoonooka",
    country: "AU",
    continent: "OC",
    lat: -28.7961,
    lon: 114.707,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGFN": {
    icao: "YGFN",
    iata: "GFN",
    name: "Clarence Valley Regional Airport",
    city: "Grafton",
    country: "AU",
    continent: "OC",
    lat: -29.7548,
    lon: 153.0312,
    elevation: 110,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGLA": {
    icao: "YGLA",
    iata: "GLT",
    name: "Gladstone Airport",
    city: "Gladstone",
    country: "AU",
    continent: "OC",
    lat: -23.8698,
    lon: 151.2254,
    elevation: 64,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGLB": {
    icao: "YGLB",
    iata: "GUL",
    name: "Goulburn Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -34.8103,
    lon: 149.726,
    elevation: 2141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGLI": {
    icao: "YGLI",
    iata: "GLI",
    name: "Glen Innes Airport",
    city: "Glen Innes",
    country: "AU",
    continent: "OC",
    lat: -29.676,
    lon: 151.6912,
    elevation: 3433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGPT": {
    icao: "YGPT",
    iata: "GPN",
    name: "Garden Point Airport",
    city: "Pirlangimpi",
    country: "AU",
    continent: "OC",
    lat: -11.3997,
    lon: 130.4256,
    elevation: 90,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGTE": {
    icao: "YGTE",
    iata: "GTE",
    name: "Groote Eylandt Airport",
    city: "Groote Eylandt",
    country: "AU",
    continent: "OC",
    lat: -13.9724,
    lon: 136.4586,
    elevation: 53,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YGTH": {
    icao: "YGTH",
    iata: "GFF",
    name: "Griffith Airport",
    city: "Griffith",
    country: "AU",
    continent: "OC",
    lat: -34.2508,
    lon: 146.067,
    elevation: 439,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHAY": {
    icao: "YHAY",
    iata: "HXX",
    name: "Hay Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -34.5314,
    lon: 144.83,
    elevation: 305,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHBA": {
    icao: "YHBA",
    iata: "HVB",
    name: "Hervey Bay Airport",
    city: "Hervey Bay",
    country: "AU",
    continent: "OC",
    lat: -25.3201,
    lon: 152.8807,
    elevation: 60,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHID": {
    icao: "YHID",
    iata: "HID",
    name: "Horn Island Airport",
    city: "Horn",
    country: "AU",
    continent: "OC",
    lat: -10.5856,
    lon: 142.2927,
    elevation: 43,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHLC": {
    icao: "YHLC",
    iata: "HCQ",
    name: "Halls Creek Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -18.2339,
    lon: 127.67,
    elevation: 1346,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHML": {
    icao: "YHML",
    iata: "HLT",
    name: "Hamilton Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -37.6489,
    lon: 142.065,
    elevation: 803,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHOT": {
    icao: "YHOT",
    iata: "MHU",
    name: "Mount Hotham Airport",
    city: "Mount Hotham",
    country: "AU",
    continent: "OC",
    lat: -37.0475,
    lon: 147.334,
    elevation: 4260,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHPN": {
    icao: "YHPN",
    iata: "HTU",
    name: "Hopetoun Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -35.7153,
    lon: 142.36,
    elevation: 256,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YHSM": {
    icao: "YHSM",
    iata: "HSM",
    name: "Horsham Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -36.6697,
    lon: 142.173,
    elevation: 445,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YIVL": {
    icao: "YIVL",
    iata: "IVR",
    name: "Inverell Airport",
    city: "Inverell",
    country: "AU",
    continent: "OC",
    lat: -29.8883,
    lon: 151.144,
    elevation: 2667,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YKER": {
    icao: "YKER",
    iata: "KRA",
    name: "Kerang Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -35.7514,
    lon: 143.939,
    elevation: 254,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YKII": {
    icao: "YKII",
    iata: "KNS",
    name: "King Island Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -39.8775,
    lon: 143.878,
    elevation: 132,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YKMP": {
    icao: "YKMP",
    iata: "KPS",
    name: "Kempsey Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -31.0723,
    lon: 152.7653,
    elevation: 54,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YKOW": {
    icao: "YKOW",
    iata: "KWM",
    name: "Kowanyama Airport",
    city: "Kowanyama",
    country: "AU",
    continent: "OC",
    lat: -15.4854,
    lon: 141.7526,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YKRY": {
    icao: "YKRY",
    iata: "KGY",
    name: "Kingaroy Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -26.5811,
    lon: 151.8399,
    elevation: 1492,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YKSC": {
    icao: "YKSC",
    iata: "KGC",
    name: "Kingscote Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -35.7139,
    lon: 137.521,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLEC": {
    icao: "YLEC",
    iata: "LGH",
    name: "Leigh Creek Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -30.5983,
    lon: 138.426,
    elevation: 856,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLEO": {
    icao: "YLEO",
    iata: "LNO",
    name: "Leonora Airport",
    city: "Leonora",
    country: "AU",
    continent: "OC",
    lat: -28.8781,
    lon: 121.315,
    elevation: 1217,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLHR": {
    icao: "YLHR",
    iata: "IRG",
    name: "Lockhart River Airport",
    city: "Lockhart River",
    country: "AU",
    continent: "OC",
    lat: -12.7869,
    lon: 143.305,
    elevation: 77,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLIS": {
    icao: "YLIS",
    iata: "LSY",
    name: "Lismore Airport",
    city: "Lismore",
    country: "AU",
    continent: "OC",
    lat: -28.8307,
    lon: 153.2584,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLRD": {
    icao: "YLRD",
    iata: "LHG",
    name: "Lightning Ridge Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -29.4529,
    lon: 147.9771,
    elevation: 540,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLRE": {
    icao: "YLRE",
    iata: "LRE",
    name: "Longreach Airport",
    city: "Longreach",
    country: "AU",
    continent: "OC",
    lat: -23.4342,
    lon: 144.28,
    elevation: 627,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLST": {
    icao: "YLST",
    iata: "LER",
    name: "Leinster Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -27.8433,
    lon: 120.703,
    elevation: 1631,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YLTV": {
    icao: "YLTV",
    iata: "TGN",
    name: "Latrobe Valley Airport",
    city: "Morwell",
    country: "AU",
    continent: "OC",
    lat: -38.211,
    lon: 146.4708,
    elevation: 180,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMAV": {
    icao: "YMAV",
    iata: "AVV",
    name: "Melbourne Avalon International Airport",
    city: "Lara",
    country: "AU",
    continent: "OC",
    lat: -38.0403,
    lon: 144.4672,
    elevation: 35,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMAY": {
    icao: "YMAY",
    iata: "ABX",
    name: "Albury Airport",
    city: "East Albury",
    country: "AU",
    continent: "OC",
    lat: -36.0668,
    lon: 146.9591,
    elevation: 539,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMBA": {
    icao: "YMBA",
    iata: "MRG",
    name: "Mareeba Airport",
    city: "Mareeba",
    country: "AU",
    continent: "OC",
    lat: -17.0703,
    lon: 145.4242,
    elevation: 1560,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMDG": {
    icao: "YMDG",
    iata: "DGE",
    name: "Mudgee Airport",
    city: "Mudgee",
    country: "AU",
    continent: "OC",
    lat: -32.5648,
    lon: 149.6095,
    elevation: 1545,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMEK": {
    icao: "YMEK",
    iata: "MKR",
    name: "Meekatharra Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -26.6117,
    lon: 118.548,
    elevation: 1713,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMEN": {
    icao: "YMEN",
    iata: "MEB",
    name: "Melbourne Essendon Airport",
    city: "Essendon Fields",
    country: "AU",
    continent: "OC",
    lat: -37.7281,
    lon: 144.902,
    elevation: 282,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMER": {
    icao: "YMER",
    iata: "MIM",
    name: "Merimbula Airport",
    city: "Merimbula",
    country: "AU",
    continent: "OC",
    lat: -36.9086,
    lon: 149.901,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMES": {
    icao: "YMES",
    iata: "",
    name: "RAAF Base East Sale",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -38.0989,
    lon: 147.149,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMGD": {
    icao: "YMGD",
    iata: "MNG",
    name: "Maningrida Airport",
    city: "Maningrida",
    country: "AU",
    continent: "OC",
    lat: -12.0561,
    lon: 134.234,
    elevation: 123,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMHB": {
    icao: "YMHB",
    iata: "HBA",
    name: "Hobart International Airport",
    city: "Hobart (Cambridge)",
    country: "AU",
    continent: "OC",
    lat: -42.8371,
    lon: 147.5129,
    elevation: 13,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMIA": {
    icao: "YMIA",
    iata: "MQL",
    name: "Mildura Airport",
    city: "Mildura",
    country: "AU",
    continent: "OC",
    lat: -34.2292,
    lon: 142.086,
    elevation: 167,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMLT": {
    icao: "YMLT",
    iata: "LST",
    name: "Launceston Airport",
    city: "Launceston (Western Junction)",
    country: "AU",
    continent: "OC",
    lat: -41.5449,
    lon: 147.2108,
    elevation: 562,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMMB": {
    icao: "YMMB",
    iata: "MBW",
    name: "Melbourne Moorabbin Airport",
    city: "Melbourne",
    country: "AU",
    continent: "OC",
    lat: -37.9758,
    lon: 145.102,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMML": {
    icao: "YMML",
    iata: "MEL",
    name: "Melbourne Airport",
    city: "Melbourne",
    country: "AU",
    continent: "OC",
    lat: -37.6615,
    lon: 144.8364,
    elevation: 434,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "YMNE": {
    icao: "YMNE",
    iata: "WME",
    name: "Mount Keith Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -27.2873,
    lon: 120.5549,
    elevation: 1792,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMOG": {
    icao: "YMOG",
    iata: "MMG",
    name: "Mount Magnet Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -28.1161,
    lon: 117.842,
    elevation: 1354,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMOR": {
    icao: "YMOR",
    iata: "MRZ",
    name: "Moree Airport",
    city: "Moree",
    country: "AU",
    continent: "OC",
    lat: -29.4989,
    lon: 149.845,
    elevation: 701,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMRB": {
    icao: "YMRB",
    iata: "MOV",
    name: "Moranbah Airport",
    city: "Moranbah",
    country: "AU",
    continent: "OC",
    lat: -22.0578,
    lon: 148.077,
    elevation: 770,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMRY": {
    icao: "YMRY",
    iata: "MYA",
    name: "Moruya Airport",
    city: "Moruya",
    country: "AU",
    continent: "OC",
    lat: -35.8978,
    lon: 150.144,
    elevation: 14,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YMTG": {
    icao: "YMTG",
    iata: "MGB",
    name: "Mount Gambier Airport",
    city: "Mount Gambier",
    country: "AU",
    continent: "OC",
    lat: -37.7444,
    lon: 140.7806,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YNAR": {
    icao: "YNAR",
    iata: "NRA",
    name: "Narrandera Airport",
    city: "Narrandera",
    country: "AU",
    continent: "OC",
    lat: -34.7022,
    lon: 146.512,
    elevation: 474,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YNBR": {
    icao: "YNBR",
    iata: "NAA",
    name: "Narrabri Airport",
    city: "Narrabri",
    country: "AU",
    continent: "OC",
    lat: -30.3192,
    lon: 149.827,
    elevation: 788,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YNGU": {
    icao: "YNGU",
    iata: "RPM",
    name: "Ngukurr Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -14.7228,
    lon: 134.747,
    elevation: 45,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YNRM": {
    icao: "YNRM",
    iata: "QRM",
    name: "Narromine Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -32.2147,
    lon: 148.225,
    elevation: 782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YNTN": {
    icao: "YNTN",
    iata: "NTN",
    name: "Normanton Airport",
    city: "Normanton",
    country: "AU",
    continent: "OC",
    lat: -17.6841,
    lon: 141.0697,
    elevation: 73,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YNWN": {
    icao: "YNWN",
    iata: "ZNE",
    name: "Newman Airport",
    city: "Newman",
    country: "AU",
    continent: "OC",
    lat: -23.4178,
    lon: 119.803,
    elevation: 1724,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YORG": {
    icao: "YORG",
    iata: "OAG",
    name: "Orange Airport",
    city: "Orange",
    country: "AU",
    continent: "OC",
    lat: -33.382,
    lon: 149.1313,
    elevation: 3115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPAD": {
    icao: "YPAD",
    iata: "ADL",
    name: "Adelaide International Airport",
    city: "Adelaide",
    country: "AU",
    continent: "OC",
    lat: -34.9475,
    lon: 138.5334,
    elevation: 20,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "YPAG": {
    icao: "YPAG",
    iata: "PUG",
    name: "Port Augusta Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -32.5069,
    lon: 137.717,
    elevation: 56,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPBO": {
    icao: "YPBO",
    iata: "PBO",
    name: "Paraburdoo Airport",
    city: "Paraburdoo",
    country: "AU",
    continent: "OC",
    lat: -23.1711,
    lon: 117.745,
    elevation: 1406,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPCC": {
    icao: "YPCC",
    iata: "CCK",
    name: "Cocos (Keeling) Islands Airport",
    city: "West Island",
    country: "CC",
    continent: "AS",
    lat: -12.1913,
    lon: 96.8337,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPDN": {
    icao: "YPDN",
    iata: "DRW",
    name: "Darwin International Airport / RAAF Darwin",
    city: "Darwin",
    country: "AU",
    continent: "OC",
    lat: -12.415,
    lon: 130.8818,
    elevation: 103,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "YPEA": {
    icao: "YPEA",
    iata: "",
    name: "RAAF Base Pearce",
    city: "Bullsbrook",
    country: "AU",
    continent: "OC",
    lat: -31.6678,
    lon: 116.015,
    elevation: 149,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPED": {
    icao: "YPED",
    iata: "",
    name: "RAAF Base Edinburgh",
    city: "Adelaide",
    country: "AU",
    continent: "OC",
    lat: -34.7057,
    lon: 138.6156,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPGV": {
    icao: "YPGV",
    iata: "GOV",
    name: "Gove Airport",
    city: "Nhulunbuy",
    country: "AU",
    continent: "OC",
    lat: -12.2694,
    lon: 136.818,
    elevation: 192,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPIR": {
    icao: "YPIR",
    iata: "PPI",
    name: "Port Pirie Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -33.2389,
    lon: 137.995,
    elevation: 40,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPJT": {
    icao: "YPJT",
    iata: "JAD",
    name: "Perth Jandakot Airport",
    city: "Perth",
    country: "AU",
    continent: "OC",
    lat: -32.0975,
    lon: 115.881,
    elevation: 99,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPKA": {
    icao: "YPKA",
    iata: "KTA",
    name: "Karratha Airport",
    city: "Karratha",
    country: "AU",
    continent: "OC",
    lat: -20.7122,
    lon: 116.773,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPKG": {
    icao: "YPKG",
    iata: "KGI",
    name: "Kalgoorlie Boulder Airport",
    city: "Broadwood",
    country: "AU",
    continent: "OC",
    lat: -30.7915,
    lon: 121.4646,
    elevation: 1203,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPKS": {
    icao: "YPKS",
    iata: "PKE",
    name: "Parkes Airport",
    city: "Parkes",
    country: "AU",
    continent: "OC",
    lat: -33.1314,
    lon: 148.239,
    elevation: 1069,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPKT": {
    icao: "YPKT",
    iata: "PKT",
    name: "Port Keats Airport",
    city: "Wadeye",
    country: "AU",
    continent: "OC",
    lat: -14.2497,
    lon: 129.5295,
    elevation: 91,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPKU": {
    icao: "YPKU",
    iata: "KNX",
    name: "East Kimberley Regional (Kununurra) Airport",
    city: "Kununurra",
    country: "AU",
    continent: "OC",
    lat: -15.7781,
    lon: 128.708,
    elevation: 145,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPLC": {
    icao: "YPLC",
    iata: "PLO",
    name: "Port Lincoln Airport",
    city: "Port Lincoln",
    country: "AU",
    continent: "OC",
    lat: -34.6053,
    lon: 135.88,
    elevation: 36,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPLM": {
    icao: "YPLM",
    iata: "LEA",
    name: "Learmonth Airport",
    city: "Exmouth",
    country: "AU",
    continent: "OC",
    lat: -22.2352,
    lon: 114.09,
    elevation: 19,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPMQ": {
    icao: "YPMQ",
    iata: "PQQ",
    name: "Port Macquarie Airport",
    city: "Port Macquarie",
    country: "AU",
    continent: "OC",
    lat: -31.4358,
    lon: 152.863,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPOD": {
    icao: "YPOD",
    iata: "PTJ",
    name: "Portland Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -38.3181,
    lon: 141.471,
    elevation: 265,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPPD": {
    icao: "YPPD",
    iata: "PHE",
    name: "Port Hedland International Airport",
    city: "Port Hedland",
    country: "AU",
    continent: "OC",
    lat: -20.3778,
    lon: 118.626,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPPH": {
    icao: "YPPH",
    iata: "PER",
    name: "Perth International Airport",
    city: "Perth",
    country: "AU",
    continent: "OC",
    lat: -31.9403,
    lon: 115.967,
    elevation: 67,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "YPTN": {
    icao: "YPTN",
    iata: "KTR",
    name: "Tindal Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -14.5211,
    lon: 132.378,
    elevation: 443,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YPXM": {
    icao: "YPXM",
    iata: "XCH",
    name: "Christmas Island Airport",
    city: "Flying Fish Cove",
    country: "CX",
    continent: "AS",
    lat: -10.4494,
    lon: 105.6909,
    elevation: 916,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YQLP": {
    icao: "YQLP",
    iata: "ULP",
    name: "Quilpie Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -26.6092,
    lon: 144.2537,
    elevation: 655,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YREN": {
    icao: "YREN",
    iata: "RMK",
    name: "Renmark Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -34.1964,
    lon: 140.674,
    elevation: 115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YROM": {
    icao: "YROM",
    iata: "RMA",
    name: "Roma Airport",
    city: "Roma",
    country: "AU",
    continent: "OC",
    lat: -26.545,
    lon: 148.775,
    elevation: 1032,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSBK": {
    icao: "YSBK",
    iata: "BWU",
    name: "Sydney Bankstown Airport",
    city: "Sydney",
    country: "AU",
    continent: "OC",
    lat: -33.9236,
    lon: 150.9908,
    elevation: 29,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSCB": {
    icao: "YSCB",
    iata: "CBR",
    name: "Canberra Airport",
    city: "Canberra",
    country: "AU",
    continent: "OC",
    lat: -35.3069,
    lon: 149.195,
    elevation: 1886,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSCN": {
    icao: "YSCN",
    iata: "CDU",
    name: "Camden Airport",
    city: "Cobbitty",
    country: "AU",
    continent: "OC",
    lat: -34.0383,
    lon: 150.6864,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSDU": {
    icao: "YSDU",
    iata: "DBO",
    name: "Dubbo City Regional Airport",
    city: "Dubbo",
    country: "AU",
    continent: "OC",
    lat: -32.2167,
    lon: 148.575,
    elevation: 935,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSHK": {
    icao: "YSHK",
    iata: "MJK",
    name: "Shark Bay Airport",
    city: "Denham",
    country: "AU",
    continent: "OC",
    lat: -25.8973,
    lon: 113.5758,
    elevation: 111,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSHL": {
    icao: "YSHL",
    iata: "WOL",
    name: "Shellharbour Airport",
    city: "Albion Park Rail",
    country: "AU",
    continent: "OC",
    lat: -34.5611,
    lon: 150.789,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSHT": {
    icao: "YSHT",
    iata: "SHT",
    name: "Shepparton Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -36.4283,
    lon: 145.3915,
    elevation: 374,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSMI": {
    icao: "YSMI",
    iata: "SIO",
    name: "Smithton Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -40.835,
    lon: 145.084,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSNB": {
    icao: "YSNB",
    iata: "SNB",
    name: "Snake Bay Airport",
    city: "Milikapiti",
    country: "AU",
    continent: "OC",
    lat: -11.4177,
    lon: 130.6485,
    elevation: 173,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSNF": {
    icao: "YSNF",
    iata: "NLK",
    name: "Norfolk Island International Airport",
    city: "Burnt Pine",
    country: "NF",
    continent: "OC",
    lat: -29.0419,
    lon: 167.9396,
    elevation: 371,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSNW": {
    icao: "YSNW",
    iata: "NOA",
    name: "Naval Air Station Nowra - HMAS Albatross",
    city: "Nowra Hill",
    country: "AU",
    continent: "OC",
    lat: -34.9466,
    lon: 150.5425,
    elevation: 400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSRI": {
    icao: "YSRI",
    iata: "XRH",
    name: "RAAF Base Richmond",
    city: "Richmond",
    country: "AU",
    continent: "OC",
    lat: -33.6047,
    lon: 150.7831,
    elevation: 67,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSSY": {
    icao: "YSSY",
    iata: "SYD",
    name: "Sydney Kingsford Smith International Airport",
    city: "Sydney (Mascot)",
    country: "AU",
    continent: "OC",
    lat: -33.9461,
    lon: 151.177,
    elevation: 21,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "YSTW": {
    icao: "YSTW",
    iata: "TMW",
    name: "Tamworth Airport",
    city: "Tamworth",
    country: "AU",
    continent: "OC",
    lat: -31.0779,
    lon: 150.8455,
    elevation: 1334,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSWG": {
    icao: "YSWG",
    iata: "WGA",
    name: "Wagga Wagga Airport",
    city: "Forest Hill",
    country: "AU",
    continent: "OC",
    lat: -35.1635,
    lon: 147.4683,
    elevation: 724,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSWH": {
    icao: "YSWH",
    iata: "SWH",
    name: "Swan Hill Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -35.3758,
    lon: 143.533,
    elevation: 234,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YSWL": {
    icao: "YSWL",
    iata: "SWC",
    name: "Stawell Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -37.0717,
    lon: 142.741,
    elevation: 807,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTEF": {
    icao: "YTEF",
    iata: "TEF",
    name: "Telfer Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -21.715,
    lon: 122.229,
    elevation: 970,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTEM": {
    icao: "YTEM",
    iata: "TEM",
    name: "Temora Airport",
    city: "Temora",
    country: "AU",
    continent: "OC",
    lat: -34.4214,
    lon: 147.512,
    elevation: 921,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTGM": {
    icao: "YTGM",
    iata: "XTG",
    name: "Thargomindah Airport",
    city: "Thargomindah",
    country: "AU",
    continent: "OC",
    lat: -27.9864,
    lon: 143.8121,
    elevation: 433,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTIB": {
    icao: "YTIB",
    iata: "TYB",
    name: "Tibooburra Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -29.4511,
    lon: 142.058,
    elevation: 584,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTMU": {
    icao: "YTMU",
    iata: "TUM",
    name: "Tumut Aerodrome",
    city: "Tumut",
    country: "AU",
    continent: "OC",
    lat: -35.2683,
    lon: 148.2405,
    elevation: 878,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTNG": {
    icao: "YTNG",
    iata: "THG",
    name: "Thangool Airport",
    city: "Biloela",
    country: "AU",
    continent: "OC",
    lat: -24.4949,
    lon: 150.578,
    elevation: 644,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTNK": {
    icao: "YTNK",
    iata: "TCA",
    name: "Tennant Creek Airport",
    city: "Tennant Creek",
    country: "AU",
    continent: "OC",
    lat: -19.6344,
    lon: 134.183,
    elevation: 1236,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YTRE": {
    icao: "YTRE",
    iata: "TRO",
    name: "Taree Airport",
    city: "Taree",
    country: "AU",
    continent: "OC",
    lat: -31.8886,
    lon: 152.514,
    elevation: 38,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWDH": {
    icao: "YWDH",
    iata: "WNR",
    name: "Windorah Airport",
    city: "Windorah",
    country: "AU",
    continent: "OC",
    lat: -25.4106,
    lon: 142.6684,
    elevation: 452,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWGT": {
    icao: "YWGT",
    iata: "WGT",
    name: "Wangaratta Airport",
    city: "Laceby",
    country: "AU",
    continent: "OC",
    lat: -36.4179,
    lon: 146.3069,
    elevation: 504,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWHA": {
    icao: "YWHA",
    iata: "WYA",
    name: "Whyalla Airport",
    city: "Whyalla",
    country: "AU",
    continent: "OC",
    lat: -33.0589,
    lon: 137.514,
    elevation: 41,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWKB": {
    icao: "YWKB",
    iata: "WKB",
    name: "Warracknabeal Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -36.3211,
    lon: 142.419,
    elevation: 397,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWLG": {
    icao: "YWLG",
    iata: "WGE",
    name: "Walgett Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -30.0328,
    lon: 148.126,
    elevation: 439,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWLM": {
    icao: "YWLM",
    iata: "NTL",
    name: "Newcastle Airport",
    city: "Williamtown",
    country: "AU",
    continent: "OC",
    lat: -32.795,
    lon: 151.834,
    elevation: 31,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWLU": {
    icao: "YWLU",
    iata: "WUN",
    name: "Wiluna Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -26.6292,
    lon: 120.221,
    elevation: 1649,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWMC": {
    icao: "YWMC",
    iata: "",
    name: "William Creek Aerodrome",
    city: "William Creek",
    country: "AU",
    continent: "OC",
    lat: -28.9059,
    lon: 136.3406,
    elevation: 253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWRN": {
    icao: "YWRN",
    iata: "",
    name: "Warren Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -31.7333,
    lon: 147.803,
    elevation: 669,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWSL": {
    icao: "YWSL",
    iata: "SXE",
    name: "West Sale Airport",
    city: "Sale",
    country: "AU",
    continent: "OC",
    lat: -38.0908,
    lon: 146.9653,
    elevation: 72,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWTN": {
    icao: "YWTN",
    iata: "WIN",
    name: "Winton Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -22.3636,
    lon: 143.086,
    elevation: 638,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWWL": {
    icao: "YWWL",
    iata: "WWY",
    name: "West Wyalong Airport",
    city: "West Wyalong",
    country: "AU",
    continent: "OC",
    lat: -33.9372,
    lon: 147.191,
    elevation: 859,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YWYY": {
    icao: "YWYY",
    iata: "BWT",
    name: "Wynyard Airport",
    city: "Burnie",
    country: "AU",
    continent: "OC",
    lat: -40.997,
    lon: 145.726,
    elevation: 62,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "YYNG": {
    icao: "YYNG",
    iata: "NGA",
    name: "Young Airport",
    city: "",
    country: "AU",
    continent: "OC",
    lat: -34.2556,
    lon: 148.2471,
    elevation: 1267,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "Z19O": {
    icao: "Z19O",
    iata: "",
    name: "Wujah Al Hajar Air Base",
    city: "Hamat",
    country: "LB",
    continent: "AS",
    lat: 34.2812,
    lon: 35.6801,
    elevation: 840,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBAA": {
    icao: "ZBAA",
    iata: "PEK",
    name: "Beijing Capital International Airport",
    city: "Beijing",
    country: "CN",
    continent: "AS",
    lat: 40.0801,
    lon: 116.585,
    elevation: 116,
    hub_tier: "major",
    slots: 400,
    demand: 95,
    business_pct: 45,
    landing_fee: 12000,
    competition: "extreme",
  },
  "ZBAD": {
    icao: "ZBAD",
    iata: "PKX",
    name: "Beijing Daxing International Airport",
    city: "Beijing",
    country: "CN",
    continent: "AS",
    lat: 39.5099,
    lon: 116.4109,
    elevation: 98,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZBBB": {
    icao: "ZBBB",
    iata: "",
    name: "Beijing Xijiao Airport",
    city: "Beijing",
    country: "CN",
    continent: "AS",
    lat: 39.9586,
    lon: 116.2568,
    elevation: 164,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBCD": {
    icao: "ZBCD",
    iata: "CDE",
    name: "Chengde Puning Airport",
    city: "Chengde",
    country: "CN",
    continent: "AS",
    lat: 41.1225,
    lon: 118.0739,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBCF": {
    icao: "ZBCF",
    iata: "CIF",
    name: "Chifeng Yulong Airport",
    city: "Chifeng",
    country: "CN",
    continent: "AS",
    lat: 42.1597,
    lon: 118.841,
    elevation: 2018,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBDH": {
    icao: "ZBDH",
    iata: "BPE",
    name: "Qinhuangdao Beidaihe Airport",
    city: "Qinhuangdao (Changli)",
    country: "CN",
    continent: "AS",
    lat: 39.6664,
    lon: 119.0614,
    elevation: 46,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBDS": {
    icao: "ZBDS",
    iata: "DSN",
    name: "Ordos Ejin Horo Airport",
    city: "Ordos",
    country: "CN",
    continent: "AS",
    lat: 39.4935,
    lon: 109.8599,
    elevation: 4557,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBER": {
    icao: "ZBER",
    iata: "ERL",
    name: "Erenhot Saiwusu International Airport",
    city: "Erenhot",
    country: "CN",
    continent: "AS",
    lat: 43.4225,
    lon: 112.0967,
    elevation: 3301,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBES": {
    icao: "ZBES",
    iata: "YIE",
    name: "Arxan Yi\'ershi Airport",
    city: "Arxan",
    country: "CN",
    continent: "AS",
    lat: 47.3106,
    lon: 119.9117,
    elevation: 2925,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBHD": {
    icao: "ZBHD",
    iata: "HDG",
    name: "Handan Airport",
    city: "Handan",
    country: "CN",
    continent: "AS",
    lat: 36.5258,
    lon: 114.4256,
    elevation: 229,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBHH": {
    icao: "ZBHH",
    iata: "HET",
    name: "Hohhot Baita International Airport",
    city: "Hohhot",
    country: "CN",
    continent: "AS",
    lat: 40.8497,
    lon: 111.8246,
    elevation: 3556,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZBHZ": {
    icao: "ZBHZ",
    iata: "HUO",
    name: "Holingol Huolinhe Airport",
    city: "Holingol",
    country: "CN",
    continent: "AS",
    lat: 45.4872,
    lon: 119.4072,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBLA": {
    icao: "ZBLA",
    iata: "HLD",
    name: "Hulunbuir Hailar Airport",
    city: "Hailar",
    country: "CN",
    continent: "AS",
    lat: 49.205,
    lon: 119.825,
    elevation: 2169,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBLF": {
    icao: "ZBLF",
    iata: "LFQ",
    name: "Linfen Yaodu Airport",
    city: "Linfen (Yaodu)",
    country: "CN",
    continent: "AS",
    lat: 36.1326,
    lon: 111.6412,
    elevation: 1483,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBLL": {
    icao: "ZBLL",
    iata: "LLV",
    name: "Lüliang Dawu Airport",
    city: "Lüliang",
    country: "CN",
    continent: "AS",
    lat: 37.6833,
    lon: 111.1428,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBMZ": {
    icao: "ZBMZ",
    iata: "NZH",
    name: "Manzhouli Xijiao Airport",
    city: "Manzhouli",
    country: "CN",
    continent: "AS",
    lat: 49.5667,
    lon: 117.33,
    elevation: 2231,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBOW": {
    icao: "ZBOW",
    iata: "BAV",
    name: "Baotou Donghe Airport",
    city: "Baotou",
    country: "CN",
    continent: "AS",
    lat: 40.56,
    lon: 109.997,
    elevation: 3321,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBSJ": {
    icao: "ZBSJ",
    iata: "SJW",
    name: "Shijiazhuang Zhengding International Airport",
    city: "Shijiazhuang",
    country: "CN",
    continent: "AS",
    lat: 38.2807,
    lon: 114.697,
    elevation: 233,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBTJ": {
    icao: "ZBTJ",
    iata: "TSN",
    name: "Tianjin Binhai International Airport",
    city: "Tianjin",
    country: "CN",
    continent: "AS",
    lat: 39.1244,
    lon: 117.346,
    elevation: 10,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZBTL": {
    icao: "ZBTL",
    iata: "TGO",
    name: "Tongliao Airport",
    city: "Tongliao",
    country: "CN",
    continent: "AS",
    lat: 43.5567,
    lon: 122.2,
    elevation: 2395,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBUC": {
    icao: "ZBUC",
    iata: "UCB",
    name: "Ulanqab Jining Airport",
    city: "Ulanqab",
    country: "CN",
    continent: "AS",
    lat: 41.1303,
    lon: 113.1073,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBXH": {
    icao: "ZBXH",
    iata: "XIL",
    name: "Xilinhot Airport",
    city: "Xilinhot",
    country: "CN",
    continent: "AS",
    lat: 43.9156,
    lon: 115.964,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBYC": {
    icao: "ZBYC",
    iata: "YCU",
    name: "Yuncheng Yanhu International Airport",
    city: "Yuncheng (Yanhu)",
    country: "CN",
    continent: "AS",
    lat: 35.1164,
    lon: 111.0314,
    elevation: 1242,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBYN": {
    icao: "ZBYN",
    iata: "TYN",
    name: "Taiyuan Wusu International Airport",
    city: "Taiyuan",
    country: "CN",
    continent: "AS",
    lat: 37.7469,
    lon: 112.628,
    elevation: 2575,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZBYZ": {
    icao: "ZBYZ",
    iata: "RLK",
    name: "Bayannur Tianjitai Airport",
    city: "Bavannur",
    country: "CN",
    continent: "AS",
    lat: 40.926,
    lon: 107.7428,
    elevation: 3400,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBZJ": {
    icao: "ZBZJ",
    iata: "ZQZ",
    name: "Zhangjiakou Ningyuan Airport",
    city: "Zhangjiakou",
    country: "CN",
    continent: "AS",
    lat: 40.7386,
    lon: 114.9303,
    elevation: 2347,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZBZL": {
    icao: "ZBZL",
    iata: "NZL",
    name: "Zhalantun Genghis Khan Airport",
    city: "Zhalantun",
    country: "CN",
    continent: "AS",
    lat: 47.8659,
    lon: 122.7687,
    elevation: 928,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGBH": {
    icao: "ZGBH",
    iata: "BHY",
    name: "Beihai Fucheng Airport",
    city: "Beihai (Yinhai)",
    country: "CN",
    continent: "AS",
    lat: 21.5394,
    lon: 109.294,
    elevation: 75,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGBS": {
    icao: "ZGBS",
    iata: "AEB",
    name: "Baise (Bose) Bama Airport",
    city: "Baise (Tianyang)",
    country: "CN",
    continent: "AS",
    lat: 23.7206,
    lon: 106.96,
    elevation: 490,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGCD": {
    icao: "ZGCD",
    iata: "CGD",
    name: "Changde Taohuayuan Airport",
    city: "Changde (Dingcheng)",
    country: "CN",
    continent: "AS",
    lat: 28.9189,
    lon: 111.64,
    elevation: 128,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGCJ": {
    icao: "ZGCJ",
    iata: "HJJ",
    name: "Huaihua Zhijiang Airport",
    city: "Huaihua",
    country: "CN",
    continent: "AS",
    lat: 27.4431,
    lon: 109.7047,
    elevation: 882,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGCZ": {
    icao: "ZGCZ",
    iata: "HCZ",
    name: "Chenzhou Beihu Airport",
    city: "Chenzhou",
    country: "CN",
    continent: "AS",
    lat: 25.7534,
    lon: 112.8454,
    elevation: 1071,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGFS": {
    icao: "ZGFS",
    iata: "FUO",
    name: "Foshan Shadi Airport",
    city: "Foshan (Nanhai)",
    country: "CN",
    continent: "AS",
    lat: 23.0825,
    lon: 113.0708,
    elevation: 6,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGGG": {
    icao: "ZGGG",
    iata: "CAN",
    name: "Guangzhou Baiyun International Airport",
    city: "Guangzhou (Huadu)",
    country: "CN",
    continent: "AS",
    lat: 23.3924,
    lon: 113.299,
    elevation: 50,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZGHA": {
    icao: "ZGHA",
    iata: "CSX",
    name: "Changsha Huanghua International Airport",
    city: "Changsha (Changsha)",
    country: "CN",
    continent: "AS",
    lat: 28.1892,
    lon: 113.22,
    elevation: 217,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZGHC": {
    icao: "ZGHC",
    iata: "HCJ",
    name: "Hechi Jinchengjiang Airport",
    city: "Hechi (Jinchengjiang)",
    country: "CN",
    continent: "AS",
    lat: 24.8043,
    lon: 107.7108,
    elevation: 2221,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGHZ": {
    icao: "ZGHZ",
    iata: "HUZ",
    name: "Huizhou Pingtan Airport",
    city: "Huizhou (Pingtan)",
    country: "CN",
    continent: "AS",
    lat: 23.05,
    lon: 114.6,
    elevation: 50,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGKL": {
    icao: "ZGKL",
    iata: "KWL",
    name: "Guilin Liangjiang International Airport",
    city: "Guilin (Lingui)",
    country: "CN",
    continent: "AS",
    lat: 25.2198,
    lon: 110.0396,
    elevation: 570,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZGLG": {
    icao: "ZGLG",
    iata: "LLF",
    name: "Yongzhou Lingling Airport",
    city: "Yongzhou",
    country: "CN",
    continent: "AS",
    lat: 26.3387,
    lon: 111.61,
    elevation: 340,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGNN": {
    icao: "ZGNN",
    iata: "NNG",
    name: "Nanning Wuxu Airport",
    city: "Nanning (Jiangnan)",
    country: "CN",
    continent: "AS",
    lat: 22.6085,
    lon: 108.1753,
    elevation: 421,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZGOW": {
    icao: "ZGOW",
    iata: "SWA",
    name: "Jieyang Chaoshan International Airport",
    city: "Jieyang (Rongcheng)",
    country: "CN",
    continent: "AS",
    lat: 23.552,
    lon: 116.5033,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGSD": {
    icao: "ZGSD",
    iata: "ZUH",
    name: "Zhuhai Jinwan Airport",
    city: "Zhuhai (Jinwan)",
    country: "CN",
    continent: "AS",
    lat: 22.0064,
    lon: 113.376,
    elevation: 23,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGSY": {
    icao: "ZGSY",
    iata: "WGN",
    name: "Shaoyang Wugang Airport",
    city: "Shaoyang (Wugang)",
    country: "CN",
    continent: "AS",
    lat: 26.8061,
    lon: 110.641,
    elevation: 1444,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGSZ": {
    icao: "ZGSZ",
    iata: "SZX",
    name: "Shenzhen Bao\'an International Airport",
    city: "Shenzhen (Bao\'an)",
    country: "CN",
    continent: "AS",
    lat: 22.6393,
    lon: 113.811,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZGWZ": {
    icao: "ZGWZ",
    iata: "WUZ",
    name: "Wuzhou Xijiang Airport",
    city: "Tangbu",
    country: "CN",
    continent: "AS",
    lat: 23.4032,
    lon: 111.0933,
    elevation: 357,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGYL": {
    icao: "ZGYL",
    iata: "YLX",
    name: "Yulin Fumian Airport",
    city: "Yùlín",
    country: "CN",
    continent: "AS",
    lat: 22.4381,
    lon: 110.1208,
    elevation: 328,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGYY": {
    icao: "ZGYY",
    iata: "YYA",
    name: "Yueyang Sanhe Airport",
    city: "Yueyang (Yueyanglou)",
    country: "CN",
    continent: "AS",
    lat: 29.3117,
    lon: 113.2816,
    elevation: 230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGZH": {
    icao: "ZGZH",
    iata: "LZH",
    name: "Liuzhou Bailian Airport / Bailian Air Base",
    city: "Liuzhou (Liujiang)",
    country: "CN",
    continent: "AS",
    lat: 24.2075,
    lon: 109.391,
    elevation: 295,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZGZJ": {
    icao: "ZGZJ",
    iata: "ZHA",
    name: "Zhanjiang Wuchuan Airport",
    city: "Zhanjiang",
    country: "CN",
    continent: "AS",
    lat: 21.4817,
    lon: 110.5903,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHCC": {
    icao: "ZHCC",
    iata: "CGO",
    name: "Zhengzhou Xinzheng International Airport",
    city: "Zhengzhou",
    country: "CN",
    continent: "AS",
    lat: 34.5265,
    lon: 113.8492,
    elevation: 495,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZHEC": {
    icao: "ZHEC",
    iata: "EHU",
    name: "Ezhou Huahu Airport",
    city: "Ezhou",
    country: "CN",
    continent: "AS",
    lat: 30.3412,
    lon: 115.0393,
    elevation: 86,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZHES": {
    icao: "ZHES",
    iata: "ENH",
    name: "Enshi Xujiaping Airport",
    city: "Enshi (Enshi)",
    country: "CN",
    continent: "AS",
    lat: 30.3203,
    lon: 109.485,
    elevation: 1605,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHGH": {
    icao: "ZHGH",
    iata: "LHK",
    name: "Guangzhou MR Air Base / Guanghua Airport",
    city: "Xiangyang (Laohekou)",
    country: "CN",
    continent: "AS",
    lat: 32.3887,
    lon: 111.6942,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHHH": {
    icao: "ZHHH",
    iata: "WUH",
    name: "Wuhan Tianhe International Airport",
    city: "Wuhan (Huangpi)",
    country: "CN",
    continent: "AS",
    lat: 30.7748,
    lon: 114.2137,
    elevation: 113,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZHJZ": {
    icao: "ZHJZ",
    iata: "SHS",
    name: "Jingzhou Shashi Airport",
    city: "Jingzhou (Shashi)",
    country: "CN",
    continent: "AS",
    lat: 30.2928,
    lon: 112.4485,
    elevation: 95,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHLY": {
    icao: "ZHLY",
    iata: "LYA",
    name: "Luoyang Beijiao Airport",
    city: "Luoyang (Laocheng)",
    country: "CN",
    continent: "AS",
    lat: 34.7411,
    lon: 112.388,
    elevation: 840,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHSN": {
    icao: "ZHSN",
    iata: "HPG",
    name: "Shennongjia Hongping Airport",
    city: "Shennongjia (Hongping)",
    country: "CN",
    continent: "AS",
    lat: 31.626,
    lon: 110.34,
    elevation: 8365,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHSY": {
    icao: "ZHSY",
    iata: "WDS",
    name: "Shiyan Wudangshan Airport",
    city: "Shiyan (Maojian)",
    country: "CN",
    continent: "AS",
    lat: 32.5929,
    lon: 110.9063,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHXF": {
    icao: "ZHXF",
    iata: "XFN",
    name: "Xiangyang Liuji Airport",
    city: "Xiangyang (Xiangzhou)",
    country: "CN",
    continent: "AS",
    lat: 32.1522,
    lon: 112.2917,
    elevation: 234,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHXY": {
    icao: "ZHXY",
    iata: "XAI",
    name: "Xinyang Minggang Airport",
    city: "Xinyang",
    country: "CN",
    continent: "AS",
    lat: 32.5408,
    lon: 114.0791,
    elevation: 312,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZHYC": {
    icao: "ZHYC",
    iata: "YIH",
    name: "Yichang Sanxia Airport",
    city: "Yichang (Xiaoting)",
    country: "CN",
    continent: "AS",
    lat: 30.5541,
    lon: 111.4826,
    elevation: 673,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZJHK": {
    icao: "ZJHK",
    iata: "HAK",
    name: "Haikou Meilan International Airport",
    city: "Haikou (Meilan)",
    country: "CN",
    continent: "AS",
    lat: 19.9349,
    lon: 110.459,
    elevation: 75,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZJQH": {
    icao: "ZJQH",
    iata: "BAR",
    name: "Qionghai Bo\'ao Airport",
    city: "Qionghai (Basuo)",
    country: "CN",
    continent: "AS",
    lat: 19.141,
    lon: 110.4528,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZJSY": {
    icao: "ZJSY",
    iata: "SYX",
    name: "Sanya Phoenix International Airport",
    city: "Sanya (Tianya)",
    country: "CN",
    continent: "AS",
    lat: 18.3029,
    lon: 109.412,
    elevation: 92,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZKHM": {
    icao: "ZKHM",
    iata: "RGO",
    name: "Orang (Chongjin) Airport",
    city: "Hoemun-ri",
    country: "KP",
    continent: "AS",
    lat: 41.4285,
    lon: 129.6476,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZKPY": {
    icao: "ZKPY",
    iata: "FNJ",
    name: "Pyongyang Sunan International Airport",
    city: "Pyongyang",
    country: "KP",
    continent: "AS",
    lat: 39.2241,
    lon: 125.67,
    elevation: 117,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZKSC": {
    icao: "ZKSC",
    iata: "",
    name: "Sunchon Air Base",
    city: "Sunchon",
    country: "KP",
    continent: "AS",
    lat: 39.4125,
    lon: 125.8903,
    elevation: 141,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZKSD": {
    icao: "ZKSD",
    iata: "DSO",
    name: "Sondok Airport",
    city: "Sŏndŏng-ni",
    country: "KP",
    continent: "AS",
    lat: 39.7452,
    lon: 127.474,
    elevation: 12,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZKWS": {
    icao: "ZKWS",
    iata: "WOS",
    name: "Wonsan Kalma International Airport",
    city: "Wonsan",
    country: "KP",
    continent: "AS",
    lat: 39.1668,
    lon: 127.486,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLDH": {
    icao: "ZLDH",
    iata: "DNH",
    name: "Dunhuang Mogao International Airport",
    city: "Dunhuang",
    country: "CN",
    continent: "AS",
    lat: 40.1611,
    lon: 94.8092,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLGL": {
    icao: "ZLGL",
    iata: "GMQ",
    name: "Golog Maqên Airport",
    city: "Golog (Maqên)",
    country: "CN",
    continent: "AS",
    lat: 34.4181,
    lon: 100.3011,
    elevation: 12426,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLGM": {
    icao: "ZLGM",
    iata: "GOQ",
    name: "Golmud Airport",
    city: "Golmud",
    country: "CN",
    continent: "AS",
    lat: 36.4006,
    lon: 94.7861,
    elevation: 9334,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLGY": {
    icao: "ZLGY",
    iata: "GYU",
    name: "Guyuan Liupanshan Airport",
    city: "Guyuan (Yuanzhou)",
    country: "CN",
    continent: "AS",
    lat: 36.0789,
    lon: 106.2169,
    elevation: 5727,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLHX": {
    icao: "ZLHX",
    iata: "HTT",
    name: "Huatugou Airport",
    city: "Mengnai",
    country: "CN",
    continent: "AS",
    lat: 38.2016,
    lon: 90.8378,
    elevation: 2945,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLIC": {
    icao: "ZLIC",
    iata: "INC",
    name: "Yinchuan Hedong International Airport",
    city: "Yinchuan",
    country: "CN",
    continent: "AS",
    lat: 38.3228,
    lon: 106.3932,
    elevation: 3743,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLLL": {
    icao: "ZLLL",
    iata: "LHW",
    name: "Lanzhou Zhongchuan International Airport",
    city: "Lanzhou (Yongdeng)",
    country: "CN",
    continent: "AS",
    lat: 36.5152,
    lon: 103.62,
    elevation: 6388,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZLLN": {
    icao: "ZLLN",
    iata: "LNL",
    name: "Longnan Chengzhou Airport",
    city: "Longnan (Cheng)",
    country: "CN",
    continent: "AS",
    lat: 33.7899,
    lon: 105.79,
    elevation: 3707,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLQY": {
    icao: "ZLQY",
    iata: "IQN",
    name: "Qingyang Xifeng Airport",
    city: "Qingyang (Xifeng)",
    country: "CN",
    continent: "AS",
    lat: 35.8026,
    lon: 107.5989,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLSN": {
    icao: "ZLSN",
    iata: "SIA",
    name: "Xi\'an Xiguan Airport",
    city: "Xi\'an (Baqiao)",
    country: "CN",
    continent: "AS",
    lat: 34.3767,
    lon: 109.12,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLTS": {
    icao: "ZLTS",
    iata: "THQ",
    name: "Tianshui Maijishan Airport",
    city: "Tianshui (Maiji)",
    country: "CN",
    continent: "AS",
    lat: 34.5601,
    lon: 105.8603,
    elevation: 3590,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLXH": {
    icao: "ZLXH",
    iata: "GXH",
    name: "Gannan Xiahe Airport",
    city: "Gannan (Xiahe)",
    country: "CN",
    continent: "AS",
    lat: 34.819,
    lon: 102.6223,
    elevation: 10510,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLXN": {
    icao: "ZLXN",
    iata: "XNN",
    name: "Xining Caojiabao International Airport",
    city: "Haidong (Huzhu Tu Autonomous County)",
    country: "CN",
    continent: "AS",
    lat: 36.5301,
    lon: 102.0401,
    elevation: 7119,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLXY": {
    icao: "ZLXY",
    iata: "XIY",
    name: "Xi\'an Xianyang International Airport",
    city: "Xianyang (Weicheng)",
    country: "CN",
    continent: "AS",
    lat: 34.4471,
    lon: 108.752,
    elevation: 1572,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZLYA": {
    icao: "ZLYA",
    iata: "ENY",
    name: "Yan\'an Nanniwan Airport",
    city: "Yan\'an (Baota)",
    country: "CN",
    continent: "AS",
    lat: 36.4794,
    lon: 109.4641,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLYS": {
    icao: "ZLYS",
    iata: "YUS",
    name: "Yushu Batang Airport",
    city: "Yushu (Batang)",
    country: "CN",
    continent: "AS",
    lat: 32.8364,
    lon: 97.0364,
    elevation: 12816,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZLZW": {
    icao: "ZLZW",
    iata: "ZHY",
    name: "Zhongwei Shapotou Airport",
    city: "Zhongwei (Shapotou)",
    country: "CN",
    continent: "AS",
    lat: 37.5731,
    lon: 105.1545,
    elevation: 4088,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMAH": {
    icao: "ZMAH",
    iata: "AVK",
    name: "Arvaikheer Airport",
    city: "Arvaikheer",
    country: "MN",
    continent: "AS",
    lat: 46.2503,
    lon: 102.802,
    elevation: 5932,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMAT": {
    icao: "ZMAT",
    iata: "LTI",
    name: "Altai Airport",
    city: "Altai",
    country: "MN",
    continent: "AS",
    lat: 46.3764,
    lon: 96.2211,
    elevation: 7260,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMBH": {
    icao: "ZMBH",
    iata: "BYN",
    name: "Bayankhongor Airport",
    city: "Bayankhongor",
    country: "MN",
    continent: "AS",
    lat: 46.1633,
    lon: 100.704,
    elevation: 6085,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMBN": {
    icao: "ZMBN",
    iata: "UGA",
    name: "Bulgan Airport",
    city: "Bulgan",
    country: "MN",
    continent: "AS",
    lat: 48.855,
    lon: 103.476,
    elevation: 4311,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMBU": {
    icao: "ZMBU",
    iata: "UUN",
    name: "Baruun Urt Airport",
    city: "",
    country: "MN",
    continent: "AS",
    lat: 46.6603,
    lon: 113.285,
    elevation: 3205,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMCD": {
    icao: "ZMCD",
    iata: "COQ",
    name: "Choibalsan Airport",
    city: "",
    country: "MN",
    continent: "AS",
    lat: 48.1357,
    lon: 114.646,
    elevation: 2457,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMCK": {
    icao: "ZMCK",
    iata: "UBN",
    name: "Ulaanbaatar Chinggis Khaan International Airport",
    city: "Ulaanbaatar (Sergelen)",
    country: "MN",
    continent: "AS",
    lat: 47.6469,
    lon: 106.8198,
    elevation: 4482,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZMDZ": {
    icao: "ZMDZ",
    iata: "DLZ",
    name: "Dalanzadgad Airport",
    city: "Dalanzadgad",
    country: "MN",
    continent: "AS",
    lat: 43.6086,
    lon: 104.3677,
    elevation: 4787,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMKD": {
    icao: "ZMKD",
    iata: "HVD",
    name: "Khovd Airport",
    city: "Khovd",
    country: "MN",
    continent: "AS",
    lat: 47.9541,
    lon: 91.6282,
    elevation: 4898,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMMN": {
    icao: "ZMMN",
    iata: "MXV",
    name: "Mörön Airport",
    city: "Mörön",
    country: "MN",
    continent: "AS",
    lat: 49.6633,
    lon: 100.099,
    elevation: 4272,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZMUB": {
    icao: "ZMUB",
    iata: "ULN",
    name: "Buyant-Ukhaa International Airport",
    city: "Ulaanbaatar",
    country: "MN",
    continent: "AS",
    lat: 47.8431,
    lon: 106.767,
    elevation: 4364,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPBS": {
    icao: "ZPBS",
    iata: "BSD",
    name: "Baoshan Yunrui Airport",
    city: "Baoshan (Longyang)",
    country: "CN",
    continent: "AS",
    lat: 25.0533,
    lon: 99.1683,
    elevation: 5453,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPCW": {
    icao: "ZPCW",
    iata: "CWJ",
    name: "Cangyuan Washan Airport",
    city: "Lincang (Cangyuan)",
    country: "CN",
    continent: "AS",
    lat: 23.2763,
    lon: 99.3732,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPDL": {
    icao: "ZPDL",
    iata: "DLU",
    name: "Dali Fengyi Airport",
    city: "Dali (Xiaguan)",
    country: "CN",
    continent: "AS",
    lat: 25.6494,
    lon: 100.319,
    elevation: 7050,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPDQ": {
    icao: "ZPDQ",
    iata: "DIG",
    name: "Diqing Shangri-La Airport",
    city: "Diqing (Shangri-La)",
    country: "CN",
    continent: "AS",
    lat: 27.7936,
    lon: 99.6772,
    elevation: 10761,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPJH": {
    icao: "ZPJH",
    iata: "JHG",
    name: "Xishuangbanna Gasa International Airport",
    city: "Jinghong (Gasa)",
    country: "CN",
    continent: "AS",
    lat: 21.9746,
    lon: 100.7622,
    elevation: 1815,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPJM": {
    icao: "ZPJM",
    iata: "JMJ",
    name: "Lancang Jingmai Airport",
    city: "Pu\'er (Lancang)",
    country: "CN",
    continent: "AS",
    lat: 22.4177,
    lon: 99.784,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPLC": {
    icao: "ZPLC",
    iata: "LNJ",
    name: "Lincang Boshang Airport",
    city: "Lincang",
    country: "CN",
    continent: "AS",
    lat: 23.7381,
    lon: 100.025,
    elevation: 6230,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPLJ": {
    icao: "ZPLJ",
    iata: "LJG",
    name: "Lijiang Sanyi International Airport",
    city: "Lijiang (Gucheng)",
    country: "CN",
    continent: "AS",
    lat: 26.68,
    lon: 100.246,
    elevation: 7359,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPMS": {
    icao: "ZPMS",
    iata: "LUM",
    name: "Dehong Mangshi Airport",
    city: "Dehong (Mangshi)",
    country: "CN",
    continent: "AS",
    lat: 24.4011,
    lon: 98.5317,
    elevation: 2890,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZPPP": {
    icao: "ZPPP",
    iata: "KMG",
    name: "Kunming Changshui International Airport",
    city: "Kunming",
    country: "CN",
    continent: "AS",
    lat: 25.1103,
    lon: 102.9367,
    elevation: 6903,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZPYM": {
    icao: "ZPYM",
    iata: "YUA",
    name: "Yuanmou Air Base",
    city: "Chuxiong (Yuanmou)",
    country: "CN",
    continent: "AS",
    lat: 25.7375,
    lon: 101.882,
    elevation: 3810,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSAM": {
    icao: "ZSAM",
    iata: "XMN",
    name: "Xiamen Gaoqi International Airport",
    city: "Xiamen",
    country: "CN",
    continent: "AS",
    lat: 24.544,
    lon: 118.128,
    elevation: 59,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSAQ": {
    icao: "ZSAQ",
    iata: "AQG",
    name: "Anqing Tianzhushan Airport / Anqing North Air Base",
    city: "Anqing",
    country: "CN",
    continent: "AS",
    lat: 30.5822,
    lon: 117.05,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSBB": {
    icao: "ZSBB",
    iata: "BFU",
    name: "Bengbu Tenghu Airport",
    city: "Bengbu",
    country: "CN",
    continent: "AS",
    lat: 32.8477,
    lon: 117.3202,
    elevation: 100,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSCG": {
    icao: "ZSCG",
    iata: "CZX",
    name: "Changzhou Benniu International Airport",
    city: "Changzhou",
    country: "CN",
    continent: "AS",
    lat: 31.9205,
    lon: 119.7755,
    elevation: 33,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSCN": {
    icao: "ZSCN",
    iata: "KHN",
    name: "Nanchang Changbei International Airport",
    city: "Nanchang",
    country: "CN",
    continent: "AS",
    lat: 28.8648,
    lon: 115.9027,
    elevation: 143,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSDY": {
    icao: "ZSDY",
    iata: "DOY",
    name: "Dongying Shengli Airport",
    city: "Dongying (Kenli)",
    country: "CN",
    continent: "AS",
    lat: 37.5014,
    lon: 118.7899,
    elevation: 15,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSFY": {
    icao: "ZSFY",
    iata: "FUG",
    name: "Fuyang Xiguan Airport",
    city: "Yingzhou, Fuyang",
    country: "CN",
    continent: "AS",
    lat: 32.8822,
    lon: 115.7344,
    elevation: 104,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSFZ": {
    icao: "ZSFZ",
    iata: "FOC",
    name: "Fuzhou Changle International Airport",
    city: "Fuzhou (Changle)",
    country: "CN",
    continent: "AS",
    lat: 25.9347,
    lon: 119.6632,
    elevation: 46,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSHC": {
    icao: "ZSHC",
    iata: "HGH",
    name: "Hangzhou Xiaoshan International Airport",
    city: "Hangzhou",
    country: "CN",
    continent: "AS",
    lat: 30.2361,
    lon: 120.4289,
    elevation: 23,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSHZ": {
    icao: "ZSHZ",
    iata: "HZA",
    name: "Heze Mudan Airport",
    city: "Heze (Dingtao)",
    country: "CN",
    continent: "AS",
    lat: 35.213,
    lon: 115.7367,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSJD": {
    icao: "ZSJD",
    iata: "JDZ",
    name: "Jingdezhen Luojia Airport",
    city: "Jingdezhen",
    country: "CN",
    continent: "AS",
    lat: 29.3386,
    lon: 117.176,
    elevation: 112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSJG": {
    icao: "ZSJG",
    iata: "JNG",
    name: "Jining Da\'an Airport",
    city: "Jining",
    country: "CN",
    continent: "AS",
    lat: 35.6474,
    lon: 116.7433,
    elevation: 171,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSJN": {
    icao: "ZSJN",
    iata: "TNA",
    name: "Jinan Yaoqiang International Airport",
    city: "Jinan (Licheng)",
    country: "CN",
    continent: "AS",
    lat: 36.8572,
    lon: 117.216,
    elevation: 76,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSJU": {
    icao: "ZSJU",
    iata: "JUZ",
    name: "Quzhou Airport",
    city: "Quzhou (Kezheng)",
    country: "CN",
    continent: "AS",
    lat: 28.9661,
    lon: 118.8988,
    elevation: 213,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSLG": {
    icao: "ZSLG",
    iata: "LYG",
    name: "Lianyungang Huaguoshan International Airport",
    city: "Lianyungang",
    country: "CN",
    continent: "AS",
    lat: 34.4141,
    lon: 119.179,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSLO": {
    icao: "ZSLO",
    iata: "LCX",
    name: "Liancheng Guanzhishan Airport",
    city: "Longyan (Liancheng)",
    country: "CN",
    continent: "AS",
    lat: 25.6759,
    lon: 116.7459,
    elevation: 1225,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSLQ": {
    icao: "ZSLQ",
    iata: "HYN",
    name: "Taizhou Luqiao Airport",
    city: "Taizhou (Luqiao)",
    country: "CN",
    continent: "AS",
    lat: 28.5622,
    lon: 121.429,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSLY": {
    icao: "ZSLY",
    iata: "LYI",
    name: "Linyi Qiyang Airport",
    city: "Linyi (Hedong)",
    country: "CN",
    continent: "AS",
    lat: 35.0529,
    lon: 118.4118,
    elevation: 177,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSNB": {
    icao: "ZSNB",
    iata: "NGB",
    name: "Ningbo Lishe International Airport",
    city: "Ningbo",
    country: "CN",
    continent: "AS",
    lat: 29.8267,
    lon: 121.462,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSNJ": {
    icao: "ZSNJ",
    iata: "NKG",
    name: "Nanjing Lukou International Airport",
    city: "Nanjing",
    country: "CN",
    continent: "AS",
    lat: 31.735,
    lon: 118.8659,
    elevation: 49,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSNT": {
    icao: "ZSNT",
    iata: "NTG",
    name: "Nantong Xingdong International Airport",
    city: "Nantong (Tongzhou)",
    country: "CN",
    continent: "AS",
    lat: 32.0736,
    lon: 120.9801,
    elevation: 16,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSOF": {
    icao: "ZSOF",
    iata: "HFE",
    name: "Hefei Xinqiao International Airport",
    city: "Hefei",
    country: "CN",
    continent: "AS",
    lat: 31.9878,
    lon: 116.9769,
    elevation: 207,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSPD": {
    icao: "ZSPD",
    iata: "PVG",
    name: "Shanghai Pudong International Airport",
    city: "Shanghai (Pudong)",
    country: "CN",
    continent: "AS",
    lat: 31.1434,
    lon: 121.805,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSQD": {
    icao: "ZSQD",
    iata: "TAO",
    name: "Qingdao Jiaodong International Airport",
    city: "Qingdao (Jiaozhou)",
    country: "CN",
    continent: "AS",
    lat: 36.362,
    lon: 120.0882,
    elevation: 30,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSQZ": {
    icao: "ZSQZ",
    iata: "JJN",
    name: "Quanzhou Jinjiang International Airport",
    city: "Quanzhou",
    country: "CN",
    continent: "AS",
    lat: 24.7966,
    lon: 118.5889,
    elevation: 39,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSRG": {
    icao: "ZSRG",
    iata: "RUG",
    name: "Rugao Air Base",
    city: "Rugao (Nantong)",
    country: "CN",
    continent: "AS",
    lat: 32.2583,
    lon: 120.5011,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSRZ": {
    icao: "ZSRZ",
    iata: "RIZ",
    name: "Rizhao Shanzihe Airport",
    city: "Rizhao (Donggang)",
    country: "CN",
    continent: "AS",
    lat: 35.405,
    lon: 119.3244,
    elevation: 121,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSSH": {
    icao: "ZSSH",
    iata: "HIA",
    name: "Huai\'an Lianshui International Airport",
    city: "Huai\'an",
    country: "CN",
    continent: "AS",
    lat: 33.7908,
    lon: 119.125,
    elevation: 28,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSSM": {
    icao: "ZSSM",
    iata: "SQJ",
    name: "Sanming Shaxian Airport",
    city: "Sanming (Sha)",
    country: "CN",
    continent: "AS",
    lat: 26.4263,
    lon: 117.8336,
    elevation: 830,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSSR": {
    icao: "ZSSR",
    iata: "SQD",
    name: "Shangrao Sanqingshan Airport",
    city: "Shangrao (Hengfeng)",
    country: "CN",
    continent: "AS",
    lat: 28.3797,
    lon: 117.9643,
    elevation: 340,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSSS": {
    icao: "ZSSS",
    iata: "SHA",
    name: "Shanghai Hongqiao International Airport",
    city: "Shanghai (Minhang)",
    country: "CN",
    continent: "AS",
    lat: 31.1981,
    lon: 121.3343,
    elevation: 10,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSSZ": {
    icao: "ZSSZ",
    iata: "SZV",
    name: "Suzhou Guangfu Airport",
    city: "Suzhou",
    country: "CN",
    continent: "AS",
    lat: 31.2631,
    lon: 120.401,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSTX": {
    icao: "ZSTX",
    iata: "TXN",
    name: "Tunxi International Airport",
    city: "Huangshan",
    country: "CN",
    continent: "AS",
    lat: 29.7333,
    lon: 118.256,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSWA": {
    icao: "ZSWA",
    iata: "WHA",
    name: "Wuhu Xuanzhou Airport",
    city: "Wuhu",
    country: "CN",
    continent: "AS",
    lat: 31.1045,
    lon: 118.6669,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSWF": {
    icao: "ZSWF",
    iata: "WEF",
    name: "Weifang Nanyuan Airport",
    city: "Weifang (Kuiwen)",
    country: "CN",
    continent: "AS",
    lat: 36.6467,
    lon: 119.119,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSWH": {
    icao: "ZSWH",
    iata: "WEH",
    name: "Weihai Dashuibo Airport",
    city: "Weihai",
    country: "CN",
    continent: "AS",
    lat: 37.1871,
    lon: 122.229,
    elevation: 145,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSWX": {
    icao: "ZSWX",
    iata: "WUX",
    name: "Sunan Shuofang International Airport",
    city: "Wuxi",
    country: "CN",
    continent: "AS",
    lat: 31.4944,
    lon: 120.429,
    elevation: 24,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSWY": {
    icao: "ZSWY",
    iata: "WUS",
    name: "Nanping Wuyishan Airport",
    city: "Wuyishan",
    country: "CN",
    continent: "AS",
    lat: 27.7019,
    lon: 118.001,
    elevation: 614,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSWZ": {
    icao: "ZSWZ",
    iata: "WNZ",
    name: "Wenzhou Longwan International Airport",
    city: "Wenzhou (Longwan)",
    country: "CN",
    continent: "AS",
    lat: 27.9106,
    lon: 120.8535,
    elevation: 13,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSXZ": {
    icao: "ZSXZ",
    iata: "XUZ",
    name: "Xuzhou Guanyin International Airport",
    city: "Xuzhou",
    country: "CN",
    continent: "AS",
    lat: 34.0591,
    lon: 117.5553,
    elevation: 108,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSYA": {
    icao: "ZSYA",
    iata: "YTY",
    name: "Yangzhou Taizhou Airport",
    city: "Yangzhou",
    country: "CN",
    continent: "AS",
    lat: 32.5634,
    lon: 119.7198,
    elevation: 7,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSYC": {
    icao: "ZSYC",
    iata: "YIC",
    name: "Yichun Mingyueshan Airport",
    city: "Yichun",
    country: "CN",
    continent: "AS",
    lat: 27.8025,
    lon: 114.3062,
    elevation: 430,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSYN": {
    icao: "ZSYN",
    iata: "YNZ",
    name: "Yancheng Nanyang International Airport",
    city: "Yancheng (Tinghu)",
    country: "CN",
    continent: "AS",
    lat: 33.4258,
    lon: 120.2031,
    elevation: 10,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSYT": {
    icao: "ZSYT",
    iata: "YNT",
    name: "Yantai Penglai International Airport",
    city: "Yantai",
    country: "CN",
    continent: "AS",
    lat: 37.6597,
    lon: 120.9781,
    elevation: 154,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZSYW": {
    icao: "ZSYW",
    iata: "YIW",
    name: "Yiwu Airport",
    city: "Jinhua (Yiwu)",
    country: "CN",
    continent: "AS",
    lat: 29.3421,
    lon: 120.0312,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZSZS": {
    icao: "ZSZS",
    iata: "HSN",
    name: "Zhoushan Putuoshan Airport",
    city: "Zhoushan",
    country: "CN",
    continent: "AS",
    lat: 29.9342,
    lon: 122.362,
    elevation: 3,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUAL": {
    icao: "ZUAL",
    iata: "NGQ",
    name: "Ngari Gunsa Airport",
    city: "Shiquanhe",
    country: "CN",
    continent: "AS",
    lat: 32.0979,
    lon: 80.054,
    elevation: 14022,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUAS": {
    icao: "ZUAS",
    iata: "AVA",
    name: "Anshun Huangguoshu Airport",
    city: "Anshun (Xixiu)",
    country: "CN",
    continent: "AS",
    lat: 26.2606,
    lon: 105.8733,
    elevation: 4812,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUBD": {
    icao: "ZUBD",
    iata: "BPX",
    name: "Qamdo Bangda Airport",
    city: "Bangda",
    country: "CN",
    continent: "AS",
    lat: 30.5536,
    lon: 97.1083,
    elevation: 14219,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUBJ": {
    icao: "ZUBJ",
    iata: "BFJ",
    name: "Bijie Feixiong Airport",
    city: "Bijie",
    country: "CN",
    continent: "AS",
    lat: 27.2671,
    lon: 105.4721,
    elevation: 4751,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUCK": {
    icao: "ZUCK",
    iata: "CKG",
    name: "Chongqing Jiangbei International Airport",
    city: "Chongqing",
    country: "CN",
    continent: "AS",
    lat: 29.7123,
    lon: 106.6519,
    elevation: 1365,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZUDA": {
    icao: "ZUDA",
    iata: "DZH",
    name: "Dazhou Jinya Airport",
    city: "Dazhou (Dachuan)",
    country: "CN",
    continent: "AS",
    lat: 31.0488,
    lon: 107.4356,
    elevation: 1342,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUDC": {
    icao: "ZUDC",
    iata: "DCY",
    name: "Daocheng Yading Airport",
    city: "Garzê (Daocheng)",
    country: "CN",
    continent: "AS",
    lat: 29.3163,
    lon: 100.0603,
    elevation: 14472,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUDJ": {
    icao: "ZUDJ",
    iata: "DEJ",
    name: "Tongren Dejiang Airport (Under Construction)",
    city: "Tongren",
    country: "CN",
    continent: "AS",
    lat: 28.121,
    lon: 108.1631,
    elevation: 3542,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUGU": {
    icao: "ZUGU",
    iata: "GYS",
    name: "Guangyuan Panlong Airport",
    city: "Guangyuan (Lizhou)",
    country: "CN",
    continent: "AS",
    lat: 32.3903,
    lon: 105.6946,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUGY": {
    icao: "ZUGY",
    iata: "KWE",
    name: "Guiyang Longdongbao International Airport",
    city: "Guiyang (Nanming)",
    country: "CN",
    continent: "AS",
    lat: 26.5415,
    lon: 106.8033,
    elevation: 3736,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZUHY": {
    icao: "ZUHY",
    iata: "AHJ",
    name: "Hongyuan Airport",
    city: "Ngawa (Hongyuan)",
    country: "CN",
    continent: "AS",
    lat: 32.5315,
    lon: 102.3522,
    elevation: 11600,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUJZ": {
    icao: "ZUJZ",
    iata: "JZH",
    name: "Jiuzhai Huanglong Airport",
    city: "Ngawa (Songpan)",
    country: "CN",
    continent: "AS",
    lat: 32.8533,
    lon: 103.6822,
    elevation: 11327,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUKD": {
    icao: "ZUKD",
    iata: "KGT",
    name: "Kangding Airport",
    city: "Garzê (Kangding)",
    country: "CN",
    continent: "AS",
    lat: 30.1425,
    lon: 101.7387,
    elevation: 14042,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUKJ": {
    icao: "ZUKJ",
    iata: "KJH",
    name: "Kaili Huangping Airport",
    city: "Kaili  (Huangping)",
    country: "CN",
    continent: "AS",
    lat: 26.972,
    lon: 107.988,
    elevation: 3115,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZULS": {
    icao: "ZULS",
    iata: "LXA",
    name: "Lhasa Gonggar Airport",
    city: "Shannan (Gonggar)",
    country: "CN",
    continent: "AS",
    lat: 29.298,
    lon: 90.912,
    elevation: 11713,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZULZ": {
    icao: "ZULZ",
    iata: "LZO",
    name: "Luzhou Yunlong Airport",
    city: "Luzhou (Yunlong)",
    country: "CN",
    continent: "AS",
    lat: 29.0304,
    lon: 105.4684,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUMT": {
    icao: "ZUMT",
    iata: "WMT",
    name: "Zunyi Maotai Airport",
    city: "Zunyi",
    country: "CN",
    continent: "AS",
    lat: 27.9618,
    lon: 106.4354,
    elevation: 4068,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUMY": {
    icao: "ZUMY",
    iata: "MIG",
    name: "Mianyang Nanjiao Airport",
    city: "Mianyang (Fucheng)",
    country: "CN",
    continent: "AS",
    lat: 31.4281,
    lon: 104.741,
    elevation: 7874,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUNP": {
    icao: "ZUNP",
    iata: "HZH",
    name: "Liping Airport",
    city: "Liping",
    country: "CN",
    continent: "AS",
    lat: 26.3222,
    lon: 109.1499,
    elevation: 1620,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUNZ": {
    icao: "ZUNZ",
    iata: "LZY",
    name: "Nyingchi Mainling Airport",
    city: "Nyingchi (Mainling)",
    country: "CN",
    continent: "AS",
    lat: 29.3033,
    lon: 94.3353,
    elevation: 9675,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUPS": {
    icao: "ZUPS",
    iata: "LPF",
    name: "Liupanshui Yuezhao Airport",
    city: "Liupanshui (Zhongshan)",
    country: "CN",
    continent: "AS",
    lat: 26.6094,
    lon: 104.979,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUQJ": {
    icao: "ZUQJ",
    iata: "JIQ",
    name: "Qianjiang Wulingshan Airport",
    city: "Qianjiang",
    country: "CN",
    continent: "AS",
    lat: 29.5133,
    lon: 108.8311,
    elevation: 2075,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZURK": {
    icao: "ZURK",
    iata: "RKZ",
    name: "Xigaze Peace Airport / Shigatse Air Base",
    city: "Xigazê (Samzhubzê)",
    country: "CN",
    continent: "AS",
    lat: 29.3519,
    lon: 89.3114,
    elevation: 3782,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUTC": {
    icao: "ZUTC",
    iata: "TCZ",
    name: "Tengchong Tuofeng Airport",
    city: "Baoshan (Tengchong)",
    country: "CN",
    continent: "AS",
    lat: 24.9381,
    lon: 98.4858,
    elevation: 6250,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUTF": {
    icao: "ZUTF",
    iata: "TFU",
    name: "Chengdu Tianfu International Airport",
    city: "Chengdu (Jianyang)",
    country: "CN",
    continent: "AS",
    lat: 30.3125,
    lon: 104.4413,
    elevation: 1440,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZUTR": {
    icao: "ZUTR",
    iata: "TEN",
    name: "Tongren Fenghuang Airport",
    city: "Tongren (Daxing)",
    country: "CN",
    continent: "AS",
    lat: 27.8833,
    lon: 109.3089,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUUU": {
    icao: "ZUUU",
    iata: "CTU",
    name: "Chengdu Shuangliu International Airport",
    city: "Chengdu (Shuangliu)",
    country: "CN",
    continent: "AS",
    lat: 30.5583,
    lon: 103.946,
    elevation: 1625,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZUWL": {
    icao: "ZUWL",
    iata: "CQW",
    name: "Chongqing Xiannüshan Airport",
    city: "Wulong",
    country: "CN",
    continent: "AS",
    lat: 29.4657,
    lon: 107.6937,
    elevation: 1747,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUXC": {
    icao: "ZUXC",
    iata: "XIC",
    name: "Xichang Qingshan Airport",
    city: "Liangshan (Xichang)",
    country: "CN",
    continent: "AS",
    lat: 27.9891,
    lon: 102.184,
    elevation: 5112,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUYB": {
    icao: "ZUYB",
    iata: "YBP",
    name: "Yibin Wuliangye Airport",
    city: "Yibin (Cuiping)",
    country: "CN",
    continent: "AS",
    lat: 28.8584,
    lon: 104.5262,
    elevation: 1378,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUYI": {
    icao: "ZUYI",
    iata: "ACX",
    name: "Xingyi Wanfenglin Airport",
    city: "Xingyi",
    country: "CN",
    continent: "AS",
    lat: 25.0834,
    lon: 104.9608,
    elevation: 4150,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUZH": {
    icao: "ZUZH",
    iata: "PZI",
    name: "Panzhihua Bao\'anying Airport",
    city: "Panzhihua (Renhe)",
    country: "CN",
    continent: "AS",
    lat: 26.54,
    lon: 101.7985,
    elevation: 1620,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZUZY": {
    icao: "ZUZY",
    iata: "ZYI",
    name: "Zunyi Xinzhou Airport",
    city: "Zunyi",
    country: "CN",
    continent: "AS",
    lat: 27.8107,
    lon: 107.2472,
    elevation: 2723,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWAK": {
    icao: "ZWAK",
    iata: "AKU",
    name: "Aksu Hongqipo Airport",
    city: "Aksu (Onsu)",
    country: "CN",
    continent: "AS",
    lat: 41.2625,
    lon: 80.2917,
    elevation: 3816,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWAT": {
    icao: "ZWAT",
    iata: "AAT",
    name: "Altay Xuedu Airport",
    city: "Altay",
    country: "CN",
    continent: "AS",
    lat: 47.7499,
    lon: 88.0858,
    elevation: 2460,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWBL": {
    icao: "ZWBL",
    iata: "BPL",
    name: "Bole Alashankou Airport",
    city: "Bole",
    country: "CN",
    continent: "AS",
    lat: 44.8955,
    lon: 82.3001,
    elevation: 1253,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWCM": {
    icao: "ZWCM",
    iata: "IQM",
    name: "Qiemo Yudu Airport",
    city: "Qiemo",
    country: "CN",
    continent: "AS",
    lat: 38.2345,
    lon: 85.4655,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWFY": {
    icao: "ZWFY",
    iata: "FYN",
    name: "Fuyun Koktokay Airport",
    city: "Fuyun",
    country: "CN",
    continent: "AS",
    lat: 46.8042,
    lon: 89.512,
    elevation: 3081,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWHM": {
    icao: "ZWHM",
    iata: "HMI",
    name: "Hami Airport",
    city: "Hami",
    country: "CN",
    continent: "AS",
    lat: 42.8414,
    lon: 93.6692,
    elevation: 2703,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWKL": {
    icao: "ZWKL",
    iata: "KRL",
    name: "Korla Licheng Airport",
    city: "Korla",
    country: "CN",
    continent: "AS",
    lat: 41.615,
    lon: 86.1408,
    elevation: 3041,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWKN": {
    icao: "ZWKN",
    iata: "KJI",
    name: "Burqin Kanas Airport",
    city: "Burqin",
    country: "CN",
    continent: "AS",
    lat: 48.2223,
    lon: 86.9959,
    elevation: 3921,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWNL": {
    icao: "ZWNL",
    iata: "NLT",
    name: "Xinyuan Nalati Airport",
    city: "Xinyuan",
    country: "CN",
    continent: "AS",
    lat: 43.4318,
    lon: 83.3786,
    elevation: 3050,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWRQ": {
    icao: "ZWRQ",
    iata: "RQA",
    name: "Ruoqiang Loulan Airport",
    city: "Ruoqiang Town",
    country: "CN",
    continent: "AS",
    lat: 38.9747,
    lon: 88.0083,
    elevation: 2916,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWSC": {
    icao: "ZWSC",
    iata: "QSZ",
    name: "Shache Airport",
    city: "Shache",
    country: "CN",
    continent: "AS",
    lat: 38.2454,
    lon: 77.0561,
    elevation: 4232,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWSH": {
    icao: "ZWSH",
    iata: "KHG",
    name: "Kashgar Laining International Airport",
    city: "Kashgar",
    country: "CN",
    continent: "AS",
    lat: 39.5429,
    lon: 76.02,
    elevation: 4529,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWSS": {
    icao: "ZWSS",
    iata: "SXJ",
    name: "Shanshan Airport",
    city: "Shanshan",
    country: "CN",
    continent: "AS",
    lat: 42.9117,
    lon: 90.2475,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWTL": {
    icao: "ZWTL",
    iata: "TLQ",
    name: "Turpan Jiaohe Airport",
    city: "Turpan",
    country: "CN",
    continent: "AS",
    lat: 43.0308,
    lon: 89.0987,
    elevation: 934,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWTN": {
    icao: "ZWTN",
    iata: "HTN",
    name: "Hotan Airport",
    city: "Hotan",
    country: "CN",
    continent: "AS",
    lat: 37.0385,
    lon: 79.8649,
    elevation: 4672,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZWWW": {
    icao: "ZWWW",
    iata: "URC",
    name: "Ürümqi Tianshan International Airport",
    city: "Ürümqi",
    country: "CN",
    continent: "AS",
    lat: 43.9071,
    lon: 87.4742,
    elevation: 2125,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZYAS": {
    icao: "ZYAS",
    iata: "AOG",
    name: "Anshan Teng\'ao Airport / Anshan Air Base",
    city: "Anshan",
    country: "CN",
    continent: "AS",
    lat: 41.1053,
    lon: 122.854,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYBA": {
    icao: "ZYBA",
    iata: "DBC",
    name: "Baicheng Chang\'an Airport",
    city: "Baicheng",
    country: "CN",
    continent: "AS",
    lat: 45.5053,
    lon: 123.0197,
    elevation: 480,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYBS": {
    icao: "ZYBS",
    iata: "NBS",
    name: "Changbaishan Airport",
    city: "Baishan",
    country: "CN",
    continent: "AS",
    lat: 42.0669,
    lon: 127.6022,
    elevation: 2874,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYCC": {
    icao: "ZYCC",
    iata: "CGQ",
    name: "Changchun Longjia International Airport",
    city: "Changchun",
    country: "CN",
    continent: "AS",
    lat: 43.9962,
    lon: 125.685,
    elevation: 706,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZYCH": {
    icao: "ZYCH",
    iata: "CNI",
    name: "Changhai Airport",
    city: "Dalian (Changhai)",
    country: "CN",
    continent: "AS",
    lat: 39.2667,
    lon: 122.6669,
    elevation: 80,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYCY": {
    icao: "ZYCY",
    iata: "CHG",
    name: "Chaoyang Airport",
    city: "Shuangta, Chaoyang",
    country: "CN",
    continent: "AS",
    lat: 41.5381,
    lon: 120.435,
    elevation: 568,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYDD": {
    icao: "ZYDD",
    iata: "DDG",
    name: "Dandong Langtou Airport",
    city: "Dandong (Zhenxing)",
    country: "CN",
    continent: "AS",
    lat: 40.0255,
    lon: 124.2867,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYDU": {
    icao: "ZYDU",
    iata: "DTU",
    name: "Wudalianchi Dedu Airport",
    city: "Heihe",
    country: "CN",
    continent: "AS",
    lat: 48.441,
    lon: 126.1284,
    elevation: 984,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYFY": {
    icao: "ZYFY",
    iata: "FYJ",
    name: "Fuyuan Dongji Airport",
    city: "Fuyuan",
    country: "CN",
    continent: "AS",
    lat: 48.1972,
    lon: 134.363,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYHB": {
    icao: "ZYHB",
    iata: "HRB",
    name: "Harbin Taiping International Airport",
    city: "Harbin",
    country: "CN",
    continent: "AS",
    lat: 45.6234,
    lon: 126.25,
    elevation: 457,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZYHE": {
    icao: "ZYHE",
    iata: "HEK",
    name: "Heihe Aihui Airport",
    city: "Heihe",
    country: "CN",
    continent: "AS",
    lat: 50.1716,
    lon: 127.3089,
    elevation: 1047,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYJD": {
    icao: "ZYJD",
    iata: "JGD",
    name: "Daxing\'anling Elunchun Airport",
    city: "Jiagedaqi",
    country: "CN",
    continent: "AS",
    lat: 50.3714,
    lon: 124.1175,
    elevation: 1205,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYJM": {
    icao: "ZYJM",
    iata: "JMU",
    name: "Jiamusi Dongjiao Airport",
    city: "Jiamusi",
    country: "CN",
    continent: "AS",
    lat: 46.8434,
    lon: 130.465,
    elevation: 262,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYJS": {
    icao: "ZYJS",
    iata: "JSJ",
    name: "Jiansanjiang Shidi Airport",
    city: "Jiansanjiang",
    country: "CN",
    continent: "AS",
    lat: 47.1082,
    lon: 132.6579,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYJX": {
    icao: "ZYJX",
    iata: "JXA",
    name: "Jixi Xingkaihu Airport",
    city: "Jixi",
    country: "CN",
    continent: "AS",
    lat: 45.293,
    lon: 131.193,
    elevation: 760,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYJZ": {
    icao: "ZYJZ",
    iata: "JNZ",
    name: "Jinzhou Bay Airport",
    city: "Jinzhou (Linghai)",
    country: "CN",
    continent: "AS",
    lat: 40.936,
    lon: 121.2771,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYLD": {
    icao: "ZYLD",
    iata: "LDS",
    name: "Yichun Lindu Airport",
    city: "Yichun",
    country: "CN",
    continent: "AS",
    lat: 47.7521,
    lon: 129.0191,
    elevation: 791,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYMD": {
    icao: "ZYMD",
    iata: "MDG",
    name: "Mudanjiang Hailang International Airport",
    city: "Mudanjiang",
    country: "CN",
    continent: "AS",
    lat: 44.5252,
    lon: 129.5686,
    elevation: 883,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYMH": {
    icao: "ZYMH",
    iata: "OHE",
    name: "Mohe Gulian Airport",
    city: "Mohe",
    country: "CN",
    continent: "AS",
    lat: 52.9169,
    lon: 122.4228,
    elevation: 1836,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYQQ": {
    icao: "ZYQQ",
    iata: "NDG",
    name: "Qiqihar Sanjiazi Airport",
    city: "Qiqihar",
    country: "CN",
    continent: "AS",
    lat: 47.2396,
    lon: 123.918,
    elevation: 477,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYSQ": {
    icao: "ZYSQ",
    iata: "YSQ",
    name: "Songyuan Chaganhu Airport",
    city: "Qian Gorlos Mongol Autonomous County",
    country: "CN",
    continent: "AS",
    lat: 44.9311,
    lon: 124.5521,
    elevation: 459,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYTL": {
    icao: "ZYTL",
    iata: "DLC",
    name: "Dalian Zhoushuizi International Airport",
    city: "Dalian (Ganjingzi)",
    country: "CN",
    continent: "AS",
    lat: 38.9657,
    lon: 121.5385,
    elevation: 107,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZYTN": {
    icao: "ZYTN",
    iata: "TNH",
    name: "Tonghua Sanyuanpu Airport",
    city: "Tonghua",
    country: "CN",
    continent: "AS",
    lat: 42.0484,
    lon: 125.734,
    elevation: 1347,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYTX": {
    icao: "ZYTX",
    iata: "SHE",
    name: "Shenyang Taoxian International Airport",
    city: "Hunnan, Shenyang",
    country: "CN",
    continent: "AS",
    lat: 41.6398,
    lon: 123.483,
    elevation: 198,
    hub_tier: "large",
    slots: 200,
    demand: 75,
    business_pct: 38,
    landing_fee: 6000,
    competition: "high",
  },
  "ZYXC": {
    icao: "ZYXC",
    iata: "XEN",
    name: "Xingcheng Air Base",
    city: "Huludao (Xingcheng)",
    country: "CN",
    continent: "AS",
    lat: 40.5803,
    lon: 120.7004,
    elevation: 30,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYYJ": {
    icao: "ZYYJ",
    iata: "YNJ",
    name: "Yanji Chaoyangchuan Airport",
    city: "Yanji",
    country: "CN",
    continent: "AS",
    lat: 42.8828,
    lon: 129.451,
    elevation: 624,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYYK": {
    icao: "ZYYK",
    iata: "YKH",
    name: "Yingkou Lanqi Airport",
    city: "Yingkou (Laobian)",
    country: "CN",
    continent: "AS",
    lat: 40.5425,
    lon: 122.3586,
    elevation: 0,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
  "ZYYY": {
    icao: "ZYYY",
    iata: "",
    name: "Shenyang Dongta Airport",
    city: "Dadong, Shenyang",
    country: "CN",
    continent: "AS",
    lat: 41.7844,
    lon: 123.4963,
    elevation: 157,
    hub_tier: "small",
    slots: 30,
    demand: 25,
    business_pct: 22,
    landing_fee: 1200,
    competition: "low",
  },
};

// Helper to get airport by ICAO
export function getGlobalAirport(icao) {
  return GLOBAL_AIRPORTS[icao] || null;
}

// Get all airports as array
export function getAllAirports() {
  return Object.values(GLOBAL_AIRPORTS);
}

// Get airports by hub tier
export function getAirportsByHubTier(tier) {
  return Object.values(GLOBAL_AIRPORTS).filter(a => a.hub_tier === tier);
}

// Get count
export function getGlobalAirportCount() {
  return Object.keys(GLOBAL_AIRPORTS).length;
}

export default GLOBAL_AIRPORTS;